/**
 * Code generated by qudtlib-java:qudtlib-js-gen.
 */
import { Decimal } from "decimal.js";
import {
  config,
  Unit,
  QuantityKind,
  Prefix,
  LangString,
  FactorUnits,
  FactorUnit,
  SystemOfUnits,
  Qudt,
} from "@qudtlib/core";

export * from "@qudtlib/core";
// Units
{
  let unit: Unit;
  unit = new Unit(
    "http://qudt.org/vocab/currency/AED",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "د.إ",
    undefined,
    "AED",
    784,
    []
  );
  unit.addLabel(new LangString("United Arab Emirates dirham", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/AED", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/AFN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "AFN",
    971,
    []
  );
  unit.addLabel(new LangString("Afghani", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/AFN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ALL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    "ALL",
    8,
    []
  );
  unit.addLabel(new LangString("Lek", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ALL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/AMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "֏",
    undefined,
    "AMD",
    51,
    []
  );
  unit.addLabel(new LangString("Armenian Dram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/AMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ANG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ANG",
    532,
    []
  );
  unit.addLabel(new LangString("Netherlands Antillian Guilder", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ANG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/AOA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "AOA",
    973,
    []
  );
  unit.addLabel(new LangString("Kwanza", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/AOA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ARS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ARS",
    32,
    []
  );
  unit.addLabel(new LangString("Argentine Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ARS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/AUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "AUD",
    36,
    []
  );
  unit.addLabel(new LangString("Australian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/AUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/AWG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "AWG",
    533,
    []
  );
  unit.addLabel(new LangString("Aruban Guilder", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/AWG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/AZN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₼",
    undefined,
    "AZN",
    944,
    []
  );
  unit.addLabel(new LangString("Azerbaijanian Manat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/AZN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BAM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KM",
    undefined,
    "BAM",
    977,
    []
  );
  unit.addLabel(new LangString("Convertible Marks", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BAM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BBD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BBD",
    52,
    []
  );
  unit.addLabel(new LangString("Barbados Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BBD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BDT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BDT",
    50,
    []
  );
  unit.addLabel(new LangString("Bangladeshi Taka", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BDT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BGN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "лв.",
    undefined,
    "BGN",
    975,
    []
  );
  unit.addLabel(new LangString("Bulgarian Lev", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BGN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BHD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BHD",
    48,
    []
  );
  unit.addLabel(new LangString("Bahraini Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BHD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BIF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BIF",
    108,
    []
  );
  unit.addLabel(new LangString("Burundian Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BIF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BMD",
    60,
    []
  );
  unit.addLabel(new LangString("Bermuda Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BND",
    96,
    []
  );
  unit.addLabel(new LangString("Brunei Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BOB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BOB",
    68,
    []
  );
  unit.addLabel(new LangString("Boliviano", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BOB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BOV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BOV",
    984,
    []
  );
  unit.addLabel(new LangString("Bolivian Mvdol (Funds code)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BOV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BRL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "BRL",
    986,
    []
  );
  unit.addLabel(new LangString("Brazilian Real", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BRL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BSD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BSD",
    44,
    []
  );
  unit.addLabel(new LangString("Bahamian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BSD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BTN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BTN",
    64,
    []
  );
  unit.addLabel(new LangString("Ngultrum", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BTN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BWP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BWP",
    72,
    []
  );
  unit.addLabel(new LangString("Pula", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BWP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BYN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Rbl",
    undefined,
    "BYN",
    933,
    []
  );
  unit.addLabel(new LangString("Belarussian Ruble", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BYN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/BZD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BZD",
    84,
    []
  );
  unit.addLabel(new LangString("Belize Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/BZD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "CAD",
    124,
    []
  );
  unit.addLabel(new LangString("Canadian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CDF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CDF",
    976,
    []
  );
  unit.addLabel(new LangString("Franc Congolais", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CDF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CHE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CHE",
    947,
    []
  );
  unit.addLabel(new LangString("WIR Euro (complementary currency)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CHE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CHF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CHF",
    undefined,
    "CHF",
    756,
    []
  );
  unit.addLabel(new LangString("Swiss Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CHF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CHW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CHW",
    948,
    []
  );
  unit.addLabel(new LangString("WIR Franc (complementary currency)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CHW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CLF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CLF",
    990,
    []
  );
  unit.addLabel(new LangString("Unidades de formento (Funds code)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CLF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CLP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "CLP",
    152,
    []
  );
  unit.addLabel(new LangString("Chilean Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CLP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CNY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "¥",
    undefined,
    "CNY",
    156,
    []
  );
  unit.addLabel(new LangString("Yuan Renminbi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CNY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/COP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "COP",
    170,
    []
  );
  unit.addLabel(new LangString("Colombian Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/COP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/COU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "COU",
    970,
    []
  );
  unit.addLabel(new LangString("Unidad de Valor Real", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/COU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CRC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CRC",
    188,
    []
  );
  unit.addLabel(new LangString("Costa Rican Colon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CRC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CUP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CUP",
    192,
    []
  );
  unit.addLabel(new LangString("Cuban Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CUP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CVE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CVE",
    132,
    []
  );
  unit.addLabel(new LangString("Cape Verde Escudo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CVE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CYP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CYP",
    196,
    []
  );
  unit.addLabel(new LangString("Cyprus Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CYP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/CZK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Kč",
    undefined,
    "CZK",
    203,
    []
  );
  unit.addLabel(new LangString("Czech Koruna", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/CZK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/DJF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "DJF",
    262,
    []
  );
  unit.addLabel(new LangString("Djibouti Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/DJF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/DKK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "DKK",
    208,
    []
  );
  unit.addLabel(new LangString("Danish Krone", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/DKK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/DOP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "DOP",
    214,
    []
  );
  unit.addLabel(new LangString("Dominican Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/DOP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/DZD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "DZD",
    12,
    []
  );
  unit.addLabel(new LangString("Algerian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/DZD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/EEK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "EEK",
    233,
    []
  );
  unit.addLabel(new LangString("Kroon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/EEK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/EGP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "EGP",
    818,
    []
  );
  unit.addLabel(new LangString("Egyptian Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/EGP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ERN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ERN",
    232,
    []
  );
  unit.addLabel(new LangString("Nakfa", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ERN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ETB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ETB",
    230,
    []
  );
  unit.addLabel(new LangString("Ethiopian Birr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ETB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/EUR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "€",
    undefined,
    "EUR",
    978,
    []
  );
  unit.addLabel(new LangString("Euro", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/EUR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/FJD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "FJD",
    242,
    []
  );
  unit.addLabel(new LangString("Fiji Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/FJD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/FKP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "FKP",
    238,
    []
  );
  unit.addLabel(new LangString("Falkland Islands Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/FKP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GBP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "£",
    undefined,
    "GBP",
    826,
    []
  );
  unit.addLabel(new LangString("Pound Sterling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GBP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GEL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₾",
    undefined,
    "GEL",
    981,
    []
  );
  unit.addLabel(new LangString("Lari", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GEL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GHS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GHS",
    936,
    []
  );
  unit.addLabel(new LangString("Cedi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GHS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GIP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GIP",
    292,
    []
  );
  unit.addLabel(new LangString("Gibraltar pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GIP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GMD",
    270,
    []
  );
  unit.addLabel(new LangString("Dalasi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GNF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GNF",
    324,
    []
  );
  unit.addLabel(new LangString("Guinea Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GNF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GTQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GTQ",
    320,
    []
  );
  unit.addLabel(new LangString("Quetzal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GTQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/GYD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GYD",
    328,
    []
  );
  unit.addLabel(new LangString("Guyana Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/GYD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/HKD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "HKD",
    344,
    []
  );
  unit.addLabel(new LangString("Hong Kong Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/HKD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/HNL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "HNL",
    340,
    []
  );
  unit.addLabel(new LangString("Lempira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/HNL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/HRK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "HRK",
    191,
    []
  );
  unit.addLabel(new LangString("Croatian Kuna", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/HRK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/HTG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "HTG",
    332,
    []
  );
  unit.addLabel(new LangString("Haiti Gourde", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/HTG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/HUF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Ft",
    undefined,
    "HUF",
    348,
    []
  );
  unit.addLabel(new LangString("Forint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/HUF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/IDR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Rp",
    undefined,
    "IDR",
    360,
    []
  );
  unit.addLabel(new LangString("Rupiah", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/IDR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ILS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₪",
    undefined,
    "ILS",
    376,
    []
  );
  unit.addLabel(new LangString("New Israeli Shekel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ILS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/INR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₹",
    undefined,
    "INR",
    356,
    []
  );
  unit.addLabel(new LangString("Indian Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/INR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/IQD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "IQD",
    368,
    []
  );
  unit.addLabel(new LangString("Iraqi Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/IQD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/IRR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "IRR",
    364,
    []
  );
  unit.addLabel(new LangString("Iranian Rial", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/IRR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ISK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "ISK",
    352,
    []
  );
  unit.addLabel(new LangString("Iceland Krona", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ISK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/JMD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "JMD",
    388,
    []
  );
  unit.addLabel(new LangString("Jamaican Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/JMD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/JOD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "JOD",
    400,
    []
  );
  unit.addLabel(new LangString("Jordanian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/JOD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/JPY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "¥",
    undefined,
    "JPY",
    392,
    []
  );
  unit.addLabel(new LangString("Japanese yen", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/JPY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KES",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KES",
    404,
    []
  );
  unit.addLabel(new LangString("Kenyan Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KES", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KGS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KGS",
    417,
    []
  );
  unit.addLabel(new LangString("Som", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KGS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KHR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KHR",
    116,
    []
  );
  unit.addLabel(new LangString("Riel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KHR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KMF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KMF",
    174,
    []
  );
  unit.addLabel(new LangString("Comoro Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KMF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KPW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KPW",
    408,
    []
  );
  unit.addLabel(new LangString("North Korean Won", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KPW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KRW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₩",
    undefined,
    "KRW",
    410,
    []
  );
  unit.addLabel(new LangString("South Korean Won", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KRW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KWD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KWD",
    414,
    []
  );
  unit.addLabel(new LangString("Kuwaiti Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KWD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KYD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KYD",
    136,
    []
  );
  unit.addLabel(new LangString("Cayman Islands Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KYD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/KZT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "KZT",
    398,
    []
  );
  unit.addLabel(new LangString("Tenge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/KZT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LAK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    " ₭",
    undefined,
    "LAK",
    418,
    []
  );
  unit.addLabel(new LangString("Lao kip", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LAK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LBP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LBP",
    422,
    []
  );
  unit.addLabel(new LangString("Lebanese Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LBP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LKR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LKR",
    144,
    []
  );
  unit.addLabel(new LangString("Sri Lanka Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LKR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LRD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LRD",
    430,
    []
  );
  unit.addLabel(new LangString("Liberian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LRD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LSL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LSL",
    426,
    []
  );
  unit.addLabel(new LangString("Loti", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LSL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LTL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LTL",
    440,
    []
  );
  unit.addLabel(new LangString("Lithuanian Litas", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LTL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LVL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LVL",
    428,
    []
  );
  unit.addLabel(new LangString("Latvian Lats", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LVL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/LYD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "LYD",
    434,
    []
  );
  unit.addLabel(new LangString("Libyan Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/LYD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MAD",
    504,
    []
  );
  unit.addLabel(new LangString("Moroccan Dirham", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    "MDL",
    498,
    []
  );
  unit.addLabel(new LangString("Moldovan Leu", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MGA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MGA",
    969,
    []
  );
  unit.addLabel(new LangString("Malagasy Ariary", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MGA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MKD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ден",
    undefined,
    "MKD",
    807,
    []
  );
  unit.addLabel(new LangString("Denar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MKD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MMK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MMK",
    104,
    []
  );
  unit.addLabel(new LangString("Kyat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MMK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MNT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Mongolian Tugrik", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MNT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MOP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MOP",
    446,
    []
  );
  unit.addLabel(new LangString("Pataca", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MOP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MRU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MRU",
    929,
    []
  );
  unit.addLabel(new LangString("Ouguiya", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MRU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MTL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MTL",
    470,
    []
  );
  unit.addLabel(new LangString("Maltese Lira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MTL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MUR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MUR",
    480,
    []
  );
  unit.addLabel(new LangString("Mauritius Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MUR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MVR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MVR",
    462,
    []
  );
  unit.addLabel(new LangString("Rufiyaa", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MVR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MWK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MWK",
    454,
    []
  );
  unit.addLabel(new LangString("Malawi Kwacha", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MWK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MXN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "MXN",
    484,
    []
  );
  unit.addLabel(new LangString("Mexican Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MXN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MXV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MXV",
    979,
    []
  );
  unit.addLabel(
    new LangString("Mexican Unidad de Inversion (UDI) (Funds code)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MXV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "RM",
    undefined,
    "MYR",
    458,
    []
  );
  unit.addLabel(new LangString("Malaysian Ringgit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MZN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MZN",
    943,
    []
  );
  unit.addLabel(new LangString("Metical", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MZN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/MegaUSD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Million US Dollars", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/MegaUSD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/NAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NAD",
    516,
    []
  );
  unit.addLabel(new LangString("Namibian Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/NAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/NGN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NGN",
    566,
    []
  );
  unit.addLabel(new LangString("Naira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/NGN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/NIO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NIO",
    558,
    []
  );
  unit.addLabel(new LangString("Cordoba Oro", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/NIO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/NOK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "NOK",
    578,
    []
  );
  unit.addLabel(new LangString("Norwegian Krone", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/NOK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/NPR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NPR",
    524,
    []
  );
  unit.addLabel(new LangString("Nepalese Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/NPR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/NZD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "NZD",
    554,
    []
  );
  unit.addLabel(new LangString("New Zealand Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/NZD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/OMR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "OMR",
    512,
    []
  );
  unit.addLabel(new LangString("Rial Omani", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/OMR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/PAB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PAB",
    590,
    []
  );
  unit.addLabel(new LangString("Balboa", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/PAB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/PEN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PEN",
    604,
    []
  );
  unit.addLabel(new LangString("Nuevo Sol", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/PEN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/PGK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PGK",
    598,
    []
  );
  unit.addLabel(new LangString("Kina", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/PGK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/PHP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₱",
    undefined,
    "PHP",
    608,
    []
  );
  unit.addLabel(new LangString("Philippine Peso", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/PHP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/PKR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PKR",
    586,
    []
  );
  unit.addLabel(new LangString("Pakistan Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/PKR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/PLN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "zł",
    undefined,
    "PLN",
    985,
    []
  );
  unit.addLabel(new LangString("Zloty", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/PLN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/PYG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PYG",
    600,
    []
  );
  unit.addLabel(new LangString("Guarani", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/PYG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/QAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "QAR",
    634,
    []
  );
  unit.addLabel(new LangString("Qatari Rial", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/QAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/RON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    "RON",
    946,
    []
  );
  unit.addLabel(new LangString("Romanian New Leu", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/RON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/RSD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "дин",
    undefined,
    "RSD",
    941,
    []
  );
  unit.addLabel(new LangString("Serbian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/RSD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/RUB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₽",
    undefined,
    "RUB",
    643,
    []
  );
  unit.addLabel(new LangString("Russian Ruble", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/RUB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/RWF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "RWF",
    646,
    []
  );
  unit.addLabel(new LangString("Rwanda Franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/RWF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "﷼",
    undefined,
    "SAR",
    682,
    []
  );
  unit.addLabel(new LangString("Saudi Riyal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SBD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SBD",
    90,
    []
  );
  unit.addLabel(new LangString("Solomon Islands Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SBD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SCR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SCR",
    690,
    []
  );
  unit.addLabel(new LangString("Seychelles Rupee", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SCR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SDG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SDG",
    938,
    []
  );
  unit.addLabel(new LangString("Sudanese Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SDG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SEK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "kr",
    undefined,
    "SEK",
    752,
    []
  );
  unit.addLabel(new LangString("Swedish Krona", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SEK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SGD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "SGD",
    702,
    []
  );
  unit.addLabel(new LangString("Singapore Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SGD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SHP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SHP",
    654,
    []
  );
  unit.addLabel(new LangString("Saint Helena Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SHP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SKK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Sk",
    undefined,
    "SKK",
    703,
    []
  );
  unit.addLabel(new LangString("Slovak Koruna", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SKK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SLE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SLE",
    925,
    []
  );
  unit.addLabel(new LangString("Leone", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SOS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SOS",
    706,
    []
  );
  unit.addLabel(new LangString("Somali Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SOS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SRD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SRD",
    968,
    []
  );
  unit.addLabel(new LangString("Surinam Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SRD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/STN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "STN",
    930,
    []
  );
  unit.addLabel(new LangString("Dobra", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/STN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SYP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SYP",
    760,
    []
  );
  unit.addLabel(new LangString("Syrian Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SYP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/SZL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SZL",
    748,
    []
  );
  unit.addLabel(new LangString("Lilangeni", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/SZL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/THB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "฿",
    undefined,
    "THB",
    764,
    []
  );
  unit.addLabel(new LangString("Baht", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/THB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TJS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TJS",
    972,
    []
  );
  unit.addLabel(new LangString("Somoni", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TJS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TMT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TMT",
    934,
    []
  );
  unit.addLabel(new LangString("Manat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TMT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TND",
    788,
    []
  );
  unit.addLabel(new LangString("Tunisian Dinar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TOP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TOP",
    776,
    []
  );
  unit.addLabel(new LangString("Pa'anga", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TOP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₺",
    undefined,
    "TRY",
    949,
    []
  );
  unit.addLabel(new LangString("New Turkish Lira", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TTD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TTD",
    780,
    []
  );
  unit.addLabel(new LangString("Trinidad and Tobago Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TTD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TWD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "TWD",
    901,
    []
  );
  unit.addLabel(new LangString("New Taiwan Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TWD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/TZS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TZS",
    834,
    []
  );
  unit.addLabel(new LangString("Tanzanian Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/TZS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/UAH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "₴",
    undefined,
    "UAH",
    980,
    []
  );
  unit.addLabel(new LangString("Hryvnia", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/UAH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/UGX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "UGX",
    800,
    []
  );
  unit.addLabel(new LangString("Uganda Shilling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/UGX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/USD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$",
    undefined,
    "USD",
    840,
    []
  );
  unit.addLabel(new LangString("US Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/USD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/USN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "USN",
    997,
    []
  );
  unit.addLabel(
    new LangString("United States Dollar (next day) (funds code)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/USN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/USS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "USS",
    998,
    []
  );
  unit.addLabel(
    new LangString("United States Dollar (same day) (funds code)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/USS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/UYU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "UYU",
    858,
    []
  );
  unit.addLabel(new LangString("Peso Uruguayo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/UYU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/UZS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "UZS",
    860,
    []
  );
  unit.addLabel(new LangString("Uzbekistan Som", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/UZS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/VES",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "VES",
    928,
    []
  );
  unit.addLabel(new LangString("Venezuelan bolvar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/VES", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/VND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "VND",
    704,
    []
  );
  unit.addLabel(new LangString("Vietnamese ??ng", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/VND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/VUV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "VUV",
    548,
    []
  );
  unit.addLabel(new LangString("Vatu", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/VUV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/WST",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "WST",
    882,
    []
  );
  unit.addLabel(new LangString("Samoan Tala", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/WST", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XAF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XAF",
    950,
    []
  );
  unit.addLabel(new LangString("CFA Franc BEAC", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XAF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XAG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XAG",
    961,
    []
  );
  unit.addLabel(new LangString("Silver (one Troy ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XAG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XAU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XAU",
    959,
    []
  );
  unit.addLabel(new LangString("Gold (one Troy ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XAU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XBA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBA",
    955,
    []
  );
  unit.addLabel(
    new LangString("European Composite Unit (EURCO) (Bonds market unit)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XBA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XBB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBB",
    956,
    []
  );
  unit.addLabel(
    new LangString(
      "European Monetary Unit (E.M.U.-6) (Bonds market unit)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XBB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XBC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBC",
    957,
    []
  );
  unit.addLabel(
    new LangString(
      "European Unit of Account 9 (E.U.A.-9) (Bonds market unit)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XBC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XBD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XBD",
    958,
    []
  );
  unit.addLabel(
    new LangString(
      "European Unit of Account 17 (E.U.A.-17) (Bonds market unit)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XBD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XCD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XCD",
    951,
    []
  );
  unit.addLabel(new LangString("East Caribbean Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XCD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XDR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XDR",
    960,
    []
  );
  unit.addLabel(new LangString("Special Drawing Rights", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XDR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XFO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XFO",
    undefined,
    []
  );
  unit.addLabel(
    new LangString("Gold franc (special settlement currency)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XFO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XFU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XFU",
    undefined,
    []
  );
  unit.addLabel(
    new LangString("UIC franc (special settlement currency)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XFU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XOF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XOF",
    952,
    []
  );
  unit.addLabel(new LangString("CFA Franc BCEAO", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XOF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XPD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XPD",
    964,
    []
  );
  unit.addLabel(new LangString("Palladium (one Troy ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XPD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XPF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XPF",
    953,
    []
  );
  unit.addLabel(new LangString("CFP franc", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XPF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/XPT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "XPT",
    962,
    []
  );
  unit.addLabel(new LangString("Platinum (one Troy ounce)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/XPT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/YER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "YER",
    886,
    []
  );
  unit.addLabel(new LangString("Yemeni Rial", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/YER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ZAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "R",
    undefined,
    "ZAR",
    710,
    []
  );
  unit.addLabel(new LangString("South African Rand", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ZAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ZMW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ZMW",
    967,
    []
  );
  unit.addLabel(new LangString("Zambian Kwacha", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ZMW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/currency/ZWL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ZWL",
    932,
    []
  );
  unit.addLabel(new LangString("Zimbabwe Dollar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Currency");
  config.units.set("http://qudt.org/vocab/currency/ZWL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/1000000I",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("1000000I", undefined));
  config.units.set("http://qudt.org/vocab/unit/1000000I", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/1000I",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("1000I", undefined));
  config.units.set("http://qudt.org/vocab/unit/1000I", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/100KiloCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("100KiloCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/100KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/10KiloCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("10KiloCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/10KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/2PiRAD",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("2PiRAD", undefined));
  config.units.set("http://qudt.org/vocab/unit/2PiRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("ampere", "en"));
  unit.addLabel(new LangString("Ampere", "de"));
  unit.addLabel(new LangString("ampère", "fr"));
  unit.addLabel(new LangString("amperio", "es"));
  unit.addLabel(new LangString("ampere", "ms"));
  unit.addLabel(new LangString("אמפר", "he"));
  unit.addLabel(new LangString("ampere", "pt"));
  unit.addLabel(new LangString("amper", "hu"));
  unit.addLabel(new LangString("αμπέρ", "el"));
  unit.addLabel(new LangString("एम्पीयर", "hi"));
  unit.addLabel(new LangString("ampere", "it"));
  unit.addLabel(new LangString("أمبير", "ar"));
  unit.addLabel(new LangString("アンペア", "ja"));
  unit.addLabel(new LangString("ампер", "ru"));
  unit.addLabel(new LangString("amper", "sl"));
  unit.addLabel(new LangString("amper", "tr"));
  unit.addLabel(new LangString("amper", "pl"));
  unit.addLabel(new LangString("amper", "ro"));
  unit.addLabel(new LangString("ampér", "cs"));
  unit.addLabel(new LangString("آمپر", "fa"));
  unit.addLabel(new LangString("ампер", "bg"));
  unit.addLabel(new LangString("安培", "zh"));
  unit.addLabel(new LangString("amperium", "la"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/°C",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere hour per degree Celsius", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/dm³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere hour per cubic decimetre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere hour per kilogram", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere hour per square metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-HR-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·h/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere hour per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-HR-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere Square Metre", "en"));
  unit.addLabel(new LangString("Ampere Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/A-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-M2-PER-J-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·m²/(J·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(
    new LangString("Ampere Square Meter per Joule Second", "en-US")
  );
  unit.addLabel(new LangString("Ampere Square Metre per Joule Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/A-M2-PER-J-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere minute", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BatteryCapacity");
  config.units.set("http://qudt.org/vocab/unit/A-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/A·h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere per ampere hour", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-PER-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere per Centimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Ampere per Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "A/g",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Ampere per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCurrent"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere per Joule", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere per kilogram", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicElectricCurrent"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere je Meter", "de"));
  unit.addLabel(new LangString("प्रति मीटर एम्पीयर", "hi"));
  unit.addLabel(new LangString("amper bölü metre", "tr"));
  unit.addLabel(new LangString("ampérů na metr", "cs"));
  unit.addLabel(new LangString("amper na meter", "sl"));
  unit.addLabel(new LangString("آمپر بر متر", "fa"));
  unit.addLabel(new LangString("アンペア毎メートル", "ja"));
  unit.addLabel(new LangString("مقياس التبادل، الأس السالب للمتر", "ar"));
  unit.addLabel(new LangString("Ampere per Meter", "en-US"));
  unit.addLabel(new LangString("ampere al metro", "it"));
  unit.addLabel(new LangString("amperio por metro", "es"));
  unit.addLabel(new LangString("amper na metr", "pl"));
  unit.addLabel(new LangString("ampere pe metru", "ro"));
  unit.addLabel(new LangString("ampere por metro", "pt"));
  unit.addLabel(new LangString("ampere per metre", "en"));
  unit.addLabel(new LangString("ampere per meter", "ms"));
  unit.addLabel(new LangString("ампер на метр", "ru"));
  unit.addLabel(new LangString("ampère par mètre", "fr"));
  unit.addLabel(new LangString("安培每米", "zh"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Coercivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("amper bölü metre kare", "tr"));
  unit.addLabel(new LangString("amper na metr kwadratowy", "pl"));
  unit.addLabel(new LangString("ampere al metro quadrato", "it"));
  unit.addLabel(new LangString("アンペア毎平方メートル", "ja"));
  unit.addLabel(new LangString("ampère par mètre carré", "fr"));
  unit.addLabel(new LangString("ampere pe metru pătrat", "ro"));
  unit.addLabel(new LangString("ampere por metro quadrado", "pt"));
  unit.addLabel(new LangString("ampér na metr čtvereční", "cs"));
  unit.addLabel(new LangString("ампер на квадратный метр", "ru"));
  unit.addLabel(new LangString("ampere per square metre", "en"));
  unit.addLabel(new LangString("آمپر بر مترمربع", "fa"));
  unit.addLabel(new LangString("أمبير في المتر المربع", "ar"));
  unit.addLabel(new LangString("Ampere je Quadratmeter", "de"));
  unit.addLabel(new LangString("एम्पीयर प्रति वर्ग मीटर", "hi"));
  unit.addLabel(new LangString("ampere per meter persegi", "ms"));
  unit.addLabel(new LangString("amper na kvadratni meter", "sl"));
  unit.addLabel(new LangString("Ampere per Square Meter", "en-US"));
  unit.addLabel(new LangString("amperio por metro cuadrado", "es"));
  unit.addLabel(new LangString("安培每平方米", "zh"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-M2-K2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H-2T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/(m²·K²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(
    new LangString("Ampere per Square Meter Square Kelvin", "en-US")
  );
  unit.addLabel(new LangString("Ampere per Square Metre Square Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RichardsonConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-M2-K2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere per Millimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Ampere per Square Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere per Radian", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/A-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ampere Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/A-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A·s²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere per square second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "A²·s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ampere squared second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/A2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("4046.8564224"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "acre",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Acre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/AC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AC-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1233.4818375475202"),
    undefined,
    undefined,
    undefined,
    undefined,
    "acre·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Acre Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AC-FT_US");
  config.units.set("http://qudt.org/vocab/unit/AC-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AC-FT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1233.48426566137344"),
    undefined,
    undefined,
    undefined,
    undefined,
    "acre-ft (US survey)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("acre-foot (based on U.S. survey foot)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AC-FT");
  config.units.set("http://qudt.org/vocab/unit/AC-FT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AMU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.66053878283E-27"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "amu",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Atomic mass unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Da");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/U");
  config.units.set("http://qudt.org/vocab/unit/AMU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ANGSTROM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "Å",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Angstrom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/ANGSTROM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ANGSTROM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-30"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Å³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS"]
  );
  unit.addLabel(new LangString("Cubic Angstrom", "en-US"));
  unit.addLabel(new LangString("Cubic Angstrom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/ANGSTROM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ARCMIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000290888209"),
    undefined,
    undefined,
    undefined,
    undefined,
    "'",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("ArcMinute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MIN_Angle");
  config.units.set("http://qudt.org/vocab/unit/ARCMIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ARCSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00000484813681"),
    undefined,
    undefined,
    undefined,
    undefined,
    '"',
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("ArcSecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/ARCSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ARE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("are", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/ARE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "AT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Ampere Turn", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  config.units.set("http://qudt.org/vocab/unit/AT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AT-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("39.3700787"),
    undefined,
    undefined,
    undefined,
    undefined,
    "AT/in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ampere Turn per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/AT-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "AT/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Ampere Turn per Meter", "en-US"));
  unit.addLabel(new LangString("Ampere Turn per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/AT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("101325.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "atm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Standard Atmosphere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/ATM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM-M3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("101325.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "atm·m³/mol",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Atmosphere Cubic Metre per Mole", "en"));
  unit.addLabel(new LangString("Atmosphere Cubic Meter per Mole", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HenrysLawVolatilityConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/ATM-M3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("101325.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Atm/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("standard atmosphere per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/ATM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM_T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "at",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Technical Atmosphere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/ATM_T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ATM_T-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    undefined,
    undefined,
    "at/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("technical atmosphere per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/ATM_T-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("149597870691.6"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "AU",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("astronomical-unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/AU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AWG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "AWG",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("american wire gage", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/AWG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "abA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BIOT");
  config.units.set("http://qudt.org/vocab/unit/A_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Ab-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abA·cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abampere Square centimetre", "en"));
  unit.addLabel(new LangString("Abampere Square centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/A_Ab-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Ab-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abA/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abampere per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Abampere per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A_Ab-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Reactive",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("A_Reactive", undefined));
  config.units.set("http://qudt.org/vocab/unit/A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("3.335641E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "statA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/A_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/A_Stat-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("0.000003335641"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statA/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statampere per Square Centimetre", "en"));
  unit.addLabel(new LangString("Statampere per Square Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/A_Stat-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "aA",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("attoampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/AttoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "aC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("AttoCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/AttoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "aF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Attofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/AttoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "aJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Attojoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/AttoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoJ-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "aJ·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Attojoule Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Action");
  config.units.set("http://qudt.org/vocab/unit/AttoJ-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/AttoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Atto",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "as",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Attosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/AttoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/B",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "B",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("بل", "ar"));
  unit.addLabel(new LangString("贝", "zh"));
  unit.addLabel(new LangString("बेल", "hi"));
  unit.addLabel(new LangString("בל", "he"));
  unit.addLabel(new LangString("Bel", "de"));
  unit.addLabel(new LangString("bel", "cs"));
  unit.addLabel(new LangString("bel", "fr"));
  unit.addLabel(new LangString("bel", "hu"));
  unit.addLabel(new LangString("bel", "it"));
  unit.addLabel(new LangString("bel", "en"));
  unit.addLabel(new LangString("bel", "ms"));
  unit.addLabel(new LangString("bel", "pt"));
  unit.addLabel(new LangString("μπέλ", "el"));
  unit.addLabel(new LangString("бел", "ru"));
  unit.addLabel(new LangString("бел", "bg"));
  unit.addLabel(new LangString("بل", "fa"));
  unit.addLabel(new LangString("bel", "tr"));
  unit.addLabel(new LangString("bel", "pl"));
  unit.addLabel(new LangString("ベル", "ja"));
  unit.addLabel(new LangString("bel", "ro"));
  unit.addLabel(new LangString("belio", "es"));
  unit.addLabel(new LangString("bel", "sl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  config.units.set("http://qudt.org/vocab/unit/B", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/B-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "B/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("bel per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/B-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("2.30258509"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ban",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Ban", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/BAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar·L/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Bar Litre per Second", "en"));
  unit.addLabel(new LangString("Bar Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BAR-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar·m³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Bar Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Bar Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BAR-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Bar per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/BAR-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar/°C",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("bar per degree Celsius", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/BAR-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bar/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Bar per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/BAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ba",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Barad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BARYE");
  config.units.set("http://qudt.org/vocab/unit/BARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-28"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "b",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Barn", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/BARN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN-PER-EV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("6.241509074460762607776240980930446E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/eV",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("barn per electronvolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/BARN-PER-EV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-28"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/sr",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("barn per steradian", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/BARN-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARN-PER-SR-EV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("6.241509074460762607776240980930446E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/(sr·eV)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("barn per steradian electronvolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/BARN-PER-SR-EV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BARYE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ba",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Barye", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BARAD");
  config.units.set("http://qudt.org/vocab/unit/BARYE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BAUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("baud", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DigitRate");
  config.units.set("http://qudt.org/vocab/unit/BAUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Barrel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BBL_US");
  config.units.set("http://qudt.org/vocab/unit/BBL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1591132"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl{UK petroleum}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001841587"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0000441981"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.002651886"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.1591132"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Barrel (UK Petroleum) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1589873"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl{US petroleum}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Barrel (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BBL");
  config.units.set("http://qudt.org/vocab/unit/BBL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00000184"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{US petroleum}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Barrel (US) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0026498"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{US petroleum}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Barrel (US) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1156281989625"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bbl{US dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Dry Barrel (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/BBL_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_PET",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("BBL_US_PET", undefined));
  config.units.set("http://qudt.org/vocab/unit/BBL_US_PET", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000044163"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Barrel (US Petroleum) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US_PET-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.1589873"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bbl{UK petroleum}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Barrel (US Petroleum) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BEAT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("BEAT", undefined));
  config.units.set("http://qudt.org/vocab/unit/BEAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BEAT-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "BPM",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Heart Beats per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeartRate");
  config.units.set("http://qudt.org/vocab/unit/BEAT-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BFT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Beufort",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Beaufort", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/BFT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIOT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "Bi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Biot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/A_Ab");
  config.units.set("http://qudt.org/vocab/unit/BIOT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Bit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/BIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("bit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bit/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("bit per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("bit per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "b/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Bit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/BIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("bekerel", "tr"));
  unit.addLabel(new LangString("bekerel", "pl"));
  unit.addLabel(new LangString("becquerel", "cs"));
  unit.addLabel(new LangString("Becquerel", "de"));
  unit.addLabel(new LangString("becquerel", "fr"));
  unit.addLabel(new LangString("בקרל", "he"));
  unit.addLabel(new LangString("becquerel", "it"));
  unit.addLabel(new LangString("becquerel", "es"));
  unit.addLabel(new LangString("becquerel", "hu"));
  unit.addLabel(new LangString("becquerel", "en"));
  unit.addLabel(new LangString("becquerel", "pt"));
  unit.addLabel(new LangString("becquerel", "ms"));
  unit.addLabel(new LangString("беккерель", "ru"));
  unit.addLabel(new LangString("بيكريل", "ar"));
  unit.addLabel(new LangString("becquerelium", "la"));
  unit.addLabel(new LangString("بکرل", "fa"));
  unit.addLabel(new LangString("бекерел", "bg"));
  unit.addLabel(new LangString("μπεκερέλ", "el"));
  unit.addLabel(new LangString("ベクレル", "ja"));
  unit.addLabel(new LangString("becquerel", "ro"));
  unit.addLabel(new LangString("बैक्वेरल", "hi"));
  unit.addLabel(new LangString("贝克勒尔", "zh"));
  unit.addLabel(new LangString("becquerel", "sl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/BQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Becquerel per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Becquerels per litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Becquerel per Square Meter", "en-US"));
  unit.addLabel(new LangString("Becquerel per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceActivityDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Becquerel per Cubic Metre", "en"));
  unit.addLabel(new LangString("Becquerel per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BQ-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Bq·s/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Becquerels second per cubic metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsoluteActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/BQ-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BREATH",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("BREATH", undefined));
  config.units.set("http://qudt.org/vocab/unit/BREATH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BREATH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "breath/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Breath per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RespiratoryRate");
  config.units.set("http://qudt.org/vocab/unit/BREATH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BREWSTER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "B",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Brewster", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA");
  config.units.set("http://qudt.org/vocab/unit/BREWSTER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_39DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu (39 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("British thermal unit (39 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_39DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_59DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu (59 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("British thermal unit (59 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_59DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_60DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu (60 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("British thermal unit (60 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_60DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055.05585262"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("British Thermal Unit (International Definition)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("321.581024"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.730734666"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·ft/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("BTU (IT) Foot per Square Foot Hour Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("26.7984187"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("0.144227889"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) Inch per Hour Square Foot Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("519.220399911"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(ft²·s·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "BTU (IT) Inch per Square Foot Second Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("0.144227889"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) Inch per Hour Square Foot degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("519.220399911"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}·in/(s·ft²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) Inch per Second Square Foot degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1899.100535"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU (IT) per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1899.100535"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/°R",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Degree Rankine", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("11356.5267"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("3.154590745063048768072844787664884"),
    undefined,
    undefined,
    undefined,
    undefined,
    "BtuIT/(ft²·h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (international table) per square foot hour",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.678263341113487328270053328717809"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("BTU per Square Foot Hour Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("11356.52668222697556506224123559358"),
    undefined,
    undefined,
    undefined,
    undefined,
    "BtuIT/(ft²·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (international table) per square foot second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20441.74802800855438177219198338411"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(ft²·s·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("BTU per Square Foot Second Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("37258.94579"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("British Thermal Unit (IT) per Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.29307107"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("3.154590745063048768072844787664884"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(h·ft²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Hour Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.678263341113487328270053328717809"),
    undefined,
    undefined,
    undefined,
    undefined,
    "BtuIT/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (international table) per hour square foot degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.678263341113487328270053328717809"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(h·ft²·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) per Hour Square Foot degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1635339.842240684481368962737925476"),
    undefined,
    undefined,
    undefined,
    undefined,
    "BtuIT/(in²·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (international table) per square inch second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("2326.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/lb",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU-IT-PER-lb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.799999999999665056000000000028"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbm·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Pound Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.799999999999665056000000000028"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbm·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Pound Degree Rankine", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(mol-lb)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Pound Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerMassAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("237.18597062376833"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) per Pound of Force",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("426.9347648940976900014802607769946"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbf·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) per Pound of force Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("426.9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lbf·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) per Pound of force Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("17.58"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) per Minute",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lb-mol·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Pound Mole Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-MOL-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("2.326"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(mol-lb)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Pound Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerMassAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    new Decimal("4.186799999999999665056000000000028"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(lb-mol·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Pound Mole Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1055.05585262"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("6230.644798937007375564164116535475"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(s·ft·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) per Second Foot Degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("11356.52668222697556506224123559358"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(s·ft²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("BTU per Second Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC");
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20441.74802800855438177219198338411"),
    undefined,
    undefined,
    undefined,
    undefined,
    "BtuIT/(s·ft²·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (international table) per second square foot degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20441.74802800855438177219198338411"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{IT}/(s·ft²·°R)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (international Table) per Second Square Foot degree Rankine",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_MEAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055.05585262"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "BTU{mean}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("British Thermal Unit (mean)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_MEAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1054.3502645"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Btu{th}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("British Thermal Unit (Thermochemical Definition)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.729577206"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·ft/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("BTU (TH) Foot per Square Foot Hour Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.73"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·ft/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical) Foot per Hour Square Foot degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("0.144131434"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·in/(ft²·h·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("BTU (TH) Inch per Square Foot Hour Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("518.8732"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}·in/(ft²·s·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "BTU (TH) Inch per Square Foot Second Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1897.830476099999848173561912000013"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/°F",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1897.830476099999848173561912000013"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/°R",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per degree Rankine",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("11348.93179491220093551298213707538"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/ft²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per square foot",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("3.152481054142278037642495038076495"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/(ft²·h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per square foot hour",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("189.1488632485366822585497022845897"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/(ft²·min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per square foot minute",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("11348.93179491220093551298213707538"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/(ft²·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per square foot second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("37234.03"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("British Thermal Unit (TH) per Cubic Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.2929"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("British Thermal Unit (thermochemical) per Hour", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("5.674465897456100013799219272049695"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/(h·ft²·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per hour square foot degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("2324.443861"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/lbm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("British Thermal Unit (TH) per Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.000000044092117716975512617227"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/(lbm·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "British Thermal Unit (thermochemical) per Pound Degree Fahrenheit",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.000000044092117716975512617227"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/°R)/lb",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per pound degree Rankine",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("17.573"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("British Thermal Unit (thermochemical) per Minute", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1054.35"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btu{th}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("British Thermal Unit (thermochemical) per Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("20428.0772308419600496771893793789"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Btuth/(s·ft²·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "British thermal unit (thermochemical) per second square foot degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.03636872"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "bsh{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("bushel (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/BU_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.209343E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Bushel (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001010242"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Bushel (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0006061453"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Bushel (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.03636872"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Bushel (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.03523907"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("bushel (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/BU_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("BU_US_DRY", undefined));
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.0786E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000009789"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00058732"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.03523907"),
    undefined,
    undefined,
    undefined,
    undefined,
    "bsh{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Bushel (US Dry) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5.5451774444795624753378569716654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "B",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Byte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/BYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/BYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5.5451774444795624753378569716654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "byte/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("byte per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ByteRate");
  config.units.set("http://qudt.org/vocab/unit/BYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("कूलम्ब", "hi"));
  unit.addLabel(new LangString("coulomb", "cs"));
  unit.addLabel(new LangString("culombio", "es"));
  unit.addLabel(new LangString("coulomb", "ro"));
  unit.addLabel(new LangString("クーロン", "ja"));
  unit.addLabel(new LangString("کولمب/کولن", "fa"));
  unit.addLabel(new LangString("كولوم", "ar"));
  unit.addLabel(new LangString("coulomb", "tr"));
  unit.addLabel(new LangString("coulomb", "sl"));
  unit.addLabel(new LangString("Coulomb", "de"));
  unit.addLabel(new LangString("coulombium", "la"));
  unit.addLabel(new LangString("库伦", "zh"));
  unit.addLabel(new LangString("coulomb", "pt"));
  unit.addLabel(new LangString("кулон", "bg"));
  unit.addLabel(new LangString("coulomb", "ms"));
  unit.addLabel(new LangString("κουλόμπ", "el"));
  unit.addLabel(new LangString("кулон", "ru"));
  unit.addLabel(new LangString("coulomb", "hu"));
  unit.addLabel(new LangString("coulomb", "fr"));
  unit.addLabel(new LangString("coulomb", "en"));
  unit.addLabel(new LangString("kulomb", "pl"));
  unit.addLabel(new LangString("קולון", "he"));
  unit.addLabel(new LangString("coulomb", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("coulomb meter", "ms"));
  unit.addLabel(new LangString("culombio metro", "es"));
  unit.addLabel(new LangString("coulomb metre", "en"));
  unit.addLabel(new LangString("coulomb-metru", "ro"));
  unit.addLabel(new LangString("كولوم متر", "ar"));
  unit.addLabel(new LangString("कूलम्ब मीटर", "hi"));
  unit.addLabel(new LangString("coulomb-mètre", "fr"));
  unit.addLabel(new LangString("coulomb metr", "cs"));
  unit.addLabel(new LangString("Coulomb Meter", "en-US"));
  unit.addLabel(new LangString("coulomb metre", "tr"));
  unit.addLabel(new LangString("coulomb-metro", "pt"));
  unit.addLabel(new LangString("نیوتون متر", "fa"));
  unit.addLabel(new LangString("coulomb per metro", "it"));
  unit.addLabel(new LangString("クーロンメートル", "ja"));
  unit.addLabel(new LangString("库伦米", "zh"));
  unit.addLabel(new LangString("Coulombmeter", "de"));
  unit.addLabel(new LangString("кулон-метр", "ru"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/C-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("coulomb meter persegi", "ms"));
  unit.addLabel(new LangString("کولن متر مربع", "fa"));
  unit.addLabel(new LangString("Coulomb Square Meter", "en-US"));
  unit.addLabel(new LangString("coulomb per metro quadrato", "it"));
  unit.addLabel(new LangString("库仑平方米", "zh"));
  unit.addLabel(new LangString("Coulomb mal Quadratmeter", "de"));
  unit.addLabel(new LangString("coulomb square metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricQuadrupoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/C-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m²/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("coulomb square metre per kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/C-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-M2-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C·m²/V",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Coulomb mal Quadratmeter je Volt", "de"));
  unit.addLabel(new LangString("کولن متر مربع بر ولت", "fa"));
  unit.addLabel(new LangString("coulomb per metro quadrato al volt", "it"));
  unit.addLabel(new LangString("库伦平方米每伏特", "zh"));
  unit.addLabel(new LangString("coulomb square metre per volt", "en"));
  unit.addLabel(new LangString("Coulomb Square Meter per Volt", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Polarizability");
  config.units.set("http://qudt.org/vocab/unit/C-M2-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Coulomb per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-KiloGM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/(kg·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Kilogram Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExposureRate");
  config.units.set("http://qudt.org/vocab/unit/C-PER-KiloGM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Meter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLineDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLinearDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("coulomb al metro quadrato", "it"));
  unit.addLabel(new LangString("库伦每平方米", "zh"));
  unit.addLabel(new LangString("كولوم في المتر المربع", "ar"));
  unit.addLabel(new LangString("coulomb bölü metre kare", "tr"));
  unit.addLabel(new LangString("coulomb na metr čtvereční", "cs"));
  unit.addLabel(new LangString("کولمب/کولن بر مترمربع", "fa"));
  unit.addLabel(new LangString("кулон на квадратный метр", "ru"));
  unit.addLabel(new LangString("culombio por metro cuadrado", "es"));
  unit.addLabel(new LangString("coulomb par mètre carré", "fr"));
  unit.addLabel(new LangString("coulomb per square metre", "en"));
  unit.addLabel(new LangString("कूलम्ब प्रति वर्ग मीटर", "hi"));
  unit.addLabel(new LangString("coulomb por metro quadrado", "pt"));
  unit.addLabel(new LangString("coulomb per meter persegi", "ms"));
  unit.addLabel(new LangString("kulomb na metr kwadratowy", "pl"));
  unit.addLabel(new LangString("Coulomb je Quadratmeter", "de"));
  unit.addLabel(new LangString("Coulomb per Square Meter", "en-US"));
  unit.addLabel(new LangString("クーロン毎平方メートル", "ja"));
  unit.addLabel(new LangString("coulomb pe metru pătrat", "ro"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Cubic Metre", "en"));
  unit.addLabel(new LangString("Coulomb per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Coulomb per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Square Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C-PER-MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C/mm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Coulomb per Cubic Millimeter", "en-US"));
  unit.addLabel(new LangString("Coulomb per Cubic Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/C-PER-MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C2-M2-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C²·m²/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Coulomb Square Metre per Joule", "en"));
  unit.addLabel(
    new LangString("Square Coulomb Square Meter per Joule", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Polarizability");
  config.units.set("http://qudt.org/vocab/unit/C2-M2-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C3-M-PER-J2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E3L-3I0M-2H0T7D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C³·m/J²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Coulomb Metre per Square Joule", "en"));
  unit.addLabel(
    new LangString("Cubic Coulomb Meter per Square Joule", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_CubicPerEnergy_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/C3-M-PER-J2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C4-M4-PER-J3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E4L-2I0M-3H0T10D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "C⁴·m⁴/J³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Quartic Coulomb Metre per Cubic Energy", "en"));
  unit.addLabel(
    new LangString("Quartic Coulomb Meter per Cubic Energy", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_QuarticPerEnergy_Cubic"
  );
  config.units.set("http://qudt.org/vocab/unit/C4-M4-PER-J3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_15_DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.1855"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal{15 °C}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Calorie (15 Degrees C)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_15_DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_20DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "cal₂₀",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("calorie (20 °C)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_20DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.1868"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal{IT}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("International Table calorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("4186.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Calorie (international Table) per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(g·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Calorie (international Table) per Gram Degree Celsius",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186.8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(g·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Calorie (international Table) per Gram Kelvin", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418.68"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(s·cm·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Calorie (international Table) per Second Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addLabel(
    new LangString(
      "Calorie (international Table) per Second Centimetre Kelvin",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("41868.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{IT}/(s·cm²·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Calorie (international Table) per Second Square Centimetre kelvin",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "Calorie (international Table) per Second Square Centimeter kelvin",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_MEAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal{mean}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Calorie (mean)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_MEAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.184"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "cal",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Thermochemical Calorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418.4"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(cm·s·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Calorie (thermochemical) per Centimetre Second Degree Celsius",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "Calorie (thermochemical) per Centimeter Second Degree Celsius",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("41840.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "calth/cm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("calorie (thermochemical) per square centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("697.3333333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "calth/(cm²·min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "calorie (thermochemical) per square centimetre minute",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("41840.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "calth/(cm²·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "calorie (thermochemical) per square centimetre second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("4184000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal{th}/(cm³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(
    new LangString(
      "Thermochemical Calorie per Cubic Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addLabel(
    new LangString("Thermochemical Calorie per Cubic Centimetre Kelvin", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-G",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/G",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("calorie (thermochemical) per gram (calTH/g)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-G", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Calorie (thermochemical) per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(g·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Calorie (thermochemical) per Gram Degree Celsius", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(g·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Calorie (thermochemical) per Gram Kelvin", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.06973"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Calorie (thermochemical) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("4.184"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Calorie (thermochemical) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418.4"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(s·cm·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Calorie (thermochemical) per Second Centimetre Kelvin",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "Calorie (thermochemical) per Second Centimeter Kelvin",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("41840.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cal/(s·cm²·K)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Calorie (thermochemical) per Second Square Centimeter kelvin",
      "en-US"
    )
  );
  unit.addLabel(
    new LangString(
      "Calorie (thermochemical) per Second Square Centimetre kelvin",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CARAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0002"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ct",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Carat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/CARAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CASES",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("CASES", undefined));
  config.units.set("http://qudt.org/vocab/unit/CASES", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CASES-PER-1000I-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Cases/1000 individuals/year",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Cases per 1000 individuals year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Incidence");
  config.units.set("http://qudt.org/vocab/unit/CASES-PER-1000I-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Cases/1000 individuals/year",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Cases per 1000 individuals year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Incidence");
  config.units.set("http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("kandela", "hu"));
  unit.addLabel(new LangString("candelă", "ro"));
  unit.addLabel(new LangString("कॅन्डेला", "hi"));
  unit.addLabel(new LangString("カンデラ", "ja"));
  unit.addLabel(new LangString("کاندلا", "fa"));
  unit.addLabel(new LangString("kandela", "cs"));
  unit.addLabel(new LangString("candela", "la"));
  unit.addLabel(new LangString("candela", "pt"));
  unit.addLabel(new LangString("坎德拉", "zh"));
  unit.addLabel(new LangString("kandela", "sl"));
  unit.addLabel(new LangString("Candela", "de"));
  unit.addLabel(new LangString("kandela", "pl"));
  unit.addLabel(new LangString("candela", "tr"));
  unit.addLabel(new LangString("candela", "it"));
  unit.addLabel(new LangString("candela", "fr"));
  unit.addLabel(new LangString("candela", "en"));
  unit.addLabel(new LangString("قنديلة", "ar"));
  unit.addLabel(new LangString("кандела", "bg"));
  unit.addLabel(new LangString("кандела", "ru"));
  unit.addLabel(new LangString("kandela", "ms"));
  unit.addLabel(new LangString("καντέλα", "el"));
  unit.addLabel(new LangString("קנדלה", "he"));
  unit.addLabel(new LangString("candela", "es"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/CD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/ft²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("candela per square foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/CD-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1550.0031000062002"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/in²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Candela per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/CD-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-KiloLM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/klm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Candela per Kilolumen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution"
  );
  config.units.set("http://qudt.org/vocab/unit/CD-PER-KiloLM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-LM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/lm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Candela per Lumen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution"
  );
  config.units.set("http://qudt.org/vocab/unit/CD-PER-LM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cd/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("candela per square metre", "en"));
  unit.addLabel(new LangString("candela per square meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/CD-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CD_IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "international candle",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("international candle", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/CD_IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CFU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "CFU",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Colony Forming Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MicrobialFormation"
  );
  config.units.set("http://qudt.org/vocab/unit/CFU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("20.1168"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "ch",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("chain", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/CH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CHAIN_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ch (US survey)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("chain (based on U.S. survey foot)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/CHAIN_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CHF-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "CHF/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Swiss Francs per kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerMass");
  config.units.set("http://qudt.org/vocab/unit/CHF-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ci",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Curie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/CI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CI-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Ci/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("curie per kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CI-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CLO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.155"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2-K-PER-W",
    undefined,
    "clo",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Clo", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/CLO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CM_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98.0665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "cmH₂0",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Centimetre of Water", "en"));
  unit.addLabel(new LangString("Centimeter of Water", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CM_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CORD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("3.62"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "cord",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Cord", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/CORD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "cp",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Candlepower", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/CP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CUP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00023658825"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "cup",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Liquid Cup", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CUP_US");
  config.units.set("http://qudt.org/vocab/unit/CUP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CUP_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00023658825"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "cup{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Cup (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CUP");
  config.units.set("http://qudt.org/vocab/unit/CUP_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CWT_LONG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("50.80235"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{long}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Long Hundred Weight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Hundredweight_UK");
  config.units.set("http://qudt.org/vocab/unit/CWT_LONG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CWT_SHORT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("45.359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{short}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Hundred Weight - Short", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Hundredweight_US");
  config.units.set("http://qudt.org/vocab/unit/CWT_SHORT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CYC",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("CYC", undefined));
  config.units.set("http://qudt.org/vocab/unit/CYC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CYC-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "c/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Cycles per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/HZ");
  config.units.set("http://qudt.org/vocab/unit/CYC-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "abC",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abcoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/C_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abC/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abcoulomb per Square Centimetre", "en"));
  unit.addLabel(new LangString("Abcoulomb per Square Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C_Ab-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3.3356409519815204957557671447492E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C",
    undefined,
    "statC",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statcoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FR");
  config.units.set("http://qudt.org/vocab/unit/C_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("0.00000333564"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statC/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statcoulomb per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Statcoulomb per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/C_Stat-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/C_Stat-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E1L0I0M0H0T1D0",
    new Decimal("3.33564E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statC/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Statcoulomb per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/C_Stat-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "cbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Centibar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CentiBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "cC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("CentiCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/CentiC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "cg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centigram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/CentiGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "cGy",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centigray", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/CentiGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "cL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centilitre", "en-US"));
  unit.addLabel(new LangString("Centilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/CentiL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centimeter", "en-US"));
  unit.addLabel(new LangString("Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centimetre per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000002777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centimetre per Hour", "en"));
  unit.addLabel(new LangString("Centimeter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Centimetre per Kelvin", "en"));
  unit.addLabel(new LangString("Centimeter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.16880878140289E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/(1000 a)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centimetres per thousand years", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-KiloYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("centimeter per second", "en-US"));
  unit.addLabel(new LangString("centimetre per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centimetre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centimetre per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centimeter per Square Second", "en-US"));
  unit.addLabel(new LangString("Centimetre per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.16880878140289E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centimetres per year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/CentiM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM-SEC-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm·s·°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Centimetre Second Degree Celsius", "en"));
  unit.addLabel(new LangString("Centimeter Second Degree Celsius", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperatureTime"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM-SEC-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    undefined,
    undefined,
    "cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("0.006"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²·min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Centimetre Minute", "en"));
  unit.addLabel(new LangString("Square Centimeter Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Square centimetres per cubic centimetre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-ERG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/erg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("square centimetre per erg", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-ERG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/g",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Square centimeters per gram", "en-US"));
  unit.addLabel(new LangString("Square centimetres per gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square centimetres per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/(sr·erg)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("square centimetre per steradian erg", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-PER-V-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²/(V·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("square centimetre per volt second", "en"));
  unit.addLabel(new LangString("Square Centimeter per Volt Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mobility");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-PER-V-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm²·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Centimetre Second", "en"));
  unit.addLabel(new LangString("Square Centimeter Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    undefined,
    undefined,
    "cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("cubic centimetre", "en"));
  unit.addLabel(new LangString("cubic centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic centimetre per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Centimetre per Cubic Centimetre", "en"));
  unit.addLabel(
    new LangString("Cubic Centimeter per Cubic Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Centimeter per Day", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-16"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic centimetre per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic centimetre per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Centimetres per Gram", "en"));
  unit.addLabel(new LangString("Cubic Centimeters per Gram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Centimetre per Hour", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic centimetre per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic centimetre per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Cubic Centimetre per Kelvin", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Centimeter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Centimeter per Minute", "en-US"));
  unit.addLabel(new LangString("Cubic Centimetre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic centimetre per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("cubic centimetre per minute kelvin", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Cubic Centimetre per Mole", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Mole", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(mol·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Cubic Centimeter per Mole Second", "en-US"));
  unit.addLabel(new LangString("Cubic Centimeter per Mole Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Centimetre per Second", "en"));
  unit.addLabel(new LangString("Cubic Centimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic centimetre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm³/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("cubic centimetre per second kelvin", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiM3-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("1E-8"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    undefined,
    undefined,
    "cm⁴",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("quartic Centimetre", "en"));
  unit.addLabel(new LangString("centimetre to the fourth power", undefined));
  unit.addLabel(new LangString("Zentimeter hoch 4", "de"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiM4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L6I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cm⁶",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Sextic Centimetre", "en"));
  unit.addLabel(new LangString("Sextic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingConstant");
  config.units.set("http://qudt.org/vocab/unit/CentiM6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "cmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("CentiMole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Centimole per kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Centimole per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  config.units.set("http://qudt.org/vocab/unit/CentiMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_H20_4DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "cmH₂O (4 °C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centimetre of water (4 °C)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CentiM_H20_4DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98.0665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "cmH₂0",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Conventional Centimetre Of Water", "en"));
  unit.addLabel(new LangString("Conventional Centimeter Of Water", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CentiM_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "cmH₂O (4 °C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centimetre of water (4 °C)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1333.224"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "cmHg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Centimetre Of Mercury", "en"));
  unit.addLabel(new LangString("Centimeter Of Mercury", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CentiM_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "cmHg (0 °C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centimetre of mercury (0 °C)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/CentiM_HG_0DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "cN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("CentiNewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/CentiN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Centinewton Meter", "en-US"));
  unit.addLabel(new LangString("Centinewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/CentiN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cN·m/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("centinewton metre per square metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/CentiN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    "cP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Centipoise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cP/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Centipoise per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/CentiPOISE-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "cP/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("centipoise per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/CentiPOISE-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/CentiST",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Centi",
    "http://qudt.org/vocab/unit/ST",
    undefined,
    "cSt",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Centistokes", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity"
  );
  config.units.set("http://qudt.org/vocab/unit/CentiST", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Ci",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "Ci",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Curie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/Ci", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DARCY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("9.869233E-13"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "d",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Darcy", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/DARCY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("86400.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "d",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FishBiotransformationHalfLife"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BiodegredationHalfLife"
  );
  config.units.set("http://qudt.org/vocab/unit/DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DAY_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("86164.099"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "day{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Sidereal Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/DAY_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("DEATHS", undefined));
  config.units.set("http://qudt.org/vocab/unit/DEATHS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS-PER-1000000I-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "deaths/million individuals/a",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Deaths per Million individuals year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MortalityRate");
  config.units.set("http://qudt.org/vocab/unit/DEATHS-PER-1000000I-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS-PER-1000I-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "deaths/1000 individuals/a",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Deaths per 1000 individuals year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MortalityRate");
  config.units.set("http://qudt.org/vocab/unit/DEATHS-PER-1000I-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "deaths/1000 individuals/a",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Deaths per 1000 individuals year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MortalityRate");
  config.units.set("http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "deaths/million individuals/a",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Deaths per Million individuals year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MortalityRate");
  config.units.set("http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DECADE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dec",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Dec", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/DECADE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0174532925"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "°",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Degree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.00000484813681"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0174532925199433"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degrees per metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000290888209"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0174532925"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("0.0174532925"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00030461742"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Square degree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SolidAngle");
  config.units.set("http://qudt.org/vocab/unit/DEG2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("DEGREE", undefined));
  config.units.set("http://qudt.org/vocab/unit/DEGREE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_API",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°API",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Degree API", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Gravity_API");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_API", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BALLING",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Balling",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree Balling", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BALLING", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BAUME",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bé{origin}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree Baume (origin Scale)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BAUME", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bé{US Heavy}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Degree Baume (US Heavy)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bé{US Light}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Degree Baume (US Light)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_BRIX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Bx",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree Brix", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_BRIX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Oe",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree Oechsle", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_OECHSLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_PLATO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°P",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree Plato", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_PLATO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°Tw",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree Twaddell", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/DEGREE_TWADDELL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    new Decimal("273.15"),
    undefined,
    "http://qudt.org/vocab/unit/K",
    undefined,
    "°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("darjah celsius", "ms"));
  unit.addLabel(new LangString("degree Celsius", "en"));
  unit.addLabel(new LangString("摄氏度", "zh"));
  unit.addLabel(new LangString("gradus celsii", "la"));
  unit.addLabel(new LangString("درجه سانتی گراد/سلسیوس", "fa"));
  unit.addLabel(new LangString("درجة مئوية", "ar"));
  unit.addLabel(new LangString("grad celsius", "ro"));
  unit.addLabel(new LangString("セルシウス度", "ja"));
  unit.addLabel(new LangString("grado celsius", "es"));
  unit.addLabel(new LangString("градус Целзий", "bg"));
  unit.addLabel(new LangString("degré celsius", "fr"));
  unit.addLabel(new LangString("Celsius-fok", "hu"));
  unit.addLabel(new LangString("grado celsius", "it"));
  unit.addLabel(new LangString("צלזיוס", "he"));
  unit.addLabel(new LangString("celsius", "tr"));
  unit.addLabel(new LangString("Grad Celsius", "de"));
  unit.addLabel(new LangString("grau celsius", "pt"));
  unit.addLabel(new LangString("градус Цельсия", "ru"));
  unit.addLabel(new LangString("βαθμός Κελσίου", "el"));
  unit.addLabel(new LangString("stupně celsia", "cs"));
  unit.addLabel(new LangString("stopinja Celzija", "sl"));
  unit.addLabel(new LangString("सेल्सियस", "hi"));
  unit.addLabel(new LangString("stopień celsjusza", "pl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Celsius Centimetre", "en"));
  unit.addLabel(new LangString("Degree Celsius Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·kg/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(
    new LangString("Degrees Celsius kilogram per square metre", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("degree Celsius per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Celsius per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Degree Celsius per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degrees Celsius per metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Celsius per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Celsius per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("3.16880878140289E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C/a",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degrees Celsius per year", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("604800.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C·wk",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Celsius week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_C-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H2T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°C²/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Square Degrees Celsius per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_C2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("DEG_C_GROWING_CEREAL", undefined));
  config.units.set("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("86400.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "GDD",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Growing Degree Days (Cereals)", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay_Cereal"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("0.5555555555555556"),
    new Decimal("459.67"),
    undefined,
    "http://qudt.org/vocab/unit/K",
    undefined,
    "°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("2000.00000000000016"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree Fahrenheit Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.1761101836823058548197662335811061"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour Square Foot per British Thermal Unit (international Table)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("6.933471798515978536211269038626224"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/(Btu{IT}·in)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "degree Fahrenheit hour square foot per British thermal unit (international table) inch",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.1762280394439072243097885617308536"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/Btu{th}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit Hour Square Foot per British Thermal Unit (thermochemical)",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("6.938111789130205681487738650821007"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h·ft²/(Btu{th}·in)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "degree Fahrenheit hour square foot per British thermal unit (thermochemical) inch",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("1.895634240626634551676309339081973"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·h/Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree Fahrenheit Hour per BTU", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("1.896902829486604790432999412407318"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/(Btuth/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "Degree Fahrenheit hour per British thermal unit (thermochemical)",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("0.000005555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Degree Fahrenheit per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.000154320987654321"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.5555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/K",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.009259259259259260000000000000000002"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.5555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-2D0",
    new Decimal("0.5555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Degree Fahrenheit per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("0.0005265650668407318199100859275227703"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·s/Btu{IT}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "degree Fahrenheit second per British thermal unit (international table)",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("0.0005269174526351679973424998367798105"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F·s/Btu{th}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "degree Fahrenheit second per British thermal unit (thermochemical)",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("0.5555555555555556"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/K",
    undefined,
    "°R",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Rankine", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  config.units.set("http://qudt.org/vocab/unit/DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.000154320987654321"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°R/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Rankine per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_R-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.009259259259259260000000000000000002"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°R/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Rankine per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_R-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DEG_R-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.5555555555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°R/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Degree Rankine per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DEG_R-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DIOPTER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PER-M",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Diopter", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Curvature");
  config.units.set("http://qudt.org/vocab/unit/DIOPTER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DPI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("39.37008"),
    undefined,
    undefined,
    undefined,
    undefined,
    "DPI",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Dots per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/DPI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DRAM_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0017718451953125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dr{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Dram (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DRAM_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DRAM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0038879346"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dr{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Dram (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DRAM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DWT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00155517384"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dwt",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Penny Weight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Pennyweight");
  config.units.set("http://qudt.org/vocab/unit/DWT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "dyn",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Dyne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/DYN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Dyne Centimeter", "en-US"));
  unit.addLabel(new LangString("Dyne Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/DYN-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("dyne metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/DYN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Dyne per Centimetre", "en"));
  unit.addLabel(new LangString("Dyne per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/DYN-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn/cm²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Dyne per Square Centimetre", "en"));
  unit.addLabel(new LangString("Dyne per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/DYN-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·s/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Dyne Second per Centimetre", "en"));
  unit.addLabel(new LangString("Dyne Second per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·s/cm³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Dyne Second per Cubic Centimeter", "en-US"));
  unit.addLabel(new LangString("Dyne Second per Cubic Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    new Decimal("100000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dyn·s/cm⁵",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("dyne second per centimetre to the fifth power", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Da",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.66053878283E-27"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "Da",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Dalton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolecularMass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AMU");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/U");
  config.units.set("http://qudt.org/vocab/unit/Da", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Debye",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M0H0T1D0",
    new Decimal("3.33564E-30"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C-M",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Debye", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/Debye", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaARE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/ARE",
    undefined,
    "daa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/DecaARE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "daC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("DecaCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/DecaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("DecaCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/DecaCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "dag",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decagram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DecaGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaK",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("DecaK", undefined));
  config.units.set("http://qudt.org/vocab/unit/DecaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaKiloCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("DecaKiloCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/DecaKiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "daL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decalitre", "en"));
  unit.addLabel(new LangString("Decalitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DecaL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "dam",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decametre", "en"));
  unit.addLabel(new LangString("Decameter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/DecaM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    undefined,
    undefined,
    "dam³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Decameter", "en-US"));
  unit.addLabel(new LangString("Cubic Decametre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DecaM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "daPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decapascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/DecaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DecaPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deca",
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    "daP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Decapoise", "en"));
  unit.addLabel(new LangString("Dekapoise", "de"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/DecaPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/B",
    undefined,
    "dB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Decibel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-MilliW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dB·mW",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel milliwatts", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DeciB-MilliW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dB·mW/Mhz",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel milliwatts per megahertz", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dB/km",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel per kilometre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dB/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dBW",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel watt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/DeciB-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "dbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Decibar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/DeciBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciBAR-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.00031688"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dbar/a",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Decibars per year", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciBAR-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dB(A)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel with A-weighting", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB_A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dBc",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Decibel Carrier Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SignalDetectionThreshold"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_ISO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dBi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel isotropic", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB_ISO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dBmW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Decibel Referred to 1mw", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB_M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciB_Z",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "dB(Z)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("decibel with Z-weighting", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundPowerLevel");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciB_Z", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "dC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("DeciCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/DeciC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0001"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "dg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decigram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/DeciGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decilitre", "en"));
  unit.addLabel(new LangString("Decilitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dL/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decilitre per Gram", "en"));
  unit.addLabel(new LangString("Decilitre per Gram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/DeciL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "dm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decimetre", "en"));
  unit.addLabel(new LangString("Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/DeciM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    undefined,
    undefined,
    "dm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Decimetre", "en"));
  unit.addLabel(new LangString("Square Decimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/DeciM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    undefined,
    undefined,
    "dm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Decimetre", "en"));
  unit.addLabel(new LangString("Cubic Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Decimeter per Day", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Decimeter per Hour", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic decimetre per kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Decimeter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Decimetre per Minute", "en"));
  unit.addLabel(new LangString("Cubic Decimeter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Cubic Decimeter per Mole", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dm³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Decimeter per Second", "en-US"));
  unit.addLabel(new LangString("Cubic Decimetre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/DeciM3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "dN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("DeciNewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/DeciN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Decinewton Metre", "en"));
  unit.addLabel(new LangString("Decinewton Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/DeciN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "dS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("DeciSiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/DeciS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "dS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("decisiemens per metre", "en"));
  unit.addLabel(new LangString("decisiemens per meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/DeciS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ds",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("decisecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/DeciSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciTONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    "dt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("DeciTonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DeciTON_Metric");
  config.units.set("http://qudt.org/vocab/unit/DeciTONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/DeciTON_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Deci",
    "http://qudt.org/vocab/unit/TON_Metric",
    undefined,
    "dt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metric DeciTON", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DeciTONNE");
  config.units.set("http://qudt.org/vocab/unit/DeciTON_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Denier",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.1E-7"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/GM-PER-MilliM",
    undefined,
    "D",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Denier", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/Denier", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/E",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "e",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Elementary Charge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/ElementaryCharge");
  config.units.set("http://qudt.org/vocab/unit/E", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ENZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "U",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("enzyme unit", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/ENZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ENZ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "U/L",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("enzyme units per litre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/ENZ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/ERG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg·cm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("erg square centimetre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/ERG-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg·cm²/g",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("erg square centimetre per gram", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg per Centimeter", "en-US"));
  unit.addLabel(new LangString("Erg per Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Erg per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Erg per Square Centimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/(cm²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg per Square Centimeter Second", "en-US"));
  unit.addLabel(new LangString("Erg per Square Centimetre Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/cm³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Erg per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-G",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/G",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-G", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/g",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/(g·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg per Gram Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-GM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/ERG-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERG-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "erg·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Erg Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/ERG-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ERLANG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "E",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Erlang", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ERLANG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EU",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("EU", undefined));
  config.units.set("http://qudt.org/vocab/unit/EU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EU-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "U/L",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("enzyme units per litre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/EU-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EUR-PER-KiloW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/kW",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Euro per kilowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerPower");
  config.units.set("http://qudt.org/vocab/unit/EUR-PER-KiloW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EUR-PER-KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/(kW·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Euro per kilowatt hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/EUR-PER-KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EUR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Euro per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerArea");
  config.units.set("http://qudt.org/vocab/unit/EUR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EUR-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Euro per watt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerPower");
  config.units.set("http://qudt.org/vocab/unit/EUR-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EUR-PER-W-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/(W·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Euro per watt hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/EUR-PER-W-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EUR-PER-W-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "€/(W·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Euro per watt second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CostPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/EUR-PER-W-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "eV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/EV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    new Decimal("1.602176487E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV·m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("electronvolt square metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    new Decimal("1.602176487E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV·m²/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("electronvolt square metre per kilogram", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-ANGSTROM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/Å",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Electronvolt per Angstrom", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-PER-ANGSTROM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Electron Volt per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/EV-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Electronvolt per Metre", "en"));
  unit.addLabel(new LangString("Electronvolt per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Electron Volt per Tesla", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/EV-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EV-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    undefined,
    undefined,
    "eV·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Electron Volt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/EV-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/E_h",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4.35974394E-18"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hartree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/E_h", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/EarthMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("5972190000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "M⊕",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Earth mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/EarthMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ElementaryCharge",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.602176634E-19"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C",
    undefined,
    "e",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Elementary Charge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/E");
  config.units.set("http://qudt.org/vocab/unit/ElementaryCharge", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaBIT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ExaBIT", undefined));
  config.units.set("http://qudt.org/vocab/unit/ExaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Eibit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exbibit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/ExaBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ebit/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exabit per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/ExaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444479562475.3378569716654"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "EB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("ExaByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ExaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "EC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("ExaCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/ExaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "EJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Exajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/ExaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "EJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exajoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/ExaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaV",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ExaV", undefined));
  config.units.set("http://qudt.org/vocab/unit/ExaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "EV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exavolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/ExaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Exa",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "EW",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exawatt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/ExaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ExbiBIT", undefined));
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1152921504606846980.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Eibit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exbibit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1152921504606846980.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Eibit/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exbibit per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1152921504606846980.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Eibit/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("exbibit per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/ExbiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ExbiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("847976878121765354.5564583782058114"),
    undefined,
    "http://qudt.org/vocab/prefix/Exbi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "EiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("ExbiByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/ExbiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("96485.3399"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/C",
    undefined,
    "F",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Faraday", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("12.5663706"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Fractional area", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SolidAngle");
  config.units.set("http://qudt.org/vocab/unit/FA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "F",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("фарад", "bg"));
  unit.addLabel(new LangString("פאראד", "he"));
  unit.addLabel(new LangString("فاراد", "ar"));
  unit.addLabel(new LangString("farad", "it"));
  unit.addLabel(new LangString("farad", "fr"));
  unit.addLabel(new LangString("farad", "en"));
  unit.addLabel(new LangString("faradio", "es"));
  unit.addLabel(new LangString("farad", "cs"));
  unit.addLabel(new LangString("farad", "hu"));
  unit.addLabel(new LangString("فاراد", "fa"));
  unit.addLabel(new LangString("farad", "pt"));
  unit.addLabel(new LangString("फैराड", "hi"));
  unit.addLabel(new LangString("ファラド", "ja"));
  unit.addLabel(new LangString("Farad", "de"));
  unit.addLabel(new LangString("фарада", "ru"));
  unit.addLabel(new LangString("farad", "ms"));
  unit.addLabel(new LangString("farad", "pl"));
  unit.addLabel(new LangString("faradium", "la"));
  unit.addLabel(new LangString("farad", "sl"));
  unit.addLabel(new LangString("φαράντ", "el"));
  unit.addLabel(new LangString("farad", "ro"));
  unit.addLabel(new LangString("法拉", "zh"));
  unit.addLabel(new LangString("farad", "tr"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "F/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Farad per Kilometre", "en"));
  unit.addLabel(new LangString("Farad per Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/FARAD-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "F/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Farad per Meter", "en-US"));
  unit.addLabel(new LangString("فاراد بر متر", "fa"));
  unit.addLabel(new LangString("faradů na metr", "cs"));
  unit.addLabel(new LangString("Farad je Meter", "de"));
  unit.addLabel(new LangString("مقياس التبادل، الأس السالب للمتر", "ar"));
  unit.addLabel(new LangString("farad na metr", "pl"));
  unit.addLabel(new LangString("farad bölü metre", "tr"));
  unit.addLabel(new LangString("фарада на метр", "ru"));
  unit.addLabel(new LangString("faradio por metro", "es"));
  unit.addLabel(new LangString("farad na meter", "sl"));
  unit.addLabel(new LangString("farad pe metru", "ro"));
  unit.addLabel(new LangString("प्रति मीटर फैराड", "hi"));
  unit.addLabel(new LangString("farad par mètre", "fr"));
  unit.addLabel(new LangString("法拉每米", "zh"));
  unit.addLabel(new LangString("farad por metro", "pt"));
  unit.addLabel(new LangString("ファラド毎メートル", "ja"));
  unit.addLabel(new LangString("farad per meter", "ms"));
  unit.addLabel(new LangString("farad per metre", "en"));
  unit.addLabel(new LangString("farad al metro", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/FARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "abF",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abfarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FARAD_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("100000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abF/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abfarad per Centimeter", "en-US"));
  unit.addLabel(new LangString("Abfarad per Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FARAD_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1.112650056053618432174089964848E-18"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "statF",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statfarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FARAD_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FATH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.8288"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "fathom",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Fathom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FATH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FBM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00236"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "BDFT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Board Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/FBM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10.764"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    "fc",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Foot Candle", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/FC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FLIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "flight",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Flight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/FLIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "fm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("fermi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FemtoM");
  config.units.set("http://qudt.org/vocab/unit/FM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3.3356409519815204957557671447492E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "Fr",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Franklin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/C_Stat");
  config.units.set("http://qudt.org/vocab/unit/FR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FRACTION",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "÷",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Fraction", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/OpeningRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reflectance");
  config.units.set("http://qudt.org/vocab/unit/FRACTION", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FRAME",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("FRAME", undefined));
  config.units.set("http://qudt.org/vocab/unit/FRAME", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FRAME-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "fps",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Frame per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VideoFrameRate");
  config.units.set("http://qudt.org/vocab/unit/FRAME-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.3048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("241367.856773623047497959785222025991904"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(lb/(ft·h))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot hour per gallon (UK)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("289870.709611549093228056585983301828"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(lb/(ft·h))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot hour per gallon (US)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-HR-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-HR-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("66960133.9202678405356810713621427250112"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(lb/(ft·h))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot hour per cubic inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-HR-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("3.4262591"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Foot Lambert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/FT-LA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.35581807"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("14.5939042"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot Pound per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("14.5939042"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/(ft²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("Foot Pound Force per Square Foot Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0003766161136565500904"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot Pound Force per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.35581800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Foot Pound Force per Square Meter", "en-US"));
  unit.addLabel(new LangString("Foot Pound Force per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0225969678"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot Pound Force per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.35581807"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot Pound Force per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.35581800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·lbf·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot Pound Force Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/FT-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0421401100938048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft·pdl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot Poundal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/FT-PDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00000352777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.54864"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/FT-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00008466666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00508"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.00004420750047668715004148802456506335464"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot per psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.3048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("0.5486399999999999561088000000000036576"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/(s·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot per second degree Fahrenheit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.00004420750047668715004148802456506335464"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/(s·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot per second psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.3048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Foot per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/FT-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("67.04662688156195763832216256167388664"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(lb/(ft·s))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot second per gallon (UK)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("80.51964155876363700779349610647273"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(lb/(ft·s))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot second per gallon (US)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT-SEC-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("18600.037200074400148800297600595201392"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(lb/(ft·s))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot second per cubic inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT-SEC-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.09290304"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T0D0",
    new Decimal("0.051612800000000004129024"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Foot Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTemperature");
  config.units.set("http://qudt.org/vocab/unit/FT2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T1D0",
    new Decimal("185.8060800000000148644864"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·h·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Foot Hour Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/FT2-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.1761101836823058548197662335811061"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·h·°F/Btu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("Square Foot Hour Degree Fahrenheit per BTU", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H0T2D0",
    new Decimal("0.00346673589"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²/(Btu{IT}·in)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Foot per BTU Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.0000258064"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/FT2-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.09290304"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Foot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/FT2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT2-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T1D0",
    new Decimal("0.051612800000000004129024"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft²·s·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Foot Second Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/FT2-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.028316846592"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.277413E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Foot per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.05097033"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Foot per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000007865792"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.06242796057614461195632545582722213"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/lbm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic foot per pound", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0004719474432000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Foot per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00508"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/(min·ft²)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Foot per Minute Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-MIN-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("0.0000041070111850856853677903636056890634386541056"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic foot per psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.028316846592000004"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Foot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/FT3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("0.0086309748412416"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft⁴",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot to the fourth power", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/FT4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("2989.067"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "ftH₂0",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Foot of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/FT_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "ftH₂O (39.2 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("foot of water (39.2 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("40636.66"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "ftHg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Foot Of Mercury", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/FT_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.3048006"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "ft{US Survey}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Survey Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FUR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("201.168"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "furlong",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Furlong", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FUR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FUR_Long",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "furlong{long}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Long Furlong", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/FUR_Long", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "fA",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("femtoampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "fC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("FemtoCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/FemtoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "fF",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("femtofarad", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/FemtoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "fg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("FemtoGram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/FemtoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Femtograms per kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Femtograms per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/FemtoGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "fJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Femtojoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/FemtoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "fL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Femtolitre", "en"));
  unit.addLabel(new LangString("Femtolitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/FemtoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "fm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Femtometre", "en"));
  unit.addLabel(new LangString("Femtometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/FM");
  config.units.set("http://qudt.org/vocab/unit/FemtoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "fmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("FemtoMole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Femtomoles per kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Femtomoles per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "fs",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Femtosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/FemtoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/FemtoV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Femto",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "fV",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("femtovolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/FemtoV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Flight",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "flight",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Flight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/Flight", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/G",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "G",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Gravity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/G", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("GAL", undefined));
  config.units.set("http://qudt.org/vocab/unit/GAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GALILEO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gal",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Galileo", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/GALILEO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_IMP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00454609"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "gal{Imp}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GAL_UK");
  config.units.set("http://qudt.org/vocab/unit/GAL_IMP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00454609"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GAL_IMP");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("5.261678E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gallon (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001262803"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gallon (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00007576817"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gallon (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00454609"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gallon (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.003785412"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.38126389E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Gallon per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001051503"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Gallon (US) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0000630902"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Gallon per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.003785412"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Gallon (US Liquid) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GAL_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAL_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00440488377"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gal{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Dry Gallon US", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/GAL_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAUGE_FR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0003333333"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "French gauge",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("French Gauge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/GAUGE_FR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GAUSS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "Gs",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Gauss", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Gs");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/T_Ab");
  config.units.set("http://qudt.org/vocab/unit/GAUSS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GA_Charriere",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Ch",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Charrière gauge", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/GA_Charriere", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.795774715"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "Gb",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Gilbert", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  config.units.set("http://qudt.org/vocab/unit/GI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0001420653"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "gill{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gill (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/GI_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.644274E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gill (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.946258E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gill (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000002367755"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gill (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0001420653"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Gill (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000118294125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "gill{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Gill (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/GI_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.369145E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Gill (US) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.285947E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Gill (US) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001971568"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Gill (US) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GI_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0001182941"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gill{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Gill (US) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GI_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-CentiM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·(cm/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram centimetre per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/GM-CentiM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(cm³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram hour per litre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(m³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram hour per litre cubic metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(l/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram hour per litre squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(cm³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram hour per cubic metre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(l/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram hour per cubic metre litre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-HR-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(m³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "gram hour per power of metre with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-HR-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(cm³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram minute per litre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(m³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram minute per litre cubic metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(l/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram minute per litre squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(cm³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram minute per cubic metre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(l/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram minute per cubic metre litre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.06"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(m³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "gram minute per power of metre with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-MIN-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g·mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram Millimeter", "en-US"));
  unit.addLabel(new LangString("Gram Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/GM-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per centimetre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time_Squared");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per centimetre second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Square Centimetre", "en"));
  unit.addLabel(new LangString("Gram per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("3.16880878140289E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm²·a)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Grams per square centimetre year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM2-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Gram per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic centimetre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(cm³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic centimetre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.157407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Gram Degree Celsius", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("grams per decilitre", "en-US"));
  unit.addLabel(new LangString("grams per decilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/dm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Cubic Decimetre", "en"));
  unit.addLabel(new LangString("Gram per Cubic Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(dm³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic decimetre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(dm³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic decimetre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-DeciM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("2.777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/Hz",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per hertz", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Kilometer", "en-US"));
  unit.addLabel(new LangString("Gram per Kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Litre", "en"));
  unit.addLabel(new LangString("Gram per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(l·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per litre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/cP",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per litre centipoise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(l·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per litre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(mPa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per litre millipascal second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(Pa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per litre pascal second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-L-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/P",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per litre poise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-L-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Metre", "en"));
  unit.addLabel(new LangString("Gram per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Square Metre", "en"));
  unit.addLabel(new LangString("Gram per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.1574073E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m²·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("grams per square meter day", "en-US"));
  unit.addLabel(new LangString("grams per square metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Gram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic metre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/cP",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic metre centipoise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(m³·mPa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram per cubic metre millipascal second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(Pa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram per cubic metre pascal second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-M3-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/P",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per cubic metre poise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-M3-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00001666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Gram per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarMass");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Millilitre", "en"));
  unit.addLabel(new LangString("Gram per Millilitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(ml·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per millilitre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliL-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(ml·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per millilitre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliL-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Millimetre", "en"));
  unit.addLabel(new LangString("Gram per Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliM-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(mm·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Gram per Millimetre Bar", "en"));
  unit.addLabel(new LangString("Gram per Millimeter Bar", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time_Squared");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliM-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/mm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per square millimetre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gram per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(cm³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram second per litre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(m³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram second per litre cubic metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/l)/(l/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram second per litre squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(cm³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gram second per cubic metre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(l/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gram second per cubic metre litre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(g/m³)/(m³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "gram second per power of metre with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/GM-SEC-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Carbon",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("GM_Carbon", undefined));
  config.units.set("http://qudt.org/vocab/unit/GM_Carbon", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.1574073E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g{carbon}/(m²·day)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("grams Carbon per square meter day", "en-US"));
  unit.addLabel(new LangString("grams Carbon per square metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_DRY",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("GM_DRY", undefined));
  config.units.set("http://qudt.org/vocab/unit/GM_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00980665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "gf",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Gram Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/GM_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98.0665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gf/cm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Gram Force per Square Centimetre", "en"));
  unit.addLabel(new LangString("Gram Force per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/GM_F-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Nitrogen",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("GM_Nitrogen", undefined));
  config.units.set("http://qudt.org/vocab/unit/GM_Nitrogen", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.1574073E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "g{nitrogen}/(m²·day)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("grams Nitrogen per square metre day", "en"));
  unit.addLabel(new LangString("grams Nitrogen per square meter day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.015707963267949"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gon",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Gon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GRAD");
  config.units.set("http://qudt.org/vocab/unit/GON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "gr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Grade", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/GR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.015707963267949"),
    undefined,
    undefined,
    undefined,
    undefined,
    "grad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Grad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GON");
  config.units.set("http://qudt.org/vocab/unit/GRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00006479891"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "gr{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Grain", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/GRAIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.017118061"),
    undefined,
    undefined,
    undefined,
    undefined,
    "grain{UK}/gal",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Grain per Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GRAIN-PER-GAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.01711806"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gr{UK}/gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Grain per Gallon (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GRAIN-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAIN-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.00006479891"),
    undefined,
    undefined,
    undefined,
    undefined,
    "gr{UK}/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Grains per Cubic Metre", "en"));
  unit.addLabel(new LangString("Grains per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/GRAIN-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gray", "de"));
  unit.addLabel(new LangString("gray", "pt"));
  unit.addLabel(new LangString("גריי", "he"));
  unit.addLabel(new LangString("gray", "ms"));
  unit.addLabel(new LangString("γκρέι", "el"));
  unit.addLabel(new LangString("грэй", "ru"));
  unit.addLabel(new LangString("gray", "en"));
  unit.addLabel(new LangString("戈瑞", "zh"));
  unit.addLabel(new LangString("gray", "it"));
  unit.addLabel(new LangString("gray", "fr"));
  unit.addLabel(new LangString("gray", "hu"));
  unit.addLabel(new LangString("gray", "es"));
  unit.addLabel(new LangString("grej", "pl"));
  unit.addLabel(new LangString("gray", "cs"));
  unit.addLabel(new LangString("グレイ", "ja"));
  unit.addLabel(new LangString("گری", "fa"));
  unit.addLabel(new LangString("gray", "sl"));
  unit.addLabel(new LangString("graium", "la"));
  unit.addLabel(new LangString("جراي; غراي", "ar"));
  unit.addLabel(new LangString("gray", "ro"));
  unit.addLabel(new LangString("gray", "tr"));
  unit.addLabel(new LangString("ग्रेय", "hi"));
  unit.addLabel(new LangString("грей", "bg"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/GRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gray per hour", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/GRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gray per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/GRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gy/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gray per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/GRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "G.T.",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Gross Tonnage", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/GT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Gamma",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "γ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Gamma", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  config.units.set("http://qudt.org/vocab/unit/Gamma", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("744261117.954893"),
    undefined,
    "http://qudt.org/vocab/prefix/Gibi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Gibit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gibibit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/GibiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("744261117.95489301787390319512589573292032"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gibit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gibibit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GibiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("744261117.95489301787390319512589573292032"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gibit/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gibibit per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/GibiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("744261117.95489301787390319512589573292032"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gibit/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gibibit per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GibiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GibiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5954088943.6391441429912255610071"),
    undefined,
    "http://qudt.org/vocab/prefix/Gibi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "GiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("GibiByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/GibiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "GA",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigaampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147180.55994530941723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Gbit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigabit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/GigaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("693147180.55994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gbit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigabit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147180.55994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gbps",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Gigabit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/GigaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "GBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Gigabecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/GigaBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444.47956"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "GB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("GigaByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5545177444.4795624753378569716654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gbyte/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigabyte per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ByteRate");
  config.units.set("http://qudt.org/vocab/unit/GigaBYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaBasePair",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Gbp",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Gigabase Pair", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/GigaBasePair", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "GC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("GigaCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/GigaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gigacoulomb per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Gigacoulomb per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaEV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-10"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/EV",
    undefined,
    "GeV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Giga Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/GigaEV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GFLOPS",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("gigafloatingpoint operations per second", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "GHz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Gigahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/GigaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaHZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GHz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gigahertz Metre", "en"));
  unit.addLabel(new LangString("Gigahertz Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ConductionSpeed");
  config.units.set("http://qudt.org/vocab/unit/GigaHZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "GJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gigajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/GigaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("277777.7777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GJ/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gigajoule per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/GigaJ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GJ/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gigajoule per Square Metre", "en"));
  unit.addLabel(new LangString("Gigajoule per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  config.units.set("http://qudt.org/vocab/unit/GigaJ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigajoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/GigaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaN",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("GigaN", undefined));
  config.units.set("http://qudt.org/vocab/unit/GigaN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GN·m/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("giganewton metre per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/GigaN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "GΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Gigaohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/GigaOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GΩ·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigaohm metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/GigaOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GΩ/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigaohm per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "GPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gigapascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/GigaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GPa·cm³/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Gigapascal Cubed Centimeter per Gram", "en-US")
  );
  unit.addLabel(new LangString("Gigapascal Cubed Centimetre per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloM2-PER-SEC2");
  config.units.set("http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "GV",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigavolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/GigaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigavolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/GigaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "GV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("gigavolt ampere reactive", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/GigaV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Giga",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "GW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Gigawatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/GigaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/GigaW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "GW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Gigawatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/GigaW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Gs",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "G",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Gs", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GAUSS");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/T_Ab");
  config.units.set("http://qudt.org/vocab/unit/Gs", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("генри", "ru"));
  unit.addLabel(new LangString("henry", "cs"));
  unit.addLabel(new LangString("ヘンリー", "ja"));
  unit.addLabel(new LangString("הנרי", "he"));
  unit.addLabel(new LangString("هنری", "fa"));
  unit.addLabel(new LangString("хенри", "bg"));
  unit.addLabel(new LangString("henry", "en"));
  unit.addLabel(new LangString("henrium", "la"));
  unit.addLabel(new LangString("henry", "hu"));
  unit.addLabel(new LangString("henrio", "es"));
  unit.addLabel(new LangString("henry", "fr"));
  unit.addLabel(new LangString("henry", "it"));
  unit.addLabel(new LangString("हेनरी", "hi"));
  unit.addLabel(new LangString("henry", "ms"));
  unit.addLabel(new LangString("Henry", "de"));
  unit.addLabel(new LangString("χένρι", "el"));
  unit.addLabel(new LangString("henr", "pl"));
  unit.addLabel(new LangString("henry", "pt"));
  unit.addLabel(new LangString("henry", "sl"));
  unit.addLabel(new LangString("henry", "tr"));
  unit.addLabel(new LangString("هنري", "ar"));
  unit.addLabel(new LangString("henry", "ro"));
  unit.addLabel(new LangString("亨利", "zh"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/H", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H-PER-KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H/kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Henry per Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/H-PER-KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Henry per Meter", "en-US"));
  unit.addLabel(new LangString("Henry per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/H-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "H/Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Henry per Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/H-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HART",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("2.3025850929940456840179914546844"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hart",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Hartley", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/HART", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HART-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("2.3025850929940456840179914546844"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hart/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Hartley per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/HART-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "HK",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Hefner-Kerze", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/HK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("745.6999"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Horsepower", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Boiler",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("9809.5"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{boiler}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Boiler Horsepower", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Boiler", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Brake",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("9809.5"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{brake}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Horsepower (brake)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Brake", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Electric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("746.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{electric}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Horsepower (electric)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Electric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("746.043"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "water hp",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("horsepower (water)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  config.units.set("http://qudt.org/vocab/unit/HP_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HP_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("735.4988"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "HP{metric}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Horsepower (metric)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HP_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("334.450944"),
    undefined,
    undefined,
    undefined,
    undefined,
    "h·ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Hour Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/HR-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("38750.07750015500031000062000124"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(lb/(ft·h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("hour per square foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/HR-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "h/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
    ]
  );
  unit.addLabel(new LangString("Uur per Jaar", "nl"));
  unit.addLabel(new LangString("Hours per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeRatio");
  config.units.set("http://qudt.org/vocab/unit/HR-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HR_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("3590.17"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "h{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Sidereal Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/HR_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("hertz", "sl"));
  unit.addLabel(new LangString("Hertz", "de"));
  unit.addLabel(new LangString("herc", "pl"));
  unit.addLabel(new LangString("hertz", "cs"));
  unit.addLabel(new LangString("hertz", "it"));
  unit.addLabel(new LangString("hercio", "es"));
  unit.addLabel(new LangString("hertz", "fr"));
  unit.addLabel(new LangString("hertz", "hu"));
  unit.addLabel(new LangString("hertz", "ms"));
  unit.addLabel(new LangString("הרץ", "he"));
  unit.addLabel(new LangString("हर्ट्ज", "hi"));
  unit.addLabel(new LangString("hertz", "en"));
  unit.addLabel(new LangString("херц", "bg"));
  unit.addLabel(new LangString("hertzium", "la"));
  unit.addLabel(new LangString("hertz", "pt"));
  unit.addLabel(new LangString("ヘルツ", "ja"));
  unit.addLabel(new LangString("هرتز", "fa"));
  unit.addLabel(new LangString("hertz", "tr"));
  unit.addLabel(new LangString("герц", "ru"));
  unit.addLabel(new LangString("χερτζ", "el"));
  unit.addLabel(new LangString("赫兹", "zh"));
  unit.addLabel(new LangString("هرتز", "ar"));
  unit.addLabel(new LangString("hertz", "ro"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-SEC");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CYC-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hertz Meter", "en-US"));
  unit.addLabel(new LangString("Hertz Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/HZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("हर्ट्ज प्रति कैल्विन", "hi"));
  unit.addLabel(new LangString("hertz por kelvin", "pt"));
  unit.addLabel(new LangString("hertz bölü kelvin", "tr"));
  unit.addLabel(new LangString("Hertz je Kelvin", "de"));
  unit.addLabel(new LangString("hertz par kelvin", "fr"));
  unit.addLabel(new LangString("هرتز بر کلوین", "fa"));
  unit.addLabel(new LangString("ヘルツ毎立方メートル", "ja"));
  unit.addLabel(new LangString("герц на кельвин", "ru"));
  unit.addLabel(new LangString("hertz per kelvin", "en"));
  unit.addLabel(new LangString("hertz na kelvin", "cs"));
  unit.addLabel(new LangString("hertz pe kelvin", "ro"));
  unit.addLabel(new LangString("hertz al kelvin", "it"));
  unit.addLabel(new LangString("hertz per kelvin", "ms"));
  unit.addLabel(new LangString("hercio por kelvin", "es"));
  unit.addLabel(new LangString("هرتز لكل كلفن", "ar"));
  unit.addLabel(new LangString("herc na kelwin", "pl"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/HZ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Hertz per Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/HZ-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HZ-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Hz/V",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Hertz per Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux"
  );
  config.units.set("http://qudt.org/vocab/unit/HZ-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/H",
    undefined,
    "abH",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abhenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NanoH");
  config.units.set("http://qudt.org/vocab/unit/H_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("898760000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/H",
    undefined,
    "statH",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Stathenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/H_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/H_Stat-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("89876000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statH/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Stathenry per Centimeter", "en-US"));
  unit.addLabel(new LangString("Stathenry per Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/H_Stat-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HeartBeat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "heartbeat",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Heart Beat", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/HeartBeat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "hbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Hectobar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/HectoBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "hC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("HectoCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/HectoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "hg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/HectoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoKiloCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("HectoKiloCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/HectoKiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "hL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectolitre", "en-US"));
  unit.addLabel(new LangString("Hectolitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/HectoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "hm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectometre", "en"));
  unit.addLabel(new LangString("Hectometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/HectoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Hecto",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "hPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectopascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliBAR");
  config.units.set("http://qudt.org/vocab/unit/HectoPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa·L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectopascal Litre per Second", "en"));
  unit.addLabel(new LangString("Hectopascal Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HectoPA-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa·m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectopascal Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Hectopascal Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Hectopascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.0277777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Hectopascals per hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Hectopascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/HectoPA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "hPa/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("hectopascal per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/HectoPA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Hundredweight_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("50.80235"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{long}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Hundredweight (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CWT_LONG");
  config.units.set("http://qudt.org/vocab/unit/Hundredweight_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Hundredweight_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("45.359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "cwt{short}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Hundredweight (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CWT_SHORT");
  config.units.set("http://qudt.org/vocab/unit/Hundredweight_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0254"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0035116758411504"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in·pdl",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch poundal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/IN-PDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-2PiRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "in/revolution",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch per two pi radians", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion"
  );
  config.units.set("http://qudt.org/vocab/unit/IN-PER-2PiRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.04572"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Inch per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/IN-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000423333333"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Inch per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.00000368395837305726250345733538042194622"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch per psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0254"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropellantBurnRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("0.0457199999999999963424000000000003048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/(s·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch per second degree Fahrenheit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.00000368395837305726250345733538042194622"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/(s·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch per second psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.0254"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Inch per Square second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/IN-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("8.048774304763353360204831799629884E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in/y",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch per year", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/IN-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.00064516"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.00064516"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in²/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/IN2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000016387064"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.551961E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Inch per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.00003612729200008368747472537952964244"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/lbm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic inch per pound", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.7311773333333333E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Inch per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001638706"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/IN3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("4.162314E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in⁴",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Quartic Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/IN4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("249.080024"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inH₂0",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Inch of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "inH₂O (39.2 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch of water (39.2 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "inH₂O (60 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch of water (60 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_H2O_60DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3386.389"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "inHg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Inch of Mercury", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_HG_32DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "inHg (32 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch of mercury (32 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_HG_32DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IN_HG_60DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "inHg (60 °F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("inch of mercury (60 °F)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/IN_HG_60DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "IU",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("International Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/IU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "IU/L",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("International Unit per Litre", "en"));
  unit.addLabel(new LangString("International Unit per Liter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SerumOrPlasmaLevel"
  );
  config.units.set("http://qudt.org/vocab/unit/IU-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.000001"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "IU/mg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("International Unit per milligram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/IU-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/IU-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "IU/mL",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("International Unit per milliliter", "en"));
  unit.addLabel(new LangString("International Unit per milliliter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SerumOrPlasmaLevel"
  );
  config.units.set("http://qudt.org/vocab/unit/IU-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule", "de"));
  unit.addLabel(new LangString("dżul", "pl"));
  unit.addLabel(new LangString("joule", "ro"));
  unit.addLabel(new LangString("joule", "tr"));
  unit.addLabel(new LangString("joule", "sl"));
  unit.addLabel(new LangString("joule", "pt"));
  unit.addLabel(new LangString("joule", "ms"));
  unit.addLabel(new LangString("joulium", "la"));
  unit.addLabel(new LangString("джоуль", "ru"));
  unit.addLabel(new LangString("джаул", "bg"));
  unit.addLabel(new LangString("julio", "es"));
  unit.addLabel(new LangString("joule", "fr"));
  unit.addLabel(new LangString("जूल", "hi"));
  unit.addLabel(new LangString("joule", "hu"));
  unit.addLabel(new LangString("joule", "en"));
  unit.addLabel(new LangString("joule", "it"));
  unit.addLabel(new LangString("焦耳", "zh"));
  unit.addLabel(new LangString("joule", "cs"));
  unit.addLabel(new LangString("ジュール", "ja"));
  unit.addLabel(new LangString("τζάουλ", "el"));
  unit.addLabel(new LangString("ژول", "fa"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LevelWidth");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M");
  config.units.set("http://qudt.org/vocab/unit/J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-M-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·m/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule Meter per Mole", "en-US"));
  unit.addLabel(new LangString("Joule Metre per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthMolarEnergy"
  );
  config.units.set("http://qudt.org/vocab/unit/J-M-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule Square Meter", "en-US"));
  unit.addLabel(new LangString("Joule Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/J-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·m²/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule Square Metre per Kilogram", "en"));
  unit.addLabel(new LangString("Joule Square Meter per Kilogram", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower"
  );
  config.units.set("http://qudt.org/vocab/unit/J-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Square Centimetre", "en"));
  unit.addLabel(new LangString("Joule per Square Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/J-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.115740740740741"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(cm²·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joules per square centimetre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Radiosity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/J-PER-CentiM2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(cm³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule per Cubic Centimetre Kelvin", "en"));
  unit.addLabel(new LangString("Joule per Cubic Centimeter Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/d",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("joule per day", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(g·°C)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("joule per gram degree celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(g·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule per Gram Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("جول لكل كلفن", "ar"));
  unit.addLabel(new LangString("dżul na kelwin", "pl"));
  unit.addLabel(new LangString("joule na kelvin", "sl"));
  unit.addLabel(new LangString("जूल प्रति कैल्विन", "hi"));
  unit.addLabel(new LangString("焦耳每开尔文", "zh"));
  unit.addLabel(new LangString("джоуль на кельвин", "ru"));
  unit.addLabel(new LangString("Joule je Kelvin", "de"));
  unit.addLabel(new LangString("joule al kelvin", "it"));
  unit.addLabel(new LangString("joule na kelvin", "cs"));
  unit.addLabel(new LangString("joule por kelvin", "pt"));
  unit.addLabel(new LangString("julio por kelvin", "es"));
  unit.addLabel(new LangString("ژول بر کلوین", "fa"));
  unit.addLabel(new LangString("ジュール毎立方メートル", "ja"));
  unit.addLabel(new LangString("joule per kelvin", "ms"));
  unit.addLabel(new LangString("joule par kelvin", "fr"));
  unit.addLabel(new LangString("joule pe kelvin", "ro"));
  unit.addLabel(new LangString("joule bölü kelvin", "tr"));
  unit.addLabel(new LangString("joule per kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Entropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·°C)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("joule por quilograma grau celsius", "pt"));
  unit.addLabel(new LangString("joule na kilogram stopinja celzija", "sl"));
  unit.addLabel(new LangString("Joule je Kilogramm Grad Celsius", "de"));
  unit.addLabel(new LangString("joule per kilogram celsius", "tr"));
  unit.addLabel(new LangString("julio porkilogramo grado celsius", "es"));
  unit.addLabel(new LangString("joule na kilogram stupně celsia", "cs"));
  unit.addLabel(new LangString("joule per kilogram darjah celsius", "ms"));
  unit.addLabel(new LangString("joule per kilogram degree celsius", "en"));
  unit.addLabel(new LangString("joule par kilogramme-degré celsius", "fr"));
  unit.addLabel(new LangString("джоуль на килограмм-градус цельсия", "ru"));
  unit.addLabel(new LangString("joule al chilogrammo per grado celsius", "it"));
  unit.addLabel(new LangString("dżul na kilogramostopień celsjusza", "pl"));
  unit.addLabel(new LangString("joule pe kilogram-grad celsius", "ro"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule per Kilogram Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·K·m³)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule per Kilogram Kelvin Cubic Metre", "en"));
  unit.addLabel(
    new LangString("Joule per Kilogram Kelvin Cubic Meter", "en-US")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatVolume"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(kg·K·Pa)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule per Kilogram Kelvin Pascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatPressure"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Metre", "en"));
  unit.addLabel(new LangString("Joule per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Square Meter", "en-US"));
  unit.addLabel(new LangString("Joule per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  config.units.set("http://qudt.org/vocab/unit/J-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Joule per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(m³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule per Cubic Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Joule per Cubic Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-M4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/m⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Quartic Metre", "en"));
  unit.addLabel(new LangString("Joule per Quartic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-M4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("joule per minute", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("जूल प्रति मोल (इकाई)", "hi"));
  unit.addLabel(new LangString("Joule je Mol", "de"));
  unit.addLabel(new LangString("joule par mole", "fr"));
  unit.addLabel(new LangString("джоуль на моль", "ru"));
  unit.addLabel(new LangString("joule per mole", "en"));
  unit.addLabel(new LangString("焦耳每摩尔", "zh"));
  unit.addLabel(new LangString("joule na mol", "cs"));
  unit.addLabel(new LangString("joule per mole", "ms"));
  unit.addLabel(new LangString("joule por mol", "pt"));
  unit.addLabel(new LangString("joule na mol", "sl"));
  unit.addLabel(new LangString("جول لكل مول", "ar"));
  unit.addLabel(new LangString("dżul na mol", "pl"));
  unit.addLabel(new LangString("julio por mol", "es"));
  unit.addLabel(new LangString("ジュール毎立方メートル", "ja"));
  unit.addLabel(new LangString("joule bölü metre küp", "tr"));
  unit.addLabel(new LangString("joule alla mole", "it"));
  unit.addLabel(new LangString("ژول بر مول", "fa"));
  unit.addLabel(new LangString("joule pe mol", "ro"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEnergy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ChemicalAffinity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarizability"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-MOL-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/(mol·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule per Mole Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEntropy");
  config.units.set("http://qudt.org/vocab/unit/J-PER-MOL-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Joule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/J-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("joule par tesla", "fr"));
  unit.addLabel(new LangString("جول لكل تسلا", "ar"));
  unit.addLabel(new LangString("ژول بر تسلا", "fa"));
  unit.addLabel(new LangString("焦耳每特斯拉", "zh"));
  unit.addLabel(new LangString("joule na tesla", "cs"));
  unit.addLabel(new LangString("जूल प्रति टैस्ला", "hi"));
  unit.addLabel(new LangString("dżul na tesla", "pl"));
  unit.addLabel(new LangString("joule per tesla", "en"));
  unit.addLabel(new LangString("joule per tesla", "ms"));
  unit.addLabel(new LangString("julio por tesla", "es"));
  unit.addLabel(new LangString("joule bölü tesla", "tr"));
  unit.addLabel(new LangString("joule por tesla", "pt"));
  unit.addLabel(new LangString("Joule je Tesla", "de"));
  unit.addLabel(new LangString("ジュール毎立方メートル", "ja"));
  unit.addLabel(new LangString("joule pe tesla", "ro"));
  unit.addLabel(new LangString("джоуль на тесла", "ru"));
  unit.addLabel(new LangString("joule al tesla", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticMoment");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-PER-T2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J/T²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Joule per Square Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerMagneticFluxDensity_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/J-PER-T2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("joule second", "en"));
  unit.addLabel(new LangString("ジュール秒", "ja"));
  unit.addLabel(new LangString("joule-segundo", "pt"));
  unit.addLabel(new LangString("Joulesekunde", "de"));
  unit.addLabel(new LangString("joule sekunda", "cs"));
  unit.addLabel(new LangString("dżulosekunda", "pl"));
  unit.addLabel(new LangString("joule saat", "ms"));
  unit.addLabel(new LangString("joule-seconde", "fr"));
  unit.addLabel(new LangString("जूल सैकण्ड", "hi"));
  unit.addLabel(new LangString("julio segundo", "es"));
  unit.addLabel(new LangString("joule sekunda", "sl"));
  unit.addLabel(new LangString("joule saniye", "tr"));
  unit.addLabel(new LangString("焦耳秒", "zh"));
  unit.addLabel(new LangString("джоуль-секунда", "ru"));
  unit.addLabel(new LangString("joule per secondo", "it"));
  unit.addLabel(new LangString("ژول ثانیه", "fa"));
  unit.addLabel(new LangString("joule-secundă", "ro"));
  unit.addLabel(new LangString("جول ثانية", "ar"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Action");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/J-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/J-SEC-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J·s/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Joule Second per Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarAngularMomentum"
  );
  config.units.set("http://qudt.org/vocab/unit/J-SEC-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("kelvin", "pt"));
  unit.addLabel(new LangString("كلفن", "ar"));
  unit.addLabel(new LangString("کلوین", "fa"));
  unit.addLabel(new LangString("kelvin", "ms"));
  unit.addLabel(new LangString("कैल्विन", "hi"));
  unit.addLabel(new LangString("kelvin", "ro"));
  unit.addLabel(new LangString("开尔文", "zh"));
  unit.addLabel(new LangString("kelvin", "tr"));
  unit.addLabel(new LangString("kelvin", "sl"));
  unit.addLabel(new LangString("kelwin", "pl"));
  unit.addLabel(new LangString("Kelvin", "de"));
  unit.addLabel(new LangString("келвин", "bg"));
  unit.addLabel(new LangString("kelvin", "la"));
  unit.addLabel(new LangString("kelvin", "cs"));
  unit.addLabel(new LangString("kelvin", "hu"));
  unit.addLabel(new LangString("kelvin", "fr"));
  unit.addLabel(new LangString("קלווין", "he"));
  unit.addLabel(new LangString("kelvin", "es"));
  unit.addLabel(new LangString("kelvin", "en"));
  unit.addLabel(new LangString("кельвин", "ru"));
  unit.addLabel(new LangString("κέλβιν", "el"));
  unit.addLabel(new LangString("kelvin", "it"));
  unit.addLabel(new LangString("ケルビン", "ja"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  config.units.set("http://qudt.org/vocab/unit/K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("86400.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/K-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin metres", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/K-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin metres per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin Meter per Watt", "en-US"));
  unit.addLabel(new LangString("Kelvin Metre per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set("http://qudt.org/vocab/unit/K-M-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·m²/(kg·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(
    new LangString("Kelvin square metres per kilogram second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PA-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·Pa/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin Pascals per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-PA-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kelvin per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin per metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("0.01666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kelvin per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H1T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/T",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin per Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerMagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("kelvin per watt", "en"));
  unit.addLabel(new LangString("kelvin al watt", "it"));
  unit.addLabel(new LangString("Kelvin je Watt", "de"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/K-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kelvin second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimeTemperature");
  config.units.set("http://qudt.org/vocab/unit/K-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/K2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H2T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Square Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/K2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("katal", "it"));
  unit.addLabel(new LangString("katal", "en"));
  unit.addLabel(new LangString("开特", "zh"));
  unit.addLabel(new LangString("katal", "es"));
  unit.addLabel(new LangString("katal", "hu"));
  unit.addLabel(new LangString("katal", "fr"));
  unit.addLabel(new LangString("katal", "cs"));
  unit.addLabel(new LangString("カタール", "ja"));
  unit.addLabel(new LangString("كاتال", "ar"));
  unit.addLabel(new LangString("катал", "ru"));
  unit.addLabel(new LangString("Katal", "de"));
  unit.addLabel(new LangString("катал", "bg"));
  unit.addLabel(new LangString("katal", "sl"));
  unit.addLabel(new LangString("κατάλ", "el"));
  unit.addLabel(new LangString("katal", "tr"));
  unit.addLabel(new LangString("קטל", "he"));
  unit.addLabel(new LangString("katal", "ro"));
  unit.addLabel(new LangString("katal", "pl"));
  unit.addLabel(new LangString("katal", "ms"));
  unit.addLabel(new LangString("کاتال", "fa"));
  unit.addLabel(new LangString("कटल", "hi"));
  unit.addLabel(new LangString("katal", "pt"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Katal per Liter", "en-US"));
  unit.addLabel(new LangString("Katal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("katal per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KAT-PER-MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kat/µL",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Katal per Microlitre", "en"));
  unit.addLabel(new LangString("Katal per Microliter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/KAT-PER-MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KIP_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4448.222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kip",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Kip", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/KIP_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KIP_F-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894757.89"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kip/in²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kip per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KIP_F-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.5144444444444445"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kn",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Knot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/KN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KN-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.5144444444444445"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kn/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Knot per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/KN-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Kayser", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/KY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("709.782712893384"),
    undefined,
    "http://qudt.org/vocab/prefix/Kibi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Kibit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kibibit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/KibiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("709.78271289338399684324569237317632"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kibit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kibibit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KibiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("709.78271289338399684324569237317632"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kibit/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kibibit per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/KibiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("709.78271289338399684324569237317632"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Kibit/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kibibit per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KibiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KibiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5678.2617031470719747459655389854"),
    undefined,
    "http://qudt.org/vocab/prefix/Kibi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "KiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("KibiByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/KibiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Kilo-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("28.316846592"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "k(ft³)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Thousand Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/Kilo-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "kA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("kiloampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/KiloA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Kiloampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/KiloA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kiloampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Kiloampere per Metre", "en"));
  unit.addLabel(new LangString("Kiloampere per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloA-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kA/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Kiloampere per Square Metre", "en"));
  unit.addLabel(new LangString("Kiloampere per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloA-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "kbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Kilobar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBAUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BAUD",
    undefined,
    "kBd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilobaud", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DigitRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBAUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilobaud", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DigitRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693.1471805599452"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "kbit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilobit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/KiloBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693.14718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kbps",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilobit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "kBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilobecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/KiloBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBq/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilobecquerel per kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055055.85262"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BTU_IT",
    undefined,
    "kBtu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("Kilo British Thermal Unit (International Definition)", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("11356526.7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBtu{IT}/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("kBTU per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("293.07107"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBtu{IT}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "Kilo British Thermal Unit (International Definition) per Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1054350.2645"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BTU_TH",
    undefined,
    "kBtu{th}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "Kilo British Thermal Unit (Thermochemical Definition)",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("292.9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kBtu{th}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("Kilo British Thermal Unit (thermochemical) per Hour", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545.1774444795624753378569716654"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "kB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilo Byte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloBYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5545.1774444795624753378569716654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kB/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilobyte per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/KiloBYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "kC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("KiloCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/KiloC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilocoulomb per Square Meter", "en-US"));
  unit.addLabel(new LangString("Kilocoulomb per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilocoulomb per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Kilocoulomb per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "kcal",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloCAL_TH");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("418400.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(cm·s·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Kilocalorie per Centimeter Second Degree Celsius", "en-US")
  );
  unit.addLabel(
    new LangString("Kilocalorie per Centimetre Second Degree Celsius", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("41840000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Kilocalorie per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("697333.3333333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(cm²·min)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimetre Minute", "en")
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimeter Minute", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("41840000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(cm²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimetre Second", "en")
  );
  unit.addLabel(
    new LangString("Kilocalorie per Square Centimeter Second", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("4184000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4184000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(g·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Calorie per Gram Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("69.7333333"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/mol",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/(mol·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie per Mole Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4186.8"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CAL_IT",
    undefined,
    "kcal{IT}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie (international Table)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("4186800.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcalIT/(g·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "kilocalorie (international table) per gram kelvin",
      undefined
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.163"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal{IT}/(h·m·°C)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Kilocalorie (international Table) per Hour Meter Degree Celsius",
      "en-US"
    )
  );
  unit.addLabel(
    new LangString(
      "Kilocalorie (international Table) per Hour Metre Degree Celsius",
      "en"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_Mean",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4190.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "kcal{mean}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie (mean)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_Mean", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4184.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CAL_TH",
    undefined,
    "kcal",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie (thermochemical)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloCAL");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.162230555555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal{th}/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilocalorie (thermochemical) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("69.73383333333334"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal{th}/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Kilocalorie (thermochemical) per Minute", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("4184.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kcal{th}/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString("Kilocalorie (thermochemical) per Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "kCd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilocandela", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloCD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCi",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/Ci",
    undefined,
    "kCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Kilocurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DecayConstant");
  config.units.set("http://qudt.org/vocab/unit/KiloCi", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCount",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("KiloCount", undefined));
  config.units.set("http://qudt.org/vocab/unit/KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloCubicFT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("28.316846592"),
    undefined,
    undefined,
    undefined,
    undefined,
    "k(ft³)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Thousand Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/KiloCubicFT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloEV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-16"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/EV",
    undefined,
    "keV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilo Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloEV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloEV-PER-MicroM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "keV/µm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilo Electron Volt per Micrometre", "en"));
  unit.addLabel(new LangString("Kilo Electron Volt per Micrometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloEV-PER-MicroM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "kF",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilofarad", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/KiloFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGAUSS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/GAUSS",
    undefined,
    "kGs",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilogauss", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGAUSS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("kilogram", "sl"));
  unit.addLabel(new LangString("kilogram", "pl"));
  unit.addLabel(new LangString("килограм", "bg"));
  unit.addLabel(new LangString("kilogram", "tr"));
  unit.addLabel(new LangString("kilogram", "ro"));
  unit.addLabel(new LangString("公斤", "zh"));
  unit.addLabel(new LangString("килограмм", "ru"));
  unit.addLabel(new LangString("kilogram", "ms"));
  unit.addLabel(new LangString("किलोग्राम", "hi"));
  unit.addLabel(new LangString("کیلوگرم", "fa"));
  unit.addLabel(new LangString("Kilogramm", "de"));
  unit.addLabel(new LangString("kilogramm*", "hu"));
  unit.addLabel(new LangString("קילוגרם", "he"));
  unit.addLabel(new LangString("kilogram", "en"));
  unit.addLabel(new LangString("kilogramo", "es"));
  unit.addLabel(new LangString("chiliogramma", "la"));
  unit.addLabel(new LangString("kilogramme", "fr"));
  unit.addLabel(new LangString("キログラム", "ja"));
  unit.addLabel(new LangString("kilogram", "cs"));
  unit.addLabel(new LangString("χιλιόγραμμο", "el"));
  unit.addLabel(new LangString("كيلوغرام", "ar"));
  unit.addLabel(new LangString("quilograma", "pt"));
  unit.addLabel(new LangString("chilogrammo", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CO2Equivalent");
  config.units.set("http://qudt.org/vocab/unit/KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·(cm/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram centimetre per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram Square Centimetre", "en"));
  unit.addLabel(new LangString("Kilogram Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilogram Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassTemperature");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unbalance");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("kilogram meter per saat", "ms"));
  unit.addLabel(new LangString("kilogram metre per second", "en"));
  unit.addLabel(new LangString("kilogram meter na sekundo", "sl"));
  unit.addLabel(new LangString("千克米每秒", "zh"));
  unit.addLabel(new LangString("Kilogram Meter per Second", "en-US"));
  unit.addLabel(new LangString("chilogrammo per metro al secondo", "it"));
  unit.addLabel(new LangString("Kilogramm mal Meter je Sekunde", "de"));
  unit.addLabel(new LangString("کیلوگرم متر بر ثانیه", "fa"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m/s²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram metre per second squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram Square Meter", "en-US"));
  unit.addLabel(new LangString("キログラム平方メートル", "ja"));
  unit.addLabel(new LangString("килограмм-квадратный метр", "ru"));
  unit.addLabel(new LangString("kilogram meter persegi", "ms"));
  unit.addLabel(new LangString("किलोग्राम वर्ग मीटर", "hi"));
  unit.addLabel(new LangString("kilogramme-mètre carré", "fr"));
  unit.addLabel(new LangString("kilogramo metro cuadrado", "es"));
  unit.addLabel(new LangString("chilogrammo metro quadrato", "it"));
  unit.addLabel(new LangString("kilogram square metre", "en"));
  unit.addLabel(new LangString("kilogram metrekare", "tr"));
  unit.addLabel(new LangString("كيلوغرام متر مربع", "ar"));
  unit.addLabel(new LangString("kilogram-metru pătrat", "ro"));
  unit.addLabel(new LangString("kilogram čtvereční metr", "cs"));
  unit.addLabel(new LangString("نیوتون متر مربع", "fa"));
  unit.addLabel(new LangString("千克平方米", "zh"));
  unit.addLabel(new LangString("quilograma-metro quadrado", "pt"));
  unit.addLabel(new LangString("Kilogramm mal Quadratmeter", "de"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·m²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram Square Meter per Second", "en-US"));
  unit.addLabel(new LangString("Kilogram Square Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram Square Millimetre", "en"));
  unit.addLabel(new LangString("Kilogram Square Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Square Centimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Square Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(cm³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per cubic centimetre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(cm³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("kilogram per cubic centimetre kelvin", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00001157407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/dm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Cubic Decimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Cubic Decimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(dm³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per cubic decimetre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(dm³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("kilogram per cubic decimetre kelvin", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("10.763910416709722"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/ft²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-GigaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/GJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Gigajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-GigaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.000277777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Joule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/km",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per kilometre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMass");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/km²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilograms per square kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/kmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilogram per Kilomol", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarMass");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Liter", "en-US"));
  unit.addLabel(new LangString("Kilogram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(l·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per litre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-L-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(l·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per litre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-L-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Meter", "en-US"));
  unit.addLabel(new LangString("Kilogram per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·d)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per metre day", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.000277777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilograms per metre hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per metre minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilograms per metre second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m·s²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilograms per metre square second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-PER-M2");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Square Metre", "en"));
  unit.addLabel(new LangString("Kilogram per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·Pa·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Kilograms per square metre Pascal second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPermeance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/S-PER-M");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilograms per square metre second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·s²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Kilogram per Square Meter Square Second", "en-US")
  );
  unit.addLabel(
    new LangString("Kilogram per Square Metre Square Second", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureLossPerLength"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("kilogram per meter kubik", "ms"));
  unit.addLabel(new LangString("килограмм на кубический метр", "ru"));
  unit.addLabel(new LangString("千克每立方米", "zh"));
  unit.addLabel(new LangString("quilograma por metro cúbico", "pt"));
  unit.addLabel(new LangString("किलोग्राम प्रति घन मीटर", "hi"));
  unit.addLabel(new LangString("kilogramo por metro cúbico", "es"));
  unit.addLabel(new LangString("kilogram pe metru cub", "ro"));
  unit.addLabel(new LangString("كيلوغرام لكل متر مكعب", "ar"));
  unit.addLabel(new LangString("kilogram bölü metre küp", "tr"));
  unit.addLabel(new LangString("kilogram per cubic meter", "en-US"));
  unit.addLabel(new LangString("kilogramme par mètre cube", "fr"));
  unit.addLabel(new LangString("χιλιόγραμμο ανά κυβικό μέτρο", "el"));
  unit.addLabel(new LangString("キログラム毎立方メートル", "ja"));
  unit.addLabel(new LangString("kilogram per cubic metre", "en"));
  unit.addLabel(new LangString("chilogrammo al metro cubo", "it"));
  unit.addLabel(new LangString("kilogram na metr krychlový", "cs"));
  unit.addLabel(new LangString("کیلوگرم بر متر مکعب", "fa"));
  unit.addLabel(new LangString("kilogram na kubični meter", "sl"));
  unit.addLabel(new LangString("kilogram na metr sześcienny", "pl"));
  unit.addLabel(new LangString("Kilogramm je Kubikmeter", "de"));
  unit.addLabel(new LangString("килограм на кубичен метър", "bg"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWater"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWaterVapour"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per cubic metre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·Pa)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per cubic metre pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m³·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilograms per cubic metre second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.01666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilogram per Mol", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarMass");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("9.47817E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/MBtu{IT}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Kilogram per Mega BTU", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Millimetre", "en"));
  unit.addLabel(new LangString("Kilogram per Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(Pa·s·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("килограмм на паскаль-секунда-метр", "ru"));
  unit.addLabel(new LangString("chilogrammo al pascal secondo metro", "it"));
  unit.addLabel(new LangString("kilogramme par pascal-seconde-mètre", "fr"));
  unit.addLabel(new LangString("quilograma por pascal segundo metro", "pt"));
  unit.addLabel(new LangString("kilogram na paskalosekundaometr", "pl"));
  unit.addLabel(new LangString("kilogram per pascal saat meter", "ms"));
  unit.addLabel(new LangString("Kilogramm je Pascal Sekunde Meter", "de"));
  unit.addLabel(new LangString("kilogram na pascal sekunda meter", "sl"));
  unit.addLabel(new LangString("kilogram pe pascal-secundă-metru", "ro"));
  unit.addLabel(new LangString("kilogram na pascal sekunda metr", "cs"));
  unit.addLabel(new LangString("kilogramo por pascal segundo metro", "es"));
  unit.addLabel(new LangString("kilogram per pascal saniye metre", "tr"));
  unit.addLabel(new LangString("kilogram per pascal second metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/WaterVaporDiffusionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VaporPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·m²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Second Square Metre", "en"));
  unit.addLabel(new LangString("Kilogram per Second Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s·Pa)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogram per second pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(s³·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("kilogram na kubični sekunda kelvin", "sl"));
  unit.addLabel(new LangString("kilogram per saniyeküp kelvin", "tr"));
  unit.addLabel(new LangString("quilograma por segundo cúbico kelvin", "pt"));
  unit.addLabel(new LangString("kilogram per saat kubik kelvin", "ms"));
  unit.addLabel(new LangString("kilogram na  krychlovýsekunda kelvin", "cs"));
  unit.addLabel(new LangString("chilogrammo al secondo cubo per kelvin", "it"));
  unit.addLabel(new LangString("kilogramo porsegundo cúbico kelvin", "es"));
  unit.addLabel(
    new LangString("килограмм на кубический секунда-кельвин", "ru")
  );
  unit.addLabel(new LangString("kilogram per cubic second kelvin", "en"));
  unit.addLabel(new LangString("kilogramme par seconde cube-kelvin", "fr"));
  unit.addLabel(new LangString("Kilogramm je Kubiksekunde Kelvin", "de"));
  unit.addLabel(new LangString("kilogram na sekunda sześciennyokelwin", "pl"));
  unit.addLabel(new LangString("kilogram pe secundă cub-kelvin", "ro"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("3.168808781E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram per Year", "en"));
  unit.addLabel(new LangString("Kilogram per Jaar", "nl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg·s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilogram Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M2H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Kilograms per square second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloGM2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/GM_F",
    undefined,
    "kgf",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilogram Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloPOND");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilogram_force Metre", "en"));
  unit.addLabel(new LangString("Kilogram_force Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf·m/cm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("Kilogram Force Metre per Square Centimetre", "en")
  );
  unit.addLabel(
    new LangString("Kilogram Force Meter per Square Centimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf·m/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilogram_force Meter per Second", "en-US"));
  unit.addLabel(new LangString("Kilogram_force Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("98066.5"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf/cm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("Kilogram Force per Square Centimeter", "en-US")
  );
  unit.addLabel(new LangString("Kilogram Force per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilogram Force per Square Meter", "en-US"));
  unit.addLabel(new LangString("Kilogram Force per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("9806650.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kgf/mm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilogram Force per Square Millimetre", "en"));
  unit.addLabel(
    new LangString("Kilogram Force per Square Millimeter", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "kGy",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilogray", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/KiloGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "kH",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilohenry", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/KiloH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "kHz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Kilohertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/KiloHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloHZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kHz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilohertz Metre", "en"));
  unit.addLabel(new LangString("Kilohertz Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ConductionSpeed");
  config.units.set("http://qudt.org/vocab/unit/KiloHZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloINDIV",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("KiloINDIV", undefined));
  config.units.set("http://qudt.org/vocab/unit/KiloINDIV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "kJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilojoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/d",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilojoule per day", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilojoule per hour", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilojoule per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilojoule per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/(kg·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilojoule per Kilogram Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEntropy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/kV",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilojoule per kilovolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-KiloV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilojoule per minute", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilojoule per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilojoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "kL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilolitre", "en"));
  unit.addLabel(new LangString("Kilolitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/KiloL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kL/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilolitre per Hour", "en"));
  unit.addLabel(new LangString("Kilolitre per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("KiloLB", undefined));
  config.units.set("http://qudt.org/vocab/unit/KiloLB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "klb/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilopound per hour", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloLB-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4448.222"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/LB_F",
    undefined,
    "klbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("KiloPound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1355.81800916358032544"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf·ft/A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pound Force Foot per Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("2989.067"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf·ft/lbm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force Foot per Pound", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("14593.904199475066"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894757.89"),
    undefined,
    undefined,
    undefined,
    undefined,
    "klbf/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Kilopound Force per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloLB_F-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloLM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/LM",
    undefined,
    "klm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilolumen", "de"));
  unit.addLabel(new LangString("kilolumen", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousFlux");
  config.units.set("http://qudt.org/vocab/unit/KiloLM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilometre", "en"));
  unit.addLabel(new LangString("Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0115740740740741"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilometres per day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.2777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilometer per Hour", "en-US"));
  unit.addLabel(new LangString("Kilometre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilometre per Second", "en"));
  unit.addLabel(new LangString("Kilometer per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilometre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km/s²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilometre per second squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("square kilometre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Kilometers per Square Second", "en-US"));
  unit.addLabel(new LangString("Square kilometres per square second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificModulus");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/KiloM2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloM3-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-2D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "km³/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Kilometer per Square Second", "en-US"));
  unit.addLabel(new LangString("Cubic Kilometre per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloM3-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMIL_Circ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("5.067075E-7"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/MIL_Circ",
    undefined,
    "kcmil",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("thousands of circular mil", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/KiloMIL_Circ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "kmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilomole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.277777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilomole per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilomole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilomole per Cubic Metre", "en"));
  unit.addLabel(new LangString("Kilomole per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/(m³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilomole per cubic metre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilomole per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilomole per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloMOL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kmol/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilomole per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloMOL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "kN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilonewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/KiloN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilonewton Meter", "en-US"));
  unit.addLabel(new LangString("Kilonewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("57295.77957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m/°",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilonewton Metre per Degree", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("57295.77957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m/(°·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("kilonewton metre per degree metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "kN·m/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilonewton Metre per metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilonewton metre per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilo Newton Square Metre", "en"));
  unit.addLabel(new LangString("Kilo Newton Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingMoment");
  config.units.set("http://qudt.org/vocab/unit/KiloN-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilo Newton per metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilo Newton per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloN-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kN/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilo Newton per cubic metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificWeight");
  config.units.set("http://qudt.org/vocab/unit/KiloN-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kiloohm metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kiloohm per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kiloohm per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kΩ/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kiloohm per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/P",
    undefined,
    "kP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Kilopond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM_F");
  config.units.set("http://qudt.org/vocab/unit/KiloP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "kPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilopascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa·m²/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilopascal Square Metre per Gram", "en"));
  unit.addLabel(new LangString("Kilopascal Square Meter per Gram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-M2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Kilopascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilopascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilopascal per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kPa/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilopascal per Millimetre", "en"));
  unit.addLabel(new LangString("Kilopascal per Millimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloPA-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPA_A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "KPaA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Kilopascal Absolute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/KiloPA_A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloPOND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/POND",
    undefined,
    "kp",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilopond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM_F");
  config.units.set("http://qudt.org/vocab/unit/KiloPOND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("0.258"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/R",
    undefined,
    "kR",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kiloroentgen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "kS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Kilosiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/KiloS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Kilosiemens per Meter", "en-US"));
  unit.addLabel(new LangString("Kilosiemens per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/KiloS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ks",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("kilosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/KiloSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "kT",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilotesla", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  config.units.set("http://qudt.org/vocab/unit/KiloT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloTONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    "kt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("KiloTonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloTON_Metric");
  config.units.set("http://qudt.org/vocab/unit/KiloTONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloTONNE-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.03168808781"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kt/year",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("KiloTon per Jaar", "nl"));
  unit.addLabel(new LangString("KiloTonne per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/KiloTONNE-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloTON_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/TON_Metric",
    undefined,
    "kt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metric KiloTON", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloTONNE");
  config.units.set("http://qudt.org/vocab/unit/KiloTON_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "kV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Kilovolt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Kilovolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Kilovolt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilovolt ampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloV-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilovolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV·A{Reactive}·h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Kilovolt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A_Reactive-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "kvar/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("kilovolt ampere reactive per kelvin", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/KiloV-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Kilovolt per Metre", "en"));
  unit.addLabel(new LangString("Kilovolt per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "kW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Kilowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/KiloW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilowatthour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/KiloW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("3600000.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "kW·h/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kilowatt hour per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/KiloW-HR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW/(m·°C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilowatt per metre degree Celsius", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-PER-M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW/(m·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilowatt per metre kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloW-PER-M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kW/(m²·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("kilowatt per square metre kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloW-PER-M2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloWB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "kWb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("KiloWeber", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/KiloWB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloWB-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kWb/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Kiloweber per Meter", "en-US"));
  unit.addLabel(new LangString("Kiloweber per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/KiloWB-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/KiloYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Kilo",
    "http://qudt.org/vocab/unit/YR",
    undefined,
    "1000 a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("KiloYear", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/KiloYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Litre", "en"));
  unit.addLabel(new LangString("Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Liter per Day", "en-US"));
  unit.addLabel(new LangString("Litre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Liter per Hour", "en-US"));
  unit.addLabel(new LangString("Litre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Liter per Kelvin", "en-US"));
  unit.addLabel(new LangString("Litre per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Litre per Kilogram", "en"));
  unit.addLabel(new LangString("Liter per Kilogram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Liter per Liter", "en-US"));
  unit.addLabel(new LangString("Litre per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/L-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Liter per Minute", "en-US"));
  unit.addLabel(new LangString("Litre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Liter per Mole", "en-US"));
  unit.addLabel(new LangString("Litre per Mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MOL-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(mol·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per mol second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-MOL-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-MicroMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/µmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Litres per micromole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-MicroMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Litre per Second", "en"));
  unit.addLabel(new LangString("Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "l/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("litre per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/L-PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L/(s·m²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Litre per Second Square Metre", "en"));
  unit.addLabel(new LangString("Liter per Second Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VentilationRatePerFloorArea"
  );
  config.units.set("http://qudt.org/vocab/unit/L-PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("0.31830988618"),
    undefined,
    undefined,
    undefined,
    undefined,
    "L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Lambert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LANGLEY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Ly",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("langley", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  config.units.set("http://qudt.org/vocab/unit/LANGLEY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LA_FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("3.4262591"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ft-L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Foot Lambert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LA_FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "lbm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB_M");
  config.units.set("http://qudt.org/vocab/unit/LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    new Decimal("0.251995761111111131270772"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Degree Fahrenheit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassTemperature");
  config.units.set("http://qudt.org/vocab/unit/LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-DEG_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    new Decimal("0.251995761111111131270772"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·°R",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Degree Rankine", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassTemperature");
  config.units.set("http://qudt.org/vocab/unit/LB-DEG_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.138254954376"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb·(ft/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) foot per second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/LB-FT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.04214011"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Mass (avoirdupois) Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/LB-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "2.083872775779299082282838578347267334173116064268442332389984612088964920341275968"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(lbf·s/ft²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound square foot per gallon(UK) pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "2.502626854833744493086617821084779253127869007556187848462093242975047573738776"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(lbf·s/ft²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound square foot per gallon (US) pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "578.1068034665949779030087166705840311562207088517638054327176207240543226740952704"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(lbf·s/ft²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound square foot per cubic inch pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "12684849.650195333239499933867654124396741790589536829728291114929411437703588"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(gal (UK)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic foot gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "15233869.2424423705674072721585852518715359857332296007155378683289047293035"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(gal (US)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic foot gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "3519023795.0041876010710798686331933264909830700172939821848834749863198205064"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(in³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic foot cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "75424.89272556986456342335109381841563144898750316539709471380407341560228312"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(yd³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic foot cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("2036472.103590386343212430479533097669052636"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(ft³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound hour per power of foot with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-FT6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "12684849.650195333239499933867654124396741790589536829728291114929411437703588"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(ft³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per gallon (UK) cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "21919420195.537535837855885723306325290905285174268871988102623940310297574504"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(in³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per gallon (UK) cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "469809.2463035308607222197728760784685045453775881112182401022569369923571832"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(yd³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per gallon (UK) cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("79011841.29376367695695378272856609314407416"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·h/gal{UK}²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound hour per square gallon (UK)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "15233869.2424423705674072721585852518715359857332296007155378683289047293035"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(ft³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per gallon (US) cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "26324126050.940416340479766290035313232433541445579466838922411497037639403"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(in³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per gallon (US) cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "564217.3793497174284224915614290831470197693437031035772642345900475911449"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(yd³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per gallon (US) cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("113957255.63177669411463102290058577675823928"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(gal (US)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound hour per square gallon (US)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "3519023795.0041876010710798686331933264909830700172939821848834749863198205064"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(ft³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic inch cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "21919420195.537535837855885723306325290905285174268871988102623940310297574504"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(gal (UK)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic inch gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "26324126050.940416340479766290035313232433541445579466838922411497037639403"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(gal (US)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic inch gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "130334214.62978472596559555069011821230105450971546345289972840848652177795696"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(yd³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound hour per cubic inch cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("6080873117767.236174650826012998158007635932"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(in³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound hour per power of inch with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-HR-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.011521246198"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Mass (avoirdupois) Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/LB-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("0.011521246198"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb·(in/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) inch per second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impulse");
  config.units.set("http://qudt.org/vocab/unit/LB-IN-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    new Decimal("0.0002926397"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm·in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Mass (avoirdupois) Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RotationalMass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfInertia");
  config.units.set("http://qudt.org/vocab/unit/LB-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "0.0023232815854335253420099051435128282339616138505378234106449231456072737790266052"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(lbf·s/in²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound square inch per cubic foot pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "0.014471338720689576960297490127411578709535528224086405086041559806173367502369972"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(lbf·s/in²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound square inch per gallon(UK) pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "0.0173793531585676700908792904241998559244990903302513045032089808539933859287415"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(lbf·s/in²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound square inch per gallon (US) pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "4.0146305796291317909931160879901668830293104781372486488383168105837105741256616"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(lbf·s/in²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound square inch per cubic inch pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "211414.1608365888873249988977942354066123631764922804954715185821568572950598"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb·min/(ft³·gal (UK))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic foot gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "253897.820707372842790121202643087531192266428887160011925631138815078821725"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(gal (US)/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic foot gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "58650396.58340312668451799781055322210818305116695489970308139124977199700844"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(in³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic foot cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "1257.081545426164409390389184896973593857483125052756618245230067890260038052"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(yd³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic foot cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("33941.2017265064390535405079922182944842106"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(ft³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound minute per power of foot with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-FT6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "211414.1608365888873249988977942354066123631764922804954715185821568572950598"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(ft³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per gallon (UK) cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "365323669.9256255972975980953884387548484214195711478664683770656718382929084"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(in³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per gallon (UK) cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "7830.15410505884767870366288126797447507575629313518697066837094894987261972"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(yd³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per gallon (UK) cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1316864.021562727949282563045476101552401236"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (UK))/(gal (UK)/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per square gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "253897.820707372842790121202643087531192266428887160011925631138815078821725"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(ft³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per gallon (US) cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "438735434.18234027234132943816725522054055902409299111398204019161729399005"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(in³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per gallon (US) cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "9403.622989161957140374859357151385783662822395051726287737243167459852415"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(yd³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per gallon (US) cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1899287.593862944901910517048343096279303988"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(gal (US)/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per square gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "58650396.58340312668451799781055322210818305116695489970308139124977199700844"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(ft³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic inch cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "365323669.9256255972975980953884387548484214195711478664683770656718382929084"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb·min/(in³·gal (UK))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic inch gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "438735434.18234027234132943816725522054055902409299111398204019161729399005"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(gal (US)/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic inch gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "2172236.910496412099426592511501970205017575161924390881662140141442029632616"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(yd³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound minute per cubic inch cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("101347885296.1206029108471002166359667939322"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(in³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound minute per power of inch with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-MIN-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pound Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-MOL-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol·°F",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pound Mole Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstanceTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-MOL-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.000005249912"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Pound (avoirdupois) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.8164663"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/°F",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per degree Fahrenheit", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("1.4881639435695537"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.00001722411971724020608535044230582288"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(ft·d)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound (avoirdupois) per foot day", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.0004133788732137649"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Foot Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "0.33455254830242764924942634066584721521501158056064094672437823938052751208"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(lbf·s/ft²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound per foot pound-force second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.02480273239282589676290463692038495"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(ft·min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per foot minute", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.4881639435695537"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/(ft·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Foot Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("4.882428"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("Pound Mass (avoirdupois) per Square Foot", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("16.018463373960138"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("28.83323"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(ft³·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound (avoirdupois) per cubic foot degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-FT3-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.002323281585433525342009905143512828"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(ft³·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per cubic foot psi", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-FT3-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-GAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("99.7763727"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/gal",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-GAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("99.7763727"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/gal{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound (avoirdupois) per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB-PER-GAL");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("119.8264273168966285439132558055142"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Pound (avoirdupois) per Gallon (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00012599788055555556"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Pound per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal(
      "0.000226796184999999981856305200000001530118261466666665215171082666666787624632"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(h·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per hour degree Fahrenheit", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-HR-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal(
      "1.82744467346499108120663380259234724368282387719928649653070420738776779898E-8"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(h·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound (avoirdupois) per hour psi", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-PER-HR-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("17.857967322834646"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("703.06957963916"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound (avoirdupois) per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("27679.904710203125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("49823.84"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(in³·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound (avoirdupois) per cubic inch degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-IN3-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("4.014630579629131790993116087990167"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(in³·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per cubic inch psi", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-IN3-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/lb",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound per pound", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Pound per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Pound per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.007559872833333333"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Pound per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal(
      "0.0136077710999999989113783120000000934400282199999997822756624000000181436948"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(min·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound (avoirdupois) per minute degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-MIN-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal(
      "0.00000109646680407899464872398028155540847778571081579892974479605631108165169847"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(min·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per minute psi", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-PER-MIN-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.000065788008244739678923438816893324495509541"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound (avoirdupois) per psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.4535924"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Pound (avoirdupois) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.8164663"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(s·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound (avoirdupois) per second degree Fahrenheit",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-SEC-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.000065788008244739678923438816893324495509541"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(s·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per second psi", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency"
  );
  config.units.set("http://qudt.org/vocab/unit/LB-PER-SEC-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-YD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.496054647856517935258092738407699"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/yd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound (avoirdupois) per yard", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMass");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-YD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-YD2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.5424919595981167270976517261676497"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/yd²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound (avoirdupois) per square yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-YD2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.5932764212577829"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbm/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/LB-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "3523.56934727648145541664829657059011020605294153800825785864303594762158433"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(gal (UK)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic foot gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "4231.63034512288071316868671071812551987110714811933353209385231358464702875"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(gal (US)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic foot gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "977506.609723385444741966630175887035136384186115914995051356520829533283474"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(in³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic foot cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "20.9513590904360734898398197482828932309580520842126103040871677981710006342"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(yd³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic foot cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("565.68669544177398422567513320363824140351"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(ft³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound second per power of foot with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-FT6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "3523.56934727648145541664829657059011020605294153800825785864303594762158433"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/(gal (UK))/(ft³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per gallon (UK) cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "6088727.83209375995495996825647397924747369032618579777447295109453063821514"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/(gal (UK))/(in³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per gallon (UK) cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "130.502568417647461311727714687799574584595938218919782844472849149164543662"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/(gal (UK))/(yd³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per gallon (UK) cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("21947.7336927121324880427174246016925400206"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/(gal (UK))/(gal (UK)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per square gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "4231.63034512288071316868671071812551987110714811933353209385231358464702875"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(ft³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per gallon (US) cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "7312257.2363723378723554906361209203423426504015498518997006698602882331675"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb/(gal (US))/(in³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per gallon (US) cubic inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "156.72704981936595233958098928585642972771370658419543812895405279099754025"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/(gal (US))/(yd³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per gallon (US) cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("31654.7932310490816985086174723849379883998"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/(gal (US))/(gal (US)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per square gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "977506.609723385444741966630175887035136384186115914995051356520829533283474"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(ft³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic inch cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "6088727.83209375995495996825647397924747369032618579777447295109453063821514"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(gal (UK)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic inch gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "7312257.2363723378723554906361209203423426504015498518997006698602882331675"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(gal (US)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic inch gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "36203.9485082735349904432085250328367502929193654065146943690023573671605436"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(yd³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("pound second per cubic inch cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1689131421.60201004851411833694393277989887"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/in³)/(in³/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "pound second per power of inch with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/LB-SEC-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4.448222"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.35581807"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-FT-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("53.3786617780937136"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·ft/in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound-force foot per inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearTorque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-FT-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.112984839"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-IN-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4.4482218148411428"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·in/in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound-force inch per inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearTorque");
  config.units.set("http://qudt.org/vocab/unit/LB_F-IN-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("14.5939042"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("47.8802631"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("175.12685"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force per Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894.75789"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PSI");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("12410.56"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/(in²·°F)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("Pound Force per Square Inch Degree Fahrenheit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("6894.75789"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/(in²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force per Square Inch Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("9.80665085"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/lbm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force per Pound", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-PER-YD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("4.864634530666166666666666666666666"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf/yd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound-force per yard", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/LB_F-PER-YD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("47.8802631"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·s/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force Second per Square Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("6894.75789"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lbf·s/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pound Force Second per Square Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.45359237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "lbm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Pound Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB");
  config.units.set("http://qudt.org/vocab/unit/LB_M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LB_T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.3732417216"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "lbt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Pound Troy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/LB_T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Lumen", "de"));
  unit.addLabel(new LangString("lumen", "sl"));
  unit.addLabel(new LangString("流明", "zh"));
  unit.addLabel(new LangString("lümen", "tr"));
  unit.addLabel(new LangString("lumen", "la"));
  unit.addLabel(new LangString("لومن", "fa"));
  unit.addLabel(new LangString("λούμεν", "el"));
  unit.addLabel(new LangString("lumen", "cs"));
  unit.addLabel(new LangString("לומן", "he"));
  unit.addLabel(new LangString("ルーメン", "ja"));
  unit.addLabel(new LangString("lumen", "es"));
  unit.addLabel(new LangString("lumen", "hu"));
  unit.addLabel(new LangString("lumen", "fr"));
  unit.addLabel(new LangString("lumen", "it"));
  unit.addLabel(new LangString("лумен", "bg"));
  unit.addLabel(new LangString("lumen", "en"));
  unit.addLabel(new LangString("лумен", "ru"));
  unit.addLabel(new LangString("لومن", "ar"));
  unit.addLabel(new LangString("lumen", "ms"));
  unit.addLabel(new LangString("lumen", "pt"));
  unit.addLabel(new LangString("ल्यूमैन", "hi"));
  unit.addLabel(new LangString("lumen", "ro"));
  unit.addLabel(new LangString("lumen", "pl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousFlux");
  config.units.set("http://qudt.org/vocab/unit/LM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm·h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("lumen hour", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousEnergy");
  config.units.set("http://qudt.org/vocab/unit/LM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm/ft²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("lumen per square foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LM-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("lumen per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/LM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Lumen per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousEfficacy"
  );
  config.units.set("http://qudt.org/vocab/unit/LM-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lm·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("lumen second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LuminousEnergy");
  config.units.set("http://qudt.org/vocab/unit/LM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LUX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lx",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("luks", "sl"));
  unit.addLabel(new LangString("lüks", "tr"));
  unit.addLabel(new LangString("lux", "pt"));
  unit.addLabel(new LangString("luks", "pl"));
  unit.addLabel(new LangString("לוקס", "he"));
  unit.addLabel(new LangString("люкс", "ru"));
  unit.addLabel(new LangString("lux", "en"));
  unit.addLabel(new LangString("лукс", "bg"));
  unit.addLabel(new LangString("lux", "ms"));
  unit.addLabel(new LangString("lux", "el"));
  unit.addLabel(new LangString("lux", "fr"));
  unit.addLabel(new LangString("लक्स", "hi"));
  unit.addLabel(new LangString("lux", "hu"));
  unit.addLabel(new LangString("لوکس", "fa"));
  unit.addLabel(new LangString("lux", "it"));
  unit.addLabel(new LangString("لكس", "ar"));
  unit.addLabel(new LangString("lux", "cs"));
  unit.addLabel(new LangString("lux", "es"));
  unit.addLabel(new LangString("Lux", "de"));
  unit.addLabel(new LangString("勒克斯", "zh"));
  unit.addLabel(new LangString("ルクス", "ja"));
  unit.addLabel(new LangString("lux", "ro"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/LUX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LUX-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lx·h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Lux Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousExposure"
  );
  config.units.set("http://qudt.org/vocab/unit/LUX-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LUX-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lx·s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("lux second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousExposure"
  );
  config.units.set("http://qudt.org/vocab/unit/LUX-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("9460730472580800.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "ly",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Light Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/LY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/LunarMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("73460000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "M☾",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Lunar mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/LunarMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("méter", "hu"));
  unit.addLabel(new LangString("متر", "fa"));
  unit.addLabel(new LangString("метр", "ru"));
  unit.addLabel(new LangString("metr", "pl"));
  unit.addLabel(new LangString("метър", "bg"));
  unit.addLabel(new LangString("metro", "pt"));
  unit.addLabel(new LangString("मीटर", "hi"));
  unit.addLabel(new LangString("metro", "es"));
  unit.addLabel(new LangString("metrum", "la"));
  unit.addLabel(new LangString("מטר", "he"));
  unit.addLabel(new LangString("Meter", "de"));
  unit.addLabel(new LangString("米", "zh"));
  unit.addLabel(new LangString("metr", "cs"));
  unit.addLabel(new LangString("meter", "sl"));
  unit.addLabel(new LangString("metro", "it"));
  unit.addLabel(new LangString("Meter", "en-US"));
  unit.addLabel(new LangString("メートル", "ja"));
  unit.addLabel(new LangString("metre", "tr"));
  unit.addLabel(new LangString("متر", "ar"));
  unit.addLabel(new LangString("metru", "ro"));
  unit.addLabel(new LangString("meter", "ms"));
  unit.addLabel(new LangString("μέτρο", "el"));
  unit.addLabel(new LangString("metre", "en"));
  unit.addLabel(new LangString("mètre", "fr"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElevationRelativeToNAP"
  );
  config.units.set("http://qudt.org/vocab/unit/M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("meter kelvin", "ms"));
  unit.addLabel(new LangString("metro per kelvin", "it"));
  unit.addLabel(new LangString("متر کلوین", "fa"));
  unit.addLabel(new LangString("Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("米开尔文", "zh"));
  unit.addLabel(new LangString("Meter mal Kelvin", "de"));
  unit.addLabel(new LangString("metre kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-K-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·K/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Meter Kelvin per Watt", "en-US"));
  unit.addLabel(new LangString("Metre Kelvin per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M-K-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Meter Kilogram", "en-US"));
  unit.addLabel(new LangString("Metre Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/M-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PA-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·Pa/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre pascal per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/M-PA-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-DEG_C-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(°C·m)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per degree Celcius metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-DEG_C-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-FARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/F",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Meter per Farad", "en-US"));
  unit.addLabel(new LangString("Metre per Farad", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InversePermittivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-FARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000277777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metre per Hour", "en"));
  unit.addLabel(new LangString("Meter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Metre per Kelvin", "en"));
  unit.addLabel(new LangString("Meter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.0166666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metre per Minute", "en"));
  unit.addLabel(new LangString("Meter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/rad",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per radian", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("metro por segundo", "pt"));
  unit.addLabel(new LangString("metre per second", "en"));
  unit.addLabel(new LangString("metro por segundo", "es"));
  unit.addLabel(new LangString("метр в секунду", "ru"));
  unit.addLabel(new LangString("meter na sekundo", "sl"));
  unit.addLabel(new LangString("米每秒", "zh"));
  unit.addLabel(new LangString("متر بر ثانیه", "fa"));
  unit.addLabel(new LangString("metr na sekundę", "pl"));
  unit.addLabel(new LangString("метър в секунда", "bg"));
  unit.addLabel(new LangString("मीटर प्रति सैकिण्ड", "hi"));
  unit.addLabel(new LangString("metr za sekundu", "cs"));
  unit.addLabel(new LangString("メートル毎秒", "ja"));
  unit.addLabel(new LangString("metru pe secundă", "ro"));
  unit.addLabel(new LangString("mètre par seconde", "fr"));
  unit.addLabel(new LangString("Meter je Sekunde", "de"));
  unit.addLabel(new LangString("μέτρο ανά δευτερόλεπτο", "el"));
  unit.addLabel(new LangString("מטרים לשנייה", "he"));
  unit.addLabel(new LangString("متر في الثانية", "ar"));
  unit.addLabel(new LangString("Meter per Second", "en-US"));
  unit.addLabel(new LangString("metra per secundum", "la"));
  unit.addLabel(new LangString("metre bölü saniye", "tr"));
  unit.addLabel(new LangString("meter per saat", "ms"));
  unit.addLabel(new LangString("metro al secondo", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(s·Pa)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per second pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metre per Square Second", "en"));
  unit.addLabel(new LangString("Meter per Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-V-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/(V·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre per volt second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M-PER-V-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.16880878140289E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metre per year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/M-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m·s²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metre second squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M0dot",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("M0dot", undefined));
  config.units.set("http://qudt.org/vocab/unit/M0dot", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M0pt",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("M0pt", undefined));
  config.units.set("http://qudt.org/vocab/unit/M0pt", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("τετραγωνικό μέτρο", "el"));
  unit.addLabel(new LangString("négyzetméter", "hu"));
  unit.addLabel(new LangString("metr kwadratowy", "pl"));
  unit.addLabel(new LangString("квадратный метр", "ru"));
  unit.addLabel(new LangString("square metre", "en"));
  unit.addLabel(new LangString("metro quadrato", "it"));
  unit.addLabel(new LangString("metrum quadratum", "la"));
  unit.addLabel(new LangString("čtvereční metr", "cs"));
  unit.addLabel(new LangString("meter persegi", "ms"));
  unit.addLabel(new LangString("metro cuadrado", "es"));
  unit.addLabel(new LangString("वर्ग मीटर", "hi"));
  unit.addLabel(new LangString("metro quadrado", "pt"));
  unit.addLabel(new LangString("kvadratni meter", "sl"));
  unit.addLabel(new LangString("metru pătrat", "ro"));
  unit.addLabel(new LangString("Quadratmeter", "de"));
  unit.addLabel(new LangString("mètre carré", "fr"));
  unit.addLabel(new LangString("平方メートル", "ja"));
  unit.addLabel(new LangString("מטר רבוע", "he"));
  unit.addLabel(new LangString("متر مربع", "fa"));
  unit.addLabel(new LangString("metrekare", "tr"));
  unit.addLabel(new LangString("квадратен метър", "bg"));
  unit.addLabel(new LangString("متر مربع", "ar"));
  unit.addLabel(new LangString("平方米", "zh"));
  unit.addLabel(new LangString("Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("0.859845"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·h·°C/kcal{IT}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(
    new LangString(
      "Square Metre Hour Degree Celsius per Kilocalorie (international Table)",
      "en"
    )
  );
  unit.addLabel(
    new LangString(
      "Square Meter Hour Degree Celsius per Kilocalorie (international Table)",
      "en-US"
    )
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set(
    "http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metres Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Metres square Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metres cubic Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-HZ4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·Hz⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metres Hertz^4", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-HZ4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Square Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Square Metre Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTemperature");
  config.units.set("http://qudt.org/vocab/unit/M2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-K-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·K/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Square Meter Kelvin per Watt", "en-US"));
  unit.addLabel(new LangString("Square Metre Kelvin per Watt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-K-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metres per gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-GM_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/g{dry sediment}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Square metres per gram of dry sediment", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-GM_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("square meters per hectare", "en-US"));
  unit.addLabel(new LangString("square metres per hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaRatio");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(ha·a)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Square Metre per Hectare Year", "en"));
  unit.addLabel(new LangString("Square Meter per Hectare Year", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/Hz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metres per Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HZ-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("57.2957795130823"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(Hz·°)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Square metres per Hertz degree", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HZ-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-HZ2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/Hz²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metres per square Hertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-HZ2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/J",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Metre per Joule", "en"));
  unit.addLabel(new LangString("Square Meter per Joule", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Square Meter per Kelvin", "en-US"));
  unit.addLabel(new LangString("Square Metre per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Meter per Kilogram", "en-US"));
  unit.addLabel(new LangString("Square Metre per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassEnergyTransferCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-KiloW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/kW",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("square metre per Kilowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerPower");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-KiloW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/m",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("meter persegi per meter", "ms"));
  unit.addLabel(new LangString("kvadratni meter na meter", "sl"));
  unit.addLabel(new LangString("Quadratmeter je Meter", "de"));
  unit.addLabel(new LangString("metro quadrato al metro", "it"));
  unit.addLabel(new LangString("čtvereční metr na metr", "cs"));
  unit.addLabel(new LangString("metro cuadrado pormetro", "es"));
  unit.addLabel(new LangString("square metre per metre", "en"));
  unit.addLabel(new LangString("metru pătrat pe metru", "ro"));
  unit.addLabel(new LangString("квадратный метр на метр", "ru"));
  unit.addLabel(new LangString("metro quadrado por metro", "pt"));
  unit.addLabel(new LangString("mètre carré par mètre", "fr"));
  unit.addLabel(new LangString("metr kwadratowy na metr", "pl"));
  unit.addLabel(new LangString("metrekare per metre", "tr"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerLength");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "m²/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("square meter per square meter", "en-US"));
  unit.addLabel(new LangString("square metre per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaRatio");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Square Metre per Mole", "en"));
  unit.addLabel(new LangString("Square Meter per Mole", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/N",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Metre per Newton", "en"));
  unit.addLabel(new LangString("Square Meter per Newton", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("mètre carré par seconde", "fr"));
  unit.addLabel(new LangString("平方メートル毎秒", "ja"));
  unit.addLabel(new LangString("square metre per second", "en"));
  unit.addLabel(new LangString("متر مربع بر ثانیه", "fa"));
  unit.addLabel(new LangString("metro cuadrado por segundo", "es"));
  unit.addLabel(new LangString("वर्ग मीटर प्रति सैकिण्ड", "hi"));
  unit.addLabel(new LangString("Quadratmeter je Sekunde", "de"));
  unit.addLabel(new LangString("metro quadrato al secondo", "it"));
  unit.addLabel(new LangString("metrekare bölü saniye", "tr"));
  unit.addLabel(new LangString("квадратный метр в секунду", "ru"));
  unit.addLabel(new LangString("kvadratni meter na sekundo", "sl"));
  unit.addLabel(new LangString("平方米每秒", "zh"));
  unit.addLabel(new LangString("metru pătrat pe secundă", "ro"));
  unit.addLabel(new LangString("meter persegi per saat", "ms"));
  unit.addLabel(new LangString("čtvereční metr za sekundu", "cs"));
  unit.addLabel(new LangString("metro quadrado por segundo", "pt"));
  unit.addLabel(new LangString("metr kwadratowy na sekundę", "pl"));
  unit.addLabel(new LangString("متر مربع في الثانية", "ar"));
  unit.addLabel(new LangString("Square Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatioCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("square metre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("square metre per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s·Pa)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("square metre per second pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metres per square second", "en"));
  unit.addLabel(new LangString("Square Meters per Square Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificModulus");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SEC2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(s²·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("square metre per square second kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SEC2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Metre per Steradian", "en"));
  unit.addLabel(new LangString("Square Meter per Steradian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-SR-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(sr·J)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Metre per Steradian Joule", "en"));
  unit.addLabel(new LangString("Square Meter per Steradian Joule", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection"
  );
  config.units.set("http://qudt.org/vocab/unit/M2-PER-SR-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-V-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/(V·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Quadratmeter je Volt und Sekunde", "de"));
  unit.addLabel(new LangString("Square Meter per Volt Second", "en-US"));
  unit.addLabel(new LangString("square metre per volt second", "en"));
  unit.addLabel(new LangString("metro quadrato al volt e al secondo", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mobility");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-V-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-PER-W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²/W",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("square metre per watt", "en"));
  unit.addLabel(new LangString("metru pătrat pe watt", "ro"));
  unit.addLabel(new LangString("meter persegi per watt", "ms"));
  unit.addLabel(new LangString("kvadratni meter na watt", "sl"));
  unit.addLabel(new LangString("metro cuadrado porvatio", "es"));
  unit.addLabel(new LangString("metrekare per watt", "tr"));
  unit.addLabel(new LangString("metro quadrado por watt", "pt"));
  unit.addLabel(new LangString("Quadratmeter je Watt", "de"));
  unit.addLabel(new LangString("квадратный метр на ватт", "ru"));
  unit.addLabel(new LangString("metro quadrato al watt", "it"));
  unit.addLabel(new LangString("mètre carré par watt", "fr"));
  unit.addLabel(new LangString("čtvereční metr na watt", "cs"));
  unit.addLabel(new LangString("metr kwadratowy na wat", "pl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerPower");
  config.units.set("http://qudt.org/vocab/unit/M2-PER-W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-SEC-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·s/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square metre seconds per radian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M2-SEC-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m²·sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Metre Steradian", "en"));
  unit.addLabel(new LangString("Square Meter Steradian", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaAngle");
  config.units.set("http://qudt.org/vocab/unit/M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("घन मीटर", "hi"));
  unit.addLabel(new LangString("meter kubik", "ms"));
  unit.addLabel(new LangString("metru cub", "ro"));
  unit.addLabel(new LangString("metr krychlový", "cs"));
  unit.addLabel(new LangString("кубичен метър", "bg"));
  unit.addLabel(new LangString("кубический метр", "ru"));
  unit.addLabel(new LangString("متر مکعب", "fa"));
  unit.addLabel(new LangString("Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Kubikmeter", "de"));
  unit.addLabel(new LangString("מטר מעוקב", "he"));
  unit.addLabel(new LangString("立方メートル", "ja"));
  unit.addLabel(new LangString("κυβικό μετρο", "el"));
  unit.addLabel(new LangString("立方米", "zh"));
  unit.addLabel(new LangString("metro cúbico", "pt"));
  unit.addLabel(new LangString("mètre cube", "fr"));
  unit.addLabel(new LangString("متر مكعب", "ar"));
  unit.addLabel(new LangString("metreküp", "tr"));
  unit.addLabel(new LangString("cubic metre", "en"));
  unit.addLabel(new LangString("metrum cubicum", "la"));
  unit.addLabel(new LangString("metr sześcienny", "pl"));
  unit.addLabel(new LangString("kubični meter", "sl"));
  unit.addLabel(new LangString("metro cubo", "it"));
  unit.addLabel(new LangString("metro cúbico", "es"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SectionModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/C",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Metre per Coulomb", "en"));
  unit.addLabel(new LangString("Cubic Meter per Coulomb", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001157407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Metre per Day", "en"));
  unit.addLabel(new LangString("Cubic Meter per Day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.00001157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Meter per Hectare", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerArea");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.168808781402895E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(ha·a)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Cubic Meter per Hectare Year", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Hectare Year", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlow"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0002777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Meter per Hour", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Cubic Metre per Kelvin", "en"));
  unit.addLabel(new LangString("Cubic Meter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Metre per Kilogram", "en"));
  unit.addLabel(new LangString("Cubic Meter per Kilogram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(kg·s²)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Cubic Meter per Kilogram Square Second", "en-US")
  );
  unit.addLabel(new LangString("Cubic Metre per Kilogram Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Meter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerArea");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Meter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.01666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Metre per Minute", "en"));
  unit.addLabel(new LangString("Cubic Meter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("metr krychlový na mol", "cs"));
  unit.addLabel(new LangString("متر مكعب لكل مول", "ar"));
  unit.addLabel(new LangString("кубический метр на моль", "ru"));
  unit.addLabel(new LangString("cubic metre per mole", "en"));
  unit.addLabel(new LangString("metru cub pe mol", "ro"));
  unit.addLabel(new LangString("kubični meter na mol", "sl"));
  unit.addLabel(new LangString("立方米每摩尔", "zh"));
  unit.addLabel(new LangString("Cubic Meter per Mole", "en-US"));
  unit.addLabel(new LangString("metro cubo alla mole", "it"));
  unit.addLabel(new LangString("متر مکعب بر مول", "fa"));
  unit.addLabel(new LangString("metro cúbico por mol", "es"));
  unit.addLabel(new LangString("mètre cube par mole", "fr"));
  unit.addLabel(new LangString("घन मीटर प्रति मोल (इकाई)", "hi"));
  unit.addLabel(new LangString("metr sześcienny na mol", "pl"));
  unit.addLabel(new LangString("立方メートル 毎立方メートル", "ja"));
  unit.addLabel(new LangString("meter kubik per mole", "ms"));
  unit.addLabel(new LangString("metreküp bölü metre küp", "tr"));
  unit.addLabel(new LangString("Kubikmeter je Mol", "de"));
  unit.addLabel(new LangString("metro cúbico por mol", "pt"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-MOL-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(mol·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Cubic Meter per Mole Second", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Mole Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-MOL-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Metre per Second", "en"));
  unit.addLabel(new LangString("Cubic Meter per Second", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundVolumeVelocity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RecombinationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·m²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("cubic metre per second square metre", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate_SurfaceRelated"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/(s·Pa)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic metre per second pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Meter per Square Second", "en-US"));
  unit.addLabel(new LangString("Cubic Metre per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter"
  );
  config.units.set("http://qudt.org/vocab/unit/M3-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M3-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.168808781E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m³/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Kubieke meter per Jaar", "nl"));
  unit.addLabel(new LangString("Cubic Metre per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/M3-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Quartic Meter", "en-US"));
  unit.addLabel(new LangString("Quartic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/M4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M4-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁴/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metres to the power four per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/M4-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L5I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁵",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Quintic Meter", "en-US"));
  unit.addLabel(new LangString("Quintic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SectionAreaIntegral"
  );
  config.units.set("http://qudt.org/vocab/unit/M5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L6I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁶",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Sextic Meter", "en-US"));
  unit.addLabel(new LangString("Sextic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingConstant");
  config.units.set("http://qudt.org/vocab/unit/M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MACH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Mach",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Mach", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MachNumber");
  config.units.set("http://qudt.org/vocab/unit/MACH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MDOLLAR",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MDOLLAR", undefined));
  config.units.set("http://qudt.org/vocab/unit/MDOLLAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MDOLLAR-PER-FLIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$M/flight",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Million US Dollars per Flight", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight"
  );
  config.units.set("http://qudt.org/vocab/unit/MDOLLAR-PER-FLIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MESH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mesh",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Mesh", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/MESH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MHO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S",
    undefined,
    "℧",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Mho", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/S");
  config.units.set("http://qudt.org/vocab/unit/MHO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MHO_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1.1126500561E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    "stat℧",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Statmho", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/S_Stat");
  config.units.set("http://qudt.org/vocab/unit/MHO_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1609.344"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("International Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Distance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.44704"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Mile per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("26.8224"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Mile per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1609.344"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Mile per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("2589997.766409"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MI_US2");
  config.units.set("http://qudt.org/vocab/unit/MI2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4168181830.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MI3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000490873852"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mil{NATO}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Mil Angle (NATO)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MIL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MILLE",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MILLE", undefined));
  config.units.set("http://qudt.org/vocab/unit/MILLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIL_Circ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("5.067075E-10"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "cmil",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Circular Mil", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/MIL_Circ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN_Angle",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000290888209"),
    undefined,
    undefined,
    undefined,
    undefined,
    "'",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Minute Angle", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/ARCMIN");
  config.units.set("http://qudt.org/vocab/unit/MIN_Angle", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MIN_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("59.83617"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "min{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Sidereal Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MIN_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1852.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "nmi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Nautical Mile", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MI_N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_N-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.5144444444444445"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmi/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Nautical Mile per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KN");
  config.units.set("http://qudt.org/vocab/unit/MI_N-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_N-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("30.86666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmi/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Nautical Mile per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MI_N-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_UK",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MI_UK", undefined));
  config.units.set("http://qudt.org/vocab/unit/MI_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_UK3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mi³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic mile (UK statute)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SectionModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MI_UK3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1609.347"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mi{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Mile US Statute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MI_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1609.347"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi{US}/s²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("mile (statute mile) per second squared", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MI_US-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MI_US2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("2589997.766409"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mi² {US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString("square mile (based on U.S. survey foot)", undefined)
  );
  unit.addLabel(new LangString("Square Mile US Statute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MI2");
  config.units.set("http://qudt.org/vocab/unit/MI_US2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("2551442.976"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "mo",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MO_Synodic");
  config.units.set("http://qudt.org/vocab/unit/MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mohm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Mohm", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MechanicalMobility"
  );
  config.units.set("http://qudt.org/vocab/unit/MOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("摩尔", "zh"));
  unit.addLabel(new LangString("مول", "ar"));
  unit.addLabel(new LangString("mol", "pl"));
  unit.addLabel(new LangString("mol", "sl"));
  unit.addLabel(new LangString("mole", "it"));
  unit.addLabel(new LangString("mole", "fr"));
  unit.addLabel(new LangString("mol", "tr"));
  unit.addLabel(new LangString("mol", "ro"));
  unit.addLabel(new LangString("mol", "pt"));
  unit.addLabel(new LangString("مول", "fa"));
  unit.addLabel(new LangString("मोल (इकाई)", "hi"));
  unit.addLabel(new LangString("мол", "bg"));
  unit.addLabel(new LangString("μολ", "el"));
  unit.addLabel(new LangString("moles", "la"));
  unit.addLabel(new LangString("モル", "ja"));
  unit.addLabel(new LangString("mol", "cs"));
  unit.addLabel(new LangString("mol", "es"));
  unit.addLabel(new LangString("моль", "ru"));
  unit.addLabel(new LangString("mole", "ms"));
  unit.addLabel(new LangString("מול", "he"));
  unit.addLabel(new LangString("mole", "en"));
  unit.addLabel(new LangString("Mol", "de"));
  unit.addLabel(new LangString("mól", "hu"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol·°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Mole Degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol·K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/dm³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Cubic Decimeter", "en-US"));
  unit.addLabel(new LangString("Mole per Cubic Decimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-DeciM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-GM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.277777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(g·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Moles per gram hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-GM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.000277778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(kg·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mole per kilogram bar", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(kg·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mole per kilogram kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(kg·Pa)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Kilogram Pascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Litre", "en"));
  unit.addLabel(new LangString("Mole per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-L-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(l·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mole per litre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-L-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-L-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(l·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mole per litre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-L-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Moles per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("0.0000115740740740741"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Moles per Square Metre Day", "en"));
  unit.addLabel(new LangString("Moles per Square Meter Day", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Moles per square metre second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Moles per square metre second metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s·m·sr)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(
    new LangString("Moles per square metre second metre steradian", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m²·s·sr)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(
    new LangString("Moles per square metre second steradian", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Cubic Metre", "en"));
  unit.addLabel(new LangString("Mole per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mole per cubic metre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mole per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·Pa)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mole per cubic metre pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/(m³·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Moles per cubic metre second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.016666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Moles per mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mole per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL-PER-TONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mol/t",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Mol per Tonne", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL-PER-TONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("453.59237"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "lb-mol",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pound Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    new Decimal("251.995761111111131270772"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol·°F",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pound Mole Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstanceTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("999.9999999999999999999999999999998"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol/lbm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound mole per pound", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("7.559872833333333333333333333333335"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound mole per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOL_LB-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("453.59237"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb-mol/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pound mole per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MOL_LB-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOMME_Pearl",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "momme (pearl)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Momme (pearl)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MOMME_Pearl", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MOMME_Textile",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "momme (textile)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Momme (textile)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MOMME_Textile", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mo{Gregorian}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Mean Gregorian Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MO_MeanGREGORIAN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO_MeanJulian",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mo{mean Julian}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Mean Julian Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MO_MeanJulian", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MO_Synodic",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mo{synodic}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Synodic month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MO");
  config.units.set("http://qudt.org/vocab/unit/MO_Synodic", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "Mx",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Maxwell", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/MX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/M_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mH₂0",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("conventional metre of water", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/M_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("726817.4980028252"),
    undefined,
    "http://qudt.org/vocab/prefix/Mebi",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Mibit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mebibit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/MebiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("726817.49800282521276748358899013255168"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mibit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mebibit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MebiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("726817.49800282521276748358899013255168"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mibit/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mebibit per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/MebiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("726817.49800282521276748358899013255168"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mibit/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("mebibit per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MebiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MebiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5814539.984022601702139868711921018"),
    undefined,
    "http://qudt.org/vocab/prefix/Mebi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "MiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Mebibyte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/MebiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "MA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Megaampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/MegaA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaA-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MA/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Megaampere per Square Metre", "en"));
  unit.addLabel(new LangString("Megaampere per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaA-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "Mbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Megabar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MegaBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBAUD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BAUD",
    undefined,
    "MBd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megabaud", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DigitRate");
  config.units.set("http://qudt.org/vocab/unit/MegaBAUD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147.18055994530941723212145818"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Mbit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megabit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/MegaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147.18055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbps",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Megabit per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/MegaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "MBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Megabecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MegaBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MBq/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megabecquerel per kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassicActivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBTU_IT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MegaBTU_IT", undefined));
  config.units.set("http://qudt.org/vocab/unit/MegaBTU_IT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("293071.07"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MBtu{IT}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(
    new LangString(
      "Mega British Thermal Unit (International Definition) per Hour",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177.44447956"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "MB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Mega byte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaBYTE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("5545177.4444795624753378569716654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mbyte/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megabyte per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ByteRate");
  config.units.set("http://qudt.org/vocab/unit/MegaBYTE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "MC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("MegaCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MegaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megacoulomb per Square Meter", "en-US"));
  unit.addLabel(new LangString("Megacoulomb per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megacoulomb per Cubic Metre", "en"));
  unit.addLabel(new LangString("Megacoulomb per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaDOLLAR_US",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MegaDOLLAR_US", undefined));
  config.units.set("http://qudt.org/vocab/unit/MegaDOLLAR_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaDOLLAR_US-PER-FLIGHT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$M/flight",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Million US Dollars per Flight", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaDOLLAR_US-PER-FLIGHT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.602176634E-13"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/EV",
    undefined,
    "MeV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Mega Electron Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaEV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV-FemtoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("1.602176634E-28"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    undefined,
    undefined,
    "MeV·fm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Mega Electron Volt Femtometer", "en-US"));
  unit.addLabel(new LangString("Mega Electron Volt Femtometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthEnergy");
  config.units.set("http://qudt.org/vocab/unit/MegaEV-FemtoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.602176634E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MeV/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Mega Electron Volt per Centimetre", "en"));
  unit.addLabel(new LangString("Mega Electron Volt per Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaEV-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MeV/c",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Mega Electron Volt per Speed of Light", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  config.units.set("http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Mflops",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("megafloating point operations per second", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "Mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megagram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MegaGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mg/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megagram per Hectare", "en"));
  unit.addLabel(new LangString("Megagram per Hectare", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HA");
  config.units.set("http://qudt.org/vocab/unit/MegaGM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Mg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megagram per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Megagram per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MegaGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "MGy",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megagray", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Kerma");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/MegaGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "MHz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Megahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/MegaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megahertz Metre", "en"));
  unit.addLabel(new LangString("Megahertz Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  config.units.set("http://qudt.org/vocab/unit/MegaHZ-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T-1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Mega Hertz per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaHZ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaHZ-PER-T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz/T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Mega Hertz per Tesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaHZ-PER-T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaINDIV",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MegaINDIV", undefined));
  config.units.set("http://qudt.org/vocab/unit/MegaINDIV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "MJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/MegaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("277.7777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megajoule per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("MegaJoule per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatCapacity");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megajoule per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megajoule per Square Meter", "en-US"));
  unit.addLabel(new LangString("Megajoule per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megajoule per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Megajoule per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MJ/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megajoule per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaK",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MegaK", undefined));
  config.units.set("http://qudt.org/vocab/unit/MegaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "ML",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megalitre", "en"));
  unit.addLabel(new LangString("Megalitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MegaL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaLB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("4448221.8148411428"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/LB_F",
    undefined,
    "Mlbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Mega Pound Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MegaLB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "MN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Meganewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MegaN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Meganewton Meter", "en-US"));
  unit.addLabel(new LangString("Meganewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/MegaN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MN·m/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("meganewton metre per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/MegaN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "MΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Megaohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ·km",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megaohm kilometre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megaohm metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megaohm per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megaohm per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/km",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megaohm per kilometre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MΩ/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megaohm per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "MPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megapascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa·L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megapascal Liter per Second", "en-US"));
  unit.addLabel(new LangString("Megapascal Litre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaPA-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-M0dot5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    undefined,
    undefined,
    "MPa√m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megapascal Square Root Meter", "en-US"));
  unit.addLabel(new LangString("Megapascal Square Root Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaPA-M0dot5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-M0pt5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    undefined,
    undefined,
    "MPa√m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megapascal Square Root Meter", "en-US"));
  unit.addLabel(new LangString("Megapascal Square Root Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaPA-M0pt5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa·m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megapascal Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Megapascal Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Megapascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/MegaPA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MPa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Megapascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaPA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaPSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894757800.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/PSI",
    undefined,
    "Mpsi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("MPSI", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MegaPSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "MS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("MegaSiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MegaS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Megasiemens per Metre", "en"));
  unit.addLabel(new LangString("Megasiemens per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MegaS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "Ms",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megasecond", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Period");
  config.units.set("http://qudt.org/vocab/unit/MegaSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaTOE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("41868000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/TOE",
    undefined,
    "Mtoe",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Megaton of Oil Equivalent", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaTOE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaTON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907184740.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/TON",
    undefined,
    "Mtn",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megaton", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MegaTON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaTONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    "Mt",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megatonne", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MegaTONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "MV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Megavolt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Megavolt Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Megavolt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Megavolt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV·A{Reactive}·h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Megavolt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaV-A_Reactive-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Megavolt per Meter", "en-US"));
  unit.addLabel(new LangString("Megavolt per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MegaV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "MW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("MegaW", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MegaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Megawatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MegaW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MegaYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Mega",
    "http://qudt.org/vocab/unit/YR",
    undefined,
    "Ma",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Million Years", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MegaYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Megahertz",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Megahertz", undefined));
  config.units.set("http://qudt.org/vocab/unit/Megahertz", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Megahertz-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "MHz·km",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("megahertz kilometre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/Megahertz-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "μA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("microampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/MicroA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µA/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroATM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.101325"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/ATM",
    undefined,
    "μatm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Microatmospheres", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MicroATM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.1"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "μbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Microbar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MicroBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "μBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Microbecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MicroBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μBq/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microbecquerels per kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroBQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μBq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microbecquerels per litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroBQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "μC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("MicroCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MicroC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microcoulomb per Square Metre", "en"));
  unit.addLabel(new LangString("Microcoulomb per Square Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microcoulomb per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Microcoulomb per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroCi",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/Ci",
    undefined,
    "μCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("MicroCurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MicroCi", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "μF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("microfarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/MicroFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µF/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microfarad per Kilometre", "en"));
  unit.addLabel(new LangString("Microfarad per Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µF/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microfarad per Meter", "en-US"));
  unit.addLabel(new LangString("Microfarad per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/MicroFARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.00000980665"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/G",
    undefined,
    "μG",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Microgravity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroG-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µg/cm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Microgram per square centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroG-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGAL",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MicroGAL", undefined));
  config.units.set("http://qudt.org/vocab/unit/MicroGAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGAL-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µGal/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MicroGals per metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGAL-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "μg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microgram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MicroGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.00001"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "µG/cm²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Microgram per square centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.6534392E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(cm²·wk)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Micrograms per square centimeter week", "en-US")
  );
  unit.addLabel(new LangString("Micrograms per square centimetre week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microgram per Deciliter", "en-US"));
  unit.addLabel(new LangString("Microgram per Decilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micrograms per gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.00000155"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/in²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
    ]
  );
  unit.addLabel(new LangString("Microgram per Square Inch", "en-US"));
  unit.addLabel(new LangString("Microgram per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microgram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microgram per Liter", "en-US"));
  unit.addLabel(new LangString("Microgram per Liter", "nl"));
  unit.addLabel(new LangString("Microgram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("2.77777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(L·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micrograms per litre hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.15740740740741E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(m²·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micrograms per square metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microgram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Microgram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µg/(m³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microgram per cubic metre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("2.77777777777778E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/(m³·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micrograms per cubic metre hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µg/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microgram per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μg/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microgram per Milliliter", "en-US"));
  unit.addLabel(new LangString("Microgram per MilliLitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MicroGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "μGy",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("MicroGray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µGy/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microgray per hour", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µGy/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microgray per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µGy/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microgray per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroGRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "μH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microhenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/MicroH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µH/kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microhenry per Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MicroH-PER-KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µH/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microhenry per Meter", "en-US"));
  unit.addLabel(new LangString("Microhenry per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroH-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µH/Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microhenry per Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MicroH-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("2.54E-8"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/IN",
    undefined,
    "μin",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Microinch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Distance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MicroIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.000001"),
    new Decimal("0.0"),
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "μJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micro Joule", "en"));
  unit.addLabel(new LangString("Mikrojoule ", "de"));
  unit.addLabel(new LangString("Micro Joule", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MicroJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microjoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MicroJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroKAT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MicroKAT", undefined));
  config.units.set("http://qudt.org/vocab/unit/MicroKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Microkatal per Liter", "en-US"));
  unit.addLabel(new LangString("Microkatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "μL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microlitre", "en"));
  unit.addLabel(new LangString("Microlitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μL/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microlitre per Litre", "en"));
  unit.addLabel(new LangString("Microlitre per Liter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MicroL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "μm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micrometre", "en"));
  unit.addLabel(new LangString("Micrometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MicroM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µm/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micrometre per Kelvin", "en"));
  unit.addLabel(new LangString("Micrometer per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-L-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.15740740740741E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µm/(L·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micromoles per litre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-L-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µm/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("micrometre per metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Gradient");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.66666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micrometer per Minute", "en-US"));
  unit.addLabel(new LangString("micrometre per minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µm/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square microns per millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    new Decimal("0.000001"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "µm/N",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Mikrometer pro Newton", "de"));
  unit.addLabel(new LangString("Micro meter per Newton", "en-US"));
  unit.addLabel(new LangString("Micro metre per Newton", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearCompressibility"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("micrometre per second", "en"));
  unit.addLabel(new LangString("Micrometer per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MicroM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    undefined,
    undefined,
    "μm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Micrometre", "en"));
  unit.addLabel(new LangString("Square Micrometer", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/MicroM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    undefined,
    undefined,
    "µm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic micrometres (microns)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MicroM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-18"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic microns per cubic metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MicroM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroM3-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µm³/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic microns per millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MicroM3-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMHO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/MHO",
    undefined,
    "µ℧",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Micromho", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MicroMHO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "μmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/g",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("2.77777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/(g·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per gram hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(g·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per gram second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.77777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/(L·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per litre hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.15740740740741E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/(m²·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per square metre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("2.77777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/(m²·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per square metre hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/(m²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per square metre second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0000115740740740741"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μmol/(µmol·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromole per micromole of biomass day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroMOL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µmol/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Micromoles per second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFlux"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroMOL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "μN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micronewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MicroN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micronewton Meter", "en-US"));
  unit.addLabel(new LangString("Micronewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/MicroN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µN·m/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("micronewton metre per square metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "μΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Microohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/MicroOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µΩ·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microohm metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/MicroOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "μPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Micropascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MicroPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1E-7"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    "μP",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Micropoise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/MicroPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "µrad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("microradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MicroRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "μS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Microsiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MicroS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroS-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μS/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microsiemens per Centimetre", "en"));
  unit.addLabel(new LangString("Microsiemens per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MicroS-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microsiemens per Meter", "en-US"));
  unit.addLabel(new LangString("Microsiemens per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MicroS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "µs",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("microsecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MicroSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/SV",
    undefined,
    "µSv",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("MicroSievert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/MicroSV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.77778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µSv/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("MicroSievert per hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroSV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µSv/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microsievert per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroSV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µSv/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microsievert per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MicroSV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "µT",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microtesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroTORR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.000133322"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/TORR",
    undefined,
    "µTorr",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MicroTorr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MicroTORR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "µV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Microvolt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microvolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/MicroV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µV·A/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microvolt ampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroV-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "µV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("microvolt ampere reactive", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MicroV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "µvar/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("microvolt ampere reactive per kelvin", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MicroV-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Microvolt per Metre", "en"));
  unit.addLabel(new LangString("Microvolt per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MicroV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Micro",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "µW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Microwatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MicroW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MicroW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "µW/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Microwatt per Square Meter", "en-US"));
  unit.addLabel(new LangString("Microwatt per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/MicroW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilLength",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0000254"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mil",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Mil Length", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MilLength", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "mA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("MilliAmpere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/MilliA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Milliampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MilliA-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-HR-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("3600.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "mA·h/g",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Milliampere Hour per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-HR-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1.45037731222726870214855723638659299692E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA·in²/lbf",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milliampere square inch per pound-force", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliampere per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("0.03937008"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Milliampere per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-L-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/(l·min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliampere per litre minute", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-L-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M-1H0T2D0",
    new Decimal(
      "0.34845454307937980503809350919576335422566229642579948977603983952"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/(lbf·in²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milliampere per pound-force square inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Milliampere per Millimetre", "en"));
  unit.addLabel(new LangString("Milliampere per Millimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliA-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mA·s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliampere second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MilliA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliARCSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("4.84813681E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/ARCSEC",
    undefined,
    "mas",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Milli ArcSecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MilliARCSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/BAR",
    undefined,
    "mbar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millibar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/HectoPA");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar·L/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millibar Liter per Second", "en-US"));
  unit.addLabel(new LangString("Millibar Litre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar·m³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millibar Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Millibar Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millibar per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBAR-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mbar/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Millibar per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBAR-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "mBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("MilliBecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MilliBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millibecquerels per gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millibecquerels per kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificActivity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millibecquerels per litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-2D0",
    new Decimal("1.15740740740741E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mBq/(m²·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millibecquerels per square metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "mC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("MilliCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/MilliC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mC/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millicoulomb per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliC-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mC/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millicoulomb per Square Meter", "en-US"));
  unit.addLabel(new LangString("Millicoulomb per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mC/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millicoulomb per Cubic Metre", "en"));
  unit.addLabel(new LangString("Millicoulomb per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliCD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/CD",
    undefined,
    "mCd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millicandela", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliCD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliCi",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("37000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/Ci",
    undefined,
    "mCi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millicurie", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/MilliCi", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliDARCY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("9.869233E-16"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/DARCY",
    undefined,
    "md",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millidarcy", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliDARCY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliDEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("0.001"),
    new Decimal("273150.0"),
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/DEG_C",
    undefined,
    "m°C",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millidegree Celsius", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  config.units.set("http://qudt.org/vocab/unit/MilliDEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "mF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Millifarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/MilliFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.00980665"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/G",
    undefined,
    "mG",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Milligravity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/GALILEO",
    undefined,
    "mgal",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Milligal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliGAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGAL-PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-3D0",
    new Decimal("3.919350772901616281311709002114104E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mgal/mo",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MilliGals per month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGAL-PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(cm³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram hour per litre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(m³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram hour per litre cubic metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(l/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram hour per litre squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(cm³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram hour per cubic metre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("3.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(l/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram hour per cubic metre litre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.0036"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(m³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "milligram hour per power of metre with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-HR-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(cm³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram minute per litre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.06"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(m³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram minute per litre cubic metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(l/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram minute per litre squared", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("60.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(cm³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "milligram minute per cubic metre cubic centimetre",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.06"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(l/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram minute per cubic metre litre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.00006"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(m³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "milligram minute per power of metre with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Milligram per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.157407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-16"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("milligrams per decilitre", "en"));
  unit.addLabel(new LangString("milligrams per decilitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel_Mass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("2.777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Liter", "nl"));
  unit.addLabel(new LangString("Milligram per Liter", "en-US"));
  unit.addLabel(new LangString("Milligram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/cP",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per litre centipoise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(mPa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram per litre millipascal second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(Pa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per litre pascal second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/P",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per litre poise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-L-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Metre", "en"));
  unit.addLabel(new LangString("Milligram per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Square Meter", "en-US"));
  unit.addLabel(new LangString("Milligram per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.15740740740741E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m²·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligrams per square metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("2.77777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m²·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligrams per square metre hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligrams per square metre second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Milligram per Kubieke Meter", "nl"));
  unit.addLabel(new LangString("Milligram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per cubic metre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/cP",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram per cubic metre centipoise", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("1.15740740740741E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligrams per cubic metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("2.77777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligrams per cubic metre hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(mPa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram per cubic metre millipascal second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(Pa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram per cubic metre pascal second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/P",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per cubic metre poise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(m³·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligrams per cubic metre second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Millilitre", "en"));
  unit.addLabel(new LangString("Milligram per Milliliter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligram per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligram per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(cm³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram second per litre cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(m³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram second per litre cubic metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/l)/(l/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram second per litre squared", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(cm³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "milligram second per cubic metre cubic centimetre",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(l/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("milligram second per cubic metre litre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(mg/m³)/(m³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "milligram second per power of metre with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/GRAY",
    undefined,
    "mGy",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milligray", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mGy/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligray per hour", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mGy/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligray per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mGy/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milligray per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliGRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "mH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Millihenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/MilliH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mH/kΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Millihenry per Kiloohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliH-PER-KiloOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mH/Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Millihenry per Ohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliH-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "mHz",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millihertz", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/MilliHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0000254"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/IN",
    undefined,
    "mil",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Milli-inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MilliIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "mJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millijoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/MilliJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mJ/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millijoule per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/MilliJ-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mJ/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millijoule per Square Meter", "en-US"));
  unit.addLabel(new LangString("Millijoule per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyFluence");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadiantFluence");
  config.units.set("http://qudt.org/vocab/unit/MilliJ-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millijoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliK",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MilliK", undefined));
  config.units.set("http://qudt.org/vocab/unit/MilliK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliK-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H1T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mK/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millikelvin per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliK-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliK-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mK/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millikelvin per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliK-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliKAT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MilliKAT", undefined));
  config.units.set("http://qudt.org/vocab/unit/MilliKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millikatal per Liter", "en-US"));
  unit.addLabel(new LangString("Millikatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre", "en"));
  unit.addLabel(new LangString("Millilitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00016666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(cm²·min)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Millilitre per Square Centimetre Minute", "en")
  );
  unit.addLabel(
    new LangString("Millilitre per Square Centimeter Minute", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumetricFlux");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(cm²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Millilitre per Square Centimeter Second", "en-US")
  );
  unit.addLabel(
    new LangString("Millilitre per Square Centimetre Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumetricFlux");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.157407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre per Day", "en-US"));
  unit.addLabel(new LangString("Millilitre per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-16"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.157407407407407407407407407407407E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milliliter per Gram", "en-US"));
  unit.addLabel(new LangString("Millilitre per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/CentiM3-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre per Hour", "en-US"));
  unit.addLabel(new LangString("Millilitre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("2.777777777777777777777777777777778E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("2.777777777777777777777777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millilitre per Kelvin", "en-US"));
  unit.addLabel(new LangString("Millilitre per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre per Kilogram", "en-US"));
  unit.addLabel(new LangString("Millilitre per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre per Liter", "en-US"));
  unit.addLabel(new LangString("Millilitre per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.15740740740741E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/(m²·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitres per square metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Millilitre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre per Minute", "en-US"));
  unit.addLabel(new LangString("Millilitre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1.666666666666666666666666666666667E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("1.666666666666666666666666666666667E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mL/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millilitre per Second", "en"));
  unit.addLabel(new LangString("Millilitre per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T1D0",
    new Decimal("1E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ml/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millilitre per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliL-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millimetre", "en"));
  unit.addLabel(new LangString("Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millimetre per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.15741E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("millimetres per day", "en"));
  unit.addLabel(new LangString("millimeters per day", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/(°C·m)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("millimetre per degree Celsius metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("2.777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millimetre per Hour", "en"));
  unit.addLabel(new LangString("Millimeter per Hour", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimetre per Kelvin", "en"));
  unit.addLabel(new LangString("Millimeter per Kelvin", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millimetre per metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Gradient");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.00001666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millimeter per Minute", "en-US"));
  unit.addLabel(new LangString("Millimetre per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millimetre per Second", "en"));
  unit.addLabel(new LangString("Millimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/s²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millimetre per second squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millimetre per Year", "en"));
  unit.addLabel(new LangString("Millimeter per Year", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/MilliM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    undefined,
    undefined,
    "mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Square Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm²/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Millimetre per Second", "en"));
  unit.addLabel(new LangString("Square Millimeter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaPerTime");
  config.units.set("http://qudt.org/vocab/unit/MilliM2-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    undefined,
    undefined,
    "mm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Millimeter", "en-US"));
  unit.addLabel(new LangString("Cubic Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm³/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Millimetre per Gram", "en"));
  unit.addLabel(new LangString("Cubic Millimeter per Gram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM3-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm³/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Cubic Millimetre per Kilogram", "en"));
  unit.addLabel(new LangString("Cubic Millimeter per Kilogram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificVolume");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM3-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM3-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mm³/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Cubic Millimeter per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Cubic Millimetre per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFraction");
  config.units.set("http://qudt.org/vocab/unit/MilliM3-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    undefined,
    undefined,
    "mm⁴",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Quartic Millimetre", "en"));
  unit.addLabel(new LangString("Quartic Millimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliM4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "mmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/g",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimole per Gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimole per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/IonicStrength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("millimoles per litre", "en-US"));
  unit.addLabel(new LangString("millimoles per litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/m²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimoles per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.15740740740741E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/(m²·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimoles per square metre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/(m²·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimoles per square metre second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimoles per cubic metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.15740740740741E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/(m³·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimoles per cubic metre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliMOL-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mmol/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Millimoles per mole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliMOL-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM_H2O",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("9.80665"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mmH₂0",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Conventional Millimeter Of Water", "en-US"));
  unit.addLabel(new LangString("Conventional Millimetre Of Water", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliM_H2O", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM_HG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("133.322387415"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mmHg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millimetre of Mercury", "en"));
  unit.addLabel(new LangString("Millimeter of Mercury", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliM_HG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliM_HGA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mmHgA",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millimetre of Mercury - Absolute", "en"));
  unit.addLabel(new LangString("Millimeter of Mercury - Absolute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliM_HGA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/N",
    undefined,
    "mN",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millinewton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/MilliN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mN·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millinewton Meter", "en-US"));
  unit.addLabel(new LangString("Millinewton Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/MilliN-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mN·m/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("millinewton metre per square metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliN-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mN/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millinewton per Metre", "en"));
  unit.addLabel(new LangString("Millinewton per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/MilliN-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "mΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Milliohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliohm metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliohm per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliohm per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliOHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mΩ/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("milliohm per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliOHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "mPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millipascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millipascal per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliPA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millipascal Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa·s/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millipascal Second per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mPa·s/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millipascal second per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliPA-SEC-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("2.58E-7"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/R",
    undefined,
    "mR",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milliroentgen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliRAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    "mrad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("milliradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/MilliRAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliRAD_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/RAD_R",
    undefined,
    "mrad",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("MilliRad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/MilliRAD_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mrad/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Millirads per hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliRAD_R-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliR_man",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.00001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/R_man",
    undefined,
    "mrem",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Milliroentgen Equivalent Man", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/MilliR_man", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "mS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Millisiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/MilliS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliS-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mS/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Millisiemens per Centimetre", "en"));
  unit.addLabel(new LangString("Millisiemens per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MilliS-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("MilliSiemens per metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/MilliS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ms",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("millisecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/MilliSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/SV",
    undefined,
    "mSv",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Millisievert", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/MilliSV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mSv/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millisievert per hour", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliSV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.00001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mSv/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millisievert per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliSV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mSv/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millisievert per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/MilliSV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "mT",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Millitesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliTORR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("0.133322"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/TORR",
    undefined,
    "mTorr",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MilliTorr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/MilliTORR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "mV",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Millivolt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millivolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/MilliV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV·A/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millivolt ampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millivolt ampere reactive", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/MilliV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mvar/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("millivolt ampere reactive per kelvin", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliV-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Millivolt per Meter", "en-US"));
  unit.addLabel(new LangString("Millivolt per Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    new Decimal("0.00001666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Millivolt per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliV-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mV/V",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("millivolt per volt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliV-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "mW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("MilliW", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/MilliW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("10000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/(cm²·µm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString(
      "Milliwatts per square centimetre micrometre steradian",
      "en"
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set(
    "http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milliwatt per Square Metre", "en"));
  unit.addLabel(new LangString("Milliwatt per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/(m²·nm)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milliwatts per square metre nanometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/(cm·nm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Milliwatts per square metre nanometre steradian", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mW/mg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Milliwatt per Milligram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/W-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/MilliW-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MilliWB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("0.001"),
    undefined,
    "http://qudt.org/vocab/prefix/Milli",
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "mWb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Milliweber", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/MilliWB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MillionUSD",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("MillionUSD", undefined));
  config.units.set("http://qudt.org/vocab/unit/MillionUSD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/MillionUSD-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "$M/a",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Million US Dollars per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/MillionUSD-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("ニュートン", "ja"));
  unit.addLabel(new LangString("newton", "ro"));
  unit.addLabel(new LangString("niuton", "pl"));
  unit.addLabel(new LangString("newton", "tr"));
  unit.addLabel(new LangString("ньютон", "ru"));
  unit.addLabel(new LangString("ניוטון", "he"));
  unit.addLabel(new LangString("نيوتن", "ar"));
  unit.addLabel(new LangString("Newton", "de"));
  unit.addLabel(new LangString("newton", "sl"));
  unit.addLabel(new LangString("newton", "fr"));
  unit.addLabel(new LangString("newton", "hu"));
  unit.addLabel(new LangString("न्यूटन", "hi"));
  unit.addLabel(new LangString("νιούτον", "el"));
  unit.addLabel(new LangString("newton", "it"));
  unit.addLabel(new LangString("牛顿", "zh"));
  unit.addLabel(new LangString("newton", "cs"));
  unit.addLabel(new LangString("нютон", "bg"));
  unit.addLabel(new LangString("newton", "es"));
  unit.addLabel(new LangString("newton", "pt"));
  unit.addLabel(new LangString("newton", "en"));
  unit.addLabel(new LangString("newton", "ms"));
  unit.addLabel(new LangString("newtonium", "la"));
  unit.addLabel(new LangString("نیوتن", "fa"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2");
  config.units.set("http://qudt.org/vocab/unit/N", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton Centimeter", "en-US"));
  unit.addLabel(new LangString("Newton Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/N-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("newton-mètre", "fr"));
  unit.addLabel(new LangString("نيوتن متر", "ar"));
  unit.addLabel(new LangString("newton-metro", "pt"));
  unit.addLabel(new LangString("нютон-метър", "bg"));
  unit.addLabel(new LangString("newton metre", "tr"));
  unit.addLabel(new LangString("newton meter", "sl"));
  unit.addLabel(new LangString("牛米", "zh"));
  unit.addLabel(new LangString("niutonometr; dżul na radian", "pl"));
  unit.addLabel(new LangString("νιούτον επί μέτρο; νιουτόμετρο", "el"));
  unit.addLabel(new LangString("newton per metro", "it"));
  unit.addLabel(new LangString("ньютон-метр", "ru"));
  unit.addLabel(new LangString("newton metro", "es"));
  unit.addLabel(new LangString("ニュートンメートル", "ja"));
  unit.addLabel(new LangString("نیوتون متر", "fa"));
  unit.addLabel(new LangString("Newtonmeter", "de"));
  unit.addLabel(new LangString("न्यूटन मीटर", "hi"));
  unit.addLabel(new LangString("newton metre", "en"));
  unit.addLabel(new LangString("newton-metru", "ro"));
  unit.addLabel(new LangString("Newton Meter", "en-US"));
  unit.addLabel(new LangString("newton metr", "cs"));
  unit.addLabel(new LangString("newton meter", "ms"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/J");
  config.units.set("http://qudt.org/vocab/unit/N-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Newton Meter per Ampere", "en-US"));
  unit.addLabel(new LangString("Newton Metre per Ampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3437.746873197331483367149303409351"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/'",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("newton metre per minute [unit of angle]", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M-PER-MIN_Angle");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-ARCMIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("57.29577957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/°",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("newton metre per degree", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-DEG-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("57.29577957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/(°·m)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Newton metre per degree metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-DEG-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton Metre per Kilogram", "en"));
  unit.addLabel(new LangString("Newton Meter per Kilogram", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton metre per metre", "en"));
  unit.addLabel(new LangString("Newtonmeter pro Meter", "de"));
  unit.addLabel(new LangString("Newton meter per meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-M-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/(m·rad)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton Metre per Metre Radian", "en"));
  unit.addLabel(new LangString("Newton Meter per Meter Radian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-PER-RAD");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-M-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton Meter per Square Meter", "en-US"));
  unit.addLabel(new LangString("Newton Metre per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3437.746873197331483367149303409351"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/'",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("newton metre per minute [unit of angle]", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M-PER-ARCMIN");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-MIN_Angle", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newtonmeter pro Radian", "de"));
  unit.addLabel(new LangString("Newton metre per radian", "en"));
  unit.addLabel(new LangString("Newton meter per radian", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TorquePerAngle");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant"
  );
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-PER-W0dot5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m/√W",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("newton metre watt to the power minus 0.5", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/N-M-PER-W0dot5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("ньютон-метр-секунда", "ru"));
  unit.addLabel(new LangString("Newtonmetersekunde", "de"));
  unit.addLabel(new LangString("牛秒", "zh"));
  unit.addLabel(new LangString("نيوتن متر ثانية", "ar"));
  unit.addLabel(new LangString("ニュートンメートル秒", "ja"));
  unit.addLabel(new LangString("न्यूटन मीटर सैकण्ड", "hi"));
  unit.addLabel(new LangString("newton metro segundo", "es"));
  unit.addLabel(new LangString("niutonometrosekunda", "pl"));
  unit.addLabel(new LangString("newton metre second", "en"));
  unit.addLabel(new LangString("نیوتون ثانیه", "fa"));
  unit.addLabel(new LangString("newton-mètre-seconde", "fr"));
  unit.addLabel(new LangString("newton meter saat", "ms"));
  unit.addLabel(new LangString("newton metre saniye", "tr"));
  unit.addLabel(new LangString("newton metr sekunda", "cs"));
  unit.addLabel(new LangString("Newton Meter Second", "en-US"));
  unit.addLabel(new LangString("newton-metru-secundă", "ro"));
  unit.addLabel(new LangString("newton-metro-segundo", "pt"));
  unit.addLabel(new LangString("newton metro secondo", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularImpulse");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularMomentum");
  config.units.set("http://qudt.org/vocab/unit/N-M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newtonmetersekunden pro Meter", "de"));
  unit.addLabel(new LangString("Newton metre seconds per metre", "en"));
  unit.addLabel(new LangString("Newton meter seconds per meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  config.units.set("http://qudt.org/vocab/unit/N-M-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M-SEC-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·m·s/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newtonmetersekunden pro Radian", "de"));
  unit.addLabel(new LangString("Newton metre seconds per radian", "en"));
  unit.addLabel(new LangString("Newton meter seconds per radian", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentumPerAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/N-M-SEC-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton Square Metre", "en"));
  unit.addLabel(new LangString("Newton Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/WarpingMoment");
  config.units.set("http://qudt.org/vocab/unit/N-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M2-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m²/A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Newton Metre Squared per Ampere", "en"));
  unit.addLabel(new LangString("Newton Meter Squared per Ampere", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/WB-M");
  config.units.set("http://qudt.org/vocab/unit/N-M2-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-M2-PER-KiloGM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·m²/kg²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Newton Square Meter per Square Kilogram", "en-US")
  );
  unit.addLabel(
    new LangString("Newton Square Metre per Square Kilogram", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/N-M2-PER-KiloGM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Newton per Ampere", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength"
  );
  config.units.set("http://qudt.org/vocab/unit/N-PER-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/C",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton per Coulomb", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/N-PER-C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton per Centimetre", "en"));
  unit.addLabel(new LangString("Newton per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Newton per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/N-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/N-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton je Meter", "de"));
  unit.addLabel(new LangString("newton por metro", "pt"));
  unit.addLabel(new LangString("newton na meter", "sl"));
  unit.addLabel(new LangString("Newton per Meter", "en-US"));
  unit.addLabel(new LangString("牛顿每米", "zh"));
  unit.addLabel(new LangString("प्रति मीटर न्यूटन", "hi"));
  unit.addLabel(new LangString("مقياس التبادل، الأس السالب للمتر", "ar"));
  unit.addLabel(new LangString("niuton na metr", "pl"));
  unit.addLabel(new LangString("newton al metro", "it"));
  unit.addLabel(new LangString("ньютон на метр", "ru"));
  unit.addLabel(new LangString("ニュートン毎メートル", "ja"));
  unit.addLabel(new LangString("newton bölü metre", "tr"));
  unit.addLabel(new LangString("newton por metro", "es"));
  unit.addLabel(new LangString("newtonů na metr", "cs"));
  unit.addLabel(new LangString("newton par mètre", "fr"));
  unit.addLabel(new LangString("newton per meter", "ms"));
  unit.addLabel(new LangString("newton pe metru", "ro"));
  unit.addLabel(new LangString("newton per metre", "en"));
  unit.addLabel(new LangString("نیوتن بر متر", "fa"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newtons per Square Metre", "en"));
  unit.addLabel(new LangString("Newtons per Square Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2");
  config.units.set("http://qudt.org/vocab/unit/N-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newtons per cubic metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/N-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton per Millimetre", "en"));
  unit.addLabel(new LangString("Newton per Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/N-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-MilliM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N/mm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton per Square Millimeter", "en-US"));
  unit.addLabel(new LangString("Newton per Square Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/N-PER-MilliM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton per radian", "en-US"));
  unit.addLabel(new LangString("Newton pro Radian", "de"));
  unit.addLabel(new LangString("Newton per radian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerAngle");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M-PER-M-RAD");
  config.units.set("http://qudt.org/vocab/unit/N-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("ньютон-секунда", "ru"));
  unit.addLabel(new LangString("newton sekunda", "cs"));
  unit.addLabel(new LangString("牛秒", "zh"));
  unit.addLabel(new LangString("نيوتن ثانية", "ar"));
  unit.addLabel(new LangString("newton second", "en"));
  unit.addLabel(new LangString("نیوتون ثانیه", "fa"));
  unit.addLabel(new LangString("न्यूटन सैकण्ड", "hi"));
  unit.addLabel(new LangString("newton-secundă", "ro"));
  unit.addLabel(new LangString("Newtonsekunde", "de"));
  unit.addLabel(new LangString("newton-segundo", "pt"));
  unit.addLabel(new LangString("newton per secondo", "it"));
  unit.addLabel(new LangString("newton saniye", "tr"));
  unit.addLabel(new LangString("ニュートン秒", "ja"));
  unit.addLabel(new LangString("newton segundo", "es"));
  unit.addLabel(new LangString("newton saat", "ms"));
  unit.addLabel(new LangString("newton-seconde", "fr"));
  unit.addLabel(new LangString("niutonosekunda", "pl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  config.units.set("http://qudt.org/vocab/unit/N-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton Second per Meter", "en-US"));
  unit.addLabel(new LangString("Newton Second per Metre", "en"));
  unit.addLabel(new LangString("Newtonsekunden pro Meter", "de"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·s/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("newton second per square metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "N·s/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton second per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Newton second per Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance"
  );
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/N-SEC-PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("1.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "N·s/rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Newton seconds per radian", "en-US"));
  unit.addLabel(new LangString("Newton seconds per radian", "en"));
  unit.addLabel(new LangString("Newtonsekunden pro Radian", "de"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentumPerAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/N-SEC-PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NAT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nat",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Nat", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/NAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NAT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nat/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Nat per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/NAT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Np",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Neper", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/NP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NP-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Np/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("neper per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NP-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "NT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Net tonnage", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/NT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NTU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "NTU",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Nephelometry Turbidity Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Turbidity");
  config.units.set("http://qudt.org/vocab/unit/NTU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Number", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentumQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StoichiometricNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IonTransportNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Landau-GinzburgNumber"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Population");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/OpeningRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PrincipalQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HyperfineStructureQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticQuantumNumber"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NucleonNumber");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/QuantumNumber");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfPerformance"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NeutronNumber");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearSpinQuantumNumber"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReynoldsNumber");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ChargeNumber");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassNumber");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/NUM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/(cm·1000 a)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("Number per square centimetre thousand years", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/g",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-GM");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/ha",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("3.168808781402895E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/(ha·a)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per Hectare Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CountRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-HR");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-HectoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/hg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per 100 grams", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-HectoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-KiloM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/km²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per square kilometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-KiloM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/L",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-L");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-M");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-M2");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("0.0000115740740740741"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/(m²·day)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per square metre day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per cubic metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-M3");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/µL",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per microlitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/mg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per milligram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-MilliGM");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/mL",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-MilliL");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/mm³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per cubic millimeter", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-MilliM3");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-NanoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/nL",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per nanoliter", "en-US"));
  unit.addLabel(new LangString("Number per nanolitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-NanoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-PicoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/pL",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Number per picoliter", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NumberDensity");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-PicoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Counts per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CountRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NUM-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "#/a",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Number per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CountRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-YR");
  config.units.set("http://qudt.org/vocab/unit/NUM-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "nA",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanoampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/NanoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nA/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanoampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "nBq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("NanoBecquerel", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/NanoBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoBQ-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nBq/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanobecquerels per litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoBQ-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "nC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("NanoCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/NanoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "nF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Nanofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/NanoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoFARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nF/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanofarad per Meter", "en-US"));
  unit.addLabel(new LangString("Nanofarad per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/NanoFARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "ng",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/NanoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Nanogram per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.1574074E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/(cm²·day)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Square Centimeter Day", "en-US"));
  unit.addLabel(new LangString("Nanogram per Square Centimetre Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1.15740740740741E-17"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/dL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Decilitre", "en-US"));
  unit.addLabel(new LangString("Nanogram per Decilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-DeciL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/Kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Liter", "nl"));
  unit.addLabel(new LangString("Nanogram per Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg/(m²·s·Pa)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Nanogram per Square Metre Pascal Second", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPermeance");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Cubic Metre", "en"));
  unit.addLabel(new LangString("Nanogram per Cubic Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/µL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Microlitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-MicroL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ng/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanogram per Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/NanoGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("NanoGRAY", undefined));
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nGy/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanogray per hour", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nGy/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanogray per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nGy/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanogray per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoGRAY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "nH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Nanohenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/H_Ab");
  config.units.set("http://qudt.org/vocab/unit/NanoH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoH-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nH/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Nanohenry per Metre", "en"));
  unit.addLabel(new LangString("Nanohenry per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permeability");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoH-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "nJ",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanojoule", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LevelWidth");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanojoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/NanoJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoKAT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("NanoKAT", undefined));
  config.units.set("http://qudt.org/vocab/unit/NanoKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanokatal per Liter", "en-US"));
  unit.addLabel(new LangString("Nanokatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "nL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanolitre", "en-US"));
  unit.addLabel(new LangString("Nanolitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/NanoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "nm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanometer", "en-US"));
  unit.addLabel(new LangString("Nanometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nm/(cm·MPa)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanometer per Centimeter Megapascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.45037738E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nm/(cm·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Nanometer per Centimeter PSI", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nm/(mm·MPa)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Nanometer per Millimeter Megapascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/BREWSTER");
  config.units.set("http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("1E-18"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    undefined,
    undefined,
    "nm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Nanometer", "en-US"));
  unit.addLabel(new LangString("Square Nanometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "nmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("NanoMole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.77777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(cm³·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per cubic centimetre hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(g·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per gram second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.15740740740741E-11"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(L·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per litre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.77777777777778E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(L·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per litre hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.15740740740741E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(m²·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per square metre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T-1D0",
    new Decimal("0.000277777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(µg·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per microgram hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/µmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per micromole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.15740740740741E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nmol/(µmol·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Nanomoles per micromole day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoN",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("NanoN", undefined));
  config.units.set("http://qudt.org/vocab/unit/NanoN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nN·m/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanonewton metre per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/NanoN-M-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "nΩ",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanoohm", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricalResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoOHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nΩ·m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanoohm metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/NanoOHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "nS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("NanoSiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  config.units.set("http://qudt.org/vocab/unit/NanoS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoS-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nS/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Nanosiemens per Centimetre", "en"));
  unit.addLabel(new LangString("Nanosiemens per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/NanoS-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Nanosiemens per Metre", "en"));
  unit.addLabel(new LangString("Nanosiemens per Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/NanoS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ns",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("nanosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/NanoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("NanoSV", undefined));
  config.units.set("http://qudt.org/vocab/unit/NanoSV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nSv/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanosievert per hour", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoSV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nSv/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanosievert per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoSV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nSv/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanosievert per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/NanoSV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/T",
    undefined,
    "nT",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Nanotesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "nV",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanovolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/NanoV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanovolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/NanoV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "nV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanovolt ampere reactive", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/NanoV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    "http://qudt.org/vocab/prefix/Nano",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "nW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Nanowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/NanoW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/NanoW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "nW/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("nanowatt per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PoyntingVector");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/NanoW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OCT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "octave",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Oct", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/OCT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OCTET",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "o",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("octet", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/OCTET", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OCTET-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "o/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("octet per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BitRate");
  config.units.set("http://qudt.org/vocab/unit/OCTET-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OERSTED",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    new Decimal("79.5774715"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-PER-M",
    undefined,
    "Oe",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Oersted", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.units.set("http://qudt.org/vocab/unit/OERSTED", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OERSTED-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("0.795774715"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Oe·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Oersted Centimetre", "en"));
  unit.addLabel(new LangString("Oersted Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  config.units.set("http://qudt.org/vocab/unit/OERSTED-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("ohm", "en"));
  unit.addLabel(new LangString("ohmio", "es"));
  unit.addLabel(new LangString("ohm", "pt"));
  unit.addLabel(new LangString("ohm", "ms"));
  unit.addLabel(new LangString("ohm", "cs"));
  unit.addLabel(new LangString("Ohm", "de"));
  unit.addLabel(new LangString("ohm", "it"));
  unit.addLabel(new LangString("ohm", "fr"));
  unit.addLabel(new LangString("欧姆", "zh"));
  unit.addLabel(new LangString("ohm", "hu"));
  unit.addLabel(new LangString("ओह्म", "hi"));
  unit.addLabel(new LangString("أوم", "ar"));
  unit.addLabel(new LangString("ohm", "sl"));
  unit.addLabel(new LangString("اهم", "fa"));
  unit.addLabel(new LangString("ohmium", "la"));
  unit.addLabel(new LangString("אוהם", "he"));
  unit.addLabel(new LangString("ом", "ru"));
  unit.addLabel(new LangString("オーム", "ja"));
  unit.addLabel(new LangString("ом", "bg"));
  unit.addLabel(new LangString("ωμ", "el"));
  unit.addLabel(new LangString("om", "pl"));
  unit.addLabel(new LangString("ohm", "ro"));
  unit.addLabel(new LangString("ohm", "tr"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Impedance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfImpedance"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reactance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·cm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Ohm Centimetre", "en"));
  unit.addLabel(new LangString("Ohm Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·km",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ohm kilometre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("ohm-mètre", "fr"));
  unit.addLabel(new LangString("ओह्म मीटर", "hi"));
  unit.addLabel(new LangString("ohm-metro", "pt"));
  unit.addLabel(new LangString("أوم متر", "ar"));
  unit.addLabel(new LangString("Ohmmeter", "de"));
  unit.addLabel(new LangString("ohmio metro", "es"));
  unit.addLabel(new LangString("Ohm Meter", "en-US"));
  unit.addLabel(new LangString("欧姆米", "zh"));
  unit.addLabel(new LangString("ohm metre", "tr"));
  unit.addLabel(new LangString("ом-метр", "ru"));
  unit.addLabel(new LangString("ohm per metro", "it"));
  unit.addLabel(new LangString("اهم متر", "fa"));
  unit.addLabel(new LangString("ohm metre", "en"));
  unit.addLabel(new LangString("ohm metr", "cs"));
  unit.addLabel(new LangString("ohm meter", "ms"));
  unit.addLabel(new LangString("オームメートル", "ja"));
  unit.addLabel(new LangString("ohm-metru", "ro"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-M2-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·m²/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Ohm Square Meter per Meter", "en-US"));
  unit.addLabel(new LangString("Ohm Square Metre per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM-M2-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M0H0T-1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ohm per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ohm per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/km",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ohm per kilometre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ohm per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM-PER-MI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    new Decimal("0.0006213712"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω/mi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ohm per mile", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearResistance"
  );
  config.units.set("http://qudt.org/vocab/unit/OHM-PER-MI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "abΩ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/OHM_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_CIRC",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("OHM_CIRC", undefined));
  config.units.set("http://qudt.org/vocab/unit/OHM_CIRC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Ω·cmil/ft",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ohm circular mil per foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistivity");
  config.units.set("http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OHM_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("898760000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "statΩ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/OHM_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ONE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "one",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("one", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/ONE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ONE-PER-ONE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/1",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("one per one", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Ratio");
  config.units.set("http://qudt.org/vocab/unit/ONE-PER-ONE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.028349523125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ_M");
  config.units.set("http://qudt.org/vocab/unit/OZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.0086409"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "4185008.37001674003348006696013391967054969619939239878479756959513918331297668"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(lb/(ft·h))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce foot hour per cubic inch pound", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "1162.5023250046500093000186000371999084860267220534441068882137764275509202713"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(lb/(ft·s))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce foot second per cubic inch pound", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "36.1316752166621861189380447919115019472637943032352378395448512952533951671309544"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(lbf·s/ft²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "ounce square foot per cubic inch pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "219938987.18776172506694249178957458290568644187608087388655521718664498878165"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(ft³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce hour per cubic inch cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "1369963762.2210959898659928577066453306815803233918044992564139962693935984065"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(gal (UK)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce hour per cubic inch gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "1645257878.1837760212799853931272070770270963403487166774326507185648524626875"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(gal (US)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce hour per cubic inch gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "8145888.41436154537284972191813238826881590685721646580623302553040761112231"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(yd³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce hour per cubic inch cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("380054569860.45226091567662581238487547724575"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(in³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "ounce hour per power of inch with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-HR-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    new Decimal("0.000720077887375"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LengthMass");
  config.units.set("http://qudt.org/vocab/unit/OZ-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal(
      "0.25091441122682073693706975549938543018933190488357804055239480066148191088285385"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(lbf·s/in²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "ounce square inch per cubic inch pound-force second",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "3665649.7864626954177823748631595763817614406979346812314425869531107498130275"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(ft³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce minute per cubic inch cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "22832729.370351599831099880961777422178026338723196741654273566604489893306775"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz·min/(in³·gal (UK))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce minute per cubic inch gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "27420964.636396267021333089885453451283784939005811944623877511976080874378125"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(gal (US)/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce minute per cubic inch gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "135764.8069060257562141620319688731378135984476202744301038837588401268520385"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(yd³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce minute per cubic inch cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("6334242831.0075376819279437635397479246207625"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(in³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "ounce minute per power of inch with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-MIN-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("3.2812E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.305151727"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/ft²{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Mass Ounce per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-GAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("6.23602329"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/gal{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Mass Ounce per Gallon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-GAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("6.23602329"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/gal{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) per Gallon (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ-PER-GAL");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("7.48915170730603928399457848784464"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/gal{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) per Gallon (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00000787487"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("43.94184872744745489490978981957964"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/in²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce (avoirdupois) per square inch", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SurfaceDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeanMassRange");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BodyMassIndex");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1729.99404"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Mass Ounce per Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.000472492"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.02834952"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-YD2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.0339057474748823"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/yd³{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Mass Ounce per Square Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-YD2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("0.0370798"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (avoirdupois) per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/OZ-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "61094.163107711590296372914385992939696024011632244687190709782551845830217125"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(ft³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce second per cubic inch cubic foot", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "380545.48950585999718499801602962370296710564538661236090455944340816488844625"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(gal (UK)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce second per cubic inch gallon (UK)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "457016.07727327111702221816475755752139641565009686574373129186626801457296875"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(gal (US)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce second per cubic inch gallon (US)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal(
      "2262.746781767095936902700532814552296893307460337907168398062647335447533975"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(yd³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ounce second per cubic inch cubic yard", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN6",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-6I0M1H0T1D0",
    new Decimal("105570713.850125628032132396058995798743679375"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(oz/in³)/(in³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "ounce second per power of inch with the exponent 6",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/OZ-SEC-PER-IN6", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.278013875"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "ozf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Ounce Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/OZ_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_F-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.007061552425"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ozf·in",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Ounce Force Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/OZ_F-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_F-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("16965.44756278488934930625766763345"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ozf/in³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ounce of force per cubic inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificWeight");
  config.units.set("http://qudt.org/vocab/unit/OZ_F-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.028349523125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "oz",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/OZ");
  config.units.set("http://qudt.org/vocab/unit/OZ_M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_TROY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.0311034768"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "oz{Troy}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ounce Troy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/OZ_TROY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0000284130625"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "oz{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Fluid Ounce (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.288548900462962962962962962962962E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (UK Fluid) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("7.892517361111111111111111111111112E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (UK Fluid) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.735510416666666666666666666666668E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (UK Fluid) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0000284"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ounce (UK Fluid) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0000295735296"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "fl oz{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Liquid Ounce", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.42286E-10"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ounce (US Fluid) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("8.214869E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ounce (US Fluid) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("4.92892E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ounce (US Fluid) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0000295735296"),
    undefined,
    undefined,
    undefined,
    undefined,
    "fl oz{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ounce (US Fluid) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/P",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00980665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "p",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pond", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/P", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("pascal", "es"));
  unit.addLabel(new LangString("pascal", "hu"));
  unit.addLabel(new LangString("pascal", "fr"));
  unit.addLabel(new LangString("pascal", "it"));
  unit.addLabel(new LangString("帕斯卡", "zh"));
  unit.addLabel(new LangString("πασκάλ", "el"));
  unit.addLabel(new LangString("pascal", "cs"));
  unit.addLabel(new LangString("паскаль", "ru"));
  unit.addLabel(new LangString("pascalium", "la"));
  unit.addLabel(new LangString("پاسگال", "fa"));
  unit.addLabel(new LangString("פסקל", "he"));
  unit.addLabel(new LangString("Pascal", "de"));
  unit.addLabel(new LangString("pascal", "sl"));
  unit.addLabel(new LangString("باسكال", "ar"));
  unit.addLabel(new LangString("paskal", "pl"));
  unit.addLabel(new LangString("pascal", "tr"));
  unit.addLabel(new LangString("pascal", "ro"));
  unit.addLabel(new LangString("पास्कल", "hi"));
  unit.addLabel(new LangString("pascal", "ms"));
  unit.addLabel(new LangString("pascal", "pt"));
  unit.addLabel(new LangString("パスカル", "ja"));
  unit.addLabel(new LangString("pascal", "en"));
  unit.addLabel(new LangString("паскал", "bg"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BulkModulus");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fugacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-PER-M2");
  config.units.set("http://qudt.org/vocab/unit/PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·L/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal Liter per Second", "en-US"));
  unit.addLabel(new LangString("Pascal Litre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PA-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal metres", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal metres per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-M-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal metres per square second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-M-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M0dot5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa√m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal Square Root Meter", "en-US"));
  unit.addLabel(new LangString("Pascal Square Root Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-M0dot5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M0pt5",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa√m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal Square Root Meter", "en-US"));
  unit.addLabel(new LangString("Pascal Square Root Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-M0pt5", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/(kg/m²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pascal square metre per kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BurstFactor");
  config.units.set("http://qudt.org/vocab/unit/PA-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·m³/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal Cubic Meter per Second", "en-US"));
  unit.addLabel(new LangString("Pascal Cubic Metre per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PA-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Pascal per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/PA-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.000277777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Pascal per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal per Metre", "en"));
  unit.addLabel(new LangString("Pascal per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("0.0166666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("pascal-seconde", "fr"));
  unit.addLabel(new LangString("pascal sekunda", "sl"));
  unit.addLabel(new LangString("pascal saniye", "tr"));
  unit.addLabel(new LangString("paskalosekunda", "pl"));
  unit.addLabel(new LangString("pascal-secundă", "ro"));
  unit.addLabel(new LangString("pascal segundo", "es"));
  unit.addLabel(new LangString("Pascalsekunde", "de"));
  unit.addLabel(new LangString("pascal per secondo", "it"));
  unit.addLabel(new LangString("pascal-segundo", "pt"));
  unit.addLabel(new LangString("pascal sekunda", "cs"));
  unit.addLabel(new LangString("باسكال ثانية", "ar"));
  unit.addLabel(new LangString("نیوتون ثانیه", "fa"));
  unit.addLabel(new LangString("帕斯卡秒", "zh"));
  unit.addLabel(new LangString("パスカル秒", "ja"));
  unit.addLabel(new LangString("pascal second", "en"));
  unit.addLabel(new LangString("pascal saat", "ms"));
  unit.addLabel(new LangString("паскаль-секунда", "ru"));
  unit.addLabel(new LangString("पास्कल सैकण्ड", "hi"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Pascal Second per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pascal second per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/l",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pascal second per litre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Pascal Second per Metre", "en"));
  unit.addLabel(new LangString("Pascal Second per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa·s/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("pascal saat per meter kubik", "ms"));
  unit.addLabel(new LangString("パスカル秒毎立方メートル", "ja"));
  unit.addLabel(new LangString("باسكال ثانية لكل متر مكعب", "ar"));
  unit.addLabel(new LangString("pascal sekunda na metr krychlový", "cs"));
  unit.addLabel(new LangString("نیوتون ثانیه بر متر مکعب", "fa"));
  unit.addLabel(new LangString("pascal-segundo por metro cúbico", "pt"));
  unit.addLabel(new LangString("Pascalsekunde je Kubikmeter", "de"));
  unit.addLabel(new LangString("pascal-seconde par mètre cube", "fr"));
  unit.addLabel(new LangString("Pascal Second per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("paskalosekunda na metr sześcienny", "pl"));
  unit.addLabel(new LangString("pascal per secondo al metro cubo", "it"));
  unit.addLabel(new LangString("pascal-secundă pe metru cub", "ro"));
  unit.addLabel(new LangString("паскаль-секунда на кубический метр", "ru"));
  unit.addLabel(new LangString("पास्कल सैकण्ड प्रति घन मीटर", "hi"));
  unit.addLabel(new LangString("pascal second per cubic metre", "en"));
  unit.addLabel(new LangString("pascal saniye bölü metre küp", "tr"));
  unit.addLabel(new LangString("pascal segundo por metro cúbico", "es"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/PA-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA2-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M2H0T-6D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa²/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square pascal per square second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PA2-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PA2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M2H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa²·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Square Pascal Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SoundExposure");
  config.units.set("http://qudt.org/vocab/unit/PA2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PARSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("30856780000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pc",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Parsec", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PARSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PCA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0042333"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pc",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pica", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PCA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.138254954376"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "pdl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Poundal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/PDL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0421401100938048"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl·ft",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poundal foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/PDL-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("0.0035116758411504"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl·in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poundal inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MomentOfForce");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Torque");
  config.units.set("http://qudt.org/vocab/unit/PDL-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1.48816443"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Poundal per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/PDL-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("5.44310844"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl/in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poundal per inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerLength");
  config.units.set("http://qudt.org/vocab/unit/PDL-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("214.295607874015748031496062992126"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl/in²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poundal per square inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/PDL-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("1.488163943569553805774278215223097"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl/ft²)·s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poundal second per square foot", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/PDL-SEC-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("214.295607874015748031496062992126"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pdl·s/in²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poundal second per square inch", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/PDL-SEC-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-ANGSTROM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("10000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/Å",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Reciprocal Angstrom", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/PER-ANGSTROM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Reciprocal Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  config.units.set("http://qudt.org/vocab/unit/PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Centimeter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  config.units.set("http://qudt.org/vocab/unit/PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/cm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Cubic Centimetre", "en"));
  unit.addLabel(new LangString("Reciprocal Cubic Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.00001157407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/°C",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal degree Celsius", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.799999999999999856000000000000012"),
    undefined,
    undefined,
    undefined,
    undefined,
    "°F⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal degree Fahrenheit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTemperature"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-EV-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-5I0M-1H0T2D0",
    new Decimal("6241509074460762607.776240980930446"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(eV·m³)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("reciprocal electron volt per cubic metre", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-EV-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-EV2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    new Decimal("38956440500000000000000000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/eV²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Square Electron Volt", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseEnergy_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-EV2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("35.31466"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Reciprocal Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-GM");
  config.units.set("http://qudt.org/vocab/unit/PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-GigaEV2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    new Decimal("38956440500000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/GeV²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Reciprocal Square Giga Electron Volt Unit", "en")
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseEnergy_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-GigaEV2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-H",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/H",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Henry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reluctance");
  config.units.set("http://qudt.org/vocab/unit/PER-H", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("39.37007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "in⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Repetency");
  config.units.set("http://qudt.org/vocab/unit/PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1550.0031000062000124000248000496"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/in²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal square inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("61023.76"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/in³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Reciprocal Cubic Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-J",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "J⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal joule", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-J", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-J-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-5I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(J·m³)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Joule Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Joule Cubic Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-J-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-J2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/J²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Square Joule", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseEnergy_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-J2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Reciprocal Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTemperature"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kg⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloGM-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(kg·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal kilogram second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-KiloGM-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloGM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/kg²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Reciprocal Square Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseMass_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-KiloGM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Kilometre", "en"));
  unit.addLabel(new LangString("Reciprocal Kilometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-KiloV-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("2.777777777777777777777777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(kV·A·h)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Kilovolt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-KiloV-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Liter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-L");
  config.units.set("http://qudt.org/vocab/unit/PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("2.20462262184877580722973801345027"),
    undefined,
    undefined,
    undefined,
    undefined,
    "lb⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal pound (avoirdupois)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Metre", "en"));
  unit.addLabel(new LangString("Reciprocal Meter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-M");
  config.units.set("http://qudt.org/vocab/unit/PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Reciprocal Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Reciprocal Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLengthTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·nm)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal metre per nanometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  config.units.set("http://qudt.org/vocab/unit/PER-M-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-NanoM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·nm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal metre nanometre steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-M-NanoM-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal metre per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-M-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal metre per steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-M-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Square Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ParticleFluence");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-M2");
  config.units.set("http://qudt.org/vocab/unit/PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M2-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m²·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Square Meter Second", "en-US"));
  unit.addLabel(new LangString("Reciprocal Square Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/PER-M2-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "m⁻³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  config.units.set("http://qudt.org/vocab/unit/PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(m³·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Cubic Meter Second", "en-US"));
  unit.addLabel(new LangString("Reciprocal Cubic Metre Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ParticleSourceDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MILLE-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.450377E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/ksi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Reciprocal Mille per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  config.units.set("http://qudt.org/vocab/unit/PER-MILLE-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MILLE-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.450377E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/ksi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Reciprocal Mille Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  config.units.set("http://qudt.org/vocab/unit/PER-MILLE-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.91935077E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mo",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Month", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Reciprocal Mole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseAmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MegaK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "/MK",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString(
      "reciprocal megakelvin or megakelvin to the power minus one",
      undefined
    )
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTemperature"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MegaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MegaPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/MPa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal megapascal", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  config.units.set("http://qudt.org/vocab/unit/PER-MegaPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MicroM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/µm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Micrometre", "en"));
  unit.addLabel(new LangString("Reciprocal Micrometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MicroM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MicroMOL-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(µmol·L)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Reciprocal micromole per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-MicroMOL-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "mg⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal milligram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-MilliGM");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Milliliter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Millimetre", "en"));
  unit.addLabel(new LangString("Reciprocal Millimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mm³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Cubic Millimeter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Cubic Millimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-MilliM3");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-MilliSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/ms",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal millisecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-MilliSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/nm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Nanometre", "en"));
  unit.addLabel(new LangString("Reciprocal Nanometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-OZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("35.27396194958041291567580821520433"),
    undefined,
    undefined,
    undefined,
    undefined,
    "oz⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal ounce (avoirdupois)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-OZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pa⁻¹",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Pascal", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  config.units.set("http://qudt.org/vocab/unit/PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(Pa·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Pascal per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PERCENT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/%",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal percent", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-PERCENT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("0.0001450377"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/psi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Reciprocal Psi", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InversePressure");
  config.units.set("http://qudt.org/vocab/unit/PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PicoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/pm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Picometer", "en-US"));
  unit.addLabel(new LangString("Reciprocal Picometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseLength");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearIonization"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-PicoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-PlanckMass2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    new Decimal("2111089000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/mₚ²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Inverse Square Planck Mass", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseMass_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-PlanckMass2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal radian", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/HZ");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/SAMPLE-PER-SEC");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s⁻¹·m⁻²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Second Square Meter", "en-US"));
  unit.addLabel(new LangString("Reciprocal Second Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Flux");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(s·m²·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Reciprocal Second Square Metre Steradian", "en")
  );
  unit.addLabel(
    new LangString("Reciprocal Second Square Meter Steradian", "en-US")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PhotonRadiance");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s⁻¹·m⁻³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal second per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/s·sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Second Steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PhotonIntensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemporalSummationFunction"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC-SR-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s⁻¹·sr⁻¹·m⁻²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("reciprocal second per steradian square metre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-SEC-SR-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal square second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTime_Squared"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Reciprocal steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-T-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(T·m)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Tesla Metre", "en"));
  unit.addLabel(new LangString("Reciprocal Tesla Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-T-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-T-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/(T·s)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Tesla Second Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-T-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-TON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("0.001102311310924387903614869006725135"),
    undefined,
    undefined,
    undefined,
    undefined,
    "st⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal ton", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-TON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-TONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal tonne", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseMass");
  config.units.set("http://qudt.org/vocab/unit/PER-TONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V⁻¹",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal volt", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ReciprocalVoltage"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-V-A-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/VAs",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("reciprocal volt ampere second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseEnergy");
  config.units.set("http://qudt.org/vocab/unit/PER-V-A-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-WB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/Wb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Weber", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux"
  );
  config.units.set("http://qudt.org/vocab/unit/PER-WB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000001653439"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/wk",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PER-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1.307951"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Reciprocal Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/InverseVolume");
  config.units.set("http://qudt.org/vocab/unit/PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895023702689684893655E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Reciprocal Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  config.units.set("http://qudt.org/vocab/unit/PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Percent", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TimePercentage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeLuminousFlux"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthPercentage"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressurePercentage"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/OpeningRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Prevalence");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reflectance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VoltagePercentage"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResistancePercentage"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("24.19088310502224717757046927398712"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(lb/(ft·h))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("percent foot hour per pound (avoirdupois)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.006719689751395068660436241464996423"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(lb/(ft·s))",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("percent foot second per pound (avoirdupois)", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.0002088543329607266931093922420396694"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(lbf·s/ft²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("percent square foot per pound-force second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fluidity");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(cm³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per cubic centimetre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("1271.328001973589249015768372744095"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(ft³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per cubic foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("7918.892938767160350982932586024475"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(gal (UK)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per gallon (UK)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("9510.19388489334295367639717792985"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(gal (US)/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per gallon (US)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("2196854.787410362222299247748101795"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(in³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per cubic inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(l/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per litre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(m³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per cubic metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("47.08622229531812033391734713867015"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(yd³/h)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent hour per cubic yard", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.000001450377312227268702148557236386593"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(lbf·s/in²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("percent square inch per pound-force second", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fluidity");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(cm³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("percent minute per cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("21.18880003289315415026280621240158"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(ft³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent minute per cubic foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("131.9815489794526725163822097670746"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(gal (UK)/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent minute per gallon (UK)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("158.5032314148890492279399529654975"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(gal (US)/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent minute per gallon (US)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("36614.24645683937037165412913502992"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(in³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent minute per cubic inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(l/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent minute per litre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.6"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(m³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent minute per cubic metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.7847703715886353388986224523111692"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(yd³/min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent minute per cubic yard", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100k",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per one hundred thousand", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCount"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/10k",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per ten thousand", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCount");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/cP",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per centipoise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.157407407407407407407407407407407E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/day",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Percent per day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.5729577957855229894302178227976183"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/°",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per degree", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DEG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEGREE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "%/°",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per degree", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DEGREE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/°C",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per degree Celsius", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per hundred", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DecaCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/daK",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per decakelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-DecaK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/10000",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per ten thousand", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount");
  config.units.set(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCount",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.000002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Percent per hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/hbar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per hectobar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Compressibility");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/100k",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per one hundred thousand", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount");
  config.units.set(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCount",
    unit
  );
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.3937007874015748031496062992125984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Repetency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-KiloCount",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/1000",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per thousand", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-KiloCount", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Percent per metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.919350772901616281311709002114104E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/mo",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per month", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/mm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per millimetre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Repetency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(mPa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per millipascal second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-OHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/Ω",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per ohm", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-OHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(Pa·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per pascal second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-PERCENT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/%",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per percent", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-PERCENT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/P",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per poise", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/V",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent per volt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.653439153439153439153439153439153E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/wk",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Percent per week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("3.168808781402895E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/a",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Percent per Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(cm³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("percent second per cubic centimetre", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.3531466672148859025043801035400263"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(ft³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent second per cubic foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("2.199692482990877875273036829451243"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(gal (UK)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent second per gallon (UK)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("2.641720523581484153798999216091625"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(gal (US)/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent second per gallon (US)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("610.2374409473228395275688189171654"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(in³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent second per cubic inch", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("10.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(l/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent second per litre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(m³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent second per cubic metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("0.01307950619314392231497704087185282"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%/(yd³/s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("percent second per cubic yard", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERCENT_RH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "%RH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Percent Relative Humidity", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity"
  );
  config.units.set("http://qudt.org/vocab/unit/PERCENT_RH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERMEABILITY_EM_REL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "μₜ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU"]
  );
  unit.addLabel(new LangString("Relative Electromagnetic Permeability", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeabilityRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PERMEABILITY_EM_REL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERMEABILITY_REL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.00000125663706"),
    undefined,
    undefined,
    undefined,
    undefined,
    "kᵣ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU"]
  );
  unit.addLabel(new LangString("Relative Permeability", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PermeabilityRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PERMEABILITY_REL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("8.854187817E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "εᵣ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Relative Permittivity", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PERMITTIVITY_REL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_0DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (0 °C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("perm (0 °C)", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/WaterVapourPermeability"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PERM_Metric_0DEG_C");
  config.units.set("http://qudt.org/vocab/unit/PERM_0DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_23DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (23 °C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("perm (23 °C)", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/WaterVapourPermeability"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PERM_Metric_23DEG_C");
  config.units.set("http://qudt.org/vocab/unit/PERM_23DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("8.68127E-11"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC-PER-M",
    undefined,
    "perm{Metric}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Metric Perm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_Metric_0DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (0 °C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("perm (0 °C)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPermeance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PERM_0DEG_C");
  config.units.set("http://qudt.org/vocab/unit/PERM_Metric_0DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_Metric_23DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "perm (23 °C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("perm (23 °C)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPermeance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PERM_23DEG_C");
  config.units.set("http://qudt.org/vocab/unit/PERM_Metric_23DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PERM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("5.72135E-11"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC-PER-M",
    undefined,
    "perm{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("U.S. Perm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPermeance");
  config.units.set("http://qudt.org/vocab/unit/PERM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PFERDESTAERKE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PS",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pferdestaerke", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PFERDESTAERKE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PFUND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "pfd",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pfund", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/PFUND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "pH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Acidity", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Basicity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acidity");
  config.units.set("http://qudt.org/vocab/unit/PH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PHON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "phon",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("phon", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel"
  );
  config.units.set("http://qudt.org/vocab/unit/PHON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PHOT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    "ph",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Phot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.units.set("http://qudt.org/vocab/unit/PHOT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00056826125"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "pt",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Imperial Pint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PINT_UK");
  config.units.set("http://qudt.org/vocab/unit/PINT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00056826125"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pint (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PINT");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("6.577098E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pint (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.578504E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pint (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000009471022"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pint (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0005682613"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Pint (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0004731765"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Liquid Pint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  config.units.set("http://qudt.org/vocab/unit/PINT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("5.47658E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Pint (US Liquid) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.314379E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Pint (US Liquid) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000007886275"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Pint (US Liquid) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0004731765"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pt{US}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Pint (US Liquid) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PINT_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PINT_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000550610471"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "pt{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Dry Pint", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/PINT_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PIXEL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "pixel",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pixel", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PictureElement");
  config.units.set("http://qudt.org/vocab/unit/PIXEL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.009092181"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "peck{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Peck (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/PK_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.05233576E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Peck (UK) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000002525605833"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Peck (UK) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00015153635"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Peck (UK) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.009092181"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Peck (UK) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00880976754"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "peck{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Peck", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.01964902E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Peck (US Dry) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000002447157651"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Peck (US Dry) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000146829459067"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Peck (US Dry) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00880976754"),
    undefined,
    undefined,
    undefined,
    undefined,
    "peck{US Dry}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Peck (US Dry) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC",
    undefined,
    "P",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-GAUSS", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Poise", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/POISE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "P/bar",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Poise per Bar", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/POISE-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "P/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poise per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/POISE-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POISE-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "P/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("poise per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/POISE-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/POND",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("0.00980665"),
    undefined,
    undefined,
    undefined,
    undefined,
    "p",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pond", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/POND", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Parts per billion", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PPB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPM",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Parts per million", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PPM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPM/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Parts-Per-Million per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PPM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-16"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ppq",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("part per quadrillion", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PPQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ppt",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("part per trillion", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PPT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "‰",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Parts per thousand", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PPTH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTH-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("2.77777777777778E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "‰/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Parts-per-thousand per hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PPTH-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPTM",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Parts per Ten Million", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PPTM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTM-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    new Decimal("1E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPTM/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Parts-Per-Ten Million per Kelvin", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExpansionRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/PPTM-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PPTR",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Parts per trillion", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PPTR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PPTR_VOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pptr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Parts per trillion by volume", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PPTR_VOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("6894.75789"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("PSI", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  config.units.set("http://qudt.org/vocab/unit/PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("0.1129848"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·in³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Psi Cubic Inch per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-IN3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-L-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("6.894757"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·L/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Psi Litre per Second", "en"));
  unit.addLabel(new LangString("Psi Liter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-L-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("6894.757"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·m³/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("PSI Cubic Metre per Second", "en"));
  unit.addLabel(new LangString("PSI Cubic Meter per Second", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-M3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("271447.1497054715109430218860437721"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi/in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("psi per inch", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/PSI-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi/psi",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Psi per Psi", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PressureRatio");
  config.units.set("http://qudt.org/vocab/unit/PSI-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("5271.42"),
    undefined,
    undefined,
    undefined,
    undefined,
    "psi·yd³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Psi Cubic Yard per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PSI-YD3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PSU",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PSU",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Practical Salinity Unit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.units.set("http://qudt.org/vocab/unit/PSU", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0000254"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pt",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Point", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PT_BIG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.0003527778"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pb",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("big point", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Distance");
  config.units.set("http://qudt.org/vocab/unit/PT_BIG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("PebiBIT", undefined));
  config.units.set("http://qudt.org/vocab/unit/PebiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1125899906842624.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pibit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pebibit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PebiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1125899906842620.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pibit/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pebibit per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/PebiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1125899906842620.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pibit/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("pebibit per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PebiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PebiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("698137323685796.7335433103621932049"),
    undefined,
    "http://qudt.org/vocab/prefix/Pebi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "PiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("PebiByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/PebiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Pennyweight",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.00155517384"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "dwt",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Pennyweight", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/DWT");
  config.units.set("http://qudt.org/vocab/unit/Pennyweight", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "PA",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petaampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/PetaA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147180559945.2"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Pbit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petabit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/PetaBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147180559945.30941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Pbit/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petabit per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/PetaBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "PBq",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petabecquerel", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/PetaBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444479562.4753378569716654"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "PB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("PetaByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/PetaBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "PC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("PetaCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/PetaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PFLOPS",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("petafloating point operations per second", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/PetaFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "PHz",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petahertz", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PetaHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "PJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Petajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/PetaJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "PJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petajoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PetaJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaV",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("PetaV", undefined));
  config.units.set("http://qudt.org/vocab/unit/PetaV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "PV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petavolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/PetaV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PetaW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Peta",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "PW",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("petawatt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PetaW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "pA",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("picoampere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/PicoA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoA-PER-HectoPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M-1H0T2D0",
    new Decimal("1E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pA/hPa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("picoampere per hectopascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoA-PER-HectoPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E1L-3I0M0H0T0D0",
    new Decimal("0.001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pA/(µmol·L)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picoamps per micromole litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "pC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("PicoCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/PicoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoFARAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/FARAD",
    undefined,
    "pF",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Picofarad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Capacitance");
  config.units.set("http://qudt.org/vocab/unit/PicoFARAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoFARAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pF/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picofarad per Meter", "en-US"));
  unit.addLabel(new LangString("Picofarad per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Permittivity");
  config.units.set("http://qudt.org/vocab/unit/PicoFARAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/GM",
    undefined,
    "pg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picograms", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/PicoGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picograms per gram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picograms per kilogram", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassRatio");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/L",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picograms per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pg/mL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picograms per millilitre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassConcentration"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/PicoGM-PER-MilliL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/H",
    undefined,
    "pH",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Picohenry", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Inductance");
  config.units.set("http://qudt.org/vocab/unit/PicoH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "pJ",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("picojoule", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LevelWidth");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("picojoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PicoJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoKAT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("PicoKAT", undefined));
  config.units.set("http://qudt.org/vocab/unit/PicoKAT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoKAT-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pkat/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picokatal per Liter", "en-US"));
  unit.addLabel(new LangString("Picokatal per Litre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoKAT-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1E-15"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/L",
    undefined,
    "pL",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picolitre", "en"));
  unit.addLabel(new LangString("Picolitre", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/PicoL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/M",
    undefined,
    "pm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picometre", "en"));
  unit.addLabel(new LangString("Picometer", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PicoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/MOL",
    undefined,
    "pmol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("PicoMole", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/kg",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/L",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1.15740740740741E-14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(L·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per litre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("2.77777777777778E-13"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(L·h)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per litre hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-L-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M-1H0T2D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(m·W·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per metre watt second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    new Decimal("1.15740740740741E-17"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(m²·day)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per square metre day", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/m³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per cubic metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Concentration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Solubility_Water"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pmol/(m³·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Picomoles per cubic metre second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoPA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "pPa",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("PicoPascal", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BulkModulus");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fugacity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ShearModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/PicoPA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoPA-PER-KiloM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("1E-15"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pPa/km",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picopascal per Kilometer", "en-US"));
  unit.addLabel(new LangString("Picopascal per Kilometre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoPA-PER-KiloM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/S",
    undefined,
    "pS",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("PicoSiemens", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoS-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pS/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Picosiemens per Meter", "en-US"));
  unit.addLabel(new LangString("Picosiemens per Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/PicoS-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "ps",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Picosecond", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/PicoSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "pV",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("picovolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/PicoV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("picovolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/PicoV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "pV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("picovolt ampere reactive", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/PicoV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    "http://qudt.org/vocab/prefix/Pico",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "pW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Picowatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PicoW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T-3D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pW/(cm²·L)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picowatts per square centimetre litre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PicoW-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1E-12"),
    undefined,
    undefined,
    undefined,
    undefined,
    "pW/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Picowatt per Square Meter", "en-US"));
  unit.addLabel(new LangString("Picowatt per Square Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/PicoW-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckArea",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("2.61223E-71"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2",
    undefined,
    "planckarea",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Area", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/PlanckArea", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckCharge",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1.87554587E-18"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-SEC",
    undefined,
    "planckcharge",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Charge", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/PlanckCharge", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckCurrent",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("34789000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A",
    undefined,
    "planckcurrent",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Current", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  config.units.set("http://qudt.org/vocab/unit/PlanckCurrent", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckCurrentDensity",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    new Decimal(
      "133177400000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
    ),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/A-PER-M2",
    undefined,
    "planckcurrentdensity",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Current Density", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/PlanckCurrentDensity", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckDensity",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal(
      "5155000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
    ),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/GM-PER-DeciM3",
    undefined,
    "planckdensity",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Density", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/PlanckDensity", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckEnergy",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1956100000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "Eᵨ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Energy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/PlanckEnergy", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckForce",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("121027000000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "planckforce",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Force", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/PlanckForce", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckFrequency",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("18548700000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "planckfrequency",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Frequency", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/PlanckFrequency", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("18548000000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "planckangularfrequency",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Planck Angular Frequency", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/PlanckFrequency_Ang", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckImpedance",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("29.9792458"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "Zₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Impedance", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/PlanckImpedance", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckLength",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("1.616252E-35"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "plancklength",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Length", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/PlanckLength", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("2.17644E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "planckmass",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/PlanckMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckMomentum",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    new Decimal("6.52485"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC",
    undefined,
    "planckmomentum",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Momentum", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearMomentum");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Momentum");
  config.units.set("http://qudt.org/vocab/unit/PlanckMomentum", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckPower",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("36283100000000000000000000000000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "planckpower",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Power", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/PlanckPower", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckPressure",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal(
      "463309000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
    ),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2",
    undefined,
    "planckpressure",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Pressure", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/PlanckPressure", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckTemperature",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    new Decimal("141678400000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/DEG_C",
    undefined,
    "plancktemperature",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("PlanckTemperature", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BoilingPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MeltingPoint");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/FlashPoint");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Temperature");
  config.units.set("http://qudt.org/vocab/unit/PlanckTemperature", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckTime",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("5.39124E-49"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "tₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Time", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/PlanckTime", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckVolt",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1042950000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/V",
    undefined,
    "Vₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Volt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/PlanckVolt", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/PlanckVolume",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4.22419E-105"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "l³ₚ",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/PLANCK"]
  );
  unit.addLabel(new LangString("Planck Volume", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/PlanckVolume", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0011365225"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Quart (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/QT_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.31542E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Quart (UK Liquid) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("3.157007E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Quart (UK Liquid) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001894205"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Quart (UK Liquid) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_UK-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0011365225"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{UK}/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Quart (UK Liquid) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_UK-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.000946353"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt{US liq}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Liquid Quart", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LiquidVolume");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/QT_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("1.095316E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Quart (US Liquid) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("2.62875833E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Quart (US Liquid) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00001577255"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Quart (US Liquid) per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.000946353"),
    undefined,
    undefined,
    undefined,
    undefined,
    "qt/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Quart (US Liquid) per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/QT_US-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QT_US_DRY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.001101220942715"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "qt{US Dry}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("US Dry Quart", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DryVolume");
  config.units.set("http://qudt.org/vocab/unit/QT_US_DRY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/QUAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1055000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "quad",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Quad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/QUAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Quarter_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("12.70058636"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "quarter",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Quarter (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/Quarter_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    new Decimal("0.000258"),
    undefined,
    undefined,
    undefined,
    undefined,
    "R",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Roentgen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.units.set("http://qudt.org/vocab/unit/R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/R-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    new Decimal("0.000258"),
    undefined,
    undefined,
    undefined,
    undefined,
    "R/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("roentgen per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ExposureRate");
  config.units.set("http://qudt.org/vocab/unit/R-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("ακτίνιο", "el"));
  unit.addLabel(new LangString("弧度", "zh"));
  unit.addLabel(new LangString("radian", "pl"));
  unit.addLabel(new LangString("radian", "ro"));
  unit.addLabel(new LangString("ラジアン", "ja"));
  unit.addLabel(new LangString("radian", "sl"));
  unit.addLabel(new LangString("radiante", "it"));
  unit.addLabel(new LangString("radyan", "tr"));
  unit.addLabel(new LangString("radiano", "pt"));
  unit.addLabel(new LangString("radian", "la"));
  unit.addLabel(new LangString("radián", "hu"));
  unit.addLabel(new LangString("رادیان", "fa"));
  unit.addLabel(new LangString("radián", "es"));
  unit.addLabel(new LangString("راديان", "ar"));
  unit.addLabel(new LangString("वर्ग मीटर", "hi"));
  unit.addLabel(new LangString("radián", "cs"));
  unit.addLabel(new LangString("רדיאן", "he"));
  unit.addLabel(new LangString("radian", "fr"));
  unit.addLabel(new LangString("radian", "en"));
  unit.addLabel(new LangString("radian", "ms"));
  unit.addLabel(new LangString("Radiant", "de"));
  unit.addLabel(new LangString("радиан", "bg"));
  unit.addLabel(new LangString("радиан", "ru"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad·m²/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Radian Square Meter per Kilogram", "en-US"));
  unit.addLabel(new LangString("Radian Square Metre per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotatoryPower"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-M2-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad·m²/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Radian Square Metre per Mole", "en"));
  unit.addLabel(new LangString("Radian Square Meter per Mole", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotatoryPower"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-M2-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Radian per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("radian per metre", "en"));
  unit.addLabel(new LangString("radiane pe metru", "ro"));
  unit.addLabel(new LangString("प्रति मीटर वर्ग मीटर", "hi"));
  unit.addLabel(new LangString("радиан на метр", "ru"));
  unit.addLabel(new LangString("弧度每米", "zh"));
  unit.addLabel(new LangString("radiano por metro", "pt"));
  unit.addLabel(new LangString("مقياس التبادل، الأس السالب للمتر", "ar"));
  unit.addLabel(new LangString("radián por metro", "es"));
  unit.addLabel(new LangString("radian na metr", "pl"));
  unit.addLabel(new LangString("Radiant je Meter", "de"));
  unit.addLabel(new LangString("ラジアン毎メートル", "ja"));
  unit.addLabel(new LangString("Radian per Meter", "en-US"));
  unit.addLabel(new LangString("radian per meter", "ms"));
  unit.addLabel(new LangString("radiante al metro", "it"));
  unit.addLabel(new LangString("radian par mètre", "fr"));
  unit.addLabel(new LangString("radiánů na metr", "cs"));
  unit.addLabel(new LangString("رادیان بر متر", "fa"));
  unit.addLabel(new LangString("radyan bölü metre", "tr"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Radian per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("radián por segundo", "es"));
  unit.addLabel(new LangString("radian per saat", "ms"));
  unit.addLabel(new LangString("radiano por segundo", "pt"));
  unit.addLabel(new LangString("radyan bölü saniye", "tr"));
  unit.addLabel(new LangString("弧度每秒", "zh"));
  unit.addLabel(new LangString("वर्ग मीटर प्रति सैकिण्ड", "hi"));
  unit.addLabel(new LangString("ラジアン毎秒", "ja"));
  unit.addLabel(new LangString("radiante al secondo", "it"));
  unit.addLabel(new LangString("radian na sekundę", "pl"));
  unit.addLabel(new LangString("Radian je Sekunde", "de"));
  unit.addLabel(new LangString("радиан в секунду", "ru"));
  unit.addLabel(new LangString("radian per second", "en"));
  unit.addLabel(new LangString("رادیان بر ثانیه", "fa"));
  unit.addLabel(new LangString("radián za sekundu", "cs"));
  unit.addLabel(new LangString("راديان في الثانية", "ar"));
  unit.addLabel(new LangString("radian par seconde", "fr"));
  unit.addLabel(new LangString("radian na sekundo", "sl"));
  unit.addLabel(new LangString("radian pe secundă", "ro"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AngularVelocity");
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rad/s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Radian per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/RAD-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAD_R",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2-PER-SEC2",
    undefined,
    "rad",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Rad", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AbsorbedDose");
  config.units.set("http://qudt.org/vocab/unit/RAD_R", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RAYL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC",
    undefined,
    "rayl",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Rayl", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance"
  );
  config.units.set("http://qudt.org/vocab/unit/RAYL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M2-PER-SEC2",
    undefined,
    "rem",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Rem", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/R_man");
  config.units.set("http://qudt.org/vocab/unit/REM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REM-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rem/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("rem per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/REM-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("6.28318531"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Revolution", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PlaneAngle");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Angle");
  config.units.set("http://qudt.org/vocab/unit/REV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.00174532925"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Revolution per Hour", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.01666666666"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Revolution per Minute", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("6.28318531"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Revolution per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/REV-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    new Decimal("6.28318531"),
    undefined,
    undefined,
    undefined,
    undefined,
    "rev/s²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Revolution per Square Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/REV-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RHE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "rhe",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("rhe", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Fluidity");
  config.units.set("http://qudt.org/vocab/unit/RHE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ROD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("5.02921"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M",
    undefined,
    "rod",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Rod", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/ROD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RPK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "RPK",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Reads per Kilobase", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneFamilyAbundance"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/RPK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("2.8316846592"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "RT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Register Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/RT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/R_man",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SV",
    undefined,
    "rem",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("roentgen equivalent man", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/REM");
  config.units.set("http://qudt.org/vocab/unit/R_man", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/RichterMagnitude",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "mag",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Richter magnitude", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EarthquakeMagnitude"
  );
  config.units.set("http://qudt.org/vocab/unit/RichterMagnitude", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("siemens", "en"));
  unit.addLabel(new LangString("סימנס", "he"));
  unit.addLabel(new LangString("ジーメンス", "ja"));
  unit.addLabel(new LangString("simens", "pl"));
  unit.addLabel(new LangString("siemens", "ms"));
  unit.addLabel(new LangString("siemens", "pt"));
  unit.addLabel(new LangString("сименс", "ru"));
  unit.addLabel(new LangString("сименс", "bg"));
  unit.addLabel(new LangString("siemens", "ro"));
  unit.addLabel(new LangString("siemens", "tr"));
  unit.addLabel(new LangString("Siemens", "de"));
  unit.addLabel(new LangString("siemens", "sl"));
  unit.addLabel(new LangString("سيمنز", "ar"));
  unit.addLabel(new LangString("siemens", "la"));
  unit.addLabel(new LangString("ζίμενς", "el"));
  unit.addLabel(new LangString("西门子", "zh"));
  unit.addLabel(new LangString("siemens", "cs"));
  unit.addLabel(new LangString("زیمنس", "fa"));
  unit.addLabel(new LangString("siemens", "hu"));
  unit.addLabel(new LangString("siemens", "es"));
  unit.addLabel(new LangString("siemens", "it"));
  unit.addLabel(new LangString("सीमैन्स", "hi"));
  unit.addLabel(new LangString("siemens", "fr"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Admittance");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MHO");
  config.units.set("http://qudt.org/vocab/unit/S", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S-M2-PER-MOL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A-1E2L0I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S·m²/mol",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Siemens Square metre per mole", "en"));
  unit.addLabel(new LangString("Siemens Square meter per mole", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/S-M2-PER-MOL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Siemens per Centimetre", "en"));
  unit.addLabel(new LangString("Siemens per Centimeter", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  config.units.set("http://qudt.org/vocab/unit/S-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "S/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("siemens per metre", "en"));
  unit.addLabel(new LangString("siemens par mètre", "fr"));
  unit.addLabel(new LangString("simens na metr", "pl"));
  unit.addLabel(new LangString("сименс на метр", "ru"));
  unit.addLabel(new LangString("siemens per meter", "ms"));
  unit.addLabel(new LangString("siemens por metro", "es"));
  unit.addLabel(new LangString("Siemens per Meter", "en-US"));
  unit.addLabel(new LangString("مقياس التبادل، الأس السالب للمتر", "ar"));
  unit.addLabel(new LangString("siemensů na metr", "cs"));
  unit.addLabel(new LangString("प्रति मीटर सीमैन्स", "hi"));
  unit.addLabel(new LangString("siemens na meter", "sl"));
  unit.addLabel(new LangString("siemens por metro", "pt"));
  unit.addLabel(new LangString("ジーメンス毎メートル", "ja"));
  unit.addLabel(new LangString("siemens al metro", "it"));
  unit.addLabel(new LangString("西门子每米", "zh"));
  unit.addLabel(new LangString("siemens bölü metre", "tr"));
  unit.addLabel(new LangString("Siemens je Meter", "de"));
  unit.addLabel(new LangString("زیمنس بر متر", "fa"));
  unit.addLabel(new LangString("siemens pe metru", "ro"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectrolyticConductivity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Conductivity");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC");
  config.units.set("http://qudt.org/vocab/unit/S-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SAMPLE",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("SAMPLE", undefined));
  config.units.set("http://qudt.org/vocab/unit/SAMPLE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "sample/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Sample per second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/SAMPLE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("1.1981"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scf",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Standard Cubic Foot", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/SCF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCF-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.0003328"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scfh",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Standard Cubic Foot per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCF-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCF-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.0199683"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scfm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Standard Cubic Foot per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCF-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    new Decimal("42.3105"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Standard Cubic Metre", "en"));
  unit.addLabel(new LangString("Standard Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.units.set("http://qudt.org/vocab/unit/SCM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.01175"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scmh",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Standard Cubic Meter per Hour", "en-US"));
  unit.addLabel(new LangString("Standard Cubic Metre per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCM-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SCM-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    new Decimal("0.7051738"),
    undefined,
    undefined,
    undefined,
    undefined,
    "scmm",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Standard Cubic Metre per Minute", "en"));
  unit.addLabel(new LangString("Standard Cubic Meter per Minute", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MolarFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SCM-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("seconde", "fr"));
  unit.addLabel(new LangString("सैकण्ड", "hi"));
  unit.addLabel(new LangString("saat", "ms"));
  unit.addLabel(new LangString("secundum", "la"));
  unit.addLabel(new LangString("secundă", "ro"));
  unit.addLabel(new LangString("segundo", "pt"));
  unit.addLabel(new LangString("秒", "ja"));
  unit.addLabel(new LangString("ثانیه", "fa"));
  unit.addLabel(new LangString("secondo", "it"));
  unit.addLabel(new LangString("δευτερόλεπτο", "el"));
  unit.addLabel(new LangString("másodperc", "hu"));
  unit.addLabel(new LangString("ثانية", "ar"));
  unit.addLabel(new LangString("segundo", "es"));
  unit.addLabel(new LangString("秒", "zh"));
  unit.addLabel(new LangString("секунда", "bg"));
  unit.addLabel(new LangString("sekunda", "cs"));
  unit.addLabel(new LangString("секунда", "ru"));
  unit.addLabel(new LangString("saniye", "tr"));
  unit.addLabel(new LangString("sekunda", "pl"));
  unit.addLabel(new LangString("second", "en"));
  unit.addLabel(new LangString("sekunda", "sl"));
  unit.addLabel(new LangString("שנייה", "he"));
  unit.addLabel(new LangString("Sekunde", "de"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Period");
  config.units.set("http://qudt.org/vocab/unit/SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    new Decimal("0.09290304"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s·ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Second Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaTime");
  config.units.set("http://qudt.org/vocab/unit/SEC-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T1D0",
    new Decimal("10.7639104167097223083335055559"),
    undefined,
    undefined,
    undefined,
    undefined,
    "(lb/ft³)/(lb/(ft·s)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("second per square foot", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("second per kilogram", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EinsteinCoefficients"
  );
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Seconds per metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-M3-RAD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/(m³·rad)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("second per cubic metre radian", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpectralDensityOfVibrationalModes"
  );
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-M3-RAD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC-PER-RAD-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s/(rad·m³)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Second per Radian Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Second per Radian Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DensityOfStates");
  config.units.set("http://qudt.org/vocab/unit/SEC-PER-RAD-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "s²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Square Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time_Squared");
  config.units.set("http://qudt.org/vocab/unit/SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SH",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "shake",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Shake", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/SH", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SHANNON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sh",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Shannon", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/SHANNON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SHANNON-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.69314718055994530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sh/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Shannon per Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.units.set("http://qudt.org/vocab/unit/SHANNON-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("14.593903"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/SLUG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00016891087963"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("47.8802591863517"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/ft",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    new Decimal("47.8802591863517"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/(ft·s)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Foot Second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("157.08746452215124"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-FT3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("515.3788206107324"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/ft³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Cubic Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-FT3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.004053861111111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.243231666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SLUG-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("14.593903"),
    undefined,
    undefined,
    undefined,
    undefined,
    "slug/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Slug per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/SLUG-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "sone",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("sone", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SPF",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "SPF",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("sun protection factor", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SunProtectionFactorOfAProduct"
  );
  config.units.set("http://qudt.org/vocab/unit/SPF", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Q",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("spin quantum number", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("steradian", "sl"));
  unit.addLabel(new LangString("घन मीटर", "hi"));
  unit.addLabel(new LangString("szteradián", "hu"));
  unit.addLabel(new LangString("steradian", "la"));
  unit.addLabel(new LangString("esterradiano", "pt"));
  unit.addLabel(new LangString("стерадиан", "bg"));
  unit.addLabel(new LangString("球面度", "zh"));
  unit.addLabel(new LangString("steradiante", "it"));
  unit.addLabel(new LangString("ستراديان", "ar"));
  unit.addLabel(new LangString("steradian", "ro"));
  unit.addLabel(new LangString("steradian", "pl"));
  unit.addLabel(new LangString("steradian", "en"));
  unit.addLabel(new LangString("estereorradián", "es"));
  unit.addLabel(new LangString("stéradian", "fr"));
  unit.addLabel(new LangString("استرادیان", "fa"));
  unit.addLabel(new LangString("стерадиан", "ru"));
  unit.addLabel(new LangString("στερακτίνιο", "el"));
  unit.addLabel(new LangString("steradian", "ms"));
  unit.addLabel(new LangString("steradyan", "tr"));
  unit.addLabel(new LangString("Steradiant", "de"));
  unit.addLabel(new LangString("steradián", "cs"));
  unit.addLabel(new LangString("ステラジアン", "ja"));
  unit.addLabel(new LangString("סטרדיאן", "he"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SolidAngle");
  config.units.set("http://qudt.org/vocab/unit/SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Stokes", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity"
  );
  config.units.set("http://qudt.org/vocab/unit/ST", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("1E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("stokes per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/ST-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("stokes per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/ST-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ST-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T1D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "St/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("stokes per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/ST-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/STILB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/CD-PER-M2",
    undefined,
    "sb",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Stilb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Luminance");
  config.units.set("http://qudt.org/vocab/unit/STILB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/STR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "st",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Stere", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/STR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "χ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Electric Susceptibility Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "χ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Magnetic Susceptibility Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  config.units.set("http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("سیورت", "fa"));
  unit.addLabel(new LangString("siwert", "pl"));
  unit.addLabel(new LangString("sievert", "tr"));
  unit.addLabel(new LangString("sievert", "ro"));
  unit.addLabel(new LangString("زيفرت", "ar"));
  unit.addLabel(new LangString("sievertum", "la"));
  unit.addLabel(new LangString("сиверт", "bg"));
  unit.addLabel(new LangString("sievert", "sl"));
  unit.addLabel(new LangString("sievert", "cs"));
  unit.addLabel(new LangString("зиверт", "ru"));
  unit.addLabel(new LangString("sievert", "fr"));
  unit.addLabel(new LangString("sievert", "it"));
  unit.addLabel(new LangString("sievert", "es"));
  unit.addLabel(new LangString("sievert", "hu"));
  unit.addLabel(new LangString("Sievert", "de"));
  unit.addLabel(new LangString("sievert", "en"));
  unit.addLabel(new LangString("sievert", "pt"));
  unit.addLabel(new LangString("西弗", "zh"));
  unit.addLabel(new LangString("सैवर्ट", "hi"));
  unit.addLabel(new LangString("シーベルト", "ja"));
  unit.addLabel(new LangString("sievert", "ms"));
  unit.addLabel(new LangString("זיוורט", "he"));
  unit.addLabel(new LangString("σίβερτ", "el"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DoseEquivalent");
  config.units.set("http://qudt.org/vocab/unit/SV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.0002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("sievert per hour", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/SV-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("0.01666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("sievert per minute", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/SV-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SV-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Sv/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("sievert per second", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/KermaRate");
  config.units.set("http://qudt.org/vocab/unit/SV-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    "aS",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Absiemen", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/S_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/S_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    new Decimal("1.1126500561E-12"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/S-PER-M",
    undefined,
    "statS",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statsiemens", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MHO_Stat");
  config.units.set("http://qudt.org/vocab/unit/S_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SolarMass",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1988435000000000000000000000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "S",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Solar mass", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/SolarMass", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/SpeedOfLight",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("SpeedOfLight", undefined));
  config.units.set("http://qudt.org/vocab/unit/SpeedOfLight", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Standard",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("4.672"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "standard",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Standard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/Standard", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Stone_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("6.35029318"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "st{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Stone (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/Stone_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "T",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("tesla", "hu"));
  unit.addLabel(new LangString("تسلا", "ar"));
  unit.addLabel(new LangString("tesla", "fr"));
  unit.addLabel(new LangString("טסלה", "he"));
  unit.addLabel(new LangString("tesla", "it"));
  unit.addLabel(new LangString("tesla", "en"));
  unit.addLabel(new LangString("tesla", "ms"));
  unit.addLabel(new LangString("τέσλα", "el"));
  unit.addLabel(new LangString("tesla", "la"));
  unit.addLabel(new LangString("тесла", "bg"));
  unit.addLabel(new LangString("テスラ", "ja"));
  unit.addLabel(new LangString("тесла", "ru"));
  unit.addLabel(new LangString("tesla", "cs"));
  unit.addLabel(new LangString("टैस्ला", "hi"));
  unit.addLabel(new LangString("tesla", "es"));
  unit.addLabel(new LangString("特斯拉", "zh"));
  unit.addLabel(new LangString("tesla", "ro"));
  unit.addLabel(new LangString("tesla", "pl"));
  unit.addLabel(new LangString("tesla", "sl"));
  unit.addLabel(new LangString("تسلا", "fa"));
  unit.addLabel(new LangString("Tesla", "de"));
  unit.addLabel(new LangString("tesla", "pt"));
  unit.addLabel(new LangString("tesla", "tr"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  config.units.set("http://qudt.org/vocab/unit/T", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "T·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("T-M", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength"
  );
  config.units.set("http://qudt.org/vocab/unit/T-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "T·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("T-SEC", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/T-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TBSP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.0000147867656"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "tbsp",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Tablespoon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TBSP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TEX",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/GM-PER-MilliM",
    undefined,
    "tex",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Tex", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerLength");
  config.units.set("http://qudt.org/vocab/unit/TEX", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THERM_EC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "thm{EC}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("therm (EC)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THM_EEC");
  config.units.set("http://qudt.org/vocab/unit/THERM_EC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THERM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "thm{US}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("therm (U.S.)", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THM_US");
  config.units.set("http://qudt.org/vocab/unit/THERM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THM_EEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "thm{EEC}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("THM_EEC", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THERM_EC");
  config.units.set("http://qudt.org/vocab/unit/THM_EEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THM_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("105480400.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "thm{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Therm US", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/THERM_US");
  config.units.set("http://qudt.org/vocab/unit/THM_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/THM_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("29300.1111"),
    undefined,
    undefined,
    undefined,
    undefined,
    "thm{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Therm US per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/THM_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TOE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("41868000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "toe",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ton of Oil Equivalent", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TOE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907.18474"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "tn",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US");
  config.units.set("http://qudt.org/vocab/unit/TON", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "t",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CO2Equivalent");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric");
  config.units.set("http://qudt.org/vocab/unit/TONNE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.011574074074074"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-DAY");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("tonne per hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HA");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HA-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    new Decimal("3.17E-9"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(ha·a)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("tonne per hectare year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerAreaTime");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HA-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.277777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.000002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-HR-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Tonne per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-M3");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(m³·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per cubic metre bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerEnergy");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-M3-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-M3-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("16.666666666666668"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-MIN");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.0001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-MO",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.0003919350772901616281311709002114104"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/mo",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per month", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-MO", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TONNE-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.00003168808781"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/y",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Year", "en"));
  unit.addLabel(new LangString("Ton per Jaar", "nl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TONNE-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Assay",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("0.02916667"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "AT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Assay Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  config.units.set("http://qudt.org/vocab/unit/TON_Assay", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_FG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("3516.853"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J-PER-SEC",
    undefined,
    "TOR",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ton of Refrigeration", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HeatFlowRate");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TON_FG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_FG-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("12660670.2"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TOR·h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ton of Refrigeration Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ThermalEnergy");
  config.units.set("http://qudt.org/vocab/unit/TON_FG-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_F_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    new Decimal("8896.443230521"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/N",
    undefined,
    "tonf{us}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ton Force (US Short)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Force");
  config.units.set("http://qudt.org/vocab/unit/TON_F_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_LONG",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1016.0469088"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "t{long}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Long Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_UK");
  config.units.set("http://qudt.org/vocab/unit/TON_LONG", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1328.8778292234224"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t{long}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Long Ton per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_UK-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_LONG-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "t",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Metric Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.011574074074074"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/day",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-DAY");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("1.157407407407407407407407407407407E-7"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per day bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.01157407407407407407407407407407407"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(d·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per day kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-DAY-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    new Decimal("0.1"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/ha",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("metric tonne per hectare", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerArea");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.277777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.000002777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per hour bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HR-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("0.2777777777777777777777777777777778"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(h·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per hour kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-HR-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-HR-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Cubic Meter", "en-US"));
  unit.addLabel(new LangString("Tonne per Cubic Metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H-1T0D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(m³·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per cubic metre kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-M3-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-M3-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("16.666666666666668"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/min",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-MIN");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.0001666666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per minute bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(min·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per minute kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-MIN-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Tonne per Second (metric Ton)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-SEC");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal("0.01"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·bar)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per second bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "t/(s·K)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tonne per second kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TONNE-PER-SEC-K");
  config.units.set("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_Register",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "RT",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ton, register", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SectionModulus");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TON_Register", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.1326"),
    undefined,
    undefined,
    undefined,
    undefined,
    "MTON",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Ton (UK Shipping)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TON_SHIPPING_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("1.1326"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "MTON",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ton (US Shipping)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TON_SHIPPING_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907.18474"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ton{short}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Short Ton", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T0D0",
    new Decimal("1632.932"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/°F",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ton short per degree Fahrenheit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.251944444444444"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Short Ton per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassPerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-1D0",
    new Decimal(
      "0.453592369999999963712610400000003060236522933333330430342165333333575249264"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/(h·°F)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("ton short per hour degree Fahrenheit", undefined)
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    new Decimal(
      "0.0000365488934692998216241326760518469448736564775439857299306140841477553559796"
    ),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/(h·psi)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ton short per hour psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T2D0",
    new Decimal("0.131576016489479357846877633786648991019082"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("ton short per psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1186.3112117181538"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{short}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Short Ton per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_US-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_SHORT-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_UK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1016.0469088"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ton{UK}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Ton (UK)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_LONG");
  config.units.set("http://qudt.org/vocab/unit/TON_UK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_UK-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.011759259259259"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{UK}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Long Ton (uk) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TON_UK-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1328.8778292234224"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{UK}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Long Ton (UK) per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_LONG-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_UK-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("907.18474"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "ton{US}",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ton (US)", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON");
  config.units.set("http://qudt.org/vocab/unit/TON_US", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.010497685185185"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{US}/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Short Ton (us) per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  config.units.set("http://qudt.org/vocab/unit/TON_US-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    new Decimal("0.251944444444444"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{US}/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Ton (US) per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFlowRate");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT-PER-HR");
  config.units.set("http://qudt.org/vocab/unit/TON_US-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    new Decimal("1186.3112117181538"),
    undefined,
    undefined,
    undefined,
    undefined,
    "ton{US}/yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Short Ton (US) per Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassDensity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Density");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/TON_SHORT-PER-YD3");
  config.units.set("http://qudt.org/vocab/unit/TON_US-PER-YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TORR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("133.322"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/PA",
    undefined,
    "Torr",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Torr", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ForcePerArea");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VaporPressure");
  config.units.set("http://qudt.org/vocab/unit/TORR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TORR-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    new Decimal("133.322"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Torr/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("torr per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureGradient"
  );
  config.units.set("http://qudt.org/vocab/unit/TORR-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TSP",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.00000492892187"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/M3",
    undefined,
    "tsp",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Teaspoon", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/TSP", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/T_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    new Decimal("0.0001"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/T",
    undefined,
    "abT",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abtesla", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticField");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/GAUSS");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Gs");
  config.units.set("http://qudt.org/vocab/unit/T_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("TebiBIT", undefined));
  config.units.set("http://qudt.org/vocab/unit/TebiBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    new Decimal("1099511627776.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tibit/m",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tebibit per metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/TebiBIT-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    new Decimal("1099511627776.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tibit/m²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tebibit per square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AreaBitDensity");
  config.units.set("http://qudt.org/vocab/unit/TebiBIT-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    new Decimal("1099511627776.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tibit/m³",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("tebibit per cubic metre", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity"
  );
  config.units.set("http://qudt.org/vocab/unit/TebiBIT-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TebiBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("6096987078286.4836024230149744713"),
    undefined,
    "http://qudt.org/vocab/prefix/Tebi",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "TiB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("TebiByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/TebiBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/A",
    undefined,
    "TA",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("teraampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCurrent");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CurrentLinkage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticTension");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalCurrent");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBIT",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("693147180559.9453"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/BIT",
    undefined,
    "Tbit",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("terabit", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DatasetOfBits");
  config.units.set("http://qudt.org/vocab/unit/TeraBIT", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBIT-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("693147180559.94530941723212145818"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Tbit/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("terabit per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/DataRate");
  config.units.set("http://qudt.org/vocab/unit/TeraBIT-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBQ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/BQ",
    undefined,
    "TBq",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("terabecquerel", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Activity");
  config.units.set("http://qudt.org/vocab/unit/TeraBQ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraBYTE",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("5545177444479.5624753378569716654"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/BYTE",
    undefined,
    "TB",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/CGS-ESU",
      "http://qudt.org/vocab/sou/PLANCK",
      "http://qudt.org/vocab/sou/ASU",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("TeraByte", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraBYTE", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "TC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("TeraCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/TeraC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraFLOPS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TFLOPS",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(
    new LangString("terafloating point operations per second", undefined)
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraFLOPS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraHZ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/HZ",
    undefined,
    "THz",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Terahertz", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/TeraHZ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraJ",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/J",
    undefined,
    "TJ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Terajoule", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TeraJ", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraJ-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TJ/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("terajoule per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TeraJ-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraOHM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/OHM",
    undefined,
    "TΩ",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Teraohm", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Resistance");
  config.units.set("http://qudt.org/vocab/unit/TeraOHM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraV",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/V",
    undefined,
    "TV",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("teravolt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/TeraV", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraV-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TV·A",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("teravolt ampere", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/TeraV-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraV-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "TV·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("teravolt ampere reactive", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/TeraV-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraW",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Tera",
    "http://qudt.org/vocab/unit/W",
    undefined,
    "TW",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("Terawatt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TeraW", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraW-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600000000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TW·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Terawatt Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TeraW-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("114155251.14"),
    undefined,
    undefined,
    undefined,
    undefined,
    "TW·h/a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Terawattstunde pro Jahr", "de"));
  unit.addLabel(new LangString("Terawatt Hour per Year", "en"));
  unit.addLabel(new LangString("Terawatt Heure par An", "fr"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/TeraW-HR-PER-YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/TonEnergy",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("4184000000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/J",
    undefined,
    "t/lbf",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Ton Energy", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/TonEnergy", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/U",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    new Decimal("1.66053878283E-27"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/KiloGM",
    undefined,
    "u",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Unified Atomic Mass Unit", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Mass");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/AMU");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/Da");
  config.units.set("http://qudt.org/vocab/unit/U", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/UNITLESS",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "一",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Unitless", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/CouplingFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterVapourToDryGas"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/OsmoticCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dissipance");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MassFraction");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/QualityFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerFactor");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Count");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TransmittanceDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogOctanolAirPartitionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticSusceptability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerFission"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Debye-WallerFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassRatioOfVapour"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Emissivity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassFractionOfWater"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Duv");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AverageLogarithmicEnergyDecrement"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reflectance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedCoordinate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LandeGFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StatisticalWeight"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InternalConversionFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Non-LeakageProbability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassExcess"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Absorptance");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PermittivityRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BioconcentrationFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GruneisenParameter"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactor"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Dimensionless");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MobilityRatio");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Lethargy");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RadianceFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PackingFraction");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MadelungConstant"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LogOctanolWaterPartitionCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ActivityCoefficient"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Constringence");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AtomScatteringFactor"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LossFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/OrderOfReflection"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IsentropicExponent"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Chromaticity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerAbsorption"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassDensity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GFactorOfNucleus"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Short-RangeOrderParameter"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/StructureFactor");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/RefractiveIndex");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricSusceptibility"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberOfParticles"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PoissonRatio");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DegreeOfDissociation"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FastFissionFactor"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Reactivity");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/BindingFraction");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LeakageFactor");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbability"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedForce"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NapierianAbsorbance"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Long-RangeOrderParameter"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StandardAbsoluteActivity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassFractionOfDryMatter"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/TotalIonization");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Turns");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentQualityFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedVelocity"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ReflectanceFactor"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativeMassConcentrationOfVapour"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterToDryMatter"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RatioOfSpecificHeatCapacities"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GeneralizedMomentum"
  );
  config.units.set("http://qudt.org/vocab/unit/UNITLESS", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/UNKNOWN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Unknown",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Unknown", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/UNKNOWN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/UnitPole",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1.256637E-7"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/WB",
    undefined,
    "pole",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Unit Pole", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/UnitPole", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("वोल्ट", "hi"));
  unit.addLabel(new LangString("volt", "cs"));
  unit.addLabel(new LangString("вольт", "ru"));
  unit.addLabel(new LangString("βολτ", "el"));
  unit.addLabel(new LangString("volt", "sl"));
  unit.addLabel(new LangString("voltium", "la"));
  unit.addLabel(new LangString("ボルト", "ja"));
  unit.addLabel(new LangString("volt", "tr"));
  unit.addLabel(new LangString("וולט", "he"));
  unit.addLabel(new LangString("volt", "ro"));
  unit.addLabel(new LangString("волт", "bg"));
  unit.addLabel(new LangString("Volt", "de"));
  unit.addLabel(new LangString("فولت", "ar"));
  unit.addLabel(new LangString("伏特", "zh"));
  unit.addLabel(new LangString("volt", "ms"));
  unit.addLabel(new LangString("volt", "pt"));
  unit.addLabel(new LangString("volt", "it"));
  unit.addLabel(new LangString("voltio", "es"));
  unit.addLabel(new LangString("volt", "en"));
  unit.addLabel(new LangString("wolt", "pl"));
  unit.addLabel(new LangString("ولت", "fa"));
  unit.addLabel(new LangString("volt", "fr"));
  unit.addLabel(new LangString("volt", "hu"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("فولت. أمبير", "ar"));
  unit.addLabel(new LangString("volt-ampere", "pt"));
  unit.addLabel(new LangString("volt ampere", "en"));
  unit.addLabel(new LangString("Voltampere", "de"));
  unit.addLabel(new LangString("voltiamperio", "es"));
  unit.addLabel(new LangString("вольт-ампер", "ru"));
  unit.addLabel(new LangString("voltampère", "fr"));
  unit.addLabel(new LangString("volt ampere", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ComplexPower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/NonActivePower");
  config.units.set("http://qudt.org/vocab/unit/V-A", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Volt Ampere Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/V-A-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("volt ampere per kelvin", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/V-A-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A_Reactive",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A{Reactive}",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Volt Ampere Reactive", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ReactivePower");
  config.units.set("http://qudt.org/vocab/unit/V-A_Reactive", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·A{reactive}·h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Volt Ampere Reactive Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/V-A_Reactive-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-A_Reactive-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-2I0M1H-1T-3D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "var/K",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("volt ampere reactive per kelvin", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/V-A_Reactive-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-IN2-PER-LB_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("0.0001450377312227268702148557236386593"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("volt square inch per pound-force", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/V-IN2-PER-LB_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("V-M", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricFlux");
  config.units.set("http://qudt.org/vocab/unit/V-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-BAR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("0.00001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/bar",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("volt per bar", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/V-PER-BAR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("100.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/cm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Volt per Centimetre", "en"));
  unit.addLabel(new LangString("Volt per Centimeter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-IN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("39.37007874015748"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/in",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Volt per Inch", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-IN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Volt per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThomsonCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SeebeckCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-L-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L-1I0M1H0T-4D0",
    new Decimal("16.66666666666666666666666666666667"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/(l·min)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("volt per litre minute", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/V-PER-L-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("伏特每米", "zh"));
  unit.addLabel(new LangString("volți pe metru", "ro"));
  unit.addLabel(new LangString("вольт на метр", "ru"));
  unit.addLabel(new LangString("volt per metre", "en"));
  unit.addLabel(new LangString("प्रति मीटर वोल्ट", "hi"));
  unit.addLabel(new LangString("Volt per Meter", "en-US"));
  unit.addLabel(new LangString("voltio por metro", "es"));
  unit.addLabel(new LangString("مقياس التبادل، الأس السالب للمتر", "ar"));
  unit.addLabel(new LangString("volt na meter", "sl"));
  unit.addLabel(new LangString("Volt je Meter", "de"));
  unit.addLabel(new LangString("volt al metro", "it"));
  unit.addLabel(new LangString("ボルト毎メートル", "ja"));
  unit.addLabel(new LangString("volt por metro", "pt"));
  unit.addLabel(new LangString("ولت بر متر", "fa"));
  unit.addLabel(new LangString("volt bölü metre", "tr"));
  unit.addLabel(new LangString("volt per meter", "ms"));
  unit.addLabel(new LangString("volt par mètre", "fr"));
  unit.addLabel(new LangString("voltů na metr", "cs"));
  unit.addLabel(new LangString("wolt na metr", "pl"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricField");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Volt per Square Meter", "en-US"));
  unit.addLabel(new LangString("Volt per Square Metre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerAreaElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-MicroSEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    new Decimal("1000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/µs",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Volt per Microsecond", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-MicroSEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Volt per Millimeter", "en-US"));
  unit.addLabel(new LangString("Volt per Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/Pa",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("volt per pascal", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/HallCoefficient");
  config.units.set("http://qudt.org/vocab/unit/V-PER-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Volt per second", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge"
  );
  config.units.set("http://qudt.org/vocab/unit/V-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-PER-V",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V/V",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("volt per volt", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/V-PER-V", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V-SEC-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V·s/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Volt Second per Metre", "en"));
  unit.addLabel(new LangString("Volt Second per Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ScalarMagneticPotential"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength"
  );
  config.units.set("http://qudt.org/vocab/unit/V-SEC-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V2-PER-K2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-2L4I0M2H-2T-6D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "V²/K²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Square Volt per Square Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LorenzCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/V2-PER-K2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Ab",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/V",
    undefined,
    "abV",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abvolt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/V_Ab", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("0.000001"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abV/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abvolt per centimeter", "en-US"));
  unit.addLabel(new LangString("Abvolt per centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricField");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V_Ab-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Ab-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1E-8"),
    undefined,
    undefined,
    undefined,
    undefined,
    "abV·s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS-EMU", "http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Abvolt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/V_Ab-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Stat",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    new Decimal("299.792458"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/V",
    undefined,
    "statV",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS", "http://qudt.org/vocab/sou/CGS-ESU"]
  );
  unit.addLabel(new LangString("Statvolt", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Voltage");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/V_Stat", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Stat-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-3D0",
    new Decimal("2.99792458"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statV·cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("V_Stat-CentiM", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricFlux");
  config.units.set("http://qudt.org/vocab/unit/V_Stat-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    new Decimal("29979.2458"),
    undefined,
    undefined,
    undefined,
    undefined,
    "statV/cm",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("Statvolt per Centimeter", "en-US"));
  unit.addLabel(new LangString("Statvolt per Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricField");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.units.set("http://qudt.org/vocab/unit/V_Stat-PER-CentiM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("watt", "pt"));
  unit.addLabel(new LangString("وات", "fa"));
  unit.addLabel(new LangString("wat", "pl"));
  unit.addLabel(new LangString("watt", "ms"));
  unit.addLabel(new LangString("واط", "ar"));
  unit.addLabel(new LangString("vatio", "es"));
  unit.addLabel(new LangString("watt", "sl"));
  unit.addLabel(new LangString("watt", "ro"));
  unit.addLabel(new LangString("Watt", "de"));
  unit.addLabel(new LangString("watt", "tr"));
  unit.addLabel(new LangString("ватт", "ru"));
  unit.addLabel(new LangString("wattium", "la"));
  unit.addLabel(new LangString("watt", "it"));
  unit.addLabel(new LangString("瓦特", "zh"));
  unit.addLabel(new LangString("watt", "fr"));
  unit.addLabel(new LangString("ват", "bg"));
  unit.addLabel(new LangString("watt", "en"));
  unit.addLabel(new LangString("ואט", "he"));
  unit.addLabel(new LangString("watt", "cs"));
  unit.addLabel(new LangString("watt", "hu"));
  unit.addLabel(new LangString("वाट", "hi"));
  unit.addLabel(new LangString("βατ", "el"));
  unit.addLabel(new LangString("ワット", "ja"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ActivePower");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Power");
  config.units.set("http://qudt.org/vocab/unit/W", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watthour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/W-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h/kg",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("watt hour per kilogram", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificEnergy");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-L",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3600000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h/l",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("watt hour per litre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-L", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("3600.0"),
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    "W·h/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt hour per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-HR-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    new Decimal("3600.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·h/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watthour per Cubic meter", "en-US"));
  unit.addLabel(new LangString("Watthour per Cubic metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyDensity");
  config.units.set("http://qudt.org/vocab/unit/W-HR-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-M-PER-M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·m/(m²·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt metre per square metre steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-M-PER-M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("W-M2", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerArea");
  config.units.set("http://qudt.org/vocab/unit/W-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-M2-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·m²/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("W-M2-PER-SR", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerAreaPerSolidAngle"
  );
  config.units.set("http://qudt.org/vocab/unit/W-M2-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-CentiM2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("10000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/cm²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt per Square Centimeter", "en-US"));
  unit.addLabel(new LangString("Watt per Square Centimetre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-PER-CentiM2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-FT2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("10.7639104"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/ft²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Watt per Square Foot", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-PER-FT2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-GM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/g",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt per Gram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/MilliW-PER-MilliGM");
  config.units.set("http://qudt.org/vocab/unit/W-PER-GM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-IN2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1550.0031"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/in²",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS"]
  );
  unit.addLabel(new LangString("Watt per Square Inch", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-PER-IN2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/K",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Watt per Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductance"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-KiloGM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/kg",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt per Kilogram", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/SpecificPower");
  config.units.set("http://qudt.org/vocab/unit/W-PER-KiloGM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watts per metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LineicPower");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M-DEG_C",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m·°C)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("watt per metre degree Celsius", undefined));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M-DEG_C", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Watt per Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Watt per Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("vatio por metro cuadrado", "es"));
  unit.addLabel(new LangString("Watt je Quadratmeter", "de"));
  unit.addLabel(new LangString("watt per meter persegi", "ms"));
  unit.addLabel(new LangString("watt per square metre", "en"));
  unit.addLabel(new LangString("瓦特每平方米", "zh"));
  unit.addLabel(new LangString("वाट प्रति वर्ग मीटर", "hi"));
  unit.addLabel(new LangString("وات بر مترمربع", "fa"));
  unit.addLabel(new LangString("ワット毎平方メートル", "ja"));
  unit.addLabel(new LangString("ватт на квадратный метр", "ru"));
  unit.addLabel(new LangString("watt na metr čtvereční", "cs"));
  unit.addLabel(new LangString("واط في المتر المربع", "ar"));
  unit.addLabel(new LangString("watt bölü metre kare", "tr"));
  unit.addLabel(new LangString("Watt per Square Meter", "en-US"));
  unit.addLabel(new LangString("wat na metr kwadratowy", "pl"));
  unit.addLabel(new LangString("watt pe metru pătrat", "ro"));
  unit.addLabel(new LangString("watt par mètre carré", "fr"));
  unit.addLabel(new LangString("watt na kvadratni meter", "sl"));
  unit.addLabel(new LangString("watt por metro quadrado", "pt"));
  unit.addLabel(new LangString("watt al metro quadrato", "it"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PoyntingVector");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/PowerPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-K",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·K)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(new LangString("Watt per Square Meter Kelvin", "en-US"));
  unit.addLabel(new LangString("Watt per Square Metre Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient"
  );
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-K", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-K4",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-4T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·K⁴)",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/SI"]
  );
  unit.addLabel(
    new LangString("Watt per Square Meter Quartic Kelvin", "en-US")
  );
  unit.addLabel(new LangString("Watt per Square Metre Quartic Kelvin", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaQuarticTemperature"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-K4", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·m)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watts per square metre metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-M-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·m·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watts per square metre metre steradian", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-M-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·nm)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watts per square metre nanometre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-NanoM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1000000000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·nm·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(
    new LangString("Watts per square metre nanometre steradian", "en")
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-PA",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·Pa)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt per Square Metre Pascal", "en"));
  unit.addLabel(new LangString("Watt per Square Meter Pascal", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransferCoefficient"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-PA", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M2-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(m²·sr)",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt per Square Metre Steradian", "en"));
  unit.addLabel(new LangString("Watt per Square Meter Steradian", "en-US"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Radiance");
  config.units.set("http://qudt.org/vocab/unit/W-PER-M2-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-M3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/m³",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt per Cubic Metre", "en"));
  unit.addLabel(new LangString("Watt per Cubic Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-M3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-SR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/sr",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt per Steradian", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RadiantIntensity"
  );
  config.units.set("http://qudt.org/vocab/unit/W-PER-SR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-PER-SR-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W/(sr·m²)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("watt per steradian square metre", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/W-PER-SR-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·s",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Energy");
  config.units.set("http://qudt.org/vocab/unit/W-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W-SEC-PER-M2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "W·s/m²",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
    ]
  );
  unit.addLabel(new LangString("Watt seconds per square metre", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/EnergyPerArea");
  config.units.set("http://qudt.org/vocab/unit/W-SEC-PER-M2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/W0dot",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("W0dot", undefined));
  config.units.set("http://qudt.org/vocab/unit/W0dot", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("weber", "es"));
  unit.addLabel(new LangString("weber", "fr"));
  unit.addLabel(new LangString("weber", "hu"));
  unit.addLabel(new LangString("ウェーバ", "ja"));
  unit.addLabel(new LangString("weber", "it"));
  unit.addLabel(new LangString("韦伯", "zh"));
  unit.addLabel(new LangString("ويبر; فيبر", "ar"));
  unit.addLabel(new LangString("weber", "en"));
  unit.addLabel(new LangString("weber", "ms"));
  unit.addLabel(new LangString("weber", "pt"));
  unit.addLabel(new LangString("weberium", "la"));
  unit.addLabel(new LangString("ובר", "he"));
  unit.addLabel(new LangString("weber", "tr"));
  unit.addLabel(new LangString("वैबर", "hi"));
  unit.addLabel(new LangString("Weber", "de"));
  unit.addLabel(new LangString("weber", "pl"));
  unit.addLabel(new LangString("weber", "ro"));
  unit.addLabel(new LangString("βέμπερ", "el"));
  unit.addLabel(new LangString("weber", "sl"));
  unit.addLabel(new LangString("вебер", "bg"));
  unit.addLabel(new LangString("وبر", "fa"));
  unit.addLabel(new LangString("вебер", "ru"));
  unit.addLabel(new LangString("weber", "cs"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/MagneticFlux");
  config.units.set("http://qudt.org/vocab/unit/WB", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb·m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Weber Metre", "en"));
  unit.addLabel(new LangString("Weber Meter", "en-US"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment"
  );
  unit.addExactMatchIri("http://qudt.org/vocab/unit/N-M2-PER-A");
  config.units.set("http://qudt.org/vocab/unit/WB-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB-PER-M",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb/m",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("प्रति मीटर वैबर", "hi"));
  unit.addLabel(new LangString("weber per metre", "en"));
  unit.addLabel(new LangString("ウェーバ毎メートル", "ja"));
  unit.addLabel(new LangString("وبر بر متر", "fa"));
  unit.addLabel(new LangString("вебер на метр", "ru"));
  unit.addLabel(new LangString("weber por metro", "es"));
  unit.addLabel(new LangString("weber na metr", "pl"));
  unit.addLabel(new LangString("韦伯每米", "zh"));
  unit.addLabel(new LangString("Weber je Meter", "de"));
  unit.addLabel(new LangString("مقياس التبادل، الأس السالب للمتر", "ar"));
  unit.addLabel(new LangString("weber bölü metre", "tr"));
  unit.addLabel(new LangString("weber por metro", "pt"));
  unit.addLabel(new LangString("weber pe metru", "ro"));
  unit.addLabel(new LangString("weber al metro", "it"));
  unit.addLabel(new LangString("weberů na metr", "cs"));
  unit.addLabel(new LangString("Weber per Meter", "en-US"));
  unit.addLabel(new LangString("weber par mètre", "fr"));
  unit.addLabel(new LangString("weber per meter", "ms"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/WB-PER-M", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WB-PER-MilliM",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    new Decimal("1000.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "Wb/mm",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
    ]
  );
  unit.addLabel(new LangString("Weber per Millimeter", "en-US"));
  unit.addLabel(new LangString("Weber per Millimetre", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential"
  );
  config.units.set("http://qudt.org/vocab/unit/WB-PER-MilliM", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/WK",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("604800.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "wk",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Week", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/WK", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    new Decimal("0.9144"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/YD", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    new Decimal("1.6459200164592"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Yard per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/YD-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.000254"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/h",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("yard per hour", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.01524"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/min",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("yard per minute", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T2D0",
    new Decimal("0.00013262250143006145012446407369519006392"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("yard per psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    new Decimal("0.9144"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("yard per second", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Velocity");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed"
  );
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Speed");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/LinearVelocity");
  config.units.set("http://qudt.org/vocab/unit/YD-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD-PER-SEC2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    new Decimal("0.9144"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd/s²",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("yard per second squared", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Acceleration");
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.units.set("http://qudt.org/vocab/unit/YD-PER-SEC2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD2",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    new Decimal("0.83612736"),
    undefined,
    undefined,
    undefined,
    undefined,
    "sqyd",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Square Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Area");
  config.units.set("http://qudt.org/vocab/unit/YD2", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    new Decimal("0.764554857984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Yard", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Volume");
  config.units.set("http://qudt.org/vocab/unit/YD3", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-DAY",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00000884901456"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/day",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Yard per Day", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-DAY", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-DEG_F",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    new Decimal("1.376198881991088"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/°F",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Yard per Degree Fahrenheit", "en"));
  unit.addQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion"
  );
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-DEG_F", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-HR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.00021237634944"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/h",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Yard per Hour", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-HR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-MIN",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.0127425809664"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/min",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Yard per Minute", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-MIN", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-PSI",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M-1H0T2D0",
    new Decimal("0.0001108893019973135049303398173536047128436608512"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/psi",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("cubic yard per psi", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Unknown");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-PSI", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YD3-PER-SEC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    new Decimal("0.764554857984"),
    undefined,
    undefined,
    undefined,
    undefined,
    "yd³/s",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/USCS", "http://qudt.org/vocab/sou/IMPERIAL"]
  );
  unit.addLabel(new LangString("Cubic Yard per Second", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumePerTime");
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/VolumeFlowRate");
  config.units.set("http://qudt.org/vocab/unit/YD3-PER-SEC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31557600.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_Common",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31536000.0"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Common Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR_Common", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_Metrology",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "y (metrology)",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("metrology year", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR_Metrology", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_Sidereal",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31558149.7632"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a{sidereal}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Sidereal Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  config.units.set("http://qudt.org/vocab/unit/YR_Sidereal", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YR_TROPICAL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    new Decimal("31556925.216"),
    undefined,
    undefined,
    "http://qudt.org/vocab/unit/SEC",
    undefined,
    "a{tropical}",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/USCS",
      "http://qudt.org/vocab/sou/IMPERIAL",
    ]
  );
  unit.addLabel(new LangString("Tropical Year", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Time");
  unit.addExactMatchIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  config.units.set("http://qudt.org/vocab/unit/YR_TROPICAL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YoctoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-24"),
    undefined,
    "http://qudt.org/vocab/prefix/Yocto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "yC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("YoctoCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/YoctoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/YottaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Yotta",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "YC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("YottaCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/YottaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/Z",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "Z",
    undefined,
    undefined,
    undefined,
    ["http://qudt.org/vocab/sou/CGS"]
  );
  unit.addLabel(new LangString("atomic-number", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/AtomicNumber");
  config.units.set("http://qudt.org/vocab/unit/Z", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ZOLL",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    "“",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("zoll", undefined));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Length");
  config.units.set("http://qudt.org/vocab/unit/ZOLL", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ZeptoC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1E-21"),
    undefined,
    "http://qudt.org/vocab/prefix/Zepto",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "zC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("ZeptoCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/ZeptoC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/ZettaC",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    new Decimal("1000000000000000000000.0"),
    undefined,
    "http://qudt.org/vocab/prefix/Zetta",
    "http://qudt.org/vocab/unit/C",
    undefined,
    "ZC",
    undefined,
    undefined,
    undefined,
    [
      "http://qudt.org/vocab/sou/CGS-EMU",
      "http://qudt.org/vocab/sou/CGS-GAUSS",
      "http://qudt.org/vocab/sou/SI",
      "http://qudt.org/vocab/sou/CGS",
      "http://qudt.org/vocab/sou/PLANCK",
    ]
  );
  unit.addLabel(new LangString("ZettaCoulomb", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/ElectricCharge");
  config.units.set("http://qudt.org/vocab/unit/ZettaC", unit);
  unit = new Unit(
    "http://qudt.org/vocab/unit/failures-in-time",
    undefined,
    undefined,
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    new Decimal("0.0"),
    undefined,
    undefined,
    undefined,
    undefined,
    "failures/s",
    undefined,
    undefined,
    undefined,
    []
  );
  unit.addLabel(new LangString("Failures In Time", "en"));
  unit.addQuantityKindIri("http://qudt.org/vocab/quantitykind/Frequency");
  config.units.set("http://qudt.org/vocab/unit/failures-in-time", unit);
}

export const Units = {
  // Gon
  GON: Qudt.unitFromLocalnameRequired("GON"),
  // Megahertz Metre
  MegaHZ__M: Qudt.unitFromLocalnameRequired("MegaHZ-M"),
  // Cubic Millimeter
  MilliM3: Qudt.unitFromLocalnameRequired("MilliM3"),
  // Bulgarian Lev
  BGN_Currency: Qudt.currencyFromLocalnameRequired("BGN"),
  // terabecquerel
  TeraBQ: Qudt.unitFromLocalnameRequired("TeraBQ"),
  // nanonewton metre per square metre
  NanoN__M__PER__M2: Qudt.unitFromLocalnameRequired("NanoN-M-PER-M2"),
  // Planck Length
  PlanckLength: Qudt.unitFromLocalnameRequired("PlanckLength"),
  // foot per second psi
  FT__PER__SEC__PSI: Qudt.unitFromLocalnameRequired("FT-PER-SEC-PSI"),
  // pound second per gallon (UK) cubic foot
  LB__SEC__PER__GAL_UK__FT3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_UK-FT3"
  ),
  // Milligram per Millilitre
  MilliGM__PER__MilliL: Qudt.unitFromLocalnameRequired("MilliGM-PER-MilliL"),
  // Circular Mil
  MIL_Circ: Qudt.unitFromLocalnameRequired("MIL_Circ"),
  // poundal per inch
  PDL__PER__IN: Qudt.unitFromLocalnameRequired("PDL-PER-IN"),
  // Pound (avoirdupois) per Square Inch
  LB__PER__IN2: Qudt.unitFromLocalnameRequired("LB-PER-IN2"),
  // tonne per hour bar
  TON_Metric__PER__HR__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-HR-BAR"
  ),
  // Mongolian Tugrik
  MNT_Currency: Qudt.currencyFromLocalnameRequired("MNT"),
  // Poise
  POISE: Qudt.unitFromLocalnameRequired("POISE"),
  // percent per kelvin
  PERCENT__PER__K: Qudt.unitFromLocalnameRequired("PERCENT-PER-K"),
  // KiloPound Force
  KiloLB_F: Qudt.unitFromLocalnameRequired("KiloLB_F"),
  // kilogram per hour kelvin
  KiloGM__PER__HR__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-HR-K"),
  // Hectopascal per Kelvin
  HectoPA__PER__K: Qudt.unitFromLocalnameRequired("HectoPA-PER-K"),
  // Long Ton (UK) per Cubic Yard
  TON_UK__PER__YD3: Qudt.unitFromLocalnameRequired("TON_UK-PER-YD3"),
  // Quad
  QUAD: Qudt.unitFromLocalnameRequired("QUAD"),
  // darjah celsius
  DEG_C: Qudt.unitFromLocalnameRequired("DEG_C"),
  // Millilitres per square metre day
  MilliL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliL-PER-M2-DAY"),
  // Parts per Ten Million
  PPTM: Qudt.unitFromLocalnameRequired("PPTM"),
  // KiloYear
  KiloYR: Qudt.unitFromLocalnameRequired("KiloYR"),
  // kilogram
  KiloGM: Qudt.unitFromLocalnameRequired("KiloGM"),
  // nanosecond
  NanoSEC: Qudt.unitFromLocalnameRequired("NanoSEC"),
  // Quart (UK Liquid) per Hour
  QT_UK__PER__HR: Qudt.unitFromLocalnameRequired("QT_UK-PER-HR"),
  // Quart (US Liquid) per Hour
  QT_US__PER__HR: Qudt.unitFromLocalnameRequired("QT_US-PER-HR"),
  // WIR Franc (complementary currency)
  CHW_Currency: Qudt.currencyFromLocalnameRequired("CHW"),
  // Atomic mass unit
  AMU: Qudt.unitFromLocalnameRequired("AMU"),
  // Degree Brix
  DEGREE_BRIX: Qudt.unitFromLocalnameRequired("DEGREE_BRIX"),
  // Revolution per Second
  REV__PER__SEC: Qudt.unitFromLocalnameRequired("REV-PER-SEC"),
  // Atmosphere Cubic Metre per Mole
  ATM__M3__PER__MOL: Qudt.unitFromLocalnameRequired("ATM-M3-PER-MOL"),
  // Degree
  DEG: Qudt.unitFromLocalnameRequired("DEG"),
  // KiloINDIV
  KiloINDIV: Qudt.unitFromLocalnameRequired("KiloINDIV"),
  // poundal second per square foot
  PDL__SEC__PER__FT2: Qudt.unitFromLocalnameRequired("PDL-SEC-PER-FT2"),
  // 10KiloCount
  _10KiloCount: Qudt.unitFromLocalnameRequired("10KiloCount"),
  // reciprocal inch
  PER__IN: Qudt.unitFromLocalnameRequired("PER-IN"),
  // Kilobecquerel
  KiloBQ: Qudt.unitFromLocalnameRequired("KiloBQ"),
  // Kilopascal per Millimetre
  KiloPA__PER__MilliM: Qudt.unitFromLocalnameRequired("KiloPA-PER-MilliM"),
  // GibiByte
  GibiBYTE: Qudt.unitFromLocalnameRequired("GibiBYTE"),
  // Pound Force Inch
  LB_F__IN: Qudt.unitFromLocalnameRequired("LB_F-IN"),
  // Degree per Second
  DEG__PER__SEC: Qudt.unitFromLocalnameRequired("DEG-PER-SEC"),
  // Standard Cubic Metre per Minute
  SCM__PER__MIN: Qudt.unitFromLocalnameRequired("SCM-PER-MIN"),
  // katal per cubic metre
  KAT__PER__M3: Qudt.unitFromLocalnameRequired("KAT-PER-M3"),
  // pound minute per gallon (UK) cubic yard
  LB__MIN__PER__GAL_UK__YD3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_UK-YD3"
  ),
  // Microcoulomb per Cubic Meter
  MicroC__PER__M3: Qudt.unitFromLocalnameRequired("MicroC-PER-M3"),
  // Kelvin metres per second
  K__M__PER__SEC: Qudt.unitFromLocalnameRequired("K-M-PER-SEC"),
  // Long Ton (uk) per Day
  TON_UK__PER__DAY: Qudt.unitFromLocalnameRequired("TON_UK-PER-DAY"),
  // Kilolumen
  KiloLM: Qudt.unitFromLocalnameRequired("KiloLM"),
  // US Dollar
  USD_Currency: Qudt.currencyFromLocalnameRequired("USD"),
  // Cubic microns per millilitre
  MicroM3__PER__MilliL: Qudt.unitFromLocalnameRequired("MicroM3-PER-MilliL"),
  // pascal second per litre
  PA__SEC__PER__L: Qudt.unitFromLocalnameRequired("PA-SEC-PER-L"),
  // milligram hour per cubic metre cubic centimetre
  MilliGM__HR__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-M3-CentiM3"
  ),
  // millimetre per metre
  MilliM__PER__M: Qudt.unitFromLocalnameRequired("MilliM-PER-M"),
  // Reciprocal Micrometre
  PER__MicroM: Qudt.unitFromLocalnameRequired("PER-MicroM"),
  // pascal-seconde
  PA__SEC: Qudt.unitFromLocalnameRequired("PA-SEC"),
  // Phot
  PHOT: Qudt.unitFromLocalnameRequired("PHOT"),
  // Nanometer
  NanoM: Qudt.unitFromLocalnameRequired("NanoM"),
  // Centilitre
  CentiL: Qudt.unitFromLocalnameRequired("CentiL"),
  // CentiMole
  CentiMOL: Qudt.unitFromLocalnameRequired("CentiMOL"),
  // MicroGals per metre
  MicroGAL__PER__M: Qudt.unitFromLocalnameRequired("MicroGAL-PER-M"),
  // Gram per Millimetre
  GM__PER__MilliM: Qudt.unitFromLocalnameRequired("GM-PER-MilliM"),
  // ArcMinute
  ARCMIN: Qudt.unitFromLocalnameRequired("ARCMIN"),
  // cubic centimetre per second bar
  CentiM3__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-SEC-BAR"),
  // Nanobecquerels per litre
  NanoBQ__PER__L: Qudt.unitFromLocalnameRequired("NanoBQ-PER-L"),
  // Ohm Square Meter per Meter
  OHM__M2__PER__M: Qudt.unitFromLocalnameRequired("OHM-M2-PER-M"),
  // terabit
  TeraBIT: Qudt.unitFromLocalnameRequired("TeraBIT"),
  // BTU (TH) Inch per Square Foot Hour Degree Fahrenheit
  BTU_TH__IN__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-IN-PER-FT2-HR-DEG_F"
  ),
  // Millimoles per cubic metre day
  MilliMOL__PER__M3__DAY: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M3-DAY"),
  // joule par tesla
  J__PER__T: Qudt.unitFromLocalnameRequired("J-PER-T"),
  // Milligray
  MilliGRAY: Qudt.unitFromLocalnameRequired("MilliGRAY"),
  // Cubic Decimetre
  DeciM3: Qudt.unitFromLocalnameRequired("DeciM3"),
  // Kilo Electron Volt
  KiloEV: Qudt.unitFromLocalnameRequired("KiloEV"),
  // Kilogauss
  KiloGAUSS: Qudt.unitFromLocalnameRequired("KiloGAUSS"),
  // Ounce (UK Fluid) per Hour
  OZ_VOL_UK__PER__HR: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-HR"),
  // U.S. Perm
  PERM_US: Qudt.unitFromLocalnameRequired("PERM_US"),
  // Pound per Inch
  LB__PER__IN: Qudt.unitFromLocalnameRequired("LB-PER-IN"),
  // Millilitre per Liter
  MilliL__PER__L: Qudt.unitFromLocalnameRequired("MilliL-PER-L"),
  // YottaCoulomb
  YottaC: Qudt.unitFromLocalnameRequired("YottaC"),
  // Pound Force Foot
  LB_F__FT: Qudt.unitFromLocalnameRequired("LB_F-FT"),
  // Ton of Oil Equivalent
  TOE: Qudt.unitFromLocalnameRequired("TOE"),
  // Egyptian Pound
  EGP_Currency: Qudt.currencyFromLocalnameRequired("EGP"),
  // octet
  OCTET: Qudt.unitFromLocalnameRequired("OCTET"),
  // Bushel (UK) per Second
  BU_UK__PER__SEC: Qudt.unitFromLocalnameRequired("BU_UK-PER-SEC"),
  // Quart (UK)
  QT_UK: Qudt.unitFromLocalnameRequired("QT_UK"),
  // pound minute per cubic foot cubic yard
  LB__MIN__PER__FT3__YD3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-FT3-YD3"),
  // Millimeter per Minute
  MilliM__PER__MIN: Qudt.unitFromLocalnameRequired("MilliM-PER-MIN"),
  // Kelvin Pascals per second
  K__PA__PER__SEC: Qudt.unitFromLocalnameRequired("K-PA-PER-SEC"),
  // T-M
  T__M: Qudt.unitFromLocalnameRequired("T-M"),
  // ampere minute
  A__MIN: Qudt.unitFromLocalnameRequired("A-MIN"),
  // kilogram per second bar
  KiloGM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-BAR"),
  // kilogram per metre minute
  KiloGM__PER__M__MIN: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-MIN"),
  // WIR Euro (complementary currency)
  CHE_Currency: Qudt.currencyFromLocalnameRequired("CHE"),
  // Cubic Centimetre per Hour
  CentiM3__PER__HR: Qudt.unitFromLocalnameRequired("CentiM3-PER-HR"),
  // Square metres per square second
  M2__PER__SEC2: Qudt.unitFromLocalnameRequired("M2-PER-SEC2"),
  // BTU (TH) Foot per Square Foot Hour Degree Fahrenheit
  BTU_TH__FT__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-FT-PER-FT2-HR-DEG_F"
  ),
  // Microhenry per Ohm
  MicroH__PER__OHM: Qudt.unitFromLocalnameRequired("MicroH-PER-OHM"),
  // Barrel (UK Petroleum) per Minute
  BBL_UK_PET__PER__MIN: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-MIN"),
  // ampere hour per kilogram
  A__HR__PER__KiloGM: Qudt.unitFromLocalnameRequired("A-HR-PER-KiloGM"),
  // percent per bar
  PERCENT__PER__BAR: Qudt.unitFromLocalnameRequired("PERCENT-PER-BAR"),
  // Square Kilometers per Square Second
  KiloM2__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloM2-PER-SEC2"),
  // milligram per cubic metre poise
  MilliGM__PER__M3__POISE: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-POISE"
  ),
  // therm (EC)
  THERM_EC: Qudt.unitFromLocalnameRequired("THERM_EC"),
  // Abfarad per Centimeter
  FARAD_Ab__PER__CentiM: Qudt.unitFromLocalnameRequired("FARAD_Ab-PER-CentiM"),
  // Pound Mole
  LB__MOL: Qudt.unitFromLocalnameRequired("LB-MOL"),
  // Milligrams per square metre second
  MilliGM__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2-SEC"),
  // ounce minute per cubic inch gallon (US)
  OZ__MIN__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "OZ-MIN-PER-IN3-GAL_US"
  ),
  // Revolution per Minute
  REV__PER__MIN: Qudt.unitFromLocalnameRequired("REV-PER-MIN"),
  // Centimetre Of Mercury
  CentiM_HG: Qudt.unitFromLocalnameRequired("CentiM_HG"),
  // Hertz per Volt
  HZ__PER__V: Qudt.unitFromLocalnameRequired("HZ-PER-V"),
  // Minute
  MIN: Qudt.unitFromLocalnameRequired("MIN"),
  // percent second per cubic yard
  PERCENT__SEC__PER__YD3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-YD3"),
  // Candela per Lumen
  CD__PER__LM: Qudt.unitFromLocalnameRequired("CD-PER-LM"),
  // tonne per hour bar
  TONNE__PER__HR__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-HR-BAR"),
  // pound minute per cubic inch gallon (UK)
  LB__MIN__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-IN3-GAL_UK"
  ),
  // CentiNewton
  CentiN: Qudt.unitFromLocalnameRequired("CentiN"),
  // pound hour per cubic inch cubic foot
  LB__HR__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("LB-HR-PER-IN3-FT3"),
  // Coulomb per Cubic Metre
  C__PER__M3: Qudt.unitFromLocalnameRequired("C-PER-M3"),
  // metric tonne per hectare
  TON_Metric__PER__HA: Qudt.unitFromLocalnameRequired("TON_Metric-PER-HA"),
  // Newton per Centimetre
  N__PER__CentiM: Qudt.unitFromLocalnameRequired("N-PER-CentiM"),
  // Quart (UK Liquid) per Minute
  QT_UK__PER__MIN: Qudt.unitFromLocalnameRequired("QT_UK-PER-MIN"),
  // Percent per Year
  PERCENT__PER__YR: Qudt.unitFromLocalnameRequired("PERCENT-PER-YR"),
  // electronvolt square metre per kilogram
  EV__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("EV-M2-PER-KiloGM"),
  // Reciprocal Kilometre
  PER__KiloM: Qudt.unitFromLocalnameRequired("PER-KiloM"),
  // Moroccan Dirham
  MAD_Currency: Qudt.currencyFromLocalnameRequired("MAD"),
  // Watt per Steradian
  W__PER__SR: Qudt.unitFromLocalnameRequired("W-PER-SR"),
  // British thermal unit (international table) per second square foot degree Fahrenheit
  BTU_IT__PER__SEC__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-SEC-FT2-DEG_F"
  ),
  // kilogram per cubic metre pascal
  KiloGM__PER__M3__PA: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-PA"),
  // Volt per Kelvin
  V__PER__K: Qudt.unitFromLocalnameRequired("V-PER-K"),
  // Revolution per Hour
  REV__PER__HR: Qudt.unitFromLocalnameRequired("REV-PER-HR"),
  // Ounce (UK Fluid) per Minute
  OZ_VOL_UK__PER__MIN: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-MIN"),
  // kilopound per hour
  KiloLB__PER__HR: Qudt.unitFromLocalnameRequired("KiloLB-PER-HR"),
  // joule por quilograma grau celsius
  J__PER__KiloGM__DEG_C: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-DEG_C"),
  // curie per kilogram
  CI__PER__KiloGM: Qudt.unitFromLocalnameRequired("CI-PER-KiloGM"),
  // pound second per cubic foot cubic yard
  LB__SEC__PER__FT3__YD3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-FT3-YD3"),
  // Ounce (UK Fluid) per Second
  OZ_VOL_UK__PER__SEC: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-SEC"),
  // cubic centimetre per hour bar
  CentiM3__PER__HR__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-HR-BAR"),
  // cubic metre per second pascal
  M3__PER__SEC__PA: Qudt.unitFromLocalnameRequired("M3-PER-SEC-PA"),
  // Milliwatts per square metre nanometre steradian
  MilliW__PER__M2__NanoM__SR: Qudt.unitFromLocalnameRequired(
    "MilliW-PER-M2-NanoM-SR"
  ),
  // Uganda Shilling
  UGX_Currency: Qudt.currencyFromLocalnameRequired("UGX"),
  // gram second per power of metre with the exponent 6
  GM__SEC__PER__M6: Qudt.unitFromLocalnameRequired("GM-SEC-PER-M6"),
  // Peck (US Dry) per Second
  PK_US_DRY__PER__SEC: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-SEC"),
  // millilitre per day kelvin
  MilliL__PER__DAY__K: Qudt.unitFromLocalnameRequired("MilliL-PER-DAY-K"),
  // Bit
  BIT: Qudt.unitFromLocalnameRequired("BIT"),
  // pound minute per cubic foot gallon (UK)
  LB__MIN__PER__FT3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-FT3-GAL_UK"
  ),
  // Joule per Second
  J__PER__SEC: Qudt.unitFromLocalnameRequired("J-PER-SEC"),
  // Barrel (UK Petroleum)
  BBL_UK_PET: Qudt.unitFromLocalnameRequired("BBL_UK_PET"),
  // Gigawatt Hour
  GigaW__HR: Qudt.unitFromLocalnameRequired("GigaW-HR"),
  // horsepower (water)
  HP_H2O: Qudt.unitFromLocalnameRequired("HP_H2O"),
  // percent per millimetre
  PERCENT__PER__MilliM: Qudt.unitFromLocalnameRequired("PERCENT-PER-MilliM"),
  // Percent per day
  PERCENT__PER__DAY: Qudt.unitFromLocalnameRequired("PERCENT-PER-DAY"),
  // Libyan Dinar
  LYD_Currency: Qudt.currencyFromLocalnameRequired("LYD"),
  // Ounce (US Fluid) per Day
  OZ_VOL_US__PER__DAY: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-DAY"),
  // pound hour per gallon (UK) cubic foot
  LB__HR__PER__GAL_UK__FT3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_UK-FT3"
  ),
  // Horsepower (metric)
  HP_Metric: Qudt.unitFromLocalnameRequired("HP_Metric"),
  // Square Foot Second Degree Fahrenheit
  FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired("FT2-SEC-DEG_F"),
  // Cayman Islands Dollar
  KYD_Currency: Qudt.currencyFromLocalnameRequired("KYD"),
  // micrometre per second
  MicroM__PER__SEC: Qudt.unitFromLocalnameRequired("MicroM-PER-SEC"),
  // ampere
  A: Qudt.unitFromLocalnameRequired("A"),
  // Pound Force per Foot
  LB_F__PER__FT: Qudt.unitFromLocalnameRequired("LB_F-PER-FT"),
  // megaohm metre
  MegaOHM__M: Qudt.unitFromLocalnameRequired("MegaOHM-M"),
  // Centibar
  CentiBAR: Qudt.unitFromLocalnameRequired("CentiBAR"),
  // FemtoGram
  FemtoGM: Qudt.unitFromLocalnameRequired("FemtoGM"),
  // Slug per Foot
  SLUG__PER__FT: Qudt.unitFromLocalnameRequired("SLUG-PER-FT"),
  // Micrograms per square metre day
  MicroGM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MicroGM-PER-M2-DAY"),
  // Kilogram per Day
  KiloGM__PER__DAY: Qudt.unitFromLocalnameRequired("KiloGM-PER-DAY"),
  // kilogram per cubic metre kelvin
  KiloGM__PER__M3__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-K"),
  // Terajoule
  TeraJ: Qudt.unitFromLocalnameRequired("TeraJ"),
  // american wire gage
  AWG: Qudt.unitFromLocalnameRequired("AWG"),
  // British thermal unit (thermochemical) per square foot
  BTU_TH__PER__FT2: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2"),
  // millimetres per day
  MilliM__PER__DAY: Qudt.unitFromLocalnameRequired("MilliM-PER-DAY"),
  // Quart (US Liquid) per Minute
  QT_US__PER__MIN: Qudt.unitFromLocalnameRequired("QT_US-PER-MIN"),
  // Number per litre
  NUM__PER__L: Qudt.unitFromLocalnameRequired("NUM-PER-L"),
  // Liter per Minute
  L__PER__MIN: Qudt.unitFromLocalnameRequired("L-PER-MIN"),
  // Number per hour
  NUM__PER__HR: Qudt.unitFromLocalnameRequired("NUM-PER-HR"),
  // Pascal per Minute
  PA__PER__MIN: Qudt.unitFromLocalnameRequired("PA-PER-MIN"),
  // Megaampere
  MegaA: Qudt.unitFromLocalnameRequired("MegaA"),
  // US Peck
  PK_US_DRY: Qudt.unitFromLocalnameRequired("PK_US_DRY"),
  // Dyne Centimeter
  DYN__CentiM: Qudt.unitFromLocalnameRequired("DYN-CentiM"),
  // Pound Mass (avoirdupois) per Square Foot
  LB__PER__FT2: Qudt.unitFromLocalnameRequired("LB-PER-FT2"),
  // kilogram per second kelvin
  KiloGM__PER__SEC__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-K"),
  // Foot per Day
  FT__PER__DAY: Qudt.unitFromLocalnameRequired("FT-PER-DAY"),
  // Microkatal per Liter
  MicroKAT__PER__L: Qudt.unitFromLocalnameRequired("MicroKAT-PER-L"),
  // ExaV
  ExaV: Qudt.unitFromLocalnameRequired("ExaV"),
  // pound second per gallon (UK) cubic yard
  LB__SEC__PER__GAL_UK__YD3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_UK-YD3"
  ),
  // Microsiemens per Centimetre
  MicroS__PER__CentiM: Qudt.unitFromLocalnameRequired("MicroS-PER-CentiM"),
  // European Composite Unit (EURCO) (Bonds market unit)
  XBA_Currency: Qudt.currencyFromLocalnameRequired("XBA"),
  // Kilogram per Year
  KiloGM__PER__YR: Qudt.unitFromLocalnameRequired("KiloGM-PER-YR"),
  // Pound Mass
  LB: Qudt.unitFromLocalnameRequired("LB"),
  // lumen second
  LM__SEC: Qudt.unitFromLocalnameRequired("LM-SEC"),
  // nanowatt per square metre
  NanoW__PER__M2: Qudt.unitFromLocalnameRequired("NanoW-PER-M2"),
  // Kilocalorie (thermochemical) per Second
  KiloCAL_TH__PER__SEC: Qudt.unitFromLocalnameRequired("KiloCAL_TH-PER-SEC"),
  // BEAT
  BEAT: Qudt.unitFromLocalnameRequired("BEAT"),
  // CASES
  CASES: Qudt.unitFromLocalnameRequired("CASES"),
  // Decibel Carrier Unit
  DeciB_C: Qudt.unitFromLocalnameRequired("DeciB_C"),
  // Kip per Square Inch
  KIP_F__PER__IN2: Qudt.unitFromLocalnameRequired("KIP_F-PER-IN2"),
  // ampere squared second
  A2__SEC: Qudt.unitFromLocalnameRequired("A2-SEC"),
  // Cubic Yard
  YD3: Qudt.unitFromLocalnameRequired("YD3"),
  // Joule per Square Tesla
  J__PER__T2: Qudt.unitFromLocalnameRequired("J-PER-T2"),
  // metre per pascal
  M__PER__PA: Qudt.unitFromLocalnameRequired("M-PER-PA"),
  // Percent per metre
  PERCENT__PER__M: Qudt.unitFromLocalnameRequired("PERCENT-PER-M"),
  // Reciprocal Square Giga Electron Volt Unit
  PER__GigaEV2: Qudt.unitFromLocalnameRequired("PER-GigaEV2"),
  // Watt per Cubic Metre
  W__PER__M3: Qudt.unitFromLocalnameRequired("W-PER-M3"),
  // Decinewton Metre
  DeciN__M: Qudt.unitFromLocalnameRequired("DeciN-M"),
  // Oersted Centimetre
  OERSTED__CentiM: Qudt.unitFromLocalnameRequired("OERSTED-CentiM"),
  // percent square foot per pound-force second
  PERCENT__FT2__PER__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "PERCENT-FT2-PER-LB_F-SEC"
  ),
  // ньютон-секунда
  N__SEC: Qudt.unitFromLocalnameRequired("N-SEC"),
  // Stokes
  ST: Qudt.unitFromLocalnameRequired("ST"),
  // kilojoule per hour
  KiloJ__PER__HR: Qudt.unitFromLocalnameRequired("KiloJ-PER-HR"),
  // Radian per Square Second
  RAD__PER__SEC2: Qudt.unitFromLocalnameRequired("RAD-PER-SEC2"),
  // Kilocalorie per Second
  KiloCAL__PER__SEC: Qudt.unitFromLocalnameRequired("KiloCAL-PER-SEC"),
  // sun protection factor
  SPF: Qudt.unitFromLocalnameRequired("SPF"),
  // генри
  H: Qudt.unitFromLocalnameRequired("H"),
  // Kilojoule per Kilogram
  KiloJ__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloJ-PER-KiloGM"),
  // ounce foot second per cubic inch pound
  OZ__FT__SEC__PER__IN3__LB: Qudt.unitFromLocalnameRequired(
    "OZ-FT-SEC-PER-IN3-LB"
  ),
  // Meter Kilogram
  M__KiloGM: Qudt.unitFromLocalnameRequired("M-KiloGM"),
  // Ampere per Millimeter
  A__PER__MilliM: Qudt.unitFromLocalnameRequired("A-PER-MilliM"),
  // pound minute per power of inch with the exponent 6
  LB__MIN__PER__IN6: Qudt.unitFromLocalnameRequired("LB-MIN-PER-IN6"),
  // Micro Joule
  MicroJ: Qudt.unitFromLocalnameRequired("MicroJ"),
  // Liter per Day
  L__PER__DAY: Qudt.unitFromLocalnameRequired("L-PER-DAY"),
  // Watt per Square Meter Quartic Kelvin
  W__PER__M2__K4: Qudt.unitFromLocalnameRequired("W-PER-M2-K4"),
  // Liter per Liter
  L__PER__L: Qudt.unitFromLocalnameRequired("L-PER-L"),
  // Iceland Krona
  ISK_Currency: Qudt.currencyFromLocalnameRequired("ISK"),
  // Joule per Cubic Meter
  J__PER__M3: Qudt.unitFromLocalnameRequired("J-PER-M3"),
  // Square metres per gram
  M2__PER__GM: Qudt.unitFromLocalnameRequired("M2-PER-GM"),
  // Cubic Decimeter per Hour
  DeciM3__PER__HR: Qudt.unitFromLocalnameRequired("DeciM3-PER-HR"),
  // Newton Square Metre
  N__M2: Qudt.unitFromLocalnameRequired("N-M2"),
  // Cubic Decameter
  DecaM3: Qudt.unitFromLocalnameRequired("DecaM3"),
  // decibel milliwatts per megahertz
  DeciB__MilliW__PER__MegaHZ: Qudt.unitFromLocalnameRequired(
    "DeciB-MilliW-PER-MegaHZ"
  ),
  // Number per cubic millimeter
  NUM__PER__MilliM3: Qudt.unitFromLocalnameRequired("NUM-PER-MilliM3"),
  // méter
  M: Qudt.unitFromLocalnameRequired("M"),
  // Kayser
  KY: Qudt.unitFromLocalnameRequired("KY"),
  // milligram hour per litre squared
  MilliGM__HR__PER__L2: Qudt.unitFromLocalnameRequired("MilliGM-HR-PER-L2"),
  // Reciprocal Psi
  PER__PSI: Qudt.unitFromLocalnameRequired("PER-PSI"),
  // radian per metre
  RAD__PER__M: Qudt.unitFromLocalnameRequired("RAD-PER-M"),
  // Erg per Gram
  ERG__PER__GM: Qudt.unitFromLocalnameRequired("ERG-PER-GM"),
  // Guinea Franc
  GNF_Currency: Qudt.currencyFromLocalnameRequired("GNF"),
  // Square centimeters per gram
  CentiM2__PER__GM: Qudt.unitFromLocalnameRequired("CentiM2-PER-GM"),
  // ohm kilometre
  OHM__KiloM: Qudt.unitFromLocalnameRequired("OHM-KiloM"),
  // Centimetres per year
  CentiM__PER__YR: Qudt.unitFromLocalnameRequired("CentiM-PER-YR"),
  // kilomole per cubic metre kelvin
  KiloMOL__PER__M3__K: Qudt.unitFromLocalnameRequired("KiloMOL-PER-M3-K"),
  // Micrograms per cubic metre hour
  MicroGM__PER__M3__HR: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3-HR"),
  // Growing Degree Days (Cereals)
  DEG_C_GROWING_CEREAL__DAY: Qudt.unitFromLocalnameRequired(
    "DEG_C_GROWING_CEREAL-DAY"
  ),
  // Square metres cubic Hertz
  M2__HZ3: Qudt.unitFromLocalnameRequired("M2-HZ3"),
  // Number per nanoliter
  NUM__PER__NanoL: Qudt.unitFromLocalnameRequired("NUM-PER-NanoL"),
  // Reciprocal Cubic Yard
  PER__YD3: Qudt.unitFromLocalnameRequired("PER-YD3"),
  // Chilean Peso
  CLP_Currency: Qudt.currencyFromLocalnameRequired("CLP"),
  // Decametre
  DecaM: Qudt.unitFromLocalnameRequired("DecaM"),
  // Micromoles per litre hour
  MicroMOL__PER__L__HR: Qudt.unitFromLocalnameRequired("MicroMOL-PER-L-HR"),
  // Bahraini Dinar
  BHD_Currency: Qudt.currencyFromLocalnameRequired("BHD"),
  // gram minute per litre cubic metre
  GM__MIN__PER__L__M3: Qudt.unitFromLocalnameRequired("GM-MIN-PER-L-M3"),
  // Horsepower
  HP: Qudt.unitFromLocalnameRequired("HP"),
  // Foot Lambert
  LA_FT: Qudt.unitFromLocalnameRequired("LA_FT"),
  // tonne per minute bar
  TONNE__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-MIN-BAR"),
  // radián por segundo
  RAD__PER__SEC: Qudt.unitFromLocalnameRequired("RAD-PER-SEC"),
  // Millibar per Bar
  MilliBAR__PER__BAR: Qudt.unitFromLocalnameRequired("MilliBAR-PER-BAR"),
  // Metric Ton
  TON_Metric: Qudt.unitFromLocalnameRequired("TON_Metric"),
  // gram per second bar
  GM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("GM-PER-SEC-BAR"),
  // Joule
  J: Qudt.unitFromLocalnameRequired("J"),
  // Bermuda Dollar
  BMD_Currency: Qudt.currencyFromLocalnameRequired("BMD"),
  // ton short per psi
  TON_SHORT__PER__PSI: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-PSI"),
  // inch of mercury (60 °F)
  IN_HG_60DEG_F: Qudt.unitFromLocalnameRequired("IN_HG_60DEG_F"),
  // Kilo Newton per square metre
  KiloN__PER__M2: Qudt.unitFromLocalnameRequired("KiloN-PER-M2"),
  // megagray
  MegaGRAY: Qudt.unitFromLocalnameRequired("MegaGRAY"),
  // Reciprocal Square Electron Volt
  PER__EV2: Qudt.unitFromLocalnameRequired("PER-EV2"),
  // Pa'anga
  TOP_Currency: Qudt.currencyFromLocalnameRequired("TOP"),
  // megahertz kilometre
  Megahertz__KiloM: Qudt.unitFromLocalnameRequired("Megahertz-KiloM"),
  // Picomoles per square metre day
  PicoMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("PicoMOL-PER-M2-DAY"),
  // centimetre of mercury (0 °C)
  CentiM_HG_0DEG_C: Qudt.unitFromLocalnameRequired("CentiM_HG_0DEG_C"),
  // Kilocalorie
  KiloCAL: Qudt.unitFromLocalnameRequired("KiloCAL"),
  // Degree Fahrenheit per Square Second
  DEG_F__PER__SEC2: Qudt.unitFromLocalnameRequired("DEG_F-PER-SEC2"),
  // Quartic Inch
  IN4: Qudt.unitFromLocalnameRequired("IN4"),
  // Milli-inch
  MilliIN: Qudt.unitFromLocalnameRequired("MilliIN"),
  // ohm-mètre
  OHM__M: Qudt.unitFromLocalnameRequired("OHM-M"),
  // Special Drawing Rights
  XDR_Currency: Qudt.currencyFromLocalnameRequired("XDR"),
  // perm (23 °C)
  PERM_23DEG_C: Qudt.unitFromLocalnameRequired("PERM_23DEG_C"),
  // pound square foot per cubic inch pound-force second
  LB__FT2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-FT2-PER-IN3-LB_F-SEC"
  ),
  // petavolt ampere
  PetaV__A: Qudt.unitFromLocalnameRequired("PetaV-A"),
  // MicroTorr
  MicroTORR: Qudt.unitFromLocalnameRequired("MicroTORR"),
  // Second per Radian Cubic Meter
  SEC__PER__RAD__M3: Qudt.unitFromLocalnameRequired("SEC-PER-RAD-M3"),
  // pound minute per gallon (UK) cubic foot
  LB__MIN__PER__GAL_UK__FT3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_UK-FT3"
  ),
  // Pascal metres per second
  PA__M__PER__SEC: Qudt.unitFromLocalnameRequired("PA-M-PER-SEC"),
  // Planck Frequency
  PlanckFrequency: Qudt.unitFromLocalnameRequired("PlanckFrequency"),
  // Microcoulomb per Square Metre
  MicroC__PER__M2: Qudt.unitFromLocalnameRequired("MicroC-PER-M2"),
  // Newton metre per metre
  N__M__PER__M: Qudt.unitFromLocalnameRequired("N-M-PER-M"),
  // BTU (IT) Foot per Square Foot Hour Degree Fahrenheit
  BTU_IT__FT__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-FT-PER-FT2-HR-DEG_F"
  ),
  // Square Yard
  YD2: Qudt.unitFromLocalnameRequired("YD2"),
  // Pascal Second per Metre
  PA__SEC__PER__M: Qudt.unitFromLocalnameRequired("PA-SEC-PER-M"),
  // gram minute per litre cubic centimetre
  GM__MIN__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-MIN-PER-L-CentiM3"
  ),
  // MilliKAT
  MilliKAT: Qudt.unitFromLocalnameRequired("MilliKAT"),
  // Lempira
  HNL_Currency: Qudt.currencyFromLocalnameRequired("HNL"),
  // Venezuelan bolvar
  VES_Currency: Qudt.currencyFromLocalnameRequired("VES"),
  // Nanosiemens per Metre
  NanoS__PER__M: Qudt.unitFromLocalnameRequired("NanoS-PER-M"),
  // Kenyan Shilling
  KES_Currency: Qudt.currencyFromLocalnameRequired("KES"),
  // जूल प्रति मोल (इकाई)
  J__PER__MOL: Qudt.unitFromLocalnameRequired("J-PER-MOL"),
  // Square Millimetre per Second
  MilliM2__PER__SEC: Qudt.unitFromLocalnameRequired("MilliM2-PER-SEC"),
  // Cubic Centimeter per Minute
  CentiM3__PER__MIN: Qudt.unitFromLocalnameRequired("CentiM3-PER-MIN"),
  // Joule per Gram
  J__PER__GM: Qudt.unitFromLocalnameRequired("J-PER-GM"),
  // watt per steradian square metre
  W__PER__SR__M2: Qudt.unitFromLocalnameRequired("W-PER-SR-M2"),
  // GigaByte
  GigaBYTE: Qudt.unitFromLocalnameRequired("GigaBYTE"),
  // part per trillion
  PPT: Qudt.unitFromLocalnameRequired("PPT"),
  // kilogram per cubic metre bar
  KiloGM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-BAR"),
  // Ounce (UK Fluid) per Day
  OZ_VOL_UK__PER__DAY: Qudt.unitFromLocalnameRequired("OZ_VOL_UK-PER-DAY"),
  // Micromoles per square metre hour
  MicroMOL__PER__M2__HR: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2-HR"),
  // gram per hour kelvin
  GM__PER__HR__K: Qudt.unitFromLocalnameRequired("GM-PER-HR-K"),
  // British thermal unit (thermochemical) per degree Rankine
  BTU_TH__PER__DEG_R: Qudt.unitFromLocalnameRequired("BTU_TH-PER-DEG_R"),
  // Milliwatt per Square Metre
  MilliW__PER__M2: Qudt.unitFromLocalnameRequired("MilliW-PER-M2"),
  // percent square inch per pound-force second
  PERCENT__IN2__PER__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "PERCENT-IN2-PER-LB_F-SEC"
  ),
  // pebibit per metre
  PebiBIT__PER__M: Qudt.unitFromLocalnameRequired("PebiBIT-PER-M"),
  // Quart (US Liquid) per Second
  QT_US__PER__SEC: Qudt.unitFromLocalnameRequired("QT_US-PER-SEC"),
  // Slovak Koruna
  SKK_Currency: Qudt.currencyFromLocalnameRequired("SKK"),
  // Henry per Ohm
  H__PER__OHM: Qudt.unitFromLocalnameRequired("H-PER-OHM"),
  // Swiss Francs per kilogram
  CHF__PER__KiloGM: Qudt.unitFromLocalnameRequired("CHF-PER-KiloGM"),
  // Henry per Kiloohm
  H__PER__KiloOHM: Qudt.unitFromLocalnameRequired("H-PER-KiloOHM"),
  // pound hour per square gallon (UK)
  LB__HR__PER__GAL_UK2: Qudt.unitFromLocalnameRequired("LB-HR-PER-GAL_UK2"),
  // Million US Dollars
  MegaUSD_Currency: Qudt.currencyFromLocalnameRequired("MegaUSD"),
  // pound square foot per gallon (US) pound-force second
  LB__FT2__PER__GAL_US__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-FT2-PER-GAL_US-LB_F-SEC"
  ),
  // Pound per Cubic Meter
  LB__PER__M3: Qudt.unitFromLocalnameRequired("LB-PER-M3"),
  // millilitre per second kelvin
  MilliL__PER__SEC__K: Qudt.unitFromLocalnameRequired("MilliL-PER-SEC-K"),
  // Reciprocal Pascal per second
  PER__PA__SEC: Qudt.unitFromLocalnameRequired("PER-PA-SEC"),
  // Picokatal per Liter
  PicoKAT__PER__L: Qudt.unitFromLocalnameRequired("PicoKAT-PER-L"),
  // Joule Square Meter
  J__M2: Qudt.unitFromLocalnameRequired("J-M2"),
  // ньютон-метр-секунда
  N__M__SEC: Qudt.unitFromLocalnameRequired("N-M-SEC"),
  // percent minute per litre
  PERCENT__MIN__PER__L: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-L"),
  // Slug per Hour
  SLUG__PER__HR: Qudt.unitFromLocalnameRequired("SLUG-PER-HR"),
  // Bushel (US Dry) per Day
  BU_US_DRY__PER__DAY: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-DAY"),
  // metre per radian
  M__PER__RAD: Qudt.unitFromLocalnameRequired("M-PER-RAD"),
  // kilogram per minute bar
  KiloGM__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-MIN-BAR"),
  // Erg per Cubic Centimetre
  ERG__PER__CentiM3: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM3"),
  // Barbados Dollar
  BBD_Currency: Qudt.currencyFromLocalnameRequired("BBD"),
  // Number per 100 grams
  NUM__PER__HectoGM: Qudt.unitFromLocalnameRequired("NUM-PER-HectoGM"),
  // Megajoule per Square Meter
  MegaJ__PER__M2: Qudt.unitFromLocalnameRequired("MegaJ-PER-M2"),
  // Millimoles per square metre
  MilliMOL__PER__M2: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M2"),
  // millipascal second per kelvin
  MilliPA__SEC__PER__K: Qudt.unitFromLocalnameRequired("MilliPA-SEC-PER-K"),
  // Afghani
  AFN_Currency: Qudt.currencyFromLocalnameRequired("AFN"),
  // Jordanian Dinar
  JOD_Currency: Qudt.currencyFromLocalnameRequired("JOD"),
  // percent per percent
  PERCENT__PER__PERCENT: Qudt.unitFromLocalnameRequired("PERCENT-PER-PERCENT"),
  // Femtojoule
  FemtoJ: Qudt.unitFromLocalnameRequired("FemtoJ"),
  // Kiloweber per Meter
  KiloWB__PER__M: Qudt.unitFromLocalnameRequired("KiloWB-PER-M"),
  // Planck Impedance
  PlanckImpedance: Qudt.unitFromLocalnameRequired("PlanckImpedance"),
  // Kwanza
  AOA_Currency: Qudt.currencyFromLocalnameRequired("AOA"),
  // reciprocal degree Fahrenheit
  PER__DEG_F: Qudt.unitFromLocalnameRequired("PER-DEG_F"),
  // Reciprocal Kelvin
  PER__K: Qudt.unitFromLocalnameRequired("PER-K"),
  // kilogram per cubic decimetre bar
  KiloGM__PER__DeciM3__BAR: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-DeciM3-BAR"
  ),
  // Peso Uruguayo
  UYU_Currency: Qudt.currencyFromLocalnameRequired("UYU"),
  // Dec
  DECADE: Qudt.unitFromLocalnameRequired("DECADE"),
  // Foot per Minute
  FT__PER__MIN: Qudt.unitFromLocalnameRequired("FT-PER-MIN"),
  // Volt Ampere Reactive Hour
  V__A_Reactive__HR: Qudt.unitFromLocalnameRequired("V-A_Reactive-HR"),
  // Kelvin Meter per Watt
  K__M__PER__W: Qudt.unitFromLocalnameRequired("K-M-PER-W"),
  // kilometre per second bar
  KiloM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("KiloM-PER-SEC-BAR"),
  // Cubic Metre per Day
  M3__PER__DAY: Qudt.unitFromLocalnameRequired("M3-PER-DAY"),
  // Pound (avoirdupois) per Gallon (US)
  LB__PER__GAL_US: Qudt.unitFromLocalnameRequired("LB-PER-GAL_US"),
  // Costa Rican Colon
  CRC_Currency: Qudt.currencyFromLocalnameRequired("CRC"),
  // Forint
  HUF_Currency: Qudt.currencyFromLocalnameRequired("HUF"),
  // Belarussian Ruble
  BYN_Currency: Qudt.currencyFromLocalnameRequired("BYN"),
  // Reciprocal Henry
  PER__H: Qudt.unitFromLocalnameRequired("PER-H"),
  // Square Foot Degree Fahrenheit
  FT2__DEG_F: Qudt.unitFromLocalnameRequired("FT2-DEG_F"),
  // Newtonmetersekunden pro Meter
  N__M__SEC__PER__M: Qudt.unitFromLocalnameRequired("N-M-SEC-PER-M"),
  // Cubic Yard per Degree Fahrenheit
  YD3__PER__DEG_F: Qudt.unitFromLocalnameRequired("YD3-PER-DEG_F"),
  // pound (avoirdupois) per cubic inch degree Fahrenheit
  LB__PER__IN3__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-IN3-DEG_F"),
  // Mole per Kilogram
  MOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM"),
  // Millicoulomb per Cubic Metre
  MilliC__PER__M3: Qudt.unitFromLocalnameRequired("MilliC-PER-M3"),
  // Milliwatts per square metre nanometre
  MilliW__PER__M2__NanoM: Qudt.unitFromLocalnameRequired("MilliW-PER-M2-NanoM"),
  // percent hour per cubic metre
  PERCENT__HR__PER__M3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-M3"),
  // Pint (US Liquid) per Hour
  PINT_US__PER__HR: Qudt.unitFromLocalnameRequired("PINT_US-PER-HR"),
  // Micrometer per Minute
  MicroM__PER__MIN: Qudt.unitFromLocalnameRequired("MicroM-PER-MIN"),
  // Radian Square Metre per Mole
  RAD__M2__PER__MOL: Qudt.unitFromLocalnameRequired("RAD-M2-PER-MOL"),
  // Watts per square metre metre
  W__PER__M2__M: Qudt.unitFromLocalnameRequired("W-PER-M2-M"),
  // MegaK
  MegaK: Qudt.unitFromLocalnameRequired("MegaK"),
  // Square Foot per BTU Inch
  FT2__PER__BTU_IT__IN: Qudt.unitFromLocalnameRequired("FT2-PER-BTU_IT-IN"),
  // W-M2-PER-SR
  W__M2__PER__SR: Qudt.unitFromLocalnameRequired("W-M2-PER-SR"),
  // milligram minute per litre cubic metre
  MilliGM__MIN__PER__L__M3: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-L-M3"
  ),
  // Gray
  GRAY: Qudt.unitFromLocalnameRequired("GRAY"),
  // ArcSecond
  ARCSEC: Qudt.unitFromLocalnameRequired("ARCSEC"),
  // Coulomb per Square Millimeter
  C__PER__MilliM2: Qudt.unitFromLocalnameRequired("C-PER-MilliM2"),
  // Neper
  NP: Qudt.unitFromLocalnameRequired("NP"),
  // calorie (thermochemical) per square centimetre second
  CAL_TH__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM2-SEC"
  ),
  // Joule per Hour
  J__PER__HR: Qudt.unitFromLocalnameRequired("J-PER-HR"),
  // Gram Force
  GM_F: Qudt.unitFromLocalnameRequired("GM_F"),
  // DeciCoulomb
  DeciC: Qudt.unitFromLocalnameRequired("DeciC"),
  // Microsiemens per Meter
  MicroS__PER__M: Qudt.unitFromLocalnameRequired("MicroS-PER-M"),
  // Pint (US Liquid) per Minute
  PINT_US__PER__MIN: Qudt.unitFromLocalnameRequired("PINT_US-PER-MIN"),
  // HectoKiloCount
  HectoKiloCount: Qudt.unitFromLocalnameRequired("HectoKiloCount"),
  // yard per second squared
  YD__PER__SEC2: Qudt.unitFromLocalnameRequired("YD-PER-SEC2"),
  // Beaufort
  BFT: Qudt.unitFromLocalnameRequired("BFT"),
  // grams per square meter day
  GM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("GM-PER-M2-DAY"),
  // Reciprocal Week
  PER__WK: Qudt.unitFromLocalnameRequired("PER-WK"),
  // Foot Pound Force per Hour
  FT__LB_F__PER__HR: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-HR"),
  // Microbecquerels per kilogram
  MicroBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MicroBQ-PER-KiloGM"),
  // inch per second degree Fahrenheit
  IN__PER__SEC__DEG_F: Qudt.unitFromLocalnameRequired("IN-PER-SEC-DEG_F"),
  // Bolivian Mvdol (Funds code)
  BOV_Currency: Qudt.currencyFromLocalnameRequired("BOV"),
  // percent per millipascal second
  PERCENT__PER__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-MilliPA-SEC"
  ),
  // Picomoles per cubic metre second
  PicoMOL__PER__M3__SEC: Qudt.unitFromLocalnameRequired("PicoMOL-PER-M3-SEC"),
  // cubic yard per psi
  YD3__PER__PSI: Qudt.unitFromLocalnameRequired("YD3-PER-PSI"),
  // Millisiemens per Centimetre
  MilliS__PER__CentiM: Qudt.unitFromLocalnameRequired("MilliS-PER-CentiM"),
  // Point
  PT: Qudt.unitFromLocalnameRequired("PT"),
  // Quartic Meter
  M4: Qudt.unitFromLocalnameRequired("M4"),
  // Micrograms per litre hour
  MicroGM__PER__L__HR: Qudt.unitFromLocalnameRequired("MicroGM-PER-L-HR"),
  // square mile (based on U.S. survey foot)
  MI_US2: Qudt.unitFromLocalnameRequired("MI_US2"),
  // Picowatt
  PicoW: Qudt.unitFromLocalnameRequired("PicoW"),
  // Dry Gallon US
  GAL_US_DRY: Qudt.unitFromLocalnameRequired("GAL_US_DRY"),
  // Gill (US) per Hour
  GI_US__PER__HR: Qudt.unitFromLocalnameRequired("GI_US-PER-HR"),
  // Gram per Millilitre
  GM__PER__MilliL: Qudt.unitFromLocalnameRequired("GM-PER-MilliL"),
  // ohm per metre
  OHM__PER__M: Qudt.unitFromLocalnameRequired("OHM-PER-M"),
  // Pascal Cubic Meter per Second
  PA__M3__PER__SEC: Qudt.unitFromLocalnameRequired("PA-M3-PER-SEC"),
  // Reciprocal Second Square Metre Steradian
  PER__SEC__M2__SR: Qudt.unitFromLocalnameRequired("PER-SEC-M2-SR"),
  // Degree Rankine
  DEG_R: Qudt.unitFromLocalnameRequired("DEG_R"),
  // cubic foot per psi
  FT3__PER__PSI: Qudt.unitFromLocalnameRequired("FT3-PER-PSI"),
  // cubic metre per day kelvin
  M3__PER__DAY__K: Qudt.unitFromLocalnameRequired("M3-PER-DAY-K"),
  // Millilitre per Cubic Meter
  MilliL__PER__M3: Qudt.unitFromLocalnameRequired("MilliL-PER-M3"),
  // volt square inch per pound-force
  V__IN2__PER__LB_F: Qudt.unitFromLocalnameRequired("V-IN2-PER-LB_F"),
  // kilovolt ampere reactive per kelvin
  KiloV__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired(
    "KiloV-A_Reactive-PER-K"
  ),
  // A_Reactive
  A_Reactive: Qudt.unitFromLocalnameRequired("A_Reactive"),
  // Frame per Second
  FRAME__PER__SEC: Qudt.unitFromLocalnameRequired("FRAME-PER-SEC"),
  // Mole per Cubic Decimeter
  MOL__PER__DeciM3: Qudt.unitFromLocalnameRequired("MOL-PER-DeciM3"),
  // kilogram metre
  KiloGM__M: Qudt.unitFromLocalnameRequired("KiloGM-M"),
  // percent minute per gallon (US)
  PERCENT__MIN__PER__GAL_US: Qudt.unitFromLocalnameRequired(
    "PERCENT-MIN-PER-GAL_US"
  ),
  // Decibars per year
  DeciBAR__PER__YR: Qudt.unitFromLocalnameRequired("DeciBAR-PER-YR"),
  // Milligram per Kilogram
  MilliGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliGM-PER-KiloGM"),
  // Second Square Foot
  SEC__FT2: Qudt.unitFromLocalnameRequired("SEC-FT2"),
  // Femtograms per kilogram
  FemtoGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("FemtoGM-PER-KiloGM"),
  // bar per degree Celsius
  BAR__PER__DEG_C: Qudt.unitFromLocalnameRequired("BAR-PER-DEG_C"),
  // pound (avoirdupois) per hour degree Fahrenheit
  LB__PER__HR__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-HR-DEG_F"),
  // Siemens Square metre per mole
  S__M2__PER__MOL: Qudt.unitFromLocalnameRequired("S-M2-PER-MOL"),
  // meganewton metre per square metre
  MegaN__M__PER__M2: Qudt.unitFromLocalnameRequired("MegaN-M-PER-M2"),
  // Cubic Foot per Minute
  FT3__PER__MIN: Qudt.unitFromLocalnameRequired("FT3-PER-MIN"),
  // Gauss
  GAUSS: Qudt.unitFromLocalnameRequired("GAUSS"),
  // Parts per million
  PPM: Qudt.unitFromLocalnameRequired("PPM"),
  // Ton (UK)
  TON_UK: Qudt.unitFromLocalnameRequired("TON_UK"),
  // Degree Baume (origin Scale)
  DEGREE_BAUME: Qudt.unitFromLocalnameRequired("DEGREE_BAUME"),
  // inch per psi
  IN__PER__PSI: Qudt.unitFromLocalnameRequired("IN-PER-PSI"),
  // Megabar
  MegaBAR: Qudt.unitFromLocalnameRequired("MegaBAR"),
  // Mega Hertz per Kelvin
  MegaHZ__PER__K: Qudt.unitFromLocalnameRequired("MegaHZ-PER-K"),
  // British thermal unit (thermochemical) per square foot minute
  BTU_TH__PER__FT2__MIN: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2-MIN"),
  // Hectopascal Litre per Second
  HectoPA__L__PER__SEC: Qudt.unitFromLocalnameRequired("HectoPA-L-PER-SEC"),
  // percent per one hundred thousand
  PERCENT__PER__HectoKiloCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-HectoKiloCount"
  ),
  // Psi Cubic Inch per Second
  PSI__IN3__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-IN3-PER-SEC"),
  // milligray per minute
  MilliGRAY__PER__MIN: Qudt.unitFromLocalnameRequired("MilliGRAY-PER-MIN"),
  // Reciprocal micromole per litre
  PER__MicroMOL__L: Qudt.unitFromLocalnameRequired("PER-MicroMOL-L"),
  // Reciprocal Second Square Meter
  PER__SEC__M2: Qudt.unitFromLocalnameRequired("PER-SEC-M2"),
  // pound hour per gallon (UK) cubic inch
  LB__HR__PER__GAL_UK__IN3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_UK-IN3"
  ),
  // Micrometre per Kelvin
  MicroM__PER__K: Qudt.unitFromLocalnameRequired("MicroM-PER-K"),
  // Nanogram per Cubic Metre
  NanoGM__PER__M3: Qudt.unitFromLocalnameRequired("NanoGM-PER-M3"),
  // percent per hectobar
  PERCENT__PER__HectoBAR: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-HectoBAR"
  ),
  // milliohm per bar
  MilliOHM__PER__BAR: Qudt.unitFromLocalnameRequired("MilliOHM-PER-BAR"),
  // PebiBIT
  PebiBIT: Qudt.unitFromLocalnameRequired("PebiBIT"),
  // gram per centimetre second
  GM__PER__CentiM__SEC: Qudt.unitFromLocalnameRequired("GM-PER-CentiM-SEC"),
  // Cases per 1000 individuals year
  CASES__PER__KiloINDIV__YR: Qudt.unitFromLocalnameRequired(
    "CASES-PER-KiloINDIV-YR"
  ),
  // volt per litre minute
  V__PER__L__MIN: Qudt.unitFromLocalnameRequired("V-PER-L-MIN"),
  // British Thermal Unit (international Table) per Second Square Foot degree Rankine
  BTU_IT__PER__SEC__FT2__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-SEC-FT2-DEG_R"
  ),
  // Centipoise per Bar
  CentiPOISE__PER__BAR: Qudt.unitFromLocalnameRequired("CentiPOISE-PER-BAR"),
  // percent second per cubic inch
  PERCENT__SEC__PER__IN3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-IN3"),
  // Standard Cubic Metre
  SCM: Qudt.unitFromLocalnameRequired("SCM"),
  // Deaths per 1000 individuals year
  DEATHS__PER__1000I__YR: Qudt.unitFromLocalnameRequired("DEATHS-PER-1000I-YR"),
  // KiloCoulomb
  KiloC: Qudt.unitFromLocalnameRequired("KiloC"),
  // Net tonnage
  NT: Qudt.unitFromLocalnameRequired("NT"),
  // baud
  BAUD: Qudt.unitFromLocalnameRequired("BAUD"),
  // Degree Plato
  DEGREE_PLATO: Qudt.unitFromLocalnameRequired("DEGREE_PLATO"),
  // megaohm kilometre
  MegaOHM__KiloM: Qudt.unitFromLocalnameRequired("MegaOHM-KiloM"),
  // Square Foot per Second
  FT2__PER__SEC: Qudt.unitFromLocalnameRequired("FT2-PER-SEC"),
  // gray per hour
  GRAY__PER__HR: Qudt.unitFromLocalnameRequired("GRAY-PER-HR"),
  // Becquerel per Cubic Metre
  BQ__PER__M3: Qudt.unitFromLocalnameRequired("BQ-PER-M3"),
  // Kilometre per Second
  KiloM__PER__SEC: Qudt.unitFromLocalnameRequired("KiloM-PER-SEC"),
  // Microsiemens
  MicroS: Qudt.unitFromLocalnameRequired("MicroS"),
  // Reciprocal Square Joule
  PER__J2: Qudt.unitFromLocalnameRequired("PER-J2"),
  // watt hour per kilogram
  W__HR__PER__KiloGM: Qudt.unitFromLocalnameRequired("W-HR-PER-KiloGM"),
  // Failures In Time
  failures__in__time: Qudt.unitFromLocalnameRequired("failures-in-time"),
  // BTU (IT) Inch per Square Foot Second Degree Fahrenheit
  BTU_IT__IN__PER__FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-FT2-SEC-DEG_F"
  ),
  // BTU (IT) per Degree Fahrenheit
  BTU_IT__PER__DEG_F: Qudt.unitFromLocalnameRequired("BTU_IT-PER-DEG_F"),
  // roentgen equivalent man
  R_man: Qudt.unitFromLocalnameRequired("R_man"),
  // Megalitre
  MegaL: Qudt.unitFromLocalnameRequired("MegaL"),
  // pound second per power of foot with the exponent 6
  LB__SEC__PER__FT6: Qudt.unitFromLocalnameRequired("LB-SEC-PER-FT6"),
  // percent minute per cubic centimetre
  PERCENT__MIN__PER__CentiM3: Qudt.unitFromLocalnameRequired(
    "PERCENT-MIN-PER-CentiM3"
  ),
  // Ampere Turn per Inch
  AT__PER__IN: Qudt.unitFromLocalnameRequired("AT-PER-IN"),
  // Microwatt
  MicroW: Qudt.unitFromLocalnameRequired("MicroW"),
  // Ampere je Meter
  A__PER__M: Qudt.unitFromLocalnameRequired("A-PER-M"),
  // Watt per Square Centimeter
  W__PER__CentiM2: Qudt.unitFromLocalnameRequired("W-PER-CentiM2"),
  // Decibel Referred to 1mw
  DeciB_M: Qudt.unitFromLocalnameRequired("DeciB_M"),
  // Cubic Centimeter per Cubic Meter
  CentiM3__PER__M3: Qudt.unitFromLocalnameRequired("CentiM3-PER-M3"),
  // kibibit per metre
  KibiBIT__PER__M: Qudt.unitFromLocalnameRequired("KibiBIT-PER-M"),
  // inch poundal
  IN__PDL: Qudt.unitFromLocalnameRequired("IN-PDL"),
  // tonne per hectare year
  TONNE__PER__HA__YR: Qudt.unitFromLocalnameRequired("TONNE-PER-HA-YR"),
  // Slug per Minute
  SLUG__PER__MIN: Qudt.unitFromLocalnameRequired("SLUG-PER-MIN"),
  // litre per second kelvin
  L__PER__SEC__K: Qudt.unitFromLocalnameRequired("L-PER-SEC-K"),
  // Absiemen
  S_Ab: Qudt.unitFromLocalnameRequired("S_Ab"),
  // Microinch
  MicroIN: Qudt.unitFromLocalnameRequired("MicroIN"),
  // Saudi Riyal
  SAR_Currency: Qudt.currencyFromLocalnameRequired("SAR"),
  // Moles per square metre second metre steradian
  MOL__PER__M2__SEC__M__SR: Qudt.unitFromLocalnameRequired(
    "MOL-PER-M2-SEC-M-SR"
  ),
  // Gold franc (special settlement currency)
  XFO_Currency: Qudt.currencyFromLocalnameRequired("XFO"),
  // GM_Nitrogen
  GM_Nitrogen: Qudt.unitFromLocalnameRequired("GM_Nitrogen"),
  // Micromole
  MicroMOL: Qudt.unitFromLocalnameRequired("MicroMOL"),
  // Cubic Centimetre per Mole
  CentiM3__PER__MOL: Qudt.unitFromLocalnameRequired("CentiM3-PER-MOL"),
  // milligram hour per litre cubic metre
  MilliGM__HR__PER__L__M3: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-L-M3"
  ),
  // Watt seconds per square metre
  W__SEC__PER__M2: Qudt.unitFromLocalnameRequired("W-SEC-PER-M2"),
  // Erg Second
  ERG__SEC: Qudt.unitFromLocalnameRequired("ERG-SEC"),
  // Liter per Hour
  L__PER__HR: Qudt.unitFromLocalnameRequired("L-PER-HR"),
  // Reciprocal Tesla Metre
  PER__T__M: Qudt.unitFromLocalnameRequired("PER-T-M"),
  // Watt per Square Metre Pascal
  W__PER__M2__PA: Qudt.unitFromLocalnameRequired("W-PER-M2-PA"),
  // Farad per Kilometre
  FARAD__PER__KiloM: Qudt.unitFromLocalnameRequired("FARAD-PER-KiloM"),
  // petafloating point operations per second
  PetaFLOPS: Qudt.unitFromLocalnameRequired("PetaFLOPS"),
  // Ton (UK Shipping)
  TON_SHIPPING_UK: Qudt.unitFromLocalnameRequired("TON_SHIPPING_UK"),
  // Pound Mole Degree Fahrenheit
  LB__MOL__DEG_F: Qudt.unitFromLocalnameRequired("LB-MOL-DEG_F"),
  // Long Hundred Weight
  CWT_LONG: Qudt.unitFromLocalnameRequired("CWT_LONG"),
  // Cubic Decimeter per Mole
  DeciM3__PER__MOL: Qudt.unitFromLocalnameRequired("DeciM3-PER-MOL"),
  // ohm per kelvin
  OHM__PER__K: Qudt.unitFromLocalnameRequired("OHM-PER-K"),
  // centigray
  CentiGRAY: Qudt.unitFromLocalnameRequired("CentiGRAY"),
  // Kilograms per square metre Pascal second
  KiloGM__PER__M2__PA__SEC: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-M2-PA-SEC"
  ),
  // Cuban Peso
  CUP_Currency: Qudt.currencyFromLocalnameRequired("CUP"),
  // Pound Force
  LB_F: Qudt.unitFromLocalnameRequired("LB_F"),
  // Mile per Minute
  MI__PER__MIN: Qudt.unitFromLocalnameRequired("MI-PER-MIN"),
  // milliampere per pound-force square inch
  MilliA__PER__LB_F__IN2: Qudt.unitFromLocalnameRequired("MilliA-PER-LB_F-IN2"),
  // Square Metre per Joule
  M2__PER__J: Qudt.unitFromLocalnameRequired("M2-PER-J"),
  // Mexican Unidad de Inversion (UDI) (Funds code)
  MXV_Currency: Qudt.currencyFromLocalnameRequired("MXV"),
  // Richter magnitude
  RichterMagnitude: Qudt.unitFromLocalnameRequired("RichterMagnitude"),
  // mile (statute mile) per second squared
  MI_US__PER__SEC2: Qudt.unitFromLocalnameRequired("MI_US-PER-SEC2"),
  // Gram per Square Metre
  GM__PER__M2: Qudt.unitFromLocalnameRequired("GM-PER-M2"),
  // Kilo British Thermal Unit (International Definition)
  KiloBTU_IT: Qudt.unitFromLocalnameRequired("KiloBTU_IT"),
  // litre per hour bar
  L__PER__HR__BAR: Qudt.unitFromLocalnameRequired("L-PER-HR-BAR"),
  // Psi Litre per Second
  PSI__L__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-L-PER-SEC"),
  // cubic foot per pound
  FT3__PER__LB: Qudt.unitFromLocalnameRequired("FT3-PER-LB"),
  // Square Meter Kelvin
  M2__K: Qudt.unitFromLocalnameRequired("M2-K"),
  // Kilogram per Square Second
  KiloGM__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC2"),
  // Pound Sterling
  GBP_Currency: Qudt.currencyFromLocalnameRequired("GBP"),
  // Flight
  Flight: Qudt.unitFromLocalnameRequired("Flight"),
  // kilogram per cubic decimetre kelvin
  KiloGM__PER__DeciM3__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-DeciM3-K"),
  // Kilogram per Kilomol
  KiloGM__PER__KiloMOL: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloMOL"),
  // Oct
  OCT: Qudt.unitFromLocalnameRequired("OCT"),
  // Stilb
  STILB: Qudt.unitFromLocalnameRequired("STILB"),
  // Deaths per Million individuals year
  DEATHS__PER__1000000I__YR: Qudt.unitFromLocalnameRequired(
    "DEATHS-PER-1000000I-YR"
  ),
  // Nanosiemens per Centimetre
  NanoS__PER__CentiM: Qudt.unitFromLocalnameRequired("NanoS-PER-CentiM"),
  // gram per hour bar
  GM__PER__HR__BAR: Qudt.unitFromLocalnameRequired("GM-PER-HR-BAR"),
  // Kelvin per Kelvin
  K__PER__K: Qudt.unitFromLocalnameRequired("K-PER-K"),
  // nanogray per hour
  NanoGRAY__PER__HR: Qudt.unitFromLocalnameRequired("NanoGRAY-PER-HR"),
  // percent per pascal second
  PERCENT__PER__PA__SEC: Qudt.unitFromLocalnameRequired("PERCENT-PER-PA-SEC"),
  // Meganewton
  MegaN: Qudt.unitFromLocalnameRequired("MegaN"),
  // Slug
  SLUG: Qudt.unitFromLocalnameRequired("SLUG"),
  // Bangladeshi Taka
  BDT_Currency: Qudt.currencyFromLocalnameRequired("BDT"),
  // Cyprus Pound
  CYP_Currency: Qudt.currencyFromLocalnameRequired("CYP"),
  // pound (avoirdupois) per second degree Fahrenheit
  LB__PER__SEC__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-SEC-DEG_F"),
  // Microatmospheres
  MicroATM: Qudt.unitFromLocalnameRequired("MicroATM"),
  // exabit per second
  ExaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("ExaBIT-PER-SEC"),
  // Nanogram per Square Metre Pascal Second
  NanoGM__PER__M2__PA__SEC: Qudt.unitFromLocalnameRequired(
    "NanoGM-PER-M2-PA-SEC"
  ),
  // volt ampere per kelvin
  V__A__PER__K: Qudt.unitFromLocalnameRequired("V-A-PER-K"),
  // Psi per Psi
  PSI__PER__PSI: Qudt.unitFromLocalnameRequired("PSI-PER-PSI"),
  // Ounce (avoirdupois) per Gallon (UK)
  OZ__PER__GAL_UK: Qudt.unitFromLocalnameRequired("OZ-PER-GAL_UK"),
  // North Korean Won
  KPW_Currency: Qudt.currencyFromLocalnameRequired("KPW"),
  // Nanogram per Millilitre
  NanoGM__PER__MilliL: Qudt.unitFromLocalnameRequired("NanoGM-PER-MilliL"),
  // New Taiwan Dollar
  TWD_Currency: Qudt.currencyFromLocalnameRequired("TWD"),
  // Revolution
  REV: Qudt.unitFromLocalnameRequired("REV"),
  // Calorie (mean)
  CAL_MEAN: Qudt.unitFromLocalnameRequired("CAL_MEAN"),
  // Rayl
  RAYL: Qudt.unitFromLocalnameRequired("RAYL"),
  // exavolt ampere
  ExaV__A: Qudt.unitFromLocalnameRequired("ExaV-A"),
  // NanoSV
  NanoSV: Qudt.unitFromLocalnameRequired("NanoSV"),
  // Tonne
  TONNE: Qudt.unitFromLocalnameRequired("TONNE"),
  // British Thermal Unit (International Definition)
  BTU_IT: Qudt.unitFromLocalnameRequired("BTU_IT"),
  // Millivolt per Meter
  MilliV__PER__M: Qudt.unitFromLocalnameRequired("MilliV-PER-M"),
  // Micromoles per square metre day
  MicroMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2-DAY"),
  // Metric DeciTON
  DeciTON_Metric: Qudt.unitFromLocalnameRequired("DeciTON_Metric"),
  // Square metres per Hertz
  M2__PER__HZ: Qudt.unitFromLocalnameRequired("M2-PER-HZ"),
  // nanoampere per kelvin
  NanoA__PER__K: Qudt.unitFromLocalnameRequired("NanoA-PER-K"),
  // nanogray per minute
  NanoGRAY__PER__MIN: Qudt.unitFromLocalnameRequired("NanoGRAY-PER-MIN"),
  // PicoSiemens
  PicoS: Qudt.unitFromLocalnameRequired("PicoS"),
  // pound per pound
  LB__PER__LB: Qudt.unitFromLocalnameRequired("LB-PER-LB"),
  // Minute Angle
  MIN_Angle: Qudt.unitFromLocalnameRequired("MIN_Angle"),
  // Cubic Meter per Kilogram Square Second
  M3__PER__KiloGM__SEC2: Qudt.unitFromLocalnameRequired("M3-PER-KiloGM-SEC2"),
  // litre per minute bar
  L__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("L-PER-MIN-BAR"),
  // cubic centimetre per hour kelvin
  CentiM3__PER__HR__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-HR-K"),
  // Centimetre of Water
  CM_H2O: Qudt.unitFromLocalnameRequired("CM_H2O"),
  // Milliroentgen
  MilliR: Qudt.unitFromLocalnameRequired("MilliR"),
  // Horsepower (electric)
  HP_Electric: Qudt.unitFromLocalnameRequired("HP_Electric"),
  // Mole per Cubic Metre
  MOL__PER__M3: Qudt.unitFromLocalnameRequired("MOL-PER-M3"),
  // Erg per Gram Second
  ERG__PER__GM__SEC: Qudt.unitFromLocalnameRequired("ERG-PER-GM-SEC"),
  // European Unit of Account 17 (E.U.A.-17) (Bonds market unit)
  XBD_Currency: Qudt.currencyFromLocalnameRequired("XBD"),
  // Degree Rankine per Minute
  DEG_R__PER__MIN: Qudt.unitFromLocalnameRequired("DEG_R-PER-MIN"),
  // Square Foot Hour Degree Fahrenheit per BTU
  FT2__HR__DEG_F__PER__BTU_IT: Qudt.unitFromLocalnameRequired(
    "FT2-HR-DEG_F-PER-BTU_IT"
  ),
  // Nat per Second
  NAT__PER__SEC: Qudt.unitFromLocalnameRequired("NAT-PER-SEC"),
  // nanoohm
  NanoOHM: Qudt.unitFromLocalnameRequired("NanoOHM"),
  // megasecond
  MegaSEC: Qudt.unitFromLocalnameRequired("MegaSEC"),
  // Joule per Square Centimetre
  J__PER__CentiM2: Qudt.unitFromLocalnameRequired("J-PER-CentiM2"),
  // milligram hour per power of metre with the exponent 6
  MilliGM__HR__PER__M6: Qudt.unitFromLocalnameRequired("MilliGM-HR-PER-M6"),
  // Pint (UK) per Minute
  PINT_UK__PER__MIN: Qudt.unitFromLocalnameRequired("PINT_UK-PER-MIN"),
  // megabit
  MegaBIT: Qudt.unitFromLocalnameRequired("MegaBIT"),
  // Reciprocal metre per steradian
  PER__M__SR: Qudt.unitFromLocalnameRequired("PER-M-SR"),
  // Cubic Mile
  MI3: Qudt.unitFromLocalnameRequired("MI3"),
  // Pound Force Second per Square Inch
  LB_F__SEC__PER__IN2: Qudt.unitFromLocalnameRequired("LB_F-SEC-PER-IN2"),
  // Millisievert
  MilliSV: Qudt.unitFromLocalnameRequired("MilliSV"),
  // kelvin per watt
  K__PER__W: Qudt.unitFromLocalnameRequired("K-PER-W"),
  // percent per hundred
  PERCENT__PER__DecaCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-DecaCount"
  ),
  // Saint Helena Pound
  SHP_Currency: Qudt.currencyFromLocalnameRequired("SHP"),
  // Degree Fahrenheit per Hour
  DEG_F__PER__HR: Qudt.unitFromLocalnameRequired("DEG_F-PER-HR"),
  // Cubic Metre per Kelvin
  M3__PER__K: Qudt.unitFromLocalnameRequired("M3-PER-K"),
  // microgram per cubic metre kelvin
  MicroGM__PER__M3__K: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3-K"),
  // therm (U.S.)
  THERM_US: Qudt.unitFromLocalnameRequired("THERM_US"),
  // torr per metre
  TORR__PER__M: Qudt.unitFromLocalnameRequired("TORR-PER-M"),
  // Cases per 1000 individuals year
  CASES__PER__1000I__YR: Qudt.unitFromLocalnameRequired("CASES-PER-1000I-YR"),
  // megabyte per second
  MegaBYTE__PER__SEC: Qudt.unitFromLocalnameRequired("MegaBYTE-PER-SEC"),
  // Newton per Millimetre
  N__PER__MilliM: Qudt.unitFromLocalnameRequired("N-PER-MilliM"),
  // Fractional area
  FA: Qudt.unitFromLocalnameRequired("FA"),
  // ton short per degree Fahrenheit
  TON_SHORT__PER__DEG_F: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-DEG_F"),
  // FRAME
  FRAME: Qudt.unitFromLocalnameRequired("FRAME"),
  // Foot
  FT: Qudt.unitFromLocalnameRequired("FT"),
  // kilosecond
  KiloSEC: Qudt.unitFromLocalnameRequired("KiloSEC"),
  // Megacoulomb per Cubic Metre
  MegaC__PER__M3: Qudt.unitFromLocalnameRequired("MegaC-PER-M3"),
  // Kilovolt Ampere Reactive Hour
  KiloV__A_Reactive__HR: Qudt.unitFromLocalnameRequired("KiloV-A_Reactive-HR"),
  // Lambert
  LA: Qudt.unitFromLocalnameRequired("LA"),
  // Inch per Square second
  IN__PER__SEC2: Qudt.unitFromLocalnameRequired("IN-PER-SEC2"),
  // milligram per day bar
  MilliGM__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-DAY-BAR"),
  // Peck (UK) per Day
  PK_UK__PER__DAY: Qudt.unitFromLocalnameRequired("PK_UK-PER-DAY"),
  // Foot Poundal
  FT__PDL: Qudt.unitFromLocalnameRequired("FT-PDL"),
  // kilocalorie (international table) per gram kelvin
  KiloCAL_IT__PER__GM__K: Qudt.unitFromLocalnameRequired("KiloCAL_IT-PER-GM-K"),
  // Danish Krone
  DKK_Currency: Qudt.currencyFromLocalnameRequired("DKK"),
  // KibiByte
  KibiBYTE: Qudt.unitFromLocalnameRequired("KibiBYTE"),
  // reciprocal pound (avoirdupois)
  PER__LB: Qudt.unitFromLocalnameRequired("PER-LB"),
  // Percent
  PERCENT: Qudt.unitFromLocalnameRequired("PERCENT"),
  // Ounce Mass
  OZ: Qudt.unitFromLocalnameRequired("OZ"),
  // Reciprocal Day
  PER__DAY: Qudt.unitFromLocalnameRequired("PER-DAY"),
  // Djibouti Franc
  DJF_Currency: Qudt.currencyFromLocalnameRequired("DJF"),
  // Cubic Metre per Kilogram
  M3__PER__KiloGM: Qudt.unitFromLocalnameRequired("M3-PER-KiloGM"),
  // Counts per second
  NUM__PER__SEC: Qudt.unitFromLocalnameRequired("NUM-PER-SEC"),
  // Kilohertz Metre
  KiloHZ__M: Qudt.unitFromLocalnameRequired("KiloHZ-M"),
  // poundal inch
  PDL__IN: Qudt.unitFromLocalnameRequired("PDL-IN"),
  // Stone (UK)
  Stone_UK: Qudt.unitFromLocalnameRequired("Stone_UK"),
  // Gram per Mole
  GM__PER__MOL: Qudt.unitFromLocalnameRequired("GM-PER-MOL"),
  // Milligrams per cubic metre day
  MilliGM__PER__M3__DAY: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-DAY"),
  // Armenian Dram
  AMD_Currency: Qudt.currencyFromLocalnameRequired("AMD"),
  // Grain per Gallon (US)
  GRAIN__PER__GAL_US: Qudt.unitFromLocalnameRequired("GRAIN-PER-GAL_US"),
  // Kilocalorie (international Table) per Hour Meter Degree Celsius
  KiloCAL_IT__PER__HR__M__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL_IT-PER-HR-M-DEG_C"
  ),
  // Vietnamese ??ng
  VND_Currency: Qudt.currencyFromLocalnameRequired("VND"),
  // Pound (avoirdupois) per Gallon (UK)
  LB__PER__GAL_UK: Qudt.unitFromLocalnameRequired("LB-PER-GAL_UK"),
  // poundal per square inch
  PDL__PER__IN2: Qudt.unitFromLocalnameRequired("PDL-PER-IN2"),
  // Dyne Second per Cubic Centimeter
  DYN__SEC__PER__CentiM3: Qudt.unitFromLocalnameRequired("DYN-SEC-PER-CentiM3"),
  // Meganewton Meter
  MegaN__M: Qudt.unitFromLocalnameRequired("MegaN-M"),
  // Long Ton per Cubic Yard
  TON_LONG__PER__YD3: Qudt.unitFromLocalnameRequired("TON_LONG-PER-YD3"),
  // picojoule per second
  PicoJ__PER__SEC: Qudt.unitFromLocalnameRequired("PicoJ-PER-SEC"),
  // decisecond
  DeciSEC: Qudt.unitFromLocalnameRequired("DeciSEC"),
  // gram per centimetre bar
  GM__PER__CentiM__BAR: Qudt.unitFromLocalnameRequired("GM-PER-CentiM-BAR"),
  // Pound Degree Rankine
  LB__DEG_R: Qudt.unitFromLocalnameRequired("LB-DEG_R"),
  // Newton per Square Centimeter
  N__PER__CentiM2: Qudt.unitFromLocalnameRequired("N-PER-CentiM2"),
  // Kilo British Thermal Unit (thermochemical) per Hour
  KiloBTU_TH__PER__HR: Qudt.unitFromLocalnameRequired("KiloBTU_TH-PER-HR"),
  // Dram (UK)
  DRAM_UK: Qudt.unitFromLocalnameRequired("DRAM_UK"),
  // inch of water (60 °F)
  IN_H2O_60DEG_F: Qudt.unitFromLocalnameRequired("IN_H2O_60DEG_F"),
  // Malawi Kwacha
  MWK_Currency: Qudt.currencyFromLocalnameRequired("MWK"),
  // Becquerel per Kilogram
  BQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("BQ-PER-KiloGM"),
  // Kilojoule per Kelvin
  KiloJ__PER__K: Qudt.unitFromLocalnameRequired("KiloJ-PER-K"),
  // perm (23 °C)
  PERM_Metric_23DEG_C: Qudt.unitFromLocalnameRequired("PERM_Metric_23DEG_C"),
  // Watthour per Cubic meter
  W__HR__PER__M3: Qudt.unitFromLocalnameRequired("W-HR-PER-M3"),
  // Kilogram per Square Meter Square Second
  KiloGM__PER__M2__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-PER-M2-SEC2"),
  // pound per foot pound-force second
  LB__PER__FT__LB_F__SEC: Qudt.unitFromLocalnameRequired("LB-PER-FT-LB_F-SEC"),
  // milligram per cubic metre kelvin
  MilliGM__PER__M3__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-K"),
  // Cubic Yard per Second
  YD3__PER__SEC: Qudt.unitFromLocalnameRequired("YD3-PER-SEC"),
  // Kilonewton
  KiloN: Qudt.unitFromLocalnameRequired("KiloN"),
  // Millijoule per Square Meter
  MilliJ__PER__M2: Qudt.unitFromLocalnameRequired("MilliJ-PER-M2"),
  // Cubic Meter per Square Second
  M3__PER__SEC2: Qudt.unitFromLocalnameRequired("M3-PER-SEC2"),
  // joule second
  J__SEC: Qudt.unitFromLocalnameRequired("J-SEC"),
  // MegaJoule per Kelvin
  MegaJ__PER__K: Qudt.unitFromLocalnameRequired("MegaJ-PER-K"),
  // Pint (US Liquid) per Day
  PINT_US__PER__DAY: Qudt.unitFromLocalnameRequired("PINT_US-PER-DAY"),
  // Malagasy Ariary
  MGA_Currency: Qudt.currencyFromLocalnameRequired("MGA"),
  // conventional metre of water
  M_H2O: Qudt.unitFromLocalnameRequired("M_H2O"),
  // Microtesla
  MicroT: Qudt.unitFromLocalnameRequired("MicroT"),
  // percent minute per cubic inch
  PERCENT__MIN__PER__IN3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-IN3"),
  // Watt per Meter Kelvin
  W__PER__M__K: Qudt.unitFromLocalnameRequired("W-PER-M-K"),
  // Square Coulomb Square Metre per Joule
  C2__M2__PER__J: Qudt.unitFromLocalnameRequired("C2-M2-PER-J"),
  // Gram per Litre
  GM__PER__L: Qudt.unitFromLocalnameRequired("GM-PER-L"),
  // kilometre per second squared
  KiloM__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloM-PER-SEC2"),
  // Nakfa
  ERN_Currency: Qudt.currencyFromLocalnameRequired("ERN"),
  // gigavolt
  GigaV: Qudt.unitFromLocalnameRequired("GigaV"),
  // Dots per Inch
  DPI: Qudt.unitFromLocalnameRequired("DPI"),
  // grams Nitrogen per square metre day
  GM_Nitrogen__PER__M2__DAY: Qudt.unitFromLocalnameRequired(
    "GM_Nitrogen-PER-M2-DAY"
  ),
  // Sudanese Pound
  SDG_Currency: Qudt.currencyFromLocalnameRequired("SDG"),
  // millivolt per volt
  MilliV__PER__V: Qudt.unitFromLocalnameRequired("MilliV-PER-V"),
  // centipoise per kelvin
  CentiPOISE__PER__K: Qudt.unitFromLocalnameRequired("CentiPOISE-PER-K"),
  // milligram per cubic metre centipoise
  MilliGM__PER__M3__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-CentiPOISE"
  ),
  // millilitre per hour kelvin
  MilliL__PER__HR__K: Qudt.unitFromLocalnameRequired("MilliL-PER-HR-K"),
  // Momme (pearl)
  MOMME_Pearl: Qudt.unitFromLocalnameRequired("MOMME_Pearl"),
  // Decalitre
  DecaL: Qudt.unitFromLocalnameRequired("DecaL"),
  // nanojoule per second
  NanoJ__PER__SEC: Qudt.unitFromLocalnameRequired("NanoJ-PER-SEC"),
  // Watt hour per square metre
  W__HR__PER__M2: Qudt.unitFromLocalnameRequired("W-HR-PER-M2"),
  // Nanogram per Kilogram
  NanoGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("NanoGM-PER-KiloGM"),
  // Kilowatthour
  KiloW__HR: Qudt.unitFromLocalnameRequired("KiloW-HR"),
  // Kilonewton Meter
  KiloN__M: Qudt.unitFromLocalnameRequired("KiloN-M"),
  // gram per bar
  GM__PER__BAR: Qudt.unitFromLocalnameRequired("GM-PER-BAR"),
  // Milliampere per Millimetre
  MilliA__PER__MilliM: Qudt.unitFromLocalnameRequired("MilliA-PER-MilliM"),
  // NanoKAT
  NanoKAT: Qudt.unitFromLocalnameRequired("NanoKAT"),
  // Millimoles per cubic metre
  MilliMOL__PER__M3: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M3"),
  // kilogram per kelvin
  KiloGM__PER__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-K"),
  // Millibecquerels per kilogram
  MilliBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliBQ-PER-KiloGM"),
  // Megavolt Ampere Reactive
  MegaV__A_Reactive: Qudt.unitFromLocalnameRequired("MegaV-A_Reactive"),
  // Biot
  BIOT: Qudt.unitFromLocalnameRequired("BIOT"),
  // Inch per Degree Fahrenheit
  IN__PER__DEG_F: Qudt.unitFromLocalnameRequired("IN-PER-DEG_F"),
  // Tenge
  KZT_Currency: Qudt.currencyFromLocalnameRequired("KZT"),
  // candela per square metre
  CD__PER__M2: Qudt.unitFromLocalnameRequired("CD-PER-M2"),
  // British Thermal Unit (international Table) per Hour Square Foot degree Rankine
  BTU_IT__PER__HR__FT2__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-HR-FT2-DEG_R"
  ),
  // Degree Fahrenheit per Minute
  DEG_F__PER__MIN: Qudt.unitFromLocalnameRequired("DEG_F-PER-MIN"),
  // Reciprocal Year
  PER__YR: Qudt.unitFromLocalnameRequired("PER-YR"),
  // Short Ton (US) per Cubic Yard
  TON_US__PER__YD3: Qudt.unitFromLocalnameRequired("TON_US-PER-YD3"),
  // Nanogram per Liter
  NanoGM__PER__L: Qudt.unitFromLocalnameRequired("NanoGM-PER-L"),
  // Pferdestaerke
  PFERDESTAERKE: Qudt.unitFromLocalnameRequired("PFERDESTAERKE"),
  // Micromho
  MicroMHO: Qudt.unitFromLocalnameRequired("MicroMHO"),
  // W0dot
  W0dot: Qudt.unitFromLocalnameRequired("W0dot"),
  // Euro
  EUR_Currency: Qudt.currencyFromLocalnameRequired("EUR"),
  // Number per square centimetre thousand years
  NUM__PER__CentiM__KiloYR: Qudt.unitFromLocalnameRequired(
    "NUM-PER-CentiM-KiloYR"
  ),
  // Megajoule per Kilogram
  MegaJ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MegaJ-PER-KiloGM"),
  // Square centimetres per second
  CentiM2__PER__SEC: Qudt.unitFromLocalnameRequired("CentiM2-PER-SEC"),
  // pound (avoirdupois) per cubic foot psi
  LB__PER__FT3__PSI: Qudt.unitFromLocalnameRequired("LB-PER-FT3-PSI"),
  // barn per electronvolt
  BARN__PER__EV: Qudt.unitFromLocalnameRequired("BARN-PER-EV"),
  // tonne per hour kelvin
  TON_Metric__PER__HR__K: Qudt.unitFromLocalnameRequired("TON_Metric-PER-HR-K"),
  // millilitre per bar
  MilliL__PER__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-BAR"),
  // Tonne per Cubic Meter
  TONNE__PER__M3: Qudt.unitFromLocalnameRequired("TONNE-PER-M3"),
  // Millimetre per Kelvin
  MilliM__PER__K: Qudt.unitFromLocalnameRequired("MilliM-PER-K"),
  // Abvolt Second
  V_Ab__SEC: Qudt.unitFromLocalnameRequired("V_Ab-SEC"),
  // Gallon (US) per Hour
  GAL_US__PER__HR: Qudt.unitFromLocalnameRequired("GAL_US-PER-HR"),
  // pound second per square gallon (US)
  LB__SEC__PER__GAL_US2: Qudt.unitFromLocalnameRequired("LB-SEC-PER-GAL_US2"),
  // Gram per Second
  GM__PER__SEC: Qudt.unitFromLocalnameRequired("GM-PER-SEC"),
  // ounce minute per cubic inch cubic foot
  OZ__MIN__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("OZ-MIN-PER-IN3-FT3"),
  // Tonne per Cubic Meter
  TON_Metric__PER__M3: Qudt.unitFromLocalnameRequired("TON_Metric-PER-M3"),
  // exbibit per metre
  ExbiBIT__PER__M: Qudt.unitFromLocalnameRequired("ExbiBIT-PER-M"),
  // Indian Rupee
  INR_Currency: Qudt.currencyFromLocalnameRequired("INR"),
  // phon
  PHON: Qudt.unitFromLocalnameRequired("PHON"),
  // gram hour per cubic metre litre
  GM__HR__PER__M3__L: Qudt.unitFromLocalnameRequired("GM-HR-PER-M3-L"),
  // Picomoles per kilogram
  PicoMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("PicoMOL-PER-KiloGM"),
  // gram second per cubic metre cubic centimetre
  GM__SEC__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-SEC-PER-M3-CentiM3"
  ),
  // Ounce (avoirdupois) per Day
  OZ__PER__DAY: Qudt.unitFromLocalnameRequired("OZ-PER-DAY"),
  // tonne per bar
  TON_Metric__PER__BAR: Qudt.unitFromLocalnameRequired("TON_Metric-PER-BAR"),
  // pound minute per gallon (US) cubic foot
  LB__MIN__PER__GAL_US__FT3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_US-FT3"
  ),
  // Kilogram per Mega BTU
  KiloGM__PER__MegaBTU_IT: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-MegaBTU_IT"
  ),
  // Hertz Meter
  HZ__M: Qudt.unitFromLocalnameRequired("HZ-M"),
  // Microfarad per Meter
  MicroFARAD__PER__M: Qudt.unitFromLocalnameRequired("MicroFARAD-PER-M"),
  // pound (avoirdupois) inch per second
  LB__IN__PER__SEC: Qudt.unitFromLocalnameRequired("LB-IN-PER-SEC"),
  // inch of water (39.2 °F)
  IN_H2O_39dot2DEG_F: Qudt.unitFromLocalnameRequired("IN_H2O_39dot2DEG_F"),
  // ohm per mile
  OHM__PER__MI: Qudt.unitFromLocalnameRequired("OHM-PER-MI"),
  // Ton (US)
  TON_US: Qudt.unitFromLocalnameRequired("TON_US"),
  // Watt per Gram
  W__PER__GM: Qudt.unitFromLocalnameRequired("W-PER-GM"),
  // astronomical-unit
  AU: Qudt.unitFromLocalnameRequired("AU"),
  // cubic metre per minute kelvin
  M3__PER__MIN__K: Qudt.unitFromLocalnameRequired("M3-PER-MIN-K"),
  // Mega British Thermal Unit (International Definition) per Hour
  MegaBTU_IT__PER__HR: Qudt.unitFromLocalnameRequired("MegaBTU_IT-PER-HR"),
  // Volt per Inch
  V__PER__IN: Qudt.unitFromLocalnameRequired("V-PER-IN"),
  // kilogram per pascal
  KiloGM__PER__PA: Qudt.unitFromLocalnameRequired("KiloGM-PER-PA"),
  // Candela per Kilolumen
  CD__PER__KiloLM: Qudt.unitFromLocalnameRequired("CD-PER-KiloLM"),
  // Gibraltar pound
  GIP_Currency: Qudt.currencyFromLocalnameRequired("GIP"),
  // gram per cubic metre kelvin
  GM__PER__M3__K: Qudt.unitFromLocalnameRequired("GM-PER-M3-K"),
  // Kiloohm
  KiloOHM: Qudt.unitFromLocalnameRequired("KiloOHM"),
  // Millicurie
  MilliCi: Qudt.unitFromLocalnameRequired("MilliCi"),
  // British thermal unit (60 °F)
  BTU_60DEG_F: Qudt.unitFromLocalnameRequired("BTU_60DEG_F"),
  // British Thermal Unit (international Table) per Minute
  BTU_IT__PER__MIN: Qudt.unitFromLocalnameRequired("BTU_IT-PER-MIN"),
  // Kilograms per cubic metre second
  KiloGM__PER__M3__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3-SEC"),
  // Kilocalorie (thermochemical) per Hour
  KiloCAL_TH__PER__HR: Qudt.unitFromLocalnameRequired("KiloCAL_TH-PER-HR"),
  // Mil Angle (NATO)
  MIL: Qudt.unitFromLocalnameRequired("MIL"),
  // Volt per Centimetre
  V__PER__CentiM: Qudt.unitFromLocalnameRequired("V-PER-CentiM"),
  // Kilolitre
  KiloL: Qudt.unitFromLocalnameRequired("KiloL"),
  // Micromoles per gram second
  MicroMOL__PER__GM__SEC: Qudt.unitFromLocalnameRequired("MicroMOL-PER-GM-SEC"),
  // metre pascal per second
  M__PA__PER__SEC: Qudt.unitFromLocalnameRequired("M-PA-PER-SEC"),
  // Bushel (US Dry) per Hour
  BU_US_DRY__PER__HR: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-HR"),
  // Nanogram per Microlitre
  NanoGM__PER__MicroL: Qudt.unitFromLocalnameRequired("NanoGM-PER-MicroL"),
  // Cubic Metre per Second
  M3__PER__SEC: Qudt.unitFromLocalnameRequired("M3-PER-SEC"),
  // reciprocal radian
  PER__RAD: Qudt.unitFromLocalnameRequired("PER-RAD"),
  // Slug per Second
  SLUG__PER__SEC: Qudt.unitFromLocalnameRequired("SLUG-PER-SEC"),
  // Kilometer per Hour
  KiloM__PER__HR: Qudt.unitFromLocalnameRequired("KiloM-PER-HR"),
  // Pakistan Rupee
  PKR_Currency: Qudt.currencyFromLocalnameRequired("PKR"),
  // US Liquid Ounce
  OZ_VOL_US: Qudt.unitFromLocalnameRequired("OZ_VOL_US"),
  // Franc Congolais
  CDF_Currency: Qudt.currencyFromLocalnameRequired("CDF"),
  // Synodic month
  MO_Synodic: Qudt.unitFromLocalnameRequired("MO_Synodic"),
  // Litre per Second Square Metre
  L__PER__SEC__M2: Qudt.unitFromLocalnameRequired("L-PER-SEC-M2"),
  // Denier
  Denier: Qudt.unitFromLocalnameRequired("Denier"),
  // Square Inch
  IN2: Qudt.unitFromLocalnameRequired("IN2"),
  // Iraqi Dinar
  IQD_Currency: Qudt.currencyFromLocalnameRequired("IQD"),
  // Picomoles per litre hour
  PicoMOL__PER__L__HR: Qudt.unitFromLocalnameRequired("PicoMOL-PER-L-HR"),
  // barn per steradian electronvolt
  BARN__PER__SR__EV: Qudt.unitFromLocalnameRequired("BARN-PER-SR-EV"),
  // gigafloatingpoint operations per second
  GigaFLOPS: Qudt.unitFromLocalnameRequired("GigaFLOPS"),
  // cubic metre per pascal
  M3__PER__PA: Qudt.unitFromLocalnameRequired("M3-PER-PA"),
  // percent per ten thousand
  PERCENT__PER__10KiloCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-10KiloCount"
  ),
  // vatio por metro cuadrado
  W__PER__M2: Qudt.unitFromLocalnameRequired("W-PER-M2"),
  // Namibian Dollar
  NAD_Currency: Qudt.currencyFromLocalnameRequired("NAD"),
  // British Thermal Unit (international Table) per Pound of force Degree Rankine
  BTU_IT__PER__LB_F__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-LB_F-DEG_R"
  ),
  // Calorie (international Table) per Gram Kelvin
  CAL_IT__PER__GM__K: Qudt.unitFromLocalnameRequired("CAL_IT-PER-GM-K"),
  // Square Metre per Newton
  M2__PER__N: Qudt.unitFromLocalnameRequired("M2-PER-N"),
  // Degrees Celsius per metre
  DEG_C__PER__M: Qudt.unitFromLocalnameRequired("DEG_C-PER-M"),
  // Femtomoles per kilogram
  FemtoMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("FemtoMOL-PER-KiloGM"),
  // Megajoule per Hour
  MegaJ__PER__HR: Qudt.unitFromLocalnameRequired("MegaJ-PER-HR"),
  // Bit per Second
  BIT__PER__SEC: Qudt.unitFromLocalnameRequired("BIT-PER-SEC"),
  // kiloampere
  KiloA: Qudt.unitFromLocalnameRequired("KiloA"),
  // Millifarad
  MilliFARAD: Qudt.unitFromLocalnameRequired("MilliFARAD"),
  // BTU per Pound Degree Rankine
  BTU_IT__PER__LB__DEG_R: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB-DEG_R"),
  // Reciprocal Hour
  PER__HR: Qudt.unitFromLocalnameRequired("PER-HR"),
  // Square metres Hertz
  M2__HZ: Qudt.unitFromLocalnameRequired("M2-HZ"),
  // tonne per second kelvin
  TONNE__PER__SEC__K: Qudt.unitFromLocalnameRequired("TONNE-PER-SEC-K"),
  // gigavolt ampere reactive
  GigaV__A_Reactive: Qudt.unitFromLocalnameRequired("GigaV-A_Reactive"),
  // Mole Kelvin
  MOL__K: Qudt.unitFromLocalnameRequired("MOL-K"),
  // Milliweber
  MilliWB: Qudt.unitFromLocalnameRequired("MilliWB"),
  // SAMPLE
  SAMPLE: Qudt.unitFromLocalnameRequired("SAMPLE"),
  // Kilomole per Minute
  KiloMOL__PER__MIN: Qudt.unitFromLocalnameRequired("KiloMOL-PER-MIN"),
  // megabaud
  MegaBAUD: Qudt.unitFromLocalnameRequired("MegaBAUD"),
  // Tonne per Second (metric Ton)
  TON_Metric__PER__SEC: Qudt.unitFromLocalnameRequired("TON_Metric-PER-SEC"),
  // NanoGRAY
  NanoGRAY: Qudt.unitFromLocalnameRequired("NanoGRAY"),
  // percent second per cubic metre
  PERCENT__SEC__PER__M3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-M3"),
  // Thermochemical Calorie per Cubic Centimeter Kelvin
  CAL_TH__PER__CentiM3__K: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM3-K"
  ),
  // Joule per Kilogram Kelvin Cubic Metre
  J__PER__KiloGM__K__M3: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-K-M3"),
  // pound minute per gallon (US) cubic inch
  LB__MIN__PER__GAL_US__IN3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_US-IN3"
  ),
  // newton metre per minute [unit of angle]
  N__M__PER__MIN_Angle: Qudt.unitFromLocalnameRequired("N-M-PER-MIN_Angle"),
  // coulomb al metro quadrato
  C__PER__M2: Qudt.unitFromLocalnameRequired("C-PER-M2"),
  // square metre per watt
  M2__PER__W: Qudt.unitFromLocalnameRequired("M2-PER-W"),
  // Lux Hour
  LUX__HR: Qudt.unitFromLocalnameRequired("LUX-HR"),
  // Millilitre per Hour
  MilliL__PER__HR: Qudt.unitFromLocalnameRequired("MilliL-PER-HR"),
  // Statvolt
  V_Stat: Qudt.unitFromLocalnameRequired("V_Stat"),
  // Somali Shilling
  SOS_Currency: Qudt.currencyFromLocalnameRequired("SOS"),
  // newton metre watt to the power minus 0.5
  N__M__PER__W0dot5: Qudt.unitFromLocalnameRequired("N-M-PER-W0dot5"),
  // Litre per Kilogram
  L__PER__KiloGM: Qudt.unitFromLocalnameRequired("L-PER-KiloGM"),
  // NanoN
  NanoN: Qudt.unitFromLocalnameRequired("NanoN"),
  // Tonne per Hour
  TON_Metric__PER__HR: Qudt.unitFromLocalnameRequired("TON_Metric-PER-HR"),
  // Romanian New Leu
  RON_Currency: Qudt.currencyFromLocalnameRequired("RON"),
  // Mach
  MACH: Qudt.unitFromLocalnameRequired("MACH"),
  // pound-force foot per inch
  LB_F__FT__PER__IN: Qudt.unitFromLocalnameRequired("LB_F-FT-PER-IN"),
  // Mega Pound Force
  MegaLB_F: Qudt.unitFromLocalnameRequired("MegaLB_F"),
  // Millidarcy
  MilliDARCY: Qudt.unitFromLocalnameRequired("MilliDARCY"),
  // Cubic Millimeter per Cubic Meter
  MilliM3__PER__M3: Qudt.unitFromLocalnameRequired("MilliM3-PER-M3"),
  // MilliTorr
  MilliTORR: Qudt.unitFromLocalnameRequired("MilliTORR"),
  // Quarter (UK)
  Quarter_UK: Qudt.unitFromLocalnameRequired("Quarter_UK"),
  // pebibit per square metre
  PebiBIT__PER__M2: Qudt.unitFromLocalnameRequired("PebiBIT-PER-M2"),
  // Ampere per Joule
  A__PER__J: Qudt.unitFromLocalnameRequired("A-PER-J"),
  // Gs
  Gs: Qudt.unitFromLocalnameRequired("Gs"),
  // technical atmosphere per metre
  ATM_T__PER__M: Qudt.unitFromLocalnameRequired("ATM_T-PER-M"),
  // Millinewton Meter
  MilliN__M: Qudt.unitFromLocalnameRequired("MilliN-M"),
  // BTU-IT-PER-lb
  BTU_IT__PER__LB: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB"),
  // millijoule per second
  MilliJ__PER__SEC: Qudt.unitFromLocalnameRequired("MilliJ-PER-SEC"),
  // Microgram per Liter
  MicroGM__PER__L: Qudt.unitFromLocalnameRequired("MicroGM-PER-L"),
  // ampere hour per cubic metre
  A__HR__PER__M3: Qudt.unitFromLocalnameRequired("A-HR-PER-M3"),
  // reciprocal degree Celsius
  PER__DEG_C: Qudt.unitFromLocalnameRequired("PER-DEG_C"),
  // British thermal unit (thermochemical) per hour square foot degree Fahrenheit
  BTU_TH__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-PER-HR-FT2-DEG_F"
  ),
  // square metre per second kelvin
  M2__PER__SEC__K: Qudt.unitFromLocalnameRequired("M2-PER-SEC-K"),
  // kilogram per litre kelvin
  KiloGM__PER__L__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-L-K"),
  // Reciprocal Bar
  PER__BAR: Qudt.unitFromLocalnameRequired("PER-BAR"),
  // pfund
  PFUND: Qudt.unitFromLocalnameRequired("PFUND"),
  // degree Fahrenheit second per British thermal unit (international table)
  DEG_F__SEC__PER__BTU_IT: Qudt.unitFromLocalnameRequired(
    "DEG_F-SEC-PER-BTU_IT"
  ),
  // kilogram per bar
  KiloGM__PER__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-BAR"),
  // pound minute per cubic inch gallon (US)
  LB__MIN__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-IN3-GAL_US"
  ),
  // Gram per Kilogram
  GM__PER__KiloGM: Qudt.unitFromLocalnameRequired("GM-PER-KiloGM"),
  // millikelvin per kelvin
  MilliK__PER__K: Qudt.unitFromLocalnameRequired("MilliK-PER-K"),
  // gram per cubic centimetre kelvin
  GM__PER__CentiM3__K: Qudt.unitFromLocalnameRequired("GM-PER-CentiM3-K"),
  // Pint (UK)
  PINT_UK: Qudt.unitFromLocalnameRequired("PINT_UK"),
  // Barrel (US)
  BBL_US: Qudt.unitFromLocalnameRequired("BBL_US"),
  // pound hour per cubic inch cubic yard
  LB__HR__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("LB-HR-PER-IN3-YD3"),
  // British thermal unit (thermochemical) per second square foot degree Fahrenheit
  BTU_TH__PER__SEC__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-PER-SEC-FT2-DEG_F"
  ),
  // Mauritius Rupee
  MUR_Currency: Qudt.currencyFromLocalnameRequired("MUR"),
  // microsecond
  MicroSEC: Qudt.unitFromLocalnameRequired("MicroSEC"),
  // Tablespoon
  TBSP: Qudt.unitFromLocalnameRequired("TBSP"),
  // pound hour per gallon (UK) cubic yard
  LB__HR__PER__GAL_UK__YD3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_UK-YD3"
  ),
  // Lilangeni
  SZL_Currency: Qudt.currencyFromLocalnameRequired("SZL"),
  // Statsiemens
  S_Stat: Qudt.unitFromLocalnameRequired("S_Stat"),
  // gram minute per power of metre with the exponent 6
  GM__MIN__PER__M6: Qudt.unitFromLocalnameRequired("GM-MIN-PER-M6"),
  // Slug per Cubic Foot
  SLUG__PER__FT3: Qudt.unitFromLocalnameRequired("SLUG-PER-FT3"),
  // newton metre per degree
  N__M__PER__DEG: Qudt.unitFromLocalnameRequired("N-M-PER-DEG"),
  // ZettaCoulomb
  ZettaC: Qudt.unitFromLocalnameRequired("ZettaC"),
  // Cubic Centimetres per Gram
  CentiM3__PER__GM: Qudt.unitFromLocalnameRequired("CentiM3-PER-GM"),
  // milligram per minute bar
  MilliGM__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-MIN-BAR"),
  // Mega Electron Volt
  MegaEV: Qudt.unitFromLocalnameRequired("MegaEV"),
  // Moles per mole
  MOL__PER__MOL: Qudt.unitFromLocalnameRequired("MOL-PER-MOL"),
  // Picomoles per litre
  PicoMOL__PER__L: Qudt.unitFromLocalnameRequired("PicoMOL-PER-L"),
  // Terawattstunde pro Jahr
  TeraW__HR__PER__YR: Qudt.unitFromLocalnameRequired("TeraW-HR-PER-YR"),
  // Number per Year
  NUM__PER__YR: Qudt.unitFromLocalnameRequired("NUM-PER-YR"),
  // siemens per metre
  S__PER__M: Qudt.unitFromLocalnameRequired("S-PER-M"),
  // ounce second per cubic inch cubic foot
  OZ__SEC__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("OZ-SEC-PER-IN3-FT3"),
  // Volt per second
  V__PER__SEC: Qudt.unitFromLocalnameRequired("V-PER-SEC"),
  // dyne second per centimetre to the fifth power
  DYN__SEC__PER__CentiM5: Qudt.unitFromLocalnameRequired("DYN-SEC-PER-CentiM5"),
  // Kilomole
  KiloMOL: Qudt.unitFromLocalnameRequired("KiloMOL"),
  // Nanogram per Square Centimeter
  NanoGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("NanoGM-PER-CentiM2"),
  // Megavolt per Meter
  MegaV__PER__M: Qudt.unitFromLocalnameRequired("MegaV-PER-M"),
  // MicroGAL
  MicroGAL: Qudt.unitFromLocalnameRequired("MicroGAL"),
  // Liter per Kelvin
  L__PER__K: Qudt.unitFromLocalnameRequired("L-PER-K"),
  // perm (0 °C)
  PERM_0DEG_C: Qudt.unitFromLocalnameRequired("PERM_0DEG_C"),
  // Ampere per Square Millimeter
  A__PER__MilliM2: Qudt.unitFromLocalnameRequired("A-PER-MilliM2"),
  // Teaspoon
  TSP: Qudt.unitFromLocalnameRequired("TSP"),
  // Cubic Inch per Second
  IN3__PER__SEC: Qudt.unitFromLocalnameRequired("IN3-PER-SEC"),
  // Hectopascals per hour
  HectoPA__PER__HR: Qudt.unitFromLocalnameRequired("HectoPA-PER-HR"),
  // MDOLLAR
  MDOLLAR: Qudt.unitFromLocalnameRequired("MDOLLAR"),
  // MILLE
  MILLE: Qudt.unitFromLocalnameRequired("MILLE"),
  // Ampere Turn per Meter
  AT__PER__M: Qudt.unitFromLocalnameRequired("AT-PER-M"),
  // Ounce (US Fluid) per Second
  OZ_VOL_US__PER__SEC: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-SEC"),
  // kilobit
  KiloBIT: Qudt.unitFromLocalnameRequired("KiloBIT"),
  // milligram per hour kelvin
  MilliGM__PER__HR__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-HR-K"),
  // gram hour per cubic metre cubic centimetre
  GM__HR__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-HR-PER-M3-CentiM3"
  ),
  // Parts per trillion
  PPTR: Qudt.unitFromLocalnameRequired("PPTR"),
  // Kilowatt
  KiloW: Qudt.unitFromLocalnameRequired("KiloW"),
  // Number per Millilitre
  NUM__PER__MilliL: Qudt.unitFromLocalnameRequired("NUM-PER-MilliL"),
  // kilogram per minute kelvin
  KiloGM__PER__MIN__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-MIN-K"),
  // Millibar per Kelvin
  MilliBAR__PER__K: Qudt.unitFromLocalnameRequired("MilliBAR-PER-K"),
  // Millibecquerels per litre
  MilliBQ__PER__L: Qudt.unitFromLocalnameRequired("MilliBQ-PER-L"),
  // Kilogram per Meter
  KiloGM__PER__M: Qudt.unitFromLocalnameRequired("KiloGM-PER-M"),
  // Abcoulomb per Square Centimetre
  C_Ab__PER__CentiM2: Qudt.unitFromLocalnameRequired("C_Ab-PER-CentiM2"),
  // Ohm Centimetre
  OHM__CentiM: Qudt.unitFromLocalnameRequired("OHM-CentiM"),
  // pound second per cubic inch cubic yard
  LB__SEC__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-IN3-YD3"),
  // Gram Force per Square Centimetre
  GM_F__PER__CentiM2: Qudt.unitFromLocalnameRequired("GM_F-PER-CentiM2"),
  // pound (avoirdupois) per foot day
  LB__PER__FT__DAY: Qudt.unitFromLocalnameRequired("LB-PER-FT-DAY"),
  // pound minute per power of foot with the exponent 6
  LB__MIN__PER__FT6: Qudt.unitFromLocalnameRequired("LB-MIN-PER-FT6"),
  // Ounce (avoirdupois) Inch
  OZ__IN: Qudt.unitFromLocalnameRequired("OZ-IN"),
  // weber
  WB: Qudt.unitFromLocalnameRequired("WB"),
  // Reciprocal Tesla Second Unit
  PER__T__SEC: Qudt.unitFromLocalnameRequired("PER-T-SEC"),
  // Metical
  MZN_Currency: Qudt.currencyFromLocalnameRequired("MZN"),
  // Fathom
  FATH: Qudt.unitFromLocalnameRequired("FATH"),
  // Kilo Newton per metre
  KiloN__PER__M: Qudt.unitFromLocalnameRequired("KiloN-PER-M"),
  // BTU per Square Foot Second Degree Fahrenheit
  BTU_IT__PER__FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-FT2-SEC-DEG_F"
  ),
  // Electron Volt per Kelvin
  EV__PER__K: Qudt.unitFromLocalnameRequired("EV-PER-K"),
  // Square Meter per Kelvin
  M2__PER__K: Qudt.unitFromLocalnameRequired("M2-PER-K"),
  // mètre carré par seconde
  M2__PER__SEC: Qudt.unitFromLocalnameRequired("M2-PER-SEC"),
  // tesla
  T: Qudt.unitFromLocalnameRequired("T"),
  // Kelvin per Hour
  K__PER__HR: Qudt.unitFromLocalnameRequired("K-PER-HR"),
  // Litre per Second
  L__PER__SEC: Qudt.unitFromLocalnameRequired("L-PER-SEC"),
  // Reciprocal Pascal
  PER__PA: Qudt.unitFromLocalnameRequired("PER-PA"),
  // Kilopond
  KiloP: Qudt.unitFromLocalnameRequired("KiloP"),
  // Millilitre per Second
  MilliL__PER__SEC: Qudt.unitFromLocalnameRequired("MilliL-PER-SEC"),
  // Peck (US Dry) per Hour
  PK_US_DRY__PER__HR: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-HR"),
  // kilomole per cubic metre bar
  KiloMOL__PER__M3__BAR: Qudt.unitFromLocalnameRequired("KiloMOL-PER-M3-BAR"),
  // kilogram per cubic centimetre kelvin
  KiloGM__PER__CentiM3__K: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-CentiM3-K"
  ),
  // reciprocal second per cubic metre
  PER__SEC__M3: Qudt.unitFromLocalnameRequired("PER-SEC-M3"),
  // tonne per hectare
  TONNE__PER__HA: Qudt.unitFromLocalnameRequired("TONNE-PER-HA"),
  // hectopascal per metre
  HectoPA__PER__M: Qudt.unitFromLocalnameRequired("HectoPA-PER-M"),
  // Degree Fahrenheit per Second
  DEG_F__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_F-PER-SEC"),
  // cubic inch per pound
  IN3__PER__LB: Qudt.unitFromLocalnameRequired("IN3-PER-LB"),
  // Reciprocal Mille per Psi
  PER__MILLE__PER__PSI: Qudt.unitFromLocalnameRequired("PER-MILLE-PER-PSI"),
  // Picograms per gram
  PicoGM__PER__GM: Qudt.unitFromLocalnameRequired("PicoGM-PER-GM"),
  // Statampere
  A_Stat: Qudt.unitFromLocalnameRequired("A_Stat"),
  // pound mole per minute
  MOL_LB__PER__MIN: Qudt.unitFromLocalnameRequired("MOL_LB-PER-MIN"),
  // Megavolt
  MegaV: Qudt.unitFromLocalnameRequired("MegaV"),
  // millilitre per second bar
  MilliL__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-SEC-BAR"),
  // tonne per cubic metre kelvin
  TONNE__PER__M3__K: Qudt.unitFromLocalnameRequired("TONNE-PER-M3-K"),
  // Kubieke meter per Jaar
  M3__PER__YR: Qudt.unitFromLocalnameRequired("M3-PER-YR"),
  // International Unit per milliliter
  IU__PER__MilliL: Qudt.unitFromLocalnameRequired("IU-PER-MilliL"),
  // Dyne per Square Centimetre
  DYN__PER__CentiM2: Qudt.unitFromLocalnameRequired("DYN-PER-CentiM2"),
  // Milligram per Gram
  MilliGM__PER__GM: Qudt.unitFromLocalnameRequired("MilliGM-PER-GM"),
  // Cubic Meter per Mole Second
  M3__PER__MOL__SEC: Qudt.unitFromLocalnameRequired("M3-PER-MOL-SEC"),
  // milligram per second bar
  MilliGM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-SEC-BAR"),
  // W-M2
  W__M2: Qudt.unitFromLocalnameRequired("W-M2"),
  // Reciprocal Millimetre
  PER__MilliM: Qudt.unitFromLocalnameRequired("PER-MilliM"),
  // nanovolt
  NanoV: Qudt.unitFromLocalnameRequired("NanoV"),
  // Kilojoule per Kilogram Kelvin
  KiloJ__PER__KiloGM__K: Qudt.unitFromLocalnameRequired("KiloJ-PER-KiloGM-K"),
  // picovolt ampere
  PicoV__A: Qudt.unitFromLocalnameRequired("PicoV-A"),
  // mole per cubic metre bar
  MOL__PER__M3__BAR: Qudt.unitFromLocalnameRequired("MOL-PER-M3-BAR"),
  // Kilopound Force per Square Inch
  KiloLB_F__PER__IN2: Qudt.unitFromLocalnameRequired("KiloLB_F-PER-IN2"),
  // Kilopascal per Kelvin
  KiloPA__PER__K: Qudt.unitFromLocalnameRequired("KiloPA-PER-K"),
  // Kiloampere per Metre
  KiloA__PER__M: Qudt.unitFromLocalnameRequired("KiloA-PER-M"),
  // Kilovolt per Metre
  KiloV__PER__M: Qudt.unitFromLocalnameRequired("KiloV-PER-M"),
  // Boliviano
  BOB_Currency: Qudt.currencyFromLocalnameRequired("BOB"),
  // Riel
  KHR_Currency: Qudt.currencyFromLocalnameRequired("KHR"),
  // Megacoulomb per Square Meter
  MegaC__PER__M2: Qudt.unitFromLocalnameRequired("MegaC-PER-M2"),
  // Reciprocal Centimeter
  PER__CentiM: Qudt.unitFromLocalnameRequired("PER-CentiM"),
  // Common Year
  YR_Common: Qudt.unitFromLocalnameRequired("YR_Common"),
  // Newton per Kilogram
  N__PER__KiloGM: Qudt.unitFromLocalnameRequired("N-PER-KiloGM"),
  // Sidereal Minute
  MIN_Sidereal: Qudt.unitFromLocalnameRequired("MIN_Sidereal"),
  // British Thermal Unit (international Table) per Second Foot Degree Rankine
  BTU_IT__PER__SEC__FT__DEG_R: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-SEC-FT-DEG_R"
  ),
  // Faraday
  F: Qudt.unitFromLocalnameRequired("F"),
  // Mile US Statute
  MI_US: Qudt.unitFromLocalnameRequired("MI_US"),
  // Degree Celsius per Kelvin
  DEG_C__PER__K: Qudt.unitFromLocalnameRequired("DEG_C-PER-K"),
  // gram second per litre squared
  GM__SEC__PER__L2: Qudt.unitFromLocalnameRequired("GM-SEC-PER-L2"),
  // KiloTon per Jaar
  KiloTONNE__PER__YR: Qudt.unitFromLocalnameRequired("KiloTONNE-PER-YR"),
  // pascal square metre per kilogram
  PA__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("PA-M2-PER-KiloGM"),
  // Square Foot
  FT2: Qudt.unitFromLocalnameRequired("FT2"),
  // Poundal per Square Foot
  PDL__PER__FT2: Qudt.unitFromLocalnameRequired("PDL-PER-FT2"),
  // International Unit
  IU: Qudt.unitFromLocalnameRequired("IU"),
  // Cubic Centimetre per Cubic Centimetre
  CentiM3__PER__CentiM3: Qudt.unitFromLocalnameRequired("CentiM3-PER-CentiM3"),
  // Mho
  MHO: Qudt.unitFromLocalnameRequired("MHO"),
  // Ton Force (US Short)
  TON_F_US: Qudt.unitFromLocalnameRequired("TON_F_US"),
  // yard per minute
  YD__PER__MIN: Qudt.unitFromLocalnameRequired("YD-PER-MIN"),
  // Bushel (US Dry) per Second
  BU_US_DRY__PER__SEC: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-SEC"),
  // Pascal Liter per Second
  PA__L__PER__SEC: Qudt.unitFromLocalnameRequired("PA-L-PER-SEC"),
  // Kilometre
  KiloM: Qudt.unitFromLocalnameRequired("KiloM"),
  // Ounce (avoirdupois) per Hour
  OZ__PER__HR: Qudt.unitFromLocalnameRequired("OZ-PER-HR"),
  // percent per month
  PERCENT__PER__MO: Qudt.unitFromLocalnameRequired("PERCENT-PER-MO"),
  // Newton per radian
  N__PER__RAD: Qudt.unitFromLocalnameRequired("N-PER-RAD"),
  // ampere hour per degree Celsius
  A__HR__PER__DEG_C: Qudt.unitFromLocalnameRequired("A-HR-PER-DEG_C"),
  // BBL_US_PET
  BBL_US_PET: Qudt.unitFromLocalnameRequired("BBL_US_PET"),
  // Petajoule
  PetaJ: Qudt.unitFromLocalnameRequired("PetaJ"),
  // Reciprocal Mole
  PER__MOL: Qudt.unitFromLocalnameRequired("PER-MOL"),
  // cubic metre per second kelvin
  M3__PER__SEC__K: Qudt.unitFromLocalnameRequired("M3-PER-SEC-K"),
  // Nanomoles per square metre day
  NanoMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("NanoMOL-PER-M2-DAY"),
  // reciprocal megapascal
  PER__MegaPA: Qudt.unitFromLocalnameRequired("PER-MegaPA"),
  // Tonne per Second
  TONNE__PER__SEC: Qudt.unitFromLocalnameRequired("TONNE-PER-SEC"),
  // milligram hour per cubic metre litre
  MilliGM__HR__PER__M3__L: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-M3-L"
  ),
  // MegaDOLLAR_US
  MegaDOLLAR_US: Qudt.unitFromLocalnameRequired("MegaDOLLAR_US"),
  // ounce square foot per cubic inch pound-force second
  OZ__FT2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "OZ-FT2-PER-IN3-LB_F-SEC"
  ),
  // Teraohm
  TeraOHM: Qudt.unitFromLocalnameRequired("TeraOHM"),
  // millilitre per minute kelvin
  MilliL__PER__MIN__K: Qudt.unitFromLocalnameRequired("MilliL-PER-MIN-K"),
  // Foot Pound Force
  FT__LB_F: Qudt.unitFromLocalnameRequired("FT-LB_F"),
  // Kilogram per Hectare
  KiloGM__PER__HA: Qudt.unitFromLocalnameRequired("KiloGM-PER-HA"),
  // Kilocalorie per Square Centimetre Second
  KiloCAL__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-CentiM2-SEC"
  ),
  // decibel with A-weighting
  DeciB_A: Qudt.unitFromLocalnameRequired("DeciB_A"),
  // Euro per kilowatt hour
  EUR__PER__KiloW__HR: Qudt.unitFromLocalnameRequired("EUR-PER-KiloW-HR"),
  // stokes per kelvin
  ST__PER__K: Qudt.unitFromLocalnameRequired("ST-PER-K"),
  // Gigawatt
  GigaW: Qudt.unitFromLocalnameRequired("GigaW"),
  // Square metres per square Hertz
  M2__PER__HZ2: Qudt.unitFromLocalnameRequired("M2-PER-HZ2"),
  // Statampere per Square Centimetre
  A_Stat__PER__CentiM2: Qudt.unitFromLocalnameRequired("A_Stat-PER-CentiM2"),
  // Ton (US) per Hour
  TON_US__PER__HR: Qudt.unitFromLocalnameRequired("TON_US-PER-HR"),
  // Sidereal Year
  YR_Sidereal: Qudt.unitFromLocalnameRequired("YR_Sidereal"),
  // Unitless
  UNITLESS: Qudt.unitFromLocalnameRequired("UNITLESS"),
  // Degrees Celsius kilogram per square metre
  DEG_C__KiloGM__PER__M2: Qudt.unitFromLocalnameRequired("DEG_C-KiloGM-PER-M2"),
  // tonne per cubic metre bar
  TONNE__PER__M3__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-M3-BAR"),
  // gram per second kelvin
  GM__PER__SEC__K: Qudt.unitFromLocalnameRequired("GM-PER-SEC-K"),
  // Imperial Mass Ounce per Gallon
  OZ__PER__GAL: Qudt.unitFromLocalnameRequired("OZ-PER-GAL"),
  // kilowatt per metre kelvin
  KiloW__PER__M__K: Qudt.unitFromLocalnameRequired("KiloW-PER-M-K"),
  // Ampere per Square Meter Square Kelvin
  A__PER__M2__K2: Qudt.unitFromLocalnameRequired("A-PER-M2-K2"),
  // BTU per Pound Mole
  BTU_IT__PER__LB__MOL: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB-MOL"),
  // Microvolt
  MicroV: Qudt.unitFromLocalnameRequired("MicroV"),
  // kilojoule per minute
  KiloJ__PER__MIN: Qudt.unitFromLocalnameRequired("KiloJ-PER-MIN"),
  // Micromoles per gram
  MicroMOL__PER__GM: Qudt.unitFromLocalnameRequired("MicroMOL-PER-GM"),
  // exbibit per metre
  ExaBIT__PER__M: Qudt.unitFromLocalnameRequired("ExaBIT-PER-M"),
  // gram per minute kelvin
  GM__PER__MIN__K: Qudt.unitFromLocalnameRequired("GM-PER-MIN-K"),
  // cubic centimetre per day bar
  CentiM3__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-DAY-BAR"),
  // Reciprocal Square Kilogram
  PER__KiloGM2: Qudt.unitFromLocalnameRequired("PER-KiloGM2"),
  // Microgram per Kilogram
  MicroGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("MicroGM-PER-KiloGM"),
  // Denar
  MKD_Currency: Qudt.currencyFromLocalnameRequired("MKD"),
  // pound mole per second
  MOL_LB__PER__SEC: Qudt.unitFromLocalnameRequired("MOL_LB-PER-SEC"),
  // centimeter per second
  CentiM__PER__SEC: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC"),
  // megaton
  MegaTON: Qudt.unitFromLocalnameRequired("MegaTON"),
  // Degree Fahrenheit
  DEG_F: Qudt.unitFromLocalnameRequired("DEG_F"),
  // Kilo Newton Square Metre
  KiloN__M2: Qudt.unitFromLocalnameRequired("KiloN-M2"),
  // Electric Susceptibility Unit
  SUSCEPTIBILITY_ELEC: Qudt.unitFromLocalnameRequired("SUSCEPTIBILITY_ELEC"),
  // Joule per Quartic Metre
  J__PER__M4: Qudt.unitFromLocalnameRequired("J-PER-M4"),
  // Cubic Foot per Degree Fahrenheit
  FT3__PER__DEG_F: Qudt.unitFromLocalnameRequired("FT3-PER-DEG_F"),
  // kibibit per square metre
  KibiBIT__PER__M2: Qudt.unitFromLocalnameRequired("KibiBIT-PER-M2"),
  // reciprocal megakelvin or megakelvin to the power minus one
  PER__MegaK: Qudt.unitFromLocalnameRequired("PER-MegaK"),
  // Standard
  Standard: Qudt.unitFromLocalnameRequired("Standard"),
  // pound minute per gallon (US) cubic yard
  LB__MIN__PER__GAL_US__YD3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_US-YD3"
  ),
  // metre per volt second
  M__PER__V__SEC: Qudt.unitFromLocalnameRequired("M-PER-V-SEC"),
  // Milligrams per cubic metre second
  MilliGM__PER__M3__SEC: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-SEC"),
  // Nanohenry
  NanoH: Qudt.unitFromLocalnameRequired("NanoH"),
  // nanogray per second
  NanoGRAY__PER__SEC: Qudt.unitFromLocalnameRequired("NanoGRAY-PER-SEC"),
  // kelvin
  K: Qudt.unitFromLocalnameRequired("K"),
  // Degree per Hour
  DEG__PER__HR: Qudt.unitFromLocalnameRequired("DEG-PER-HR"),
  // newton metre per minute [unit of angle]
  N__M__PER__ARCMIN: Qudt.unitFromLocalnameRequired("N-M-PER-ARCMIN"),
  // 摩尔
  MOL: Qudt.unitFromLocalnameRequired("MOL"),
  // Ton Energy
  TonEnergy: Qudt.unitFromLocalnameRequired("TonEnergy"),
  // Kilogram per Kilogram
  KiloGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloGM"),
  // Lari
  GEL_Currency: Qudt.currencyFromLocalnameRequired("GEL"),
  // Mean Julian Month
  MO_MeanJulian: Qudt.unitFromLocalnameRequired("MO_MeanJulian"),
  // Reciprocal Picometer
  PER__PicoM: Qudt.unitFromLocalnameRequired("PER-PicoM"),
  // V_Stat-CentiM
  V_Stat__CentiM: Qudt.unitFromLocalnameRequired("V_Stat-CentiM"),
  // Becquerel per Square Meter
  BQ__PER__M2: Qudt.unitFromLocalnameRequired("BQ-PER-M2"),
  // pound hour per power of inch with the exponent 6
  LB__HR__PER__IN6: Qudt.unitFromLocalnameRequired("LB-HR-PER-IN6"),
  // Pint (UK) per Day
  PINT_UK__PER__DAY: Qudt.unitFromLocalnameRequired("PINT_UK-PER-DAY"),
  // Convertible Marks
  BAM_Currency: Qudt.currencyFromLocalnameRequired("BAM"),
  // Microhenry per Kiloohm
  MicroH__PER__KiloOHM: Qudt.unitFromLocalnameRequired("MicroH-PER-KiloOHM"),
  // picovolt
  PicoV: Qudt.unitFromLocalnameRequired("PicoV"),
  // decibel isotropic
  DeciB_ISO: Qudt.unitFromLocalnameRequired("DeciB_ISO"),
  // Kilocoulomb per Cubic Meter
  KiloC__PER__M3: Qudt.unitFromLocalnameRequired("KiloC-PER-M3"),
  // Milliohm
  MilliOHM: Qudt.unitFromLocalnameRequired("MilliOHM"),
  // Milliroentgen Equivalent Man
  MilliR_man: Qudt.unitFromLocalnameRequired("MilliR_man"),
  // Long Furlong
  FUR_Long: Qudt.unitFromLocalnameRequired("FUR_Long"),
  // Kuwaiti Dinar
  KWD_Currency: Qudt.currencyFromLocalnameRequired("KWD"),
  // Square Centimetre Minute
  CentiM2__MIN: Qudt.unitFromLocalnameRequired("CentiM2-MIN"),
  // Joule per Gram Kelvin
  J__PER__GM__K: Qudt.unitFromLocalnameRequired("J-PER-GM-K"),
  // pound hour per cubic foot cubic inch
  LB__HR__PER__FT3__IN3: Qudt.unitFromLocalnameRequired("LB-HR-PER-FT3-IN3"),
  // Erg
  ERG: Qudt.unitFromLocalnameRequired("ERG"),
  // milligram minute per litre cubic centimetre
  MilliGM__MIN__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-L-CentiM3"
  ),
  // Calorie (15 Degrees C)
  CAL_15_DEG_C: Qudt.unitFromLocalnameRequired("CAL_15_DEG_C"),
  // Exajoule
  ExaJ: Qudt.unitFromLocalnameRequired("ExaJ"),
  // Picosiemens per Meter
  PicoS__PER__M: Qudt.unitFromLocalnameRequired("PicoS-PER-M"),
  // Calorie (international Table) per Second Centimeter Kelvin
  CAL_IT__PER__SEC__CentiM__K: Qudt.unitFromLocalnameRequired(
    "CAL_IT-PER-SEC-CentiM-K"
  ),
  // kiloohm per metre
  KiloOHM__PER__M: Qudt.unitFromLocalnameRequired("KiloOHM-PER-M"),
  // 2PiRAD
  _2PiRAD: Qudt.unitFromLocalnameRequired("2PiRAD"),
  // ExbiByte
  ExbiBYTE: Qudt.unitFromLocalnameRequired("ExbiBYTE"),
  // Swiss Franc
  CHF_Currency: Qudt.currencyFromLocalnameRequired("CHF"),
  // gibibit per metre
  GibiBIT__PER__M: Qudt.unitFromLocalnameRequired("GibiBIT-PER-M"),
  // Megabecquerel
  MegaBQ: Qudt.unitFromLocalnameRequired("MegaBQ"),
  // reciprocal milligram
  PER__MilliGM: Qudt.unitFromLocalnameRequired("PER-MilliGM"),
  // ton, register
  TON_Register: Qudt.unitFromLocalnameRequired("TON_Register"),
  // Gram per Metre
  GM__PER__M: Qudt.unitFromLocalnameRequired("GM-PER-M"),
  // Gigahertz Metre
  GigaHZ__M: Qudt.unitFromLocalnameRequired("GigaHZ-M"),
  // Millimole per Kilogram
  MilliMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliMOL-PER-KiloGM"),
  // Statvolt per Centimeter
  V_Stat__PER__CentiM: Qudt.unitFromLocalnameRequired("V_Stat-PER-CentiM"),
  // International Table calorie
  CAL_IT: Qudt.unitFromLocalnameRequired("CAL_IT"),
  // Kilogram per Second
  KiloGM__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC"),
  // Centimeter
  CentiM: Qudt.unitFromLocalnameRequired("CentiM"),
  // Tonne per Minute
  TON_Metric__PER__MIN: Qudt.unitFromLocalnameRequired("TON_Metric-PER-MIN"),
  // Stathenry per Centimeter
  H_Stat__PER__CentiM: Qudt.unitFromLocalnameRequired("H_Stat-PER-CentiM"),
  // Millihenry per Kiloohm
  MilliH__PER__KiloOHM: Qudt.unitFromLocalnameRequired("MilliH-PER-KiloOHM"),
  // millisecond
  MilliSEC: Qudt.unitFromLocalnameRequired("MilliSEC"),
  // Mikrometer pro Newton
  MicroM__PER__N: Qudt.unitFromLocalnameRequired("MicroM-PER-N"),
  // milliradian
  MilliRAD: Qudt.unitFromLocalnameRequired("MilliRAD"),
  // Nanomoles per cubic centimetre hour
  NanoMOL__PER__CentiM3__HR: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-CentiM3-HR"
  ),
  // Revolution per Square Second
  REV__PER__SEC2: Qudt.unitFromLocalnameRequired("REV-PER-SEC2"),
  // milligram minute per litre squared
  MilliGM__MIN__PER__L2: Qudt.unitFromLocalnameRequired("MilliGM-MIN-PER-L2"),
  // microohm metre
  MicroOHM__M: Qudt.unitFromLocalnameRequired("MicroOHM-M"),
  // reciprocal joule
  PER__J: Qudt.unitFromLocalnameRequired("PER-J"),
  // Rad
  RAD_R: Qudt.unitFromLocalnameRequired("RAD_R"),
  // MilliAmpere
  MilliA: Qudt.unitFromLocalnameRequired("MilliA"),
  // Degree Fahrenheit hour per British thermal unit (thermochemical)
  DEG_F__HR__PER__BTU_TH: Qudt.unitFromLocalnameRequired("DEG_F-HR-PER-BTU_TH"),
  // foot per psi
  FT__PER__PSI: Qudt.unitFromLocalnameRequired("FT-PER-PSI"),
  // Gigabit per Second
  GigaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("GigaBIT-PER-SEC"),
  // Kilocalorie (international Table)
  KiloCAL_IT: Qudt.unitFromLocalnameRequired("KiloCAL_IT"),
  // Pint (US Liquid) per Second
  PINT_US__PER__SEC: Qudt.unitFromLocalnameRequired("PINT_US-PER-SEC"),
  // Latvian Lats
  LVL_Currency: Qudt.currencyFromLocalnameRequired("LVL"),
  // ounce of force per cubic inch
  OZ_F__PER__IN3: Qudt.unitFromLocalnameRequired("OZ_F-PER-IN3"),
  // cubic metre per minute bar
  M3__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("M3-PER-MIN-BAR"),
  // kilogram metre per second squared
  KiloGM__M__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-M-PER-SEC2"),
  // percent minute per gallon (UK)
  PERCENT__MIN__PER__GAL_UK: Qudt.unitFromLocalnameRequired(
    "PERCENT-MIN-PER-GAL_UK"
  ),
  // Rwanda Franc
  RWF_Currency: Qudt.currencyFromLocalnameRequired("RWF"),
  // decibel per metre
  DeciB__PER__M: Qudt.unitFromLocalnameRequired("DeciB-PER-M"),
  // mole per litre bar
  MOL__PER__L__BAR: Qudt.unitFromLocalnameRequired("MOL-PER-L-BAR"),
  // DecaCount
  DecaCount: Qudt.unitFromLocalnameRequired("DecaCount"),
  // milligram per litre poise
  MilliGM__PER__L__POISE: Qudt.unitFromLocalnameRequired("MilliGM-PER-L-POISE"),
  // Micrograms per gram
  MicroGM__PER__GM: Qudt.unitFromLocalnameRequired("MicroGM-PER-GM"),
  // Boiler Horsepower
  HP_Boiler: Qudt.unitFromLocalnameRequired("HP_Boiler"),
  // ampere hour per square metre
  A__HR__PER__M2: Qudt.unitFromLocalnameRequired("A-HR-PER-M2"),
  // Mol per Tonne
  MOL__PER__TONNE: Qudt.unitFromLocalnameRequired("MOL-PER-TONNE"),
  // Yuan Renminbi
  CNY_Currency: Qudt.currencyFromLocalnameRequired("CNY"),
  // nanojoule
  NanoJ: Qudt.unitFromLocalnameRequired("NanoJ"),
  // Gram per Hour
  GM__PER__HR: Qudt.unitFromLocalnameRequired("GM-PER-HR"),
  // microradian
  MicroRAD: Qudt.unitFromLocalnameRequired("MicroRAD"),
  // AttoCoulomb
  AttoC: Qudt.unitFromLocalnameRequired("AttoC"),
  // decisiemens per metre
  DeciS__PER__M: Qudt.unitFromLocalnameRequired("DeciS-PER-M"),
  // bit per square metre
  BIT__PER__M2: Qudt.unitFromLocalnameRequired("BIT-PER-M2"),
  // pound square inch per cubic inch pound-force second
  LB__IN2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-IN3-LB_F-SEC"
  ),
  // milligram per litre centipoise
  MilliGM__PER__L__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-L-CentiPOISE"
  ),
  // milligram second per litre squared
  MilliGM__SEC__PER__L2: Qudt.unitFromLocalnameRequired("MilliGM-SEC-PER-L2"),
  // Short Ton per Cubic Yard
  TON_SHORT__PER__YD3: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-YD3"),
  // pound hour per cubic foot gallon (UK)
  LB__HR__PER__FT3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-FT3-GAL_UK"
  ),
  // جول لكل كلفن
  J__PER__K: Qudt.unitFromLocalnameRequired("J-PER-K"),
  // kilogram meter per saat
  KiloGM__M__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM-M-PER-SEC"),
  // petabit per second
  PetaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("PetaBIT-PER-SEC"),
  // Volt Ampere Hour
  V__A__HR: Qudt.unitFromLocalnameRequired("V-A-HR"),
  // Pula
  BWP_Currency: Qudt.currencyFromLocalnameRequired("BWP"),
  // gram per millilitre bar
  GM__PER__MilliL__BAR: Qudt.unitFromLocalnameRequired("GM-PER-MilliL-BAR"),
  // PSI
  PSI: Qudt.unitFromLocalnameRequired("PSI"),
  // Farad per Meter
  FARAD__PER__M: Qudt.unitFromLocalnameRequired("FARAD-PER-M"),
  // Gram per Square Centimetre
  GM__PER__CentiM2: Qudt.unitFromLocalnameRequired("GM-PER-CentiM2"),
  // Microgram
  MicroGM: Qudt.unitFromLocalnameRequired("MicroGM"),
  // Calorie (international Table) per Second Square Centimetre kelvin
  CAL_IT__PER__SEC__CentiM2__K: Qudt.unitFromLocalnameRequired(
    "CAL_IT-PER-SEC-CentiM2-K"
  ),
  // poise per pascal
  POISE__PER__PA: Qudt.unitFromLocalnameRequired("POISE-PER-PA"),
  // Inch
  IN: Qudt.unitFromLocalnameRequired("IN"),
  // Moles per square metre second steradian
  MOL__PER__M2__SEC__SR: Qudt.unitFromLocalnameRequired("MOL-PER-M2-SEC-SR"),
  // percent per inch
  PERCENT__PER__IN: Qudt.unitFromLocalnameRequired("PERCENT-PER-IN"),
  // percent per degree
  PERCENT__PER__DEGREE: Qudt.unitFromLocalnameRequired("PERCENT-PER-DEGREE"),
  // THM_EEC
  THM_EEC: Qudt.unitFromLocalnameRequired("THM_EEC"),
  // Pound per Foot Hour
  LB__PER__FT__HR: Qudt.unitFromLocalnameRequired("LB-PER-FT-HR"),
  // Somoni
  TJS_Currency: Qudt.currencyFromLocalnameRequired("TJS"),
  // Millipascal Second per Bar
  MilliPA__SEC__PER__BAR: Qudt.unitFromLocalnameRequired("MilliPA-SEC-PER-BAR"),
  // Micromoles per kilogram
  MicroMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MicroMOL-PER-KiloGM"),
  // Microhenry
  MicroH: Qudt.unitFromLocalnameRequired("MicroH"),
  // Parts-per-thousand per hour
  PPTH__PER__HR: Qudt.unitFromLocalnameRequired("PPTH-PER-HR"),
  // Baht
  THB_Currency: Qudt.currencyFromLocalnameRequired("THB"),
  // foot to the fourth power
  FT4: Qudt.unitFromLocalnameRequired("FT4"),
  // pound second per gallon (US) cubic foot
  LB__SEC__PER__GAL_US__FT3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_US-FT3"
  ),
  // chain (based on U.S. survey foot)
  CHAIN_US: Qudt.unitFromLocalnameRequired("CHAIN_US"),
  // Gallon (UK) per Second
  GAL_UK__PER__SEC: Qudt.unitFromLocalnameRequired("GAL_UK-PER-SEC"),
  // Quart (UK Liquid) per Day
  QT_UK__PER__DAY: Qudt.unitFromLocalnameRequired("QT_UK-PER-DAY"),
  // Lebanese Pound
  LBP_Currency: Qudt.currencyFromLocalnameRequired("LBP"),
  // Milliwatt per Milligram
  MilliW__PER__MilliGM: Qudt.unitFromLocalnameRequired("MilliW-PER-MilliGM"),
  // gram per cubic decimetre bar
  GM__PER__DeciM3__BAR: Qudt.unitFromLocalnameRequired("GM-PER-DeciM3-BAR"),
  // reciprocal second per steradian square metre
  PER__SEC__SR__M2: Qudt.unitFromLocalnameRequired("PER-SEC-SR-M2"),
  // bel per metre
  B__PER__M: Qudt.unitFromLocalnameRequired("B-PER-M"),
  // British Thermal Unit (international Table) Inch per Second Square Foot degree Fahrenheit
  BTU_IT__IN__PER__SEC__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-SEC-FT2-DEG_F"
  ),
  // gram per millilitre kelvin
  GM__PER__MilliL__K: Qudt.unitFromLocalnameRequired("GM-PER-MilliL-K"),
  // perm (0 °C)
  PERM_Metric_0DEG_C: Qudt.unitFromLocalnameRequired("PERM_Metric_0DEG_C"),
  // candela per square foot
  CD__PER__FT2: Qudt.unitFromLocalnameRequired("CD-PER-FT2"),
  // kBTU per Square Foot
  KiloBTU_IT__PER__FT2: Qudt.unitFromLocalnameRequired("KiloBTU_IT-PER-FT2"),
  // US Dry Pint
  PINT_US_DRY: Qudt.unitFromLocalnameRequired("PINT_US_DRY"),
  // Cubic Meter per Cubic Meter
  M3__PER__M3: Qudt.unitFromLocalnameRequired("M3-PER-M3"),
  // international candle
  CD_IN: Qudt.unitFromLocalnameRequired("CD_IN"),
  // Coulomb mal Quadratmeter je Volt
  C__M2__PER__V: Qudt.unitFromLocalnameRequired("C-M2-PER-V"),
  // ounce second per cubic inch cubic yard
  OZ__SEC__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("OZ-SEC-PER-IN3-YD3"),
  // percent per centipoise
  PERCENT__PER__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-CentiPOISE"
  ),
  // Picopascal per Kilometer
  PicoPA__PER__KiloM: Qudt.unitFromLocalnameRequired("PicoPA-PER-KiloM"),
  // kilobaud
  KiloBD: Qudt.unitFromLocalnameRequired("KiloBD"),
  // Kilocoulomb per Square Meter
  KiloC__PER__M2: Qudt.unitFromLocalnameRequired("KiloC-PER-M2"),
  // Nanomoles per kilogram
  NanoMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("NanoMOL-PER-KiloGM"),
  // cubic metre per hour kelvin
  M3__PER__HR__K: Qudt.unitFromLocalnameRequired("M3-PER-HR-K"),
  // Reciprocal Metre
  PER__M: Qudt.unitFromLocalnameRequired("PER-M"),
  // tonne per minute bar
  TON_Metric__PER__MIN__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-MIN-BAR"
  ),
  // square kilometre
  KiloM2: Qudt.unitFromLocalnameRequired("KiloM2"),
  // Megapascal Cubic Meter per Second
  MegaPA__M3__PER__SEC: Qudt.unitFromLocalnameRequired("MegaPA-M3-PER-SEC"),
  // Milliampere per Inch
  MilliA__PER__IN: Qudt.unitFromLocalnameRequired("MilliA-PER-IN"),
  // Board Foot
  FBM: Qudt.unitFromLocalnameRequired("FBM"),
  // Kilocalorie per Centimeter Second Degree Celsius
  KiloCAL__PER__CentiM__SEC__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-CentiM-SEC-DEG_C"
  ),
  // pound square inch per gallon(UK) pound-force second
  LB__IN2__PER__GAL_UK__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-GAL_UK-LB_F-SEC"
  ),
  // Statcoulomb per Mole
  C_Stat__PER__MOL: Qudt.unitFromLocalnameRequired("C_Stat-PER-MOL"),
  // Breath per Minute
  BREATH__PER__MIN: Qudt.unitFromLocalnameRequired("BREATH-PER-MIN"),
  // square metre per second bar
  M2__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("M2-PER-SEC-BAR"),
  // Kilogram_force Metre
  KiloGM_F__M: Qudt.unitFromLocalnameRequired("KiloGM_F-M"),
  // PetaByte
  PetaBYTE: Qudt.unitFromLocalnameRequired("PetaBYTE"),
  // inch per two pi radians
  IN__PER__2PiRAD: Qudt.unitFromLocalnameRequired("IN-PER-2PiRAD"),
  // Naira
  NGN_Currency: Qudt.currencyFromLocalnameRequired("NGN"),
  // Cubic Foot per Day
  FT3__PER__DAY: Qudt.unitFromLocalnameRequired("FT3-PER-DAY"),
  // Gram per Millimetre Bar
  GM__PER__MilliM__BAR: Qudt.unitFromLocalnameRequired("GM-PER-MilliM-BAR"),
  // Hartree
  E_h: Qudt.unitFromLocalnameRequired("E_h"),
  // Kelvin per Square Second
  K__PER__SEC2: Qudt.unitFromLocalnameRequired("K-PER-SEC2"),
  // Micromoles per square metre second
  MicroMOL__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2-SEC"),
  // Watt per Square Meter Kelvin
  W__PER__M2__K: Qudt.unitFromLocalnameRequired("W-PER-M2-K"),
  // femtovolt
  FemtoV: Qudt.unitFromLocalnameRequired("FemtoV"),
  // centimetre per second bar
  CentiM__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC-BAR"),
  // Sidereal Day
  DAY_Sidereal: Qudt.unitFromLocalnameRequired("DAY_Sidereal"),
  // Erg per Centimeter
  ERG__PER__CentiM: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM"),
  // Peck (UK) per Hour
  PK_UK__PER__HR: Qudt.unitFromLocalnameRequired("PK_UK-PER-HR"),
  // Milligram per Minute
  MilliGM__PER__MIN: Qudt.unitFromLocalnameRequired("MilliGM-PER-MIN"),
  // ounce minute per cubic inch gallon (UK)
  OZ__MIN__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "OZ-MIN-PER-IN3-GAL_UK"
  ),
  // Milligram per Hectare
  MilliGM__PER__HA: Qudt.unitFromLocalnameRequired("MilliGM-PER-HA"),
  // Becquerels per litre
  BQ__PER__L: Qudt.unitFromLocalnameRequired("BQ-PER-L"),
  // Micromoles per litre
  MicroMOL__PER__L: Qudt.unitFromLocalnameRequired("MicroMOL-PER-L"),
  // Gigacoulomb per Cubic Meter
  GigaC__PER__M3: Qudt.unitFromLocalnameRequired("GigaC-PER-M3"),
  // Ethiopian Birr
  ETB_Currency: Qudt.currencyFromLocalnameRequired("ETB"),
  // gram per cubic metre centipoise
  GM__PER__M3__CentiPOISE: Qudt.unitFromLocalnameRequired(
    "GM-PER-M3-CentiPOISE"
  ),
  // Microgram per Deciliter
  MicroGM__PER__DeciL: Qudt.unitFromLocalnameRequired("MicroGM-PER-DeciL"),
  // Parts per trillion by volume
  PPTR_VOL: Qudt.unitFromLocalnameRequired("PPTR_VOL"),
  // millimetre per second squared
  MilliM__PER__SEC2: Qudt.unitFromLocalnameRequired("MilliM-PER-SEC2"),
  // Picowatts per square centimetre litre
  PicoW__PER__CentiM2__L: Qudt.unitFromLocalnameRequired("PicoW-PER-CentiM2-L"),
  // Grains per Cubic Metre
  GRAIN__PER__M3: Qudt.unitFromLocalnameRequired("GRAIN-PER-M3"),
  // petawatt
  PetaW: Qudt.unitFromLocalnameRequired("PetaW"),
  // Reciprocal steradian
  PER__SR: Qudt.unitFromLocalnameRequired("PER-SR"),
  // ampere per pascal
  A__PER__PA: Qudt.unitFromLocalnameRequired("A-PER-PA"),
  // degree Fahrenheit hour square foot per British thermal unit (international table) inch
  DEG_F__HR__FT2__PER__BTU_IT__IN: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_IT-IN"
  ),
  // Kilograms per metre second
  KiloGM__PER__M__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-SEC"),
  // Parts per billion
  PPB: Qudt.unitFromLocalnameRequired("PPB"),
  // Volt per Square Meter
  V__PER__M2: Qudt.unitFromLocalnameRequired("V-PER-M2"),
  // Abampere Square centimetre
  A_Ab__CentiM2: Qudt.unitFromLocalnameRequired("A_Ab-CentiM2"),
  // Millimoles per mole
  MilliMOL__PER__MOL: Qudt.unitFromLocalnameRequired("MilliMOL-PER-MOL"),
  // one
  ONE: Qudt.unitFromLocalnameRequired("ONE"),
  // microampere
  MicroA: Qudt.unitFromLocalnameRequired("MicroA"),
  // MilliSiemens per metre
  MilliS__PER__M: Qudt.unitFromLocalnameRequired("MilliS-PER-M"),
  // Cubic Meter per Square Meter
  M3__PER__M2: Qudt.unitFromLocalnameRequired("M3-PER-M2"),
  // Kilojoule per Mole
  KiloJ__PER__MOL: Qudt.unitFromLocalnameRequired("KiloJ-PER-MOL"),
  // metre second squared
  M__SEC2: Qudt.unitFromLocalnameRequired("M-SEC2"),
  // micronewton metre per square metre
  MicroN__M__PER__M2: Qudt.unitFromLocalnameRequired("MicroN-M-PER-M2"),
  // Inch of Water
  IN_H2O: Qudt.unitFromLocalnameRequired("IN_H2O"),
  // Ampere Square Meter per Joule Second
  A__M2__PER__J__SEC: Qudt.unitFromLocalnameRequired("A-M2-PER-J-SEC"),
  // Calorie (international Table) per Gram Degree Celsius
  CAL_IT__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired("CAL_IT-PER-GM-DEG_C"),
  // lumen per square foot
  LM__PER__FT2: Qudt.unitFromLocalnameRequired("LM-PER-FT2"),
  // Serbian Dinar
  RSD_Currency: Qudt.currencyFromLocalnameRequired("RSD"),
  // pound-force per yard
  LB_F__PER__YD: Qudt.unitFromLocalnameRequired("LB_F-PER-YD"),
  // lumen hour
  LM__HR: Qudt.unitFromLocalnameRequired("LM-HR"),
  // Pound Force Foot per Ampere
  KiloLB_F__FT__PER__A: Qudt.unitFromLocalnameRequired("KiloLB_F-FT-PER-A"),
  // millivolt ampere reactive per kelvin
  MilliV__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired(
    "MilliV-A_Reactive-PER-K"
  ),
  // DeciNewton
  DeciN: Qudt.unitFromLocalnameRequired("DeciN"),
  // Newton per Square Millimeter
  N__PER__MilliM2: Qudt.unitFromLocalnameRequired("N-PER-MilliM2"),
  // litre per bar
  L__PER__BAR: Qudt.unitFromLocalnameRequired("L-PER-BAR"),
  // Newton Metre per Metre Radian
  N__M__PER__M__RAD: Qudt.unitFromLocalnameRequired("N-M-PER-M-RAD"),
  // Square Metre per Hectare Year
  M2__PER__HA__YR: Qudt.unitFromLocalnameRequired("M2-PER-HA-YR"),
  // gigaohm metre
  GigaOHM__M: Qudt.unitFromLocalnameRequired("GigaOHM-M"),
  // ampere per kelvin
  A__PER__K: Qudt.unitFromLocalnameRequired("A-PER-K"),
  // Long Ton
  TON_LONG: Qudt.unitFromLocalnameRequired("TON_LONG"),
  // Galileo
  GALILEO: Qudt.unitFromLocalnameRequired("GALILEO"),
  // Microfarad per Kilometre
  MicroFARAD__PER__KiloM: Qudt.unitFromLocalnameRequired(
    "MicroFARAD-PER-KiloM"
  ),
  // Kiloampere Hour
  KiloA__HR: Qudt.unitFromLocalnameRequired("KiloA-HR"),
  // foot second per cubic inch
  FT__SEC__PER__IN3: Qudt.unitFromLocalnameRequired("FT-SEC-PER-IN3"),
  // Megabit per Second
  MegaBIT__PER__SEC: Qudt.unitFromLocalnameRequired("MegaBIT-PER-SEC"),
  // Coulomb per Square Centimeter
  C__PER__CentiM2: Qudt.unitFromLocalnameRequired("C-PER-CentiM2"),
  // electronvolt square metre
  EV__M2: Qudt.unitFromLocalnameRequired("EV-M2"),
  // Gigahertz
  GigaHZ: Qudt.unitFromLocalnameRequired("GigaHZ"),
  // kilogram per meter kubik
  KiloGM__PER__M3: Qudt.unitFromLocalnameRequired("KiloGM-PER-M3"),
  // kilogram per day kelvin
  KiloGM__PER__DAY__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-DAY-K"),
  // Centimole per litre
  CentiMOL__PER__L: Qudt.unitFromLocalnameRequired("CentiMOL-PER-L"),
  // Kilograms per square kilometre
  KiloGM__PER__KiloM2: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloM2"),
  // Argentine Peso
  ARS_Currency: Qudt.currencyFromLocalnameRequired("ARS"),
  // Yemeni Rial
  YER_Currency: Qudt.currencyFromLocalnameRequired("YER"),
  // British thermal unit (thermochemical) per pound degree Rankine
  BTU_TH__PER__LB__DEG_R: Qudt.unitFromLocalnameRequired("BTU_TH-PER-LB-DEG_R"),
  // Grad
  GRAD: Qudt.unitFromLocalnameRequired("GRAD"),
  // luks
  LUX: Qudt.unitFromLocalnameRequired("LUX"),
  // Peck (UK) per Minute
  PK_UK__PER__MIN: Qudt.unitFromLocalnameRequired("PK_UK-PER-MIN"),
  // Tonne per Hour
  TONNE__PER__HR: Qudt.unitFromLocalnameRequired("TONNE-PER-HR"),
  // milliampere per litre minute
  MilliA__PER__L__MIN: Qudt.unitFromLocalnameRequired("MilliA-PER-L-MIN"),
  // Picowatt per Square Meter
  PicoW__PER__M2: Qudt.unitFromLocalnameRequired("PicoW-PER-M2"),
  // stokes per bar
  ST__PER__BAR: Qudt.unitFromLocalnameRequired("ST-PER-BAR"),
  // Millihenry per Ohm
  MilliH__PER__OHM: Qudt.unitFromLocalnameRequired("MilliH-PER-OHM"),
  // degree Celsius per bar
  DEG_C__PER__BAR: Qudt.unitFromLocalnameRequired("DEG_C-PER-BAR"),
  // percent per thousand
  PERCENT__PER__KiloCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-KiloCount"
  ),
  // Calorie (thermochemical) per Minute
  CAL_TH__PER__MIN: Qudt.unitFromLocalnameRequired("CAL_TH-PER-MIN"),
  // ounce hour per cubic inch gallon (UK)
  OZ__HR__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "OZ-HR-PER-IN3-GAL_UK"
  ),
  // Hundredweight (UK)
  Hundredweight_UK: Qudt.unitFromLocalnameRequired("Hundredweight_UK"),
  // Square Metre per Mole
  M2__PER__MOL: Qudt.unitFromLocalnameRequired("M2-PER-MOL"),
  // Gigapascal Cubed Centimeter per Gram
  GigaPA__CentiM3__PER__GM: Qudt.unitFromLocalnameRequired(
    "GigaPA-CentiM3-PER-GM"
  ),
  // exajoule per second
  ExaJ__PER__SEC: Qudt.unitFromLocalnameRequired("ExaJ-PER-SEC"),
  // Pascal metres per square second
  PA__M__PER__SEC2: Qudt.unitFromLocalnameRequired("PA-M-PER-SEC2"),
  // Shannon
  SHANNON: Qudt.unitFromLocalnameRequired("SHANNON"),
  // microgray per second
  MicroGRAY__PER__SEC: Qudt.unitFromLocalnameRequired("MicroGRAY-PER-SEC"),
  // Czech Koruna
  CZK_Currency: Qudt.currencyFromLocalnameRequired("CZK"),
  // Attojoule
  AttoJ: Qudt.unitFromLocalnameRequired("AttoJ"),
  // ounce second per power of inch with the exponent 6
  OZ__SEC__PER__IN6: Qudt.unitFromLocalnameRequired("OZ-SEC-PER-IN6"),
  // reciprocal electron volt per cubic metre
  PER__EV__M3: Qudt.unitFromLocalnameRequired("PER-EV-M3"),
  // sievert per hour
  SV__PER__HR: Qudt.unitFromLocalnameRequired("SV-PER-HR"),
  // Square Centimeter
  CentiM2: Qudt.unitFromLocalnameRequired("CentiM2"),
  // Number per milligram
  NUM__PER__MilliGM: Qudt.unitFromLocalnameRequired("NUM-PER-MilliGM"),
  // Reciprocal Month
  PER__MO: Qudt.unitFromLocalnameRequired("PER-MO"),
  // ounce minute per power of inch with the exponent 6
  OZ__MIN__PER__IN6: Qudt.unitFromLocalnameRequired("OZ-MIN-PER-IN6"),
  // Coulomb per Kilogram
  C__PER__KiloGM: Qudt.unitFromLocalnameRequired("C-PER-KiloGM"),
  // Kilogram per Square Foot
  KiloGM__PER__FT2: Qudt.unitFromLocalnameRequired("KiloGM-PER-FT2"),
  // millilitre per day bar
  MilliL__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-DAY-BAR"),
  // Nanomoles per litre day
  NanoMOL__PER__L__DAY: Qudt.unitFromLocalnameRequired("NanoMOL-PER-L-DAY"),
  // kilogram per litre bar
  KiloGM__PER__L__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-L-BAR"),
  // PSI Cubic Metre per Second
  PSI__M3__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-M3-PER-SEC"),
  // millimetre per bar
  MilliM__PER__BAR: Qudt.unitFromLocalnameRequired("MilliM-PER-BAR"),
  // Heart Beats per Minute
  BEAT__PER__MIN: Qudt.unitFromLocalnameRequired("BEAT-PER-MIN"),
  // Reciprocal metre per second
  PER__M__SEC: Qudt.unitFromLocalnameRequired("PER-M-SEC"),
  // Nanometer per Centimeter PSI
  NanoM__PER__CentiM__PSI: Qudt.unitFromLocalnameRequired(
    "NanoM-PER-CentiM-PSI"
  ),
  // Watt per Kilogram
  W__PER__KiloGM: Qudt.unitFromLocalnameRequired("W-PER-KiloGM"),
  // Barrel (US) per Day
  BBL_US__PER__DAY: Qudt.unitFromLocalnameRequired("BBL_US-PER-DAY"),
  // Kilograms per metre hour
  KiloGM__PER__M__HR: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-HR"),
  // gigajoule per second
  GigaJ__PER__SEC: Qudt.unitFromLocalnameRequired("GigaJ-PER-SEC"),
  // gigavolt ampere
  GigaV__A: Qudt.unitFromLocalnameRequired("GigaV-A"),
  // milligram second per litre cubic centimetre
  MilliGM__SEC__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-L-CentiM3"
  ),
  // watt hour per litre
  W__HR__PER__L: Qudt.unitFromLocalnameRequired("W-HR-PER-L"),
  // Grams per square centimetre year
  GM__PER__CentiM2__YR: Qudt.unitFromLocalnameRequired("GM-PER-CentiM2-YR"),
  // Watts per square metre metre steradian
  W__PER__M2__M__SR: Qudt.unitFromLocalnameRequired("W-PER-M2-M-SR"),
  // ampere per ampere hour
  A__PER__A__HR: Qudt.unitFromLocalnameRequired("A-PER-A-HR"),
  // poise per kelvin
  POISE__PER__K: Qudt.unitFromLocalnameRequired("POISE-PER-K"),
  // Meter per Farad
  M__PER__FARAD: Qudt.unitFromLocalnameRequired("M-PER-FARAD"),
  // percent hour per cubic yard
  PERCENT__HR__PER__YD3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-YD3"),
  // Barrel
  BBL: Qudt.unitFromLocalnameRequired("BBL"),
  // Manat
  TMT_Currency: Qudt.currencyFromLocalnameRequired("TMT"),
  // Degree Celsius per Hour
  DEG_C__PER__HR: Qudt.unitFromLocalnameRequired("DEG_C-PER-HR"),
  // Statcoulomb
  C_Stat: Qudt.unitFromLocalnameRequired("C_Stat"),
  // Erg per Second
  ERG__PER__SEC: Qudt.unitFromLocalnameRequired("ERG-PER-SEC"),
  // Gravity
  G: Qudt.unitFromLocalnameRequired("G"),
  // reciprocal volt
  PER__V: Qudt.unitFromLocalnameRequired("PER-V"),
  // MilliBecquerel
  MilliBQ: Qudt.unitFromLocalnameRequired("MilliBQ"),
  // megaohm per kilometre
  MegaOHM__PER__KiloM: Qudt.unitFromLocalnameRequired("MegaOHM-PER-KiloM"),
  // Coulomb per Cubic Centimetre
  C__PER__CentiM3: Qudt.unitFromLocalnameRequired("C-PER-CentiM3"),
  // Cubic Foot per Second
  FT3__PER__SEC: Qudt.unitFromLocalnameRequired("FT3-PER-SEC"),
  // Dalasi
  GMD_Currency: Qudt.currencyFromLocalnameRequired("GMD"),
  // gram per litre centipoise
  GM__PER__L__CentiPOISE: Qudt.unitFromLocalnameRequired("GM-PER-L-CentiPOISE"),
  // mole per kilogram kelvin
  MOL__PER__KiloGM__K: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM-K"),
  // second per kilogram
  SEC__PER__KiloGM: Qudt.unitFromLocalnameRequired("SEC-PER-KiloGM"),
  // Nanometer per Centimeter Megapascal
  NanoM__PER__CentiM__MegaPA: Qudt.unitFromLocalnameRequired(
    "NanoM-PER-CentiM-MegaPA"
  ),
  // Metre per Square Second
  M__PER__SEC2: Qudt.unitFromLocalnameRequired("M-PER-SEC2"),
  // Reciprocal Liter
  PER__L: Qudt.unitFromLocalnameRequired("PER-L"),
  // Brewster
  BREWSTER: Qudt.unitFromLocalnameRequired("BREWSTER"),
  // gigaampere
  GigaA: Qudt.unitFromLocalnameRequired("GigaA"),
  // Cubic Inch
  IN3: Qudt.unitFromLocalnameRequired("IN3"),
  // Micropascal
  MicroPA: Qudt.unitFromLocalnameRequired("MicroPA"),
  // gram per cubic metre bar
  GM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("GM-PER-M3-BAR"),
  // Relative Permittivity
  PERMITTIVITY_REL: Qudt.unitFromLocalnameRequired("PERMITTIVITY_REL"),
  // Kilopascal
  KiloPA: Qudt.unitFromLocalnameRequired("KiloPA"),
  // Decibel
  DeciB: Qudt.unitFromLocalnameRequired("DeciB"),
  // pound hour per cubic foot cubic yard
  LB__HR__PER__FT3__YD3: Qudt.unitFromLocalnameRequired("LB-HR-PER-FT3-YD3"),
  // Nanowatt
  NanoW: Qudt.unitFromLocalnameRequired("NanoW"),
  // Fiji Dollar
  FJD_Currency: Qudt.currencyFromLocalnameRequired("FJD"),
  // Parsec
  PARSEC: Qudt.unitFromLocalnameRequired("PARSEC"),
  // Femtomoles per litre
  FemtoMOL__PER__L: Qudt.unitFromLocalnameRequired("FemtoMOL-PER-L"),
  // microvolt ampere reactive per kelvin
  MicroV__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired(
    "MicroV-A_Reactive-PER-K"
  ),
  // pound second per gallon (UK) cubic inch
  LB__SEC__PER__GAL_UK__IN3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_UK-IN3"
  ),
  // terajoule per second
  TeraJ__PER__SEC: Qudt.unitFromLocalnameRequired("TeraJ-PER-SEC"),
  // MicroCoulomb
  MicroC: Qudt.unitFromLocalnameRequired("MicroC"),
  // byte per second
  BYTE__PER__SEC: Qudt.unitFromLocalnameRequired("BYTE-PER-SEC"),
  // Cubic Centimeter per Day
  CentiM3__PER__DAY: Qudt.unitFromLocalnameRequired("CentiM3-PER-DAY"),
  // Reciprocal Angstrom
  PER__ANGSTROM: Qudt.unitFromLocalnameRequired("PER-ANGSTROM"),
  // exbibit per square metre
  ExbiBIT__PER__M2: Qudt.unitFromLocalnameRequired("ExbiBIT-PER-M2"),
  // Pound Force Second per Square Foot
  LB_F__SEC__PER__FT2: Qudt.unitFromLocalnameRequired("LB_F-SEC-PER-FT2"),
  // Number per hectare
  NUM__PER__HA: Qudt.unitFromLocalnameRequired("NUM-PER-HA"),
  // Gallon (UK) per Minute
  GAL_UK__PER__MIN: Qudt.unitFromLocalnameRequired("GAL_UK-PER-MIN"),
  // gram second per litre cubic centimetre
  GM__SEC__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-SEC-PER-L-CentiM3"
  ),
  // Belize Dollar
  BZD_Currency: Qudt.currencyFromLocalnameRequired("BZD"),
  // Pound (avoirdupois) per Day
  LB__PER__DAY: Qudt.unitFromLocalnameRequired("LB-PER-DAY"),
  // Imperial Pint
  PINT: Qudt.unitFromLocalnameRequired("PINT"),
  // gigabyte per second
  GigaBYTE__PER__SEC: Qudt.unitFromLocalnameRequired("GigaBYTE-PER-SEC"),
  // Reciprocal Cubic Foot
  PER__FT3: Qudt.unitFromLocalnameRequired("PER-FT3"),
  // Conventional Millimeter Of Water
  MilliM_H2O: Qudt.unitFromLocalnameRequired("MilliM_H2O"),
  // bushel (UK)
  BU_UK: Qudt.unitFromLocalnameRequired("BU_UK"),
  // Centimetre per Hour
  CentiM__PER__HR: Qudt.unitFromLocalnameRequired("CentiM-PER-HR"),
  // Mega Electron Volt Femtometer
  MegaEV__FemtoM: Qudt.unitFromLocalnameRequired("MegaEV-FemtoM"),
  // Reciprocal Cubic Meter Second
  PER__M3__SEC: Qudt.unitFromLocalnameRequired("PER-M3-SEC"),
  // Fluid Ounce (UK)
  OZ_VOL_UK: Qudt.unitFromLocalnameRequired("OZ_VOL_UK"),
  // Som
  KGS_Currency: Qudt.currencyFromLocalnameRequired("KGS"),
  // Imperial Ounce Force Inch
  OZ_F__IN: Qudt.unitFromLocalnameRequired("OZ_F-IN"),
  // pound square inch per cubic foot pound-force second
  LB__IN2__PER__FT3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-FT3-LB_F-SEC"
  ),
  // percent second per cubic foot
  PERCENT__SEC__PER__FT3: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-FT3"),
  // Square Second
  SEC2: Qudt.unitFromLocalnameRequired("SEC2"),
  // Kilocalorie per Square Centimeter
  KiloCAL__PER__CentiM2: Qudt.unitFromLocalnameRequired("KiloCAL-PER-CentiM2"),
  // Millicoulomb per Kilogram
  MilliC__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliC-PER-KiloGM"),
  // Reciprocal Cubic Centimetre
  PER__CentiM3: Qudt.unitFromLocalnameRequired("PER-CentiM3"),
  // Nautical Mile
  MI_N: Qudt.unitFromLocalnameRequired("MI_N"),
  // Nanogram per Square Centimeter Day
  NanoGM__PER__CentiM2__DAY: Qudt.unitFromLocalnameRequired(
    "NanoGM-PER-CentiM2-DAY"
  ),
  // Millimetre per Hour
  MilliM__PER__HR: Qudt.unitFromLocalnameRequired("MilliM-PER-HR"),
  // pound second per cubic foot gallon (US)
  LB__SEC__PER__FT3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-FT3-GAL_US"
  ),
  // MegaW
  MegaW: Qudt.unitFromLocalnameRequired("MegaW"),
  // kilojoule per kilovolt
  KiloJ__PER__KiloV: Qudt.unitFromLocalnameRequired("KiloJ-PER-KiloV"),
  // megaohm per metre
  MegaOHM__PER__M: Qudt.unitFromLocalnameRequired("MegaOHM-PER-M"),
  // Curie
  Ci: Qudt.unitFromLocalnameRequired("Ci"),
  // gigabit
  GigaBIT: Qudt.unitFromLocalnameRequired("GigaBIT"),
  // CFP franc
  XPF_Currency: Qudt.currencyFromLocalnameRequired("XPF"),
  // Pound Mass
  LB_M: Qudt.unitFromLocalnameRequired("LB_M"),
  // Radian per Hour
  RAD__PER__HR: Qudt.unitFromLocalnameRequired("RAD-PER-HR"),
  // Bar per Kelvin
  BAR__PER__K: Qudt.unitFromLocalnameRequired("BAR-PER-K"),
  // Seychelles Rupee
  SCR_Currency: Qudt.currencyFromLocalnameRequired("SCR"),
  // Millidegree Celsius
  MilliDEG_C: Qudt.unitFromLocalnameRequired("MilliDEG_C"),
  // Cubic Kilometer per Square Second
  KiloM3__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloM3-PER-SEC2"),
  // petabit
  PetaBIT: Qudt.unitFromLocalnameRequired("PetaBIT"),
  // millisievert per second
  MilliSV__PER__SEC: Qudt.unitFromLocalnameRequired("MilliSV-PER-SEC"),
  // Decapascal
  DecaPA: Qudt.unitFromLocalnameRequired("DecaPA"),
  // tonne per day kelvin
  TON_Metric__PER__DAY__K: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-DAY-K"
  ),
  // DecaK
  DecaK: Qudt.unitFromLocalnameRequired("DecaK"),
  // Torr
  TORR: Qudt.unitFromLocalnameRequired("TORR"),
  // reciprocal ounce (avoirdupois)
  PER__OZ: Qudt.unitFromLocalnameRequired("PER-OZ"),
  // pascal second per kelvin
  PA__SEC__PER__K: Qudt.unitFromLocalnameRequired("PA-SEC-PER-K"),
  // FemtoMole
  FemtoMOL: Qudt.unitFromLocalnameRequired("FemtoMOL"),
  // millivolt ampere reactive
  MilliV__A_Reactive: Qudt.unitFromLocalnameRequired("MilliV-A_Reactive"),
  // Planck Volt
  PlanckVolt: Qudt.unitFromLocalnameRequired("PlanckVolt"),
  // TeraCoulomb
  TeraC: Qudt.unitFromLocalnameRequired("TeraC"),
  // CentiCoulomb
  CentiC: Qudt.unitFromLocalnameRequired("CentiC"),
  // petabecquerel
  PetaBQ: Qudt.unitFromLocalnameRequired("PetaBQ"),
  // Meter Kelvin per Watt
  M__K__PER__W: Qudt.unitFromLocalnameRequired("M-K-PER-W"),
  // milliampere second
  MilliA__SEC: Qudt.unitFromLocalnameRequired("MilliA-SEC"),
  // Millimoles per square metre second
  MilliMOL__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M2-SEC"),
  // Rufiyaa
  MVR_Currency: Qudt.currencyFromLocalnameRequired("MVR"),
  // Decilitre
  DeciL: Qudt.unitFromLocalnameRequired("DeciL"),
  // Metres to the power four per second
  M4__PER__SEC: Qudt.unitFromLocalnameRequired("M4-PER-SEC"),
  // Number per square kilometre
  NUM__PER__KiloM2: Qudt.unitFromLocalnameRequired("NUM-PER-KiloM2"),
  // erg square centimetre
  ERG__CentiM2: Qudt.unitFromLocalnameRequired("ERG-CentiM2"),
  // Hryvnia
  UAH_Currency: Qudt.currencyFromLocalnameRequired("UAH"),
  // Weber Metre
  WB__M: Qudt.unitFromLocalnameRequired("WB-M"),
  // cubic centimetre per day kelvin
  CentiM3__PER__DAY__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-DAY-K"),
  // PetaV
  PetaV: Qudt.unitFromLocalnameRequired("PetaV"),
  // Gill (UK) per Minute
  GI_UK__PER__MIN: Qudt.unitFromLocalnameRequired("GI_UK-PER-MIN"),
  // YoctoCoulomb
  YoctoC: Qudt.unitFromLocalnameRequired("YoctoC"),
  // spin quantum number
  SPIN_QUANTUM_NUMBER: Qudt.unitFromLocalnameRequired("SPIN_QUANTUM_NUMBER"),
  // Barn
  BARN: Qudt.unitFromLocalnameRequired("BARN"),
  // percent minute per cubic yard
  PERCENT__MIN__PER__YD3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-YD3"),
  // volt per bar
  V__PER__BAR: Qudt.unitFromLocalnameRequired("V-PER-BAR"),
  // Lithuanian Litas
  LTL_Currency: Qudt.currencyFromLocalnameRequired("LTL"),
  // Gill (UK) per Day
  GI_UK__PER__DAY: Qudt.unitFromLocalnameRequired("GI_UK-PER-DAY"),
  // Netherlands Antillian Guilder
  ANG_Currency: Qudt.currencyFromLocalnameRequired("ANG"),
  // milligram per bar
  MilliGM__PER__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-BAR"),
  // milligram per litre pascal second
  MilliGM__PER__L__PA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-L-PA-SEC"
  ),
  // litre per hour kelvin
  L__PER__HR__K: Qudt.unitFromLocalnameRequired("L-PER-HR-K"),
  // metre second
  M__SEC: Qudt.unitFromLocalnameRequired("M-SEC"),
  // Number per gram
  NUM__PER__GM: Qudt.unitFromLocalnameRequired("NUM-PER-GM"),
  // Uur per Jaar
  HR__PER__YR: Qudt.unitFromLocalnameRequired("HR-PER-YR"),
  // ounce second per cubic inch gallon (US)
  OZ__SEC__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "OZ-SEC-PER-IN3-GAL_US"
  ),
  // kilobaud
  KiloBAUD: Qudt.unitFromLocalnameRequired("KiloBAUD"),
  // Micropoise
  MicroPOISE: Qudt.unitFromLocalnameRequired("MicroPOISE"),
  // Vatu
  VUV_Currency: Qudt.currencyFromLocalnameRequired("VUV"),
  // British Thermal Unit (international Table) Inch per Hour Square Foot degree Fahrenheit
  BTU_IT__IN__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-HR-FT2-DEG_F"
  ),
  // Cycles per Second
  CYC__PER__SEC: Qudt.unitFromLocalnameRequired("CYC-PER-SEC"),
  // Joule per Kilogram
  J__PER__KiloGM: Qudt.unitFromLocalnameRequired("J-PER-KiloGM"),
  // Kilo Newton per cubic metre
  KiloN__PER__M3: Qudt.unitFromLocalnameRequired("KiloN-PER-M3"),
  // BTU Foot
  BTU_IT__FT: Qudt.unitFromLocalnameRequired("BTU_IT-FT"),
  // Square degree
  DEG2: Qudt.unitFromLocalnameRequired("DEG2"),
  // Australian Dollar
  AUD_Currency: Qudt.currencyFromLocalnameRequired("AUD"),
  // Reciprocal Minute
  PER__MIN: Qudt.unitFromLocalnameRequired("PER-MIN"),
  // Decare
  DecaARE: Qudt.unitFromLocalnameRequired("DecaARE"),
  // CFA Franc BCEAO
  XOF_Currency: Qudt.currencyFromLocalnameRequired("XOF"),
  // milliampere per kelvin
  MilliA__PER__K: Qudt.unitFromLocalnameRequired("MilliA-PER-K"),
  // Gram per Cubic Centimetre
  GM__PER__CentiM3: Qudt.unitFromLocalnameRequired("GM-PER-CentiM3"),
  // KiloLB
  KiloLB: Qudt.unitFromLocalnameRequired("KiloLB"),
  // GigaCoulomb
  GigaC: Qudt.unitFromLocalnameRequired("GigaC"),
  // Iranian Rial
  IRR_Currency: Qudt.currencyFromLocalnameRequired("IRR"),
  // Nanometer per Millimeter Megapascal
  NanoM__PER__MilliM__MegaPA: Qudt.unitFromLocalnameRequired(
    "NanoM-PER-MilliM-MegaPA"
  ),
  // tonne per cubic metre kelvin
  TON_Metric__PER__M3__K: Qudt.unitFromLocalnameRequired("TON_Metric-PER-M3-K"),
  // Bahamian Dollar
  BSD_Currency: Qudt.currencyFromLocalnameRequired("BSD"),
  // Mega Hertz per Tesla
  MegaHZ__PER__T: Qudt.unitFromLocalnameRequired("MegaHZ-PER-T"),
  // Gill (US) per Second
  GI_US__PER__SEC: Qudt.unitFromLocalnameRequired("GI_US-PER-SEC"),
  // PicoKAT
  PicoKAT: Qudt.unitFromLocalnameRequired("PicoKAT"),
  // tonne per minute kelvin
  TONNE__PER__MIN__K: Qudt.unitFromLocalnameRequired("TONNE-PER-MIN-K"),
  // Carat
  CARAT: Qudt.unitFromLocalnameRequired("CARAT"),
  // Number per microlitre
  NUM__PER__MicroL: Qudt.unitFromLocalnameRequired("NUM-PER-MicroL"),
  // Square metres per Hertz degree
  M2__PER__HZ__DEG: Qudt.unitFromLocalnameRequired("M2-PER-HZ-DEG"),
  // Millinewton
  MilliN: Qudt.unitFromLocalnameRequired("MilliN"),
  // pound second per power of inch with the exponent 6
  LB__SEC__PER__IN6: Qudt.unitFromLocalnameRequired("LB-SEC-PER-IN6"),
  // Peck (UK)
  PK_UK: Qudt.unitFromLocalnameRequired("PK_UK"),
  // pound square inch per gallon (US) pound-force second
  LB__IN2__PER__GAL_US__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-IN2-PER-GAL_US-LB_F-SEC"
  ),
  // Cubic Meter per Hectare Year
  M3__PER__HA__YR: Qudt.unitFromLocalnameRequired("M3-PER-HA-YR"),
  // Megavolt Ampere Reactive Hour
  MegaV__A_Reactive__HR: Qudt.unitFromLocalnameRequired("MegaV-A_Reactive-HR"),
  // Kilobit per Second
  KiloBIT__PER__SEC: Qudt.unitFromLocalnameRequired("KiloBIT-PER-SEC"),
  // Coulomb per Mole
  C__PER__MOL: Qudt.unitFromLocalnameRequired("C-PER-MOL"),
  // Kilogram per Liter
  KiloGM__PER__L: Qudt.unitFromLocalnameRequired("KiloGM-PER-L"),
  // Nautical Mile per Minute
  MI_N__PER__MIN: Qudt.unitFromLocalnameRequired("MI_N-PER-MIN"),
  // Ouguiya
  MRU_Currency: Qudt.currencyFromLocalnameRequired("MRU"),
  // Kilogram Square Centimetre
  KiloGM__CentiM2: Qudt.unitFromLocalnameRequired("KiloGM-CentiM2"),
  // Cubic Centimeter per Mole Second
  CentiM3__PER__MOL__SEC: Qudt.unitFromLocalnameRequired("CentiM3-PER-MOL-SEC"),
  // Nanohenry per Metre
  NanoH__PER__M: Qudt.unitFromLocalnameRequired("NanoH-PER-M"),
  // Reciprocal Cubic Inch
  PER__IN3: Qudt.unitFromLocalnameRequired("PER-IN3"),
  // Pica
  PCA: Qudt.unitFromLocalnameRequired("PCA"),
  // reciprocal percent
  PER__PERCENT: Qudt.unitFromLocalnameRequired("PER-PERCENT"),
  // millimoles per litre
  MilliMOL__PER__L: Qudt.unitFromLocalnameRequired("MilliMOL-PER-L"),
  // Megagram per Hectare
  MegaGM__PER__HA: Qudt.unitFromLocalnameRequired("MegaGM-PER-HA"),
  // Abohm
  OHM_Ab: Qudt.unitFromLocalnameRequired("OHM_Ab"),
  // Acre Foot
  AC__FT: Qudt.unitFromLocalnameRequired("AC-FT"),
  // pebibit per cubic metre
  PebiBIT__PER__M3: Qudt.unitFromLocalnameRequired("PebiBIT-PER-M3"),
  // Reciprocal metre nanometre steradian
  PER__M__NanoM__SR: Qudt.unitFromLocalnameRequired("PER-M-NanoM-SR"),
  // percent second per cubic centimetre
  PERCENT__SEC__PER__CentiM3: Qudt.unitFromLocalnameRequired(
    "PERCENT-SEC-PER-CentiM3"
  ),
  // katal
  KAT: Qudt.unitFromLocalnameRequired("KAT"),
  // ounce minute per cubic inch cubic yard
  OZ__MIN__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("OZ-MIN-PER-IN3-YD3"),
  // Russian Ruble
  RUB_Currency: Qudt.currencyFromLocalnameRequired("RUB"),
  // millilitre per minute bar
  MilliL__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-MIN-BAR"),
  // Foot Of Mercury
  FT_HG: Qudt.unitFromLocalnameRequired("FT_HG"),
  // kilogram per day bar
  KiloGM__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-DAY-BAR"),
  // square meter per square meter
  M2__PER__M2: Qudt.unitFromLocalnameRequired("M2-PER-M2"),
  // European Monetary Unit (E.M.U.-6) (Bonds market unit)
  XBB_Currency: Qudt.currencyFromLocalnameRequired("XBB"),
  // gibibit
  GibiBIT: Qudt.unitFromLocalnameRequired("GibiBIT"),
  // Microhenry per Meter
  MicroH__PER__M: Qudt.unitFromLocalnameRequired("MicroH-PER-M"),
  // watt per metre degree Celsius
  W__PER__M__DEG_C: Qudt.unitFromLocalnameRequired("W-PER-M-DEG_C"),
  // Kilovolt
  KiloV: Qudt.unitFromLocalnameRequired("KiloV"),
  // nanoampere
  NanoA: Qudt.unitFromLocalnameRequired("NanoA"),
  // Nanogram per Decilitre
  NanoGM__PER__DeciL: Qudt.unitFromLocalnameRequired("NanoGM-PER-DeciL"),
  // Lunar mass
  LunarMass: Qudt.unitFromLocalnameRequired("LunarMass"),
  // metr krychlový na mol
  M3__PER__MOL: Qudt.unitFromLocalnameRequired("M3-PER-MOL"),
  // Millivolt per Minute
  MilliV__PER__MIN: Qudt.unitFromLocalnameRequired("MilliV-PER-MIN"),
  // gibibit per square metre
  GibiBIT__PER__M2: Qudt.unitFromLocalnameRequired("GibiBIT-PER-M2"),
  // mole per litre kelvin
  MOL__PER__L__K: Qudt.unitFromLocalnameRequired("MOL-PER-L-K"),
  // Picofarad per Meter
  PicoFARAD__PER__M: Qudt.unitFromLocalnameRequired("PicoFARAD-PER-M"),
  // terabit per second
  TeraBIT__PER__SEC: Qudt.unitFromLocalnameRequired("TeraBIT-PER-SEC"),
  // Qatari Rial
  QAR_Currency: Qudt.currencyFromLocalnameRequired("QAR"),
  // Hartley
  HART: Qudt.unitFromLocalnameRequired("HART"),
  // MegaINDIV
  MegaINDIV: Qudt.unitFromLocalnameRequired("MegaINDIV"),
  // poundal foot
  PDL__FT: Qudt.unitFromLocalnameRequired("PDL-FT"),
  // British thermal unit (international table) per square inch second
  BTU_IT__PER__IN2__SEC: Qudt.unitFromLocalnameRequired("BTU_IT-PER-IN2-SEC"),
  // microgray per minute
  MicroGRAY__PER__MIN: Qudt.unitFromLocalnameRequired("MicroGRAY-PER-MIN"),
  // Micromoles per mole
  MicroMOL__PER__MOL: Qudt.unitFromLocalnameRequired("MicroMOL-PER-MOL"),
  // Cubic Decimeter per Day
  DeciM3__PER__DAY: Qudt.unitFromLocalnameRequired("DeciM3-PER-DAY"),
  // वोल्ट
  V: Qudt.unitFromLocalnameRequired("V"),
  // milligram hour per litre cubic centimetre
  MilliGM__HR__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-HR-PER-L-CentiM3"
  ),
  // Degree Celsius week
  DEG_C__WK: Qudt.unitFromLocalnameRequired("DEG_C-WK"),
  // Gigabase Pair
  GigaBasePair: Qudt.unitFromLocalnameRequired("GigaBasePair"),
  // microfarad
  MicroFARAD: Qudt.unitFromLocalnameRequired("MicroFARAD"),
  // terafloating point operations per second
  TeraFLOPS: Qudt.unitFromLocalnameRequired("TeraFLOPS"),
  // gram minute per cubic metre litre
  GM__MIN__PER__M3__L: Qudt.unitFromLocalnameRequired("GM-MIN-PER-M3-L"),
  // Foot Pound Force Second
  FT__LB_F__SEC: Qudt.unitFromLocalnameRequired("FT-LB_F-SEC"),
  // Number
  NUM: Qudt.unitFromLocalnameRequired("NUM"),
  // Degrees per metre
  DEG__PER__M: Qudt.unitFromLocalnameRequired("DEG-PER-M"),
  // Roentgen
  R: Qudt.unitFromLocalnameRequired("R"),
  // tonne per minute kelvin
  TON_Metric__PER__MIN__K: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-MIN-K"
  ),
  // Picoamps per micromole litre
  PicoA__PER__MicroMOL__L: Qudt.unitFromLocalnameRequired(
    "PicoA-PER-MicroMOL-L"
  ),
  // acre-foot (based on U.S. survey foot)
  AC__FT_US: Qudt.unitFromLocalnameRequired("AC-FT_US"),
  // ニュートン
  N: Qudt.unitFromLocalnameRequired("N"),
  // petajoule per second
  PetaJ__PER__SEC: Qudt.unitFromLocalnameRequired("PetaJ-PER-SEC"),
  // British thermal unit (international table) per hour square foot degree Fahrenheit
  BTU_IT__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-HR-FT2-DEG_F"
  ),
  // British thermal unit (39 °F)
  BTU_39DEG_F: Qudt.unitFromLocalnameRequired("BTU_39DEG_F"),
  // Cubic Decimeter per Second
  DeciM3__PER__SEC: Qudt.unitFromLocalnameRequired("DeciM3-PER-SEC"),
  // Megavolt Ampere
  MegaV__A: Qudt.unitFromLocalnameRequired("MegaV-A"),
  // Millikatal per Liter
  MilliKAT__PER__L: Qudt.unitFromLocalnameRequired("MilliKAT-PER-L"),
  // प्रति मीटर वैबर
  WB__PER__M: Qudt.unitFromLocalnameRequired("WB-PER-M"),
  // UIC franc (special settlement currency)
  XFU_Currency: Qudt.currencyFromLocalnameRequired("XFU"),
  // pound hour per cubic foot gallon (US)
  LB__HR__PER__FT3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-FT3-GAL_US"
  ),
  // Pound per Minute
  LB__PER__MIN: Qudt.unitFromLocalnameRequired("LB-PER-MIN"),
  // Megajoule per Cubic Meter
  MegaJ__PER__M3: Qudt.unitFromLocalnameRequired("MegaJ-PER-M3"),
  // Ounce (avoirdupois) per Minute
  OZ__PER__MIN: Qudt.unitFromLocalnameRequired("OZ-PER-MIN"),
  // BTU Inch
  BTU_IT__IN: Qudt.unitFromLocalnameRequired("BTU_IT-IN"),
  // Reciprocal Milliliter
  PER__MilliL: Qudt.unitFromLocalnameRequired("PER-MilliL"),
  // Quartic Coulomb Metre per Cubic Energy
  C4__M4__PER__J3: Qudt.unitFromLocalnameRequired("C4-M4-PER-J3"),
  // pound second per cubic inch cubic foot
  LB__SEC__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-IN3-FT3"),
  // British Thermal Unit (thermochemical) per Pound Degree Fahrenheit
  BTU_TH__PER__LB__DEG_F: Qudt.unitFromLocalnameRequired("BTU_TH-PER-LB-DEG_F"),
  // gram second per cubic metre litre
  GM__SEC__PER__M3__L: Qudt.unitFromLocalnameRequired("GM-SEC-PER-M3-L"),
  // millivolt ampere per kelvin
  MilliV__A__PER__K: Qudt.unitFromLocalnameRequired("MilliV-A-PER-K"),
  // KiloCount
  KiloCount: Qudt.unitFromLocalnameRequired("KiloCount"),
  // kilowatt per square metre kelvin
  KiloW__PER__M2__K: Qudt.unitFromLocalnameRequired("KiloW-PER-M2-K"),
  // Picolitre
  PicoL: Qudt.unitFromLocalnameRequired("PicoL"),
  // Joule per Square Meter
  J__PER__M2: Qudt.unitFromLocalnameRequired("J-PER-M2"),
  // Barrel (US) per Minute
  BBL_US__PER__MIN: Qudt.unitFromLocalnameRequired("BBL_US-PER-MIN"),
  // International Unit per Litre
  IU__PER__L: Qudt.unitFromLocalnameRequired("IU-PER-L"),
  // quartic Centimetre
  CentiM4: Qudt.unitFromLocalnameRequired("CentiM4"),
  // cubic metre per second square metre
  M3__PER__SEC__M2: Qudt.unitFromLocalnameRequired("M3-PER-SEC-M2"),
  // millikelvin per bar
  MilliK__PER__BAR: Qudt.unitFromLocalnameRequired("MilliK-PER-BAR"),
  // gram per hertz
  GM__PER__HZ: Qudt.unitFromLocalnameRequired("GM-PER-HZ"),
  // Millilitre per Square Centimeter Second
  MilliL__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired(
    "MilliL-PER-CentiM2-SEC"
  ),
  // Kilogram per Hour
  KiloGM__PER__HR: Qudt.unitFromLocalnameRequired("KiloGM-PER-HR"),
  // BTU per Degree Rankine
  BTU_IT__PER__DEG_R: Qudt.unitFromLocalnameRequired("BTU_IT-PER-DEG_R"),
  // DeciSiemens
  DeciS: Qudt.unitFromLocalnameRequired("DeciS"),
  // GM_DRY
  GM_DRY: Qudt.unitFromLocalnameRequired("GM_DRY"),
  // Tex
  TEX: Qudt.unitFromLocalnameRequired("TEX"),
  // Surinam Dollar
  SRD_Currency: Qudt.currencyFromLocalnameRequired("SRD"),
  // Gross Tonnage
  GT: Qudt.unitFromLocalnameRequired("GT"),
  // Cubic Angstrom
  ANGSTROM3: Qudt.unitFromLocalnameRequired("ANGSTROM3"),
  // Kilosiemens per Meter
  KiloS__PER__M: Qudt.unitFromLocalnameRequired("KiloS-PER-M"),
  // US Liquid Quart
  QT_US: Qudt.unitFromLocalnameRequired("QT_US"),
  // Pound (avoirdupois) per Second
  LB__PER__SEC: Qudt.unitFromLocalnameRequired("LB-PER-SEC"),
  // Sextic Centimetre
  CentiM6: Qudt.unitFromLocalnameRequired("CentiM6"),
  // coulomb meter persegi
  C__M2: Qudt.unitFromLocalnameRequired("C-M2"),
  // Mean Gregorian Month
  MO_MeanGREGORIAN: Qudt.unitFromLocalnameRequired("MO_MeanGREGORIAN"),
  // kilopascal per metre
  KiloPA__PER__M: Qudt.unitFromLocalnameRequired("KiloPA-PER-M"),
  // Kilovolt Ampere Reactive
  KiloV__A_Reactive: Qudt.unitFromLocalnameRequired("KiloV-A_Reactive"),
  // Canadian Dollar
  CAD_Currency: Qudt.currencyFromLocalnameRequired("CAD"),
  // Planck Density
  PlanckDensity: Qudt.unitFromLocalnameRequired("PlanckDensity"),
  // Nanomoles per microgram hour
  NanoMOL__PER__MicroGM__HR: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-MicroGM-HR"
  ),
  // reciprocal kilogram
  PER__KiloGM: Qudt.unitFromLocalnameRequired("PER-KiloGM"),
  // Megaampere per Square Metre
  MegaA__PER__M2: Qudt.unitFromLocalnameRequired("MegaA-PER-M2"),
  // Standard Cubic Foot
  SCF: Qudt.unitFromLocalnameRequired("SCF"),
  // are
  ARE: Qudt.unitFromLocalnameRequired("ARE"),
  // British Thermal Unit (international Table) per Pound of Force
  BTU_IT__PER__LB_F: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB_F"),
  // picoampere per hectopascal
  PicoA__PER__HectoPA: Qudt.unitFromLocalnameRequired("PicoA-PER-HectoPA"),
  // ExbiBIT
  ExbiBIT: Qudt.unitFromLocalnameRequired("ExbiBIT"),
  // metre per degree Celcius metre
  M__PER__DEG_C__M: Qudt.unitFromLocalnameRequired("M-PER-DEG_C-M"),
  // mebibit per cubic metre
  MebiBIT__PER__M3: Qudt.unitFromLocalnameRequired("MebiBIT-PER-M3"),
  // Watts per square metre nanometre
  W__PER__M2__NanoM: Qudt.unitFromLocalnameRequired("W-PER-M2-NanoM"),
  // Gigabecquerel
  GigaBQ: Qudt.unitFromLocalnameRequired("GigaBQ"),
  // Philippine Peso
  PHP_Currency: Qudt.currencyFromLocalnameRequired("PHP"),
  // Microohm
  MicroOHM: Qudt.unitFromLocalnameRequired("MicroOHM"),
  // Micronewton Meter
  MicroN__M: Qudt.unitFromLocalnameRequired("MicroN-M"),
  // Yard per Degree Fahrenheit
  YD__PER__DEG_F: Qudt.unitFromLocalnameRequired("YD-PER-DEG_F"),
  // langley
  LANGLEY: Qudt.unitFromLocalnameRequired("LANGLEY"),
  // square centimetre per erg
  CentiM2__PER__ERG: Qudt.unitFromLocalnameRequired("CentiM2-PER-ERG"),
  // Cubic Centimetre per Kelvin
  CentiM3__PER__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-K"),
  // Foot Pound Force per Square Foot Second
  FT__LB_F__PER__FT2__SEC: Qudt.unitFromLocalnameRequired(
    "FT-LB_F-PER-FT2-SEC"
  ),
  // Kilograms per square metre second
  KiloGM__PER__M2__SEC: Qudt.unitFromLocalnameRequired("KiloGM-PER-M2-SEC"),
  // Degree per Minute
  DEG__PER__MIN: Qudt.unitFromLocalnameRequired("DEG-PER-MIN"),
  // Gram per Day
  GM__PER__DAY: Qudt.unitFromLocalnameRequired("GM-PER-DAY"),
  // milligrams per decilitre
  MilliGM__PER__DeciL: Qudt.unitFromLocalnameRequired("MilliGM-PER-DeciL"),
  // Square Kilograms per square second
  KiloGM2__PER__SEC2: Qudt.unitFromLocalnameRequired("KiloGM2-PER-SEC2"),
  // pound minute per cubic foot gallon (US)
  LB__MIN__PER__FT3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-FT3-GAL_US"
  ),
  // Square centimetres per cubic centimetre
  CentiM2__PER__CentiM3: Qudt.unitFromLocalnameRequired("CentiM2-PER-CentiM3"),
  // grams Carbon per square meter day
  GM_Carbon__PER__M2__DAY: Qudt.unitFromLocalnameRequired(
    "GM_Carbon-PER-M2-DAY"
  ),
  // Newton Metre per Kilogram
  N__M__PER__KiloGM: Qudt.unitFromLocalnameRequired("N-M-PER-KiloGM"),
  // ohm per kilometre
  OHM__PER__KiloM: Qudt.unitFromLocalnameRequired("OHM-PER-KiloM"),
  // microvolt ampere reactive
  MicroV__A_Reactive: Qudt.unitFromLocalnameRequired("MicroV-A_Reactive"),
  // seconde
  SEC: Qudt.unitFromLocalnameRequired("SEC"),
  // MegaCoulomb
  MegaC: Qudt.unitFromLocalnameRequired("MegaC"),
  // Imperial Ounce Force
  OZ_F: Qudt.unitFromLocalnameRequired("OZ_F"),
  // Coulomb per Cubic Millimeter
  C__PER__MilliM3: Qudt.unitFromLocalnameRequired("C-PER-MilliM3"),
  // OHM_CIRC
  OHM_CIRC: Qudt.unitFromLocalnameRequired("OHM_CIRC"),
  // Moles per square metre
  MOL__PER__M2: Qudt.unitFromLocalnameRequired("MOL-PER-M2"),
  // Ban
  BAN: Qudt.unitFromLocalnameRequired("BAN"),
  // Mole per Kilogram Pascal
  MOL__PER__KiloGM__PA: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM-PA"),
  // centimetre of water (4 °C)
  CentiM_H20_4DEG_C: Qudt.unitFromLocalnameRequired("CentiM_H20_4DEG_C"),
  // Liter per Mole
  L__PER__MOL: Qudt.unitFromLocalnameRequired("L-PER-MOL"),
  // pascal saat per meter kubik
  PA__SEC__PER__M3: Qudt.unitFromLocalnameRequired("PA-SEC-PER-M3"),
  // kiloohm per bar
  KiloOHM__PER__BAR: Qudt.unitFromLocalnameRequired("KiloOHM-PER-BAR"),
  // Square Decimetre
  DeciM2: Qudt.unitFromLocalnameRequired("DeciM2"),
  // Degree Fahrenheit Hour per BTU
  DEG_F__HR__PER__BTU_IT: Qudt.unitFromLocalnameRequired("DEG_F-HR-PER-BTU_IT"),
  // milligram per minute kelvin
  MilliGM__PER__MIN__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-MIN-K"),
  // US Gallon per Minute
  GAL_US__PER__MIN: Qudt.unitFromLocalnameRequired("GAL_US-PER-MIN"),
  // picovolt ampere reactive
  PicoV__A_Reactive: Qudt.unitFromLocalnameRequired("PicoV-A_Reactive"),
  // Therm US
  THM_US: Qudt.unitFromLocalnameRequired("THM_US"),
  // Standard Atmosphere
  ATM: Qudt.unitFromLocalnameRequired("ATM"),
  // Nephelometry Turbidity Unit
  NTU: Qudt.unitFromLocalnameRequired("NTU"),
  // Euro per kilowatt
  EUR__PER__KiloW: Qudt.unitFromLocalnameRequired("EUR-PER-KiloW"),
  // Erg per Gram
  ERG__PER__G: Qudt.unitFromLocalnameRequired("ERG-PER-G"),
  // pound (avoirdupois) per degree Fahrenheit
  LB__PER__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-DEG_F"),
  // Gill (US) per Day
  GI_US__PER__DAY: Qudt.unitFromLocalnameRequired("GI_US-PER-DAY"),
  // kilogram per second pascal
  KiloGM__PER__SEC__PA: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-PA"),
  // pound second per cubic foot gallon (UK)
  LB__SEC__PER__FT3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-FT3-GAL_UK"
  ),
  // US Gallon
  GAL_US: Qudt.unitFromLocalnameRequired("GAL_US"),
  // Electronvolt per Metre
  EV__PER__M: Qudt.unitFromLocalnameRequired("EV-PER-M"),
  // percent per ten thousand
  PERCENT__PER__DecaKiloCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-DecaKiloCount"
  ),
  // Centimole per kilogram
  CentiMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("CentiMOL-PER-KiloGM"),
  // Percent per week
  PERCENT__PER__WK: Qudt.unitFromLocalnameRequired("PERCENT-PER-WK"),
  // Unified Atomic Mass Unit
  U: Qudt.unitFromLocalnameRequired("U"),
  // Microbecquerels per litre
  MicroBQ__PER__L: Qudt.unitFromLocalnameRequired("MicroBQ-PER-L"),
  // Femtograms per litre
  FemtoGM__PER__L: Qudt.unitFromLocalnameRequired("FemtoGM-PER-L"),
  // calorie (thermochemical) per gram (calTH/g)
  CAL_TH__PER__G: Qudt.unitFromLocalnameRequired("CAL_TH-PER-G"),
  // kilocandela
  KiloCD: Qudt.unitFromLocalnameRequired("KiloCD"),
  // Planck Current
  PlanckCurrent: Qudt.unitFromLocalnameRequired("PlanckCurrent"),
  // Barrel (UK Petroleum) per Second
  BBL_UK_PET__PER__SEC: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-SEC"),
  // DeciTonne
  DeciTONNE: Qudt.unitFromLocalnameRequired("DeciTONNE"),
  // Pound per Foot
  LB__PER__FT: Qudt.unitFromLocalnameRequired("LB-PER-FT"),
  // decibel watt
  DeciB__W: Qudt.unitFromLocalnameRequired("DeciB-W"),
  // Kilocalorie per Gram
  KiloCAL__PER__GM: Qudt.unitFromLocalnameRequired("KiloCAL-PER-GM"),
  // foot hour per gallon (UK)
  FT__HR__PER__GAL_UK: Qudt.unitFromLocalnameRequired("FT-HR-PER-GAL_UK"),
  // millisievert per hour
  MilliSV__PER__HR: Qudt.unitFromLocalnameRequired("MilliSV-PER-HR"),
  // mole per kilogram bar
  MOL__PER__KiloGM__BAR: Qudt.unitFromLocalnameRequired("MOL-PER-KiloGM-BAR"),
  // pixel
  PIXEL: Qudt.unitFromLocalnameRequired("PIXEL"),
  // Millimetre of Mercury - Absolute
  MilliM_HGA: Qudt.unitFromLocalnameRequired("MilliM_HGA"),
  // centimetre of water (4 °C)
  CentiM_H2O_4DEG_C: Qudt.unitFromLocalnameRequired("CentiM_H2O_4DEG_C"),
  // Jamaican Dollar
  JMD_Currency: Qudt.currencyFromLocalnameRequired("JMD"),
  // Square Degrees Celsius per second
  DEG_C2__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_C2-PER-SEC"),
  // Femtometre
  FemtoM: Qudt.unitFromLocalnameRequired("FemtoM"),
  // Milliampere Hour per Gram
  MilliA__HR__PER__GM: Qudt.unitFromLocalnameRequired("MilliA-HR-PER-GM"),
  // Microbecquerel
  MicroBQ: Qudt.unitFromLocalnameRequired("MicroBQ"),
  // milligray per hour
  MilliGRAY__PER__HR: Qudt.unitFromLocalnameRequired("MilliGRAY-PER-HR"),
  // Nanolitre
  NanoL: Qudt.unitFromLocalnameRequired("NanoL"),
  // Micromole per micromole of biomass day
  MicroMOL__PER__MicroMOL__DAY: Qudt.unitFromLocalnameRequired(
    "MicroMOL-PER-MicroMOL-DAY"
  ),
  // metre per second kelvin
  M__PER__SEC__K: Qudt.unitFromLocalnameRequired("M-PER-SEC-K"),
  // Pound per Cubic Foot
  LB__PER__FT3: Qudt.unitFromLocalnameRequired("LB-PER-FT3"),
  // ExaBIT
  ExaBIT: Qudt.unitFromLocalnameRequired("ExaBIT"),
  // Joule per Kilogram Kelvin
  J__PER__KiloGM__K: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-K"),
  // Quintic Meter
  M5: Qudt.unitFromLocalnameRequired("M5"),
  // Ampere per Square Centimeter
  A__PER__CentiM2: Qudt.unitFromLocalnameRequired("A-PER-CentiM2"),
  // Mole per Hour
  MOL__PER__HR: Qudt.unitFromLocalnameRequired("MOL-PER-HR"),
  // Millicoulomb per Square Meter
  MilliC__PER__M2: Qudt.unitFromLocalnameRequired("MilliC-PER-M2"),
  // Ton
  TON: Qudt.unitFromLocalnameRequired("TON"),
  // Bushel (UK) per Minute
  BU_UK__PER__MIN: Qudt.unitFromLocalnameRequired("BU_UK-PER-MIN"),
  // degree Fahrenheit hour square foot per British thermal unit (thermochemical) inch
  DEG_F__HR__FT2__PER__BTU_TH__IN: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_TH-IN"
  ),
  // Reciprocal Cubic Millimeter
  PER__MilliM3: Qudt.unitFromLocalnameRequired("PER-MilliM3"),
  // milligram per second kelvin
  MilliGM__PER__SEC__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-SEC-K"),
  // Quart (UK Liquid) per Second
  QT_UK__PER__SEC: Qudt.unitFromLocalnameRequired("QT_UK-PER-SEC"),
  // reciprocal ton
  PER__TON: Qudt.unitFromLocalnameRequired("PER-TON"),
  // Unidades de formento (Funds code)
  CLF_Currency: Qudt.currencyFromLocalnameRequired("CLF"),
  // Dobra
  STN_Currency: Qudt.currencyFromLocalnameRequired("STN"),
  // exawatt
  ExaW: Qudt.unitFromLocalnameRequired("ExaW"),
  // Silver (one Troy ounce)
  XAG_Currency: Qudt.currencyFromLocalnameRequired("XAG"),
  // Pascal metres
  PA__M: Qudt.unitFromLocalnameRequired("PA-M"),
  // Ounce Mass
  OZ_M: Qudt.unitFromLocalnameRequired("OZ_M"),
  // Hectogram
  HectoGM: Qudt.unitFromLocalnameRequired("HectoGM"),
  // Milligrams per square metre hour
  MilliGM__PER__M2__HR: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2-HR"),
  // Hour
  HR: Qudt.unitFromLocalnameRequired("HR"),
  // Hectobar
  HectoBAR: Qudt.unitFromLocalnameRequired("HectoBAR"),
  // ExaCoulomb
  ExaC: Qudt.unitFromLocalnameRequired("ExaC"),
  // Kilogram per Mol
  KiloGM__PER__MOL: Qudt.unitFromLocalnameRequired("KiloGM-PER-MOL"),
  // pound hour per gallon (US) cubic foot
  LB__HR__PER__GAL_US__FT3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_US-FT3"
  ),
  // Croatian Kuna
  HRK_Currency: Qudt.currencyFromLocalnameRequired("HRK"),
  // Millibecquerels per square metre day
  MilliBQ__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliBQ-PER-M2-DAY"),
  // kilotesla
  KiloT: Qudt.unitFromLocalnameRequired("KiloT"),
  // Moles per Square Metre Day
  MOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MOL-PER-M2-DAY"),
  // standard atmosphere per metre
  ATM__PER__M: Qudt.unitFromLocalnameRequired("ATM-PER-M"),
  // MPSI
  MegaPSI: Qudt.unitFromLocalnameRequired("MegaPSI"),
  // milliohm per metre
  MilliOHM__PER__M: Qudt.unitFromLocalnameRequired("MilliOHM-PER-M"),
  // Number per square metre
  NUM__PER__M2: Qudt.unitFromLocalnameRequired("NUM-PER-M2"),
  // Euro per watt
  EUR__PER__W: Qudt.unitFromLocalnameRequired("EUR-PER-W"),
  // Flight
  FLIGHT: Qudt.unitFromLocalnameRequired("FLIGHT"),
  // Rupiah
  IDR_Currency: Qudt.currencyFromLocalnameRequired("IDR"),
  // exbibit per cubic metre
  ExbiBIT__PER__M3: Qudt.unitFromLocalnameRequired("ExbiBIT-PER-M3"),
  // rhe
  RHE: Qudt.unitFromLocalnameRequired("RHE"),
  // thousands of circular mil
  KiloMIL_Circ: Qudt.unitFromLocalnameRequired("KiloMIL_Circ"),
  // Ngultrum
  BTN_Currency: Qudt.currencyFromLocalnameRequired("BTN"),
  // cubic centimetre
  CentiM3: Qudt.unitFromLocalnameRequired("CentiM3"),
  // Katal per Liter
  KAT__PER__L: Qudt.unitFromLocalnameRequired("KAT-PER-L"),
  // Earth mass
  EarthMass: Qudt.unitFromLocalnameRequired("EarthMass"),
  // Nanomoles per litre
  NanoMOL__PER__L: Qudt.unitFromLocalnameRequired("NanoMOL-PER-L"),
  // Diopter
  DIOPTER: Qudt.unitFromLocalnameRequired("DIOPTER"),
  // Nanogram
  NanoGM: Qudt.unitFromLocalnameRequired("NanoGM"),
  // Square Metres square Hertz
  M2__HZ2: Qudt.unitFromLocalnameRequired("M2-HZ2"),
  // Millirads per hour
  MilliRAD_R__PER__HR: Qudt.unitFromLocalnameRequired("MilliRAD_R-PER-HR"),
  // Furlong
  FUR: Qudt.unitFromLocalnameRequired("FUR"),
  // Gram Degree Celsius
  GM__PER__DEG_C: Qudt.unitFromLocalnameRequired("GM-PER-DEG_C"),
  // Gigajoule
  GigaJ: Qudt.unitFromLocalnameRequired("GigaJ"),
  // barn per steradian
  BARN__PER__SR: Qudt.unitFromLocalnameRequired("BARN-PER-SR"),
  // inch per second psi
  IN__PER__SEC__PSI: Qudt.unitFromLocalnameRequired("IN-PER-SEC-PSI"),
  // Watt per Kelvin
  W__PER__K: Qudt.unitFromLocalnameRequired("W-PER-K"),
  // Quetzal
  GTQ_Currency: Qudt.currencyFromLocalnameRequired("GTQ"),
  // Hour Square Foot
  HR__FT2: Qudt.unitFromLocalnameRequired("HR-FT2"),
  // pound (avoirdupois) per cubic foot degree Fahrenheit
  LB__PER__FT3__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-FT3-DEG_F"),
  // Abampere
  A_Ab: Qudt.unitFromLocalnameRequired("A_Ab"),
  // Watthour
  W__HR: Qudt.unitFromLocalnameRequired("W-HR"),
  // Ounce (avoirdupois) per Cubic Yard
  OZ__PER__YD3: Qudt.unitFromLocalnameRequired("OZ-PER-YD3"),
  // Pascal per Second
  PA__PER__SEC: Qudt.unitFromLocalnameRequired("PA-PER-SEC"),
  // Gigapascal
  GigaPA: Qudt.unitFromLocalnameRequired("GigaPA"),
  // cubic metre per day bar
  M3__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("M3-PER-DAY-BAR"),
  // PetaCoulomb
  PetaC: Qudt.unitFromLocalnameRequired("PetaC"),
  // Barrel (UK Petroleum) per Day
  BBL_UK_PET__PER__DAY: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-DAY"),
  // gram per litre kelvin
  GM__PER__L__K: Qudt.unitFromLocalnameRequired("GM-PER-L-K"),
  // Cubic Millimetre per Gram
  MilliM3__PER__GM: Qudt.unitFromLocalnameRequired("MilliM3-PER-GM"),
  // pound second per cubic inch gallon (UK)
  LB__SEC__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-IN3-GAL_UK"
  ),
  // tonne per kelvin
  TON_Metric__PER__K: Qudt.unitFromLocalnameRequired("TON_Metric-PER-K"),
  // Picohenry
  PicoH: Qudt.unitFromLocalnameRequired("PicoH"),
  // Charrière gauge
  GA_Charriere: Qudt.unitFromLocalnameRequired("GA_Charriere"),
  // tebibit per square metre
  TebiBIT__PER__M2: Qudt.unitFromLocalnameRequired("TebiBIT-PER-M2"),
  // Nanofarad per Meter
  NanoFARAD__PER__M: Qudt.unitFromLocalnameRequired("NanoFARAD-PER-M"),
  // Planck Pressure
  PlanckPressure: Qudt.unitFromLocalnameRequired("PlanckPressure"),
  // US Survey Foot
  FT_US: Qudt.unitFromLocalnameRequired("FT_US"),
  // Bar
  BAR: Qudt.unitFromLocalnameRequired("BAR"),
  // GigaN
  GigaN: Qudt.unitFromLocalnameRequired("GigaN"),
  // Reciprocal Kilovolt Ampere Hour
  PER__KiloV__A__HR: Qudt.unitFromLocalnameRequired("PER-KiloV-A-HR"),
  // Uzbekistan Som
  UZS_Currency: Qudt.currencyFromLocalnameRequired("UZS"),
  // square centimetre per volt second
  CentiM2__PER__V__SEC: Qudt.unitFromLocalnameRequired("CentiM2-PER-V-SEC"),
  // Reciprocal Square Meter Second
  PER__M2__SEC: Qudt.unitFromLocalnameRequired("PER-M2-SEC"),
  // Coulomb per Kilogram Second
  C__PER__KiloGM__SEC: Qudt.unitFromLocalnameRequired("C-PER-KiloGM-SEC"),
  // Horsepower (brake)
  HP_Brake: Qudt.unitFromLocalnameRequired("HP_Brake"),
  // square meters per hectare
  M2__PER__HA: Qudt.unitFromLocalnameRequired("M2-PER-HA"),
  // Electronvolt per Angstrom
  EV__PER__ANGSTROM: Qudt.unitFromLocalnameRequired("EV-PER-ANGSTROM"),
  // micrometre per metre
  MicroM__PER__M: Qudt.unitFromLocalnameRequired("MicroM-PER-M"),
  // Statmho
  MHO_Stat: Qudt.unitFromLocalnameRequired("MHO_Stat"),
  // milliampere per bar
  MilliA__PER__BAR: Qudt.unitFromLocalnameRequired("MilliA-PER-BAR"),
  // Relative Permeability
  PERMEABILITY_REL: Qudt.unitFromLocalnameRequired("PERMEABILITY_REL"),
  // Rod
  ROD: Qudt.unitFromLocalnameRequired("ROD"),
  // Centimetre Second Degree Celsius
  CentiM__SEC__DEG_C: Qudt.unitFromLocalnameRequired("CentiM-SEC-DEG_C"),
  // Abfarad
  FARAD_Ab: Qudt.unitFromLocalnameRequired("FARAD_Ab"),
  // Megapascal Square Root Meter
  MegaPA__M0pt5: Qudt.unitFromLocalnameRequired("MegaPA-M0pt5"),
  // kilogray
  KiloGRAY: Qudt.unitFromLocalnameRequired("KiloGRAY"),
  // Volt Second per Metre
  V__SEC__PER__M: Qudt.unitFromLocalnameRequired("V-SEC-PER-M"),
  // KiloTonne
  KiloTONNE: Qudt.unitFromLocalnameRequired("KiloTONNE"),
  // DEG_C_GROWING_CEREAL
  DEG_C_GROWING_CEREAL: Qudt.unitFromLocalnameRequired("DEG_C_GROWING_CEREAL"),
  // square centimetre per steradian erg
  CentiM2__PER__SR__ERG: Qudt.unitFromLocalnameRequired("CentiM2-PER-SR-ERG"),
  // Electron Volt
  EV: Qudt.unitFromLocalnameRequired("EV"),
  // Pound Force per Pound
  LB_F__PER__LB: Qudt.unitFromLocalnameRequired("LB_F-PER-LB"),
  // Kilobyte per Second
  KiloBYTE__PER__SEC: Qudt.unitFromLocalnameRequired("KiloBYTE-PER-SEC"),
  // Millimetre per Second
  MilliM__PER__SEC: Qudt.unitFromLocalnameRequired("MilliM-PER-SEC"),
  // litre per day bar
  L__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("L-PER-DAY-BAR"),
  // Decimetre
  DeciM: Qudt.unitFromLocalnameRequired("DeciM"),
  // Pound per Cubic Inch
  LB__PER__IN3: Qudt.unitFromLocalnameRequired("LB-PER-IN3"),
  // percent hour per cubic centimetre
  PERCENT__HR__PER__CentiM3: Qudt.unitFromLocalnameRequired(
    "PERCENT-HR-PER-CentiM3"
  ),
  // Kilogram Square Meter
  KiloGM__M2: Qudt.unitFromLocalnameRequired("KiloGM-M2"),
  // nanoohm metre
  NanoOHM__M: Qudt.unitFromLocalnameRequired("NanoOHM-M"),
  // Solar mass
  SolarMass: Qudt.unitFromLocalnameRequired("SolarMass"),
  // Kilopascal Square Metre per Gram
  KiloPA__M2__PER__GM: Qudt.unitFromLocalnameRequired("KiloPA-M2-PER-GM"),
  // Light Year
  LY: Qudt.unitFromLocalnameRequired("LY"),
  // pound hour per power of foot with the exponent 6
  LB__HR__PER__FT6: Qudt.unitFromLocalnameRequired("LB-HR-PER-FT6"),
  // pound minute per cubic inch cubic yard
  LB__MIN__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-IN3-YD3"),
  // newton-mètre
  N__M: Qudt.unitFromLocalnameRequired("N-M"),
  // Elementary Charge
  ElementaryCharge: Qudt.unitFromLocalnameRequired("ElementaryCharge"),
  // ounce second per cubic inch gallon (UK)
  OZ__SEC__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "OZ-SEC-PER-IN3-GAL_UK"
  ),
  // second per cubic metre radian
  SEC__PER__M3__RAD: Qudt.unitFromLocalnameRequired("SEC-PER-M3-RAD"),
  // Dyne Second per Centimetre
  DYN__SEC__PER__CentiM: Qudt.unitFromLocalnameRequired("DYN-SEC-PER-CentiM"),
  // Kilogram per Gigajoule
  KiloGM__PER__GigaJ: Qudt.unitFromLocalnameRequired("KiloGM-PER-GigaJ"),
  // Reciprocal Second Steradian
  PER__SEC__SR: Qudt.unitFromLocalnameRequired("PER-SEC-SR"),
  // Lao kip
  LAK_Currency: Qudt.currencyFromLocalnameRequired("LAK"),
  // Number per metre
  NUM__PER__M: Qudt.unitFromLocalnameRequired("NUM-PER-M"),
  // Kilogram per Millimetre
  KiloGM__PER__MilliM: Qudt.unitFromLocalnameRequired("KiloGM-PER-MilliM"),
  // percent per ohm
  PERCENT__PER__OHM: Qudt.unitFromLocalnameRequired("PERCENT-PER-OHM"),
  // pound (avoirdupois) per minute psi
  LB__PER__MIN__PSI: Qudt.unitFromLocalnameRequired("LB-PER-MIN-PSI"),
  // Burundian Franc
  BIF_Currency: Qudt.currencyFromLocalnameRequired("BIF"),
  // Pascal Square Root Meter
  PA__M0pt5: Qudt.unitFromLocalnameRequired("PA-M0pt5"),
  // gram hour per litre cubic centimetre
  GM__HR__PER__L__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-HR-PER-L-CentiM3"
  ),
  // pound minute per cubic inch cubic foot
  LB__MIN__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-IN3-FT3"),
  // Litres per micromole
  L__PER__MicroMOL: Qudt.unitFromLocalnameRequired("L-PER-MicroMOL"),
  // Square microns per millilitre
  MicroM__PER__MilliL: Qudt.unitFromLocalnameRequired("MicroM-PER-MilliL"),
  // one per one
  ONE__PER__ONE: Qudt.unitFromLocalnameRequired("ONE-PER-ONE"),
  // Erlang
  ERLANG: Qudt.unitFromLocalnameRequired("ERLANG"),
  // Norwegian Krone
  NOK_Currency: Qudt.currencyFromLocalnameRequired("NOK"),
  // percent minute per cubic foot
  PERCENT__MIN__PER__FT3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-FT3"),
  // kiloohm per kelvin
  KiloOHM__PER__K: Qudt.unitFromLocalnameRequired("KiloOHM-PER-K"),
  // Microbar
  MicroBAR: Qudt.unitFromLocalnameRequired("MicroBAR"),
  // BTU per Pound Mole
  BTU_IT__PER__MOL_LB: Qudt.unitFromLocalnameRequired("BTU_IT-PER-MOL_LB"),
  // Megajoule
  MegaJ: Qudt.unitFromLocalnameRequired("MegaJ"),
  // sone
  SON: Qudt.unitFromLocalnameRequired("SON"),
  // Micrograms per square centimeter week
  MicroGM__PER__CentiM2__WK: Qudt.unitFromLocalnameRequired(
    "MicroGM-PER-CentiM2-WK"
  ),
  // Millibecquerels per gram
  MilliBQ__PER__GM: Qudt.unitFromLocalnameRequired("MilliBQ-PER-GM"),
  // nanosievert per second
  NanoSV__PER__SEC: Qudt.unitFromLocalnameRequired("NanoSV-PER-SEC"),
  // ounce hour per cubic inch cubic yard
  OZ__HR__PER__IN3__YD3: Qudt.unitFromLocalnameRequired("OZ-HR-PER-IN3-YD3"),
  // Watt Second
  W__SEC: Qudt.unitFromLocalnameRequired("W-SEC"),
  // Volt per Millimeter
  V__PER__MilliM: Qudt.unitFromLocalnameRequired("V-PER-MilliM"),
  // Millijoule per Gram
  MilliJ__PER__GM: Qudt.unitFromLocalnameRequired("MilliJ-PER-GM"),
  // Square Kelvin
  K2: Qudt.unitFromLocalnameRequired("K2"),
  // Newton Metre Squared per Ampere
  N__M2__PER__A: Qudt.unitFromLocalnameRequired("N-M2-PER-A"),
  // Mohm
  MOHM: Qudt.unitFromLocalnameRequired("MOHM"),
  // part per quadrillion
  PPQ: Qudt.unitFromLocalnameRequired("PPQ"),
  // centinewton metre per square metre
  CentiN__M__PER__M2: Qudt.unitFromLocalnameRequired("CentiN-M-PER-M2"),
  // Katal per Microlitre
  KAT__PER__MicroL: Qudt.unitFromLocalnameRequired("KAT-PER-MicroL"),
  // Tunisian Dinar
  TND_Currency: Qudt.currencyFromLocalnameRequired("TND"),
  // pond
  P: Qudt.unitFromLocalnameRequired("P"),
  // percent foot second per pound (avoirdupois)
  PERCENT__FT__SEC__PER__LB: Qudt.unitFromLocalnameRequired(
    "PERCENT-FT-SEC-PER-LB"
  ),
  // Pound Force Foot per Pound
  KiloLB_F__FT__PER__LB: Qudt.unitFromLocalnameRequired("KiloLB_F-FT-PER-LB"),
  // Angstrom
  ANGSTROM: Qudt.unitFromLocalnameRequired("ANGSTROM"),
  // Technical Atmosphere
  ATM_T: Qudt.unitFromLocalnameRequired("ATM_T"),
  // Milligrams per cubic metre hour
  MilliGM__PER__M3__HR: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-HR"),
  // percent second per litre
  PERCENT__SEC__PER__L: Qudt.unitFromLocalnameRequired("PERCENT-SEC-PER-L"),
  // Metre per Minute
  M__PER__MIN: Qudt.unitFromLocalnameRequired("M-PER-MIN"),
  // Peck (US Dry) per Minute
  PK_US_DRY__PER__MIN: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-MIN"),
  // DEATHS
  DEATHS: Qudt.unitFromLocalnameRequired("DEATHS"),
  // Dram (US)
  DRAM_US: Qudt.unitFromLocalnameRequired("DRAM_US"),
  // Gill (UK)
  GI_UK: Qudt.unitFromLocalnameRequired("GI_UK"),
  // Quadratmeter je Volt und Sekunde
  M2__PER__V__SEC: Qudt.unitFromLocalnameRequired("M2-PER-V-SEC"),
  // Kilobar
  KiloBAR: Qudt.unitFromLocalnameRequired("KiloBAR"),
  // Foot per Degree Fahrenheit
  FT__PER__DEG_F: Qudt.unitFromLocalnameRequired("FT-PER-DEG_F"),
  // Register Ton
  RT: Qudt.unitFromLocalnameRequired("RT"),
  // Brazilian Real
  BRL_Currency: Qudt.currencyFromLocalnameRequired("BRL"),
  // Pound Mass (avoirdupois) Square Foot
  LB__FT2: Qudt.unitFromLocalnameRequired("LB-FT2"),
  // Millinewton per Metre
  MilliN__PER__M: Qudt.unitFromLocalnameRequired("MilliN-PER-M"),
  // Square metres Hertz^4
  M2__HZ4: Qudt.unitFromLocalnameRequired("M2-HZ4"),
  // Decapoise
  DecaPOISE: Qudt.unitFromLocalnameRequired("DecaPOISE"),
  // newton second per square metre
  N__SEC__PER__M2: Qudt.unitFromLocalnameRequired("N-SEC-PER-M2"),
  // gram minute per cubic metre cubic centimetre
  GM__MIN__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "GM-MIN-PER-M3-CentiM3"
  ),
  // Number per cubic metre
  NUM__PER__M3: Qudt.unitFromLocalnameRequired("NUM-PER-M3"),
  // Planck Current Density
  PlanckCurrentDensity: Qudt.unitFromLocalnameRequired("PlanckCurrentDensity"),
  // volt ampere reactive per kelvin
  V__A_Reactive__PER__K: Qudt.unitFromLocalnameRequired("V-A_Reactive-PER-K"),
  // Number per square metre day
  NUM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("NUM-PER-M2-DAY"),
  // cubic centimetre per second kelvin
  CentiM3__PER__SEC__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-SEC-K"),
  // Degree Rankine per Second
  DEG_R__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_R-PER-SEC"),
  // Thousand Cubic Foot
  Kilo__FT3: Qudt.unitFromLocalnameRequired("Kilo-FT3"),
  // Gram per Kilometer
  GM__PER__KiloM: Qudt.unitFromLocalnameRequired("GM-PER-KiloM"),
  // inch of mercury (32 °F)
  IN_HG_32DEG_F: Qudt.unitFromLocalnameRequired("IN_HG_32DEG_F"),
  // reciprocal tonne
  PER__TONNE: Qudt.unitFromLocalnameRequired("PER-TONNE"),
  // Degree API
  DEGREE_API: Qudt.unitFromLocalnameRequired("DEGREE_API"),
  // Volt per Microsecond
  V__PER__MicroSEC: Qudt.unitFromLocalnameRequired("V-PER-MicroSEC"),
  // Colombian Peso
  COP_Currency: Qudt.currencyFromLocalnameRequired("COP"),
  // cubic decimetre per kilogram
  DeciM3__PER__KiloGM: Qudt.unitFromLocalnameRequired("DeciM3-PER-KiloGM"),
  // pound minute per gallon (UK) cubic inch
  LB__MIN__PER__GAL_UK__IN3: Qudt.unitFromLocalnameRequired(
    "LB-MIN-PER-GAL_UK-IN3"
  ),
  // Acidity
  PH: Qudt.unitFromLocalnameRequired("PH"),
  // ohm per bar
  OHM__PER__BAR: Qudt.unitFromLocalnameRequired("OHM-PER-BAR"),
  // Mole per Litre
  MOL__PER__L: Qudt.unitFromLocalnameRequired("MOL-PER-L"),
  // Moles per square metre second metre
  MOL__PER__M2__SEC__M: Qudt.unitFromLocalnameRequired("MOL-PER-M2-SEC-M"),
  // Watt metre per square metre steradian
  W__M__PER__M2__SR: Qudt.unitFromLocalnameRequired("W-M-PER-M2-SR"),
  // Calorie (thermochemical) per Second
  CAL_TH__PER__SEC: Qudt.unitFromLocalnameRequired("CAL_TH-PER-SEC"),
  // Hectopascal
  HectoPA: Qudt.unitFromLocalnameRequired("HectoPA"),
  // Newtons per cubic metre
  N__PER__M3: Qudt.unitFromLocalnameRequired("N-PER-M3"),
  // megafloating point operations per second
  MegaFLOPS: Qudt.unitFromLocalnameRequired("MegaFLOPS"),
  // Cup (US)
  CUP_US: Qudt.unitFromLocalnameRequired("CUP_US"),
  // pound-force inch per inch
  LB_F__IN__PER__IN: Qudt.unitFromLocalnameRequired("LB_F-IN-PER-IN"),
  // Number per picoliter
  NUM__PER__PicoL: Qudt.unitFromLocalnameRequired("NUM-PER-PicoL"),
  // Picofarad
  PicoFARAD: Qudt.unitFromLocalnameRequired("PicoFARAD"),
  // femtoampere
  FemtoA: Qudt.unitFromLocalnameRequired("FemtoA"),
  // gram hour per litre cubic metre
  GM__HR__PER__L__M3: Qudt.unitFromLocalnameRequired("GM-HR-PER-L-M3"),
  // Millibar
  MilliBAR: Qudt.unitFromLocalnameRequired("MilliBAR"),
  // gram per cubic metre pascal second
  GM__PER__M3__PA__SEC: Qudt.unitFromLocalnameRequired("GM-PER-M3-PA-SEC"),
  // Erg per Square Centimeter Second
  ERG__PER__CentiM2__SEC: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM2-SEC"),
  // Megapascal Square Root Meter
  MegaPA__M0dot5: Qudt.unitFromLocalnameRequired("MegaPA-M0dot5"),
  // Percent Relative Humidity
  PERCENT_RH: Qudt.unitFromLocalnameRequired("PERCENT_RH"),
  // British Thermal Unit (TH) per Pound
  BTU_TH__PER__LB: Qudt.unitFromLocalnameRequired("BTU_TH-PER-LB"),
  // milligram per kelvin
  MilliGM__PER__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-K"),
  // ton short per hour degree Fahrenheit
  TON_SHORT__PER__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "TON_SHORT-PER-HR-DEG_F"
  ),
  // Knot per Second
  KN__PER__SEC: Qudt.unitFromLocalnameRequired("KN-PER-SEC"),
  // Degree per Square Second
  DEG__PER__SEC2: Qudt.unitFromLocalnameRequired("DEG-PER-SEC2"),
  // Barye
  BARYE: Qudt.unitFromLocalnameRequired("BARYE"),
  // calorie (20 °C)
  CAL_20DEG_C: Qudt.unitFromLocalnameRequired("CAL_20DEG_C"),
  // Cubic Centimetre per Second
  CentiM3__PER__SEC: Qudt.unitFromLocalnameRequired("CentiM3-PER-SEC"),
  // milligram per litre millipascal second
  MilliGM__PER__L__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-L-MilliPA-SEC"
  ),
  // 1000000I
  _1000000I: Qudt.unitFromLocalnameRequired("1000000I"),
  // Square Foot Hour Degree Fahrenheit
  FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired("FT2-HR-DEG_F"),
  // Haiti Gourde
  HTG_Currency: Qudt.currencyFromLocalnameRequired("HTG"),
  // Planck Energy
  PlanckEnergy: Qudt.unitFromLocalnameRequired("PlanckEnergy"),
  // Foot Pound Force per Minute
  FT__LB_F__PER__MIN: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-MIN"),
  // pound minute per square gallon (UK)
  LB__MIN__PER__GAL_UK2: Qudt.unitFromLocalnameRequired("LB-MIN-PER-GAL_UK2"),
  // PlanckTemperature
  PlanckTemperature: Qudt.unitFromLocalnameRequired("PlanckTemperature"),
  // Pound per Hour
  LB__PER__HR: Qudt.unitFromLocalnameRequired("LB-PER-HR"),
  // Relative Electromagnetic Permeability
  PERMEABILITY_EM_REL: Qudt.unitFromLocalnameRequired("PERMEABILITY_EM_REL"),
  // British Thermal Unit (IT) per Cubic Foot
  BTU_IT__PER__FT3: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT3"),
  // Degree Fahrenheit Hour Square Foot per British Thermal Unit (thermochemical)
  DEG_F__HR__FT2__PER__BTU_TH: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_TH"
  ),
  // cubic mile (UK statute)
  MI_UK3: Qudt.unitFromLocalnameRequired("MI_UK3"),
  // ampere per square second
  A__SEC2: Qudt.unitFromLocalnameRequired("A-SEC2"),
  // microjoule per second
  MicroJ__PER__SEC: Qudt.unitFromLocalnameRequired("MicroJ-PER-SEC"),
  // Newtonmetersekunden pro Radian
  N__M__SEC__PER__RAD: Qudt.unitFromLocalnameRequired("N-M-SEC-PER-RAD"),
  // Micromoles per square metre
  MicroMOL__PER__M2: Qudt.unitFromLocalnameRequired("MicroMOL-PER-M2"),
  // Joule per Mole Kelvin
  J__PER__MOL__K: Qudt.unitFromLocalnameRequired("J-PER-MOL-K"),
  // Pascal per Kelvin
  PA__PER__K: Qudt.unitFromLocalnameRequired("PA-PER-K"),
  // NanoMole
  NanoMOL: Qudt.unitFromLocalnameRequired("NanoMOL"),
  // Abtesla
  T_Ab: Qudt.unitFromLocalnameRequired("T_Ab"),
  // Kelvin per Tesla
  K__PER__T: Qudt.unitFromLocalnameRequired("K-PER-T"),
  // Terawatt
  TeraW: Qudt.unitFromLocalnameRequired("TeraW"),
  // ampere hour per cubic decimetre
  A__HR__PER__DeciM3: Qudt.unitFromLocalnameRequired("A-HR-PER-DeciM3"),
  // BTU (TH) Inch per Square Foot Second Degree Fahrenheit
  BTU_TH__IN__PER__FT2__SEC__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-IN-PER-FT2-SEC-DEG_F"
  ),
  // Loti
  LSL_Currency: Qudt.currencyFromLocalnameRequired("LSL"),
  // MicroCurie
  MicroCi: Qudt.unitFromLocalnameRequired("MicroCi"),
  // Cubic Decimeter per Cubic Meter
  DeciM3__PER__M3: Qudt.unitFromLocalnameRequired("DeciM3-PER-M3"),
  // Clo
  CLO: Qudt.unitFromLocalnameRequired("CLO"),
  // Cape Verde Escudo
  CVE_Currency: Qudt.currencyFromLocalnameRequired("CVE"),
  // Solomon Islands Dollar
  SBD_Currency: Qudt.currencyFromLocalnameRequired("SBD"),
  // Foot per Square Second
  FT__PER__SEC2: Qudt.unitFromLocalnameRequired("FT-PER-SEC2"),
  // mebibit per square metre
  MebiBIT__PER__M2: Qudt.unitFromLocalnameRequired("MebiBIT-PER-M2"),
  // Barad
  BARAD: Qudt.unitFromLocalnameRequired("BARAD"),
  // Decibar
  DeciBAR: Qudt.unitFromLocalnameRequired("DeciBAR"),
  // Reciprocal Mille Psi
  PER__MILLE__PSI: Qudt.unitFromLocalnameRequired("PER-MILLE-PSI"),
  // Joule Second per Mole
  J__SEC__PER__MOL: Qudt.unitFromLocalnameRequired("J-SEC-PER-MOL"),
  // Byte
  BYTE: Qudt.unitFromLocalnameRequired("BYTE"),
  // Newton per Ampere
  N__PER__A: Qudt.unitFromLocalnameRequired("N-PER-A"),
  // degree Fahrenheit second per British thermal unit (thermochemical)
  DEG_F__SEC__PER__BTU_TH: Qudt.unitFromLocalnameRequired(
    "DEG_F-SEC-PER-BTU_TH"
  ),
  // Pound per Gallon
  LB__PER__GAL: Qudt.unitFromLocalnameRequired("LB-PER-GAL"),
  // Kilohertz
  KiloHZ: Qudt.unitFromLocalnameRequired("KiloHZ"),
  // milligram per cubic metre bar
  MilliGM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3-BAR"),
  // milliohm metre
  MilliOHM__M: Qudt.unitFromLocalnameRequired("MilliOHM-M"),
  // millisievert per minute
  MilliSV__PER__MIN: Qudt.unitFromLocalnameRequired("MilliSV-PER-MIN"),
  // Reciprocal Square Meter
  PER__M2: Qudt.unitFromLocalnameRequired("PER-M2"),
  // MI_UK
  MI_UK: Qudt.unitFromLocalnameRequired("MI_UK"),
  // gram per cubic centimetre bar
  GM__PER__CentiM3__BAR: Qudt.unitFromLocalnameRequired("GM-PER-CentiM3-BAR"),
  // Kilomole per Hour
  KiloMOL__PER__HR: Qudt.unitFromLocalnameRequired("KiloMOL-PER-HR"),
  // metro por segundo
  M__PER__SEC: Qudt.unitFromLocalnameRequired("M-PER-SEC"),
  // MilliRad
  MilliRAD_R: Qudt.unitFromLocalnameRequired("MilliRAD_R"),
  // Leone
  SLE_Currency: Qudt.currencyFromLocalnameRequired("SLE"),
  // Electron Volt Second
  EV__SEC: Qudt.unitFromLocalnameRequired("EV-SEC"),
  // Calorie per Gram Degree Celsius
  KiloCAL__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-GM-DEG_C"
  ),
  // MillionUSD
  MillionUSD: Qudt.unitFromLocalnameRequired("MillionUSD"),
  // Foot Candle
  FC: Qudt.unitFromLocalnameRequired("FC"),
  // KiloWeber
  KiloWB: Qudt.unitFromLocalnameRequired("KiloWB"),
  // Moles per square metre second
  MOL__PER__M2__SEC: Qudt.unitFromLocalnameRequired("MOL-PER-M2-SEC"),
  // Guarani
  PYG_Currency: Qudt.currencyFromLocalnameRequired("PYG"),
  // Joule Square Metre per Kilogram
  J__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("J-M2-PER-KiloGM"),
  // Reciprocal gram
  PER__GM: Qudt.unitFromLocalnameRequired("PER-GM"),
  // sievert per second
  SV__PER__SEC: Qudt.unitFromLocalnameRequired("SV-PER-SEC"),
  // Lek
  ALL_Currency: Qudt.currencyFromLocalnameRequired("ALL"),
  // Decilitre per Gram
  DeciL__PER__GM: Qudt.unitFromLocalnameRequired("DeciL-PER-GM"),
  // Peck (UK) per Second
  PK_UK__PER__SEC: Qudt.unitFromLocalnameRequired("PK_UK-PER-SEC"),
  // Picomoles per metre watt second
  PicoMOL__PER__M__W__SEC: Qudt.unitFromLocalnameRequired(
    "PicoMOL-PER-M-W-SEC"
  ),
  // foot per second degree Fahrenheit
  FT__PER__SEC__DEG_F: Qudt.unitFromLocalnameRequired("FT-PER-SEC-DEG_F"),
  // Abcoulomb
  C_Ab: Qudt.unitFromLocalnameRequired("C_Ab"),
  // Moldovan Leu
  MDL_Currency: Qudt.currencyFromLocalnameRequired("MDL"),
  // Kilomole per Cubic Metre
  KiloMOL__PER__M3: Qudt.unitFromLocalnameRequired("KiloMOL-PER-M3"),
  // teravolt ampere
  TeraV__A: Qudt.unitFromLocalnameRequired("TeraV-A"),
  // US Liquid Pint
  PINT_US: Qudt.unitFromLocalnameRequired("PINT_US"),
  // Planck Area
  PlanckArea: Qudt.unitFromLocalnameRequired("PlanckArea"),
  // Microgram per Cubic Metre
  MicroGM__PER__M3: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3"),
  // tonne per second bar
  TONNE__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-SEC-BAR"),
  // kilovolt ampere per kelvin
  KiloV__A__PER__K: Qudt.unitFromLocalnameRequired("KiloV-A-PER-K"),
  // Pint (UK) per Second
  PINT_UK__PER__SEC: Qudt.unitFromLocalnameRequired("PINT_UK-PER-SEC"),
  // tebibit per metre
  TebiBIT__PER__M: Qudt.unitFromLocalnameRequired("TebiBIT-PER-M"),
  // bit per cubic metre
  BIT__PER__M3: Qudt.unitFromLocalnameRequired("BIT-PER-M3"),
  // Kilogram_force Meter per Second
  KiloGM_F__M__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM_F-M-PER-SEC"),
  // Joule per Cubic Centimetre Kelvin
  J__PER__CentiM3__K: Qudt.unitFromLocalnameRequired("J-PER-CentiM3-K"),
  // reciprocal volt ampere second
  PER__V__A__SEC: Qudt.unitFromLocalnameRequired("PER-V-A-SEC"),
  // Malaysian Ringgit
  MYR_Currency: Qudt.currencyFromLocalnameRequired("MYR"),
  // Gamma
  Gamma: Qudt.unitFromLocalnameRequired("Gamma"),
  // Kilogram Force
  KiloGM_F: Qudt.unitFromLocalnameRequired("KiloGM_F"),
  // Watt per Square Inch
  W__PER__IN2: Qudt.unitFromLocalnameRequired("W-PER-IN2"),
  // Dominican Peso
  DOP_Currency: Qudt.currencyFromLocalnameRequired("DOP"),
  // Kilogram per Cubic Centimetre
  KiloGM__PER__CentiM3: Qudt.unitFromLocalnameRequired("KiloGM-PER-CentiM3"),
  // 伏特每米
  V__PER__M: Qudt.unitFromLocalnameRequired("V-PER-M"),
  // pound hour per cubic inch gallon (UK)
  LB__HR__PER__IN3__GAL_UK: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-IN3-GAL_UK"
  ),
  // pound second per gallon (US) cubic yard
  LB__SEC__PER__GAL_US__YD3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_US-YD3"
  ),
  // Milligram per Hour
  MilliGM__PER__HR: Qudt.unitFromLocalnameRequired("MilliGM-PER-HR"),
  // Millihenry
  MilliH: Qudt.unitFromLocalnameRequired("MilliH"),
  // East Caribbean Dollar
  XCD_Currency: Qudt.currencyFromLocalnameRequired("XCD"),
  // Statfarad
  FARAD_Stat: Qudt.unitFromLocalnameRequired("FARAD_Stat"),
  // Darcy
  DARCY: Qudt.unitFromLocalnameRequired("DARCY"),
  // Ampere Turn
  AT: Qudt.unitFromLocalnameRequired("AT"),
  // Bar Litre per Second
  BAR__L__PER__SEC: Qudt.unitFromLocalnameRequired("BAR-L-PER-SEC"),
  // psi per inch
  PSI__PER__IN: Qudt.unitFromLocalnameRequired("PSI-PER-IN"),
  // Bushel (US Dry) per Minute
  BU_US_DRY__PER__MIN: Qudt.unitFromLocalnameRequired("BU_US_DRY-PER-MIN"),
  // Stathenry
  H_Stat: Qudt.unitFromLocalnameRequired("H_Stat"),
  // Milligal
  MilliGAL: Qudt.unitFromLocalnameRequired("MilliGAL"),
  // mebibit per metre
  MebiBIT__PER__M: Qudt.unitFromLocalnameRequired("MebiBIT-PER-M"),
  // British Thermal Unit (international Table) per Pound of force Degree Fahrenheit
  BTU_IT__PER__LB_F__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-LB_F-DEG_F"
  ),
  // Knot
  KN: Qudt.unitFromLocalnameRequired("KN"),
  // Millimetre of Mercury
  MilliM_HG: Qudt.unitFromLocalnameRequired("MilliM_HG"),
  // Abhenry
  H_Ab: Qudt.unitFromLocalnameRequired("H_Ab"),
  // Month
  MO: Qudt.unitFromLocalnameRequired("MO"),
  // Megavolt Ampere Hour
  MegaV__A__HR: Qudt.unitFromLocalnameRequired("MegaV-A-HR"),
  // Square pascal per square second
  PA2__PER__SEC2: Qudt.unitFromLocalnameRequired("PA2-PER-SEC2"),
  // Cubic Meter per Hectare
  M3__PER__HA: Qudt.unitFromLocalnameRequired("M3-PER-HA"),
  // Femtosecond
  FemtoSEC: Qudt.unitFromLocalnameRequired("FemtoSEC"),
  // Pound Force per Inch
  LB_F__PER__IN: Qudt.unitFromLocalnameRequired("LB_F-PER-IN"),
  // percent per decakelvin
  PERCENT__PER__DecaK: Qudt.unitFromLocalnameRequired("PERCENT-PER-DecaK"),
  // GAL
  GAL: Qudt.unitFromLocalnameRequired("GAL"),
  // Terawatt Hour
  TeraW__HR: Qudt.unitFromLocalnameRequired("TeraW-HR"),
  // ounce hour per power of inch with the exponent 6
  OZ__HR__PER__IN6: Qudt.unitFromLocalnameRequired("OZ-HR-PER-IN6"),
  // PicoMole
  PicoMOL: Qudt.unitFromLocalnameRequired("PicoMOL"),
  // litre per minute kelvin
  L__PER__MIN__K: Qudt.unitFromLocalnameRequired("L-PER-MIN-K"),
  // microsievert per second
  MicroSV__PER__SEC: Qudt.unitFromLocalnameRequired("MicroSV-PER-SEC"),
  // kilowatt per metre degree Celsius
  KiloW__PER__M__DEG_C: Qudt.unitFromLocalnameRequired("KiloW-PER-M-DEG_C"),
  // lux second
  LUX__SEC: Qudt.unitFromLocalnameRequired("LUX-SEC"),
  // pound (avoirdupois) per minute degree Fahrenheit
  LB__PER__MIN__DEG_F: Qudt.unitFromLocalnameRequired("LB-PER-MIN-DEG_F"),
  // Degree Fahrenheit per bar
  DEG_F__PER__BAR: Qudt.unitFromLocalnameRequired("DEG_F-PER-BAR"),
  // Reciprocal Nanometre
  PER__NanoM: Qudt.unitFromLocalnameRequired("PER-NanoM"),
  // Kilolitre per Hour
  KiloL__PER__HR: Qudt.unitFromLocalnameRequired("KiloL-PER-HR"),
  // ton short per hour psi
  TON_SHORT__PER__HR__PSI: Qudt.unitFromLocalnameRequired(
    "TON_SHORT-PER-HR-PSI"
  ),
  // Candela per Square Inch
  CD__PER__IN2: Qudt.unitFromLocalnameRequired("CD-PER-IN2"),
  // Gram per Cubic Metre
  GM__PER__M3: Qudt.unitFromLocalnameRequired("GM-PER-M3"),
  // Statohm
  OHM_Stat: Qudt.unitFromLocalnameRequired("OHM_Stat"),
  // Maxwell
  MX: Qudt.unitFromLocalnameRequired("MX"),
  // percent per volt
  PERCENT__PER__V: Qudt.unitFromLocalnameRequired("PERCENT-PER-V"),
  // metre per bar
  M__PER__BAR: Qudt.unitFromLocalnameRequired("M-PER-BAR"),
  // tonne per kelvin
  TONNE__PER__K: Qudt.unitFromLocalnameRequired("TONNE-PER-K"),
  // Mole Degree Celsius
  MOL__DEG_C: Qudt.unitFromLocalnameRequired("MOL-DEG_C"),
  // Ounce (avoirdupois) Foot
  OZ__FT: Qudt.unitFromLocalnameRequired("OZ-FT"),
  // Picometre
  PicoM: Qudt.unitFromLocalnameRequired("PicoM"),
  // Acre
  AC: Qudt.unitFromLocalnameRequired("AC"),
  // decibel with Z-weighting
  DeciB_Z: Qudt.unitFromLocalnameRequired("DeciB_Z"),
  // Kilopascal per Bar
  KiloPA__PER__BAR: Qudt.unitFromLocalnameRequired("KiloPA-PER-BAR"),
  // Degree Balling
  DEGREE_BALLING: Qudt.unitFromLocalnameRequired("DEGREE_BALLING"),
  // cubic metre per second bar
  M3__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("M3-PER-SEC-BAR"),
  // Pataca
  MOP_Currency: Qudt.currencyFromLocalnameRequired("MOP"),
  // Assay Ton
  TON_Assay: Qudt.unitFromLocalnameRequired("TON_Assay"),
  // British thermal unit (thermochemical) per square foot hour
  BTU_TH__PER__FT2__HR: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2-HR"),
  // milligram second per cubic metre cubic centimetre
  MilliGM__SEC__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-M3-CentiM3"
  ),
  // Radian Square Meter per Kilogram
  RAD__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("RAD-M2-PER-KiloGM"),
  // gram per kelvin
  GM__PER__K: Qudt.unitFromLocalnameRequired("GM-PER-K"),
  // Megapascal Liter per Second
  MegaPA__L__PER__SEC: Qudt.unitFromLocalnameRequired("MegaPA-L-PER-SEC"),
  // Millilitre per Square Centimetre Minute
  MilliL__PER__CentiM2__MIN: Qudt.unitFromLocalnameRequired(
    "MilliL-PER-CentiM2-MIN"
  ),
  // kibibit per cubic metre
  KibiBIT__PER__M3: Qudt.unitFromLocalnameRequired("KibiBIT-PER-M3"),
  // hertz
  HZ: Qudt.unitFromLocalnameRequired("HZ"),
  // Swedish Krona
  SEK_Currency: Qudt.currencyFromLocalnameRequired("SEK"),
  // Bar Cubic Meter per Second
  BAR__M3__PER__SEC: Qudt.unitFromLocalnameRequired("BAR-M3-PER-SEC"),
  // Kilocalorie per Square Centimetre Minute
  KiloCAL__PER__CentiM2__MIN: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-CentiM2-MIN"
  ),
  // Newton Square Meter per Square Kilogram
  N__M2__PER__KiloGM2: Qudt.unitFromLocalnameRequired("N-M2-PER-KiloGM2"),
  // Millilitre per Day
  MilliL__PER__DAY: Qudt.unitFromLocalnameRequired("MilliL-PER-DAY"),
  // NanoBecquerel
  NanoBQ: Qudt.unitFromLocalnameRequired("NanoBQ"),
  // Ton of Refrigeration Hour
  TON_FG__HR: Qudt.unitFromLocalnameRequired("TON_FG-HR"),
  // millicandela
  MilliCD: Qudt.unitFromLocalnameRequired("MilliCD"),
  // Pound Mole Degree Fahrenheit
  MOL_LB__DEG_F: Qudt.unitFromLocalnameRequired("MOL_LB-DEG_F"),
  // Microlitre
  MicroL: Qudt.unitFromLocalnameRequired("MicroL"),
  // Degree Rankine per Hour
  DEG_R__PER__HR: Qudt.unitFromLocalnameRequired("DEG_R-PER-HR"),
  // Milliwatts per square centimetre micrometre steradian
  MilliW__PER__CentiM2__MicroM__SR: Qudt.unitFromLocalnameRequired(
    "MilliW-PER-CentiM2-MicroM-SR"
  ),
  // Newton Centimeter
  N__CentiM: Qudt.unitFromLocalnameRequired("N-CentiM"),
  // MegaSiemens
  MegaS: Qudt.unitFromLocalnameRequired("MegaS"),
  // kilonewton metre per degree metre
  KiloN__M__PER__DEG__M: Qudt.unitFromLocalnameRequired("KiloN-M-PER-DEG-M"),
  // Lumen per Watt
  LM__PER__W: Qudt.unitFromLocalnameRequired("LM-PER-W"),
  // kilogram per metre day
  KiloGM__PER__M__DAY: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-DAY"),
  // pound square foot per gallon(UK) pound-force second
  LB__FT2__PER__GAL_UK__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "LB-FT2-PER-GAL_UK-LB_F-SEC"
  ),
  // ExaByte
  ExaBYTE: Qudt.unitFromLocalnameRequired("ExaBYTE"),
  // Decagram
  DecaGM: Qudt.unitFromLocalnameRequired("DecaGM"),
  // Foot Pound Force per Square Meter
  FT__LB_F__PER__M2: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-M2"),
  // Millipascal
  MilliPA: Qudt.unitFromLocalnameRequired("MilliPA"),
  // volt per volt
  V__PER__V: Qudt.unitFromLocalnameRequired("V-PER-V"),
  // Mega Electron Volt per Speed of Light
  MegaEV__PER__SpeedOfLight: Qudt.unitFromLocalnameRequired(
    "MegaEV-PER-SpeedOfLight"
  ),
  // pound minute per square gallon (US)
  LB__MIN__PER__GAL_US2: Qudt.unitFromLocalnameRequired("LB-MIN-PER-GAL_US2"),
  // Dry Barrel (US)
  BBL_US_DRY: Qudt.unitFromLocalnameRequired("BBL_US_DRY"),
  // kilogram centimetre per second
  KiloGM__CentiM__PER__SEC: Qudt.unitFromLocalnameRequired(
    "KiloGM-CentiM-PER-SEC"
  ),
  // Micromoles per litre day
  MicroM__PER__L__DAY: Qudt.unitFromLocalnameRequired("MicroM-PER-L-DAY"),
  // Calorie (international Table) per Gram
  CAL_IT__PER__GM: Qudt.unitFromLocalnameRequired("CAL_IT-PER-GM"),
  // Nanomoles per litre hour
  NanoMOL__PER__L__HR: Qudt.unitFromLocalnameRequired("NanoMOL-PER-L-HR"),
  // Japanese yen
  JPY_Currency: Qudt.currencyFromLocalnameRequired("JPY"),
  // gram hour per power of metre with the exponent 6
  GM__HR__PER__M6: Qudt.unitFromLocalnameRequired("GM-HR-PER-M6"),
  // microsievert per minute
  MicroSV__PER__MIN: Qudt.unitFromLocalnameRequired("MicroSV-PER-MIN"),
  // Newton seconds per radian
  N__SEC__PER__RAD: Qudt.unitFromLocalnameRequired("N-SEC-PER-RAD"),
  // Ampere Second
  A__SEC: Qudt.unitFromLocalnameRequired("A-SEC"),
  // kilojoule per day
  KiloJ__PER__DAY: Qudt.unitFromLocalnameRequired("KiloJ-PER-DAY"),
  // milligram per day kelvin
  MilliGM__PER__DAY__K: Qudt.unitFromLocalnameRequired("MilliGM-PER-DAY-K"),
  // pound (avoirdupois) per foot minute
  LB__PER__FT__MIN: Qudt.unitFromLocalnameRequired("LB-PER-FT-MIN"),
  // reciprocal kilogram second
  PER__KiloGM__SEC: Qudt.unitFromLocalnameRequired("PER-KiloGM-SEC"),
  // Shannon per Second
  SHANNON__PER__SEC: Qudt.unitFromLocalnameRequired("SHANNON-PER-SEC"),
  // Falkland Islands Pound
  FKP_Currency: Qudt.currencyFromLocalnameRequired("FKP"),
  // Weber per Millimeter
  WB__PER__MilliM: Qudt.unitFromLocalnameRequired("WB-PER-MilliM"),
  // square metre per Kilowatt
  M2__PER__KiloW: Qudt.unitFromLocalnameRequired("M2-PER-KiloW"),
  // Planck Mass
  PlanckMass: Qudt.unitFromLocalnameRequired("PlanckMass"),
  // tonne per hour kelvin
  TONNE__PER__HR__K: Qudt.unitFromLocalnameRequired("TONNE-PER-HR-K"),
  // Hundred Weight - Short
  CWT_SHORT: Qudt.unitFromLocalnameRequired("CWT_SHORT"),
  // attoampere
  AttoA: Qudt.unitFromLocalnameRequired("AttoA"),
  // SpeedOfLight
  SpeedOfLight: Qudt.unitFromLocalnameRequired("SpeedOfLight"),
  // TebiByte
  TebiBYTE: Qudt.unitFromLocalnameRequired("TebiBYTE"),
  // FemtoCoulomb
  FemtoC: Qudt.unitFromLocalnameRequired("FemtoC"),
  // stokes per pascal
  ST__PER__PA: Qudt.unitFromLocalnameRequired("ST-PER-PA"),
  // British Thermal Unit (Thermochemical Definition)
  BTU_TH: Qudt.unitFromLocalnameRequired("BTU_TH"),
  // Elementary Charge
  E: Qudt.unitFromLocalnameRequired("E"),
  // Pascal per Bar
  PA__PER__BAR: Qudt.unitFromLocalnameRequired("PA-PER-BAR"),
  // Cubic Foot per Minute Square Foot
  FT3__PER__MIN__FT2: Qudt.unitFromLocalnameRequired("FT3-PER-MIN-FT2"),
  // Kilometres per day
  KiloM__PER__DAY: Qudt.unitFromLocalnameRequired("KiloM-PER-DAY"),
  // Standard Cubic Meter per Hour
  SCM__PER__HR: Qudt.unitFromLocalnameRequired("SCM-PER-HR"),
  // cubic metre per hour bar
  M3__PER__HR__BAR: Qudt.unitFromLocalnameRequired("M3-PER-HR-BAR"),
  // Nat
  NAT: Qudt.unitFromLocalnameRequired("NAT"),
  // British thermal unit (59 °F)
  BTU_59DEG_F: Qudt.unitFromLocalnameRequired("BTU_59DEG_F"),
  // gram hour per litre squared
  GM__HR__PER__L2: Qudt.unitFromLocalnameRequired("GM-HR-PER-L2"),
  // Abvolt per centimeter
  V_Ab__PER__CentiM: Qudt.unitFromLocalnameRequired("V_Ab-PER-CentiM"),
  // pound minute per cubic foot cubic inch
  LB__MIN__PER__FT3__IN3: Qudt.unitFromLocalnameRequired("LB-MIN-PER-FT3-IN3"),
  // Picosecond
  PicoSEC: Qudt.unitFromLocalnameRequired("PicoSEC"),
  // Tonne per Year
  TONNE__PER__YR: Qudt.unitFromLocalnameRequired("TONNE-PER-YR"),
  // Electron Volt per Tesla
  EV__PER__T: Qudt.unitFromLocalnameRequired("EV-PER-T"),
  // Hectometre
  HectoM: Qudt.unitFromLocalnameRequired("HectoM"),
  // gram second per litre cubic metre
  GM__SEC__PER__L__M3: Qudt.unitFromLocalnameRequired("GM-SEC-PER-L-M3"),
  // Momme (textile)
  MOMME_Textile: Qudt.unitFromLocalnameRequired("MOMME_Textile"),
  // Pint (UK) per Hour
  PINT_UK__PER__HR: Qudt.unitFromLocalnameRequired("PINT_UK-PER-HR"),
  // Microgram per square centimetre
  MicroGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("MicroGM-PER-CentiM2"),
  // enzyme units per litre
  EU__PER__L: Qudt.unitFromLocalnameRequired("EU-PER-L"),
  // Nautical Mile per Hour
  MI_N__PER__HR: Qudt.unitFromLocalnameRequired("MI_N-PER-HR"),
  // ampere per kilogram
  A__PER__KiloGM: Qudt.unitFromLocalnameRequired("A-PER-KiloGM"),
  // gram per day kelvin
  GM__PER__DAY__K: Qudt.unitFromLocalnameRequired("GM-PER-DAY-K"),
  // Deaths per Million individuals year
  DEATHS__PER__MegaINDIV__YR: Qudt.unitFromLocalnameRequired(
    "DEATHS-PER-MegaINDIV-YR"
  ),
  // Pound per Foot Second
  LB__PER__FT__SEC: Qudt.unitFromLocalnameRequired("LB-PER-FT-SEC"),
  // enzyme units per litre
  ENZ__PER__L: Qudt.unitFromLocalnameRequired("ENZ-PER-L"),
  // Dalton
  Da: Qudt.unitFromLocalnameRequired("Da"),
  // pound second per cubic inch gallon (US)
  LB__SEC__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-IN3-GAL_US"
  ),
  // mole per cubic metre pascal
  MOL__PER__M3__PA: Qudt.unitFromLocalnameRequired("MOL-PER-M3-PA"),
  // Megasiemens per Metre
  MegaS__PER__M: Qudt.unitFromLocalnameRequired("MegaS-PER-M"),
  // Megagram per Cubic Meter
  MegaGM__PER__M3: Qudt.unitFromLocalnameRequired("MegaGM-PER-M3"),
  // Joule per Kilogram Kelvin Pascal
  J__PER__KiloGM__K__PA: Qudt.unitFromLocalnameRequired("J-PER-KiloGM-K-PA"),
  // kelvin per bar
  K__PER__BAR: Qudt.unitFromLocalnameRequired("K-PER-BAR"),
  // Inch per Second
  IN__PER__SEC: Qudt.unitFromLocalnameRequired("IN-PER-SEC"),
  // Newton metre per degree metre
  N__M__PER__DEG__M: Qudt.unitFromLocalnameRequired("N-M-PER-DEG-M"),
  // Bar per Bar
  BAR__PER__BAR: Qudt.unitFromLocalnameRequired("BAR-PER-BAR"),
  // Mega byte
  MegaBYTE: Qudt.unitFromLocalnameRequired("MegaBYTE"),
  // Newtonmeter pro Radian
  N__M__PER__RAD: Qudt.unitFromLocalnameRequired("N-M-PER-RAD"),
  // cubic centimetre per minute kelvin
  CentiM3__PER__MIN__K: Qudt.unitFromLocalnameRequired("CentiM3-PER-MIN-K"),
  // Degree Baume (US Heavy)
  DEGREE_BAUME_US_HEAVY: Qudt.unitFromLocalnameRequired(
    "DEGREE_BAUME_US_HEAVY"
  ),
  // Metre per Kelvin
  M__PER__K: Qudt.unitFromLocalnameRequired("M-PER-K"),
  // Square Metre per Steradian
  M2__PER__SR: Qudt.unitFromLocalnameRequired("M2-PER-SR"),
  // Inch per Minute
  IN__PER__MIN: Qudt.unitFromLocalnameRequired("IN-PER-MIN"),
  // inch per year
  IN__PER__YR: Qudt.unitFromLocalnameRequired("IN-PER-YR"),
  // pound (avoirdupois) per psi
  LB__PER__PSI: Qudt.unitFromLocalnameRequired("LB-PER-PSI"),
  // Kilomole per Second
  KiloMOL__PER__SEC: Qudt.unitFromLocalnameRequired("KiloMOL-PER-SEC"),
  // mole per cubic metre kelvin
  MOL__PER__M3__K: Qudt.unitFromLocalnameRequired("MOL-PER-M3-K"),
  // British Thermal Unit (international Table) Inch per Hour Square Foot Degree Fahrenheit
  BTU_IT__IN__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-IN-PER-FT2-HR-DEG_F"
  ),
  // ounce (avoirdupois) per square inch
  OZ__PER__IN2: Qudt.unitFromLocalnameRequired("OZ-PER-IN2"),
  // percent per degree
  PERCENT__PER__DEG: Qudt.unitFromLocalnameRequired("PERCENT-PER-DEG"),
  // Megapascal per Bar
  MegaPA__PER__BAR: Qudt.unitFromLocalnameRequired("MegaPA-PER-BAR"),
  // kilogram per hour bar
  KiloGM__PER__HR__BAR: Qudt.unitFromLocalnameRequired("KiloGM-PER-HR-BAR"),
  // milliampere square inch per pound-force
  MilliA__IN2__PER__LB_F: Qudt.unitFromLocalnameRequired("MilliA-IN2-PER-LB_F"),
  // Foot Lambert
  FT__LA: Qudt.unitFromLocalnameRequired("FT-LA"),
  // NanoCoulomb
  NanoC: Qudt.unitFromLocalnameRequired("NanoC"),
  // nanovolt ampere
  NanoV__A: Qudt.unitFromLocalnameRequired("NanoV-A"),
  // Foot Pound Force per Second
  FT__LB_F__PER__SEC: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-SEC"),
  // فولت. أمبير
  V__A: Qudt.unitFromLocalnameRequired("V-A"),
  // South Korean Won
  KRW_Currency: Qudt.currencyFromLocalnameRequired("KRW"),
  // Kilograms per metre square second
  KiloGM__PER__M__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-PER-M-SEC2"),
  // Milligrams per square metre day
  MilliGM__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2-DAY"),
  // Short Ton per Hour
  TON_SHORT__PER__HR: Qudt.unitFromLocalnameRequired("TON_SHORT-PER-HR"),
  // Giga Electron Volt
  GigaEV: Qudt.unitFromLocalnameRequired("GigaEV"),
  // Millibar Liter per Second
  MilliBAR__L__PER__SEC: Qudt.unitFromLocalnameRequired("MilliBAR-L-PER-SEC"),
  // ounce hour per cubic inch cubic foot
  OZ__HR__PER__IN3__FT3: Qudt.unitFromLocalnameRequired("OZ-HR-PER-IN3-FT3"),
  // calorie (thermochemical) per square centimetre minute
  CAL_TH__PER__CentiM2__MIN: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM2-MIN"
  ),
  // gram per litre bar
  GM__PER__L__BAR: Qudt.unitFromLocalnameRequired("GM-PER-L-BAR"),
  // Unit Pole
  UnitPole: Qudt.unitFromLocalnameRequired("UnitPole"),
  // percent second per gallon (UK)
  PERCENT__SEC__PER__GAL_UK: Qudt.unitFromLocalnameRequired(
    "PERCENT-SEC-PER-GAL_UK"
  ),
  // yard per second
  YD__PER__SEC: Qudt.unitFromLocalnameRequired("YD-PER-SEC"),
  // petahertz
  PetaHZ: Qudt.unitFromLocalnameRequired("PetaHZ"),
  // BTU per Pound Degree Fahrenheit
  BTU_IT__PER__LB__DEG_F: Qudt.unitFromLocalnameRequired("BTU_IT-PER-LB-DEG_F"),
  // US Dry Quart
  QT_US_DRY: Qudt.unitFromLocalnameRequired("QT_US_DRY"),
  // Joule per Metre
  J__PER__M: Qudt.unitFromLocalnameRequired("J-PER-M"),
  // Foot Pound per Square Foot
  FT__LB_F__PER__FT2: Qudt.unitFromLocalnameRequired("FT-LB_F-PER-FT2"),
  // Millilitre per Kilogram
  MilliL__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliL-PER-KiloGM"),
  // Megagram
  MegaGM: Qudt.unitFromLocalnameRequired("MegaGM"),
  // Megahertz
  MegaHZ: Qudt.unitFromLocalnameRequired("MegaHZ"),
  // Kilogram per Square Centimetre
  KiloGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("KiloGM-PER-CentiM2"),
  // Hundredweight (US)
  Hundredweight_US: Qudt.unitFromLocalnameRequired("Hundredweight_US"),
  // Mile per Hour
  MI__PER__HR: Qudt.unitFromLocalnameRequired("MI-PER-HR"),
  // Gigajoule per Hour
  GigaJ__PER__HR: Qudt.unitFromLocalnameRequired("GigaJ-PER-HR"),
  // litre per day kelvin
  L__PER__DAY__K: Qudt.unitFromLocalnameRequired("L-PER-DAY-K"),
  // PicoPascal
  PicoPA: Qudt.unitFromLocalnameRequired("PicoPA"),
  // Milligram per Metre
  MilliGM__PER__M: Qudt.unitFromLocalnameRequired("MilliGM-PER-M"),
  // giganewton metre per square metre
  GigaN__M__PER__M2: Qudt.unitFromLocalnameRequired("GigaN-M-PER-M2"),
  // Kilo Electron Volt per Micrometre
  KiloEV__PER__MicroM: Qudt.unitFromLocalnameRequired("KiloEV-PER-MicroM"),
  // sievert per minute
  SV__PER__MIN: Qudt.unitFromLocalnameRequired("SV-PER-MIN"),
  // Centinewton Meter
  CentiN__M: Qudt.unitFromLocalnameRequired("CentiN-M"),
  // Gray per Second
  GRAY__PER__SEC: Qudt.unitFromLocalnameRequired("GRAY-PER-SEC"),
  // Kilogram Force per Square Centimeter
  KiloGM_F__PER__CentiM2: Qudt.unitFromLocalnameRequired(
    "KiloGM_F-PER-CentiM2"
  ),
  // Colony Forming Unit
  CFU: Qudt.unitFromLocalnameRequired("CFU"),
  // Dyne
  DYN: Qudt.unitFromLocalnameRequired("DYN"),
  // gram minute per litre squared
  GM__MIN__PER__L2: Qudt.unitFromLocalnameRequired("GM-MIN-PER-L2"),
  // Planck Charge
  PlanckCharge: Qudt.unitFromLocalnameRequired("PlanckCharge"),
  // Kilonewton Metre per Degree
  KiloN__M__PER__DEG: Qudt.unitFromLocalnameRequired("KiloN-M-PER-DEG"),
  // pound second per square gallon (UK)
  LB__SEC__PER__GAL_UK2: Qudt.unitFromLocalnameRequired("LB-SEC-PER-GAL_UK2"),
  // British thermal unit (international table) per square foot second
  BTU_IT__PER__FT2__SEC: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT2-SEC"),
  // τετραγωνικό μέτρο
  M2: Qudt.unitFromLocalnameRequired("M2"),
  // Cubic Decimetre per Minute
  DeciM3__PER__MIN: Qudt.unitFromLocalnameRequired("DeciM3-PER-MIN"),
  // Ounce (US Fluid) per Hour
  OZ_VOL_US__PER__HR: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-HR"),
  // Cedi
  GHS_Currency: Qudt.currencyFromLocalnameRequired("GHS"),
  // Micromoles per gram hour
  MicroMOL__PER__GM__HR: Qudt.unitFromLocalnameRequired("MicroMOL-PER-GM-HR"),
  // Hectare
  HA: Qudt.unitFromLocalnameRequired("HA"),
  // MicroSievert
  MicroSV: Qudt.unitFromLocalnameRequired("MicroSV"),
  // Kilonewton Metre per metre
  KiloN__M__PER__M: Qudt.unitFromLocalnameRequired("KiloN-M-PER-M"),
  // GM_Carbon
  GM_Carbon: Qudt.unitFromLocalnameRequired("GM_Carbon"),
  // gibibit per cubic metre
  GibiBIT__PER__M3: Qudt.unitFromLocalnameRequired("GibiBIT-PER-M3"),
  // Gigajoule per Square Metre
  GigaJ__PER__M2: Qudt.unitFromLocalnameRequired("GigaJ-PER-M2"),
  // Planck Momentum
  PlanckMomentum: Qudt.unitFromLocalnameRequired("PlanckMomentum"),
  // Sri Lanka Rupee
  LKR_Currency: Qudt.currencyFromLocalnameRequired("LKR"),
  // Kelvin per Second
  K__PER__SEC: Qudt.unitFromLocalnameRequired("K-PER-SEC"),
  // atomic-number
  Z: Qudt.unitFromLocalnameRequired("Z"),
  // International Unit per milligram
  IU__PER__MilliGM: Qudt.unitFromLocalnameRequired("IU-PER-MilliGM"),
  // Joules per square centimetre day
  J__PER__CentiM2__DAY: Qudt.unitFromLocalnameRequired("J-PER-CentiM2-DAY"),
  // Quart (US Liquid) per Day
  QT_US__PER__DAY: Qudt.unitFromLocalnameRequired("QT_US-PER-DAY"),
  // Mile per Second
  MI__PER__SEC: Qudt.unitFromLocalnameRequired("MI-PER-SEC"),
  // Degree Twaddell
  DEGREE_TWADDELL: Qudt.unitFromLocalnameRequired("DEGREE_TWADDELL"),
  // gram per minute bar
  GM__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("GM-PER-MIN-BAR"),
  // South African Rand
  ZAR_Currency: Qudt.currencyFromLocalnameRequired("ZAR"),
  // Ampere Square Metre
  A__M2: Qudt.unitFromLocalnameRequired("A-M2"),
  // Kilomole per Kilogram
  KiloMOL__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloMOL-PER-KiloGM"),
  // Bushel (UK) per Day
  BU_UK__PER__DAY: Qudt.unitFromLocalnameRequired("BU_UK-PER-DAY"),
  // Calorie (thermochemical) per Second Centimetre Kelvin
  CAL_TH__PER__SEC__CentiM__K: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-SEC-CentiM-K"
  ),
  // picoampere
  PicoA: Qudt.unitFromLocalnameRequired("PicoA"),
  // Square Volt per Square Kelvin
  V2__PER__K2: Qudt.unitFromLocalnameRequired("V2-PER-K2"),
  // Penny Weight
  DWT: Qudt.unitFromLocalnameRequired("DWT"),
  // Gilbert
  GI: Qudt.unitFromLocalnameRequired("GI"),
  // Cubic Inch per Hour
  IN3__PER__HR: Qudt.unitFromLocalnameRequired("IN3-PER-HR"),
  // Cubic Metre per Minute
  M3__PER__MIN: Qudt.unitFromLocalnameRequired("M3-PER-MIN"),
  // second per square foot
  SEC__PER__FT2: Qudt.unitFromLocalnameRequired("SEC-PER-FT2"),
  // Practical Salinity Unit
  PSU: Qudt.unitFromLocalnameRequired("PSU"),
  // Nanomoles per gram second
  NanoMOL__PER__GM__SEC: Qudt.unitFromLocalnameRequired("NanoMOL-PER-GM-SEC"),
  // بل
  B: Qudt.unitFromLocalnameRequired("B"),
  // gigaohm per metre
  GigaOHM__PER__M: Qudt.unitFromLocalnameRequired("GigaOHM-PER-M"),
  // milligram second per litre cubic metre
  MilliGM__SEC__PER__L__M3: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-L-M3"
  ),
  // ohm circular mil per foot
  OHM_CIRC__MIL__PER__FT: Qudt.unitFromLocalnameRequired("OHM_CIRC-MIL-PER-FT"),
  // Percent per hour
  PERCENT__PER__HR: Qudt.unitFromLocalnameRequired("PERCENT-PER-HR"),
  // pound mole per pound
  MOL_LB__PER__LB: Qudt.unitFromLocalnameRequired("MOL_LB-PER-LB"),
  // Tanzanian Shilling
  TZS_Currency: Qudt.currencyFromLocalnameRequired("TZS"),
  // Euro per square metre
  EUR__PER__M2: Qudt.unitFromLocalnameRequired("EUR-PER-M2"),
  // British Thermal Unit (mean)
  BTU_MEAN: Qudt.unitFromLocalnameRequired("BTU_MEAN"),
  // fermi
  FM: Qudt.unitFromLocalnameRequired("FM"),
  // pound (avoirdupois) per square yard
  LB__PER__YD2: Qudt.unitFromLocalnameRequired("LB-PER-YD2"),
  // percent hour per gallon (US)
  PERCENT__HR__PER__GAL_US: Qudt.unitFromLocalnameRequired(
    "PERCENT-HR-PER-GAL_US"
  ),
  // Planck Power
  PlanckPower: Qudt.unitFromLocalnameRequired("PlanckPower"),
  // tebibit per cubic metre
  TebiBIT__PER__M3: Qudt.unitFromLocalnameRequired("TebiBIT-PER-M3"),
  // Kilogram Force Metre per Square Centimetre
  KiloGM_F__M__PER__CentiM2: Qudt.unitFromLocalnameRequired(
    "KiloGM_F-M-PER-CentiM2"
  ),
  // Gram per Minute
  GM__PER__MIN: Qudt.unitFromLocalnameRequired("GM-PER-MIN"),
  // millipascal per metre
  MilliPA__PER__M: Qudt.unitFromLocalnameRequired("MilliPA-PER-M"),
  // femtofarad
  FemtoFARAD: Qudt.unitFromLocalnameRequired("FemtoFARAD"),
  // Standard Cubic Foot per Hour
  SCF__PER__HR: Qudt.unitFromLocalnameRequired("SCF-PER-HR"),
  // Mesh
  MESH: Qudt.unitFromLocalnameRequired("MESH"),
  // kelvin per pascal
  K__PER__PA: Qudt.unitFromLocalnameRequired("K-PER-PA"),
  // Palladium (one Troy ounce)
  XPD_Currency: Qudt.currencyFromLocalnameRequired("XPD"),
  // Gallon (US Liquid) per Second
  GAL_US__PER__SEC: Qudt.unitFromLocalnameRequired("GAL_US-PER-SEC"),
  // Planck Force
  PlanckForce: Qudt.unitFromLocalnameRequired("PlanckForce"),
  // हर्ट्ज प्रति कैल्विन
  HZ__PER__K: Qudt.unitFromLocalnameRequired("HZ-PER-K"),
  // Tropical Year
  YR_TROPICAL: Qudt.unitFromLocalnameRequired("YR_TROPICAL"),
  // Watt per Square Foot
  W__PER__FT2: Qudt.unitFromLocalnameRequired("W-PER-FT2"),
  // Kilogram Square Millimetre
  KiloGM__MilliM2: Qudt.unitFromLocalnameRequired("KiloGM-MilliM2"),
  // Million US Dollars per Year
  MillionUSD__PER__YR: Qudt.unitFromLocalnameRequired("MillionUSD-PER-YR"),
  // foot hour per cubic inch
  FT__HR__PER__IN3: Qudt.unitFromLocalnameRequired("FT-HR-PER-IN3"),
  // Square Foot per Hour
  FT2__PER__HR: Qudt.unitFromLocalnameRequired("FT2-PER-HR"),
  // gram per litre pascal second
  GM__PER__L__PA__SEC: Qudt.unitFromLocalnameRequired("GM-PER-L-PA-SEC"),
  // NanoSiemens
  NanoS: Qudt.unitFromLocalnameRequired("NanoS"),
  // milligram second per cubic metre litre
  MilliGM__SEC__PER__M3__L: Qudt.unitFromLocalnameRequired(
    "MilliGM-SEC-PER-M3-L"
  ),
  // Newton per Coulomb
  N__PER__C: Qudt.unitFromLocalnameRequired("N-PER-C"),
  // Curie
  CI: Qudt.unitFromLocalnameRequired("CI"),
  // Nanomoles per micromole day
  NanoMOL__PER__MicroMOL__DAY: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-MicroMOL-DAY"
  ),
  // tonne per day bar
  TON_Metric__PER__DAY__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-DAY-BAR"
  ),
  // Slug per Day
  SLUG__PER__DAY: Qudt.unitFromLocalnameRequired("SLUG-PER-DAY"),
  // MicroSievert per hour
  MicroSV__PER__HR: Qudt.unitFromLocalnameRequired("MicroSV-PER-HR"),
  // Shake
  SH: Qudt.unitFromLocalnameRequired("SH"),
  // joule per minute
  J__PER__MIN: Qudt.unitFromLocalnameRequired("J-PER-MIN"),
  // Metric KiloTON
  KiloTON_Metric: Qudt.unitFromLocalnameRequired("KiloTON_Metric"),
  // Megajoule per Second
  MegaJ__PER__SEC: Qudt.unitFromLocalnameRequired("MegaJ-PER-SEC"),
  // Planck Volume
  PlanckVolume: Qudt.unitFromLocalnameRequired("PlanckVolume"),
  // Conventional Centimetre Of Water
  CentiM_H2O: Qudt.unitFromLocalnameRequired("CentiM_H2O"),
  // Parts-Per-Million per Kelvin
  PPM__PER__K: Qudt.unitFromLocalnameRequired("PPM-PER-K"),
  // big point
  PT_BIG: Qudt.unitFromLocalnameRequired("PT_BIG"),
  // Megawatt Hour
  MegaW__HR: Qudt.unitFromLocalnameRequired("MegaW-HR"),
  // Millivolt
  MilliV: Qudt.unitFromLocalnameRequired("MilliV"),
  // Metre per Hour
  M__PER__HR: Qudt.unitFromLocalnameRequired("M-PER-HR"),
  // Nanogram per Day
  NanoGM__PER__DAY: Qudt.unitFromLocalnameRequired("NanoGM-PER-DAY"),
  // kiloohm metre
  KiloOHM__M: Qudt.unitFromLocalnameRequired("KiloOHM-M"),
  // Mole per Minute
  MOL__PER__MIN: Qudt.unitFromLocalnameRequired("MOL-PER-MIN"),
  // Cubic Coulomb Metre per Square Joule
  C3__M__PER__J2: Qudt.unitFromLocalnameRequired("C3-M-PER-J2"),
  // International Mile
  MI: Qudt.unitFromLocalnameRequired("MI"),
  // Zimbabwe Dollar
  ZWL_Currency: Qudt.currencyFromLocalnameRequired("ZWL"),
  // Kilogram Force per Square Millimetre
  KiloGM_F__PER__MilliM2: Qudt.unitFromLocalnameRequired(
    "KiloGM_F-PER-MilliM2"
  ),
  // millimetre per degree Celsius metre
  MilliM__PER__DEG_C__M: Qudt.unitFromLocalnameRequired("MilliM-PER-DEG_C-M"),
  // Imperial Mass Ounce per Cubic Inch
  OZ__PER__IN3: Qudt.unitFromLocalnameRequired("OZ-PER-IN3"),
  // Nepalese Rupee
  NPR_Currency: Qudt.currencyFromLocalnameRequired("NPR"),
  // pound (avoirdupois) per second psi
  LB__PER__SEC__PSI: Qudt.unitFromLocalnameRequired("LB-PER-SEC-PSI"),
  // nanovolt ampere reactive
  NanoV__A_Reactive: Qudt.unitFromLocalnameRequired("NanoV-A_Reactive"),
  // Milligram per Square Meter
  MilliGM__PER__M2: Qudt.unitFromLocalnameRequired("MilliGM-PER-M2"),
  // Erg per Square Centimeter
  ERG__PER__CentiM2: Qudt.unitFromLocalnameRequired("ERG-PER-CentiM2"),
  // British thermal unit (thermochemical) per square foot second
  BTU_TH__PER__FT2__SEC: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT2-SEC"),
  // Microwatt per Square Meter
  MicroW__PER__M2: Qudt.unitFromLocalnameRequired("MicroW-PER-M2"),
  // Ounce (avoirdupois) per Second
  OZ__PER__SEC: Qudt.unitFromLocalnameRequired("OZ-PER-SEC"),
  // Inch of Mercury
  IN_HG: Qudt.unitFromLocalnameRequired("IN_HG"),
  // meter persegi per meter
  M2__PER__M: Qudt.unitFromLocalnameRequired("M2-PER-M"),
  // pound hour per gallon (US) cubic yard
  LB__HR__PER__GAL_US__YD3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_US-YD3"
  ),
  // Thousand Cubic Foot
  KiloCubicFT: Qudt.unitFromLocalnameRequired("KiloCubicFT"),
  // Microgravity
  MicroG: Qudt.unitFromLocalnameRequired("MicroG"),
  // CFA Franc BEAC
  XAF_Currency: Qudt.currencyFromLocalnameRequired("XAF"),
  // Watt per Square Metre Steradian
  W__PER__M2__SR: Qudt.unitFromLocalnameRequired("W-PER-M2-SR"),
  // Sextic Meter
  M6: Qudt.unitFromLocalnameRequired("M6"),
  // gram per square millimetre
  GM__PER__MilliM2: Qudt.unitFromLocalnameRequired("GM-PER-MilliM2"),
  // Platinum (one Troy ounce)
  XPT_Currency: Qudt.currencyFromLocalnameRequired("XPT"),
  // microgray per hour
  MicroGRAY__PER__HR: Qudt.unitFromLocalnameRequired("MicroGRAY-PER-HR"),
  // tonne per second bar
  TON_Metric__PER__SEC__BAR: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-SEC-BAR"
  ),
  // Square Inch per Second
  IN2__PER__SEC: Qudt.unitFromLocalnameRequired("IN2-PER-SEC"),
  // Femtolitre
  FemtoL: Qudt.unitFromLocalnameRequired("FemtoL"),
  // Imperial Mass Ounce per Square Foot
  OZ__PER__FT2: Qudt.unitFromLocalnameRequired("OZ-PER-FT2"),
  // percent hour per cubic foot
  PERCENT__HR__PER__FT3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-FT3"),
  // kibibit
  KibiBIT: Qudt.unitFromLocalnameRequired("KibiBIT"),
  // kilojoule per second
  KiloJ__PER__SEC: Qudt.unitFromLocalnameRequired("KiloJ-PER-SEC"),
  // Microgram per Milliliter
  MicroGM__PER__MilliL: Qudt.unitFromLocalnameRequired("MicroGM-PER-MilliL"),
  // Barrel (US Petroleum) per Hour
  BBL_US_PET__PER__HR: Qudt.unitFromLocalnameRequired("BBL_US_PET-PER-HR"),
  // Psi Cubic Yard per Second
  PSI__YD3__PER__SEC: Qudt.unitFromLocalnameRequired("PSI-YD3-PER-SEC"),
  // Degree Oechsle
  DEGREE_OECHSLE: Qudt.unitFromLocalnameRequired("DEGREE_OECHSLE"),
  // Picograms
  PicoGM: Qudt.unitFromLocalnameRequired("PicoGM"),
  // Dyne per Centimetre
  DYN__PER__CentiM: Qudt.unitFromLocalnameRequired("DYN-PER-CentiM"),
  // Degrees Celsius per year
  DEG_C__PER__YR: Qudt.unitFromLocalnameRequired("DEG_C-PER-YR"),
  // Square Metre Hour Degree Celsius per Kilocalorie (international Table)
  M2__HR__DEG_C__PER__KiloCAL_IT: Qudt.unitFromLocalnameRequired(
    "M2-HR-DEG_C-PER-KiloCAL_IT"
  ),
  // Tonne per Day
  TON_Metric__PER__DAY: Qudt.unitFromLocalnameRequired("TON_Metric-PER-DAY"),
  // pound second per gallon (US) cubic inch
  LB__SEC__PER__GAL_US__IN3: Qudt.unitFromLocalnameRequired(
    "LB-SEC-PER-GAL_US-IN3"
  ),
  // Gram per Cubic Decimetre
  GM__PER__DeciM3: Qudt.unitFromLocalnameRequired("GM-PER-DeciM3"),
  // Day
  DAY: Qudt.unitFromLocalnameRequired("DAY"),
  // amper bölü metre kare
  A__PER__M2: Qudt.unitFromLocalnameRequired("A-PER-M2"),
  // Kilovolt Ampere
  KiloV__A: Qudt.unitFromLocalnameRequired("KiloV-A"),
  // British Thermal Unit (thermochemical) per Minute
  BTU_TH__PER__MIN: Qudt.unitFromLocalnameRequired("BTU_TH-PER-MIN"),
  // foot second per gallon (UK)
  FT__SEC__PER__GAL_UK: Qudt.unitFromLocalnameRequired("FT-SEC-PER-GAL_UK"),
  // Deaths per 1000 individuals year
  DEATHS__PER__KiloINDIV__YR: Qudt.unitFromLocalnameRequired(
    "DEATHS-PER-KiloINDIV-YR"
  ),
  // neper per second
  NP__PER__SEC: Qudt.unitFromLocalnameRequired("NP-PER-SEC"),
  // Year
  YR: Qudt.unitFromLocalnameRequired("YR"),
  // Rial Omani
  OMR_Currency: Qudt.currencyFromLocalnameRequired("OMR"),
  // Micromoles per second
  MicroMOL__PER__SEC: Qudt.unitFromLocalnameRequired("MicroMOL-PER-SEC"),
  // Square metres per gram of dry sediment
  M2__PER__GM_DRY: Qudt.unitFromLocalnameRequired("M2-PER-GM_DRY"),
  // New Israeli Shekel
  ILS_Currency: Qudt.currencyFromLocalnameRequired("ILS"),
  // Foot of Water
  FT_H2O: Qudt.unitFromLocalnameRequired("FT_H2O"),
  // octet per second
  OCTET__PER__SEC: Qudt.unitFromLocalnameRequired("OCTET-PER-SEC"),
  // Kelvin day
  K__DAY: Qudt.unitFromLocalnameRequired("K-DAY"),
  // gram per cubic decimetre kelvin
  GM__PER__DeciM3__K: Qudt.unitFromLocalnameRequired("GM-PER-DeciM3-K"),
  // Megaohm
  MegaOHM: Qudt.unitFromLocalnameRequired("MegaOHM"),
  // Milli ArcSecond
  MilliARCSEC: Qudt.unitFromLocalnameRequired("MilliARCSEC"),
  // reciprocal square inch
  PER__IN2: Qudt.unitFromLocalnameRequired("PER-IN2"),
  // Square Pascal Second
  PA2__SEC: Qudt.unitFromLocalnameRequired("PA2-SEC"),
  // ZeptoCoulomb
  ZeptoC: Qudt.unitFromLocalnameRequired("ZeptoC"),
  // Magnetic Susceptibility Unit
  SUSCEPTIBILITY_MAG: Qudt.unitFromLocalnameRequired("SUSCEPTIBILITY_MAG"),
  // microampere per kelvin
  MicroA__PER__K: Qudt.unitFromLocalnameRequired("MicroA-PER-K"),
  // teraampere
  TeraA: Qudt.unitFromLocalnameRequired("TeraA"),
  // Inverse Square Planck Mass
  PER__PlanckMass2: Qudt.unitFromLocalnameRequired("PER-PlanckMass2"),
  // Thermochemical Calorie
  CAL_TH: Qudt.unitFromLocalnameRequired("CAL_TH"),
  // US Liquid Cup
  CUP: Qudt.unitFromLocalnameRequired("CUP"),
  // British Thermal Unit (thermochemical) per Hour
  BTU_TH__PER__HR: Qudt.unitFromLocalnameRequired("BTU_TH-PER-HR"),
  // Cordoba Oro
  NIO_Currency: Qudt.currencyFromLocalnameRequired("NIO"),
  // Foot per Second
  FT__PER__SEC: Qudt.unitFromLocalnameRequired("FT-PER-SEC"),
  // Microvolt per Metre
  MicroV__PER__M: Qudt.unitFromLocalnameRequired("MicroV-PER-M"),
  // bushel (US)
  BU_US: Qudt.unitFromLocalnameRequired("BU_US"),
  // megaohm per kelvin
  MegaOHM__PER__K: Qudt.unitFromLocalnameRequired("MegaOHM-PER-K"),
  // United States Dollar (next day) (funds code)
  USN_Currency: Qudt.currencyFromLocalnameRequired("USN"),
  // Kelvin square metres per kilogram second
  K__M2__PER__KiloGM__SEC: Qudt.unitFromLocalnameRequired(
    "K-M2-PER-KiloGM-SEC"
  ),
  // kilohenry
  KiloH: Qudt.unitFromLocalnameRequired("KiloH"),
  // pound hour per gallon (US) cubic inch
  LB__HR__PER__GAL_US__IN3: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-GAL_US-IN3"
  ),
  // percent second per gallon (US)
  PERCENT__SEC__PER__GAL_US: Qudt.unitFromLocalnameRequired(
    "PERCENT-SEC-PER-GAL_US"
  ),
  // Megahertz
  Megahertz: Qudt.unitFromLocalnameRequired("Megahertz"),
  // gigabit per metre
  GigaBIT__PER__M: Qudt.unitFromLocalnameRequired("GigaBIT-PER-M"),
  // milligram per cubic metre pascal second
  MilliGM__PER__M3__PA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-PA-SEC"
  ),
  // Ton of Refrigeration
  TON_FG: Qudt.unitFromLocalnameRequired("TON_FG"),
  // ounce square inch per cubic inch pound-force second
  OZ__IN2__PER__IN3__LB_F__SEC: Qudt.unitFromLocalnameRequired(
    "OZ-IN2-PER-IN3-LB_F-SEC"
  ),
  // Square Nanometer
  NanoM2: Qudt.unitFromLocalnameRequired("NanoM2"),
  // Seconds per metre
  SEC__PER__M: Qudt.unitFromLocalnameRequired("SEC-PER-M"),
  // cubic centimetre per minute bar
  CentiM3__PER__MIN__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-MIN-BAR"),
  // kiloampere per kelvin
  KiloA__PER__K: Qudt.unitFromLocalnameRequired("KiloA-PER-K"),
  // घन मीटर
  M3: Qudt.unitFromLocalnameRequired("M3"),
  // Nuevo Sol
  PEN_Currency: Qudt.currencyFromLocalnameRequired("PEN"),
  // Decigram
  DeciGM: Qudt.unitFromLocalnameRequired("DeciGM"),
  // Kilogram per Minute
  KiloGM__PER__MIN: Qudt.unitFromLocalnameRequired("KiloGM-PER-MIN"),
  // 1000I
  _1000I: Qudt.unitFromLocalnameRequired("1000I"),
  // pascal
  PA: Qudt.unitFromLocalnameRequired("PA"),
  // Newton Meter per Ampere
  N__M__PER__A: Qudt.unitFromLocalnameRequired("N-M-PER-A"),
  // Comoro Franc
  KMF_Currency: Qudt.currencyFromLocalnameRequired("KMF"),
  // kilogram na kubični sekunda kelvin
  KiloGM__PER__SEC3__K: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC3-K"),
  // Ampere per Gram
  A__PER__GM: Qudt.unitFromLocalnameRequired("A-PER-GM"),
  // Candlepower
  CP: Qudt.unitFromLocalnameRequired("CP"),
  // pound (avoirdupois) per hour psi
  LB__PER__HR__PSI: Qudt.unitFromLocalnameRequired("LB-PER-HR-PSI"),
  // Planck Time
  PlanckTime: Qudt.unitFromLocalnameRequired("PlanckTime"),
  // Ampere per Degree Celsius
  A__PER__DEG_C: Qudt.unitFromLocalnameRequired("A-PER-DEG_C"),
  // Kiloroentgen
  KiloR: Qudt.unitFromLocalnameRequired("KiloR"),
  // nanosievert per minute
  NanoSV__PER__MIN: Qudt.unitFromLocalnameRequired("NanoSV-PER-MIN"),
  // M0pt
  M0pt: Qudt.unitFromLocalnameRequired("M0pt"),
  // centimetre per second kelvin
  CentiM__PER__SEC__K: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC-K"),
  // microgram per cubic metre bar
  MicroGM__PER__M3__BAR: Qudt.unitFromLocalnameRequired("MicroGM-PER-M3-BAR"),
  // Milligravity
  MilliG: Qudt.unitFromLocalnameRequired("MilliG"),
  // Kilogram per Second Square Metre
  KiloGM__PER__SEC__M2: Qudt.unitFromLocalnameRequired("KiloGM-PER-SEC-M2"),
  // Tonne per Minute
  TONNE__PER__MIN: Qudt.unitFromLocalnameRequired("TONNE-PER-MIN"),
  // Square Micrometre
  MicroM2: Qudt.unitFromLocalnameRequired("MicroM2"),
  // metre per second pascal
  M__PER__SEC__PA: Qudt.unitFromLocalnameRequired("M-PER-SEC-PA"),
  // Milligram per Liter
  MilliGM__PER__L: Qudt.unitFromLocalnameRequired("MilliGM-PER-L"),
  // Mexican Peso
  MXN_Currency: Qudt.currencyFromLocalnameRequired("MXN"),
  // United States Dollar (same day) (funds code)
  USS_Currency: Qudt.currencyFromLocalnameRequired("USS"),
  // Picomoles per litre day
  PicoMOL__PER__L__DAY: Qudt.unitFromLocalnameRequired("PicoMOL-PER-L-DAY"),
  // Degree Fahrenheit per Kelvin
  DEG_F__PER__K: Qudt.unitFromLocalnameRequired("DEG_F-PER-K"),
  // kilobecquerel per kilogram
  KiloBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("KiloBQ-PER-KiloGM"),
  // Reciprocal Second
  PER__SEC: Qudt.unitFromLocalnameRequired("PER-SEC"),
  // Liberian Dollar
  LRD_Currency: Qudt.currencyFromLocalnameRequired("LRD"),
  // Microgram per square centimetre
  MicroG__PER__CentiM2: Qudt.unitFromLocalnameRequired("MicroG-PER-CentiM2"),
  // Lumen
  LM: Qudt.unitFromLocalnameRequired("LM"),
  // Ampere per Centimeter
  A__PER__CentiM: Qudt.unitFromLocalnameRequired("A-PER-CentiM"),
  // Foot per Hour
  FT__PER__HR: Qudt.unitFromLocalnameRequired("FT-PER-HR"),
  // V-M
  V__M: Qudt.unitFromLocalnameRequired("V-M"),
  // centimetre per bar
  CentiM__PER__BAR: Qudt.unitFromLocalnameRequired("CentiM-PER-BAR"),
  // milliohm per kelvin
  MilliOHM__PER__K: Qudt.unitFromLocalnameRequired("MilliOHM-PER-K"),
  // milligram minute per cubic metre litre
  MilliGM__MIN__PER__M3__L: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-M3-L"
  ),
  // Henry per Meter
  H__PER__M: Qudt.unitFromLocalnameRequired("H-PER-M"),
  // Attojoule Second
  AttoJ__SEC: Qudt.unitFromLocalnameRequired("AttoJ-SEC"),
  // Centimetre per Kelvin
  CentiM__PER__K: Qudt.unitFromLocalnameRequired("CentiM-PER-K"),
  // Calorie (thermochemical) per Centimetre Second Degree Celsius
  CAL_TH__PER__CentiM__SEC__DEG_C: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-CentiM-SEC-DEG_C"
  ),
  // Kilogram per Joule
  KiloGM__PER__J: Qudt.unitFromLocalnameRequired("KiloGM-PER-J"),
  // Millimetre per Year
  MilliM__PER__YR: Qudt.unitFromLocalnameRequired("MilliM-PER-YR"),
  // Hectopascal per Bar
  HectoPA__PER__BAR: Qudt.unitFromLocalnameRequired("HectoPA-PER-BAR"),
  // Pascal Square Root Meter
  PA__M0dot5: Qudt.unitFromLocalnameRequired("PA-M0dot5"),
  // Heart Beat
  HeartBeat: Qudt.unitFromLocalnameRequired("HeartBeat"),
  // foot hour per gallon (US)
  FT__HR__PER__GAL_US: Qudt.unitFromLocalnameRequired("FT-HR-PER-GAL_US"),
  // Abampere per Square Centimeter
  A_Ab__PER__CentiM2: Qudt.unitFromLocalnameRequired("A_Ab-PER-CentiM2"),
  // steradian
  SR: Qudt.unitFromLocalnameRequired("SR"),
  // Cubic Foot per Hour
  FT3__PER__HR: Qudt.unitFromLocalnameRequired("FT3-PER-HR"),
  // Number per Hectare Year
  NUM__PER__HA__YR: Qudt.unitFromLocalnameRequired("NUM-PER-HA-YR"),
  // Gram per Gram
  GM__PER__GM: Qudt.unitFromLocalnameRequired("GM-PER-GM"),
  // petaampere
  PetaA: Qudt.unitFromLocalnameRequired("PetaA"),
  // TebiBIT
  TebiBIT: Qudt.unitFromLocalnameRequired("TebiBIT"),
  // HectoCoulomb
  HectoC: Qudt.unitFromLocalnameRequired("HectoC"),
  // Kilo British Thermal Unit (International Definition) per Hour
  KiloBTU_IT__PER__HR: Qudt.unitFromLocalnameRequired("KiloBTU_IT-PER-HR"),
  // MicroGray
  MicroGRAY: Qudt.unitFromLocalnameRequired("MicroGRAY"),
  // percent per poise
  PERCENT__PER__POISE: Qudt.unitFromLocalnameRequired("PERCENT-PER-POISE"),
  // Hefner-Kerze
  HK: Qudt.unitFromLocalnameRequired("HK"),
  // Singapore Dollar
  SGD_Currency: Qudt.currencyFromLocalnameRequired("SGD"),
  // Millibar Cubic Meter per Second
  MilliBAR__M3__PER__SEC: Qudt.unitFromLocalnameRequired("MilliBAR-M3-PER-SEC"),
  // Degree Fahrenheit Hour Square Foot per British Thermal Unit (international Table)
  DEG_F__HR__FT2__PER__BTU_IT: Qudt.unitFromLocalnameRequired(
    "DEG_F-HR-FT2-PER-BTU_IT"
  ),
  // PicoCoulomb
  PicoC: Qudt.unitFromLocalnameRequired("PicoC"),
  // Tonne per Day
  TONNE__PER__DAY: Qudt.unitFromLocalnameRequired("TONNE-PER-DAY"),
  // BREATH
  BREATH: Qudt.unitFromLocalnameRequired("BREATH"),
  // pound (avoirdupois) per cubic inch psi
  LB__PER__IN3__PSI: Qudt.unitFromLocalnameRequired("LB-PER-IN3-PSI"),
  // Mole per Second
  MOL__PER__SEC: Qudt.unitFromLocalnameRequired("MOL-PER-SEC"),
  // Micrometre
  MicroM: Qudt.unitFromLocalnameRequired("MicroM"),
  // Parts-Per-Ten Million per Kelvin
  PPTM__PER__K: Qudt.unitFromLocalnameRequired("PPTM-PER-K"),
  // Kilocalorie per Mole
  KiloCAL__PER__MOL: Qudt.unitFromLocalnameRequired("KiloCAL-PER-MOL"),
  // milligram second per power of metre with the exponent 6
  MilliGM__SEC__PER__M6: Qudt.unitFromLocalnameRequired("MilliGM-SEC-PER-M6"),
  // Kilopond
  KiloPOND: Qudt.unitFromLocalnameRequired("KiloPOND"),
  // Kilocalorie per Minute
  KiloCAL__PER__MIN: Qudt.unitFromLocalnameRequired("KiloCAL-PER-MIN"),
  // percent per degree Celsius
  PERCENT__PER__DEG_C: Qudt.unitFromLocalnameRequired("PERCENT-PER-DEG_C"),
  // volt per pascal
  V__PER__PA: Qudt.unitFromLocalnameRequired("V-PER-PA"),
  // Kilowatt hour per square metre
  KiloW__HR__PER__M2: Qudt.unitFromLocalnameRequired("KiloW-HR-PER-M2"),
  // Pound Force per Square Foot
  LB_F__PER__FT2: Qudt.unitFromLocalnameRequired("LB_F-PER-FT2"),
  // percent foot hour per pound (avoirdupois)
  PERCENT__FT__HR__PER__LB: Qudt.unitFromLocalnameRequired(
    "PERCENT-FT-HR-PER-LB"
  ),
  // joule per day
  J__PER__DAY: Qudt.unitFromLocalnameRequired("J-PER-DAY"),
  // Square Mile
  MI2: Qudt.unitFromLocalnameRequired("MI2"),
  // Radian per Minute
  RAD__PER__MIN: Qudt.unitFromLocalnameRequired("RAD-PER-MIN"),
  // Moles per gram hour
  MOL__PER__GM__HR: Qudt.unitFromLocalnameRequired("MOL-PER-GM-HR"),
  // chain
  CH: Qudt.unitFromLocalnameRequired("CH"),
  // Kilocalorie (thermochemical) per Minute
  KiloCAL_TH__PER__MIN: Qudt.unitFromLocalnameRequired("KiloCAL_TH-PER-MIN"),
  // Newton je Meter
  N__PER__M: Qudt.unitFromLocalnameRequired("N-PER-M"),
  // rem per second
  REM__PER__SEC: Qudt.unitFromLocalnameRequired("REM-PER-SEC"),
  // Nanokatal per Liter
  NanoKAT__PER__L: Qudt.unitFromLocalnameRequired("NanoKAT-PER-L"),
  // gram per litre poise
  GM__PER__L__POISE: Qudt.unitFromLocalnameRequired("GM-PER-L-POISE"),
  // BTU per Pound Mole Degree Fahrenheit
  BTU_IT__PER__MOL_LB__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-MOL_LB-DEG_F"
  ),
  // Rem
  REM: Qudt.unitFromLocalnameRequired("REM"),
  // Nanotesla
  NanoT: Qudt.unitFromLocalnameRequired("NanoT"),
  // Reciprocal Cubic Meter
  PER__M3: Qudt.unitFromLocalnameRequired("PER-M3"),
  // Kelvin per Minute
  K__PER__MIN: Qudt.unitFromLocalnameRequired("K-PER-MIN"),
  // Degree Celsius per Second
  DEG_C__PER__SEC: Qudt.unitFromLocalnameRequired("DEG_C-PER-SEC"),
  // Kilocurie
  KiloCi: Qudt.unitFromLocalnameRequired("KiloCi"),
  // Barrel (US Petroleum) per Second
  BBL_US_PET__PER__SEC: Qudt.unitFromLocalnameRequired("BBL_US_PET-PER-SEC"),
  // Cubic Millimetre per Kilogram
  MilliM3__PER__KiloGM: Qudt.unitFromLocalnameRequired("MilliM3-PER-KiloGM"),
  // BTU per Square Foot
  BTU_IT__PER__FT2: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT2"),
  // BTU per Hour
  BTU_IT__PER__HR: Qudt.unitFromLocalnameRequired("BTU_IT-PER-HR"),
  // Milligram per Day
  MilliGM__PER__DAY: Qudt.unitFromLocalnameRequired("MilliGM-PER-DAY"),
  // gram centimetre per second
  GM__CentiM__PER__SEC: Qudt.unitFromLocalnameRequired("GM-CentiM-PER-SEC"),
  // pound (avoirdupois) foot per second
  LB__FT__PER__SEC: Qudt.unitFromLocalnameRequired("LB-FT-PER-SEC"),
  // Pound Force per Square Inch Degree Fahrenheit
  LB_F__PER__IN2__DEG_F: Qudt.unitFromLocalnameRequired("LB_F-PER-IN2-DEG_F"),
  // cubic centimetre per bar
  CentiM3__PER__BAR: Qudt.unitFromLocalnameRequired("CentiM3-PER-BAR"),
  // Gallon (UK) per Day
  GAL_UK__PER__DAY: Qudt.unitFromLocalnameRequired("GAL_UK-PER-DAY"),
  // Moles per cubic metre second
  MOL__PER__M3__SEC: Qudt.unitFromLocalnameRequired("MOL-PER-M3-SEC"),
  // Short Ton (us) per Day
  TON_US__PER__DAY: Qudt.unitFromLocalnameRequired("TON_US-PER-DAY"),
  // Franklin
  FR: Qudt.unitFromLocalnameRequired("FR"),
  // Kelvin second
  K__SEC: Qudt.unitFromLocalnameRequired("K-SEC"),
  // Megapascal
  MegaPA: Qudt.unitFromLocalnameRequired("MegaPA"),
  // Pound Mass (avoirdupois) Square Inch
  LB__IN2: Qudt.unitFromLocalnameRequired("LB-IN2"),
  // Million US Dollars per Flight
  MegaDOLLAR_US__PER__FLIGHT: Qudt.unitFromLocalnameRequired(
    "MegaDOLLAR_US-PER-FLIGHT"
  ),
  // Gold (one Troy ounce)
  XAU_Currency: Qudt.currencyFromLocalnameRequired("XAU"),
  // Newton Second per Meter
  N__SEC__PER__M: Qudt.unitFromLocalnameRequired("N-SEC-PER-M"),
  // ακτίνιο
  RAD: Qudt.unitFromLocalnameRequired("RAD"),
  // British Thermal Unit (thermochemical) Foot per Hour Square Foot degree Fahrenheit
  BTU_TH__FT__PER__HR__FT2__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_TH-FT-PER-HR-FT2-DEG_F"
  ),
  // percent hour per cubic inch
  PERCENT__HR__PER__IN3: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-IN3"),
  // zoll
  ZOLL: Qudt.unitFromLocalnameRequired("ZOLL"),
  // Guyana Dollar
  GYD_Currency: Qudt.currencyFromLocalnameRequired("GYD"),
  // millihertz
  MilliHZ: Qudt.unitFromLocalnameRequired("MilliHZ"),
  // Megaton of Oil Equivalent
  MegaTOE: Qudt.unitFromLocalnameRequired("MegaTOE"),
  // Poise per Bar
  POISE__PER__BAR: Qudt.unitFromLocalnameRequired("POISE-PER-BAR"),
  // Centipoise
  CentiPOISE: Qudt.unitFromLocalnameRequired("CentiPOISE"),
  // Attosecond
  AttoSEC: Qudt.unitFromLocalnameRequired("AttoSEC"),
  // Gill (US)
  GI_US: Qudt.unitFromLocalnameRequired("GI_US"),
  // Kilogram Square Second
  KiloGM__SEC2: Qudt.unitFromLocalnameRequired("KiloGM-SEC2"),
  // Gallon (UK)
  GAL_UK: Qudt.unitFromLocalnameRequired("GAL_UK"),
  // Pascal per Hour
  PA__PER__HR: Qudt.unitFromLocalnameRequired("PA-PER-HR"),
  // Week
  WK: Qudt.unitFromLocalnameRequired("WK"),
  // Newton second per Cubic Meter
  N__SEC__PER__M3: Qudt.unitFromLocalnameRequired("N-SEC-PER-M3"),
  // Millisiemens
  MilliS: Qudt.unitFromLocalnameRequired("MilliS"),
  // Reciprocal metre per nanometre
  PER__M__NanoM: Qudt.unitFromLocalnameRequired("PER-M-NanoM"),
  // Becquerels second per cubic metre
  BQ__SEC__PER__M3: Qudt.unitFromLocalnameRequired("BQ-SEC-PER-M3"),
  // Watts per metre
  W__PER__M: Qudt.unitFromLocalnameRequired("W-PER-M"),
  // Grade
  GR: Qudt.unitFromLocalnameRequired("GR"),
  // Kilogram Force per Square Meter
  KiloGM_F__PER__M2: Qudt.unitFromLocalnameRequired("KiloGM_F-PER-M2"),
  // Gill (UK) per Second
  GI_UK__PER__SEC: Qudt.unitFromLocalnameRequired("GI_UK-PER-SEC"),
  // Microgram per Square Inch
  MicroGM__PER__IN2: Qudt.unitFromLocalnameRequired("MicroGM-PER-IN2"),
  // Picograms per kilogram
  PicoGM__PER__KiloGM: Qudt.unitFromLocalnameRequired("PicoGM-PER-KiloGM"),
  // foot second per gallon (US)
  FT__SEC__PER__GAL_US: Qudt.unitFromLocalnameRequired("FT-SEC-PER-GAL_US"),
  // Cubic Metre per Coulomb
  M3__PER__C: Qudt.unitFromLocalnameRequired("M3-PER-C"),
  // MegaBTU_IT
  MegaBTU_IT: Qudt.unitFromLocalnameRequired("MegaBTU_IT"),
  // Milligram per Square Centimeter
  MilliGM__PER__CentiM2: Qudt.unitFromLocalnameRequired("MilliGM-PER-CentiM2"),
  // roentgen per second
  R__PER__SEC: Qudt.unitFromLocalnameRequired("R-PER-SEC"),
  // DecaCoulomb
  DecaC: Qudt.unitFromLocalnameRequired("DecaC"),
  // yard per psi
  YD__PER__PSI: Qudt.unitFromLocalnameRequired("YD-PER-PSI"),
  // Picomoles per cubic metre
  PicoMOL__PER__M3: Qudt.unitFromLocalnameRequired("PicoMOL-PER-M3"),
  // gram per cubic metre poise
  GM__PER__M3__POISE: Qudt.unitFromLocalnameRequired("GM-PER-M3-POISE"),
  // Square Metre Steradian
  M2__SR: Qudt.unitFromLocalnameRequired("M2-SR"),
  // millivolt ampere
  MilliV__A: Qudt.unitFromLocalnameRequired("MilliV-A"),
  // Watts per square metre nanometre steradian
  W__PER__M2__NanoM__SR: Qudt.unitFromLocalnameRequired("W-PER-M2-NanoM-SR"),
  // metrology year
  YR_Metrology: Qudt.unitFromLocalnameRequired("YR_Metrology"),
  // Calorie (thermochemical) per Gram
  CAL_TH__PER__GM: Qudt.unitFromLocalnameRequired("CAL_TH-PER-GM"),
  // Kilojoule
  KiloJ: Qudt.unitFromLocalnameRequired("KiloJ"),
  // Oersted
  OERSTED: Qudt.unitFromLocalnameRequired("OERSTED"),
  // pond
  POND: Qudt.unitFromLocalnameRequired("POND"),
  // BTU per Pound Mole Degree Fahrenheit
  BTU_IT__PER__MOL__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-MOL-DEG_F"
  ),
  // square metre per second pascal
  M2__PER__SEC__PA: Qudt.unitFromLocalnameRequired("M2-PER-SEC-PA"),
  // Quartic Millimetre
  MilliM4: Qudt.unitFromLocalnameRequired("MilliM4"),
  // Newtons per Square Metre
  N__PER__M2: Qudt.unitFromLocalnameRequired("N-PER-M2"),
  // Milliampere Hour
  MilliA__HR: Qudt.unitFromLocalnameRequired("MilliA-HR"),
  // фарад
  FARAD: Qudt.unitFromLocalnameRequired("FARAD"),
  // Trinidad and Tobago Dollar
  TTD_Currency: Qudt.currencyFromLocalnameRequired("TTD"),
  // Calorie (thermochemical) per Second Square Centimeter kelvin
  CAL_TH__PER__SEC__CentiM2__K: Qudt.unitFromLocalnameRequired(
    "CAL_TH-PER-SEC-CentiM2-K"
  ),
  // Unidad de Valor Real
  COU_Currency: Qudt.currencyFromLocalnameRequired("COU"),
  // TeraByte
  TeraBYTE: Qudt.unitFromLocalnameRequired("TeraBYTE"),
  // Kiloampere per Square Metre
  KiloA__PER__M2: Qudt.unitFromLocalnameRequired("KiloA-PER-M2"),
  // Square Centimetre Second
  CentiM2__SEC: Qudt.unitFromLocalnameRequired("CentiM2-SEC"),
  // Metre per year
  M__PER__YR: Qudt.unitFromLocalnameRequired("M-PER-YR"),
  // Stere
  STR: Qudt.unitFromLocalnameRequired("STR"),
  // teravolt ampere reactive
  TeraV__A_Reactive: Qudt.unitFromLocalnameRequired("TeraV-A_Reactive"),
  // Kilogram Kelvin
  KiloGM__K: Qudt.unitFromLocalnameRequired("KiloGM-K"),
  // Kilogram Square Meter per Second
  KiloGM__M2__PER__SEC: Qudt.unitFromLocalnameRequired("KiloGM-M2-PER-SEC"),
  // Pascal per Metre
  PA__PER__M: Qudt.unitFromLocalnameRequired("PA-PER-M"),
  // bit per metre
  BIT__PER__M: Qudt.unitFromLocalnameRequired("BIT-PER-M"),
  // British Thermal Unit (TH) per Cubic Foot
  BTU_TH__PER__FT3: Qudt.unitFromLocalnameRequired("BTU_TH-PER-FT3"),
  // square metre per square second kelvin
  M2__PER__SEC2__K: Qudt.unitFromLocalnameRequired("M2-PER-SEC2-K"),
  // Brunei Dollar
  BND_Currency: Qudt.currencyFromLocalnameRequired("BND"),
  // bekerel
  BQ: Qudt.unitFromLocalnameRequired("BQ"),
  // MilliW
  MilliW: Qudt.unitFromLocalnameRequired("MilliW"),
  // Square Meter Kelvin per Watt
  M2__K__PER__W: Qudt.unitFromLocalnameRequired("M2-K-PER-W"),
  // Kilo British Thermal Unit (Thermochemical Definition)
  KiloBTU_TH: Qudt.unitFromLocalnameRequired("KiloBTU_TH"),
  // milligram per hour bar
  MilliGM__PER__HR__BAR: Qudt.unitFromLocalnameRequired("MilliGM-PER-HR-BAR"),
  // Reads per Kilobase
  RPK: Qudt.unitFromLocalnameRequired("RPK"),
  // ounce hour per cubic inch gallon (US)
  OZ__HR__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "OZ-HR-PER-IN3-GAL_US"
  ),
  // Barrel (UK Petroleum) per Hour
  BBL_UK_PET__PER__HR: Qudt.unitFromLocalnameRequired("BBL_UK_PET-PER-HR"),
  // Euro per watt hour
  EUR__PER__W__HR: Qudt.unitFromLocalnameRequired("EUR-PER-W-HR"),
  // Pound Force per Square Inch
  LB_F__PER__IN2: Qudt.unitFromLocalnameRequired("LB_F-PER-IN2"),
  // Cord
  CORD: Qudt.unitFromLocalnameRequired("CORD"),
  // Square Millimeter
  MilliM2: Qudt.unitFromLocalnameRequired("MilliM2"),
  // килограмм на паскаль-секунда-метр
  KiloGM__PER__PA__SEC__M: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-PA-SEC-M"
  ),
  // Millipascal Second
  MilliPA__SEC: Qudt.unitFromLocalnameRequired("MilliPA-SEC"),
  // Newton Meter per Square Meter
  N__M__PER__M2: Qudt.unitFromLocalnameRequired("N-M-PER-M2"),
  // kilonewton metre per square metre
  KiloN__M__PER__M2: Qudt.unitFromLocalnameRequired("KiloN-M-PER-M2"),
  // French Gauge
  GAUGE_FR: Qudt.unitFromLocalnameRequired("GAUGE_FR"),
  // percent per one hundred thousand
  PERCENT__PER__100KiloCount: Qudt.unitFromLocalnameRequired(
    "PERCENT-PER-100KiloCount"
  ),
  // Coulomb per Meter
  C__PER__M: Qudt.unitFromLocalnameRequired("C-PER-M"),
  // megatonne
  MegaTONNE: Qudt.unitFromLocalnameRequired("MegaTONNE"),
  // Short Ton
  TON_SHORT: Qudt.unitFromLocalnameRequired("TON_SHORT"),
  // Million Years
  MegaYR: Qudt.unitFromLocalnameRequired("MegaYR"),
  // Aruban Guilder
  AWG_Currency: Qudt.currencyFromLocalnameRequired("AWG"),
  // Millimetre
  MilliM: Qudt.unitFromLocalnameRequired("MilliM"),
  // Zambian Kwacha
  ZMW_Currency: Qudt.currencyFromLocalnameRequired("ZMW"),
  // microvolt ampere
  MicroV__A: Qudt.unitFromLocalnameRequired("MicroV-A"),
  // Planck Angular Frequency
  PlanckFrequency_Ang: Qudt.unitFromLocalnameRequired("PlanckFrequency_Ang"),
  // pound hour per square gallon (US)
  LB__HR__PER__GAL_US2: Qudt.unitFromLocalnameRequired("LB-HR-PER-GAL_US2"),
  // Nanomoles per micromole
  NanoMOL__PER__MicroMOL: Qudt.unitFromLocalnameRequired(
    "NanoMOL-PER-MicroMOL"
  ),
  // pound (avoirdupois) per yard
  LB__PER__YD: Qudt.unitFromLocalnameRequired("LB-PER-YD"),
  // Cubic Yard per Day
  YD3__PER__DAY: Qudt.unitFromLocalnameRequired("YD3-PER-DAY"),
  // Unknown
  UNKNOWN: Qudt.unitFromLocalnameRequired("UNKNOWN"),
  // Centigram
  CentiGM: Qudt.unitFromLocalnameRequired("CentiGM"),
  // Hartley per Second
  HART__PER__SEC: Qudt.unitFromLocalnameRequired("HART-PER-SEC"),
  // Kilovolt Ampere Hour
  KiloV__A__HR: Qudt.unitFromLocalnameRequired("KiloV-A-HR"),
  // tonne per day kelvin
  TONNE__PER__DAY__K: Qudt.unitFromLocalnameRequired("TONNE-PER-DAY-K"),
  // pound second per cubic foot cubic inch
  LB__SEC__PER__FT3__IN3: Qudt.unitFromLocalnameRequired("LB-SEC-PER-FT3-IN3"),
  // Ampere per Radian
  A__PER__RAD: Qudt.unitFromLocalnameRequired("A-PER-RAD"),
  // milligram minute per cubic metre cubic centimetre
  MilliGM__MIN__PER__M3__CentiM3: Qudt.unitFromLocalnameRequired(
    "MilliGM-MIN-PER-M3-CentiM3"
  ),
  // Balboa
  PAB_Currency: Qudt.currencyFromLocalnameRequired("PAB"),
  // Fraction
  FRACTION: Qudt.unitFromLocalnameRequired("FRACTION"),
  // Gram
  GM: Qudt.unitFromLocalnameRequired("GM"),
  // Gram Millimeter
  GM__MilliM: Qudt.unitFromLocalnameRequired("GM-MilliM"),
  // gram per litre millipascal second
  GM__PER__L__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "GM-PER-L-MilliPA-SEC"
  ),
  // litre per mol second
  L__PER__MOL__SEC: Qudt.unitFromLocalnameRequired("L-PER-MOL-SEC"),
  // Square Metre per Steradian Joule
  M2__PER__SR__J: Qudt.unitFromLocalnameRequired("M2-PER-SR-J"),
  // Algerian Dinar
  DZD_Currency: Qudt.currencyFromLocalnameRequired("DZD"),
  // Gallon (UK) per Hour
  GAL_UK__PER__HR: Qudt.unitFromLocalnameRequired("GAL_UK-PER-HR"),
  // gram per day bar
  GM__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("GM-PER-DAY-BAR"),
  // Ampere Hour
  A__HR: Qudt.unitFromLocalnameRequired("A-HR"),
  // kandela
  CD: Qudt.unitFromLocalnameRequired("CD"),
  // Kelvin per metre
  K__PER__M: Qudt.unitFromLocalnameRequired("K-PER-M"),
  // Kroon
  EEK_Currency: Qudt.currencyFromLocalnameRequired("EEK"),
  // Picograms per litre
  PicoGM__PER__L: Qudt.unitFromLocalnameRequired("PicoGM-PER-L"),
  // Grain
  GRAIN: Qudt.unitFromLocalnameRequired("GRAIN"),
  // Reciprocal Weber
  PER__WB: Qudt.unitFromLocalnameRequired("PER-WB"),
  // Parts per thousand
  PPTH: Qudt.unitFromLocalnameRequired("PPTH"),
  // Gill (US) per Minute
  GI_US__PER__MIN: Qudt.unitFromLocalnameRequired("GI_US-PER-MIN"),
  // teravolt
  TeraV: Qudt.unitFromLocalnameRequired("TeraV"),
  // Square metre seconds per radian
  M2__SEC__PER__RAD: Qudt.unitFromLocalnameRequired("M2-SEC-PER-RAD"),
  // Centistokes
  CentiST: Qudt.unitFromLocalnameRequired("CentiST"),
  // Millilitre per Kelvin
  MilliL__PER__K: Qudt.unitFromLocalnameRequired("MilliL-PER-K"),
  // Hectolitre
  HectoL: Qudt.unitFromLocalnameRequired("HectoL"),
  // Hong Kong Dollar
  HKD_Currency: Qudt.currencyFromLocalnameRequired("HKD"),
  // Imperial Mass Ounce per Square Yard
  OZ__PER__YD2: Qudt.unitFromLocalnameRequired("OZ-PER-YD2"),
  // kilofarad
  KiloFARAD: Qudt.unitFromLocalnameRequired("KiloFARAD"),
  // Pound Force per Square Inch Second
  LB_F__PER__IN2__SEC: Qudt.unitFromLocalnameRequired("LB_F-PER-IN2-SEC"),
  // Kilogram per Square Metre
  KiloGM__PER__M2: Qudt.unitFromLocalnameRequired("KiloGM-PER-M2"),
  // US Gallon per Day
  GAL_US__PER__DAY: Qudt.unitFromLocalnameRequired("GAL_US-PER-DAY"),
  // Pound per Cubic Yard
  LB__PER__YD3: Qudt.unitFromLocalnameRequired("LB-PER-YD3"),
  // Ounce (avoirdupois) per Gallon (US)
  OZ__PER__GAL_US: Qudt.unitFromLocalnameRequired("OZ-PER-GAL_US"),
  // foot of water (39.2 °F)
  FT_H2O_39dot2DEG_F: Qudt.unitFromLocalnameRequired("FT_H2O_39dot2DEG_F"),
  // Debye
  Debye: Qudt.unitFromLocalnameRequired("Debye"),
  // Reciprocal Meter Kelvin
  PER__M__K: Qudt.unitFromLocalnameRequired("PER-M-K"),
  // Ounce (US Fluid) per Minute
  OZ_VOL_US__PER__MIN: Qudt.unitFromLocalnameRequired("OZ_VOL_US-PER-MIN"),
  // Millimoles per square metre day
  MilliMOL__PER__M2__DAY: Qudt.unitFromLocalnameRequired("MilliMOL-PER-M2-DAY"),
  // Peck (US Dry) per Day
  PK_US_DRY__PER__DAY: Qudt.unitFromLocalnameRequired("PK_US_DRY-PER-DAY"),
  // DecaKiloCount
  DecaKiloCount: Qudt.unitFromLocalnameRequired("DecaKiloCount"),
  // Millilitre
  MilliL: Qudt.unitFromLocalnameRequired("MilliL"),
  // Centimetres per thousand years
  CentiM__PER__KiloYR: Qudt.unitFromLocalnameRequired("CentiM-PER-KiloYR"),
  // Samoan Tala
  WST_Currency: Qudt.currencyFromLocalnameRequired("WST"),
  // Statcoulomb per Square Centimeter
  C_Stat__PER__CentiM2: Qudt.unitFromLocalnameRequired("C_Stat-PER-CentiM2"),
  // poundal second per square inch
  PDL__SEC__PER__IN2: Qudt.unitFromLocalnameRequired("PDL-SEC-PER-IN2"),
  // Kilocalorie per Mole Degree Celsius
  KiloCAL__PER__MOL__DEG_C: Qudt.unitFromLocalnameRequired(
    "KiloCAL-PER-MOL-DEG_C"
  ),
  // Millitesla
  MilliT: Qudt.unitFromLocalnameRequired("MilliT"),
  // coulomb meter
  C__M: Qudt.unitFromLocalnameRequired("C-M"),
  // MilliK
  MilliK: Qudt.unitFromLocalnameRequired("MilliK"),
  // Gigaohm
  GigaOHM: Qudt.unitFromLocalnameRequired("GigaOHM"),
  // percent hour per gallon (UK)
  PERCENT__HR__PER__GAL_UK: Qudt.unitFromLocalnameRequired(
    "PERCENT-HR-PER-GAL_UK"
  ),
  // BTU per Hour Square Foot
  BTU_IT__PER__HR__FT2: Qudt.unitFromLocalnameRequired("BTU_IT-PER-HR-FT2"),
  // Pound Mass (avoirdupois) Inch
  LB__IN: Qudt.unitFromLocalnameRequired("LB-IN"),
  // Kelvin metres
  K__M: Qudt.unitFromLocalnameRequired("K-M"),
  // PebiByte
  PebiBYTE: Qudt.unitFromLocalnameRequired("PebiBYTE"),
  // tonne per day bar
  TONNE__PER__DAY__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-DAY-BAR"),
  // millinewton metre per square metre
  MilliN__M__PER__M2: Qudt.unitFromLocalnameRequired("MilliN-M-PER-M2"),
  // Attofarad
  AttoFARAD: Qudt.unitFromLocalnameRequired("AttoFARAD"),
  // Syrian Pound
  SYP_Currency: Qudt.currencyFromLocalnameRequired("SYP"),
  // ounce foot hour per cubic inch pound
  OZ__FT__HR__PER__IN3__LB: Qudt.unitFromLocalnameRequired(
    "OZ-FT-HR-PER-IN3-LB"
  ),
  // Zloty
  PLN_Currency: Qudt.currencyFromLocalnameRequired("PLN"),
  // Millilitre per Minute
  MilliL__PER__MIN: Qudt.unitFromLocalnameRequired("MilliL-PER-MIN"),
  // Ounce Troy
  OZ_TROY: Qudt.unitFromLocalnameRequired("OZ_TROY"),
  // pound hour per cubic inch gallon (US)
  LB__HR__PER__IN3__GAL_US: Qudt.unitFromLocalnameRequired(
    "LB-HR-PER-IN3-GAL_US"
  ),
  // Kip
  KIP_F: Qudt.unitFromLocalnameRequired("KIP_F"),
  // Degree Fahrenheit Hour
  DEG_F__HR: Qudt.unitFromLocalnameRequired("DEG_F-HR"),
  // European Unit of Account 9 (E.U.A.-9) (Bonds market unit)
  XBC_Currency: Qudt.currencyFromLocalnameRequired("XBC"),
  // Slug per Square Foot
  SLUG__PER__FT2: Qudt.unitFromLocalnameRequired("SLUG-PER-FT2"),
  // percent hour per litre
  PERCENT__HR__PER__L: Qudt.unitFromLocalnameRequired("PERCENT-HR-PER-L"),
  // M0dot
  M0dot: Qudt.unitFromLocalnameRequired("M0dot"),
  // سیورت
  SV: Qudt.unitFromLocalnameRequired("SV"),
  // Kilosiemens
  KiloS: Qudt.unitFromLocalnameRequired("KiloS"),
  // Kina
  PGK_Currency: Qudt.currencyFromLocalnameRequired("PGK"),
  // Slug per Foot Second
  SLUG__PER__FT__SEC: Qudt.unitFromLocalnameRequired("SLUG-PER-FT-SEC"),
  // Milliliter per Gram
  MilliL__PER__GM: Qudt.unitFromLocalnameRequired("MilliL-PER-GM"),
  // MicroKAT
  MicroKAT: Qudt.unitFromLocalnameRequired("MicroKAT"),
  // litre per second bar
  L__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("L-PER-SEC-BAR"),
  // Pascal Second per Bar
  PA__SEC__PER__BAR: Qudt.unitFromLocalnameRequired("PA-SEC-PER-BAR"),
  // BTU per Square Foot Hour Degree Fahrenheit
  BTU_IT__PER__FT2__HR__DEG_F: Qudt.unitFromLocalnameRequired(
    "BTU_IT-PER-FT2-HR-DEG_F"
  ),
  // Kilopascal Absolute
  KiloPA_A: Qudt.unitFromLocalnameRequired("KiloPA_A"),
  // Poundal
  PDL: Qudt.unitFromLocalnameRequired("PDL"),
  // Mil Length
  MilLength: Qudt.unitFromLocalnameRequired("MilLength"),
  // watt
  W: Qudt.unitFromLocalnameRequired("W"),
  // Pound Degree Fahrenheit
  LB__DEG_F: Qudt.unitFromLocalnameRequired("LB-DEG_F"),
  // Centimeter per Square Second
  CentiM__PER__SEC2: Qudt.unitFromLocalnameRequired("CentiM-PER-SEC2"),
  // Sidereal Hour
  HR_Sidereal: Qudt.unitFromLocalnameRequired("HR_Sidereal"),
  // British Thermal Unit (thermochemical) per Second
  BTU_TH__PER__SEC: Qudt.unitFromLocalnameRequired("BTU_TH-PER-SEC"),
  // Joule per Cubic Meter Kelvin
  J__PER__M3__K: Qudt.unitFromLocalnameRequired("J-PER-M3-K"),
  // kilogram per cubic centimetre bar
  KiloGM__PER__CentiM3__BAR: Qudt.unitFromLocalnameRequired(
    "KiloGM-PER-CentiM3-BAR"
  ),
  // T-SEC
  T__SEC: Qudt.unitFromLocalnameRequired("T-SEC"),
  // picojoule
  PicoJ: Qudt.unitFromLocalnameRequired("PicoJ"),
  // metre per second bar
  M__PER__SEC__BAR: Qudt.unitFromLocalnameRequired("M-PER-SEC-BAR"),
  // Milligram per Second
  MilliGM__PER__SEC: Qudt.unitFromLocalnameRequired("MilliGM-PER-SEC"),
  // coulomb square metre per kilogram
  C__M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("C-M2-PER-KiloGM"),
  // EU
  EU: Qudt.unitFromLocalnameRequired("EU"),
  // meter kelvin
  M__K: Qudt.unitFromLocalnameRequired("M-K"),
  // Kilocalorie (thermochemical)
  KiloCAL_TH: Qudt.unitFromLocalnameRequired("KiloCAL_TH"),
  // milligray per second
  MilliGRAY__PER__SEC: Qudt.unitFromLocalnameRequired("MilliGRAY-PER-SEC"),
  // Micronewton
  MicroN: Qudt.unitFromLocalnameRequired("MicroN"),
  // Standard Cubic Foot per Minute
  SCF__PER__MIN: Qudt.unitFromLocalnameRequired("SCF-PER-MIN"),
  // kilogram per kilometre
  KiloGM__PER__KiloM: Qudt.unitFromLocalnameRequired("KiloGM-PER-KiloM"),
  // yard per hour
  YD__PER__HR: Qudt.unitFromLocalnameRequired("YD-PER-HR"),
  // Cubic Inch per Minute
  IN3__PER__MIN: Qudt.unitFromLocalnameRequired("IN3-PER-MIN"),
  // Pound Mole
  MOL_LB: Qudt.unitFromLocalnameRequired("MOL_LB"),
  // Abvolt
  V_Ab: Qudt.unitFromLocalnameRequired("V_Ab"),
  // Reciprocal Joule Cubic Meter
  PER__J__M3: Qudt.unitFromLocalnameRequired("PER-J-M3"),
  // Therm US per Hour
  THM_US__PER__HR: Qudt.unitFromLocalnameRequired("THM_US-PER-HR"),
  // Terahertz
  TeraHZ: Qudt.unitFromLocalnameRequired("TeraHZ"),
  // Sample per second
  SAMPLE__PER__SEC: Qudt.unitFromLocalnameRequired("SAMPLE-PER-SEC"),
  // Milligram per Cubic Metre
  MilliGM__PER__M3: Qudt.unitFromLocalnameRequired("MilliGM-PER-M3"),
  // Joule Meter per Mole
  J__M__PER__MOL: Qudt.unitFromLocalnameRequired("J-M-PER-MOL"),
  // Degree Celsius Centimetre
  DEG_C__CentiM: Qudt.unitFromLocalnameRequired("DEG_C-CentiM"),
  // BTU per Second Square Foot
  BTU_IT__PER__SEC__FT2: Qudt.unitFromLocalnameRequired("BTU_IT-PER-SEC-FT2"),
  // calorie (thermochemical) per square centimetre
  CAL_TH__PER__CentiM2: Qudt.unitFromLocalnameRequired("CAL_TH-PER-CentiM2"),
  // tonne per bar
  TONNE__PER__BAR: Qudt.unitFromLocalnameRequired("TONNE-PER-BAR"),
  // Millijoule
  MilliJ: Qudt.unitFromLocalnameRequired("MilliJ"),
  // BTU per Second
  BTU_IT__PER__SEC: Qudt.unitFromLocalnameRequired("BTU_IT-PER-SEC"),
  // Mega Electron Volt per Centimetre
  MegaEV__PER__CentiM: Qudt.unitFromLocalnameRequired("MegaEV-PER-CentiM"),
  // milligram per cubic metre millipascal second
  MilliGM__PER__M3__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "MilliGM-PER-M3-MilliPA-SEC"
  ),
  // British thermal unit (international table) per square foot hour
  BTU_IT__PER__FT2__HR: Qudt.unitFromLocalnameRequired("BTU_IT-PER-FT2-HR"),
  // percent minute per cubic metre
  PERCENT__MIN__PER__M3: Qudt.unitFromLocalnameRequired("PERCENT-MIN-PER-M3"),
  // gram per cubic metre millipascal second
  GM__PER__M3__MilliPA__SEC: Qudt.unitFromLocalnameRequired(
    "GM-PER-M3-MilliPA-SEC"
  ),
  // cubic metre per bar
  M3__PER__BAR: Qudt.unitFromLocalnameRequired("M3-PER-BAR"),
  // Calorie (thermochemical) per Gram Degree Celsius
  CAL_TH__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired("CAL_TH-PER-GM-DEG_C"),
  // Azerbaijanian Manat
  AZN_Currency: Qudt.currencyFromLocalnameRequired("AZN"),
  // Megapascal per Kelvin
  MegaPA__PER__K: Qudt.unitFromLocalnameRequired("MegaPA-PER-K"),
  // Microlitre per Litre
  MicroL__PER__L: Qudt.unitFromLocalnameRequired("MicroL-PER-L"),
  // decibel milliwatts
  DeciB__MilliW: Qudt.unitFromLocalnameRequired("DeciB-MilliW"),
  // nanosievert per hour
  NanoSV__PER__HR: Qudt.unitFromLocalnameRequired("NanoSV-PER-HR"),
  // BU_US_DRY
  BU_US_DRY: Qudt.unitFromLocalnameRequired("BU_US_DRY"),
  // decibel per kilometre
  DeciB__PER__KiloM: Qudt.unitFromLocalnameRequired("DeciB-PER-KiloM"),
  // millilitre per hour bar
  MilliL__PER__HR__BAR: Qudt.unitFromLocalnameRequired("MilliL-PER-HR-BAR"),
  // New Turkish Lira
  TRY_Currency: Qudt.currencyFromLocalnameRequired("TRY"),
  // Millimole per Gram
  MilliMOL__PER__GM: Qudt.unitFromLocalnameRequired("MilliMOL-PER-GM"),
  // Hectopascal Cubic Meter per Second
  HectoPA__M3__PER__SEC: Qudt.unitFromLocalnameRequired("HectoPA-M3-PER-SEC"),
  // Gill (UK) per Hour
  GI_UK__PER__HR: Qudt.unitFromLocalnameRequired("GI_UK-PER-HR"),
  // Yard
  YD: Qudt.unitFromLocalnameRequired("YD"),
  // Million US Dollars per Flight
  MDOLLAR__PER__FLIGHT: Qudt.unitFromLocalnameRequired("MDOLLAR-PER-FLIGHT"),
  // Cubic micrometres (microns)
  MicroM3: Qudt.unitFromLocalnameRequired("MicroM3"),
  // Euro per watt second
  EUR__PER__W__SEC: Qudt.unitFromLocalnameRequired("EUR-PER-W-SEC"),
  // MilliCoulomb
  MilliC: Qudt.unitFromLocalnameRequired("MilliC"),
  // Degree Baume (US Light)
  DEGREE_BAUME_US_LIGHT: Qudt.unitFromLocalnameRequired(
    "DEGREE_BAUME_US_LIGHT"
  ),
  // siemens
  S: Qudt.unitFromLocalnameRequired("S"),
  // Millimole
  MilliMOL: Qudt.unitFromLocalnameRequired("MilliMOL"),
  // Kyat
  MMK_Currency: Qudt.currencyFromLocalnameRequired("MMK"),
  // megabecquerel per kilogram
  MegaBQ__PER__KiloGM: Qudt.unitFromLocalnameRequired("MegaBQ-PER-KiloGM"),
  // tonne per second kelvin
  TON_Metric__PER__SEC__K: Qudt.unitFromLocalnameRequired(
    "TON_Metric-PER-SEC-K"
  ),
  // erg square centimetre per gram
  ERG__CentiM2__PER__GM: Qudt.unitFromLocalnameRequired("ERG-CentiM2-PER-GM"),
  // DEGREE
  DEGREE: Qudt.unitFromLocalnameRequired("DEGREE"),
  // Siemens per Centimetre
  S__PER__CentiM: Qudt.unitFromLocalnameRequired("S-PER-CentiM"),
  // Calorie (thermochemical) per Gram Kelvin
  CAL_TH__PER__GM__K: Qudt.unitFromLocalnameRequired("CAL_TH-PER-GM-K"),
  // Cubic Meter per Hour
  M3__PER__HR: Qudt.unitFromLocalnameRequired("M3-PER-HR"),
  // Kilocalorie (mean)
  KiloCAL_Mean: Qudt.unitFromLocalnameRequired("KiloCAL_Mean"),
  // ohm
  OHM: Qudt.unitFromLocalnameRequired("OHM"),
  // gray per minute
  GRAY__PER__MIN: Qudt.unitFromLocalnameRequired("GRAY-PER-MIN"),
  // Reciprocal millisecond
  PER__MilliSEC: Qudt.unitFromLocalnameRequired("PER-MilliSEC"),
  // Square Meter per Kilogram
  M2__PER__KiloGM: Qudt.unitFromLocalnameRequired("M2-PER-KiloGM"),
  // lumen per square metre
  LM__PER__M2: Qudt.unitFromLocalnameRequired("LM-PER-M2"),
  // 100KiloCount
  _100KiloCount: Qudt.unitFromLocalnameRequired("100KiloCount"),
  // dyne metre
  DYN__M: Qudt.unitFromLocalnameRequired("DYN-M"),
  // Milligram
  MilliGM: Qudt.unitFromLocalnameRequired("MilliGM"),
  // Nanofarad
  NanoFARAD: Qudt.unitFromLocalnameRequired("NanoFARAD"),
  // Kilo Byte
  KiloBYTE: Qudt.unitFromLocalnameRequired("KiloBYTE"),
  // enzyme unit
  ENZ: Qudt.unitFromLocalnameRequired("ENZ"),
  // Cubic Foot
  FT3: Qudt.unitFromLocalnameRequired("FT3"),
  // MilliGals per month
  MilliGAL__PER__MO: Qudt.unitFromLocalnameRequired("MilliGAL-PER-MO"),
  // Imperial Gallon
  GAL_IMP: Qudt.unitFromLocalnameRequired("GAL_IMP"),
  // New Zealand Dollar
  NZD_Currency: Qudt.currencyFromLocalnameRequired("NZD"),
  // hour per square foot
  HR__PER__FT2: Qudt.unitFromLocalnameRequired("HR-PER-FT2"),
  // कूलम्ब
  C: Qudt.unitFromLocalnameRequired("C"),
  // Bushel (UK) per Hour
  BU_UK__PER__HR: Qudt.unitFromLocalnameRequired("BU_UK-PER-HR"),
  // Ton (US Shipping)
  TON_SHIPPING_US: Qudt.unitFromLocalnameRequired("TON_SHIPPING_US"),
  // microvolt ampere per kelvin
  MicroV__A__PER__K: Qudt.unitFromLocalnameRequired("MicroV-A-PER-K"),
  // Cubic Yard per Hour
  YD3__PER__HR: Qudt.unitFromLocalnameRequired("YD3-PER-HR"),
  // Grain per Gallon
  GRAIN__PER__GAL: Qudt.unitFromLocalnameRequired("GRAIN-PER-GAL"),
  // CYC
  CYC: Qudt.unitFromLocalnameRequired("CYC"),
  // Pound Force per Foot
  KiloLB_F__PER__FT: Qudt.unitFromLocalnameRequired("KiloLB_F-PER-FT"),
  // British thermal unit (thermochemical) per degree Fahrenheit
  BTU_TH__PER__DEG_F: Qudt.unitFromLocalnameRequired("BTU_TH-PER-DEG_F"),
  // Pennyweight
  Pennyweight: Qudt.unitFromLocalnameRequired("Pennyweight"),
  // milligram minute per power of metre with the exponent 6
  MilliGM__MIN__PER__M6: Qudt.unitFromLocalnameRequired("MilliGM-MIN-PER-M6"),
  // Maltese Lira
  MTL_Currency: Qudt.currencyFromLocalnameRequired("MTL"),
  // grams per decilitre
  GM__PER__DeciL: Qudt.unitFromLocalnameRequired("GM-PER-DeciL"),
  // Litre
  L: Qudt.unitFromLocalnameRequired("L"),
  // United Arab Emirates dirham
  AED_Currency: Qudt.currencyFromLocalnameRequired("AED"),
  // mebibit
  MebiBIT: Qudt.unitFromLocalnameRequired("MebiBIT"),
  // megaohm per bar
  MegaOHM__PER__BAR: Qudt.unitFromLocalnameRequired("MegaOHM-PER-BAR"),
  // Cubic microns per cubic metre
  MicroM3__PER__M3: Qudt.unitFromLocalnameRequired("MicroM3-PER-M3"),
  // joule per gram degree celsius
  J__PER__GM__DEG_C: Qudt.unitFromLocalnameRequired("J-PER-GM-DEG_C"),
  // Volt Ampere Reactive
  V__A_Reactive: Qudt.unitFromLocalnameRequired("V-A_Reactive"),
  // Picograms per millilitre
  PicoGM__PER__MilliL: Qudt.unitFromLocalnameRequired("PicoGM-PER-MilliL"),
  // Reciprocal square second
  PER__SEC2: Qudt.unitFromLocalnameRequired("PER-SEC2"),
  // Kilogram per Cubic Decimetre
  KiloGM__PER__DeciM3: Qudt.unitFromLocalnameRequired("KiloGM-PER-DeciM3"),
  // Mebibyte
  MebiBYTE: Qudt.unitFromLocalnameRequired("MebiBYTE"),
  // Hertz per Tesla
  HZ__PER__T: Qudt.unitFromLocalnameRequired("HZ-PER-T"),
  // Pound Troy
  LB_T: Qudt.unitFromLocalnameRequired("LB_T"),
  // Metric Perm
  PERM_Metric: Qudt.unitFromLocalnameRequired("PERM_Metric"),
  // Degree Celsius per Minute
  DEG_C__PER__MIN: Qudt.unitFromLocalnameRequired("DEG_C-PER-MIN"),
  // tonne per month
  TONNE__PER__MO: Qudt.unitFromLocalnameRequired("TONNE-PER-MO"),
  // Cubic Yard per Minute
  YD3__PER__MIN: Qudt.unitFromLocalnameRequired("YD3-PER-MIN"),
};

// QuantityKinds
{
  let quantityKind: QuantityKind;
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsoluteActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Absolute Activity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-SEC-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsoluteActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsoluteHumidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    "AH",
    undefined
  );
  quantityKind.addLabel(new LangString("Absolute Humidity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Density"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsoluteHumidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsoluteTypographicMeasurement",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("absolute typographic measurement", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsoluteTypographicMeasurement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsorbedDose",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Absorbed Dose", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD_R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD_R");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsorbedDose",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Absorbed Dose Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AbsorbedDoseRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Absorptance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Absorptance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Absorptance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Acceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ускоре́ние", "ru"));
  quantityKind.addLabel(new LangString("aceleración", "es"));
  quantityKind.addLabel(new LangString("accelerație", "ro"));
  quantityKind.addLabel(new LangString("Όγκος", "el"));
  quantityKind.addLabel(new LangString("ivme", "tr"));
  quantityKind.addLabel(new LangString("加速度", "ja"));
  quantityKind.addLabel(new LangString("Pecutan", "ms"));
  quantityKind.addLabel(new LangString("Zrychlení", "cs"));
  quantityKind.addLabel(new LangString("accelerazione", "it"));
  quantityKind.addLabel(new LangString("شتاب", "fa"));
  quantityKind.addLabel(new LangString("त्वरण", "hi"));
  quantityKind.addLabel(new LangString("التسارع", "ar"));
  quantityKind.addLabel(new LangString("Beschleunigung", "de"));
  quantityKind.addLabel(new LangString("aceleração", "pt"));
  quantityKind.addLabel(new LangString("acceleration", "en"));
  quantityKind.addLabel(new LangString("pospešek", "sl"));
  quantityKind.addLabel(new LangString("accélération", "fr"));
  quantityKind.addLabel(new LangString("przyspieszenie", "pl"));
  quantityKind.addLabel(new LangString("acceleratio", "la"));
  quantityKind.addLabel(new LangString("加速度", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Acceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AccelerationOfGravity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Acceleration Of Gravity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AccelerationOfGravity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AcceptorDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Acceptor Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AcceptorDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AcceptorIonizationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Acceptor Ionization Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AcceptorIonizationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Acidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Acidity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PH");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Acidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Acoustic Impediance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Action",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("Action", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Action",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActionTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Action Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActionTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActiveEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "W",
    undefined
  );
  quantityKind.addLabel(new LangString("Active Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActiveEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivePower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("Active Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ComplexPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivePower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Activity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Activity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCi");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliCi");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroCi");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/StochasticProcess"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Activity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Activity Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    "c_A",
    undefined
  );
  quantityKind.addLabel(new LangString("Activity Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoBQ-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBQ-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBQ-PER-L");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityRelatedByMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    "0173-1#Z4-BAJ342#002",
    undefined
  );
  quantityKind.addLabel(new LangString("activity related by mass", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassicActivity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityRelatedByMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ActivityThresholds",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Activity Thresholds", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ActivityThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Adaptation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Adaptation", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Adaptation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Admittance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Admittance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Admittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AlphaDisintegrationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Alpha Disintegration Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AlphaDisintegrationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Altitude",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Altitude", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Altitude",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmbientPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Ambient Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmbientPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfBiologicallyActiveSubstance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("amount of biologically active substance", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfBiologicallyActiveSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("كمية المادة", "ar"));
  quantityKind.addLabel(new LangString("množina snovi", "sl"));
  quantityKind.addLabel(new LangString("quantità di sostanza", "it"));
  quantityKind.addLabel(new LangString("مقدار ماده", "fa"));
  quantityKind.addLabel(new LangString("quantité de matière", "fr"));
  quantityKind.addLabel(new LangString("anyagmennyiség", "hu"));
  quantityKind.addLabel(new LangString("כמות חומר", "he"));
  quantityKind.addLabel(new LangString("Количество вещества", "ru"));
  quantityKind.addLabel(new LangString("cantitate de substanță", "ro"));
  quantityKind.addLabel(new LangString("cantidad de sustancia", "es"));
  quantityKind.addLabel(new LangString("物質量", "ja"));
  quantityKind.addLabel(new LangString("Ποσότητα Ουσίας", "el"));
  quantityKind.addLabel(new LangString("Stoffmenge", "de"));
  quantityKind.addLabel(new LangString("पदार्थ की मात्रा", "hi"));
  quantityKind.addLabel(new LangString("quantitas substantiae", "la"));
  quantityKind.addLabel(new LangString("amount of substance", "en"));
  quantityKind.addLabel(new LangString("madde miktarı", "tr"));
  quantityKind.addLabel(new LangString("Количество вещество", "bg"));
  quantityKind.addLabel(new LangString("Látkové množství", "cs"));
  quantityKind.addLabel(new LangString("quantidade de substância", "pt"));
  quantityKind.addLabel(new LangString("物质的量", "zh"));
  quantityKind.addLabel(new LangString("Jumlah bahan", "ms"));
  quantityKind.addLabel(new LangString("liczność materii", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Amount of Substance of Concentration", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentrationOfB",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    "C_B",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Amount of Substance of Concentration of B", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentrationOfB",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "X_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Fractional Amount of Substance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFractionOfB",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "X_B",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Amount of Substance of Fraction of B", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MoleFraction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceFractionOfB",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceIonConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceIonConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Amount of Substance per Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IU-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-TONNE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure",
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Molar Mass variation due to Pressure", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMassPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerUnitMass",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Amount of Substance per Unit Mass", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerUnitMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerUnitMassPressure",
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Molar Mass variation due to Pressure", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerUnitMassPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerUnitVolume",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    "C_B",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Amount of Substance per Unit Volume", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerUnitVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Amount of Substance per Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstanceConcentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Angle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/PlaneAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Angle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngleOfAttack",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angle Of Attack", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngleOfAttack",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngleOfOpticalRotation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angle of Optical Rotation", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngleOfOpticalRotation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Угловое ускорение", "ru"));
  quantityKind.addLabel(new LangString("角加速度", "zh"));
  quantityKind.addLabel(new LangString("angular acceleration", "en"));
  quantityKind.addLabel(new LangString("Pecutan bersudut", "ms"));
  quantityKind.addLabel(new LangString("شتاب زاویه‌ای", "fa"));
  quantityKind.addLabel(new LangString("Açısal ivme", "tr"));
  quantityKind.addLabel(new LangString("Winkelbeschleunigung", "de"));
  quantityKind.addLabel(new LangString("Accelerație unghiulară", "ro"));
  quantityKind.addLabel(new LangString("कोणीय त्वरण", "hi"));
  quantityKind.addLabel(new LangString("Przyspieszenie kątowe", "pl"));
  quantityKind.addLabel(new LangString("accelerazione angolare", "it"));
  quantityKind.addLabel(new LangString("Úhlové zrychlení", "cs"));
  quantityKind.addLabel(new LangString("aceleración angular", "es"));
  quantityKind.addLabel(new LangString("角加速度", "ja"));
  quantityKind.addLabel(new LangString("accélération angulaire", "fr"));
  quantityKind.addLabel(new LangString("تسارع زاوي", "ar"));
  quantityKind.addLabel(new LangString("aceleração angular", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-SEC2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseSquareTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularAcceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kreisfrequenz", "de"));
  quantityKind.addLabel(new LangString("تردد زاوى", "ar"));
  quantityKind.addLabel(new LangString("frequenza angolare", "it"));
  quantityKind.addLabel(new LangString("Pulsación", "fr"));
  quantityKind.addLabel(new LangString("pulsacja", "pl"));
  quantityKind.addLabel(new LangString("角频率", "zh"));
  quantityKind.addLabel(new LangString("pulsación", "es"));
  quantityKind.addLabel(new LangString("角振動数", "ja"));
  quantityKind.addLabel(new LangString("angular frequency", "en"));
  quantityKind.addLabel(new LangString("frequência angular", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularImpulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("impulso angolare", "it"));
  quantityKind.addLabel(new LangString("نبضة دفعية زاوية", "ar"));
  quantityKind.addLabel(new LangString("angular impulse", "en"));
  quantityKind.addLabel(new LangString("impulsion angulaire", "fr"));
  quantityKind.addLabel(new LangString("impulsão angular", "pt"));
  quantityKind.addLabel(new LangString("popęd kątowy", "pl"));
  quantityKind.addLabel(new LangString("impulso angular", "es"));
  quantityKind.addLabel(new LangString("Drehstoß", "de"));
  quantityKind.addLabel(new LangString("角力積", "ja"));
  quantityKind.addLabel(new LangString("角冲量;冲量矩", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularImpulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularImpulse"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularMomentumPerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Angular Momentum per Angle", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-SEC-PER-RAD"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularMomentumPerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "G",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Angular Reciprocal Lattice Vector", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Halaju bersudut", "ms"));
  quantityKind.addLabel(new LangString("Winkelgeschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("velocità angolare", "it"));
  quantityKind.addLabel(new LangString("Viteză unghiulară", "ro"));
  quantityKind.addLabel(new LangString("Úhlová rychlost", "cs"));
  quantityKind.addLabel(new LangString("Угловая скорость", "ru"));
  quantityKind.addLabel(new LangString("سرعة زاوية", "ar"));
  quantityKind.addLabel(new LangString("角速度", "ja"));
  quantityKind.addLabel(new LangString("angular velocity", "en"));
  quantityKind.addLabel(new LangString("سرعت زاویه‌ای", "fa"));
  quantityKind.addLabel(new LangString("角速度", "zh"));
  quantityKind.addLabel(new LangString("kotna hitrost", "sl"));
  quantityKind.addLabel(new LangString("velocidad angular", "es"));
  quantityKind.addLabel(new LangString("Prędkość kątowa", "pl"));
  quantityKind.addLabel(new LangString("कोणीय वेग", "hi"));
  quantityKind.addLabel(new LangString("velocidade angular", "pt"));
  quantityKind.addLabel(new LangString("vitesse angulaire", "fr"));
  quantityKind.addLabel(new LangString("Açısal hız", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "k",
    undefined
  );
  quantityKind.addLabel(new LangString("número de onda angular", "pt"));
  quantityKind.addLabel(new LangString("角波数", "ja"));
  quantityKind.addLabel(new LangString("número de onda angular", "es"));
  quantityKind.addLabel(new LangString("角波数", "zh"));
  quantityKind.addLabel(new LangString("nombre d'onde angulaire", "fr"));
  quantityKind.addLabel(new LangString("liczba falowa kątowa", "pl"));
  quantityKind.addLabel(new LangString("angular wavenumber", "en"));
  quantityKind.addLabel(new LangString("عدد موجى زاوى", "ar"));
  quantityKind.addLabel(new LangString("numero d'onda angolare", "it"));
  quantityKind.addLabel(new LangString("Kreisrepetenz", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AngularWavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ApogeeRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r_2",
    undefined
  );
  quantityKind.addLabel(new LangString("Apogee Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Radius"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ApogeeRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ApparentPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("皮相電力", "ja"));
  quantityKind.addLabel(new LangString("puissance apparente", "fr"));
  quantityKind.addLabel(new LangString("moc pozorna", "pl"));
  quantityKind.addLabel(new LangString("apparent power", "en"));
  quantityKind.addLabel(new LangString("视在功率", "zh"));
  quantityKind.addLabel(new LangString("potencia aparente", "es"));
  quantityKind.addLabel(new LangString("potência aparente", "pt"));
  quantityKind.addLabel(new LangString("Scheinleistung", "de"));
  quantityKind.addLabel(new LangString("potenza apparente", "it"));
  quantityKind.addLabel(new LangString("القدرة الظاهرية", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV-A");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ComplexPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ApparentPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Area",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("área", "pt"));
  quantityKind.addLabel(new LangString("pole powierzchni", "pl"));
  quantityKind.addLabel(new LangString("面积", "zh"));
  quantityKind.addLabel(new LangString("面積", "ja"));
  quantityKind.addLabel(new LangString("مساحة", "ar"));
  quantityKind.addLabel(new LangString("alan", "tr"));
  quantityKind.addLabel(new LangString("Площ", "bg"));
  quantityKind.addLabel(new LangString("שטח", "he"));
  quantityKind.addLabel(new LangString("area", "en"));
  quantityKind.addLabel(new LangString("क्षेत्रफल", "hi"));
  quantityKind.addLabel(new LangString("Keluasan", "ms"));
  quantityKind.addLabel(new LangString("area", "it"));
  quantityKind.addLabel(new LangString("مساحت", "fa"));
  quantityKind.addLabel(new LangString("plocha", "cs"));
  quantityKind.addLabel(new LangString("Ταχύτητα", "el"));
  quantityKind.addLabel(new LangString("aire", "fr"));
  quantityKind.addLabel(new LangString("área", "es"));
  quantityKind.addLabel(new LangString("Fläche", "de"));
  quantityKind.addLabel(new LangString("arie", "ro"));
  quantityKind.addLabel(new LangString("Площадь", "ru"));
  quantityKind.addLabel(new LangString("površina", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Area",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaBitDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("areic bit density", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaBitDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaChargeDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("areic charge density", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaChargeDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("areic mass", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("area per length", "en"));
  quantityKind.addLabel(new LangString("Fläche pro Längeneinheit", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaPerPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fläche pro Heizlast", "de"));
  quantityKind.addLabel(new LangString("area per heating load", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloW");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaPerPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaPerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area per Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaPerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaThermalExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Thermal Expansion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaThermalExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC-FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Area Time Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-SEC-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-HR-DEG_F");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreaTimeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicChargeDensityOrElectricFluxDensityOrElectricPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "0173-1#Z4-BAJ320#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "areic charge density or electric flux density or electric polarization",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicChargeDensityOrElectricFluxDensityOrElectricPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    "0173-1#Z4-BAJ321#002",
    undefined
  );
  quantityKind.addLabel(new LangString("areic data volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicEnergyFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "0173-1#Z4-BAJ322#002",
    undefined
  );
  quantityKind.addLabel(new LangString("areic energy flow", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicEnergyFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicHeatFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "φ",
    undefined
  );
  quantityKind.addLabel(new LangString("Aeric Heat Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicHeatFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    "0173-1#Z4-BAJ288#004",
    undefined
  );
  quantityKind.addLabel(new LangString("areic mass", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AreicTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "0173-1#Z4-BAJ420#001",
    undefined
  );
  quantityKind.addLabel(new LangString("areic torque", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AreicTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Asset",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Asset", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Asset",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Atmospheric Hydroxylation Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-MOL-SEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtmosphericHydroxylationRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtmosphericPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Atmospheric Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtmosphericPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomScatteringFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(new LangString("Atom Scattering Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomScatteringFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "μₐ",
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCharge");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZettaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YottaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YoctoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZeptoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ElementaryCharge"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCharge"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ291#002",
    undefined
  );
  quantityKind.addLabel(new LangString("atomic energy", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Atomic Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Z");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AtomicStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    "0173-1#Z4-BAJ292#002",
    undefined
  );
  quantityKind.addLabel(new LangString("atomic stopping power", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AtomicStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AuditoryThresholds",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Auditory Thresholds", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundPowerLevel"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AuditoryThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AuxillaryMagneticField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Auxillary Magnetic Field", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OERSTED");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AuxillaryMagneticField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageEnergyLossPerElementaryChargeProduced",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "W_i",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Average Energy Loss per Elementary Charge Produced", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageEnergyLossPerElementaryChargeProduced",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageHeadEndPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Average Head End Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeadEndPressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageHeadEndPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageLogarithmicEnergyDecrement",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Average Logarithmic Energy Decrement", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageLogarithmicEnergyDecrement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageSpecificImpulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Average Specific Impulse", "en"));
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageSpecificImpulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/AverageVacuumThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Average Vacuum Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VacuumThrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/AverageVacuumThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Azimuth",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Azimuth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Azimuth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BandwidthDistanceProduct",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("bandwidth distance product", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BandwidthDistanceProduct",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BandwidthLengthProduct",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "0173-1#Z4-BAJ293#003",
    undefined
  );
  quantityKind.addLabel(new LangString("bandwidth length product", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BandwidthLengthProduct",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Basicity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Basicity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PH");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Basicity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BatteryCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    "0173-1#Z4-BAJ270#003",
    undefined
  );
  quantityKind.addLabel(new LangString("battery capacity", "en-US"));
  quantityKind.addLabel(new LangString("battery capacity", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-MIN");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BatteryCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BendingMomentOfForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "M_b",
    undefined
  );
  quantityKind.addLabel(new LangString("Bending Moment of Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Torque"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BendingMomentOfForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BetaDisintegrationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Qᵦ",
    undefined
  );
  quantityKind.addLabel(new LangString("Beta Disintegration Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BetaDisintegrationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BevelGearPitchAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Bevel Gear Pitch Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BevelGearPitchAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BindingFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("Binding Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BindingFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BioconcentrationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Bioconcentration Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BioconcentrationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BiodegredationHalfLife",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Biodegredation Half Life", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BiodegredationHalfLife",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BitDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ436#002",
    undefined
  );
  quantityKind.addLabel(new LangString("bit data volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BitDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BitRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("bit rate", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCTET-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BitRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BitTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ295#003",
    undefined
  );
  quantityKind.addLabel(new LangString("bit transmission rate", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCTET-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BitRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BitTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Blood Glucose Level", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel_Mass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Blood Glucose Level by Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BloodGlucoseLevel_Mass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BodyMassIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    "BMI",
    undefined
  );
  quantityKind.addLabel(new LangString("Body Mass Index", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BodyMassIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BoilingPoint",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Boiling Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BoilingPoint",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BraggAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Bragg Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BraggAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Breadth",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("larghezza", "it"));
  quantityKind.addLabel(new LangString("genişliği", "tr"));
  quantityKind.addLabel(new LangString("lebar", "ms"));
  quantityKind.addLabel(new LangString("šířka", "cs"));
  quantityKind.addLabel(new LangString("breadth", "en"));
  quantityKind.addLabel(new LangString("العرض", "ar"));
  quantityKind.addLabel(new LangString("largeur", "fr"));
  quantityKind.addLabel(new LangString("largura", "pt"));
  quantityKind.addLabel(new LangString("szerokość", "pl"));
  quantityKind.addLabel(new LangString("ancho", "es"));
  quantityKind.addLabel(new LangString("寬度", "zh"));
  quantityKind.addLabel(new LangString("عرض", "fa"));
  quantityKind.addLabel(new LangString("širina", "sl"));
  quantityKind.addLabel(new LangString("ширина", "ru"));
  quantityKind.addLabel(new LangString("幅", "ja"));
  quantityKind.addLabel(new LangString("Breite", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Breadth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BucklingFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Buckling Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BucklingFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BulkModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Bulk Modulus", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BulkModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurgersVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("Burgers Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurgersVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurnRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Burn Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurnRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurnTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "t",
    undefined
  );
  quantityKind.addLabel(new LangString("Burn Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurnTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/BurstFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    "0173-1#Z4-BAJ434#001",
    undefined
  );
  quantityKind.addLabel(new LangString("burst factor", undefined));
  quantityKind.addLabel(new LangString("burst factor", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-M2-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/BurstFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ByteDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ435#004",
    undefined
  );
  quantityKind.addLabel(new LangString("byte data volume", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ByteDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ByteRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("byte rate", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ByteRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ByteTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ297#003",
    undefined
  );
  quantityKind.addLabel(new LangString("byte transmission rate", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ByteRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ByteTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_X",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the X axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_X",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Y axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Z axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-GRAVITY_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Center of Mass (CoM)", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PositionVector"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CENTER-OF-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CO2Equivalent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("CO2Equivalent", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Equivalent_Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CO2Equivalent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CONTRACT-END-ITEM-SPECIFICATION-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Contract End Item (CEI) Specification Mass.", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CONTRACT-END-ITEM-SPECIFICATION-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CONTROL-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Control Mass.", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CONTROL-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Canonical Partition Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Capacitance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T4D0",
    "C",
    undefined
  );
  quantityKind.addLabel(new LangString("Capacitance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliFARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoFARAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Capacitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Capacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "TBD",
    undefined
  );
  quantityKind.addLabel(new LangString("Capacity", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Capacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CarrierLifetime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Carrier LifetIme", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CarrierLifetime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CartesianArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Cartesian Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CartesianArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CartesianCoordinates",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "x, y, z",
    undefined
  );
  quantityKind.addLabel(new LangString("مختصات دکارتی", "fa"));
  quantityKind.addLabel(new LangString("kartezyen koordinatları", "tr"));
  quantityKind.addLabel(new LangString("kartesische Koordinaten", "de"));
  quantityKind.addLabel(new LangString("Koordiant Kartesius", "ms"));
  quantityKind.addLabel(new LangString("coordenadas cartesianas", "pt"));
  quantityKind.addLabel(new LangString("coordinate cartesiane", "it"));
  quantityKind.addLabel(new LangString("Cartesian coordinates", "en"));
  quantityKind.addLabel(new LangString("直角坐标系", "zh"));
  quantityKind.addLabel(new LangString("Kartézská soustava souřadnic", "cs"));
  quantityKind.addLabel(new LangString("coordonnées cartésiennes", "fr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CartesianCoordinates",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CartesianVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("volume", "it"));
  quantityKind.addLabel(new LangString("Isipadu", "ms"));
  quantityKind.addLabel(new LangString("Επιτάχυνση", "el"));
  quantityKind.addLabel(new LangString("volume", "fr"));
  quantityKind.addLabel(new LangString("volume", "en"));
  quantityKind.addLabel(new LangString("objętość", "pl"));
  quantityKind.addLabel(new LangString("Volumen", "de"));
  quantityKind.addLabel(new LangString("体積", "ja"));
  quantityKind.addLabel(new LangString("נפח", "he"));
  quantityKind.addLabel(new LangString("Объём", "ru"));
  quantityKind.addLabel(new LangString("حجم", "ar"));
  quantityKind.addLabel(new LangString("体积", "zh"));
  quantityKind.addLabel(new LangString("hacim", "tr"));
  quantityKind.addLabel(new LangString("आयतन", "hi"));
  quantityKind.addLabel(new LangString("Обем", "bg"));
  quantityKind.addLabel(new LangString("حجم", "fa"));
  quantityKind.addLabel(new LangString("prostornina", "sl"));
  quantityKind.addLabel(new LangString("volumen", "es"));
  quantityKind.addLabel(new LangString("Objem", "cs"));
  quantityKind.addLabel(new LangString("volume", "pt"));
  quantityKind.addLabel(new LangString("volum", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolume");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_UK_PET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TBSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FBM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Standard");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CartesianVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Catalytic Activity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL_LB-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL_LB-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ENZ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CatalyticActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Catalytic Activity Concentration", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoKAT-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KAT-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliKAT-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroKAT-PER-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ENZ-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KAT-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoKAT-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KAT-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-L-HR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CatalyticActivityConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CelsiusTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("teplota", "cs"));
  quantityKind.addLabel(new LangString("temperatura", "sl"));
  quantityKind.addLabel(new LangString("temperatura Celsius", "es"));
  quantityKind.addLabel(
    new LangString("درجة الحرارة المئوية أو السيلسيوس", "ar")
  );
  quantityKind.addLabel(new LangString("temperatura", "pl"));
  quantityKind.addLabel(new LangString("Температура Цельсия", "ru"));
  quantityKind.addLabel(new LangString("Celsius temperature", "en"));
  quantityKind.addLabel(new LangString("temperatură Celsius", "ro"));
  quantityKind.addLabel(new LangString("Suhu Celsius", "ms"));
  quantityKind.addLabel(new LangString("温度", "ja"));
  quantityKind.addLabel(new LangString("température Celsius", "fr"));
  quantityKind.addLabel(new LangString("सेल्सियस तापमान", "hi"));
  quantityKind.addLabel(new LangString("دمای سلسیوس/سانتیگراد", "fa"));
  quantityKind.addLabel(new LangString("צלזיוס", "he"));
  quantityKind.addLabel(new LangString("temperatura Celsius", "it"));
  quantityKind.addLabel(new LangString("温度", "zh"));
  quantityKind.addLabel(new LangString("Celsius-Temperatur", "de"));
  quantityKind.addLabel(new LangString("temperatura celsius", "pt"));
  quantityKind.addLabel(new LangString("Celsius sıcaklık", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CelsiusTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_X",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the X axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_X",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Y axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "cg",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Center of Gravity in the Z axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CenterOfGravity_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CharacteristicAcousticImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Characteristic Acoustic Impedance", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AcousticImpedance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CharacteristicAcousticImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CharacteristicNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ279#002",
    undefined
  );
  quantityKind.addLabel(new LangString("characteristic number", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CharacteristicNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CharacteristicVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Characteristic Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CharacteristicVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChargeNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "z",
    undefined
  );
  quantityKind.addLabel(new LangString("Charge Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChargeNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChemicalAffinity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Chemical Affinity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChemicalAffinity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChemicalConsumptionPerMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Chemical Consumption per Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChemicalConsumptionPerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ChemicalPotential",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("potencial químico", "pt"));
  quantityKind.addLabel(new LangString("potential chimique", "fr"));
  quantityKind.addLabel(new LangString("Химический потенциал", "ru"));
  quantityKind.addLabel(new LangString("Potențial chimic", "ro"));
  quantityKind.addLabel(new LangString("化学势", "zh"));
  quantityKind.addLabel(new LangString("potenziale chimico", "it"));
  quantityKind.addLabel(new LangString("جهد كيميائي", "ar"));
  quantityKind.addLabel(
    new LangString("chemisches Potential des Stoffs B", "de")
  );
  quantityKind.addLabel(new LangString("potencial químico", "es"));
  quantityKind.addLabel(new LangString("kimyasal potansiyel", "tr"));
  quantityKind.addLabel(new LangString("Potencjał chemiczny", "pl"));
  quantityKind.addLabel(new LangString("chemical potential", "en"));
  quantityKind.addLabel(new LangString("Chemický potenciál", "cs"));
  quantityKind.addLabel(new LangString("化学ポテンシャル", "ja"));
  quantityKind.addLabel(new LangString("پتانسیل شیمیایی", "fa"));
  quantityKind.addLabel(new LangString("Keupayaan kimia", "ms"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ChemicalPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Chromaticity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Chromaticity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Chromaticity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Circulation",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Circulation", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaPerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Circulation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ClosestApproachRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r_o",
    undefined
  );
  quantityKind.addLabel(new LangString("Closest Approach Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Radius"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ClosestApproachRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Coefficient of heat transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CoefficientOfPerformance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "COP",
    undefined
  );
  quantityKind.addLabel(new LangString("CoefficientOfPerformance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CoefficientOfPerformance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Coercivity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "H_{c,B}",
    undefined
  );
  quantityKind.addLabel(new LangString("Coercivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Coercivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CoherenceLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "ξ",
    undefined
  );
  quantityKind.addLabel(new LangString("Coherence Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CoherenceLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ColdReceptorThreshold",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Cold Receptor Threshold", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ColdReceptorThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    "h",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Combined Non Evaporative Heat Transfer Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CombinedNonEvaporativeHeatTransferCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CombustionChamberTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_c",
    undefined
  );
  quantityKind.addLabel(new LangString("Combustion Chamber Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CombustionChamberTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ComplexFrequency_Real",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("real part of complex frequency", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/failures-in-time"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ComplexFrequency_Real",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ComplexPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Complex Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV-A");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ComplexPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CompoundPlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Compound Plane Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PlaneAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CompoundPlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Compressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Compressibility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Compressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CompressibilityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Compressibility Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CompressibilityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Concentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Concentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Conductance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Conductance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MHO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Conductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConductionSpeed",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Conduction Speed", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Speed"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConductionSpeed",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConductiveHeatTransferRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Conductive Heat Transfer Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConductiveHeatTransferRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Conductivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Conductivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoS-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroS-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroS-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliS-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliS-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloS-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Conductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Constringence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Constringence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Constringence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ConvectiveHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Convective Heat Transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ConvectiveHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Correlated Color Temperature", "en-US")
  );
  quantityKind.addLabel(new LangString("Correlated Colour Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CorrelatedColorTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("cost per area", "en"));
  quantityKind.addLabel(new LangString("Kosten pro Fläche", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EUR-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energiekosten", "de"));
  quantityKind.addLabel(new LangString("energy cost", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EUR-PER-W-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/EUR-PER-KiloW-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EUR-PER-W-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kosten pro Masse", "de"));
  quantityKind.addLabel(new LangString("cost per mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CHF-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Anschaffungskosten pro Watt", "de"));
  quantityKind.addLabel(new LangString("cost per power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EUR-PER-KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EUR-PER-W");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerUnitEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energiekosten", "de"));
  quantityKind.addLabel(new LangString("energy cost", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerUnitEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CostPerUnitPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Anschaffungskosten pro Watt", "de"));
  quantityKind.addLabel(new LangString("cost per power", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CostPerUnitPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Count",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Count", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Count",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CountRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("CountRate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CountRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CouplingFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k",
    undefined
  );
  quantityKind.addLabel(new LangString("Çiftlenim sabiti", "tr"));
  quantityKind.addLabel(new LangString("結合定数", "ja"));
  quantityKind.addLabel(new LangString("constante de acoplamiento", "es"));
  quantityKind.addLabel(new LangString("耦合常數", "zh"));
  quantityKind.addLabel(new LangString("fattore di accoppiamento", "it"));
  quantityKind.addLabel(new LangString("Constantă de cuplaj", "ro"));
  quantityKind.addLabel(new LangString("Константа взаимодействия", "ru"));
  quantityKind.addLabel(new LangString("coupling factor", "en"));
  quantityKind.addLabel(new LangString("constante de couplage", "fr"));
  quantityKind.addLabel(new LangString("stała sprzężenia", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CouplingFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "σ",
    undefined
  );
  quantityKind.addLabel(new LangString("Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CrossSectionalArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Cross-sectional Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CrossSectionalArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CubicElectricDipoleMomentPerSquareEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E3L-3I0M-2H0T7D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Cubic Electric Dipole Moment per Square Energy", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CubicElectricDipoleMomentPerSquareEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CubicExpansionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("współczynnik rozszerzalności objętościowej", "pl")
  );
  quantityKind.addLabel(new LangString("cubic expansion coefficient", "en"));
  quantityKind.addLabel(
    new LangString("coefficient de dilatation volumique", "fr")
  );
  quantityKind.addLabel(
    new LangString("coeficiente de dilatación cúbica", "es")
  );
  quantityKind.addLabel(new LangString("Температурный коэффициент", "ru"));
  quantityKind.addLabel(new LangString("Hullámszám", "hu"));
  quantityKind.addLabel(new LangString("מספר גל", "he"));
  quantityKind.addLabel(new LangString("kübik genleşme katsayısı", "tr"));
  quantityKind.addLabel(new LangString("Κυματαριθμός", "el"));
  quantityKind.addLabel(new LangString("ضریب انبساط گرمایی", "fa"));
  quantityKind.addLabel(
    new LangString("coefficiente di dilatazione volumica", "it")
  );
  quantityKind.addLabel(new LangString("معامل التمدد الحجمى", "ar"));
  quantityKind.addLabel(new LangString("Вълново число", "bg"));
  quantityKind.addLabel(new LangString("体膨胀系数", "zh"));
  quantityKind.addLabel(new LangString("Volumenausdehnungskoeffizient", "de"));
  quantityKind.addLabel(
    new LangString("coeficiente de dilatação volúmica", "pt")
  );
  quantityKind.addLabel(new LangString("線膨張係数", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CubicExpansionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurieTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_C",
    undefined
  );
  quantityKind.addLabel(new LangString("نقطه کوری", "fa"));
  quantityKind.addLabel(new LangString("temperatura de Curie", "es"));
  quantityKind.addLabel(new LangString("Curie temperature", "en"));
  quantityKind.addLabel(new LangString("Curie sıcaklığı", "tr"));
  quantityKind.addLabel(new LangString("Curie-Temperatur", "de"));
  quantityKind.addLabel(new LangString("क्यूरी ताप", "hi"));
  quantityKind.addLabel(new LangString("temperatura Curie", "pl"));
  quantityKind.addLabel(new LangString("Punct Curie", "ro"));
  quantityKind.addLabel(new LangString("temperatura de Curie", "pt"));
  quantityKind.addLabel(new LangString("Suhu Curie", "ms"));
  quantityKind.addLabel(new LangString("درجة حرارة كوري", "ar"));
  quantityKind.addLabel(new LangString("Точка Кюри", "ru"));
  quantityKind.addLabel(new LangString("punto di Curie", "it"));
  quantityKind.addLabel(new LangString("Curieova teplota", "cs"));
  quantityKind.addLabel(new LangString("température de Curie", "fr"));
  quantityKind.addLabel(new LangString("キュリー温度", "ja"));
  quantityKind.addLabel(new LangString("居里点", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurieTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Currency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Currency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MKD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/USD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/COP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ISK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/JMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/PYG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/RUB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KWD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/PHP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LYD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BDT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MRU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CNY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/THB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/UZS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XPF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XPD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/IRR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/VES");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ZMW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MTL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CHE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/DJF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ALL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CHF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/HRK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LRD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XAG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XAF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LAK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KGS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SOS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/VUV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/USS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ETB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SGD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/USN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/PAB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/DZD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/COU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XFU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KMF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/DOP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/RSD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TWD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XFO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CUP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/IQD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SDG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BSD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SLE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/STN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MXV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ZAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ARS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/QAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ERN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MZN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GNF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BTN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/UAH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KES");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SEK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/OMR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/PGK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/AZN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TOP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CVE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/UYU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GEL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XOF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/FKP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XDR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MWK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BIF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/HUF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GBP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SBD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/PLN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/AOA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/JPY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MNT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KRW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/NPR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/AWG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/INR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/AFN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MVR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/HNL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/UGX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CLP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BBD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GTQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CDF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LVL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SCR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MXN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/FJD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BRL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CLF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TMT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/NZD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/WST");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/PEN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/NIO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SKK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/NAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BAM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/EGP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MOP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MegaUSD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BZD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/DKK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LSL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/EUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/AED");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/HKD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/RWF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/JOD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TJS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CYP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LBP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XBD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BWP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SHP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/AMD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XBB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XBC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KYD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/IDR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XBA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BOB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KHR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CHW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GHS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GYD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KPW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/AUD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ILS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/VND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XAU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TZS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/YER");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LTL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/TTD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/KZT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SRD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SZL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BHD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ANG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/HTG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/XCD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/PKR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CRC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/CZK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/NGN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/LKR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/RON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/GIP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/ZWL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/NOK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/SYP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/EEK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/MMK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BGN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/currency/BOV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Asset"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Currency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Currency Per Flight", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaDOLLAR_US-PER-FLIGHT"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurrencyPerFlight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurrentLinkage",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Current Linkage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurrentLinkage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurrentOfTheAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ384#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("current of the amount of substance", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurrentOfTheAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurrentOfTheAmountOfSubtance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ384#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("current of the amount of subtance", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurrentOfTheAmountOfSubtance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Curvature",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Curvature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DIOPTER");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Curvature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Curvature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CurvatureFromRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CutoffCurrentRating",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ325#003",
    undefined
  );
  quantityKind.addLabel(new LangString("I²t-value", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CutoffCurrentRating",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/CyclotronAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Larmor Angular Frequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/CyclotronAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DELTA-V",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Delta-V", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DELTA-V",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DRY-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dry Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DRY-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DataRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Data Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBYTE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PetaBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ExaBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraBIT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBIT-PER-SEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DataRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DataTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("data transmission rate", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DataTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DatasetOfBits",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dataset of bits", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCTET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBIT");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DatasetOfBits",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DatasetOfBytes",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dataset of bytes", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DatasetOfBytes",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Debye-WallerFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "D, B",
    undefined
  );
  quantityKind.addLabel(new LangString("Debye-Waller Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Debye-WallerFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DebyeAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Debye Angular Frequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DebyeAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "q_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Debye Angular Wavenumber", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DebyeAngularWavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DebyeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Debye Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DebyeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DecayConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Decay Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCi");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DecayConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DegreeOfDissociation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Degree of Dissociation", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DegreeOfDissociation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Density",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MassDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Density",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DensityInCombustionChamber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Density In Combustion Chamber", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DensityInCombustionChamber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DensityOfStates",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Density of states", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SEC-PER-RAD-M3"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DensityOfStates",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DensityOfTheExhaustGases",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Density Of The Exhaust Gases", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Density"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DensityOfTheExhaustGases",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Depth",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Depth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Depth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DewPointTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Dew Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DewPointTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Diameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("直径", "ja"));
  quantityKind.addLabel(new LangString("çap", "tr"));
  quantityKind.addLabel(new LangString("diameter", "en"));
  quantityKind.addLabel(new LangString("diámetro", "es"));
  quantityKind.addLabel(new LangString("قطر", "ar"));
  quantityKind.addLabel(new LangString("premer", "sl"));
  quantityKind.addLabel(new LangString("диаметр", "ru"));
  quantityKind.addLabel(new LangString("średnica", "pl"));
  quantityKind.addLabel(new LangString("قطر", "fa"));
  quantityKind.addLabel(new LangString("Durchmesser", "de"));
  quantityKind.addLabel(new LangString("průměr", "cs"));
  quantityKind.addLabel(new LangString("diamètre", "fr"));
  quantityKind.addLabel(new LangString("diâmetro", "pt"));
  quantityKind.addLabel(new LangString("直径", "zh"));
  quantityKind.addLabel(new LangString("diametro", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Diameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiastolicBloodPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Diastolic Blood Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiastolicBloodPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "L^2",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusion Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusionskoeffizient", "de"));
  quantityKind.addLabel(new LangString("coeficiente de difusión", "es"));
  quantityKind.addLabel(new LangString("coefficiente di diffusione", "it"));
  quantityKind.addLabel(new LangString("coefficient de diffusion", "fr"));
  quantityKind.addLabel(new LangString("coeficiente de difusão", "pt"));
  quantityKind.addLabel(new LangString("difuzijski koeficient", "sl"));
  quantityKind.addLabel(new LangString("diffusion coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficientForFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "Dᵩ",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Diffusion Coefficient for Fluence Rate", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionCoefficientForFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DiffusionLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusion Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DiffusionLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DigitRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("digit rate", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAUD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAUD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAUD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DigitRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Dimensionless",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Dimensionless", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Dimensionless",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dimensionless Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Displacement",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Displacement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "I_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement Current Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DisplacementCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DisplacementVectorOfIon",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Displacement Vector of Ion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DisplacementVectorOfIon",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Dissipance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dissipance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Dissipance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Distance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Jarak", "ms"));
  quantityKind.addLabel(new LangString("Vzdálenost", "cs"));
  quantityKind.addLabel(new LangString("distanza", "it"));
  quantityKind.addLabel(new LangString("距离", "zh"));
  quantityKind.addLabel(new LangString("distância", "pt"));
  quantityKind.addLabel(new LangString("Entfernung", "de"));
  quantityKind.addLabel(new LangString("distance", "en"));
  quantityKind.addLabel(new LangString("مسافت", "fa"));
  quantityKind.addLabel(new LangString("distance", "fr"));
  quantityKind.addLabel(new LangString("distancia", "es"));
  quantityKind.addLabel(new LangString("uzaklık", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT_BIG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Distance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DistanceTraveledDuringBurn",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "s",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Distance Traveled During a Burn", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT_BIG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Distance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DistanceTraveledDuringBurn",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DonorDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Donor Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DonorDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DonorIonizationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Donor Ionization Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DonorIonizationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DoseEquivalent",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Dose Equivalent", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliR_man");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R_man");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DoseEquivalent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentQualityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Dose Equivalent Quality Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentQualityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dose equivalent rate", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DoseEquivalentRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DotsPerInch",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("dots per inch", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DPI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MESH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-ANGSTROM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DotsPerInch",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DragCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "C_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Drag Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DragCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DragForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "D or F_D",
    undefined
  );
  quantityKind.addLabel(new LangString("Drag Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DragForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DryVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dry Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CORD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_US_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DryVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Duv",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Delta u,v", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Duv",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicFriction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dynamic Friction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Friction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicFriction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicFrictionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Dynamic Friction Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicFrictionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Dynamic Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("श्यानता", "hi"));
  quantityKind.addLabel(new LangString("viscosidad dinámica", "es"));
  quantityKind.addLabel(new LangString("lepkość dynamiczna", "pl"));
  quantityKind.addLabel(new LangString("dynamische Viskosität", "de"));
  quantityKind.addLabel(new LangString("لزوجة", "ar"));
  quantityKind.addLabel(new LangString("viscosidade dinâmica", "pt"));
  quantityKind.addLabel(new LangString("Viscozitate dinamică", "ro"));
  quantityKind.addLabel(new LangString("dinamična viskoznost", "sl"));
  quantityKind.addLabel(new LangString("viskozita", "cs"));
  quantityKind.addLabel(new LangString("Kelikatan dinamik", "ms"));
  quantityKind.addLabel(
    new LangString("گرانروی دینامیکی/ویسکوزیته دینامیکی", "fa")
  );
  quantityKind.addLabel(new LangString("viscosità dinamica", "it"));
  quantityKind.addLabel(new LangString("粘度", "ja"));
  quantityKind.addLabel(new LangString("динамическую вязкость", "ru"));
  quantityKind.addLabel(new LangString("dynamic viscosity", "en"));
  quantityKind.addLabel(new LangString("动力粘度", "zh"));
  quantityKind.addLabel(new LangString("viscosité dynamique", "fr"));
  quantityKind.addLabel(new LangString("dinamik akmazlık", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SLUG-PER-FT-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPOISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-DAY");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Viscosity");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EarthClosestApproachVehicleVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_o",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Earth Closest Approach Vehicle Velocity", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EarthClosestApproachVehicleVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EarthquakeMagnitude",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("earthquake magnitude", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/RichterMagnitude"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EarthquakeMagnitude",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EccentricityOfOrbit",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Eccentricity Of Orbit", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EccentricityOfOrbit",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EffectiveExhaustVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v_{e}",
    undefined
  );
  quantityKind.addLabel(new LangString("Effective Exhaustvelocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EffectiveExhaustVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EffectiveMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m^*",
    undefined
  );
  quantityKind.addLabel(new LangString("Effective Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EffectiveMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EffectiveMultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k_{eff}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Effective Multiplication Factor", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EffectiveMultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Efficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("eficiência", "pt"));
  quantityKind.addLabel(new LangString("Wirkungsgrad", "de"));
  quantityKind.addLabel(new LangString("sprawność", "pl"));
  quantityKind.addLabel(new LangString("efficiency", "en"));
  quantityKind.addLabel(new LangString("efficienza", "it"));
  quantityKind.addLabel(new LangString("效率", "zh"));
  quantityKind.addLabel(new LangString("كفاءة", "ar"));
  quantityKind.addLabel(new LangString("rendimiento", "es"));
  quantityKind.addLabel(new LangString("効率", "ja"));
  quantityKind.addLabel(new LangString("rendement", "fr"));
  quantityKind.addLabel(new LangString("коэффициент полезного действия", "ru"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Efficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EinsteinCoefficients",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Einstein coefficients", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SEC-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EinsteinCoefficients",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_jkN_j",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Einstein Transition Probability", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    "0173-1#Z4-BAJ456#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "Einstein transition probability for spontaneous or induced emission and absorption",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("ładunek elektryczny", "pl"));
  quantityKind.addLabel(new LangString("Ηλεκτρικό φορτίο", "el"));
  quantityKind.addLabel(new LangString("Электрический заряд", "ru"));
  quantityKind.addLabel(new LangString("carica elettrica", "it"));
  quantityKind.addLabel(new LangString("Elektrický náboj", "cs"));
  quantityKind.addLabel(new LangString("Cas elektrik", "ms"));
  quantityKind.addLabel(new LangString("विद्युत आवेग या विद्युत बहाव", "hi"));
  quantityKind.addLabel(new LangString("电荷", "zh"));
  quantityKind.addLabel(new LangString("carga elétrica", "pt"));
  quantityKind.addLabel(new LangString("električni naboj", "sl"));
  quantityKind.addLabel(new LangString("onus electricum", "la"));
  quantityKind.addLabel(new LangString("elektrische Ladung", "de"));
  quantityKind.addLabel(new LangString("Charge électrique", "fr"));
  quantityKind.addLabel(new LangString("sarcină electrică", "ro"));
  quantityKind.addLabel(new LangString("carga eléctrica", "es"));
  quantityKind.addLabel(new LangString("מטען חשמלי", "he"));
  quantityKind.addLabel(new LangString("electric charge", "en"));
  quantityKind.addLabel(new LangString("電荷", "ja"));
  quantityKind.addLabel(new LangString("بار الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("elektrik yükü", "tr"));
  quantityKind.addLabel(new LangString("الشحنة الكهربائية", "ar"));
  quantityKind.addLabel(new LangString("elektromos töltés", "hu"));
  quantityKind.addLabel(new LangString("Електрически заряд", "bg"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCharge");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZettaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YottaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YoctoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZeptoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ElementaryCharge"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLineDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Line Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLineDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLinearDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Linear Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeLinearDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A-1E1L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric charge per amount of substance", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric charge per area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Per Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliC-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-T-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-M2-PER-J-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Charge Surface Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeSurfaceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Charge Volume Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricChargeVolumeDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("电导率", "zh"));
  quantityKind.addLabel(new LangString("condutividade elétrica", "pt"));
  quantityKind.addLabel(new LangString("conductivité électrique", "fr"));
  quantityKind.addLabel(new LangString("elektrische Leitfähigkeit", "de"));
  quantityKind.addLabel(new LangString("conductividad eléctrica", "es"));
  quantityKind.addLabel(new LangString("conducibilità elettrica", "it"));
  quantityKind.addLabel(new LangString("električna prevodnost", "sl"));
  quantityKind.addLabel(new LangString("electric conductivity", "en"));
  quantityKind.addLabel(new LangString("elektrik iletkenliği", "tr"));
  quantityKind.addLabel(
    new LangString("رسانايى الکتريکى/هدایت الکتریکی", "fa")
  );
  quantityKind.addLabel(new LangString("Kekonduksian elektrik", "ms"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MHO_Stat");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("corrente elettrica", "it"));
  quantityKind.addLabel(new LangString("corrente elétrica", "pt"));
  quantityKind.addLabel(new LangString("elektrische Stromstärke", "de"));
  quantityKind.addLabel(new LangString("تيار كهربائي", "ar"));
  quantityKind.addLabel(
    new LangString("intensité de courant électrique", "fr")
  );
  quantityKind.addLabel(new LangString("elektromos áramerősség", "hu"));
  quantityKind.addLabel(new LangString("Електрически ток", "bg"));
  quantityKind.addLabel(new LangString("电流", "zh"));
  quantityKind.addLabel(new LangString("curent electric", "ro"));
  quantityKind.addLabel(new LangString("električni tok", "sl"));
  quantityKind.addLabel(new LangString("Сила электрического тока", "ru"));
  quantityKind.addLabel(new LangString("Arus elektrik", "ms"));
  quantityKind.addLabel(new LangString("fluxio electrica", "la"));
  quantityKind.addLabel(new LangString("elektrik akımı", "tr"));
  quantityKind.addLabel(new LangString("Ένταση ηλεκτρικού ρεύματος", "el"));
  quantityKind.addLabel(new LangString("विद्युत धारा", "hi"));
  quantityKind.addLabel(new LangString("電流", "ja"));
  quantityKind.addLabel(new LangString("זרם חשמלי", "he"));
  quantityKind.addLabel(new LangString("Elektrický proud", "cs"));
  quantityKind.addLabel(new LangString("electric current", "en"));
  quantityKind.addLabel(new LangString("جریان الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("prąd elektryczny", "pl"));
  quantityKind.addLabel(new LangString("corriente eléctrica", "es"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCurrent");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Ketumpatan arus elektrik", "ms"));
  quantityKind.addLabel(new LangString("densidad de corriente", "es"));
  quantityKind.addLabel(new LangString("چگالی جریان الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("плотность тока", "ru"));
  quantityKind.addLabel(new LangString("كثافة التيار", "ar"));
  quantityKind.addLabel(new LangString("electric current density", "en"));
  quantityKind.addLabel(new LangString("धारा घनत्व", "hi"));
  quantityKind.addLabel(new LangString("Gęstość prądu elektrycznego", "pl"));
  quantityKind.addLabel(new LangString("densidade de corrente elétrica", "pt"));
  quantityKind.addLabel(new LangString("elektrische Stromdichte", "de"));
  quantityKind.addLabel(new LangString("densité de courant", "fr"));
  quantityKind.addLabel(new LangString("Akım yoğunluğu", "tr"));
  quantityKind.addLabel(new LangString("电流密度", "zh"));
  quantityKind.addLabel(new LangString("電流密度", "ja"));
  quantityKind.addLabel(new LangString("Densitate de curent", "ro"));
  quantityKind.addLabel(new LangString("densità di corrente elettrica", "it"));
  quantityKind.addLabel(new LangString("gostota električnega toka", "sl"));
  quantityKind.addLabel(new LangString("Hustota elektrického proudu", "cs"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaA-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckCurrentDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current per Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-J");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current per Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Current per Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoA-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerUnitEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Current per Unit Energy", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerUnitEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerUnitLength",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Current per Unit Length", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerUnitLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerUnitTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Current per Unit Temperature", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerUnitTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Current Phasor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPhasor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L1I0M0H0T1D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("momento di dipolo elettrico", "it"));
  quantityKind.addLabel(new LangString("Dipólový moment", "cs"));
  quantityKind.addLabel(new LangString("moment dipolaire", "fr"));
  quantityKind.addLabel(new LangString("momento de dipolo eléctrico", "es"));
  quantityKind.addLabel(new LangString("momento do dipolo elétrico", "pt"));
  quantityKind.addLabel(new LangString("电偶极矩", "zh"));
  quantityKind.addLabel(new LangString("moment electric dipolar", "ro"));
  quantityKind.addLabel(new LangString("elektryczny moment dipolowy", "pl"));
  quantityKind.addLabel(new LangString("विद्युत द्विध्रुव आघूर्ण", "hi"));
  quantityKind.addLabel(new LangString("electric dipole moment", "en"));
  quantityKind.addLabel(new LangString("گشتاور دوقطبی الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("電気双極子", "ja"));
  quantityKind.addLabel(new LangString("Momen dwikutub elektrik", "ms"));
  quantityKind.addLabel(new LangString("elektrik dipol momenti", "tr"));
  quantityKind.addLabel(new LangString("elektrisches Dipolmoment", "de"));
  quantityKind.addLabel(new LangString("عزم ثنائي قطب", "ar"));
  quantityKind.addLabel(new LangString("Электрический дипольный момент", "ru"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Debye");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_CubicPerEnergy_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E3L-3I0M-2H0T7D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Cubic Electric Dipole Moment per Square Energy", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C3-M-PER-J2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_CubicPerEnergy_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_QuarticPerEnergy_Cubic",
    "http://qudt.org/vocab/dimensionvector/A0E4L-2I0M-3H0T10D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Quartic Electric Dipole Moment per Cubic Energy", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C4-M4-PER-J3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDipoleMoment_QuarticPerEnergy_Cubic",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacement",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Displacement", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacementField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Displacement Field", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacementField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricField",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Field", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("विद्युत्-क्षेत्र", "hi"));
  quantityKind.addLabel(new LangString("電界強度", "ja"));
  quantityKind.addLabel(new LangString("intensidade de campo elétrico", "pt"));
  quantityKind.addLabel(new LangString("שדה חשמלי", "he"));
  quantityKind.addLabel(new LangString("elektrische Feldstärke", "de"));
  quantityKind.addLabel(new LangString("Електрично поле", "bg"));
  quantityKind.addLabel(new LangString("jakost električnega polja", "sl"));
  quantityKind.addLabel(new LangString("intensità di campo elettrico", "it"));
  quantityKind.addLabel(new LangString("Kekuatan medan elektrik", "ms"));
  quantityKind.addLabel(new LangString("elektrické pole", "cs"));
  quantityKind.addLabel(new LangString("câmp electric", "ro"));
  quantityKind.addLabel(new LangString("elektriksel alan kuvveti", "tr"));
  quantityKind.addLabel(
    new LangString("Напряженность электрического поля", "ru")
  );
  quantityKind.addLabel(new LangString("natężenie pola elektrycznego", "pl"));
  quantityKind.addLabel(new LangString("intensidad de campo eléctrico", "es"));
  quantityKind.addLabel(new LangString("شدت میدان الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("Ηλεκτρικό πεδίο", "el"));
  quantityKind.addLabel(new LangString("電場", "zh"));
  quantityKind.addLabel(new LangString("electric field strength", "en"));
  quantityKind.addLabel(new LangString("intensité de champ électrique", "fr"));
  quantityKind.addLabel(new LangString("Elektromos mező", "hu"));
  quantityKind.addLabel(new LangString("شدة المجال الكهربائي", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-MilliM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricFlux",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electric Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat-CentiM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("چگالی شار الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("spostamento elettrico", "it"));
  quantityKind.addLabel(new LangString("Inducție electrică", "ro"));
  quantityKind.addLabel(new LangString("elektrik akı yoğunluğu", "tr"));
  quantityKind.addLabel(new LangString("Ketumpatan fluks elektrik", "ms"));
  quantityKind.addLabel(new LangString("Elektrická indukce", "cs"));
  quantityKind.addLabel(new LangString("Indukcja elektryczna", "pl"));
  quantityKind.addLabel(new LangString("elektrische Flussdichte", "de"));
  quantityKind.addLabel(new LangString("電束密度", "ja"));
  quantityKind.addLabel(new LangString("electric flux density", "en"));
  quantityKind.addLabel(new LangString("Induction électrique", "fr"));
  quantityKind.addLabel(new LangString("campo de deslocamento elétrico", "pt"));
  quantityKind.addLabel(new LangString("Электрическая индукция", "ru"));
  quantityKind.addLabel(new LangString("إزاحة كهربائية", "ar"));
  quantityKind.addLabel(new LangString("Densidad de flujo eléctrico", "es"));
  quantityKind.addLabel(new LangString("電位移", "zh"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricDisplacement"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPolarizability",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("polarizzabilità elettrica", "it"));
  quantityKind.addLabel(new LangString("قابلية استقطاب", "ar"));
  quantityKind.addLabel(new LangString("分極率", "ja"));
  quantityKind.addLabel(new LangString("قطبیت پذیری الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("polarizabilidade", "pt"));
  quantityKind.addLabel(new LangString("Polarizovatelnost", "cs"));
  quantityKind.addLabel(new LangString("Kepengkutuban elektrik", "ms"));
  quantityKind.addLabel(new LangString("electric polarizability", "en"));
  quantityKind.addLabel(new LangString("Polarisabilité", "fr"));
  quantityKind.addLabel(new LangString("elektrische Polarisierbarkeit", "de"));
  quantityKind.addLabel(new LangString("Поляризуемость", "ru"));
  quantityKind.addLabel(new LangString("Polaryzowalność", "pl"));
  quantityKind.addLabel(new LangString("Polarizabilidad", "es"));
  quantityKind.addLabel(new LangString("極化性", "zh"));
  quantityKind.addLabel(new LangString("Kutuplanabilirlik", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPolarizability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("polarização eléctrica", "pt"));
  quantityKind.addLabel(new LangString("電気分極", "ja"));
  quantityKind.addLabel(new LangString("polarizzazione elettrica", "it"));
  quantityKind.addLabel(new LangString("polarización eléctrica", "es"));
  quantityKind.addLabel(new LangString("إستقطاب كهربائي", "ar"));
  quantityKind.addLabel(new LangString("elektrische Polarisation", "de"));
  quantityKind.addLabel(new LangString("polarisation électrique", "fr"));
  quantityKind.addLabel(new LangString("polaryzacja elektryczna", "pl"));
  quantityKind.addLabel(new LangString("электрическая поляризация", "ru"));
  quantityKind.addLabel(new LangString("electric polarization", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPotential",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V_{ab}",
    undefined
  );
  quantityKind.addLabel(new LangString("電位", "ja"));
  quantityKind.addLabel(new LangString("電勢", "zh"));
  quantityKind.addLabel(new LangString("potentiel électrique", "fr"));
  quantityKind.addLabel(new LangString("электростатический потенциал", "ru"));
  quantityKind.addLabel(new LangString("كمون كهربائي", "ar"));
  quantityKind.addLabel(new LangString("elektrik potansiyeli", "tr"));
  quantityKind.addLabel(new LangString("električni potencial", "sl"));
  quantityKind.addLabel(new LangString("electric potential", "en"));
  quantityKind.addLabel(new LangString("Keupayaan elektrik", "ms"));
  quantityKind.addLabel(new LangString("potencial elétrico", "pt"));
  quantityKind.addLabel(new LangString("Електрически потенциал", "bg"));
  quantityKind.addLabel(new LangString("elektrický potenciál", "cs"));
  quantityKind.addLabel(new LangString("elektrisches Potenzial", "de"));
  quantityKind.addLabel(
    new LangString(
      "elektromos feszültség , elektromos potenciálkülönbség",
      "hu"
    )
  );
  quantityKind.addLabel(new LangString("potencjał elektryczny", "pl"));
  quantityKind.addLabel(new LangString("potențial electric", "ro"));
  quantityKind.addLabel(new LangString("विद्युत विभव", "hi"));
  quantityKind.addLabel(new LangString("potenziale elettrico", "it"));
  quantityKind.addLabel(new LangString("מתח חשמלי (הפרש פוטנציאלים)", "he"));
  quantityKind.addLabel(new LangString("potencial eléctrico", "es"));
  quantityKind.addLabel(new LangString("tensio electrica", "la"));
  quantityKind.addLabel(new LangString("پتانسیل الکتریکی", "fa"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Voltage");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V",
    undefined
  );
  quantityKind.addLabel(
    new LangString("differenza di potenziale elettrico", "it")
  );
  quantityKind.addLabel(new LangString("विभवांतर", "hi"));
  quantityKind.addLabel(new LangString("tensión eléctrica", "es"));
  quantityKind.addLabel(new LangString("электрическое напряжение", "ru"));
  quantityKind.addLabel(new LangString("electric potential difference", "en"));
  quantityKind.addLabel(new LangString("جهد كهربائي", "ar"));
  quantityKind.addLabel(new LangString("elektrische Spannung", "de"));
  quantityKind.addLabel(new LangString("napięcie elektryczne", "pl"));
  quantityKind.addLabel(new LangString("ولتاژ/ اختلاف پتانسیل", "fa"));
  quantityKind.addLabel(
    new LangString("Voltan Perbezaan keupayaan elektrik", "ms")
  );
  quantityKind.addLabel(new LangString("電圧", "ja"));
  quantityKind.addLabel(new LangString("električna napetost", "sl"));
  quantityKind.addLabel(
    new LangString("tensão elétrica (diferença de potencial)", "pt")
  );
  quantityKind.addLabel(new LangString("gerilim", "tr"));
  quantityKind.addLabel(new LangString("電壓", "zh"));
  quantityKind.addLabel(new LangString("tension électrique", "fr"));
  quantityKind.addLabel(
    new LangString("diferență de potențial electric", "ro")
  );
  quantityKind.addLabel(new LangString("elektrické napětí", "cs"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Voltage");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P_E",
    undefined
  );
  quantityKind.addLabel(new LangString("Wirkleistung", "de"));
  quantityKind.addLabel(new LangString("puissance active", "fr"));
  quantityKind.addLabel(new LangString("electric power", "en"));
  quantityKind.addLabel(new LangString("potência activa", "pt"));
  quantityKind.addLabel(new LangString("potencia activa", "es"));
  quantityKind.addLabel(new LangString("moc czynna", "pl"));
  quantityKind.addLabel(new LangString("有効電力", "ja"));
  quantityKind.addLabel(new LangString("potenza attiva", "it"));
  quantityKind.addLabel(new LangString("有功功率", "zh"));
  quantityKind.addLabel(new LangString("القدرة الفعالة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricPropulsionPropellantMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_P",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electric Propulsion Propellant Mass", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropellantMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricPropulsionPropellantMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricQuadrupoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T1D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(
    new LangString("elektryczny moment kwadrupolowy", "pl")
  );
  quantityKind.addLabel(
    new LangString("moment quadrupolaire électrique", "fr")
  );
  quantityKind.addLabel(new LangString("momento de quadrupolo elétrico", "pt"));
  quantityKind.addLabel(new LangString("elektrisches Quadrupolmoment", "de"));
  quantityKind.addLabel(new LangString("electric quadrupole moment", "en"));
  quantityKind.addLabel(
    new LangString("momento de cuadrupolo eléctrico", "es")
  );
  quantityKind.addLabel(
    new LangString("Электрический квадрупольный момент", "ru")
  );
  quantityKind.addLabel(new LangString("四極子", "ja"));
  quantityKind.addLabel(new LangString("电四极矩", "zh"));
  quantityKind.addLabel(new LangString("Momen kuadrupol elektrik", "ms"));
  quantityKind.addLabel(
    new LangString("momento di quadrupolo elettrico", "it")
  );
  quantityKind.addLabel(new LangString("گشتاور چهار قطبی الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("elektrik kuadrupol momenti", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricQuadrupoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricSusceptibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("podatność elektryczna", "pl"));
  quantityKind.addLabel(new LangString("susceptibilidad eléctrica", "es"));
  quantityKind.addLabel(
    new LangString("المتأثرية الكهربائية، سرعة التأثر الكهربائية", "ar")
  );
  quantityKind.addLabel(new LangString("электрическая восприимчивость", "ru"));
  quantityKind.addLabel(new LangString("susceptibilidade eléctrica", "pt"));
  quantityKind.addLabel(new LangString("electric susceptibility", "en"));
  quantityKind.addLabel(new LangString("elektrische Suszeptibilität", "de"));
  quantityKind.addLabel(new LangString("suscettività elettrica", "it"));
  quantityKind.addLabel(new LangString("susceptibilité électrique", "fr"));
  quantityKind.addLabel(new LangString("電気感受率", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricSusceptibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricalConductance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "0173-1#Z4-BAJ223#002",
    undefined
  );
  quantityKind.addLabel(new LangString("electrical conductance", undefined));
  quantityKind.addLabel(new LangString("electrical conductance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricalConductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricalPowerToMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Electrical Power To Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricalPowerToMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectricalResistance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "0173-1#Z4-BAJ215#003",
    undefined
  );
  quantityKind.addLabel(new LangString("electrical resistance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoOHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectricalResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectrolyticConductivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T3D0",
    "x",
    undefined
  );
  quantityKind.addLabel(new LangString("Electrolytic Conductivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectrolyticConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "w",
    undefined
  );
  quantityKind.addLabel(new LangString("Electromagnetic Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/H_Stat-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH-PER-M");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/Permeability"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeabilityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electromagnetic Permeability Ratio", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMEABILITY_EM_REL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeabilityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Electromagnetic Wave Phase Speed", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromagneticWavePhaseSpeed",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectromotiveForce",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("electromotive force", "en"));
  quantityKind.addLabel(new LangString("forza elettromotrice", "it"));
  quantityKind.addLabel(new LangString("विद्युतवाहक बल", "hi"));
  quantityKind.addLabel(new LangString("電動勢", "zh"));
  quantityKind.addLabel(new LangString("força eletromotriz", "pt"));
  quantityKind.addLabel(new LangString("Daya gerak elektrik", "ms"));
  quantityKind.addLabel(new LangString("force électromotrice", "fr"));
  quantityKind.addLabel(new LangString("قوة محركة كهربائية", "ar"));
  quantityKind.addLabel(new LangString("起電力", "ja"));
  quantityKind.addLabel(new LangString("электродвижущая сила", "ru"));
  quantityKind.addLabel(new LangString("elektromotorna sila", "sl"));
  quantityKind.addLabel(new LangString("siła elektromotoryczna", "pl"));
  quantityKind.addLabel(new LangString("Elektromotor kuvvet", "tr"));
  quantityKind.addLabel(new LangString("Elektromotorické napětí", "cs"));
  quantityKind.addLabel(new LangString("fuerza electromotriz", "es"));
  quantityKind.addLabel(new LangString("نیروی محرک الکتریکی", "fa"));
  quantityKind.addLabel(new LangString("forță electromotoare", "ro"));
  quantityKind.addLabel(new LangString("elektromotorische Kraft", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectromotiveForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronAffinity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "χ",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Affinity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronAffinity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronMeanFreePath",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "l_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Mean Free Path", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronMeanFreePath",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronMobility",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("electron mobility", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-V-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-V-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mobility"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronMobility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElectronRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Electron Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElectronRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ElevationRelativeToNAP",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "mNAP",
    undefined
  );
  quantityKind.addLabel(new LangString("Elevation relative to NAP", "en"));
  quantityKind.addLabel(new LangString("Hoogte ten opzichte van NAP", "nl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Altitude"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ElevationRelativeToNAP",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitApogeeVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_a",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Elliptical Orbit Apogee Velocity", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitApogeeVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitPerigeeVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Elliptical Orbit Perigee Velocity", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EllipticalOrbitPerigeeVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Emissivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Emissivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Emissivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Energy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("energia", "pl"));
  quantityKind.addLabel(new LangString("انرژی", "fa"));
  quantityKind.addLabel(new LangString("energie", "ro"));
  quantityKind.addLabel(new LangString("enerji", "tr"));
  quantityKind.addLabel(new LangString("energia", "pt"));
  quantityKind.addLabel(new LangString("能量", "zh"));
  quantityKind.addLabel(new LangString("Tenaga", "ms"));
  quantityKind.addLabel(new LangString("Енергия", "bg"));
  quantityKind.addLabel(new LangString("Energie", "cs"));
  quantityKind.addLabel(new LangString("energy", "en"));
  quantityKind.addLabel(new LangString("Έργο - Ενέργεια", "el"));
  quantityKind.addLabel(new LangString("energija", "sl"));
  quantityKind.addLabel(new LangString("energia", "es"));
  quantityKind.addLabel(new LangString("الطاقة", "ar"));
  quantityKind.addLabel(new LangString("エネルギー", "ja"));
  quantityKind.addLabel(new LangString("énergie", "fr"));
  quantityKind.addLabel(new LangString("Энергия", "ru"));
  quantityKind.addLabel(new LangString("energia", "it"));
  quantityKind.addLabel(new LangString("energia", "la"));
  quantityKind.addLabel(new LangString("ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("Energie", "de"));
  quantityKind.addLabel(new LangString("energia , munka , hő", "hu"));
  quantityKind.addLabel(new LangString("אנרגיה ועבודה", "he"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Energy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyContent",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ319#002",
    undefined
  );
  quantityKind.addLabel(new LangString("energy content", undefined));
  quantityKind.addLabel(new LangString("energy content", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyContent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates",
    "http://qudt.org/vocab/dimensionvector/A0E0L-5I0M-1H0T2D0",
    "n_E",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Density of States", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-EV-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-J-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyDensityOfStates",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyExpenditure",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Expenditure", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyExpenditure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyFluence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Fluence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyFluence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "Ψ",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Fluence Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyImparted",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "ε",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Imparted", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyImparted",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyInternal",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("energia interna", "it"));
  quantityKind.addLabel(new LangString("vnitřní energie", "cs"));
  quantityKind.addLabel(new LangString("Tenaga dalaman", "ms"));
  quantityKind.addLabel(new LangString("İç enerji", "tr"));
  quantityKind.addLabel(new LangString("internal energy", "en"));
  quantityKind.addLabel(new LangString("आन्तरिक ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("Notranja energija", "sl"));
  quantityKind.addLabel(new LangString("طاقة داخلية", "ar"));
  quantityKind.addLabel(new LangString("انرژی درونی", "fa"));
  quantityKind.addLabel(new LangString("内能", "zh"));
  quantityKind.addLabel(new LangString("energia wewnętrzna", "pl"));
  quantityKind.addLabel(new LangString("内部エネルギー", "ja"));
  quantityKind.addLabel(new LangString("energía interna", "es"));
  quantityKind.addLabel(new LangString("innere Energie", "de"));
  quantityKind.addLabel(new LangString("внутренняя энергия", "ru"));
  quantityKind.addLabel(new LangString("energia interna", "pt"));
  quantityKind.addLabel(new LangString("énergie interne", "fr"));
  quantityKind.addLabel(new LangString("energie internă", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/InternalEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyInternal",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyKinetic",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Tenaga kinetik", "ms"));
  quantityKind.addLabel(new LangString("انرژی جنبشی", "fa"));
  quantityKind.addLabel(new LangString("طاقة حركية", "ar"));
  quantityKind.addLabel(new LangString("energia cinética", "pt"));
  quantityKind.addLabel(new LangString("kinetic energy", "en"));
  quantityKind.addLabel(new LangString("energia kinetyczna", "pl"));
  quantityKind.addLabel(new LangString("kinetická energie", "cs"));
  quantityKind.addLabel(new LangString("Energie cinetică", "ro"));
  quantityKind.addLabel(new LangString("गतिज ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("énergie cinétique", "fr"));
  quantityKind.addLabel(new LangString("кинетическая энергия", "ru"));
  quantityKind.addLabel(new LangString("kinetische Energie", "de"));
  quantityKind.addLabel(new LangString("energía cinética", "es"));
  quantityKind.addLabel(new LangString("運動エネルギー", "ja"));
  quantityKind.addLabel(new LangString("Kinetik enerji", "tr"));
  quantityKind.addLabel(new LangString("energia cinetica", "it"));
  quantityKind.addLabel(new LangString("动能", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyKinetic",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy Level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy per Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerAreaElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy Per Area Electric Charge", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerAreaElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Energy per electric charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Voltage");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerMagneticFluxDensity_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E2L2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy Per Square Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-T2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerMagneticFluxDensity_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerMassAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy and work per mass amount of substance", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerMassAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerSquareMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E2L2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Energy Per Square Magnetic Flux Density", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerSquareMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Energy per temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Energy_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M2H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Square Energy", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Energy_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Enthalpy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Entalpi", "ms"));
  quantityKind.addLabel(new LangString("entalpía", "es"));
  quantityKind.addLabel(new LangString("энтальпия", "ru"));
  quantityKind.addLabel(new LangString("Entalpi", "tr"));
  quantityKind.addLabel(new LangString("entalpia", "pl"));
  quantityKind.addLabel(new LangString("enthalpy", "en"));
  quantityKind.addLabel(new LangString("محتوى حراري", "ar"));
  quantityKind.addLabel(new LangString("Enthalpie", "de"));
  quantityKind.addLabel(new LangString("焓", "zh"));
  quantityKind.addLabel(new LangString("entalpia", "pt"));
  quantityKind.addLabel(new LangString("enthalpie", "fr"));
  quantityKind.addLabel(new LangString("エンタルピー", "ja"));
  quantityKind.addLabel(new LangString("entalpija", "sl"));
  quantityKind.addLabel(new LangString("entalpia", "it"));
  quantityKind.addLabel(new LangString("آنتالپی", "fa"));
  quantityKind.addLabel(new LangString("Entalpie", "ro"));
  quantityKind.addLabel(new LangString("entalpie", "cs"));
  quantityKind.addLabel(new LangString("पूर्ण ऊष्मा", "hi"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Enthalpy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Entropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("entropie", "cs"));
  quantityKind.addLabel(new LangString("Entropie", "de"));
  quantityKind.addLabel(new LangString("entropia", "it"));
  quantityKind.addLabel(new LangString("entropie", "fr"));
  quantityKind.addLabel(new LangString("entropia", "pt"));
  quantityKind.addLabel(new LangString("entropy", "en"));
  quantityKind.addLabel(new LangString("एन्ट्रॉपी", "hi"));
  quantityKind.addLabel(new LangString("Entropi", "ms"));
  quantityKind.addLabel(new LangString("إنتروبيا", "ar"));
  quantityKind.addLabel(new LangString("آنتروپی", "fa"));
  quantityKind.addLabel(new LangString("entropi", "tr"));
  quantityKind.addLabel(new LangString("entropia", "pl"));
  quantityKind.addLabel(new LangString("熵", "zh"));
  quantityKind.addLabel(new LangString("entropija", "sl"));
  quantityKind.addLabel(new LangString("entropie", "ro"));
  quantityKind.addLabel(new LangString("Энтропия", "ru"));
  quantityKind.addLabel(new LangString("entropía", "es"));
  quantityKind.addLabel(new LangString("エントロピー", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Entropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Equilibrium Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "0173-1#Z4-BAJ458#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("equilibrium constant based on concentration", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnPressure",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ459#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("equilibrium constant based on pressure", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantBasedOnPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnConcentrationBasis",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Equilibrium Constant on Concentration Basis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnConcentrationBasis",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnPressureBasis",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Equilibrium Constant on Pressure Basis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstant"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumConstantOnPressureBasis",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquilibriumPositionVectorOfIon",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R_0",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Equilibrium Position Vector of Ion", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquilibriumPositionVectorOfIon",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalenceDoseOutput",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    "0173-1#Z4-BAJ450#001",
    undefined
  );
  quantityKind.addLabel(new LangString("equivalence dose output", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalenceDoseOutput",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalentAbsorptionArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Equivalent absorption area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalentAbsorptionArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalentConcentration",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Equivalent Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalentConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EquivalentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Equivalent Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Density"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EquivalentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Equivalent_Mass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Equivalent", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Equivalent_Mass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Equivalent_Molar",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    "equiv",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Equivalent", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Equivalent_Molar",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Evaporative Heat Transfer", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransferCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "h_e",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Combined Non Evaporative Heat Transfer Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-PA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/EvaporativeHeatTransferCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Exchange Integral", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExchangeIntegral",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExhaustGasMeanMolecularWeight",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Exhaust Gas Mean Molecular Weight", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExhaustGasMeanMolecularWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExhaustGasesSpecificHeat",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_p",
    undefined
  );
  quantityKind.addLabel(new LangString("Exhaust Gases Specific Heat", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExhaustGasesSpecificHeat",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExhaustStreamPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Exhaust Stream Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExhaustStreamPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExitPlaneCrossSectionalArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A_{e}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Exit Plane Cross-sectional Area", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExitPlaneCrossSectionalArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExitPlanePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p_{e}",
    undefined
  );
  quantityKind.addLabel(new LangString("Exit Plane Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExitPlanePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExitPlaneTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Exit Plane Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExitPlaneTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Expansion Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Exposure",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    "X",
    undefined
  );
  quantityKind.addLabel(new LangString("Exposure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliC-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-T-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-M2-PER-J-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Exposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExposureOfIonizingRadiation",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    "0173-1#Z4-BAJ326#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("exposure of ionizing radiation", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExposureOfIonizingRadiation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExposureRate",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Exposure Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C-PER-KiloGM-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/R-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExposureRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExposureRateOfIonizingRadiation",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    "0173-1#Z4-BAJ327#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("exposure rate of ionizing radiation", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExposureRateOfIonizingRadiation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Extent of Reaction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoMOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ExtentOfReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FLIGHT-PERFORMANCE-RESERVE-PROPELLANT-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Flight Performance Reserve Propellant Mass", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FLIGHT-PERFORMANCE-RESERVE-PROPELLANT-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FUEL-BIAS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fuel Bias", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FUEL-BIAS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FahrenheitTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "0173-1#Z4-BAJ278#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Fahrenheit temperature", undefined));
  quantityKind.addLabel(new LangString("Fahrenheit temperature", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FahrenheitTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FailureRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ466#003",
    undefined
  );
  quantityKind.addLabel(new LangString("failure rate", undefined));
  quantityKind.addLabel(new LangString("failure rate", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FailureRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FastFissionFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fast Fission Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FastFissionFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "k_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Fermi Angular Wavenumber", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FermiAngularWavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FermiEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Fermi Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FermiEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FermiTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Fermi Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FermiTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FinalOrCurrentVehicleMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Final Or Current Vehicle Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FinalOrCurrentVehicleMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FirstMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("First Moment of Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolume");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_UK_PET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TBSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FBM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Standard");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FirstMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FirstStageMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R_1",
    undefined
  );
  quantityKind.addLabel(new LangString("First Stage Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FirstStageMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FishBiotransformationHalfLife",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fish Biotransformation Half Life", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FishBiotransformationHalfLife",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FissionCoreRadiusToHeightRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R/H",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fission Core Radius To Height Ratio", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FissionCoreRadiusToHeightRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FissionFuelUtilizationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fission Fuel Utilization Factor", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FissionFuelUtilizationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FissionMultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Fission Multiplication Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FissionMultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FlashPoint",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Flash Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FlashPoint",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FlightPathAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Flight Path Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FlightPathAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("floating point calculation capability", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaFLOPS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaFLOPS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaFLOPS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraFLOPS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FloatingPointCalculationCapability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Fluidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T1D0",
    "0173-1#Z4-BAJ447#001",
    undefined
  );
  quantityKind.addLabel(new LangString("fluidity", "en-US"));
  quantityKind.addLabel(new LangString("fluidity", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RHE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Fluidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Flux",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HA-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M2-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-M2-DAY"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Flux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Force",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "F",
    undefined
  );
  quantityKind.addLabel(new LangString("force", "en"));
  quantityKind.addLabel(new LangString("vis", "la"));
  quantityKind.addLabel(new LangString("siła", "pl"));
  quantityKind.addLabel(new LangString("כוח", "he"));
  quantityKind.addLabel(
    new LangString("وحدة القوة في نظام متر كيلوغرام ثانية", "ar")
  );
  quantityKind.addLabel(new LangString("força", "pt"));
  quantityKind.addLabel(new LangString("erő", "hu"));
  quantityKind.addLabel(new LangString("نیرو", "fa"));
  quantityKind.addLabel(new LangString("sila", "sl"));
  quantityKind.addLabel(new LangString("fuerza", "es"));
  quantityKind.addLabel(new LangString("forță", "ro"));
  quantityKind.addLabel(new LangString("Daya", "ms"));
  quantityKind.addLabel(new LangString("Δύναμη", "el"));
  quantityKind.addLabel(new LangString("kuvvet", "tr"));
  quantityKind.addLabel(new LangString("Сила", "ru"));
  quantityKind.addLabel(new LangString("Kraft", "de"));
  quantityKind.addLabel(new LangString("сила", "bg"));
  quantityKind.addLabel(new LangString("力", "ja"));
  quantityKind.addLabel(new LangString("forza", "it"));
  quantityKind.addLabel(new LangString("force", "fr"));
  quantityKind.addLabel(new LangString("Síla", "cs"));
  quantityKind.addLabel(new LangString("力", "zh"));
  quantityKind.addLabel(new LangString("बल", "hi"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Force",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForceConstant",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("force constant", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForceConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForceMagnitude",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Force Magnitude", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForceMagnitude",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Force Per Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force Per Area Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciBAR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerAreaTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force per Electric Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-C");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ForcePerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Force per Length", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ForcePerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Frequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("תדירות", "he"));
  quantityKind.addLabel(new LangString("frecvență", "ro"));
  quantityKind.addLabel(new LangString("周波数", "ja"));
  quantityKind.addLabel(new LangString("frequenza", "it"));
  quantityKind.addLabel(new LangString("frekans", "tr"));
  quantityKind.addLabel(new LangString("التردد لدى نظام الوحدات الدولي", "ar"));
  quantityKind.addLabel(new LangString("frekvenca", "sl"));
  quantityKind.addLabel(new LangString("بسامد", "fa"));
  quantityKind.addLabel(new LangString("frekvencia", "hu"));
  quantityKind.addLabel(new LangString("Частота", "ru"));
  quantityKind.addLabel(new LangString("Συχνότητα", "el"));
  quantityKind.addLabel(new LangString("Frequenz", "de"));
  quantityKind.addLabel(new LangString("częstotliwość", "pl"));
  quantityKind.addLabel(new LangString("Frekuensi", "ms"));
  quantityKind.addLabel(new LangString("Честота", "bg"));
  quantityKind.addLabel(new LangString("आवृत्ति", "hi"));
  quantityKind.addLabel(new LangString("frequency", "en"));
  quantityKind.addLabel(new LangString("频率", "zh"));
  quantityKind.addLabel(new LangString("frequência", "pt"));
  quantityKind.addLabel(new LangString("fréquence", "fr"));
  quantityKind.addLabel(new LangString("Frekvence", "cs"));
  quantityKind.addLabel(new LangString("frecuencia", "es"));
  quantityKind.addLabel(new LangString("frequentia", "la"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/failures-in-time"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Frequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Friction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Friction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Friction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Friction Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Fugacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("fugacitate", "ro"));
  quantityKind.addLabel(new LangString("بی‌دوامی", "fa"));
  quantityKind.addLabel(new LangString("逸度", "zh"));
  quantityKind.addLabel(new LangString("fugacità", "it"));
  quantityKind.addLabel(new LangString("fugacity", "en"));
  quantityKind.addLabel(new LangString("fugacita", "cs"));
  quantityKind.addLabel(new LangString("fugacidad", "es"));
  quantityKind.addLabel(new LangString("fügasite", "tr"));
  quantityKind.addLabel(new LangString("fugacité", "fr"));
  quantityKind.addLabel(new LangString("Fugazität", "de"));
  quantityKind.addLabel(new LangString("fugacidade", "pt"));
  quantityKind.addLabel(new LangString("フガシティー", "ja"));
  quantityKind.addLabel(new LangString("انفلاتية", "ar"));
  quantityKind.addLabel(new LangString("Lotność", "pl"));
  quantityKind.addLabel(new LangString("Fugasiti", "ms"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Fugacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FundamentalLatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "a_1, a_2, a_3",
    undefined
  );
  quantityKind.addLabel(new LangString("Fundamental Lattice vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LatticeVector"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FundamentalLatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/FundamentalReciprocalLatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "b_1, b_2, b_3",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Fundamental Reciprocal Lattice Vector", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularReciprocalLatticeVector"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/FundamentalReciprocalLatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GFactorOfNucleus",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("g-Factor of Nucleus", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GFactorOfNucleus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GROSS-LIFT-OFF-WEIGHT",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gross Lift-Off Weight", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GROSS-LIFT-OFF-WEIGHT",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Gain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Gain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GapEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_g",
    undefined
  );
  quantityKind.addLabel(new LangString("Gap Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GapEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GasLeakRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "0173-1#Z4-BAJ324#002",
    undefined
  );
  quantityKind.addLabel(new LangString("gas leak rate", "en-US"));
  quantityKind.addLabel(new LangString("gas leak rate", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GasLeakRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GaugePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gauge Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GaugePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneFamilyAbundance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gene Family Abundance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneFamilyAbundance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedCoordinate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "q_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Coordinate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedCoordinate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Q_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "p_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GeneralizedVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Generalized Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GeneralizedVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GibbsEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("energia libera di Gibbs", "it"));
  quantityKind.addLabel(new LangString("Prosta entalpija", "sl"));
  quantityKind.addLabel(new LangString("Gibbs energy", "en"));
  quantityKind.addLabel(new LangString("Gibbsova volná energie", "cs"));
  quantityKind.addLabel(new LangString("طاقة غيبس الحرة", "ar"));
  quantityKind.addLabel(new LangString("ギブズエネルギー", "ja"));
  quantityKind.addLabel(new LangString("freie Enthalpie", "de"));
  quantityKind.addLabel(new LangString("Energía de Gibbs", "es"));
  quantityKind.addLabel(new LangString("Entalpie liberă", "ro"));
  quantityKind.addLabel(new LangString("Gibbs Serbest Enerjisi", "tr"));
  quantityKind.addLabel(new LangString("انرژی آزاد گیبس", "fa"));
  quantityKind.addLabel(new LangString("энергия Гиббса", "ru"));
  quantityKind.addLabel(new LangString("entalpia swobodna", "pl"));
  quantityKind.addLabel(new LangString("Tenaga Gibbs", "ms"));
  quantityKind.addLabel(new LangString("enthalpie libre", "fr"));
  quantityKind.addLabel(new LangString("吉布斯自由能", "zh"));
  quantityKind.addLabel(new LangString("energia livre de Gibbs", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GibbsEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Gradient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("gradient", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Gradient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GrandCanonicalPartitionFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Grand Canonical Partition Function", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GrandCanonicalPartitionFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GravitationalAttraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Gravitational Attraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GravitationalAttraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Gravity_API",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("API Gravity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_API");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Gravity_API",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Group Speed of Sound", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GroupSpeedOfSound",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay_Cereal",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Growing Degree Days (Cereals)", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TimeTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GrowingDegreeDay_Cereal",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GruneisenParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gruneisen Parameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GruneisenParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GustatoryThreshold",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gustatory Threshold", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GustatoryThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/GyromagneticRatio",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Gyromagnetic Ratio", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/GyromagneticRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Half-Life",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "T_{1/2}",
    undefined
  );
  quantityKind.addLabel(new LangString("semiperiodo", "es"));
  quantityKind.addLabel(new LangString("نیمه عمر", "fa"));
  quantityKind.addLabel(new LangString("Halbwertszeit", "de"));
  quantityKind.addLabel(new LangString("Separuh hayat", "ms"));
  quantityKind.addLabel(new LangString("Poločas rozpadu", "cs"));
  quantityKind.addLabel(new LangString("tempo di dimezzamento", "it"));
  quantityKind.addLabel(new LangString("temps de demi-vie", "fr"));
  quantityKind.addLabel(new LangString("yarılanma süresi", "tr"));
  quantityKind.addLabel(new LangString("meia-vida", "pt"));
  quantityKind.addLabel(new LangString("half-life", "en"));
  quantityKind.addLabel(new LangString("半衰期", "zh"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Half-Life",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Half-ValueThickness",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d_{1/2}",
    undefined
  );
  quantityKind.addLabel(new LangString("Half-Value Thickness", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Half-ValueThickness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HallCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    "R_H, A_H",
    undefined
  );
  quantityKind.addLabel(new LangString("Hall Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-IN2-PER-LB_F"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HallCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "H",
    undefined
  );
  quantityKind.addLabel(new LangString("Hamilton Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HamiltonFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeadEndPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Head End Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeadEndPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeartRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heart Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BEAT-PER-MIN");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeartRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Heat",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("ciepło", "pl"));
  quantityKind.addLabel(new LangString("jednotka tepla", "cs"));
  quantityKind.addLabel(new LangString("quantidade de calor", "pt"));
  quantityKind.addLabel(new LangString("熱量", "ja"));
  quantityKind.addLabel(new LangString("calor", "es"));
  quantityKind.addLabel(new LangString("cantitate de căldură", "ro"));
  quantityKind.addLabel(new LangString("quantité de chaleur", "fr"));
  quantityKind.addLabel(new LangString("calore", "it"));
  quantityKind.addLabel(new LangString("kuantiti haba Haba", "ms"));
  quantityKind.addLabel(new LangString("ısı miktarı", "tr"));
  quantityKind.addLabel(new LangString("heat", "en"));
  quantityKind.addLabel(new LangString("ऊष्मा", "hi"));
  quantityKind.addLabel(new LangString("热量", "zh"));
  quantityKind.addLabel(new LangString("Теплота", "ru"));
  quantityKind.addLabel(new LangString("toplota", "sl"));
  quantityKind.addLabel(new LangString("کمیت گرما", "fa"));
  quantityKind.addLabel(new LangString("حرارة", "ar"));
  quantityKind.addLabel(new LangString("labor", "la"));
  quantityKind.addLabel(new LangString("Wärme", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_20DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_15_DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_Mean");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_39DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_59DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_60DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermalEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Heat",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "C_P",
    undefined
  );
  quantityKind.addLabel(new LangString("ऊष्मा धारिता", "hi"));
  quantityKind.addLabel(new LangString("pojemność cieplna", "pl"));
  quantityKind.addLabel(new LangString("capacidade térmica", "pt"));
  quantityKind.addLabel(new LangString("toplotna kapaciteta", "sl"));
  quantityKind.addLabel(new LangString("熱容量", "ja"));
  quantityKind.addLabel(new LangString("isı kapasitesi", "tr"));
  quantityKind.addLabel(new LangString("Wärmekapazität", "de"));
  quantityKind.addLabel(new LangString("ظرفیت گرمایی", "fa"));
  quantityKind.addLabel(new LangString("capacitate termică", "ro"));
  quantityKind.addLabel(new LangString("热容", "zh"));
  quantityKind.addLabel(new LangString("tepelná kapacita", "cs"));
  quantityKind.addLabel(new LangString("muatan haba", "ms"));
  quantityKind.addLabel(new LangString("heat capacity", "en"));
  quantityKind.addLabel(new LangString("سعة حرارية", "ar"));
  quantityKind.addLabel(new LangString("capacité thermique", "fr"));
  quantityKind.addLabel(new LangString("теплоёмкость", "ru"));
  quantityKind.addLabel(new LangString("capacidad calorífica", "es"));
  quantityKind.addLabel(new LangString("capacità termica", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatCapacityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Capacity Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatCapacityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatFlowRatePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Flow Rate per Unit Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatFlowRatePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatFlowRatePerUnitArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Flow Rate per Unit Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatFlowRatePerUnitArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Heat Flux Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HeatingValue",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Calorific Value", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HeatingValue",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Height",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "h",
    undefined
  );
  quantityKind.addLabel(new LangString("Înălțime", "ro"));
  quantityKind.addLabel(new LangString("altezza", "it"));
  quantityKind.addLabel(new LangString("altura", "pt"));
  quantityKind.addLabel(new LangString("yükseklik", "tr"));
  quantityKind.addLabel(new LangString("Výška", "cs"));
  quantityKind.addLabel(new LangString("高度", "zh"));
  quantityKind.addLabel(new LangString("высота", "ru"));
  quantityKind.addLabel(new LangString("hauteur", "fr"));
  quantityKind.addLabel(new LangString("Ketinggian", "ms"));
  quantityKind.addLabel(new LangString("altura", "es"));
  quantityKind.addLabel(new LangString("height", "en"));
  quantityKind.addLabel(new LangString("ارتفاع", "fa"));
  quantityKind.addLabel(new LangString("Höhe", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Height",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HelmholtzEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("energia livre de Helmholtz", "pt"));
  quantityKind.addLabel(new LangString("Helmholtz enerjisi", "tr"));
  quantityKind.addLabel(new LangString("Energía de Helmholtz", "es"));
  quantityKind.addLabel(new LangString("ヘルムホルツの自由エネルギー", "ja"));
  quantityKind.addLabel(new LangString("Helmholtz energy", "en"));
  quantityKind.addLabel(new LangString("Helmholtzova volná energie", "cs"));
  quantityKind.addLabel(new LangString("طاقة هلمهولتز الحرة", "ar"));
  quantityKind.addLabel(new LangString("انرژی آزاد هلمولتز", "fa"));
  quantityKind.addLabel(new LangString("Tenaga Helmholtz", "ms"));
  quantityKind.addLabel(new LangString("énergie libre", "fr"));
  quantityKind.addLabel(new LangString("freie Energie", "de"));
  quantityKind.addLabel(new LangString("energia libera di Helmholz", "it"));
  quantityKind.addLabel(new LangString("energia swobodna", "pl"));
  quantityKind.addLabel(new LangString("亥姆霍兹自由能", "zh"));
  quantityKind.addLabel(new LangString("свободная энергия Гельмгольца", "ru"));
  quantityKind.addLabel(new LangString("Prosta energija", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HelmholtzEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HenrysLawVolatilityConstant",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Henry's Law Volatility Constant", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ATM-M3-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HenrysLawVolatilityConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HoleDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Hole Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HoleDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HorizontalVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_{X}",
    undefined
  );
  quantityKind.addLabel(new LangString("Horizontal Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HorizontalVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Hydraulic Permeability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DARCY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDARCY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HydraulicPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/HyperfineStructureQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "F",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Hyperfine Structure Quantum Number", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/HyperfineStructureQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/INERT-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inert Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/INERT-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IgnitionIntervalTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ignition interval time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IgnitionIntervalTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Illuminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("osvetljenost", "sl"));
  quantityKind.addLabel(new LangString("natężenie oświetlenia", "pl"));
  quantityKind.addLabel(new LangString("Beleuchtungsstärke", "de"));
  quantityKind.addLabel(new LangString("شدت روشنایی", "fa"));
  quantityKind.addLabel(new LangString("照度", "zh"));
  quantityKind.addLabel(new LangString("Осветеност", "bg"));
  quantityKind.addLabel(new LangString("megvilágítás", "hu"));
  quantityKind.addLabel(new LangString("شدة الضوء", "ar"));
  quantityKind.addLabel(new LangString("הארה (שטף ליחידת שטח)", "he"));
  quantityKind.addLabel(new LangString("照度", "ja"));
  quantityKind.addLabel(new LangString("luminosidad", "es"));
  quantityKind.addLabel(new LangString("Intenzita osvětlení", "cs"));
  quantityKind.addLabel(new LangString("aydınlanma şiddeti", "tr"));
  quantityKind.addLabel(new LangString("Pencahayaan", "ms"));
  quantityKind.addLabel(new LangString("Освещённость", "ru"));
  quantityKind.addLabel(new LangString("iluminamento", "pt"));
  quantityKind.addLabel(new LangString("illuminamento", "it"));
  quantityKind.addLabel(new LangString("éclairement lumineux", "fr"));
  quantityKind.addLabel(new LangString("illuminance", "en"));
  quantityKind.addLabel(new LangString("iluminare", "ro"));
  quantityKind.addLabel(new LangString("प्रदीपन", "hi"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Illuminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Impedance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Impedance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Impedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Impulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    "0173-1#Z4-BAJ241#002",
    undefined
  );
  quantityKind.addLabel(new LangString("impulse", "en-US"));
  quantityKind.addLabel(new LangString("impulse", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Impulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Incidence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Incidence", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Incidence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IncidenceProportion",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Incidence Proportion", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IncidenceProportion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IncidenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Incidence Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IncidenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Inductance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("induktivitás", "hu"));
  quantityKind.addLabel(new LangString("indutância", "pt"));
  quantityKind.addLabel(new LangString("Indukstans", "ms"));
  quantityKind.addLabel(new LangString("المحاثة (التحريض)", "ar"));
  quantityKind.addLabel(new LangString("induktivnost", "sl"));
  quantityKind.addLabel(new LangString("القاوری", "fa"));
  quantityKind.addLabel(new LangString("İndüktans", "tr"));
  quantityKind.addLabel(new LangString("电感", "zh"));
  quantityKind.addLabel(new LangString("Индуктивность", "ru"));
  quantityKind.addLabel(new LangString("インダクタンス・誘導係数", "ja"));
  quantityKind.addLabel(new LangString("inductancia", "es"));
  quantityKind.addLabel(new LangString("inductanță", "ro"));
  quantityKind.addLabel(new LangString("indukcyjność", "pl"));
  quantityKind.addLabel(new LangString("inductance", "en"));
  quantityKind.addLabel(new LangString("induttanza", "it"));
  quantityKind.addLabel(new LangString("Индуктивност", "bg"));
  quantityKind.addLabel(new LangString("inductantia", "la"));
  quantityKind.addLabel(new LangString("Inductance électrique", "fr"));
  quantityKind.addLabel(new LangString("השראות", "he"));
  quantityKind.addLabel(new LangString("Indukčnost", "cs"));
  quantityKind.addLabel(new LangString("प्रेरकत्व", "hi"));
  quantityKind.addLabel(new LangString("Induktivität", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Stat");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Inductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InfiniteMultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Infinite Multiplication Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InfiniteMultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("information content", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ468#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "information content expressed as a logarithm to base 10",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase2",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ463#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "information content expressed as a logarithm to base 2",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBase2",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBaseE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ469#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "information content expressed as a logarithm to base e",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationContentExpressedAsALogarithmToBaseE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationEntropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Information Entropy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERLANG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HART");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SHANNON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBYTE");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Information flow rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NAT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HART-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SHANNON-PER-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialExpansionRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Expansion Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialExpansionRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialNozzleThroatDiameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Nozzle Throat Diameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NozzleThroatDiameter"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialNozzleThroatDiameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialVehicleMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{o}",
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Vehicle Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialVehicleMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InitialVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_{i}",
    undefined
  );
  quantityKind.addLabel(new LangString("Initial Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InitialVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InstantaneousPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Instantaneous Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InstantaneousPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InternalConversionFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("InternalConversionFactor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InternalConversionFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InternalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Internal Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyInternal"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InternalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IntinsicCarrierDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Intinsic Carrier Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IntinsicCarrierDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse amount of substance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-V-A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-J");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-KiloV-A-HR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseEnergy_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-EV2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-J2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-GigaEV2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseEnergy_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DPI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MESH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-ANGSTROM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseLengthTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Length Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseLengthTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Magnetic Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-V");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseMagneticFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal mass", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseMass_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Mass", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-PlanckMass2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloGM2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseMass_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InversePermittivity",
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Permittivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-FARAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InversePermittivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InversePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Pressure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PSI");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InversePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseSquareEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M-2H0T4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Energy", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseSquareEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseSquareMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-2H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Mass", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseSquareMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseSquareTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Time", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseSquareTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Time", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Time Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTimeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseTime_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Square Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseTime_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/InverseVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Inverse Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YD3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/InverseVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "N, n^+, n^-",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YD3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/IonDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "j",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCurrent");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrent"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "N, n^+, n^-",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YD3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/IonConcentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonTransportNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "t_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Transport Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonTransportNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonicCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T1D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Ionic Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckCharge");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloV"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZettaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YottaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YoctoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZeptoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ElementaryCharge"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCharge"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonicCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonicStrength",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Ionic Strength", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonicStrength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Ionization Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IonizationEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Irradiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("éclairement énergétique", "fr"));
  quantityKind.addLabel(new LangString("yoğunluk", "tr"));
  quantityKind.addLabel(
    new LangString("Поверхностная плотность потока энергии", "ru")
  );
  quantityKind.addLabel(new LangString("irradiancia", "es"));
  quantityKind.addLabel(new LangString("irradianza", "it"));
  quantityKind.addLabel(new LangString("Kepenyinaran", "ms"));
  quantityKind.addLabel(new LangString("irradiância", "pt"));
  quantityKind.addLabel(new LangString("irradiance", "en"));
  quantityKind.addLabel(new LangString("Bestrahlungsstärke", "de"));
  quantityKind.addLabel(new LangString("الطاقة الهلامية", "ar"));
  quantityKind.addLabel(new LangString("Intenzita záření", "cs"));
  quantityKind.addLabel(new LangString("辐照度", "zh"));
  quantityKind.addLabel(new LangString("熱流束", "ja"));
  quantityKind.addLabel(new LangString("پرتو افکنی/چگالی تابش", "fa"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Irradiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Isentropic Compressibility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsentropicCompressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsentropicExponent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Показатель адиабаты", "ru"));
  quantityKind.addLabel(new LangString("Wykładnik adiabaty", "pl"));
  quantityKind.addLabel(new LangString("exposant isoentropique", "fr"));
  quantityKind.addLabel(
    new LangString("ısı sığası oranı; adyabatik indeks", "tr")
  );
  quantityKind.addLabel(new LangString("绝热指数", "zh"));
  quantityKind.addLabel(new LangString("isentropic exponent", "en"));
  quantityKind.addLabel(new LangString("Poissonova konstanta", "cs"));
  quantityKind.addLabel(
    new LangString("Coefficiente di dilatazione adiabatica", "it")
  );
  quantityKind.addLabel(
    new LangString("Coeficient de transformare adiabatică", "ro")
  );
  quantityKind.addLabel(
    new LangString("Coeficiente de expansão adiabática", "pt")
  );
  quantityKind.addLabel(new LangString("نسبة السعة الحرارية", "ar"));
  quantityKind.addLabel(new LangString("adiabatni eksponent", "sl"));
  quantityKind.addLabel(new LangString("Isentropenexponent", "de"));
  quantityKind.addLabel(new LangString("比熱比", "ja"));
  quantityKind.addLabel(
    new LangString("Coeficiente de dilatación adiabática", "es")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsentropicExponent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("等温压缩率", "zh"));
  quantityKind.addLabel(
    new LangString("معامل الانضغاط عند ثبوت درجة الحرارة", "ar")
  );
  quantityKind.addLabel(new LangString("compressibilité isotherme", "fr"));
  quantityKind.addLabel(new LangString("Izotermna stisljivost", "sl"));
  quantityKind.addLabel(new LangString("isotherme Kompressibilität", "de"));
  quantityKind.addLabel(new LangString("comprimibilità isotermica", "it"));
  quantityKind.addLabel(new LangString("compressibilidade isotérmica", "pt"));
  quantityKind.addLabel(new LangString("Ketermampatan isotermik", "ms"));
  quantityKind.addLabel(new LangString("isothermal compressibility", "en"));
  quantityKind.addLabel(new LangString("compresibilidad isotérmica", "es"));
  quantityKind.addLabel(new LangString("objemová stlačitelnost", "cs"));
  quantityKind.addLabel(new LangString("ضریب تراکم‌پذیری همدما", "fa"));
  quantityKind.addLabel(new LangString("ściśliwość izotermiczna", "pl"));
  quantityKind.addLabel(
    new LangString("изотермический коэффициент сжимаемости", "ru")
  );
  quantityKind.addLabel(new LangString("等温圧縮率", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PSI");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/InversePressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsothermalCompressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/IsothermalMoistureCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Isothermal Moisture Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/IsothermalMoistureCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Kerma",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Kerma", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGRAY");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Kerma",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KermaRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kerma Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KermaRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("श्यानता", "hi"));
  quantityKind.addLabel(new LangString("kinematična viskoznost", "sl"));
  quantityKind.addLabel(new LangString("Viscozitate cinematică", "ro"));
  quantityKind.addLabel(new LangString("Kinematik akmazlık", "tr"));
  quantityKind.addLabel(new LangString("لزوجة", "ar"));
  quantityKind.addLabel(new LangString("viscosidad cinemática", "es"));
  quantityKind.addLabel(new LangString("Kelikatan kinematik", "ms"));
  quantityKind.addLabel(new LangString("kinematische Viskosität", "de"));
  quantityKind.addLabel(new LangString("运动粘度", "zh"));
  quantityKind.addLabel(new LangString("viskozita", "cs"));
  quantityKind.addLabel(new LangString("kinematic viscosity", "en"));
  quantityKind.addLabel(new LangString("粘度", "ja"));
  quantityKind.addLabel(new LangString("گرانروی جنبشی/ویسکوزیته جنبشی", "fa"));
  quantityKind.addLabel(new LangString("viscosité cinématique", "fr"));
  quantityKind.addLabel(new LangString("кинематическую вязкость", "ru"));
  quantityKind.addLabel(new LangString("lepkość kinematyczna", "pl"));
  quantityKind.addLabel(new LangString("viscosità cinematica", "it"));
  quantityKind.addLabel(new LangString("viscosidade cinemática", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiST");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaPerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KinematicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KinematicViscosityOrDiffusionConstantOrThermalDiffusivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "0173-1#Z4-BAJ328#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "kinematic viscosity or diffusion constant or thermal diffusivity",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KinematicViscosityOrDiffusionConstantOrThermalDiffusivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KineticEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "KE",
    undefined
  );
  quantityKind.addLabel(new LangString("Kinetic Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KineticEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/KineticOrThermalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ280#002",
    undefined
  );
  quantityKind.addLabel(new LangString("kinetic or thermal energy", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/KineticOrThermalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Lagrange Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LagrangeFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Landau-GinzburgNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Landau-Ginzburg Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Landau-GinzburgNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LandeGFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Lande g-Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LandeGFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LarmorAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Larmor Angular Frequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LarmorAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LatticePlaneSpacing",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Lattice Plane Spacing", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LatticePlaneSpacing",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LatticeVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Lattice Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LatticeVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LeakageFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Leakage Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LeakageFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Length",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "l",
    undefined
  );
  quantityKind.addLabel(new LangString("אורך", "he"));
  quantityKind.addLabel(new LangString("طول", "fa"));
  quantityKind.addLabel(new LangString("długość", "pl"));
  quantityKind.addLabel(new LangString("Μήκος", "el"));
  quantityKind.addLabel(new LangString("Panjang", "ms"));
  quantityKind.addLabel(new LangString("longitud", "es"));
  quantityKind.addLabel(new LangString("Дължина", "bg"));
  quantityKind.addLabel(new LangString("lunghezza", "it"));
  quantityKind.addLabel(new LangString("longitudo", "la"));
  quantityKind.addLabel(new LangString("長さ", "ja"));
  quantityKind.addLabel(new LangString("hossz", "hu"));
  quantityKind.addLabel(new LangString("uzunluk", "tr"));
  quantityKind.addLabel(new LangString("comprimento", "pt"));
  quantityKind.addLabel(new LangString("लम्बाई", "hi"));
  quantityKind.addLabel(new LangString("长度", "zh"));
  quantityKind.addLabel(new LangString("طول", "ar"));
  quantityKind.addLabel(new LangString("longueur", "fr"));
  quantityKind.addLabel(new LangString("dolžina", "sl"));
  quantityKind.addLabel(new LangString("lungime", "ro"));
  quantityKind.addLabel(new LangString("Délka", "cs"));
  quantityKind.addLabel(new LangString("Длина", "ru"));
  quantityKind.addLabel(new LangString("length", "en"));
  quantityKind.addLabel(new LangString("Länge", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Length",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthByForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Work"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthByForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV-FemtoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthMolarEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Molar Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-M-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthMolarEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthPerElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length per Electric Current", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthPerElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthPerUnitElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Length per Unit Electric Current", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthPerUnitElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthPercentage",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Percentage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthPercentage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-CentiM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LengthTemperatureTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Length Temperature Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-SEC-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LengthTemperatureTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Lethargy",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Lethargy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Lethargy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LevelWidth",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Level Width", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LevelWidth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LiftCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "C_{L}",
    undefined
  );
  quantityKind.addLabel(new LangString("Lift Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LiftCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LiftForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Lift Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LiftForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Absorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearAbsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Acceleration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearAcceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic bit density", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBIT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBIT-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearBitDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearCompressibility",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Compressibility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM-PER-N");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearCompressibility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic electric charge", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Electric Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "J_s",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Linear Electric Current Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Energy Transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaEV-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloEV-PER-MicroM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearEnergyTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("معدل التمدد الحراري الخطي", "ar"));
  quantityKind.addLabel(new LangString("linear expansion coefficient", "en"));
  quantityKind.addLabel(
    new LangString("coeficiente de dilatação térmica linear", "pt")
  );
  quantityKind.addLabel(
    new LangString("coefficient de dilatation linéique", "fr")
  );
  quantityKind.addLabel(
    new LangString("współczynnik liniowej rozszerzalności cieplnej", "pl")
  );
  quantityKind.addLabel(
    new LangString("linearer Ausdehnungskoeffizient", "de")
  );
  quantityKind.addLabel(
    new LangString("coeficiente de expansión térmica lineal", "es")
  );
  quantityKind.addLabel(new LangString("線熱膨張係数", "ja"));
  quantityKind.addLabel(
    new LangString("coefficiente di dilatazione lineare", "it")
  );
  quantityKind.addLabel(new LangString("线性热膨胀系数", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaK"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearExpansionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Force", "en"));
  quantityKind.addLabel(new LangString("Streckenlast", "de"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearIonization",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "N_{il}",
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Ionization", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearIonization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic logarithmic ratio", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciB-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearLogarithmicRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic mass", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckMomentum"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Momentum");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic power", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearResistance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic resistance", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliOHM-PER-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaOHM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaOHM-PER-KiloM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearStiffness",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Force", "en"));
  quantityKind.addLabel(new LangString("Streckenlast", "de"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearStiffness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearStrain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthRatio"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Strain");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearStrain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Thermal Expansion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearThermalExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic torque", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-FT-PER-IN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-IN-PER-IN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v",
    undefined
  );
  quantityKind.addLabel(new LangString("Linear Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Velocity");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinearVoltageCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "0173-1#Z4-BAJ336#003",
    undefined
  );
  quantityKind.addLabel(new LangString("linear voltage coefficient", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinearVoltageCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T1D0",
    "0173-1#Z4-BAJ457#001",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic charge", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicDataVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ331#002",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic data volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicDataVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicLogarithmicRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ332#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic logarithmic ratio", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicLogarithmicRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    "0173-1#Z4-BAJ341#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic mass", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-3D0",
    "0173-1#Z4-BAJ418#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic power", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicQuantity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("lineic quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicResistance",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ333#003",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic resistance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicResolution",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ438#002",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic resolution", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DPI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MESH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-ANGSTROM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicResolution",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LineicTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "0173-1#Z4-BAJ433#001",
    undefined
  );
  quantityKind.addLabel(new LangString("lineic torque", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LineicTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LinkedFlux",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Linked Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UnitPole");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFlux"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LinkedFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LiquidVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Liquid Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CUP_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CUP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_IMP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Volume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LiquidVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Log10FrequencyInterval",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic frequency interval to base 10", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Log10FrequencyInterval",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Log10Ratio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic ratio to base 10", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Log10Ratio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogERatio",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic ratio to base e", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogERatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogOctanolAirPartitionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Octanol Air Partition Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogOctanolAirPartitionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogOctanolWaterPartitionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Logarithm of Octanol Water Partition Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogOctanolWaterPartitionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ441#002",
    undefined
  );
  quantityKind.addLabel(new LangString("logarithm ratio to base 10", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBaseE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ440#002",
    undefined
  );
  quantityKind.addLabel(new LangString("logarithm ratio to base e", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmRatioToBaseE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("intervalo logarítmico de frequência", "pt")
  );
  quantityKind.addLabel(
    new LangString("intervallo logaritmico di frequenza", "it")
  );
  quantityKind.addLabel(new LangString("Selang kekerapan logaritma", "ms"));
  quantityKind.addLabel(new LangString("logarithmic frequency interval", "en"));
  quantityKind.addLabel(new LangString("فاصله فرکانس لگاریتمی", "fa"));
  quantityKind.addLabel(new LangString("частотный интервал", "ru"));
  quantityKind.addLabel(new LangString("Frequenzmaßintervall", "de"));
  quantityKind.addLabel(new LangString("Interval měření frekvence ?", "cs"));
  quantityKind.addLabel(
    new LangString("intervalle de fréquence logarithmique", "fr")
  );
  quantityKind.addLabel(new LangString("对数频率间隔", "zh"));
  quantityKind.addLabel(new LangString("logaritmik frekans aralığı", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyInterval",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyIntervalToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ472#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("logarithmic frequency interval to base 10", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicFrequencyIntervalToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase10",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ470#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a common logarithm ",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase10",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase2",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ464#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a binary logarithm",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBase2",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBaseE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ471#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "median information flow (from a source of information), expressed as a natural logarithm ",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LogarithmicMedianInformationFlow_SourceToBaseE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LondonPenetrationDepth",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "λₗ",
    undefined
  );
  quantityKind.addLabel(new LangString("London Penetration Depth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LondonPenetrationDepth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Long-RangeOrderParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R, s",
    undefined
  );
  quantityKind.addLabel(new LangString("Long-Range Order Parameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Long-RangeOrderParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LorenzCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-2L4I0M2H-2T-6D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Lorenz Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V2-PER-K2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LorenzCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LossAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Loss Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LossAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LossFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Loss Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LossFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Loudness",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ334#002",
    undefined
  );
  quantityKind.addLabel(new LangString("loudness", "en-US"));
  quantityKind.addLabel(new LangString("loudness", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Loudness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LoudnessLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ361#002",
    undefined
  );
  quantityKind.addLabel(new LangString("loudness level", "en-US"));
  quantityKind.addLabel(new LangString("loudness level", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LoudnessLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LowerCriticalMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B_{c1}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Lower Critical Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gs");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gamma");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LowerCriticalMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Luminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    "L_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STILB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LA_FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Luminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousEfficacy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Efficacy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-PER-W");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousEfficacy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousEmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    "M_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Emmitance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousEmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    "Q_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousExitance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    "0173-1#Z4-BAJ382#002",
    undefined
  );
  quantityKind.addLabel(new LangString("luminous exitance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousExitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousExposure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T1D0",
    "H_v",
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Exposure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousFlux",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    "F",
    undefined
  );
  quantityKind.addLabel(new LangString("fluctús lucis", "la"));
  quantityKind.addLabel(new LangString("flujo luminoso", "es"));
  quantityKind.addLabel(new LangString("flusso luminoso", "it"));
  quantityKind.addLabel(new LangString("flux lumineux", "fr"));
  quantityKind.addLabel(new LangString("प्रकाशीय बहाव", "hi"));
  quantityKind.addLabel(new LangString("işık akısı", "tr"));
  quantityKind.addLabel(new LangString("التدفق الضوئي", "ar"));
  quantityKind.addLabel(new LangString("strumień świetlny", "pl"));
  quantityKind.addLabel(new LangString("Fluks berluminositi", "ms"));
  quantityKind.addLabel(new LangString("svetlobni tok", "sl"));
  quantityKind.addLabel(new LangString("Светлинен поток", "bg"));
  quantityKind.addLabel(new LangString("光通量", "zh"));
  quantityKind.addLabel(new LangString("Световой поток", "ru"));
  quantityKind.addLabel(new LangString("fluxo luminoso", "pt"));
  quantityKind.addLabel(new LangString("שטף הארה", "he"));
  quantityKind.addLabel(new LangString("flux luminos", "ro"));
  quantityKind.addLabel(new LangString("fényáram", "hu"));
  quantityKind.addLabel(new LangString("Lichtstrom", "de"));
  quantityKind.addLabel(new LangString("luminous flux", "en"));
  quantityKind.addLabel(new LangString("Světelný tok", "cs"));
  quantityKind.addLabel(new LangString("شار نوری", "fa"));
  quantityKind.addLabel(new LangString("光束", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Flux per Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousFluxPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousFluxRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Luminous Flux Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousFluxRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T0D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Lichtstärke", "de"));
  quantityKind.addLabel(new LangString("شدة الإضاءة", "ar"));
  quantityKind.addLabel(new LangString("ışık şiddeti", "tr"));
  quantityKind.addLabel(new LangString("intensité lumineuse", "fr"));
  quantityKind.addLabel(new LangString("Keamatan berluminositi", "ms"));
  quantityKind.addLabel(new LangString("intensitate luminoasă", "ro"));
  quantityKind.addLabel(new LangString("光度", "ja"));
  quantityKind.addLabel(new LangString("עוצמת הארה", "he"));
  quantityKind.addLabel(new LangString("fényerősség", "hu"));
  quantityKind.addLabel(new LangString("Интензитет на светлината", "bg"));
  quantityKind.addLabel(new LangString("发光强度", "zh"));
  quantityKind.addLabel(new LangString("Сила света", "ru"));
  quantityKind.addLabel(new LangString("światłość", "pl"));
  quantityKind.addLabel(new LangString("प्रकाशीय तीव्रता", "hi"));
  quantityKind.addLabel(new LangString("intensità luminosa", "it"));
  quantityKind.addLabel(new LangString("intensidad luminosa", "es"));
  quantityKind.addLabel(new LangString("Ένταση Φωτεινότητας", "el"));
  quantityKind.addLabel(new LangString("intensitas luminosa", "la"));
  quantityKind.addLabel(new LangString("svetilnost", "sl"));
  quantityKind.addLabel(new LangString("شدت نور", "fa"));
  quantityKind.addLabel(new LangString("Svítivost", "cs"));
  quantityKind.addLabel(new LangString("intensidade luminosa", "pt"));
  quantityKind.addLabel(new LangString("luminous intensity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD_IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliCD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Ion Concentration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-LM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CD-PER-KiloLM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/LuminousIntensityDistribution",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-DELIVERED",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Delivered", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-DELIVERED",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-GROWTH-ALLOWANCE",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Growth Allowance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-GROWTH-ALLOWANCE",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-MARGIN",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Margin", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-MARGIN",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MASS-PROPERTY-UNCERTAINTY",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Property Uncertainty", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MASS-PROPERTY-UNCERTAINTY",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I_{y}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Moment of Inertia in the Y axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I_{z}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Moment of Inertia in the Z axis", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MOMENT-OF-INERTIA_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MachNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Ma",
    undefined
  );
  quantityKind.addLabel(new LangString("मैक संख्या", "hi"));
  quantityKind.addLabel(new LangString("número de Mach", "pt"));
  quantityKind.addLabel(new LangString("nombre de Mach", "fr"));
  quantityKind.addLabel(new LangString("Machovo číslo", "cs"));
  quantityKind.addLabel(new LangString("عدد ماخ", "fa"));
  quantityKind.addLabel(new LangString("马赫", "zh"));
  quantityKind.addLabel(new LangString("Mach number", "en"));
  quantityKind.addLabel(new LangString("liczba Macha", "pl"));
  quantityKind.addLabel(new LangString("Mach sayısı", "tr"));
  quantityKind.addLabel(new LangString("Mach-Zahl", "de"));
  quantityKind.addLabel(new LangString("număr Mach", "ro"));
  quantityKind.addLabel(new LangString("マッハ数n", "ja"));
  quantityKind.addLabel(new LangString("число Маха", "ru"));
  quantityKind.addLabel(new LangString("Machovo število", "sl"));
  quantityKind.addLabel(new LangString("Nombor Mach", "ms"));
  quantityKind.addLabel(new LangString("numero di Mach", "it"));
  quantityKind.addLabel(new LangString("عدد ماخ", "ar"));
  quantityKind.addLabel(new LangString("número de Mach", "es"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MACH");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MachNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MacroscopicCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Macroscopic Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CrossSection"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MacroscopicCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MacroscopicTotalCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Macroscopic Total Cross-section", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CrossSection"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MacroscopicTotalCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MadelungConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stała Madelunga", "pl"));
  quantityKind.addLabel(new LangString("постоянная Маделунга", "ru"));
  quantityKind.addLabel(new LangString("ثابت مادلونك", "ar"));
  quantityKind.addLabel(new LangString("Madelung constant", "en"));
  quantityKind.addLabel(new LangString("ثابت مادلونگ", "fa"));
  quantityKind.addLabel(new LangString("Costante di Madelung", "it"));
  quantityKind.addLabel(new LangString("Constante de Madelung", "es"));
  quantityKind.addLabel(new LangString("マーデルングエネルギー", "ja"));
  quantityKind.addLabel(new LangString("constante de Madelung", "pt"));
  quantityKind.addLabel(new LangString("Constante de Madelung", "fr"));
  quantityKind.addLabel(new LangString("馬德隆常數", "zh"));
  quantityKind.addLabel(new LangString("Madelung-Konstante", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MadelungConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Area Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab-CentiM2");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MagneticMoment"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M1H0T-2D0",
    "J_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Dipole Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M2-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMomentOfAMolecule",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    "0173-1#Z4-BAJ460#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("magnetic dipole moment of a molecule", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticDipoleMomentOfAMolecule",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticField",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Field", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gamma");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("jakost magnetnega polja", "sl"));
  quantityKind.addLabel(new LangString("Магнитное поле", "ru"));
  quantityKind.addLabel(new LangString("Magnetické pole", "cs"));
  quantityKind.addLabel(new LangString("Manyetik alan", "tr"));
  quantityKind.addLabel(new LangString("شدت میدان مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("intensidad de campo magnético", "es"));
  quantityKind.addLabel(new LangString("磁場", "zh"));
  quantityKind.addLabel(new LangString("intensidade de campo magnético", "pt"));
  quantityKind.addLabel(new LangString("Kekuatan medan magnetik", "ms"));
  quantityKind.addLabel(new LangString("磁場", "ja"));
  quantityKind.addLabel(new LangString("Câmp magnetic", "ro"));
  quantityKind.addLabel(new LangString("حقل مغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("magnetische Feldstärke", "de"));
  quantityKind.addLabel(new LangString("pole magnetyczne", "pl"));
  quantityKind.addLabel(new LangString("magnetic field strength", "en"));
  quantityKind.addLabel(new LangString("intensité de champ magnétique", "fr"));
  quantityKind.addLabel(new LangString("intensità di campo magnetico", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OERSTED");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFieldStrength_H",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFlux",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("flusso magnetico", "it"));
  quantityKind.addLabel(new LangString("Magnetický tok", "cs"));
  quantityKind.addLabel(new LangString("mágneses fluxus", "hu"));
  quantityKind.addLabel(new LangString("שטף מגנטי", "he"));
  quantityKind.addLabel(new LangString("التدفق المغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("شار مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("Flux d'induction magnétique", "fr"));
  quantityKind.addLabel(new LangString("Магнитный поток", "ru"));
  quantityKind.addLabel(new LangString("Магнитен поток", "bg"));
  quantityKind.addLabel(new LangString("flux de inducție magnetică", "ro"));
  quantityKind.addLabel(new LangString("fluxo magnético", "pt"));
  quantityKind.addLabel(new LangString("磁通量", "zh"));
  quantityKind.addLabel(new LangString("磁束", "ja"));
  quantityKind.addLabel(new LangString("fluxus magneticus", "la"));
  quantityKind.addLabel(new LangString("चुम्बकीय बहाव", "hi"));
  quantityKind.addLabel(new LangString("Fluks magnet", "ms"));
  quantityKind.addLabel(new LangString("manyetik akı", "tr"));
  quantityKind.addLabel(new LangString("magnetischer Flux", "de"));
  quantityKind.addLabel(new LangString("magnetic flux", "en"));
  quantityKind.addLabel(new LangString("flujo magnético", "es"));
  quantityKind.addLabel(new LangString("magnetni pretok", "sl"));
  quantityKind.addLabel(new LangString("strumień magnetyczny", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliWB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UnitPole");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("indukcja magnetyczna", "pl"));
  quantityKind.addLabel(new LangString("Densidad de flujo magnético", "es"));
  quantityKind.addLabel(new LangString("densitas fluxus magnetici", "la"));
  quantityKind.addLabel(new LangString("Магнитна индукция", "bg"));
  quantityKind.addLabel(new LangString("gostota magnetnega pretoka", "sl"));
  quantityKind.addLabel(new LangString("magnetische Flussdichte", "de"));
  quantityKind.addLabel(new LangString("inducție magnetică", "ro"));
  quantityKind.addLabel(new LangString("densidade de fluxo magnético", "pt"));
  quantityKind.addLabel(new LangString("磁通量密度", "zh"));
  quantityKind.addLabel(new LangString("magnetic flux density", "en"));
  quantityKind.addLabel(new LangString("Magnetická indukce", "cs"));
  quantityKind.addLabel(new LangString("צפיפות שטף מגנטי", "he"));
  quantityKind.addLabel(new LangString("चुम्बकीय क्षेत्र", "hi"));
  quantityKind.addLabel(new LangString("mágneses indukció", "hu"));
  quantityKind.addLabel(new LangString("Densité de flux magnétique", "fr"));
  quantityKind.addLabel(new LangString("چگالی شار مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("densità di flusso magnetico", "it"));
  quantityKind.addLabel(new LangString("المجال المغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("manyetik akı yoğunluğu", "tr"));
  quantityKind.addLabel(new LangString("Магнитная индукция", "ru"));
  quantityKind.addLabel(new LangString("Ketumpatan fluks magnet", "ms"));
  quantityKind.addLabel(new LangString("磁束密度", "ja"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gs");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gamma");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensityOrMagneticPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "0173-1#Z4-BAJ221#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("magnetic flux density or magnetic polarization", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensityOrMagneticPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic flux per length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-SEC-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerUnitLength",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic flux per unit length", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticFluxPerUnitLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticMoment",
    "http://qudt.org/vocab/dimensionvector/A0E1L2I0M0H0T0D0",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("momento de dipolo magnético", "es"));
  quantityKind.addLabel(new LangString("Momen magnetik", "ms"));
  quantityKind.addLabel(new LangString("momento di dipolo magnetico", "it"));
  quantityKind.addLabel(new LangString("moment magnétique", "fr"));
  quantityKind.addLabel(new LangString("चुम्बकीय द्विध्रुव", "hi"));
  quantityKind.addLabel(new LangString("momento de dipolo magnético", "pt"));
  quantityKind.addLabel(new LangString("Магнитный момент", "ru"));
  quantityKind.addLabel(new LangString("magnetisches Dipolmoment", "de"));
  quantityKind.addLabel(new LangString("دوقطبی مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("Magnetický dipól", "cs"));
  quantityKind.addLabel(new LangString("magnetic moment", "en"));
  quantityKind.addLabel(new LangString("عزم مغناطيسي", "ar"));
  quantityKind.addLabel(new LangString("磁気双極子", "ja"));
  quantityKind.addLabel(new LangString("dipol magnetyczny", "pl"));
  quantityKind.addLabel(new LangString("Manyetik moment", "tr"));
  quantityKind.addLabel(new LangString("磁偶极", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A_Ab-CentiM2");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MagneticAreaMoment"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticPolarization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Polarization", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticPolarization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Reluctivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-T-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-V-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticReluctivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticSusceptability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Susceptability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticSusceptability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticTension",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "U_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetic Tension", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticTension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("potencial magnético", "pt"));
  quantityKind.addLabel(new LangString("磁向量势", "zh"));
  quantityKind.addLabel(new LangString("potențial magnetic", "ro"));
  quantityKind.addLabel(new LangString("potentiel magnétique", "fr"));
  quantityKind.addLabel(new LangString("magnetisches Potenzial", "de"));
  quantityKind.addLabel(new LangString("magnetic vector potential", "en"));
  quantityKind.addLabel(new LangString("magnetický potenciál", "cs"));
  quantityKind.addLabel(new LangString("Keupayaan vektor magnetik", "ms"));
  quantityKind.addLabel(new LangString("potencial magnético", "es"));
  quantityKind.addLabel(new LangString("Магнитний потенциал", "ru"));
  quantityKind.addLabel(new LangString("potencjał magnetyczny", "pl"));
  quantityKind.addLabel(new LangString("manyetik potansiyeli", "tr"));
  quantityKind.addLabel(new LangString("پتانسیل برداری مغناطیسی", "fa"));
  quantityKind.addLabel(new LangString("potenziale vettore magnetico", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloWB-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-SEC-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WB-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagneticVectorPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Magnetization",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetisierung", "de"));
  quantityKind.addLabel(new LangString("magnetyzacia", "pl"));
  quantityKind.addLabel(new LangString("aimantation", "fr"));
  quantityKind.addLabel(new LangString("magnetizzazione", "it"));
  quantityKind.addLabel(new LangString("magnetización", "es"));
  quantityKind.addLabel(new LangString("намагниченность", "ru"));
  quantityKind.addLabel(new LangString("magnetização", "pt"));
  quantityKind.addLabel(new LangString("磁化", "ja"));
  quantityKind.addLabel(new LangString("magnetization", "en"));
  quantityKind.addLabel(new LangString("مغنطة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LinearElectricCurrent"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Magnetization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagnetizationField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-1I0M0H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetization Field", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliA-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-MilliM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricCurrentPerLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagnetizationField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Magnetomotive Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OERSTED-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MagnetomotiveForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Mass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m",
    undefined
  );
  quantityKind.addLabel(new LangString("masa", "es"));
  quantityKind.addLabel(new LangString("Hmotnost", "cs"));
  quantityKind.addLabel(new LangString("Masse", "de"));
  quantityKind.addLabel(new LangString("Маса", "bg"));
  quantityKind.addLabel(new LangString("Масса", "ru"));
  quantityKind.addLabel(new LangString("كتلة", "ar"));
  quantityKind.addLabel(new LangString("massa", "la"));
  quantityKind.addLabel(new LangString("Jisim", "ms"));
  quantityKind.addLabel(new LangString("Μάζα", "el"));
  quantityKind.addLabel(new LangString("质量", "zh"));
  quantityKind.addLabel(new LangString("भार", "hi"));
  quantityKind.addLabel(new LangString("מסה", "he"));
  quantityKind.addLabel(new LangString("tömeg", "hu"));
  quantityKind.addLabel(new LangString("kütle", "tr"));
  quantityKind.addLabel(new LangString("masse", "fr"));
  quantityKind.addLabel(new LangString("質量", "ja"));
  quantityKind.addLabel(new LangString("massa", "it"));
  quantityKind.addLabel(new LangString("massa", "pt"));
  quantityKind.addLabel(new LangString("masa", "sl"));
  quantityKind.addLabel(new LangString("masa", "pl"));
  quantityKind.addLabel(new LangString("masă", "ro"));
  quantityKind.addLabel(new LangString("جرم", "fa"));
  quantityKind.addLabel(new LangString("mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Mass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAbsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Absorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAbsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Amount of Substance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstanceTemperature",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Amount of Substance Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-DEG_F");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAmountOfSubstanceTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-GM_DRY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Concentration", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWater",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    "w",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Concentration of Water", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWater",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWaterVapour",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    "v",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Concentration of Water Vapour", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassConcentrationOfWaterVapour",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassDefect",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Defect", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassDefect",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("yoğunluk", "tr"));
  quantityKind.addLabel(new LangString("घनत्व", "hi"));
  quantityKind.addLabel(new LangString("плотность", "ru"));
  quantityKind.addLabel(new LangString("hustota", "cs"));
  quantityKind.addLabel(new LangString("چگالی", "fa"));
  quantityKind.addLabel(new LangString("densitate", "ro"));
  quantityKind.addLabel(new LangString("mass density", "en"));
  quantityKind.addLabel(new LangString("密度", "zh"));
  quantityKind.addLabel(new LangString("Ketumpatan jisim", "ms"));
  quantityKind.addLabel(new LangString("gęstość", "pl"));
  quantityKind.addLabel(new LangString("densité", "fr"));
  quantityKind.addLabel(new LangString("الكثافة", "ar"));
  quantityKind.addLabel(new LangString("Gostôta", "sl"));
  quantityKind.addLabel(new LangString("densidad", "es"));
  quantityKind.addLabel(new LangString("Massendichte", "de"));
  quantityKind.addLabel(new LangString("densità", "it"));
  quantityKind.addLabel(new LangString("密度", "ja"));
  quantityKind.addLabel(new LangString("densidade", "pt"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_LONG-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BAUME");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-GAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GRAIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_BRIX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DeciL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_TWADDELL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckDensity");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_BALLING"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEGREE_PLATO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEGREE_OECHSLE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Density");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassEnergyTransferCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Energy Transfer Coefficient", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassEnergyTransferCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassExcess",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Excess", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassExcess",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    "q_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTONNE-PER-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "0173-1#Z4-BAJ264#003",
    undefined
  );
  quantityKind.addLabel(new LangString("mass flux density", undefined));
  quantityKind.addLabel(new LangString("mass flux density", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "w_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFractionOfDryMatter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "w_d",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Fraction of Dry Matter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFractionOfDryMatter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassFractionOfWater",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "w_{H_2o}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Fraction of Water", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassFractionOfWater",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassOfElectricalPowerSupply",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{E}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Of Electrical Power Supply", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassOfElectricalPowerSupply",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassOfSolidBooster",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{SB}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Of Solid Booster", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassOfSolidBooster",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassOfTheEarth",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Of The Earth", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassOfTheEarth",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Area Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M2-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HA-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM2-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerAreaTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Electric Charge", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Energy", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-GigaJ"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-J");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-PA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-IN3-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-FT3-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Length", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TEX");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Denier");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassPerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass per Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassPerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R or M_{R}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterToDryMatter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "u",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Concentration of Water To Dry Matter", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterToDryMatter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterVapourToDryGas",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "x",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Mass Ratio of Water Vapour to Dry Gas", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRatioOfWaterVapourToDryGas",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassRelatedElectricalCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    "0173-1#Z4-BAJ347#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("mass-related electrical current", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassRelatedElectricalCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("mass stopping power", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-CentiM2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mass Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-DEG_R");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Massic Activity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("massic electric current", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "0173-1#Z4-BAJ345#002",
    undefined
  );
  quantityKind.addLabel(new LangString("massic heat capacity", undefined));
  quantityKind.addLabel(new LangString("massic heat capacity", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    "0173-1#Z4-BAJ343#002",
    undefined
  );
  quantityKind.addLabel(new LangString("massic power", "en-US"));
  quantityKind.addLabel(new LangString("massic power", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassicTorque",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "0173-1#Z4-BAJ442#002",
    undefined
  );
  quantityKind.addLabel(new LangString("massic torque", "en-US"));
  quantityKind.addLabel(new LangString("massic torque", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassicTorque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MassieuFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Massieu Function", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MassieuFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaxExpectedOperatingThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Maximum Expected Operating Thrust", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MaxOperatingThrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaxExpectedOperatingThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaxOperatingThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Max Operating Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaxOperatingThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaxSeaLevelThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Max Sea Level Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaxSeaLevelThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaximumBeta-ParticleEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Eᵦ",
    undefined
  );
  quantityKind.addLabel(new LangString("Maximum Beta-Particle Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaximumBeta-ParticleEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaximumExpectedOperatingPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Maximum Expected Operating Pressure", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaximumExpectedOperatingPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MaximumOperatingPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Maximum Operating Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MaximumOperatingPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanEnergyImparted",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "ε̅",
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Energy Imparted", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanEnergyImparted",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanFreePath",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "λ",
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Free Path", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanFreePath",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanLifetime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Lifetime", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanLifetime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanLinearRange",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Linear Range", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanLinearRange",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeanMassRange",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mean Mass Range", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeanMassRange",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical Impedance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalMobility",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical Mobility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalMobility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalSurfaceImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Mechanical surface impedance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalSurfaceImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MechanicalTension",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "0173-1#Z4-BAJ204#005",
    undefined
  );
  quantityKind.addLabel(new LangString("mechanical tension", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MechanicalTension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MeltingPoint",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Melting Point Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MeltingPoint",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MicroCanonicalPartitionFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Micro Canonical Partition Function", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CanonicalPartitionFunction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MicroCanonicalPartitionFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MicrobialFormation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Microbial Formation", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MicrobialFormation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MigrationArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "M^2",
    undefined
  );
  quantityKind.addLabel(new LangString("Migration Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MigrationArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MigrationLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Migration Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MigrationLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Mobility",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("mobilità", "it"));
  quantityKind.addLabel(new LangString("迁移率", "zh"));
  quantityKind.addLabel(new LangString("mobilidade", "pt"));
  quantityKind.addLabel(new LangString("قابلية التحرك", "ar"));
  quantityKind.addLabel(new LangString("movilidad", "es"));
  quantityKind.addLabel(new LangString("mobility", "en"));
  quantityKind.addLabel(new LangString("移動度", "ja"));
  quantityKind.addLabel(new LangString("mobilność", "pl"));
  quantityKind.addLabel(new LangString("mobilité", "fr"));
  quantityKind.addLabel(new LangString("Beweglichkeit", "de"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-V-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-V-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Mobility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MobilityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "b",
    undefined
  );
  quantityKind.addLabel(new LangString("Mobility Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MobilityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfAdmittance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "Y",
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus Of Admittance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfAdmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus of Elasticity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfElasticity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus Of Impedance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Modulus of Linear Subgrade Reaction", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfLinearSubgradeReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Modulus of Rotational Subgrade Reaction", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M-RAD");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfRotationalSubgradeReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Modulus of Subgrade Reaction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ModulusOfSubgradeReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MoistureDiffusivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    "q_V",
    undefined
  );
  quantityKind.addLabel(new LangString("Moisture Diffusivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MoistureDiffusivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M-1H0T0D0",
    "b_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Molality of Solute", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolalityOfSolute",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    "x",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Absorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-MOL");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarAngularMomentum",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Angular Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarAngularMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    "x",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Attenuation Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-MOL");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MolarAbsorptionCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarAttenuationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarConductivity",
    "http://qudt.org/vocab/dimensionvector/A-1E2L0I0M-1H0T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Conductivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/S-M2-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarDensity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M0H0T0D0",
    "0173-1#Z4-BAJ372#002",
    undefined
  );
  quantityKind.addLabel(new LangString("molar density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    "U_M",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Energy", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarEntropy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    "S_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Entropy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarFlowRate",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    "q_V",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Flow Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SCF-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-MIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    "C_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Heat Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarInternalEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("molar internal energy", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarInternalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarMass",
    "http://qudt.org/vocab/dimensionvector/A-1E0L0I0M1H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("masa molar", "es"));
  quantityKind.addLabel(new LangString("molar mass", "en"));
  quantityKind.addLabel(new LangString("摩尔质量", "zh"));
  quantityKind.addLabel(new LangString("جرم مولی", "fa"));
  quantityKind.addLabel(new LangString("Masa molowa", "pl"));
  quantityKind.addLabel(new LangString("massa molar", "pt"));
  quantityKind.addLabel(new LangString("モル質量", "ja"));
  quantityKind.addLabel(new LangString("Молярная масса", "ru"));
  quantityKind.addLabel(new LangString("كتلة مولية", "ar"));
  quantityKind.addLabel(new LangString("massa molare", "it"));
  quantityKind.addLabel(new LangString("molar kütle", "tr"));
  quantityKind.addLabel(new LangString("Jisim molar", "ms"));
  quantityKind.addLabel(new LangString("मोलर द्रव्यमान", "hi"));
  quantityKind.addLabel(new LangString("masse molaire", "fr"));
  quantityKind.addLabel(new LangString("Molmasse", "de"));
  quantityKind.addLabel(new LangString("Masă molară", "ro"));
  quantityKind.addLabel(new LangString("Molární hmotnost", "cs"));
  quantityKind.addLabel(new LangString("molska masa", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotationalAbility",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    "0173-1#Z4-BAJ426#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("molar optical rotational ability", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotationalAbility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotatoryPower",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Optical Rotatory Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/RAD-M2-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarOpticalRotatoryPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molar Refractivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/L-PER-MicroMOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarRefractivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarThermalCapacity",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H-1T-2D0",
    "0173-1#Z4-BAJ355#002",
    undefined
  );
  quantityKind.addLabel(new LangString("molar thermal capacity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarThermalCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarThermodynamicEnergy",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ353#002",
    undefined
  );
  quantityKind.addLabel(new LangString("molar thermodynamic energy", "en-US"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MolarEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarThermodynamicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolarVolume",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T0D0",
    "V_m",
    undefined
  );
  quantityKind.addLabel(new LangString("volume molar", "pl"));
  quantityKind.addLabel(new LangString("volume molare", "it"));
  quantityKind.addLabel(new LangString("摩尔体积", "zh"));
  quantityKind.addLabel(new LangString("molski volumen", "sl"));
  quantityKind.addLabel(new LangString("حجم مولی", "fa"));
  quantityKind.addLabel(new LangString("molární objem", "cs"));
  quantityKind.addLabel(new LangString("حجم مولي", "ar"));
  quantityKind.addLabel(new LangString("Molvolumen", "de"));
  quantityKind.addLabel(new LangString("molar hacim", "tr"));
  quantityKind.addLabel(new LangString("volume molar", "pt"));
  quantityKind.addLabel(new LangString("molar volume", "en"));
  quantityKind.addLabel(new LangString("モル体積", "ja"));
  quantityKind.addLabel(new LangString("volum molar", "ro"));
  quantityKind.addLabel(new LangString("volume molaire", "fr"));
  quantityKind.addLabel(new LangString("Молярный объём", "ru"));
  quantityKind.addLabel(new LangString("volumen molar", "es"));
  quantityKind.addLabel(new LangString("Isipadu molar", "ms"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/L-PER-MicroMOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolarVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MoleFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mole Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MoleFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolecularConcentration",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "C_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Molecular Concentration", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolecularConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolecularMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Molecular Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Da");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolecularMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MolecularViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Molecular Viscosity", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MolecularViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentOfForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Moment of Force", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN-M");
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Torque");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentOfForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("慣性モーメント", "ja"));
  quantityKind.addLabel(new LangString("Momen inersia", "ms"));
  quantityKind.addLabel(new LangString("Moment bezwładności", "pl"));
  quantityKind.addLabel(new LangString("Massenträgheitsmoment", "de"));
  quantityKind.addLabel(new LangString("Moment setrvačnosti", "cs"));
  quantityKind.addLabel(new LangString("گشتاور لختی", "fa"));
  quantityKind.addLabel(new LangString("Moment de inerție", "ro"));
  quantityKind.addLabel(new LangString("momento de inércia", "pt"));
  quantityKind.addLabel(new LangString("momento di inerzia", "it"));
  quantityKind.addLabel(new LangString("Eylemsizlik momenti", "tr"));
  quantityKind.addLabel(new LangString("moment d'inertie", "fr"));
  quantityKind.addLabel(new LangString("عزم القصور الذاتي", "ar"));
  quantityKind.addLabel(new LangString("moment of inertia", "en"));
  quantityKind.addLabel(new LangString("momento de inercia", "es"));
  quantityKind.addLabel(new LangString("जड़त्वाघूर्ण", "hi"));
  quantityKind.addLabel(new LangString("Момент инерции", "ru"));
  quantityKind.addLabel(new LangString("轉動慣量", "zh"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/RotationalMass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Momentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("动量", "zh"));
  quantityKind.addLabel(new LangString("impuls", "ro"));
  quantityKind.addLabel(new LangString("quantité de mouvement", "fr"));
  quantityKind.addLabel(new LangString("تکانه", "fa"));
  quantityKind.addLabel(new LangString("momento linear", "pt"));
  quantityKind.addLabel(new LangString("Momentum", "ms"));
  quantityKind.addLabel(new LangString("cantidad de movimiento", "es"));
  quantityKind.addLabel(new LangString("運動量", "ja"));
  quantityKind.addLabel(new LangString("quantità di moto", "it"));
  quantityKind.addLabel(new LangString("pęd", "pl"));
  quantityKind.addLabel(new LangString("hybnost", "cs"));
  quantityKind.addLabel(new LangString("gibalna količina", "sl"));
  quantityKind.addLabel(new LangString("momentum", "en"));
  quantityKind.addLabel(new LangString("Impuls", "de"));
  quantityKind.addLabel(new LangString("Momentum", "tr"));
  quantityKind.addLabel(new LangString("импульс", "ru"));
  quantityKind.addLabel(new LangString("زخم الحركة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckMomentum"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Momentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MomentumPerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Momentum per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MomentumPerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MorbidityRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Morbidity Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MorbidityRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MortalityRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Mortality Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Incidence"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MortalityRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MotorConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "0173-1#Z4-BAJ358#003",
    undefined
  );
  quantityKind.addLabel(new LangString("motor constant", undefined));
  quantityKind.addLabel(new LangString("motor constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MotorConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k",
    undefined
  );
  quantityKind.addLabel(new LangString("Multiplication Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MultiplicationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/MutualInductance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    "L_{mn}",
    undefined
  );
  quantityKind.addLabel(new LangString("Mutual Inductance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H_Stat");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Inductance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/MutualInductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NOMINAL-ASCENT-PROPELLANT-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Nominal Ascent Propellant Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NOMINAL-ASCENT-PROPELLANT-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NapierianAbsorbance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_e, B",
    undefined
  );
  quantityKind.addLabel(new LangString("Napierian Absorbance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NapierianAbsorbance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeelTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_C",
    undefined
  );
  quantityKind.addLabel(new LangString("Neel Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeelTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutralRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ359#002",
    undefined
  );
  quantityKind.addLabel(new LangString("neutral ratio", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutralRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "D",
    undefined
  );
  quantityKind.addLabel(new LangString("Diffusionskoeffizient", "de"));
  quantityKind.addLabel(new LangString("coeficiente de difusión", "es"));
  quantityKind.addLabel(new LangString("coefficiente di diffusione", "it"));
  quantityKind.addLabel(new LangString("coefficient de diffusion", "fr"));
  quantityKind.addLabel(new LangString("coeficiente de difusão", "pt"));
  quantityKind.addLabel(new LangString("difuzijski koeficient", "sl"));
  quantityKind.addLabel(new LangString("diffusion coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L_{r}",
    undefined
  );
  quantityKind.addLabel(new LangString("Neutron Diffusion Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronDiffusionLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N",
    undefined
  );
  quantityKind.addLabel(new LangString("liczba neutronowa", "pl"));
  quantityKind.addLabel(new LangString("Nombor neutron", "ms"));
  quantityKind.addLabel(new LangString("Neutronové číslo", "cs"));
  quantityKind.addLabel(new LangString("numero neutronico", "it"));
  quantityKind.addLabel(new LangString("число нейтронов", "ru"));
  quantityKind.addLabel(new LangString("Nombre de neutrons", "fr"));
  quantityKind.addLabel(new LangString("número neutrónico", "es"));
  quantityKind.addLabel(new LangString("عدد نوترون", "fa"));
  quantityKind.addLabel(new LangString("número de neutrons", "pt"));
  quantityKind.addLabel(new LangString("Neutronenzahl", "de"));
  quantityKind.addLabel(new LangString("neutron number", "en"));
  quantityKind.addLabel(new LangString("中子數", "zh"));
  quantityKind.addLabel(new LangString("nötron snumarası", "tr"));
  quantityKind.addLabel(new LangString("عدد النيوترونات", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerAbsorption",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Neutron Yield per Absorption", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerAbsorption",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerFission",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Neutron Yield per Fission", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NeutronYieldPerFission",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Non-LeakageProbability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Non-Leakage Probability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Non-LeakageProbability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NonActivePower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "Q'",
    undefined
  );
  quantityKind.addLabel(new LangString("Non-active Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaV-A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV-A");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NonActivePower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NonNegativeLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NonNegativeLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NormalStress",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Normal Stress", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Stress"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NormalStress",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NormalizedDimensionlessRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Dimensionless Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NormalizedDimensionlessRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleThroatCrossSectionalArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "A^*",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Nozzle Throat Cross-sectional Area", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleThroatCrossSectionalArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleThroatDiameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Nozzle Throat Diameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleThroatDiameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleThroatPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p^*",
    undefined
  );
  quantityKind.addLabel(new LangString("Nozzle Throat Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleThroatPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NozzleWallsThrustReaction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "F_R",
    undefined
  );
  quantityKind.addLabel(new LangString("Nozzle Walls Thrust Reaction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NozzleWallsThrustReaction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("nuclear energy", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Nuclear Quadrupole Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearQuadrupoleMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearRadius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Nuclear Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearRadius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NuclearSpinQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Spin Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NuclearSpinQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NucleonNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("numero di massa", "it"));
  quantityKind.addLabel(new LangString("عدد جرمی", "fa"));
  quantityKind.addLabel(new LangString("liczba masowa", "pl"));
  quantityKind.addLabel(new LangString("nucleon number", "en"));
  quantityKind.addLabel(new LangString("質量数", "ja"));
  quantityKind.addLabel(new LangString("nükleon numarası", "tr"));
  quantityKind.addLabel(new LangString("Nukleonenzahl", "de"));
  quantityKind.addLabel(new LangString("número de massa", "pt"));
  quantityKind.addLabel(new LangString("nombre de masse", "fr"));
  quantityKind.addLabel(new LangString("Nukleové číslo", "cs"));
  quantityKind.addLabel(new LangString("Nombor nukleon", "ms"));
  quantityKind.addLabel(new LangString("质量数", "zh"));
  quantityKind.addLabel(new LangString("número másico", "es"));
  quantityKind.addLabel(new LangString("عدد كتلي", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NucleonNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NumberDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Number Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NumberDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/NumberOfParticles",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Number of Particles", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/NumberOfParticles",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OlfactoryThreshold",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Olfactory Threshold", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Concentration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OlfactoryThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OpeningRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Opening Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OpeningRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumPerMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "h",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Orbital Angular Momentum per Mass", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumPerMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumPerUnitMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "h",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Orbital Angular Momentum per Unit Mass", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumPerUnitMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "l",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Orbital Angular Momentum Quantum Number", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrbitalAngularMomentumQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrbitalRadialDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r",
    undefined
  );
  quantityKind.addLabel(new LangString("Orbital Radial Distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrbitalRadialDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OrderOfReflection",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Order of Reflection", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OrderOfReflection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OsmoticCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Osmotic Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OsmoticCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OsmoticPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "Π",
    undefined
  );
  quantityKind.addLabel(new LangString("Tekanan osmotik", "ms"));
  quantityKind.addLabel(new LangString("presión osmótica", "es"));
  quantityKind.addLabel(new LangString("pressione osmotica", "it"));
  quantityKind.addLabel(new LangString("osmotic pressure", "en"));
  quantityKind.addLabel(new LangString("osmotischer Druck", "de"));
  quantityKind.addLabel(new LangString("فشار اسمزی", "fa"));
  quantityKind.addLabel(new LangString("pression osmotique", "fr"));
  quantityKind.addLabel(new LangString("Osmotický tlak", "cs"));
  quantityKind.addLabel(new LangString("ozmotik basıç", "tr"));
  quantityKind.addLabel(new LangString("pressão osmótica", "pt"));
  quantityKind.addLabel(new LangString("渗透压", "zh"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OsmoticPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/OverRangeDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "s_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Over-range distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/OverRangeDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PREDICTED-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Predicted Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PREDICTED-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Product of Inertia", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_X",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the X axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_X",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Y",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the Y axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Y",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Z",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Product of Inertia in the Z axis", "en")
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PRODUCT-OF-INERTIA_Z",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PackingFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(new LangString("Packing Fraction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PackingFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PartialPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p_B",
    undefined
  );
  quantityKind.addLabel(new LangString("Partial Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PartialPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/failures-in-time"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    "0173-1#Z4-BAJ388#002",
    undefined
  );
  quantityKind.addLabel(new LangString("particle current density", undefined));
  quantityKind.addLabel(new LangString("particle current density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleFluence",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Fluence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-KiloM2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleFluence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Fluence Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-L-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M2-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleNumberDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Number Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MicroL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NumberDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleNumberDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticlePositionVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r, R",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Position Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticlePositionVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ParticleSourceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("Particle Source Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ParticleSourceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PathLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("Path Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PathLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PayloadMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_P",
    undefined
  );
  quantityKind.addLabel(new LangString("Payload Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PayloadMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PayloadRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Payload Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PayloadRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PeltierCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Peltier Coefficient", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PeltierCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Period",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Period", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Period",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Permeability",
    "http://qudt.org/vocab/dimensionvector/A0E-2L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/H_Stat-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroH-PER-M");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticPermeability"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Permeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PermeabilityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeability Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMEABILITY_REL"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PermeabilityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Permeance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permeance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoH");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Permeance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Permittivity",
    "http://qudt.org/vocab/dimensionvector/A0E2L-3I0M-1H0T4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permittivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroFARAD-PER-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FARAD-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoFARAD-PER-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoFARAD-PER-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FARAD-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Permittivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PermittivityRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Permittivity Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PermittivityRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Phase coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhaseCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhaseDifference",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("اختلاف طور", "ar"));
  quantityKind.addLabel(new LangString("Phasenverschiebungswinkel", "de"));
  quantityKind.addLabel(new LangString("位相差", "ja"));
  quantityKind.addLabel(new LangString("différence de phase", "fr"));
  quantityKind.addLabel(new LangString("phase difference", "en"));
  quantityKind.addLabel(new LangString("diferença de fase", "pt"));
  quantityKind.addLabel(new LangString("diferencia de fase", "es"));
  quantityKind.addLabel(new LangString("przesunięcie fazowe", "pl"));
  quantityKind.addLabel(new LangString("sfasamento angolare", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhaseDifference",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Phase speed of sound", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhaseSpeedOfSound",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhononMeanFreePath",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "l_{ph}",
    undefined
  );
  quantityKind.addLabel(new LangString("Phonon Mean Free Path", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhononMeanFreePath",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotoThresholdOfAwarenessFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Photo Threshold of Awareness Function", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotoThresholdOfAwarenessFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotonIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Photon Intensity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotonIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotonLuminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    "0173-1#Z4-BAJ363#002",
    undefined
  );
  quantityKind.addLabel(new LangString("photon luminance", "en-US"));
  quantityKind.addLabel(new LangString("photon luminance", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotonLuminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotonRadiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Photon Radiance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-M2-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotonRadiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFlux",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Photosynthetic Photon Flux", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A1E0L-2I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Photosynthetic Photon Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PhotosyntheticPhotonFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PictureElement",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ437#002",
    undefined
  );
  quantityKind.addLabel(new LangString("picture element", undefined));
  quantityKind.addLabel(new LangString("picture element", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PIXEL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PictureElement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Piece",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("piece", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Piece",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PlanarForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Flächenlast", "de"));
  quantityKind.addLabel(new LangString("Planar Force", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PlanarForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PlanckFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Planck Function", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PlanckFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Rovinný úhel", "cs"));
  quantityKind.addLabel(new LangString("क्षेत्र", "hi"));
  quantityKind.addLabel(new LangString("זווית", "he"));
  quantityKind.addLabel(new LangString("Равнинен ъгъл", "bg"));
  quantityKind.addLabel(new LangString("زاویه مستوی", "fa"));
  quantityKind.addLabel(new LangString("plane angle", "en"));
  quantityKind.addLabel(new LangString("angulus planus", "la"));
  quantityKind.addLabel(new LangString("弧度", "ja"));
  quantityKind.addLabel(new LangString("角度", "zh"));
  quantityKind.addLabel(new LangString("kąt płaski", "pl"));
  quantityKind.addLabel(new LangString("Плоский угол", "ru"));
  quantityKind.addLabel(new LangString("ángulo plano", "es"));
  quantityKind.addLabel(new LangString("Επίπεδη γωνία", "el"));
  quantityKind.addLabel(new LangString("düzlemsel açı", "tr"));
  quantityKind.addLabel(new LangString("Sudut satah", "ms"));
  quantityKind.addLabel(new LangString("ebener Winkel", "de"));
  quantityKind.addLabel(new LangString("angolo piano", "it"));
  quantityKind.addLabel(new LangString("szög", "hu"));
  quantityKind.addLabel(new LangString("unghi plan", "ro"));
  quantityKind.addLabel(new LangString("medida angular", "pt"));
  quantityKind.addLabel(new LangString("angle plan", "fr"));
  quantityKind.addLabel(new LangString("الزاوية النصف قطرية", "ar"));
  quantityKind.addLabel(new LangString("ravninski kot", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addExactMatchIri("http://qudt.org/vocab/quantitykind/Angle");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PoissonRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Poisson Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PoissonRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PolarMomentOfInertia",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "J_{zz}",
    undefined
  );
  quantityKind.addLabel(new LangString("Polar moment of inertia", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PolarMomentOfInertia",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Polarizability",
    "http://qudt.org/vocab/dimensionvector/A0E2L0I0M-1H0T4D0",
    "0173-1#Z4-BAJ365#002",
    undefined
  );
  quantityKind.addLabel(new LangString("polarisability", "en"));
  quantityKind.addLabel(new LangString("Polarizability", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C2-M2-PER-J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-M2-PER-V");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Polarizability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PolarizationField",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T1D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("Polarization Field", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Ab-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroC-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C_Stat-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/C-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloC-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricChargePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PolarizationField",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Population",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Population", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Population",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositionVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r",
    undefined
  );
  quantityKind.addLabel(new LangString("Position Vector", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositionVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositiveDimensionlessRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Dimensionless Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositiveDimensionlessRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositiveLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/NonNegativeLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositiveLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PositivePlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Positive Plane Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PlaneAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PositivePlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PotentialEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "PE",
    undefined
  );
  quantityKind.addLabel(new LangString("Tenaga keupayaan", "ms"));
  quantityKind.addLabel(new LangString("energia potenziale", "it"));
  quantityKind.addLabel(new LangString("انرژی پتانسیل", "fa"));
  quantityKind.addLabel(new LangString("потенциальная энергия", "ru"));
  quantityKind.addLabel(new LangString("Energia potencjalna", "pl"));
  quantityKind.addLabel(new LangString("potentielle Energie", "de"));
  quantityKind.addLabel(new LangString("Potansiyel enerji", "tr"));
  quantityKind.addLabel(new LangString("势能", "zh"));
  quantityKind.addLabel(new LangString("énergie potentielle", "fr"));
  quantityKind.addLabel(new LangString("طاقة وضع", "ar"));
  quantityKind.addLabel(new LangString("位置エネルギー", "ja"));
  quantityKind.addLabel(new LangString("energía potencial", "es"));
  quantityKind.addLabel(new LangString("potential energy", "en"));
  quantityKind.addLabel(new LangString("potenciální energie", "cs"));
  quantityKind.addLabel(new LangString("स्थितिज ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("energia potencial", "pt"));
  quantityKind.addLabel(new LangString("Energie potențială", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PotentialEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Power",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("puissance", "fr"));
  quantityKind.addLabel(new LangString("शक्ति", "hi"));
  quantityKind.addLabel(new LangString("putere", "ro"));
  quantityKind.addLabel(new LangString("Мощность", "ru"));
  quantityKind.addLabel(new LangString("Leistung", "de"));
  quantityKind.addLabel(new LangString("teljesítmény , hőáramlás", "hu"));
  quantityKind.addLabel(new LangString("הספק", "he"));
  quantityKind.addLabel(new LangString("potenza", "it"));
  quantityKind.addLabel(new LangString("potentia", "la"));
  quantityKind.addLabel(new LangString("potencia", "es"));
  quantityKind.addLabel(new LangString("Výkon", "cs"));
  quantityKind.addLabel(new LangString("moc", "pl"));
  quantityKind.addLabel(new LangString("Мощност", "bg"));
  quantityKind.addLabel(new LangString("potência", "pt"));
  quantityKind.addLabel(new LangString("power", "en"));
  quantityKind.addLabel(new LangString("توان، نرخ جریان گرما", "fa"));
  quantityKind.addLabel(new LangString("Kuasa", "ms"));
  quantityKind.addLabel(new LangString("功率、热流", "zh"));
  quantityKind.addLabel(new LangString("電力・仕事率", "ja"));
  quantityKind.addLabel(new LangString("القدرة", "ar"));
  quantityKind.addLabel(new LangString("moč", "sl"));
  quantityKind.addLabel(new LangString("Ισχύς", "el"));
  quantityKind.addLabel(new LangString("güç", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Power",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerAreaPerSolidAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Area per Solid Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-M2-PER-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerAreaPerSolidAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerConstant",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "0173-1#Z4-BAJ330#003",
    undefined
  );
  quantityKind.addLabel(new LangString("power constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("factor de potencia", "es"));
  quantityKind.addLabel(new LangString("Účiník", "cs"));
  quantityKind.addLabel(new LangString("力率", "ja"));
  quantityKind.addLabel(new LangString("功率因数", "zh"));
  quantityKind.addLabel(new LangString("ضریب توان", "fa"));
  quantityKind.addLabel(new LangString("faktor kuasa", "ms"));
  quantityKind.addLabel(new LangString("power factor", "en"));
  quantityKind.addLabel(new LangString("Коэффициент_мощности", "ru"));
  quantityKind.addLabel(new LangString("factor de putere", "ro"));
  quantityKind.addLabel(new LangString("fator de potência", "pt"));
  quantityKind.addLabel(new LangString("Leistungsfaktor", "de"));
  quantityKind.addLabel(new LangString("معامل القدرة", "ar"));
  quantityKind.addLabel(new LangString("शक्ति गुणांक", "hi"));
  quantityKind.addLabel(new LangString("güç faktörü", "tr"));
  quantityKind.addLabel(new LangString("facteur de puissance", "fr"));
  quantityKind.addLabel(new LangString("fattore di potenza", "it"));
  quantityKind.addLabel(new LangString("Współczynnik mocy", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Per Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power per Area Angle", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaQuarticTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-4T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Power per area quartic temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaQuarticTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Power Per Electric Charge", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-PER-MicroSEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliV-PER-MIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PowerPerElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PoyntingVector",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("ポインティングベクトル", "ja"));
  quantityKind.addLabel(new LangString("vecteur de Poynting", "fr"));
  quantityKind.addLabel(new LangString("Poynting-Vektor", "de"));
  quantityKind.addLabel(new LangString("vector de Poynting", "pt"));
  quantityKind.addLabel(new LangString("wektor Poyntinga", "pl"));
  quantityKind.addLabel(new LangString("vettore di Poynting", "it"));
  quantityKind.addLabel(new LangString("متجَه بوينتنج", "ar"));
  quantityKind.addLabel(new LangString("Poynting vector", "en"));
  quantityKind.addLabel(new LangString("вектор Пойнтинга", "ru"));
  quantityKind.addLabel(new LangString("vector de Poynting", "es"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PoyntingVector",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Pressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("压强、压力", "zh"));
  quantityKind.addLabel(new LangString("pressio", "la"));
  quantityKind.addLabel(new LangString("basınç", "tr"));
  quantityKind.addLabel(new LangString("ciśnienie", "pl"));
  quantityKind.addLabel(new LangString("Давление", "ru"));
  quantityKind.addLabel(new LangString("فشار، تنش", "fa"));
  quantityKind.addLabel(new LangString("pression", "fr"));
  quantityKind.addLabel(new LangString("Tekanan", "ms"));
  quantityKind.addLabel(new LangString("nyomás", "hu"));
  quantityKind.addLabel(new LangString("presiune", "ro"));
  quantityKind.addLabel(new LangString("tlak", "sl"));
  quantityKind.addLabel(new LangString("Налягане", "bg"));
  quantityKind.addLabel(new LangString("presión", "es"));
  quantityKind.addLabel(new LangString("Πίεση - τάση", "el"));
  quantityKind.addLabel(new LangString("pressure", "en"));
  quantityKind.addLabel(new LangString("לחץ", "he"));
  quantityKind.addLabel(new LangString("Druck", "de"));
  quantityKind.addLabel(new LangString("圧力", "ja"));
  quantityKind.addLabel(new LangString("pressão", "pt"));
  quantityKind.addLabel(new LangString("الضغط أو الإجهاد", "ar"));
  quantityKind.addLabel(new LangString("pressione", "it"));
  quantityKind.addLabel(new LangString("Tlak", "cs"));
  quantityKind.addLabel(new LangString("दबाव", "hi"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Pressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedAmountOfSubstanceConcentration",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ307#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based amount-of-substance concentration", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedAmountOfSubstanceConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedDensity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ299#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedDynamicViscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "0173-1#Z4-BAJ300#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based dynamic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedDynamicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ309#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based electric current", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L3I0M0H0T-1D0",
    "0173-1#Z4-BAJ301#003",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based electric voltage", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedElectricVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedKinematicViscosity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ303#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure-based kinematic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedKinematicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedLength",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ304#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based length", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedMass",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ305#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based mass", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedMassFlow",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ310#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based mass flow", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedMassFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedMolality",
    "http://qudt.org/vocab/dimensionvector/A1E0L1I0M-2H0T2D0",
    "0173-1#Z4-BAJ306#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based molality", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedMolality",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedQuantity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedTemperature",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ308#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based temperature", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedVelocity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ302#001",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based velocity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolume",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ312#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based volume", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolumeFlow",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ311#002",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure-based volume flow", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBasedVolumeFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Burning Rate Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Burning Rate Index", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureBurningRateIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-PER-DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureGradient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    "0173-1#Z4-BAJ313#003",
    undefined
  );
  quantityKind.addLabel(new LangString("pressure gradient", undefined));
  quantityKind.addLabel(new LangString("pressure gradient", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-PER-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureGradient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    "0173-1#Z4-BAJ290#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure in relation to volume flow", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L-4I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("pressure in relation to volume flow rate", undefined)
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureInRelationToVolumeFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureLossPerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Loss per Length", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureLossPerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressurePercentage",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Percentage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressurePercentage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PressureRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Pressure Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-PER-BAR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PressureRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Prevalence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Prevalence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Prevalence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PrincipalQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Principal Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PrincipalQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Propagation coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropagationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantBurnRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Propellant Burn Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/BurnRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantBurnRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_f",
    undefined
  );
  quantityKind.addLabel(new LangString("Propellant Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantMeanBulkTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Propellant Mean Bulk Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PropellantTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantMeanBulkTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/PropellantTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Propellant Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/PropellantTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QualityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Quality Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QualityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QuantityOfLight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I1M0H0T1D0",
    "0173-1#Z4-BAJ243#002",
    undefined
  );
  quantityKind.addLabel(new LangString("quantity of light", "en-US"));
  quantityKind.addLabel(new LangString("quantity of light", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QuantityOfLight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/QuarticElectricDipoleMomentPerCubicEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E4L-2I0M-3H0T10D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Quartic Electric Dipole Moment per Cubic Energy", "en")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/QuarticElectricDipoleMomentPerCubicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RESERVE-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_{E}",
    undefined
  );
  quantityKind.addLabel(new LangString("Reserve Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RESERVE-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RF-Power",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("RF-Power Level", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SignalStrength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RF-Power",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadialDistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radial Distance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadialDistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-SR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerAreaAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadianceFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiance Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadianceFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEmmitance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Emmitance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEmmitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q_e",
    undefined
  );
  quantityKind.addLabel(new LangString("energia radiante", "it"));
  quantityKind.addLabel(new LangString("energia promienista", "pl"));
  quantityKind.addLabel(new LangString("radiant energy", "en"));
  quantityKind.addLabel(new LangString("انرژی تابشی", "fa"));
  quantityKind.addLabel(new LangString("energie záření", "cs"));
  quantityKind.addLabel(new LangString("энергия излучения", "ru"));
  quantityKind.addLabel(new LangString("Tenaga sinaran", "ms"));
  quantityKind.addLabel(new LangString("विकिरण ऊर्जा", "hi"));
  quantityKind.addLabel(new LangString("辐射能", "zh"));
  quantityKind.addLabel(new LangString("énergie rayonnante", "fr"));
  quantityKind.addLabel(new LangString("طاقة إشعاعية", "ar"));
  quantityKind.addLabel(new LangString("Işınım erkesi", "tr"));
  quantityKind.addLabel(new LangString("放射エネルギー", "ja"));
  quantityKind.addLabel(new LangString("energía radiante", "es"));
  quantityKind.addLabel(new LangString("Strahlungsenergie", "de"));
  quantityKind.addLabel(new LangString("energia radiante", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyExposure",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("radiant energy exposure", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantEnergyExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantExposure",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "H_e",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Exposure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantFluence",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "H_e,0",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Fluence", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantFluence",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantFluenceRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "E_e,0",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Fluence Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantFluenceRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantFlux",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("قدرة إشعاعية", "ar"));
  quantityKind.addLabel(new LangString("Strahlungsfluss", "de"));
  quantityKind.addLabel(new LangString("flusso radiante", "it"));
  quantityKind.addLabel(new LangString("potencia radiante", "es"));
  quantityKind.addLabel(new LangString("potência radiante", "pt"));
  quantityKind.addLabel(new LangString("放射パワー", "ja"));
  quantityKind.addLabel(new LangString("moc promieniowania", "pl"));
  quantityKind.addLabel(new LangString("flux énergétique", "fr"));
  quantityKind.addLabel(new LangString("radiant flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiantIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Radiant Intensity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiantIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiativeHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiative Heat Transfer", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/HeatFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiativeHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadioactiveDecay",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("radioactive decay", undefined));
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadioactiveDecay",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radioactivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ230#002",
    undefined
  );
  quantityKind.addLabel(new LangString("radioactivity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radioactivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radiosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radiosity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radiosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Radius",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "r",
    undefined
  );
  quantityKind.addLabel(new LangString("Radius", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Radius",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RadiusOfCurvature",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Radius of Curvature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RadiusOfCurvature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RankineTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "0173-1#Z4-BAJ367#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Rankine temperature", "en-US"));
  quantityKind.addLabel(new LangString("Rankine temperature", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RankineTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RateOfRiseOfVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("rate of rise of voltage", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RateOfRiseOfVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Ratio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("ratio", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE-PER-ONE");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Ratio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RatioOfSpecificHeatCapacities",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Ratio of Specific Heat Capacities", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RatioOfSpecificHeatCapacities",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reactance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "X",
    undefined
  );
  quantityKind.addLabel(new LangString("Reactance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reactance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReactionEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Reaction Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReactionEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReactivePower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("无功功率", "zh"));
  quantityKind.addLabel(new LangString("reactive power", "en"));
  quantityKind.addLabel(new LangString("reaktif güç", "tr"));
  quantityKind.addLabel(new LangString("potencia reactiva", "es"));
  quantityKind.addLabel(new LangString("توان راکتیو", "fa"));
  quantityKind.addLabel(new LangString("Kuasa reaktif", "ms"));
  quantityKind.addLabel(new LangString("無効電力", "ja"));
  quantityKind.addLabel(new LangString("potência reativa", "pt"));
  quantityKind.addLabel(new LangString("potenza reattiva", "it"));
  quantityKind.addLabel(
    new LangString("القدرة الكهربائية الردفعلية;الردية", "ar")
  );
  quantityKind.addLabel(new LangString("Blindleistung", "de"));
  quantityKind.addLabel(new LangString("Jalový výkon", "cs"));
  quantityKind.addLabel(new LangString("puissance réactive", "fr"));
  quantityKind.addLabel(new LangString("moc bierna", "pl"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoV-A_Reactive"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliV-A_Reactive"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraV-A_Reactive"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoV-A_Reactive"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaV-A_Reactive"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A_Reactive");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroV-A_Reactive"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ComplexPower"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReactivePower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reactivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reactivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reactivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReactorTimeConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "T",
    undefined
  );
  quantityKind.addLabel(new LangString("Reactor Time Constant", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReactorTimeConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalElectricResistance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "0173-1#Z4-BAJ375#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("reciprocal electric resistance", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalElectricResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H0T2D0",
    "0173-1#Z4-BAJ417#002",
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal energy", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalPlaneAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ376#002",
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal plane angle", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalPlaneAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReciprocalVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M-1H0T3D0",
    "0173-1#Z4-BAJ371#002",
    undefined
  );
  quantityKind.addLabel(new LangString("reciprocal voltage", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-V");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReciprocalVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RecombinationCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Recombination Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RecombinationCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reflectance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reflectance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reflectance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReflectanceFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Reflectance Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReflectanceFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reflectivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reflectivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Reflectance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reflectivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RefractiveIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "n",
    undefined
  );
  quantityKind.addLabel(new LangString("अपवर्तनांक", "hi"));
  quantityKind.addLabel(new LangString("Indice de refracție", "ro"));
  quantityKind.addLabel(new LangString("kırılma indeksi", "tr"));
  quantityKind.addLabel(new LangString("índice refrativo", "pt"));
  quantityKind.addLabel(new LangString("折射率", "zh"));
  quantityKind.addLabel(new LangString("índice de refracción", "es"));
  quantityKind.addLabel(new LangString("معامل الانكسار", "ar"));
  quantityKind.addLabel(new LangString("indice de réfraction", "fr"));
  quantityKind.addLabel(new LangString("屈折率", "ja"));
  quantityKind.addLabel(new LangString("ضریب شکست", "fa"));
  quantityKind.addLabel(new LangString("Indeks biasan", "ms"));
  quantityKind.addLabel(new LangString("Brechzahl", "de"));
  quantityKind.addLabel(new LangString("Показатель преломления", "ru"));
  quantityKind.addLabel(new LangString("Index lomu", "cs"));
  quantityKind.addLabel(new LangString("refractive index", "en"));
  quantityKind.addLabel(new LangString("Współczynnik załamania", "pl"));
  quantityKind.addLabel(new LangString("indice di rifrazione", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RefractiveIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeAtomicMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_r",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Atomic Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeAtomicMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Humidity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT_RH");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeHumidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeLuminousFlux",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Luminous Flux", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeLuminousFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassConcentrationOfVapour",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Relative Mass Concentration of Vapour", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassConcentrationOfVapour",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassDefect",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "B_r",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Defect", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassDefect",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassExcess",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Excess", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassExcess",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMassRatioOfVapour",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Mass Ratio of Vapour", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMassRatioOfVapour",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativeMolecularMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "M_r",
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Molecular Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativeMolecularMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Partial Pressure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PressureRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativePartialPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relative Pressure Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelativePressureCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RelaxationTIme",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Relaxation TIme", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RelaxationTIme",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Reluctance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T2D0",
    "R_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Reluctance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-H");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Reluctance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Repetency",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    "0173-1#Z4-BAJ370#002",
    undefined
  );
  quantityKind.addLabel(new LangString("repetency", undefined));
  quantityKind.addLabel(new LangString("repetency", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-IN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Repetency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity",
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Residual Resistivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResidualResistivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Resistance",
    "http://qudt.org/vocab/dimensionvector/A0E-2L2I0M1H0T-3D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Resistance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckImpedance"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Resistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResistanceBasedInductance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "0173-1#Z4-BAJ411#002",
    undefined
  );
  quantityKind.addLabel(new LangString("resistance-based inductance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResistanceBasedInductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResistancePercentage",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Resistance Percentage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResistancePercentage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResistanceRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Resistance Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResistanceRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Resistivity",
    "http://qudt.org/vocab/dimensionvector/A0E-2L3I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Resistivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-M2-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-KiloM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Resistivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResonanceEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_r, E_{res}",
    undefined
  );
  quantityKind.addLabel(new LangString("Resonance Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResonanceEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Resonance Escape Probability", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbabilityForFission",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Resonance Escape Probability For Fission", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ResonanceEscapeProbabilityForFission",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RespiratoryRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "Vf, Rf or RR",
    undefined
  );
  quantityKind.addLabel(new LangString("Respiratory Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BREATH-PER-MIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RespiratoryRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RestEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "E_0",
    undefined
  );
  quantityKind.addLabel(new LangString("Rest Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RestEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RestMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "m_X",
    undefined
  );
  quantityKind.addLabel(new LangString("инвариантная масса", "ru"));
  quantityKind.addLabel(new LangString("dinlenme kütlesi", "tr"));
  quantityKind.addLabel(new LangString("Jisim rehat", "ms"));
  quantityKind.addLabel(new LangString("جرم سکون", "fa"));
  quantityKind.addLabel(new LangString("masa spoczynkowa", "pl"));
  quantityKind.addLabel(new LangString("Klidová hmotnost", "cs"));
  quantityKind.addLabel(new LangString("静止质量", "zh"));
  quantityKind.addLabel(new LangString("不変質量", "ja"));
  quantityKind.addLabel(new LangString("masa invariantă", "ro"));
  quantityKind.addLabel(new LangString("Mirovna masa", "sl"));
  quantityKind.addLabel(new LangString("massa a riposo", "it"));
  quantityKind.addLabel(new LangString("निश्चर द्रव्यमान", "hi"));
  quantityKind.addLabel(new LangString("Ruhemasse", "de"));
  quantityKind.addLabel(new LangString("masse au repos", "fr"));
  quantityKind.addLabel(new LangString("massa de repouso", "pt"));
  quantityKind.addLabel(new LangString("rest mass", "en"));
  quantityKind.addLabel(new LangString("masa invariante", "es"));
  quantityKind.addLabel(new LangString("كتلة ساكنة", "ar"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RestMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReverberationTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "T",
    undefined
  );
  quantityKind.addLabel(new LangString("Reverberation Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReverberationTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ReynoldsNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "Re",
    undefined
  );
  quantityKind.addLabel(new LangString("Reynolds Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ReynoldsNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RichardsonConstant",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H-2T0D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("Richardson Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2-K2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RichardsonConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RiseOfOffStateVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-4D0",
    "0173-1#Z4-BAJ289#003",
    undefined
  );
  quantityKind.addLabel(new LangString("rise of off-state voltage", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RiseOfOffStateVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RocketAtmosphericTransverseForce",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "T",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Rocket Atmospheric Transverse Force", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RocketAtmosphericTransverseForce",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("rotary-translatory motion conversion", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-2PiRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-RAD");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Rotary-TranslatoryMotionConversion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotaryShock",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "0173-1#Z4-BAJ234#002",
    undefined
  );
  quantityKind.addLabel(new LangString("rotary shock", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotaryShock",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("RotationalFrequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CYC-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-HR");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Rotational Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-MilliM2"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MomentOfInertia"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalStiffness",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Rotational Stiffness", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TorquePerAngle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalStiffness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("RotationalFrequency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CYC-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV-PER-HR");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/RotationalFrequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/RotationalVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ScalarMagneticPotential",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-2D0",
    "V_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Scalar Magnetic Potential", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-SEC-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ScalarMagneticPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Second Axial Moment of Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondAxialMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("截面二次轴矩", "zh"));
  quantityKind.addLabel(new LangString("secondo momento di area", "it"));
  quantityKind.addLabel(new LangString("moment quadratique", "fr"));
  quantityKind.addLabel(new LangString("断面二次モーメント", "ja"));
  quantityKind.addLabel(new LangString("second moment of area", "en"));
  quantityKind.addLabel(new LangString("Segundo momento de área", "pt"));
  quantityKind.addLabel(new LangString("क्षेत्रफल का द्वितीय आघूर्ण", "hi"));
  quantityKind.addLabel(new LangString("گشتاور دوم سطح", "fa"));
  quantityKind.addLabel(new LangString("segundo momento de érea", "es"));
  quantityKind.addLabel(
    new LangString("Geometryczny moment bezwładności", "pl")
  );
  quantityKind.addLabel(new LangString("Flächenträgheitsmoment", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant",
    "http://qudt.org/vocab/dimensionvector/A-1E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Reaction Rate Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MOL-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-MOL-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondOrderReactionRateConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T0D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Second Polar Moment of Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM4");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondPolarMomentOfArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondRadiationConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H1T0D0",
    "0173-1#Z4-BAJ428#001",
    undefined
  );
  quantityKind.addLabel(new LangString("second radiation constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondRadiationConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SecondStageMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R_2",
    undefined
  );
  quantityKind.addLabel(new LangString("Second Stage Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SecondStageMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SectionAreaIntegral",
    "http://qudt.org/vocab/dimensionvector/A0E0L5I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Section Area Integral", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M5");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SectionAreaIntegral",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SectionModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    "Z",
    undefined
  );
  quantityKind.addLabel(new LangString("Section Modulus", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SectionModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SeebeckCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H-1T-3D0",
    "S_{ab}",
    undefined
  );
  quantityKind.addLabel(new LangString("Seebeck Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SeebeckCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SerumOrPlasmaLevel",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Serum or Plasma Level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU-PER-MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IU-PER-L");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SerumOrPlasmaLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShannonDiversityIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Shannon Diversity Index", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERLANG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HART");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KibiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExbiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SHANNON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TebiBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBYTE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraBYTE");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationEntropy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShannonDiversityIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShearModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Shear Modulus", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShearModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShearStrain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Shear Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Strain"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShearStrain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ShearStress",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Shear Stress", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Stress"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ShearStress",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Short-RangeOrderParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Short-Range Order Parameter", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Short-RangeOrderParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SignalDetectionThreshold",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Signal Detection Threshold", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_C");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SignalDetectionThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SignalStrength",
    "http://qudt.org/vocab/dimensionvector/A0E-1L1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Signal Strength", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Ab-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V_Stat-PER-CentiM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricField"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ElectricFieldStrength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SignalStrength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SingleStageLauncherMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R_o",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Single Stage Launcher Mass Ratio", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MassRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SingleStageLauncherMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Slowing-DownArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "L_s^2",
    undefined
  );
  quantityKind.addLabel(new LangString("Slowing-Down Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Area"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Slowing-DownArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T-1D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Slowing-Down Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M3-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-M3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Slowing-DownDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Slowing-DownLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L_s",
    undefined
  );
  quantityKind.addLabel(new LangString("Slowing-Down Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Slowing-DownLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Soil Adsorption Coefficient", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoilAdsorptionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SolidAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("angolo solido", "it"));
  quantityKind.addLabel(new LangString("立体角", "ja"));
  quantityKind.addLabel(new LangString("زاویه فضایی", "fa"));
  quantityKind.addLabel(new LangString("ângulo sólido", "pt"));
  quantityKind.addLabel(new LangString("ángulo sólido", "es"));
  quantityKind.addLabel(new LangString("Sudut padu", "ms"));
  quantityKind.addLabel(new LangString("solid angle", "en"));
  quantityKind.addLabel(new LangString("الزاوية الصلبة", "ar"));
  quantityKind.addLabel(new LangString("kąt bryłowy", "pl"));
  quantityKind.addLabel(new LangString("katı cisimdeki açı", "tr"));
  quantityKind.addLabel(new LangString("Raumwinkel", "de"));
  quantityKind.addLabel(new LangString("आयतन", "hi"));
  quantityKind.addLabel(new LangString("Пространствен ъгъл", "bg"));
  quantityKind.addLabel(new LangString("זווית מרחבית", "he"));
  quantityKind.addLabel(new LangString("立体角度", "zh"));
  quantityKind.addLabel(new LangString("térszög", "hu"));
  quantityKind.addLabel(new LangString("angulus solidus", "la"));
  quantityKind.addLabel(new LangString("Στερεά γωνία", "el"));
  quantityKind.addLabel(new LangString("unghi solid", "ro"));
  quantityKind.addLabel(new LangString("Телесный угол", "ru"));
  quantityKind.addLabel(new LangString("Prostorový úhel", "cs"));
  quantityKind.addLabel(new LangString("angle solide", "fr"));
  quantityKind.addLabel(new LangString("prostorski kot", "sl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FA");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SolidAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SolidStateDiffusionLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "L, L_n, L_p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Diffusion Length (Solid State Physics)", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SolidStateDiffusionLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Solubility_Water",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Water Solubility", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FemtoMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-DeciM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-L"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AmountOfSubstancePerVolume"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Solubility_Water",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound energy density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundExposure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M2H0T-3D0",
    "E",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound exposure", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA2-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundExposure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound exposure level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundExposureLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound intensity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/PowerPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundParticleAcceleration",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound particle acceleration", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-M2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GALILEO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MI_US-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/G");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundParticleAcceleration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundParticleDisplacement",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "ξ",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound Particle Displacement", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundParticleDisplacement",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v",
    undefined
  );
  quantityKind.addLabel(
    new LangString("vitesse  acoustique d‘une particule", "fr")
  );
  quantityKind.addLabel(new LangString("سرعة جسيم", "ar"));
  quantityKind.addLabel(
    new LangString("velocidade acústica de uma partícula", "pt")
  );
  quantityKind.addLabel(new LangString("sound particle velocity", "en"));
  quantityKind.addLabel(new LangString("粒子速度", "ja"));
  quantityKind.addLabel(new LangString("prędkość akustyczna", "pl"));
  quantityKind.addLabel(new LangString("velocità di spostamento", "it"));
  quantityKind.addLabel(new LangString("Schallschnelle", "de"));
  quantityKind.addLabel(
    new LangString("velocidad acústica de una partícula", "es")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundParticleVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    "P",
    undefined
  );
  quantityKind.addLabel(new LangString("звуковая мощность", "ru"));
  quantityKind.addLabel(new LangString("Schallleistung", "de"));
  quantityKind.addLabel(new LangString("音源の音響出力", "ja"));
  quantityKind.addLabel(new LangString("sound power", "en"));
  quantityKind.addLabel(new LangString("potencie acústica", "es"));
  quantityKind.addLabel(new LangString("القدرة الصوتية", "ar"));
  quantityKind.addLabel(new LangString("potenza sonora", "it"));
  quantityKind.addLabel(new LangString("puissance acoustique", "fr"));
  quantityKind.addLabel(new LangString("potência acústica", "pt"));
  quantityKind.addLabel(new LangString("moc akustyczna", "pl"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPowerLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound power level", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPowerLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "L",
    undefined
  );
  quantityKind.addLabel(new LangString("利得", "ja"));
  quantityKind.addLabel(new LangString("niveau de pression acoustique", "fr"));
  quantityKind.addLabel(new LangString("nivel de presión sonora", "es"));
  quantityKind.addLabel(new LangString("miary wielkości ilorazowych", "pl"));
  quantityKind.addLabel(new LangString("sound pressure level", "en"));
  quantityKind.addLabel(new LangString("Hladina akustického tlaku", "cs"));
  quantityKind.addLabel(new LangString("Schalldruckpegel", "de"));
  quantityKind.addLabel(new LangString("كمية جذر الطاقة", "ar"));
  quantityKind.addLabel(new LangString("livello di pressione sonora", "it"));
  quantityKind.addLabel(new LangString("声压级", "zh"));
  quantityKind.addLabel(new LangString("gerilim veya akım oranı", "tr"));
  quantityKind.addLabel(new LangString("nível de pressão acústica", "pt"));
  quantityKind.addLabel(new LangString("سطح یک کمیت توان-ریشه", "fa"));
  quantityKind.addLabel(new LangString("Tahap medan", "ms"));
  quantityKind.addLabel(new LangString("уровень звукового давления", "ru"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundPressureLevel",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound reduction index", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_ISO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/B");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_Z");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB_M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundReductionIndex",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SoundVolumeVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    "q",
    undefined
  );
  quantityKind.addLabel(new LangString("Sound volume velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SoundVolumeVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SourceVoltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "U_s",
    undefined
  );
  quantityKind.addLabel(new LangString("Source Voltage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Voltage"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SourceVoltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SourceVoltageBetweenSubstances",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "E_{ab}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Source Voltage Between Substances", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Voltage"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SourceVoltageBetweenSubstances",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpatialSummationFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Spatial Summation Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpatialSummationFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Acoustic Impedance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAYL");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificAcousticImpedance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Activity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBQ-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Electric Charge", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-HR-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Electrical Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-GM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificElectricCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "e",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEnergyImparted",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "z",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Energy Imparted", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEnergyImparted",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEnthalpy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "h",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Enthalpy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEnthalpy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificEntropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Entropy", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificGibbsEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Gibbs Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificGibbsEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heat Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_p",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific heat capacity at constant pressure", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_v",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific heat capacity at constant volume", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtConstantVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H-1T-2D0",
    "c_{sat}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific Heat Capacity at Saturation", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-GM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatCapacityAtSaturation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heat Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heat Volume", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHeatsRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Heats Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHeatsRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificHelmholtzEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Helmholtz Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificHelmholtzEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Impulse", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Impulse by Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByWeight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Impulse by Weight", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificImpulse"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificImpulseByWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificInternalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Internal Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-HR-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloJ-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-GM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SpecificEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificInternalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Modulus", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM2-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotationalAbility",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M0H0T0D0",
    "0173-1#Z4-BAJ425#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString("specific optical rotational ability", "en-US")
  );
  quantityKind.addLabel(
    new LangString("specific optical rotational ability", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotationalAbility",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotatoryPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Specific Optical Rotatory Power", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificOpticalRotatoryPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliRAD_R-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGRAY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SV-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGRAY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoSV-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Surface Area", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificSurfaceArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific thrust", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M-1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Specific Volume", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL-PER-GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-KiloGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-GM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-LB");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-KiloGM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpecificWeight",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    "γ",
    undefined
  );
  quantityKind.addLabel(new LangString("specific weight", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-PER-IN3");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpecificWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Spectral Angular Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SR-J");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralAngularCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfRadiantEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ379#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("spectral concentration of radiant energy density", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfRadiantEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfVibrationalModes",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    "0173-1#Z4-BAJ431#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "spectral concentration of vibrational modes (in terms of angular frequency)",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralConcentrationOfVibrationalModes",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Spectral Cross-section", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-ERG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-J");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralDensityOfVibrationalModes",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("spectral density of vibrational modes", undefined)
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SEC-PER-M3-RAD"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralDensityOfVibrationalModes",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralLuminousEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Spectral Luminous Efficiency", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralLuminousEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Spectral Radiant Energy Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoPA-PER-KiloM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M4");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloPA-PER-MilliM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensityInTermsOfWavelength",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "spectral radiant energy density in terms of wavelength",
      undefined
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpectralRadiantEnergyDensityInTermsOfWavelength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Speed",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Speed", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Speed",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpeedOfLight",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Kelajuan cahaya", "ms"));
  quantityKind.addLabel(new LangString("光速", "ja"));
  quantityKind.addLabel(new LangString("سرعت نور", "fa"));
  quantityKind.addLabel(new LangString("Prędkość światła", "pl"));
  quantityKind.addLabel(new LangString("Işık hızı", "tr"));
  quantityKind.addLabel(new LangString("Velocidade da luz", "pt"));
  quantityKind.addLabel(new LangString("Rychlost světla", "cs"));
  quantityKind.addLabel(new LangString("vitesse de la lumière", "fr"));
  quantityKind.addLabel(new LangString("प्रकाश का वेग", "hi"));
  quantityKind.addLabel(new LangString("Скорость света", "ru"));
  quantityKind.addLabel(new LangString("speed of light", "en"));
  quantityKind.addLabel(new LangString("velocità della luce", "it"));
  quantityKind.addLabel(new LangString("velocidad de la luz", "es"));
  quantityKind.addLabel(new LangString("سرعة الضوء", "ar"));
  quantityKind.addLabel(new LangString("Lichtgeschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("光速", "zh"));
  quantityKind.addLabel(new LangString("Hitrost svetlobe", "sl"));
  quantityKind.addLabel(new LangString("Viteza luminii", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Speed"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpeedOfLight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "c",
    undefined
  );
  quantityKind.addLabel(new LangString("سرعت صوت", "fa"));
  quantityKind.addLabel(new LangString("音速", "ja"));
  quantityKind.addLabel(new LangString("音速", "zh"));
  quantityKind.addLabel(new LangString("Schallgeschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("prędkość dźwięku", "pl"));
  quantityKind.addLabel(new LangString("velocidad del sonido", "es"));
  quantityKind.addLabel(new LangString("speed of sound", "en"));
  quantityKind.addLabel(new LangString("Kelajuan bunyi", "ms"));
  quantityKind.addLabel(new LangString("سرعة الصوت", "ar"));
  quantityKind.addLabel(new LangString("Ses hızı", "tr"));
  quantityKind.addLabel(new LangString("vitesse du son", "fr"));
  quantityKind.addLabel(new LangString("rychlost zvuku", "cs"));
  quantityKind.addLabel(new LangString("viteza sunetului", "ro"));
  quantityKind.addLabel(new LangString("velocidade do som", "pt"));
  quantityKind.addLabel(new LangString("ध्वनि का वेग", "hi"));
  quantityKind.addLabel(new LangString("скорость звука", "ru"));
  quantityKind.addLabel(new LangString("Hitrost zvoka", "sl"));
  quantityKind.addLabel(new LangString("velocità del suono", "it"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT3-PER-MIN-FT2"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Speed"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpeedOfSound",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpeedRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Speed Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpeedRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SphericalIlluminance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I1M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Illuminance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PHOT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LUX");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Illuminance"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SphericalIlluminance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Spin",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("spin", "en"));
  quantityKind.addLabel(new LangString("spin", "fr"));
  quantityKind.addLabel(new LangString("Spin", "ms"));
  quantityKind.addLabel(new LangString("spin", "it"));
  quantityKind.addLabel(new LangString("Spin", "de"));
  quantityKind.addLabel(new LangString("spin", "cs"));
  quantityKind.addLabel(new LangString("espín", "es"));
  quantityKind.addLabel(new LangString("spin", "pt"));
  quantityKind.addLabel(new LangString("Спин", "ru"));
  quantityKind.addLabel(new LangString("لف مغزلي", "ar"));
  quantityKind.addLabel(new LangString("spin", "sl"));
  quantityKind.addLabel(new LangString("spin", "pl"));
  quantityKind.addLabel(new LangString("自旋", "zh"));
  quantityKind.addLabel(new LangString("Spin", "ro"));
  quantityKind.addLabel(new LangString("Spin", "tr"));
  quantityKind.addLabel(new LangString("スピン角運動量", "ja"));
  quantityKind.addLabel(new LangString("اسپین/چرخش", "fa"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Spin",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "s",
    undefined
  );
  quantityKind.addLabel(new LangString("Spin Quantum Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SpinQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SquareEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M2H0T-4D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Square Energy", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SquareEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StagePropellantMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_F",
    undefined
  );
  quantityKind.addLabel(new LangString("Stage Propellant Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StagePropellantMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StageStructuralMass",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    "M_S",
    undefined
  );
  quantityKind.addLabel(new LangString("Stage Structure Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StageStructuralMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StandardAbsoluteActivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Standard Absolute Activity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StandardAbsoluteActivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StandardChemicalPotential",
    "http://qudt.org/vocab/dimensionvector/A-1E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Standard Chemical Potential", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ChemicalPotential"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StandardChemicalPotential",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Standard Gravitational Parameter", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM3-PER-SEC2"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StandardGravitationalParameter",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StateDensity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ427#001",
    undefined
  );
  quantityKind.addLabel(new LangString("state density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StateDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StateDensityAsExpressionOfAngularFrequency",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T1D0",
    "0173-1#Z4-BAJ454#001",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "state density as expression of angular frequency)",
      undefined
    )
  );
  quantityKind.addLabel(
    new LangString("state density as expression of angular frequency", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StateDensityAsExpressionOfAngularFrequency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StaticFriction",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Static Friction", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Friction"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StaticFriction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StaticFrictionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Static Friction Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/FrictionCoefficient"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StaticFrictionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StaticPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "p",
    undefined
  );
  quantityKind.addLabel(new LangString("Static pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StaticPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StatisticalWeight",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "g",
    undefined
  );
  quantityKind.addLabel(new LangString("Statistical Weight", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StatisticalWeight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StochasticProcess",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "X",
    undefined
  );
  quantityKind.addLabel(new LangString("Stochastic Process", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/failures-in-time"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-WK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MO");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SAMPLE-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-WK");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaHZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MO"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloHZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-YR"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Frequency"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StochasticProcess",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StoichiometricNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stoichiometric Number", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StoichiometricNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Strain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/LengthRatio"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearStrain"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Strain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StrainEnergyDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "u",
    undefined
  );
  quantityKind.addLabel(new LangString("Strain Energy Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StrainEnergyDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Strain Energy Release Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StrainEnergyReleaseRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Stress",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stress", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForcePerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Stress",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L-0dot5I0M1H0T-2D0",
    "K",
    undefined
  );
  quantityKind.addLabel(new LangString("Stress Intensity Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M0dot5");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA-M0dot5");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StressIntensityFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M-1H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Stress-Optic Coefficient", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BREWSTER");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StressOpticCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StructuralEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Structural Efficiency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StructuralEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/StructureFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "F(h, k, l)",
    undefined
  );
  quantityKind.addLabel(new LangString("Structure Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/StructureFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SunProtectionFactorOfAProduct",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("sun protection factor of a product", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SPF");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SunProtectionFactorOfAProduct",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SuperconductionTransitionTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T_c",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Superconduction Transition Temperature", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SuperconductionTransitionTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SuperconductorEnergyGap",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Δ",
    undefined
  );
  quantityKind.addLabel(new LangString("Superconductor Energy Gap", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/GapEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SuperconductorEnergyGap",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceActivityDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M0H0T-1D0",
    "a_s",
    undefined
  );
  quantityKind.addLabel(new LangString("Surface Activity Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BQ-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceActivityDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Surface Coefficient of Heat Transfer", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceCoefficientOfHeatTransfer",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Surface Density", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-KiloM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-YD2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlow",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "0173-1#Z4-BAJ421#003",
    undefined
  );
  quantityKind.addLabel(new LangString("surface-related volume flow", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HA-YR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceRelatedVolumeFlow",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurfaceTension",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-2D0",
    "γ",
    undefined
  );
  quantityKind.addLabel(new LangString("Oberflächenspannung", "de"));
  quantityKind.addLabel(new LangString("Tegangan permukaan", "ms"));
  quantityKind.addLabel(new LangString("površinska napetost", "sl"));
  quantityKind.addLabel(new LangString("Yüzey gerilimi", "tr"));
  quantityKind.addLabel(new LangString("поверхностное натяжение", "ru"));
  quantityKind.addLabel(new LangString("पृष्ठ तनाव", "hi"));
  quantityKind.addLabel(new LangString("tension superficielle", "fr"));
  quantityKind.addLabel(new LangString("tensión superficial", "es"));
  quantityKind.addLabel(new LangString("surface tension", "en"));
  quantityKind.addLabel(new LangString("表面張力", "ja"));
  quantityKind.addLabel(new LangString("表面张力", "zh"));
  quantityKind.addLabel(new LangString("توتر سطحي", "ar"));
  quantityKind.addLabel(new LangString("Tensiune superficială", "ro"));
  quantityKind.addLabel(new LangString("napięcie powierzchniowe", "pl"));
  quantityKind.addLabel(new LangString("کشش سطحی", "fa"));
  quantityKind.addLabel(new LangString("tensione superficiale", "it"));
  quantityKind.addLabel(new LangString("tensão superficial", "pt"));
  quantityKind.addLabel(new LangString("povrchové napětí", "cs"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GigaN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LANGLEY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-HR-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-CentiM2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerArea"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurfaceTension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SurgeImpedanceOfTheMedium",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M1H0T-1D0",
    "0173-1#Z4-BAJ323#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("surge impedance of the medium", undefined)
  );
  quantityKind.addLabel(
    new LangString("surge impedance of the medium", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SurgeImpedanceOfTheMedium",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Susceptance",
    "http://qudt.org/vocab/dimensionvector/A0E2L-2I0M-1H0T3D0",
    "B",
    undefined
  );
  quantityKind.addLabel(new LangString("Susceptance", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Susceptance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SymbolTransmissionRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ386#002",
    undefined
  );
  quantityKind.addLabel(new LangString("symbol transmission rate", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SymbolTransmissionRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/SystolicBloodPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Systolic Blood Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/SystolicBloodPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TARGET-BOGIE-MASS",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Target Bogie Mass", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AMU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CARAT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SolarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DWT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_LONG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/U");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CWT_SHORT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LunarMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciTON_Metric"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Pennyweight");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Quarter_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EarthMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Stone_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaGM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_TROY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Hundredweight_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Assay");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DRAM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckMass");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Textile");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOMME_Pearl");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciTONNE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroGM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFUND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SLUG");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Mass"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TARGET-BOGIE-MASS",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Temperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Temperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L0I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Temperature Amount of Substance", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedAmountOfSubstanceConcentration",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ395#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "temperature-based amount-of-substance concentration",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedAmountOfSubstanceConcentration",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDensity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ389#003",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDynamicViscosity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ390#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based dynamic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedDynamicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedKinematicViscosity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ392#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based kinematic viscosity", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedKinematicViscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H-1T0D0",
    "0173-1#Z4-BAJ393#002",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based length", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMass",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ394#002",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based mass", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMassFlowRate",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ396#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based mass flow rate", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedMassFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedQuantity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVelocity",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ391#001",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature-based velocity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVolumeFlowRate",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ397#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-based volume flow rate", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureBasedVolumeFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureDifference",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "ΔT",
    undefined
  );
  quantityKind.addLabel(new LangString("temperature difference", "en"));
  quantityKind.addLabel(new LangString("Temperaturdifferenz", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliDEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureDifference",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Gradient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureGradient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperaturePerMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M-1H1T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Temperature per Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-T");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperaturePerMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature per Time", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-YR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature per Time Squared", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-SEC2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRateOfChange",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T-1D0",
    "0173-1#Z4-BAJ416#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Rate of Change", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-YR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/TemperaturePerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRateOfChange",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temperature Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliK-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedMolarMass",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    "0173-1#Z4-BAJ443#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-related molar mass", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedMolarMass",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedVolume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    "0173-1#Z4-BAJ398#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperature-related volume  ", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemperatureRelatedVolume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TemporalSummationFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Temporal Summation Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-SR");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TemporalSummationFunction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Tension",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Tension", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ForceMagnitude"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Tension",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalAdmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Admittance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalAdmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    "0173-1#Z4-BAJ406#002",
    undefined
  );
  quantityKind.addLabel(new LangString("thermal capacitance", "en-US"));
  quantityKind.addLabel(new LangString("thermal capacitance", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalCapacitance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalCoefficientOfLinearExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    "0173-1#Z4-BAJ473#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("thermal coefficient of linear expansion", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalCoefficientOfLinearExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalConductance",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-3D0",
    "G",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Conductance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliV-A-PER-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroV-A-PER-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalConductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Conductivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-PER-M-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M-DEG_C");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalConductivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusion Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "k_T",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusion Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatioCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "D_T",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusion Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusionRatioCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T-1D0",
    "a",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Diffusivity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AreaPerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalDiffusivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Efficiency", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_20DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_15_DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL_Mean");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_MEAN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_39DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_59DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_60DEG_F");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Energy Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-FT");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalEnergyLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Expansion Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MegaK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-DEG_C");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/ExpansionRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalExpansionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Insulance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CLO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-K-PER-W");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalInsulance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalInsulation",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M-1H1T3D0",
    "0173-1#Z4-BAJ404#002",
    undefined
  );
  quantityKind.addLabel(new LangString("thermal insulation", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalInsulation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalResistance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-2I0M-1H1T3D0",
    "R",
    undefined
  );
  quantityKind.addLabel(new LangString("opór cieplny", "cs"));
  quantityKind.addLabel(new LangString("thermischer Widerstand", "de"));
  quantityKind.addLabel(new LangString("مقاومة حرارية", "ar"));
  quantityKind.addLabel(new LangString("resistência térmica", "pt"));
  quantityKind.addLabel(new LangString("熱抵抗", "ja"));
  quantityKind.addLabel(new LangString("resistenza termica", "it"));
  quantityKind.addLabel(new LangString("résistance thermique", "fr"));
  quantityKind.addLabel(new LangString("热阻", "zh"));
  quantityKind.addLabel(new LangString("thermal resistance", "en"));
  quantityKind.addLabel(new LangString("resistencia térmica", "es"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalResistance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M-1H1T3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Resistivity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-K-PER-W");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-M-PER-W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalResistivity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalTransmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Transmittance", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloW-PER-M2-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CoefficientOfHeatTransfer"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalTransmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactor",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermal Utilization Factor", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactorForFission",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "f",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Thermal Utilization Factor For Fission", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DECADE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FLIGHT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HeartBeat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RPK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OCT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaBasePair");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Dimensionless"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermalUtilizationFactorForFission",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicCriticalMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B_c",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Thermodynamic Critical Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gs");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gamma");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicCriticalMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "U",
    undefined
  );
  quantityKind.addLabel(new LangString("Thermodynamic Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyInternal"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/InternalEnergy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEntropy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thermodynamic Entropy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerTemperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicEntropy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T0D0",
    "T",
    undefined
  );
  quantityKind.addLabel(
    new LangString("temperatura thermodynamica absoluta", "la")
  );
  quantityKind.addLabel(new LangString("temperatura", "sl"));
  quantityKind.addLabel(new LangString("Απόλυτη", "el"));
  quantityKind.addLabel(new LangString("température thermodynamique", "fr"));
  quantityKind.addLabel(new LangString("دمای ترمودینامیکی", "fa"));
  quantityKind.addLabel(new LangString("Термодинамическая температура", "ru"));
  quantityKind.addLabel(new LangString("abszolút hőmérséklet", "hu"));
  quantityKind.addLabel(new LangString("temperatura", "pl"));
  quantityKind.addLabel(new LangString("temperatura termodinamica", "it"));
  quantityKind.addLabel(new LangString("Termodynamická teplota", "cs"));
  quantityKind.addLabel(new LangString("temperatură termodinamică", "ro"));
  quantityKind.addLabel(new LangString("热力学温度", "zh"));
  quantityKind.addLabel(new LangString("טמפרטורה מוחלטת", "he"));
  quantityKind.addLabel(new LangString("Suhu termodinamik", "ms"));
  quantityKind.addLabel(new LangString("thermodynamische Temperatur", "de"));
  quantityKind.addLabel(new LangString("Термодинамична температура", "bg"));
  quantityKind.addLabel(new LangString("熱力学温度", "ja"));
  quantityKind.addLabel(new LangString("temperatura", "es"));
  quantityKind.addLabel(new LangString("درجة الحرارة المطلقة", "ar"));
  quantityKind.addLabel(new LangString("ऊष्मगतिकीय तापमान", "hi"));
  quantityKind.addLabel(new LangString("termodinamik sıcaklık", "tr"));
  quantityKind.addLabel(new LangString("thermodynamic temperature", "en"));
  quantityKind.addLabel(new LangString("temperatura", "pt"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_R");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckTemperature"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Temperature"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThermodynamicTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Thickness",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "d",
    undefined
  );
  quantityKind.addLabel(new LangString("Thickness", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Thickness",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThomsonCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H-1T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thomson Coefficient", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThomsonCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Thrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Thrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrustCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "C_{F}",
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust Coefficient", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrustCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust To Mass Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-LB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-KiloGM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Acceleration"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrustToMassRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrustToWeightRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Thrust To Weight Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrustToWeightRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Thruster Power To Thrust Efficiency", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-MIN-PSI"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-HR-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-SEC-PSI"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/ThrusterPowerToThrustEfficiency",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Tilt",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Tilt", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GON");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARCMIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Angle");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliARCSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliRAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/REV");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Angle"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Tilt",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Time",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    "t",
    undefined
  );
  quantityKind.addLabel(new LangString("čas", "sl"));
  quantityKind.addLabel(new LangString("时间", "zh"));
  quantityKind.addLabel(new LangString("tempo", "it"));
  quantityKind.addLabel(new LangString("tempus", "la"));
  quantityKind.addLabel(new LangString("Čas", "cs"));
  quantityKind.addLabel(new LangString("time", "en"));
  quantityKind.addLabel(new LangString("idő", "hu"));
  quantityKind.addLabel(new LangString("Zeit", "de"));
  quantityKind.addLabel(new LangString("Masa", "ms"));
  quantityKind.addLabel(new LangString("Време", "bg"));
  quantityKind.addLabel(new LangString("tiempo", "es"));
  quantityKind.addLabel(new LangString("timp", "ro"));
  quantityKind.addLabel(new LangString("時間", "ja"));
  quantityKind.addLabel(new LangString("زمان", "fa"));
  quantityKind.addLabel(new LangString("zaman", "tr"));
  quantityKind.addLabel(new LangString("زمن", "ar"));
  quantityKind.addLabel(new LangString("czas", "pl"));
  quantityKind.addLabel(new LangString("temps", "fr"));
  quantityKind.addLabel(new LangString("זמן", "he"));
  quantityKind.addLabel(new LangString("Χρόνος", "el"));
  quantityKind.addLabel(new LangString("समय", "hi"));
  quantityKind.addLabel(new LangString("Время", "ru"));
  quantityKind.addLabel(new LangString("tempo", "pt"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Time",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeAveragedSoundIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "I",
    undefined
  );
  quantityKind.addLabel(new LangString("Time averaged sound intensity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-CentiM2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-IN2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/SoundIntensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeAveragedSoundIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeConstant_Inductance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("time constant (inductance based)", undefined)
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeConstant_Inductance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimePercentage",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Percentage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimePercentage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR-PER-YR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeRelatedLogarithmicRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    "0173-1#Z4-BAJ415#002",
    undefined
  );
  quantityKind.addLabel(
    new LangString("time-related logarithmic ratio", "en-US")
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeRelatedLogarithmicRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeSquared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Squared", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeSquared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TimeTemperature",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H1T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Temperature", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-DAY");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TimeTemperature",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Time_Squared",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Time Squared", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliM-BAR"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Time_Squared",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Torque",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "M",
    undefined
  );
  quantityKind.addLabel(new LangString("عزم محورى", "ar"));
  quantityKind.addLabel(new LangString("momento de torção", "pt"));
  quantityKind.addLabel(new LangString("couple", "fr"));
  quantityKind.addLabel(new LangString("トルク", "ja"));
  quantityKind.addLabel(new LangString("torque", "en"));
  quantityKind.addLabel(new LangString("coppia", "it"));
  quantityKind.addLabel(new LangString("moment obrotowy", "pl"));
  quantityKind.addLabel(new LangString("par", "es"));
  quantityKind.addLabel(new LangString("转矩", "zh"));
  quantityKind.addLabel(new LangString("Torsionmoment", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN-M");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/MomentOfForce"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Torque",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorqueConstant",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ298#002",
    undefined
  );
  quantityKind.addLabel(new LangString("torque constant", undefined));
  quantityKind.addLabel(new LangString("torque constant", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorqueConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorquePerAngle",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Torque per Angle", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorquePerAngle",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorquePerLength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Torque per Length", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorquePerLength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorsionalRigidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("torsional rigidity", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorsionalRigidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "0173-1#Z4-BAJ448#002",
    undefined
  );
  quantityKind.addLabel(new LangString("Federkonstante Drehfeder", "de"));
  quantityKind.addLabel(new LangString("torsional spring constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-RAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-PER-DEG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-MIN_Angle"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloN-M-PER-DEG"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-ARCMIN"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TorsionalSpringConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentum",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-1D0",
    "J",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Angular Momentum", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularMomentum"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentum",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentumQuantumNumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "j",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Total Angular Momentum Quantum Number", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/QuantumNumber"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalAngularMomentumQuantumNumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M1H0T-2D0",
    "S_a",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Atomic Stopping Power", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalAtomicStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalCrossSection",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M0H0T0D0",
    "σₜ",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Cross-section", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckArea");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloMIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIL_Circ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaARE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/CrossSection"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalCrossSection",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalCurrent",
    "http://qudt.org/vocab/dimensionvector/A0E1L0I0M0H0T0D0",
    "I_{tot}",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Current", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalCurrent",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalCurrentDensity",
    "http://qudt.org/vocab/dimensionvector/A0E1L-2I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Total Current Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalCurrentDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalIonization",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N_i",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Ionization", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalIonization",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "S",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Linear Stopping Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-PER-CentiM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/EV-PER-ANGSTROM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV-PER-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalLinearStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L4I0M0H0T-2D0",
    "S_m",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Mass Stopping Power", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/EV-M2-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-M2-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalMassStoppingPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "P_0",
    undefined
  );
  quantityKind.addLabel(new LangString("Total Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TotalRadiance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M1H0T-3D0",
    "0173-1#Z4-BAJ318#002",
    undefined
  );
  quantityKind.addLabel(new LangString("total radiance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TotalRadiance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TouchThresholds",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Touch Thresholds", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TouchThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TrafficIntensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "0173-1#Z4-BAJ462#001",
    undefined
  );
  quantityKind.addLabel(new LangString("traffic intensity", "en-US"));
  quantityKind.addLabel(new LangString("traffic intensity", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TrafficIntensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TransmissionRatioBetweenRotationAndTranslation",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "0173-1#Z4-BAJ400#003",
    undefined
  );
  quantityKind.addLabel(
    new LangString(
      "transmission ratio between rotation and translation",
      "en-US"
    )
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TransmissionRatioBetweenRotationAndTranslation",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Transmittance",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Transmittance", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Transmittance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TransmittanceDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "A_10, D",
    undefined
  );
  quantityKind.addLabel(new LangString("Transmittance Density", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TransmittanceDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/TrueExhaustVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "u_{e}",
    undefined
  );
  quantityKind.addLabel(new LangString("True Exhaust Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/TrueExhaustVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Turbidity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Turbidity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NTU");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Turbidity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Turns",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    "N",
    undefined
  );
  quantityKind.addLabel(new LangString("Turns", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Count"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Turns",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Unbalance",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T0D0",
    "0173-1#Z4-BAJ432#001",
    undefined
  );
  quantityKind.addLabel(new LangString("unbalance", undefined));
  quantityKind.addLabel(new LangString("unbalance", "en-US"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-M");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Unbalance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Unknown",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Unknown", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliK-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-KiloGM-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-OHM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliOHM-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SON");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/A-HR-PER-DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-MicroMOL-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT6"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-DeciM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCount"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-KiloCount"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HZ-DEG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HZ2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-SEC-PER-L2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-HR-PER-IN3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-PERCENT"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-M-PER-M2-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DecaCount"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-SEC-PER-M6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST-PER-PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M2-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM2-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_C2-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-GM-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PER-M-NanoM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC-PER-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoA-PER-HectoPA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MillionUSD-PER-YR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA2-PER-SEC2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A-PER-A-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ONE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCount"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-POISE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-RAD");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-MIN-PER-L2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB-MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/A2-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-M3-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ4");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M3-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-HZ2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M3-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MilliL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN6"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SEC-SR-M2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BARN-PER-SR-EV"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloOHM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-HR-PER-IN6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-L-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/Megahertz-KiloM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliV-A_Reactive-PER-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-PER-V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-MIN-PER-M6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HA-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AWG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PERCENT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN-PER-EV");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M2-SEC-PER-RAD"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNKNOWN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-L-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M4-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M-SR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloOHM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaOHM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGAL-PER-MO"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV-PER-V");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-DEG"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciB-W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-L-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-KiloGM-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TONNE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM2-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-PER-M2-M-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGAL-PER-M"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M2-PER-KiloGM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-MIN-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/N-M-PER-W0dot5"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_F-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ-HR-PER-IN6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OHM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliGM-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HR-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaOHM-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-HZ");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-HR-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NP-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-MilliGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-SEC-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_Metric-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-HR-PER-L2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARN-PER-SR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliMOL-PER-M2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-DAY-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NUM-PER-HectoGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-MOL");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-L-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-HR-PER-M6");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-GM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG_C-PER-BAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DEG_C");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliOHM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MOL-PER-L-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-L2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-DAY-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/K-PA-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-HR-PER-FT6");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-M3-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M2-PER-SEC-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-HR-PER-M6"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TONNE-PER-HR-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-DEG_F");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTR_VOL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC-PER-FT2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-SEC-PER-IN3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloMOL-PER-M3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroV-A_Reactive-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-MIN-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/W-PER-M2-NanoM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM-PER-SEC-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliA-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-MilliL-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT6"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ST-PER-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN-PER-SEC-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroGM-PER-L-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-SEC-PER-L"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/C-M2-PER-KiloGM"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-PER-SEC-PSI"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-M2-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-MOL"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-DAY-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-HR-PER-L-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-SEC-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-POISE"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-PSI");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-PER-HR-DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M-PER-SEC2");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/M3-PER-SEC-BAR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroMOL-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT-PER-V");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-HR-PER-GAL_US"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC-PA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Unknown",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/UpperCriticalMagneticFluxDensity",
    "http://qudt.org/vocab/dimensionvector/A0E-1L0I0M1H0T-2D0",
    "B_{c2}",
    undefined
  );
  quantityKind.addLabel(
    new LangString("Upper Critical Magnetic Flux Density", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gs");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGAUSS");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/T_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Gamma");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/MagneticFluxDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/UpperCriticalMagneticFluxDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VacuumThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vacuum Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VacuumThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VaporPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapor Permeability", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VaporPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VaporPermeance",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapor Permeability", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERM_Metric_0DEG_C"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERM_Metric_23DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERM_Metric");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VaporPermeance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VaporPressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vapor Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VaporPressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Vehicle Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VehicleVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Velocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "v",
    undefined
  );
  quantityKind.addLabel(new LangString("速度", "zh"));
  quantityKind.addLabel(new LangString("Rychlost", "cs"));
  quantityKind.addLabel(new LangString("velocidade", "pt"));
  quantityKind.addLabel(new LangString("Halaju", "ms"));
  quantityKind.addLabel(new LangString("Επιφάνεια", "el"));
  quantityKind.addLabel(new LangString("prędkość", "pl"));
  quantityKind.addLabel(new LangString("viteză", "ro"));
  quantityKind.addLabel(new LangString("velocidad", "es"));
  quantityKind.addLabel(new LangString("velocitas", "la"));
  quantityKind.addLabel(new LangString("Geschwindigkeit", "de"));
  quantityKind.addLabel(new LangString("سرعت/تندی", "fa"));
  quantityKind.addLabel(new LangString("गति", "hi"));
  quantityKind.addLabel(new LangString("velocità", "it"));
  quantityKind.addLabel(new LangString("速力", "ja"));
  quantityKind.addLabel(new LangString("velocity", "en"));
  quantityKind.addLabel(new LangString("vitesse", "fr"));
  quantityKind.addLabel(new LangString("hitrost", "sl"));
  quantityKind.addLabel(new LangString("hız", "tr"));
  quantityKind.addLabel(new LangString("Ско́рость", "ru"));
  quantityKind.addLabel(new LangString("السرعة", "ar"));
  quantityKind.addLabel(new LangString("מהירות", "he"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/LinearVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Velocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VentilationRatePerFloorArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Ventilation Rate per Floor Area", "en")
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VentilationRatePerFloorArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VerticalVelocity",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    "V_{Z}",
    undefined
  );
  quantityKind.addLabel(new LangString("Vertical Velocity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaHZ-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-KiloYR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM-PER-YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PER-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Velocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VerticalVelocity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VideoFrameRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Video Frame Rate", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRAME-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InformationFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VideoFrameRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Viscosity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Viscosity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/SLUG-PER-FT-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-SEC-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM-PER-CentiM-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPOISE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PDL-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiPOISE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB-PER-FT-DAY");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/DynamicViscosity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Viscosity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VisibleRadiantEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "Q",
    undefined
  );
  quantityKind.addLabel(new LangString("Visible Radiant Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VisibleRadiantEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VisionThresholds",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vision Thresholds", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VisionThresholds",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Voltage",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    "V",
    undefined
  );
  quantityKind.addLabel(new LangString("Voltage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Stat");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V_Ab");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolt");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/EnergyPerElectricCharge"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotentialDifference"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectricPotential"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Voltage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VoltagePercentage",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Voltage Percentage", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VoltagePercentage",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VoltagePhasor",
    "http://qudt.org/vocab/dimensionvector/A0E-1L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Voltage Phasor", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VoltagePhasor",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VoltageRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Voltage Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VoltageRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Volume",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_Register");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCubicFT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckVolume");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL_UK_PET");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TBSP");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BBL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_VOL_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PINT_UK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FBM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/STR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_US"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_UK3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/Standard");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TON_SHIPPING_UK"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AC-FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Volume",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeDensityOfCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    "0173-1#Z4-BAJ368#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volume density of charge", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeDensityOfCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Flow Rate", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/VolumePerTime"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate_SurfaceRelated",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("surface‑related volume flow rate", undefined)
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate_SurfaceRelated",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRatio",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Flow Ratio", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRatio",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeFraction",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Fraction", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliM3-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM3-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-CentiM3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-M3");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-L");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroM3-PER-MilliL"
  );
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/DimensionlessRatio"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeFraction",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeOrSectionModulus",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T0D0",
    "0173-1#Z4-BAJ251#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volume or section modulus", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeOrSectionModulus",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumePerArea",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume per Unit Area", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HA");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumePerArea",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumePerTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume per Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumePerTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumePerUnitTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H0T-1D0",
    "q_V",
    undefined
  );
  quantityKind.addLabel(new LangString("Volume per Unit Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-YR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US_PET-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN3-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_US-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_UK-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DeciM3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloL-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BBL_US-PER-DAY"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM3-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GAL_US-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PINT_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN"
  );
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/VolumeFlowRate"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumePerUnitTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeStrain",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T0D1",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Strain", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPQ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPTM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FRACTION");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERCENT");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PERMITTIVITY_REL"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PPB");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/UNITLESS");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Strain"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeStrain",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M0H-1T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volume Thermal Expansion", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT3-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD3-PER-DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/L-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliL-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM3-PER-K");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M3-PER-K");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumeThermalExpansion",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("volumic bit density", undefined));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KibiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PebiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GibiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MebiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BIT-PER-M3");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/ExbiBIT-PER-M3"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TebiBIT-PER-M3"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricBitDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricElectricCharge",
    "http://qudt.org/vocab/dimensionvector/A0E1L-3I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("volumic electric charge", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricElectricCharge",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricEntityDensity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ377#003",
    undefined
  );
  quantityKind.addLabel(new LangString("volumetric entity density", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricEntityDensity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricFlux",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volumetric Flux", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricFlux",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H-1T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Volumetric Heat Capacity", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-PER-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/J-PER-CentiM3-K"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3-K");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricHeatCapacity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumetricOutputPower",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("volumic output power", undefined));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumetricOutputPower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicAmountOfSubstance",
    "http://qudt.org/vocab/dimensionvector/A1E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ402#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volumic amount of substance", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicAmountOfSubstance",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicDataQuantity",
    "http://qudt.org/vocab/dimensionvector/A0E0L-3I0M0H0T0D0",
    "0173-1#Z4-BAJ401#002",
    undefined
  );
  quantityKind.addLabel(new LangString("volumic data quantity", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicDataQuantity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    "w",
    undefined
  );
  quantityKind.addLabel(new LangString("Volumic Electromagnetic Energy", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-M3");
  quantityKind.addExactMatchIri(
    "http://qudt.org/vocab/quantitykind/ElectromagneticEnergyDensity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicElectromagneticEnergy",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/VolumicOutput",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-3D0",
    "0173-1#Z4-BAJ366#003",
    undefined
  );
  quantityKind.addLabel(new LangString("volumic output", "en-US"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/VolumicOutput",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Vorticity",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T-1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Vorticity", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckFrequency_Ang"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/RAD-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DEG-PER-SEC");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/AngularVelocity"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Vorticity",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WarmReceptorThreshold",
    "http://qudt.org/vocab/dimensionvector/NotApplicable",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Warm Receptor Threshold", "en"));
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WarmReceptorThreshold",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WarpingConstant",
    "http://qudt.org/vocab/dimensionvector/A0E0L6I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Warping Constant", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM6");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M6");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WarpingConstant",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WarpingMoment",
    "http://qudt.org/vocab/dimensionvector/A0E0L3I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Warping Moment", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-M2");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WarpingMoment",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WaterHorsepower",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-3D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Water Horsepower", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/TeraW-HR-PER-YR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PFERDESTAERKE");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliJ-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-MIN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Electric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_FG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-IN3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT-LB_F-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Boiler");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckPower");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-MIN"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloCAL-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Brake");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP_Metric");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliW");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/HectoPA-L-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PSI-YD3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J-PER-DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HP");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Power"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WaterHorsepower",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WaterVaporDiffusionCoefficient",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(
    new LangString("Wasserdampfdiffusionsleitkoeffizient", "de")
  );
  quantityKind.addLabel(
    new LangString("Water vapour diffusion coefficient", "en")
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WaterVaporDiffusionCoefficient",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WaterVapourPermeability",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T1D0",
    "0173-1#Z4-BAJ446#001",
    undefined
  );
  quantityKind.addLabel(new LangString("water vapour permeability", "en-US"));
  quantityKind.addLabel(new LangString("water vapour permeability", undefined));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERM_23DEG_C");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PERM_0DEG_C");
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WaterVapourPermeability",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Wavelength",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    "λ",
    undefined
  );
  quantityKind.addLabel(new LangString("Wellenlänge", "de"));
  quantityKind.addLabel(new LangString("Jarak gelombang", "ms"));
  quantityKind.addLabel(new LangString("длина волны", "ru"));
  quantityKind.addLabel(new LangString("طول موج", "fa"));
  quantityKind.addLabel(new LangString("longueur d'onde", "fr"));
  quantityKind.addLabel(new LangString("comprimento de onda", "pt"));
  quantityKind.addLabel(new LangString("wavelength", "en"));
  quantityKind.addLabel(new LangString("Vlnové délka", "cs"));
  quantityKind.addLabel(new LangString("波长", "zh"));
  quantityKind.addLabel(new LangString("lunghezza d'onda", "it"));
  quantityKind.addLabel(new LangString("longitud de onda", "es"));
  quantityKind.addLabel(new LangString("dalga boyu", "tr"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Wavelength",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Wavenumber",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("عدد الموجة", "ar"));
  quantityKind.addLabel(new LangString("valovno število", "sl"));
  quantityKind.addLabel(new LangString("Волновое число", "ru"));
  quantityKind.addLabel(new LangString("nombre d'onde", "fr"));
  quantityKind.addLabel(new LangString("波数", "zh"));
  quantityKind.addLabel(new LangString("dalga sayısı", "tr"));
  quantityKind.addLabel(new LangString("wavenumber", "en"));
  quantityKind.addLabel(new LangString("número de ola", "es"));
  quantityKind.addLabel(new LangString("波数", "ja"));
  quantityKind.addLabel(new LangString("عدد موج", "fa"));
  quantityKind.addLabel(new LangString("Vlnové číslo", "cs"));
  quantityKind.addLabel(new LangString("Liczba falowa", "pl"));
  quantityKind.addLabel(new LangString("numero d'onda", "it"));
  quantityKind.addLabel(new LangString("número de onda", "pt"));
  quantityKind.addLabel(new LangString("Bilangan gelombang", "ms"));
  quantityKind.addLabel(new LangString("Repetenz", "de"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NUM-PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-M");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DPI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MESH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PER-ANGSTROM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/InverseLength"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Wavenumber",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WebTime",
    "http://qudt.org/vocab/dimensionvector/A0E0L0I0M0H0T1D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Web Time", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/WK");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckTime");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/SH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Common");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MO_MeanGREGORIAN"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Sidereal");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoSEC");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-KiloOHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-OHM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MicroH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY_Sidereal");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_Synodic");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiPOISE-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POISE-PER-PA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MilliH-PER-OHM"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_TROPICAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YR_Metrology");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PA-SEC-PER-BAR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DAY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaYR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MO_MeanJulian");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Time"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WebTime",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WebTimeAveragePressure",
    "http://qudt.org/vocab/dimensionvector/A0E0L-1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Web Time Average Pressure", "en"));
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloLB_F-PER-IN2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM_T");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroTORR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_60DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARYE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA_A");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/GM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroATM");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/DYN-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliTORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliPA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-CentiM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TORR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN-PER-M2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM_F-PER-M2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL-PER-FT2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaPSI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/PlanckPressure"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN_HG");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaBAR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaPA");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-MilliM2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ATM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BARAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM_HGA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M_H2O");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiBAR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N-PER-M2");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Pressure"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WebTimeAveragePressure",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WebTimeAverageThrust",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Web Time Average Thrust", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Thrust"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WebTimeAverageThrust",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Weight",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M1H0T-2D0",
    "bold letter W",
    undefined
  );
  quantityKind.addLabel(new LangString("Berat", "ms"));
  quantityKind.addLabel(new LangString("Ağırlık", "tr"));
  quantityKind.addLabel(new LangString("weight", "en"));
  quantityKind.addLabel(new LangString("وزن", "ar"));
  quantityKind.addLabel(new LangString("peso", "es"));
  quantityKind.addLabel(new LangString("Gewicht", "de"));
  quantityKind.addLabel(new LangString("Вес", "ru"));
  quantityKind.addLabel(new LangString("peso", "pt"));
  quantityKind.addLabel(new LangString("tíha", "cs"));
  quantityKind.addLabel(new LangString("وزن", "fa"));
  quantityKind.addLabel(new LangString("Siła ciężkości", "pl"));
  quantityKind.addLabel(new LangString("poids", "fr"));
  quantityKind.addLabel(new LangString("重量", "zh"));
  quantityKind.addLabel(new LangString("重さ", "ja"));
  quantityKind.addLabel(new LangString("forza peso", "it"));
  quantityKind.addLabel(new LangString("greutate", "ro"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TON_F_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloPOND");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/POND");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DYN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaLB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/OZ_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloGM_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KIP_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckForce");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Force"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Weight",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Width",
    "http://qudt.org/vocab/dimensionvector/A0E0L1I0M0H0T0D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Width", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_N");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ROD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PARSEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/LY");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PCA");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ZOLL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/M");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/BTU_IT-PER-LB_F"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MI_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/IN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AU");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/HectoM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CentiM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ANGSTROM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GAUGE_FR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DeciM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FUR_Long");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FATH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilLength");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/YD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GA_Charriere");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroIN");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CHAIN_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/DecaM");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FM");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Length"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Width",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/Work",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    "A",
    undefined
  );
  quantityKind.addLabel(new LangString("kerja", "ms"));
  quantityKind.addLabel(new LangString("lucru mecanic", "ro"));
  quantityKind.addLabel(new LangString("delo", "sl"));
  quantityKind.addLabel(new LangString("iş", "tr"));
  quantityKind.addLabel(new LangString("trabajo", "es"));
  quantityKind.addLabel(new LangString("Arbeit", "de"));
  quantityKind.addLabel(new LangString("仕事量", "ja"));
  quantityKind.addLabel(new LangString("praca", "pl"));
  quantityKind.addLabel(new LangString("کار", "fa"));
  quantityKind.addLabel(new LangString("कार्य", "hi"));
  quantityKind.addLabel(new LangString("work", "en"));
  quantityKind.addLabel(new LangString("功", "zh"));
  quantityKind.addLabel(new LangString("lavoro", "it"));
  quantityKind.addLabel(new LangString("trabalho", "pt"));
  quantityKind.addLabel(new LangString("travail", "fr"));
  quantityKind.addLabel(new LangString("práce", "cs"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/Work",
    quantityKind
  );
  quantityKind = new QuantityKind(
    "http://qudt.org/vocab/quantitykind/WorkFunction",
    "http://qudt.org/vocab/dimensionvector/A0E0L2I0M1H0T-2D0",
    undefined,
    undefined
  );
  quantityKind.addLabel(new LangString("Work Function", "en"));
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/NanoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ExaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/QUAD");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-LB_F");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PicoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/EV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/AttoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaTOE");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FT-PDL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/BTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_EC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THERM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/ERG");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/V-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/V-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PetaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/CAL_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloCAL");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_US");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_IT");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MicroJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/E_h");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/FemtoJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MilliJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TonEnergy");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/KiloV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/J");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaV-A-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaEV");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/MegaW-HR");
  quantityKind.addApplicableUnitIri(
    "http://qudt.org/vocab/unit/MegaV-A_Reactive-HR"
  );
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/THM_EEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloW-HR");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/W-SEC");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/TeraJ");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/KiloBTU_TH");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/PlanckEnergy");
  quantityKind.addApplicableUnitIri("http://qudt.org/vocab/unit/GigaW-HR");
  quantityKind.addBroaderQuantityKindIri(
    "http://qudt.org/vocab/quantitykind/Energy"
  );
  config.quantityKinds.set(
    "http://qudt.org/vocab/quantitykind/WorkFunction",
    quantityKind
  );
}

export const QuantityKinds = {
  // rotary-translatory motion conversion
  Rotary__TranslatoryMotionConversion: Qudt.quantityKindFromLocalnameRequired(
    "Rotary-TranslatoryMotionConversion"
  ),
  // Temperature Amount of Substance
  TemperatureAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureAmountOfSubstance"
  ),
  // molar thermal capacity
  MolarThermalCapacity: Qudt.quantityKindFromLocalnameRequired(
    "MolarThermalCapacity"
  ),
  // Characteristic Velocity
  CharacteristicVelocity: Qudt.quantityKindFromLocalnameRequired(
    "CharacteristicVelocity"
  ),
  // electromotive force
  ElectromotiveForce:
    Qudt.quantityKindFromLocalnameRequired("ElectromotiveForce"),
  // Average Logarithmic Energy Decrement
  AverageLogarithmicEnergyDecrement: Qudt.quantityKindFromLocalnameRequired(
    "AverageLogarithmicEnergyDecrement"
  ),
  // Specific heat capacity at constant pressure
  SpecificHeatCapacityAtConstantPressure:
    Qudt.quantityKindFromLocalnameRequired(
      "SpecificHeatCapacityAtConstantPressure"
    ),
  // Luminous Exposure
  LuminousExposure: Qudt.quantityKindFromLocalnameRequired("LuminousExposure"),
  // Heat Flow Rate
  HeatFlowRate: Qudt.quantityKindFromLocalnameRequired("HeatFlowRate"),
  // lineic logarithmic ratio
  LinearLogarithmicRatio: Qudt.quantityKindFromLocalnameRequired(
    "LinearLogarithmicRatio"
  ),
  // Payload Ratio
  PayloadRatio: Qudt.quantityKindFromLocalnameRequired("PayloadRatio"),
  // Linear Attenuation Coefficient
  LinearAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearAttenuationCoefficient"
  ),
  // indukcja magnetyczna
  MagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFluxDensity"
  ),
  // Apogee Radius
  ApogeeRadius: Qudt.quantityKindFromLocalnameRequired("ApogeeRadius"),
  // Surface Activity Density
  SurfaceActivityDensity: Qudt.quantityKindFromLocalnameRequired(
    "SurfaceActivityDensity"
  ),
  // fugacitate
  Fugacity: Qudt.quantityKindFromLocalnameRequired("Fugacity"),
  // Particle Number Density
  ParticleNumberDensity: Qudt.quantityKindFromLocalnameRequired(
    "ParticleNumberDensity"
  ),
  // Thrust To Weight Ratio
  ThrustToWeightRatio: Qudt.quantityKindFromLocalnameRequired(
    "ThrustToWeightRatio"
  ),
  // Capacity
  Capacity: Qudt.quantityKindFromLocalnameRequired("Capacity"),
  // Linear Thermal Expansion
  LinearThermalExpansion: Qudt.quantityKindFromLocalnameRequired(
    "LinearThermalExpansion"
  ),
  // Vacuum Thrust
  VacuumThrust: Qudt.quantityKindFromLocalnameRequired("VacuumThrust"),
  // surge impedance of the medium
  SurgeImpedanceOfTheMedium: Qudt.quantityKindFromLocalnameRequired(
    "SurgeImpedanceOfTheMedium"
  ),
  // volume or section modulus
  VolumeOrSectionModulus: Qudt.quantityKindFromLocalnameRequired(
    "VolumeOrSectionModulus"
  ),
  // Electric Current per Length
  ElectricCurrentPerLength: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerLength"
  ),
  // Group Speed of Sound
  GroupSpeedOfSound:
    Qudt.quantityKindFromLocalnameRequired("GroupSpeedOfSound"),
  // yoğunluk
  MassDensity: Qudt.quantityKindFromLocalnameRequired("MassDensity"),
  // factor de potencia
  PowerFactor: Qudt.quantityKindFromLocalnameRequired("PowerFactor"),
  // Earth Closest Approach Vehicle Velocity
  EarthClosestApproachVehicleVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EarthClosestApproachVehicleVelocity"
  ),
  // Growing Degree Days (Cereals)
  GrowingDegreeDay_Cereal: Qudt.quantityKindFromLocalnameRequired(
    "GrowingDegreeDay_Cereal"
  ),
  // Specific Internal Energy
  SpecificInternalEnergy: Qudt.quantityKindFromLocalnameRequired(
    "SpecificInternalEnergy"
  ),
  // Density of states
  DensityOfStates: Qudt.quantityKindFromLocalnameRequired("DensityOfStates"),
  // Eccentricity Of Orbit
  EccentricityOfOrbit: Qudt.quantityKindFromLocalnameRequired(
    "EccentricityOfOrbit"
  ),
  // Debye Temperature
  DebyeTemperature: Qudt.quantityKindFromLocalnameRequired("DebyeTemperature"),
  // Energiekosten
  CostPerEnergy: Qudt.quantityKindFromLocalnameRequired("CostPerEnergy"),
  // Web Time Average Thrust
  WebTimeAverageThrust: Qudt.quantityKindFromLocalnameRequired(
    "WebTimeAverageThrust"
  ),
  // Information Entropy
  InformationEntropy:
    Qudt.quantityKindFromLocalnameRequired("InformationEntropy"),
  // Section Area Integral
  SectionAreaIntegral: Qudt.quantityKindFromLocalnameRequired(
    "SectionAreaIntegral"
  ),
  // Molecular Mass
  MolecularMass: Qudt.quantityKindFromLocalnameRequired("MolecularMass"),
  // Time Squared
  TimeSquared: Qudt.quantityKindFromLocalnameRequired("TimeSquared"),
  // Mass per Area
  MassPerArea: Qudt.quantityKindFromLocalnameRequired("MassPerArea"),
  // Temperature per Time
  TemperaturePerTime:
    Qudt.quantityKindFromLocalnameRequired("TemperaturePerTime"),
  // volume molar
  MolarVolume: Qudt.quantityKindFromLocalnameRequired("MolarVolume"),
  // Pressure Percentage
  PressurePercentage:
    Qudt.quantityKindFromLocalnameRequired("PressurePercentage"),
  // Compressibility
  Compressibility: Qudt.quantityKindFromLocalnameRequired("Compressibility"),
  // Permeability
  Permeability: Qudt.quantityKindFromLocalnameRequired("Permeability"),
  // Order of Reflection
  OrderOfReflection:
    Qudt.quantityKindFromLocalnameRequired("OrderOfReflection"),
  // Positive Plane Angle
  PositivePlaneAngle:
    Qudt.quantityKindFromLocalnameRequired("PositivePlaneAngle"),
  // Adaptation
  Adaptation: Qudt.quantityKindFromLocalnameRequired("Adaptation"),
  // First Moment of Area
  FirstMomentOfArea:
    Qudt.quantityKindFromLocalnameRequired("FirstMomentOfArea"),
  // Neutron Yield per Fission
  NeutronYieldPerFission: Qudt.quantityKindFromLocalnameRequired(
    "NeutronYieldPerFission"
  ),
  // linear voltage coefficient
  LinearVoltageCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearVoltageCoefficient"
  ),
  // Magnetic Susceptability
  MagneticSusceptability: Qudt.quantityKindFromLocalnameRequired(
    "MagneticSusceptability"
  ),
  // Product of Inertia
  PRODUCT__OF__INERTIA:
    Qudt.quantityKindFromLocalnameRequired("PRODUCT-OF-INERTIA"),
  // Blood Glucose Level by Mass
  BloodGlucoseLevel_Mass: Qudt.quantityKindFromLocalnameRequired(
    "BloodGlucoseLevel_Mass"
  ),
  // Permeability Ratio
  PermeabilityRatio:
    Qudt.quantityKindFromLocalnameRequired("PermeabilityRatio"),
  // Static pressure
  StaticPressure: Qudt.quantityKindFromLocalnameRequired("StaticPressure"),
  // Atomic Mass
  AtomicMass: Qudt.quantityKindFromLocalnameRequired("AtomicMass"),
  // Permeance
  Permeance: Qudt.quantityKindFromLocalnameRequired("Permeance"),
  // Temporal Summation Function
  TemporalSummationFunction: Qudt.quantityKindFromLocalnameRequired(
    "TemporalSummationFunction"
  ),
  // Lift Coefficient
  LiftCoefficient: Qudt.quantityKindFromLocalnameRequired("LiftCoefficient"),
  // Ion Concentration
  IonConcentration: Qudt.quantityKindFromLocalnameRequired("IonConcentration"),
  // Energy per Area
  EnergyPerArea: Qudt.quantityKindFromLocalnameRequired("EnergyPerArea"),
  // Center of Gravity in the Y axis
  CenterOfGravity_Y:
    Qudt.quantityKindFromLocalnameRequired("CenterOfGravity_Y"),
  // radioactive decay
  RadioactiveDecay: Qudt.quantityKindFromLocalnameRequired("RadioactiveDecay"),
  // Heat Capacity Ratio
  HeatCapacityRatio:
    Qudt.quantityKindFromLocalnameRequired("HeatCapacityRatio"),
  // Mole Fraction
  MoleFraction: Qudt.quantityKindFromLocalnameRequired("MoleFraction"),
  // numero di massa
  NucleonNumber: Qudt.quantityKindFromLocalnameRequired("NucleonNumber"),
  // Area Temperature
  AreaTemperature: Qudt.quantityKindFromLocalnameRequired("AreaTemperature"),
  // Atomic Charge
  AtomicCharge: Qudt.quantityKindFromLocalnameRequired("AtomicCharge"),
  // Susceptance
  Susceptance: Qudt.quantityKindFromLocalnameRequired("Susceptance"),
  // Molar Energy
  MolarEnergy: Qudt.quantityKindFromLocalnameRequired("MolarEnergy"),
  // Inverse Magnetic Flux
  InverseMagneticFlux: Qudt.quantityKindFromLocalnameRequired(
    "InverseMagneticFlux"
  ),
  // Max Operating Thrust
  MaxOperatingThrust:
    Qudt.quantityKindFromLocalnameRequired("MaxOperatingThrust"),
  // Positive Length
  PositiveLength: Qudt.quantityKindFromLocalnameRequired("PositiveLength"),
  // volumic output
  VolumicOutput: Qudt.quantityKindFromLocalnameRequired("VolumicOutput"),
  // Specific Power
  SpecificPower: Qudt.quantityKindFromLocalnameRequired("SpecificPower"),
  // Propellant Mean Bulk Temperature
  PropellantMeanBulkTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PropellantMeanBulkTemperature"
  ),
  // atomic energy
  AtomicEnergy: Qudt.quantityKindFromLocalnameRequired("AtomicEnergy"),
  // corrente elettrica
  ElectricCurrent: Qudt.quantityKindFromLocalnameRequired("ElectricCurrent"),
  // Binding Fraction
  BindingFraction: Qudt.quantityKindFromLocalnameRequired("BindingFraction"),
  // median information flow (from a source of information), expressed as a common logarithm
  LogarithmicMedianInformationFlow_SourceToBase10:
    Qudt.quantityKindFromLocalnameRequired(
      "LogarithmicMedianInformationFlow_SourceToBase10"
    ),
  // pressure-based temperature
  PressureBasedTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedTemperature"
  ),
  // Friction
  Friction: Qudt.quantityKindFromLocalnameRequired("Friction"),
  // Macroscopic Total Cross-section
  MacroscopicTotalCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "MacroscopicTotalCrossSection"
  ),
  // Force per Electric Charge
  ForcePerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "ForcePerElectricCharge"
  ),
  // Ionization Energy
  IonizationEnergy: Qudt.quantityKindFromLocalnameRequired("IonizationEnergy"),
  // Halaju bersudut
  AngularVelocity: Qudt.quantityKindFromLocalnameRequired("AngularVelocity"),
  // Stress Intensity Factor
  StressIntensityFactor: Qudt.quantityKindFromLocalnameRequired(
    "StressIntensityFactor"
  ),
  // 慣性モーメント
  MomentOfInertia: Qudt.quantityKindFromLocalnameRequired("MomentOfInertia"),
  // information content
  InformationContent:
    Qudt.quantityKindFromLocalnameRequired("InformationContent"),
  // Voltage Ratio
  VoltageRatio: Qudt.quantityKindFromLocalnameRequired("VoltageRatio"),
  // Relative Partial Pressure
  RelativePartialPressure: Qudt.quantityKindFromLocalnameRequired(
    "RelativePartialPressure"
  ),
  // Ambient Pressure
  AmbientPressure: Qudt.quantityKindFromLocalnameRequired("AmbientPressure"),
  // Flash Point Temperature
  FlashPoint: Qudt.quantityKindFromLocalnameRequired("FlashPoint"),
  // Thermal Energy
  ThermalEnergy: Qudt.quantityKindFromLocalnameRequired("ThermalEnergy"),
  // Average Vacuum Thrust
  AverageVacuumThrust: Qudt.quantityKindFromLocalnameRequired(
    "AverageVacuumThrust"
  ),
  // Molar Refractivity
  MolarRefractivity:
    Qudt.quantityKindFromLocalnameRequired("MolarRefractivity"),
  // Slowing-Down Area
  Slowing__DownArea: Qudt.quantityKindFromLocalnameRequired("Slowing-DownArea"),
  // Standard Chemical Potential
  StandardChemicalPotential: Qudt.quantityKindFromLocalnameRequired(
    "StandardChemicalPotential"
  ),
  // Activity Thresholds
  ActivityThresholds:
    Qudt.quantityKindFromLocalnameRequired("ActivityThresholds"),
  // Burn Time
  BurnTime: Qudt.quantityKindFromLocalnameRequired("BurnTime"),
  // cost per area
  CostPerArea: Qudt.quantityKindFromLocalnameRequired("CostPerArea"),
  // byte data volume
  ByteDataVolume: Qudt.quantityKindFromLocalnameRequired("ByteDataVolume"),
  // Relative Mass Density
  RelativeMassDensity: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMassDensity"
  ),
  // Electric Current per Unit Length
  ElectricCurrentPerUnitLength: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerUnitLength"
  ),
  // 利得
  SoundPressureLevel:
    Qudt.quantityKindFromLocalnameRequired("SoundPressureLevel"),
  // polarisability
  Polarizability: Qudt.quantityKindFromLocalnameRequired("Polarizability"),
  // Magnetic Dipole Moment
  MagneticDipoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "MagneticDipoleMoment"
  ),
  // Control Mass.
  CONTROL__MASS: Qudt.quantityKindFromLocalnameRequired("CONTROL-MASS"),
  // Structure Factor
  StructureFactor: Qudt.quantityKindFromLocalnameRequired("StructureFactor"),
  // Inverse Length
  InverseLength: Qudt.quantityKindFromLocalnameRequired("InverseLength"),
  // Tenaga keupayaan
  PotentialEnergy: Qudt.quantityKindFromLocalnameRequired("PotentialEnergy"),
  // Temperature per Time Squared
  TemperaturePerTime_Squared: Qudt.quantityKindFromLocalnameRequired(
    "TemperaturePerTime_Squared"
  ),
  // earthquake magnitude
  EarthquakeMagnitude: Qudt.quantityKindFromLocalnameRequired(
    "EarthquakeMagnitude"
  ),
  // Lift Force
  LiftForce: Qudt.quantityKindFromLocalnameRequired("LiftForce"),
  // massic torque
  MassicTorque: Qudt.quantityKindFromLocalnameRequired("MassicTorque"),
  // reciprocal electric resistance
  ReciprocalElectricResistance: Qudt.quantityKindFromLocalnameRequired(
    "ReciprocalElectricResistance"
  ),
  // Illuminance
  SphericalIlluminance: Qudt.quantityKindFromLocalnameRequired(
    "SphericalIlluminance"
  ),
  // Center of Mass (CoM)
  CENTER__OF__MASS: Qudt.quantityKindFromLocalnameRequired("CENTER-OF-MASS"),
  // Energy per temperature
  EnergyPerTemperature: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerTemperature"
  ),
  // Vapor Pressure
  VaporPressure: Qudt.quantityKindFromLocalnameRequired("VaporPressure"),
  // Tension
  Tension: Qudt.quantityKindFromLocalnameRequired("Tension"),
  // Maximum Expected Operating Thrust
  MaxExpectedOperatingThrust: Qudt.quantityKindFromLocalnameRequired(
    "MaxExpectedOperatingThrust"
  ),
  // dose equivalent rate
  DoseEquivalentRate:
    Qudt.quantityKindFromLocalnameRequired("DoseEquivalentRate"),
  // Energy per electric charge
  EnergyPerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerElectricCharge"
  ),
  // Displacement Current
  DisplacementCurrent: Qudt.quantityKindFromLocalnameRequired(
    "DisplacementCurrent"
  ),
  // Relative Atomic Mass
  RelativeAtomicMass:
    Qudt.quantityKindFromLocalnameRequired("RelativeAtomicMass"),
  // Inverse Time Temperature
  InverseTimeTemperature: Qudt.quantityKindFromLocalnameRequired(
    "InverseTimeTemperature"
  ),
  // Instantaneous Power
  InstantaneousPower:
    Qudt.quantityKindFromLocalnameRequired("InstantaneousPower"),
  // Energy Fluence
  EnergyFluence: Qudt.quantityKindFromLocalnameRequired("EnergyFluence"),
  // Specific Volume
  SpecificVolume: Qudt.quantityKindFromLocalnameRequired("SpecificVolume"),
  // Energy Level
  EnergyLevel: Qudt.quantityKindFromLocalnameRequired("EnergyLevel"),
  // Gain
  Gain: Qudt.quantityKindFromLocalnameRequired("Gain"),
  // Hyperfine Structure Quantum Number
  HyperfineStructureQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "HyperfineStructureQuantumNumber"
  ),
  // RotationalFrequency
  RotationalVelocity:
    Qudt.quantityKindFromLocalnameRequired("RotationalVelocity"),
  // Generalized Force
  GeneralizedForce: Qudt.quantityKindFromLocalnameRequired("GeneralizedForce"),
  // Particle Position Vector
  ParticlePositionVector: Qudt.quantityKindFromLocalnameRequired(
    "ParticlePositionVector"
  ),
  // pressure-based length
  PressureBasedLength: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedLength"
  ),
  // Thermodynamic Energy
  ThermodynamicEnergy: Qudt.quantityKindFromLocalnameRequired(
    "ThermodynamicEnergy"
  ),
  // Incidence Rate
  IncidenceRate: Qudt.quantityKindFromLocalnameRequired("IncidenceRate"),
  // Gruneisen Parameter
  GruneisenParameter:
    Qudt.quantityKindFromLocalnameRequired("GruneisenParameter"),
  // Activity Coefficient
  ActivityCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "ActivityCoefficient"
  ),
  // Turbidity
  Turbidity: Qudt.quantityKindFromLocalnameRequired("Turbidity"),
  // Linear Momentum
  LinearMomentum: Qudt.quantityKindFromLocalnameRequired("LinearMomentum"),
  // larghezza
  Breadth: Qudt.quantityKindFromLocalnameRequired("Breadth"),
  // كمية المادة
  AmountOfSubstance:
    Qudt.quantityKindFromLocalnameRequired("AmountOfSubstance"),
  // RotationalFrequency
  RotationalFrequency: Qudt.quantityKindFromLocalnameRequired(
    "RotationalFrequency"
  ),
  // Cubic Electric Dipole Moment per Square Energy
  CubicElectricDipoleMomentPerSquareEnergy:
    Qudt.quantityKindFromLocalnameRequired(
      "CubicElectricDipoleMomentPerSquareEnergy"
    ),
  // Reynolds Number
  ReynoldsNumber: Qudt.quantityKindFromLocalnameRequired("ReynoldsNumber"),
  // Final Or Current Vehicle Mass
  FinalOrCurrentVehicleMass: Qudt.quantityKindFromLocalnameRequired(
    "FinalOrCurrentVehicleMass"
  ),
  // Closest Approach Radius
  ClosestApproachRadius: Qudt.quantityKindFromLocalnameRequired(
    "ClosestApproachRadius"
  ),
  // pressure-based volume
  PressureBasedVolume: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedVolume"
  ),
  // Landau-Ginzburg Number
  Landau__GinzburgNumber: Qudt.quantityKindFromLocalnameRequired(
    "Landau-GinzburgNumber"
  ),
  // Modulus of Rotational Subgrade Reaction
  ModulusOfRotationalSubgradeReaction: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfRotationalSubgradeReaction"
  ),
  // Energy Per Square Magnetic Flux Density
  EnergyPerSquareMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerSquareMagneticFluxDensity"
  ),
  // Reaction Rate Constant
  SecondOrderReactionRateConstant: Qudt.quantityKindFromLocalnameRequired(
    "SecondOrderReactionRateConstant"
  ),
  // Water Solubility
  Solubility_Water: Qudt.quantityKindFromLocalnameRequired("Solubility_Water"),
  // Dissipance
  Dissipance: Qudt.quantityKindFromLocalnameRequired("Dissipance"),
  // Electromagnetic Energy Density
  ElectromagneticEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticEnergyDensity"
  ),
  // Length Mass
  LengthMass: Qudt.quantityKindFromLocalnameRequired("LengthMass"),
  // Positive Length
  NonNegativeLength:
    Qudt.quantityKindFromLocalnameRequired("NonNegativeLength"),
  // Current Linkage
  CurrentLinkage: Qudt.quantityKindFromLocalnameRequired("CurrentLinkage"),
  // Visible Radiant Energy
  VisibleRadiantEnergy: Qudt.quantityKindFromLocalnameRequired(
    "VisibleRadiantEnergy"
  ),
  // loudness level
  LoudnessLevel: Qudt.quantityKindFromLocalnameRequired("LoudnessLevel"),
  // Internal Energy
  InternalEnergy: Qudt.quantityKindFromLocalnameRequired("InternalEnergy"),
  // Exit Plane Cross-sectional Area
  ExitPlaneCrossSectionalArea: Qudt.quantityKindFromLocalnameRequired(
    "ExitPlaneCrossSectionalArea"
  ),
  // Radiative Heat Transfer
  RadiativeHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "RadiativeHeatTransfer"
  ),
  // rate of rise of voltage
  RateOfRiseOfVoltage: Qudt.quantityKindFromLocalnameRequired(
    "RateOfRiseOfVoltage"
  ),
  // Magnetic Area Moment
  MagneticAreaMoment:
    Qudt.quantityKindFromLocalnameRequired("MagneticAreaMoment"),
  // Photosynthetic Photon Flux
  PhotosyntheticPhotonFlux: Qudt.quantityKindFromLocalnameRequired(
    "PhotosyntheticPhotonFlux"
  ),
  // Acidity
  Acidity: Qudt.quantityKindFromLocalnameRequired("Acidity"),
  // Shannon Diversity Index
  ShannonDiversityIndex: Qudt.quantityKindFromLocalnameRequired(
    "ShannonDiversityIndex"
  ),
  // Dynamic Friction Coefficient
  DynamicFrictionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "DynamicFrictionCoefficient"
  ),
  // Molar Angular Momentum
  MolarAngularMomentum: Qudt.quantityKindFromLocalnameRequired(
    "MolarAngularMomentum"
  ),
  // Active Energy
  ActiveEnergy: Qudt.quantityKindFromLocalnameRequired("ActiveEnergy"),
  // Amount of Substance of Fraction of B
  AmountOfSubstanceFractionOfB: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceFractionOfB"
  ),
  // ciepło
  Heat: Qudt.quantityKindFromLocalnameRequired("Heat"),
  // volumetric entity density
  VolumetricEntityDensity: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricEntityDensity"
  ),
  // Power per area quartic temperature
  PowerPerAreaQuarticTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PowerPerAreaQuarticTemperature"
  ),
  // Reactor Time Constant
  ReactorTimeConstant: Qudt.quantityKindFromLocalnameRequired(
    "ReactorTimeConstant"
  ),
  // Electric Charge Surface Density
  ElectricChargeSurfaceDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeSurfaceDensity"
  ),
  // Source Voltage
  SourceVoltage: Qudt.quantityKindFromLocalnameRequired("SourceVoltage"),
  // activity related by mass
  ActivityRelatedByMass: Qudt.quantityKindFromLocalnameRequired(
    "ActivityRelatedByMass"
  ),
  // Napierian Absorbance
  NapierianAbsorbance: Qudt.quantityKindFromLocalnameRequired(
    "NapierianAbsorbance"
  ),
  // impulso angolare
  AngularImpulse: Qudt.quantityKindFromLocalnameRequired("AngularImpulse"),
  // London Penetration Depth
  LondonPenetrationDepth: Qudt.quantityKindFromLocalnameRequired(
    "LondonPenetrationDepth"
  ),
  // Degree of Dissociation
  DegreeOfDissociation: Qudt.quantityKindFromLocalnameRequired(
    "DegreeOfDissociation"
  ),
  // Average Specific Impulse
  AverageSpecificImpulse: Qudt.quantityKindFromLocalnameRequired(
    "AverageSpecificImpulse"
  ),
  // Fish Biotransformation Half Life
  FishBiotransformationHalfLife: Qudt.quantityKindFromLocalnameRequired(
    "FishBiotransformationHalfLife"
  ),
  // Mass Delivered
  MASS__DELIVERED: Qudt.quantityKindFromLocalnameRequired("MASS-DELIVERED"),
  // Spin Quantum Number
  NuclearSpinQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "NuclearSpinQuantumNumber"
  ),
  // Rest Energy
  RestEnergy: Qudt.quantityKindFromLocalnameRequired("RestEnergy"),
  // Average Energy Loss per Elementary Charge Produced
  AverageEnergyLossPerElementaryChargeProduced:
    Qudt.quantityKindFromLocalnameRequired(
      "AverageEnergyLossPerElementaryChargeProduced"
    ),
  // pressure-based volume flow
  PressureBasedVolumeFlow: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedVolumeFlow"
  ),
  // Time Ratio
  TimeRatio: Qudt.quantityKindFromLocalnameRequired("TimeRatio"),
  // Altitude
  Altitude: Qudt.quantityKindFromLocalnameRequired("Altitude"),
  // Mass Amount of Substance
  MassAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "MassAmountOfSubstance"
  ),
  // state density as expression of angular frequency)
  StateDensityAsExpressionOfAngularFrequency:
    Qudt.quantityKindFromLocalnameRequired(
      "StateDensityAsExpressionOfAngularFrequency"
    ),
  // звуковая мощность
  SoundPower: Qudt.quantityKindFromLocalnameRequired("SoundPower"),
  // Energy Per Area Electric Charge
  EnergyPerAreaElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerAreaElectricCharge"
  ),
  // equivalence dose output
  EquivalenceDoseOutput: Qudt.quantityKindFromLocalnameRequired(
    "EquivalenceDoseOutput"
  ),
  // Data Rate
  DataRate: Qudt.quantityKindFromLocalnameRequired("DataRate"),
  // Electric charge per amount of substance
  ElectricChargePerAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargePerAmountOfSubstance"
  ),
  // Alpha Disintegration Energy
  AlphaDisintegrationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "AlphaDisintegrationEnergy"
  ),
  // Particle Fluence
  ParticleFluence: Qudt.quantityKindFromLocalnameRequired("ParticleFluence"),
  // Ion Density
  IonDensity: Qudt.quantityKindFromLocalnameRequired("IonDensity"),
  // Electric Current per Unit Temperature
  ElectricCurrentPerUnitTemperature: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerUnitTemperature"
  ),
  // Total Linear Stopping Power
  TotalLinearStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "TotalLinearStoppingPower"
  ),
  // lineic resistance
  LineicResistance: Qudt.quantityKindFromLocalnameRequired("LineicResistance"),
  // Electric Charge Linear Density
  ElectricChargeLinearDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeLinearDensity"
  ),
  // Osmotic Coefficient
  OsmoticCoefficient:
    Qudt.quantityKindFromLocalnameRequired("OsmoticCoefficient"),
  // Dose Equivalent
  DoseEquivalent: Qudt.quantityKindFromLocalnameRequired("DoseEquivalent"),
  // Calorific Value
  HeatingValue: Qudt.quantityKindFromLocalnameRequired("HeatingValue"),
  // Drag Coefficient
  DragCoefficient: Qudt.quantityKindFromLocalnameRequired("DragCoefficient"),
  // dataset of bits
  DatasetOfBits: Qudt.quantityKindFromLocalnameRequired("DatasetOfBits"),
  // 等温压缩率
  IsothermalCompressibility: Qudt.quantityKindFromLocalnameRequired(
    "IsothermalCompressibility"
  ),
  // Slowing-Down Density
  Slowing__DownDensity: Qudt.quantityKindFromLocalnameRequired(
    "Slowing-DownDensity"
  ),
  // Head End Pressure
  HeadEndPressure: Qudt.quantityKindFromLocalnameRequired("HeadEndPressure"),
  // éclairement énergétique
  Irradiance: Qudt.quantityKindFromLocalnameRequired("Irradiance"),
  // अपवर्तनांक
  RefractiveIndex: Qudt.quantityKindFromLocalnameRequired("RefractiveIndex"),
  // Linear Electric Current
  LinearElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "LinearElectricCurrent"
  ),
  // reciprocal plane angle
  ReciprocalPlaneAngle: Qudt.quantityKindFromLocalnameRequired(
    "ReciprocalPlaneAngle"
  ),
  // Displacement Current Density
  DisplacementCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "DisplacementCurrentDensity"
  ),
  // burst factor
  BurstFactor: Qudt.quantityKindFromLocalnameRequired("BurstFactor"),
  // Moment of Inertia in the Y axis
  MOMENT__OF__INERTIA_Y: Qudt.quantityKindFromLocalnameRequired(
    "MOMENT-OF-INERTIA_Y"
  ),
  // Spin Quantum Number
  SpinQuantumNumber:
    Qudt.quantityKindFromLocalnameRequired("SpinQuantumNumber"),
  // Amount of Substance of Concentration of B
  AmountOfSubstanceConcentrationOfB: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceConcentrationOfB"
  ),
  // Lichtstärke
  LuminousIntensity:
    Qudt.quantityKindFromLocalnameRequired("LuminousIntensity"),
  // torque constant
  TorqueConstant: Qudt.quantityKindFromLocalnameRequired("TorqueConstant"),
  // Moment of Inertia in the Z axis
  MOMENT__OF__INERTIA_Z: Qudt.quantityKindFromLocalnameRequired(
    "MOMENT-OF-INERTIA_Z"
  ),
  // Modulus of Elasticity
  ModulusOfElasticity: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfElasticity"
  ),
  // Rotational Mass
  RotationalMass: Qudt.quantityKindFromLocalnameRequired("RotationalMass"),
  // ポインティングベクトル
  PoyntingVector: Qudt.quantityKindFromLocalnameRequired("PoyntingVector"),
  // reciprocal mass
  InverseMass: Qudt.quantityKindFromLocalnameRequired("InverseMass"),
  // Center of Gravity in the Z axis
  CENTER__OF__GRAVITY_Z: Qudt.quantityKindFromLocalnameRequired(
    "CENTER-OF-GRAVITY_Z"
  ),
  // Complex Power
  ComplexPower: Qudt.quantityKindFromLocalnameRequired("ComplexPower"),
  // Mass per Length
  MassPerLength: Qudt.quantityKindFromLocalnameRequired("MassPerLength"),
  // Reflectance Factor
  ReflectanceFactor:
    Qudt.quantityKindFromLocalnameRequired("ReflectanceFactor"),
  // Fission Core Radius To Height Ratio
  FissionCoreRadiusToHeightRatio: Qudt.quantityKindFromLocalnameRequired(
    "FissionCoreRadiusToHeightRatio"
  ),
  // Luminous Flux Ratio
  LuminousFluxRatio:
    Qudt.quantityKindFromLocalnameRequired("LuminousFluxRatio"),
  // Gene Family Abundance
  GeneFamilyAbundance: Qudt.quantityKindFromLocalnameRequired(
    "GeneFamilyAbundance"
  ),
  // Melting Point Temperature
  MeltingPoint: Qudt.quantityKindFromLocalnameRequired("MeltingPoint"),
  // Angular Reciprocal Lattice Vector
  AngularReciprocalLatticeVector: Qudt.quantityKindFromLocalnameRequired(
    "AngularReciprocalLatticeVector"
  ),
  // Cartesian Area
  CartesianArea: Qudt.quantityKindFromLocalnameRequired("CartesianArea"),
  // Thermal Utilization Factor
  ThermalUtilizationFactor: Qudt.quantityKindFromLocalnameRequired(
    "ThermalUtilizationFactor"
  ),
  // Mean Free Path
  MeanFreePath: Qudt.quantityKindFromLocalnameRequired("MeanFreePath"),
  // transmission ratio between rotation and translation
  TransmissionRatioBetweenRotationAndTranslation:
    Qudt.quantityKindFromLocalnameRequired(
      "TransmissionRatioBetweenRotationAndTranslation"
    ),
  // logarithmic frequency interval to base 10
  Log10FrequencyInterval: Qudt.quantityKindFromLocalnameRequired(
    "Log10FrequencyInterval"
  ),
  // Radiant Fluence Rate
  RadiantFluenceRate:
    Qudt.quantityKindFromLocalnameRequired("RadiantFluenceRate"),
  // Extent of Reaction
  ExtentOfReaction: Qudt.quantityKindFromLocalnameRequired("ExtentOfReaction"),
  // Volume Strain
  VolumeStrain: Qudt.quantityKindFromLocalnameRequired("VolumeStrain"),
  // Orbital Angular Momentum Quantum Number
  OrbitalAngularMomentumQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "OrbitalAngularMomentumQuantumNumber"
  ),
  // Anschaffungskosten pro Watt
  CostPerPower: Qudt.quantityKindFromLocalnameRequired("CostPerPower"),
  // Specific Entropy
  SpecificEntropy: Qudt.quantityKindFromLocalnameRequired("SpecificEntropy"),
  // thermal insulation
  ThermalInsulation:
    Qudt.quantityKindFromLocalnameRequired("ThermalInsulation"),
  // Period
  Period: Qudt.quantityKindFromLocalnameRequired("Period"),
  // radiant energy exposure
  RadiantEnergyExposure: Qudt.quantityKindFromLocalnameRequired(
    "RadiantEnergyExposure"
  ),
  // Spectral Cross-section
  SpectralCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "SpectralCrossSection"
  ),
  // electrical conductance
  ElectricalConductance: Qudt.quantityKindFromLocalnameRequired(
    "ElectricalConductance"
  ),
  // Inverse Permittivity
  InversePermittivity: Qudt.quantityKindFromLocalnameRequired(
    "InversePermittivity"
  ),
  // Specific thrust
  SpecificThrust: Qudt.quantityKindFromLocalnameRequired("SpecificThrust"),
  // Specific Impulse by Weight
  SpecificImpulseByWeight: Qudt.quantityKindFromLocalnameRequired(
    "SpecificImpulseByWeight"
  ),
  // semiperiodo
  Half__Life: Qudt.quantityKindFromLocalnameRequired("Half-Life"),
  // median information flow (from a source of information), expressed as a binary logarithm
  LogarithmicMedianInformationFlow_SourceToBase2:
    Qudt.quantityKindFromLocalnameRequired(
      "LogarithmicMedianInformationFlow_SourceToBase2"
    ),
  // Migration Length
  MigrationLength: Qudt.quantityKindFromLocalnameRequired("MigrationLength"),
  // Quartic Electric Dipole Moment per Cubic Energy
  ElectricDipoleMoment_QuarticPerEnergy_Cubic:
    Qudt.quantityKindFromLocalnameRequired(
      "ElectricDipoleMoment_QuarticPerEnergy_Cubic"
    ),
  // Angle Of Attack
  AngleOfAttack: Qudt.quantityKindFromLocalnameRequired("AngleOfAttack"),
  // Conduction Speed
  ConductionSpeed: Qudt.quantityKindFromLocalnameRequired("ConductionSpeed"),
  // Lower Critical Magnetic Flux Density
  LowerCriticalMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "LowerCriticalMagneticFluxDensity"
  ),
  // Mass Property Uncertainty
  MASS__PROPERTY__UNCERTAINTY: Qudt.quantityKindFromLocalnameRequired(
    "MASS-PROPERTY-UNCERTAINTY"
  ),
  // Total Current
  TotalCurrent: Qudt.quantityKindFromLocalnameRequired("TotalCurrent"),
  // Level Width
  LevelWidth: Qudt.quantityKindFromLocalnameRequired("LevelWidth"),
  // Body Mass Index
  BodyMassIndex: Qudt.quantityKindFromLocalnameRequired("BodyMassIndex"),
  // Equivalent Density
  EquivalentDensity:
    Qudt.quantityKindFromLocalnameRequired("EquivalentDensity"),
  // Loss Angle
  LossAngle: Qudt.quantityKindFromLocalnameRequired("LossAngle"),
  // Inverse Square Mass
  InverseSquareMass:
    Qudt.quantityKindFromLocalnameRequired("InverseSquareMass"),
  // Wellenlänge
  Wavelength: Qudt.quantityKindFromLocalnameRequired("Wavelength"),
  // mass flux density
  MassFluxDensity: Qudt.quantityKindFromLocalnameRequired("MassFluxDensity"),
  // molar internal energy
  MolarInternalEnergy: Qudt.quantityKindFromLocalnameRequired(
    "MolarInternalEnergy"
  ),
  // Prevalence
  Prevalence: Qudt.quantityKindFromLocalnameRequired("Prevalence"),
  // Count
  Count: Qudt.quantityKindFromLocalnameRequired("Count"),
  // Leakage Factor
  LeakageFactor: Qudt.quantityKindFromLocalnameRequired("LeakageFactor"),
  // sun protection factor of a product
  SunProtectionFactorOfAProduct: Qudt.quantityKindFromLocalnameRequired(
    "SunProtectionFactorOfAProduct"
  ),
  // total radiance
  TotalRadiance: Qudt.quantityKindFromLocalnameRequired("TotalRadiance"),
  // differenza di potenziale elettrico
  ElectricPotentialDifference: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPotentialDifference"
  ),
  // Relative Pressure Coefficient
  RelativePressureCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "RelativePressureCoefficient"
  ),
  // Area Angle
  AreaAngle: Qudt.quantityKindFromLocalnameRequired("AreaAngle"),
  // Electrical Power To Mass Ratio
  ElectricalPowerToMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "ElectricalPowerToMassRatio"
  ),
  // Molar Absorption Coefficient
  MolarAbsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MolarAbsorptionCoefficient"
  ),
  // atomic stopping power
  AtomicStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "AtomicStoppingPower"
  ),
  // Modulus of Linear Subgrade Reaction
  ModulusOfLinearSubgradeReaction: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfLinearSubgradeReaction"
  ),
  // Turns
  Turns: Qudt.quantityKindFromLocalnameRequired("Turns"),
  // Seebeck Coefficient
  SeebeckCoefficient:
    Qudt.quantityKindFromLocalnameRequired("SeebeckCoefficient"),
  // Nominal Ascent Propellant Mass
  NOMINAL__ASCENT__PROPELLANT__MASS: Qudt.quantityKindFromLocalnameRequired(
    "NOMINAL-ASCENT-PROPELLANT-MASS"
  ),
  // time-related logarithmic ratio
  TimeRelatedLogarithmicRatio: Qudt.quantityKindFromLocalnameRequired(
    "TimeRelatedLogarithmicRatio"
  ),
  // Fermi Angular Wavenumber
  FermiAngularWavenumber: Qudt.quantityKindFromLocalnameRequired(
    "FermiAngularWavenumber"
  ),
  // bandwidth distance product
  BandwidthDistanceProduct: Qudt.quantityKindFromLocalnameRequired(
    "BandwidthDistanceProduct"
  ),
  // Neutron Yield per Absorption
  NeutronYieldPerAbsorption: Qudt.quantityKindFromLocalnameRequired(
    "NeutronYieldPerAbsorption"
  ),
  // Magnetization Field
  MagnetizationField:
    Qudt.quantityKindFromLocalnameRequired("MagnetizationField"),
  // Center of Gravity in the Z axis
  CenterOfGravity_Z:
    Qudt.quantityKindFromLocalnameRequired("CenterOfGravity_Z"),
  // absolute typographic measurement
  AbsoluteTypographicMeasurement: Qudt.quantityKindFromLocalnameRequired(
    "AbsoluteTypographicMeasurement"
  ),
  // Short-Range Order Parameter
  Short__RangeOrderParameter: Qudt.quantityKindFromLocalnameRequired(
    "Short-RangeOrderParameter"
  ),
  // temperature-based quantity
  TemperatureBasedQuantity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedQuantity"
  ),
  // RF-Power Level
  RF__Power: Qudt.quantityKindFromLocalnameRequired("RF-Power"),
  // Length per Unit Electric Current
  LengthPerUnitElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "LengthPerUnitElectricCurrent"
  ),
  // logarithmic frequency interval to base 10
  LogarithmicFrequencyIntervalToBase10: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmicFrequencyIntervalToBase10"
  ),
  // temperature-based density
  TemperatureBasedDensity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedDensity"
  ),
  // Quantum Number
  QuantumNumber: Qudt.quantityKindFromLocalnameRequired("QuantumNumber"),
  // Boiling Point Temperature
  BoilingPoint: Qudt.quantityKindFromLocalnameRequired("BoilingPoint"),
  // Lagrange Function
  LagrangeFunction: Qudt.quantityKindFromLocalnameRequired("LagrangeFunction"),
  // First Stage Mass Ratio
  FirstStageMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "FirstStageMassRatio"
  ),
  // Slowing-Down Length
  Slowing__DownLength:
    Qudt.quantityKindFromLocalnameRequired("Slowing-DownLength"),
  // Electric Current per Unit Energy
  ElectricCurrentPerUnitEnergy: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerUnitEnergy"
  ),
  // Inverse Pressure
  InversePressure: Qudt.quantityKindFromLocalnameRequired("InversePressure"),
  // Active Power
  ActivePower: Qudt.quantityKindFromLocalnameRequired("ActivePower"),
  // 压强、压力
  Pressure: Qudt.quantityKindFromLocalnameRequired("Pressure"),
  // Mass Of The Earth
  MassOfTheEarth: Qudt.quantityKindFromLocalnameRequired("MassOfTheEarth"),
  // Canonical Partition Function
  CanonicalPartitionFunction: Qudt.quantityKindFromLocalnameRequired(
    "CanonicalPartitionFunction"
  ),
  // Molar Attenuation Coefficient
  MolarAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MolarAttenuationCoefficient"
  ),
  // Temperature per Magnetic Flux Density
  TemperaturePerMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "TemperaturePerMagneticFluxDensity"
  ),
  // Electric Current Phasor
  ElectricCurrentPhasor: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPhasor"
  ),
  // Flight Performance Reserve Propellant Mass
  FLIGHT__PERFORMANCE__RESERVE__PROPELLANT__MASS:
    Qudt.quantityKindFromLocalnameRequired(
      "FLIGHT-PERFORMANCE-RESERVE-PROPELLANT-MASS"
    ),
  // Length Molar Energy
  LengthMolarEnergy:
    Qudt.quantityKindFromLocalnameRequired("LengthMolarEnergy"),
  // Activity Concentration
  ActivityConcentration: Qudt.quantityKindFromLocalnameRequired(
    "ActivityConcentration"
  ),
  // motor constant
  MotorConstant: Qudt.quantityKindFromLocalnameRequired("MotorConstant"),
  // Cold Receptor Threshold
  ColdReceptorThreshold: Qudt.quantityKindFromLocalnameRequired(
    "ColdReceptorThreshold"
  ),
  // Width
  Width: Qudt.quantityKindFromLocalnameRequired("Width"),
  // Reflectivity
  Reflectivity: Qudt.quantityKindFromLocalnameRequired("Reflectivity"),
  // Touch Thresholds
  TouchThresholds: Qudt.quantityKindFromLocalnameRequired("TouchThresholds"),
  // Atomic Attenuation Coefficient
  AtomicAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "AtomicAttenuationCoefficient"
  ),
  // Modulus Of Impedance
  ModulusOfImpedance:
    Qudt.quantityKindFromLocalnameRequired("ModulusOfImpedance"),
  // Cross-section
  CrossSection: Qudt.quantityKindFromLocalnameRequired("CrossSection"),
  // Gross Lift-Off Weight
  GROSS__LIFT__OFF__WEIGHT: Qudt.quantityKindFromLocalnameRequired(
    "GROSS-LIFT-OFF-WEIGHT"
  ),
  // Octanol Air Partition Coefficient
  LogOctanolAirPartitionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LogOctanolAirPartitionCoefficient"
  ),
  // Time Temperature
  TimeTemperature: Qudt.quantityKindFromLocalnameRequired("TimeTemperature"),
  // Debye Angular Frequency
  DebyeAngularFrequency: Qudt.quantityKindFromLocalnameRequired(
    "DebyeAngularFrequency"
  ),
  // Horizontal Velocity
  HorizontalVelocity:
    Qudt.quantityKindFromLocalnameRequired("HorizontalVelocity"),
  // Ion Current
  IonCurrent: Qudt.quantityKindFromLocalnameRequired("IonCurrent"),
  // Total Mass Stopping Power
  TotalMassStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "TotalMassStoppingPower"
  ),
  // Angular Momentum
  AngularMomentum: Qudt.quantityKindFromLocalnameRequired("AngularMomentum"),
  // Lattice Plane Spacing
  LatticePlaneSpacing: Qudt.quantityKindFromLocalnameRequired(
    "LatticePlaneSpacing"
  ),
  // Moment of Force
  MomentOfForce: Qudt.quantityKindFromLocalnameRequired("MomentOfForce"),
  // Sound exposure level
  SoundExposureLevel:
    Qudt.quantityKindFromLocalnameRequired("SoundExposureLevel"),
  // Inverse Square Time
  InverseTime_Squared: Qudt.quantityKindFromLocalnameRequired(
    "InverseTime_Squared"
  ),
  // Curvature
  CurvatureFromRadius: Qudt.quantityKindFromLocalnameRequired(
    "CurvatureFromRadius"
  ),
  // Fission Multiplication Factor
  FissionMultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "FissionMultiplicationFactor"
  ),
  // Photo Threshold of Awareness Function
  PhotoThresholdOfAwarenessFunction: Qudt.quantityKindFromLocalnameRequired(
    "PhotoThresholdOfAwarenessFunction"
  ),
  // Number of Particles
  NumberOfParticles:
    Qudt.quantityKindFromLocalnameRequired("NumberOfParticles"),
  // loudness
  Loudness: Qudt.quantityKindFromLocalnameRequired("Loudness"),
  // Molar Flow Rate
  MolarFlowRate: Qudt.quantityKindFromLocalnameRequired("MolarFlowRate"),
  // ładunek elektryczny
  ElectricCharge: Qudt.quantityKindFromLocalnameRequired("ElectricCharge"),
  // Electric Charge Line Density
  ElectricChargeLineDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeLineDensity"
  ),
  // Electron Mean Free Path
  ElectronMeanFreePath: Qudt.quantityKindFromLocalnameRequired(
    "ElectronMeanFreePath"
  ),
  // Permeability
  ElectromagneticPermeability: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticPermeability"
  ),
  // Photosynthetic Photon Flux Density
  PhotosyntheticPhotonFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "PhotosyntheticPhotonFluxDensity"
  ),
  // lineic electric charge
  LinearElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "LinearElectricCharge"
  ),
  // Generalized Force
  GeneralizedMomentum: Qudt.quantityKindFromLocalnameRequired(
    "GeneralizedMomentum"
  ),
  // Structural Efficiency
  StructuralEfficiency: Qudt.quantityKindFromLocalnameRequired(
    "StructuralEfficiency"
  ),
  // Atom Scattering Factor
  AtomScatteringFactor: Qudt.quantityKindFromLocalnameRequired(
    "AtomScatteringFactor"
  ),
  // Mobility Ratio
  MobilityRatio: Qudt.quantityKindFromLocalnameRequired("MobilityRatio"),
  // Length Temperature
  LengthTemperature:
    Qudt.quantityKindFromLocalnameRequired("LengthTemperature"),
  // Force Per Area Time
  ForcePerAreaTime: Qudt.quantityKindFromLocalnameRequired("ForcePerAreaTime"),
  // temperature-based amount-of-substance concentration
  TemperatureBasedAmountOfSubstanceConcentration:
    Qudt.quantityKindFromLocalnameRequired(
      "TemperatureBasedAmountOfSubstanceConcentration"
    ),
  // Propellant Mass
  PropellantMass: Qudt.quantityKindFromLocalnameRequired("PropellantMass"),
  // energia
  Energy: Qudt.quantityKindFromLocalnameRequired("Energy"),
  // volume density of charge
  VolumeDensityOfCharge: Qudt.quantityKindFromLocalnameRequired(
    "VolumeDensityOfCharge"
  ),
  // Mass Fraction of Dry Matter
  MassFractionOfDryMatter: Qudt.quantityKindFromLocalnameRequired(
    "MassFractionOfDryMatter"
  ),
  // Permittivity
  Permittivity: Qudt.quantityKindFromLocalnameRequired("Permittivity"),
  // reciprocal voltage
  ReciprocalVoltage:
    Qudt.quantityKindFromLocalnameRequired("ReciprocalVoltage"),
  // digit rate
  DigitRate: Qudt.quantityKindFromLocalnameRequired("DigitRate"),
  // kinematic viscosity or diffusion constant or thermal diffusivity
  KinematicViscosityOrDiffusionConstantOrThermalDiffusivity:
    Qudt.quantityKindFromLocalnameRequired(
      "KinematicViscosityOrDiffusionConstantOrThermalDiffusivity"
    ),
  // specific weight
  SpecificWeight: Qudt.quantityKindFromLocalnameRequired("SpecificWeight"),
  // Exchange Integral
  ExchangeIntegral: Qudt.quantityKindFromLocalnameRequired("ExchangeIntegral"),
  // Mutual Inductance
  MutualInductance: Qudt.quantityKindFromLocalnameRequired("MutualInductance"),
  // Inverse Square Time
  InverseSquareTime:
    Qudt.quantityKindFromLocalnameRequired("InverseSquareTime"),
  // Mass Amount of Substance Temperature
  MassAmountOfSubstanceTemperature: Qudt.quantityKindFromLocalnameRequired(
    "MassAmountOfSubstanceTemperature"
  ),
  // Total Cross-section
  TotalCrossSection:
    Qudt.quantityKindFromLocalnameRequired("TotalCrossSection"),
  // Convective Heat Transfer
  ConvectiveHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "ConvectiveHeatTransfer"
  ),
  // Mass Absorption Coefficient
  MassAbsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MassAbsorptionCoefficient"
  ),
  // Dynamic Friction
  DynamicFriction: Qudt.quantityKindFromLocalnameRequired("DynamicFriction"),
  // Mass Equivalent
  Equivalent_Mass: Qudt.quantityKindFromLocalnameRequired("Equivalent_Mass"),
  // Radius
  Radius: Qudt.quantityKindFromLocalnameRequired("Radius"),
  // lineic torque
  LinearTorque: Qudt.quantityKindFromLocalnameRequired("LinearTorque"),
  // spectral concentration of vibrational modes (in terms of angular frequency)
  SpectralConcentrationOfVibrationalModes:
    Qudt.quantityKindFromLocalnameRequired(
      "SpectralConcentrationOfVibrationalModes"
    ),
  // Capacitance
  Capacitance: Qudt.quantityKindFromLocalnameRequired("Capacitance"),
  // Power Area
  PowerArea: Qudt.quantityKindFromLocalnameRequired("PowerArea"),
  // Elliptical Orbit Perigee Velocity
  EllipticalOrbitPerigeeVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EllipticalOrbitPerigeeVelocity"
  ),
  // Angle
  Angle: Qudt.quantityKindFromLocalnameRequired("Angle"),
  // Combined Non Evaporative Heat Transfer Coefficient
  EvaporativeHeatTransferCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "EvaporativeHeatTransferCoefficient"
  ),
  // Larmor Angular Frequency
  LarmorAngularFrequency: Qudt.quantityKindFromLocalnameRequired(
    "LarmorAngularFrequency"
  ),
  // Exposure
  Exposure: Qudt.quantityKindFromLocalnameRequired("Exposure"),
  // Reserve Mass
  RESERVE__MASS: Qudt.quantityKindFromLocalnameRequired("RESERVE-MASS"),
  // Molality of Solute
  MolalityOfSolute: Qudt.quantityKindFromLocalnameRequired("MolalityOfSolute"),
  // force
  Force: Qudt.quantityKindFromLocalnameRequired("Force"),
  // Mass per Energy
  MassPerEnergy: Qudt.quantityKindFromLocalnameRequired("MassPerEnergy"),
  // pressure-based electric voltage
  PressureBasedElectricVoltage: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedElectricVoltage"
  ),
  // سرعت صوت
  SpeedOfSound: Qudt.quantityKindFromLocalnameRequired("SpeedOfSound"),
  // lineic logarithmic ratio
  LineicLogarithmicRatio: Qudt.quantityKindFromLocalnameRequired(
    "LineicLogarithmicRatio"
  ),
  // Luminous Efficacy
  LuminousEfficacy: Qudt.quantityKindFromLocalnameRequired("LuminousEfficacy"),
  // Energy Fluence Rate
  EnergyFluenceRate:
    Qudt.quantityKindFromLocalnameRequired("EnergyFluenceRate"),
  // Conductive Heat Transfer Rate
  ConductiveHeatTransferRate: Qudt.quantityKindFromLocalnameRequired(
    "ConductiveHeatTransferRate"
  ),
  // Initial Expansion Ratio
  InitialExpansionRatio: Qudt.quantityKindFromLocalnameRequired(
    "InitialExpansionRatio"
  ),
  // Pressure Burning Rate Index
  PressureBurningRateIndex: Qudt.quantityKindFromLocalnameRequired(
    "PressureBurningRateIndex"
  ),
  // Radiance
  Radiance: Qudt.quantityKindFromLocalnameRequired("Radiance"),
  // Systolic Blood Pressure
  SystolicBloodPressure: Qudt.quantityKindFromLocalnameRequired(
    "SystolicBloodPressure"
  ),
  // opór cieplny
  ThermalResistance:
    Qudt.quantityKindFromLocalnameRequired("ThermalResistance"),
  // 電位
  ElectricPotential:
    Qudt.quantityKindFromLocalnameRequired("ElectricPotential"),
  // Magnetisierung
  Magnetization: Qudt.quantityKindFromLocalnameRequired("Magnetization"),
  // Morbidity Rate
  MorbidityRate: Qudt.quantityKindFromLocalnameRequired("MorbidityRate"),
  // Conductance
  Conductance: Qudt.quantityKindFromLocalnameRequired("Conductance"),
  // Sound energy density
  SoundEnergyDensity:
    Qudt.quantityKindFromLocalnameRequired("SoundEnergyDensity"),
  // Intinsic Carrier Density
  IntinsicCarrierDensity: Qudt.quantityKindFromLocalnameRequired(
    "IntinsicCarrierDensity"
  ),
  // rotary shock
  RotaryShock: Qudt.quantityKindFromLocalnameRequired("RotaryShock"),
  // Mean Energy Imparted
  MeanEnergyImparted:
    Qudt.quantityKindFromLocalnameRequired("MeanEnergyImparted"),
  // Volumetric Flux
  VolumetricFlux: Qudt.quantityKindFromLocalnameRequired("VolumetricFlux"),
  // Equilibrium Constant on Pressure Basis
  EquilibriumConstantOnPressureBasis: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumConstantOnPressureBasis"
  ),
  // Linear Energy Transfer
  LinearEnergyTransfer: Qudt.quantityKindFromLocalnameRequired(
    "LinearEnergyTransfer"
  ),
  // Center of Gravity in the X axis
  CenterOfGravity_X:
    Qudt.quantityKindFromLocalnameRequired("CenterOfGravity_X"),
  // Total Atomic Stopping Power
  TotalAtomicStoppingPower: Qudt.quantityKindFromLocalnameRequired(
    "TotalAtomicStoppingPower"
  ),
  // Thomson Coefficient
  ThomsonCoefficient:
    Qudt.quantityKindFromLocalnameRequired("ThomsonCoefficient"),
  // Resistivity
  Resistivity: Qudt.quantityKindFromLocalnameRequired("Resistivity"),
  // Respiratory Rate
  RespiratoryRate: Qudt.quantityKindFromLocalnameRequired("RespiratoryRate"),
  // Thermal Efficiency
  ThermalEfficiency:
    Qudt.quantityKindFromLocalnameRequired("ThermalEfficiency"),
  // bit rate
  BitRate: Qudt.quantityKindFromLocalnameRequired("BitRate"),
  // Thermodynamic Critical Magnetic Flux Density
  ThermodynamicCriticalMagneticFluxDensity:
    Qudt.quantityKindFromLocalnameRequired(
      "ThermodynamicCriticalMagneticFluxDensity"
    ),
  // Rankine temperature
  RankineTemperature:
    Qudt.quantityKindFromLocalnameRequired("RankineTemperature"),
  // Delta u,v
  Duv: Qudt.quantityKindFromLocalnameRequired("Duv"),
  // Power Area per Solid Angle
  PowerAreaPerSolidAngle: Qudt.quantityKindFromLocalnameRequired(
    "PowerAreaPerSolidAngle"
  ),
  // teplota
  CelsiusTemperature:
    Qudt.quantityKindFromLocalnameRequired("CelsiusTemperature"),
  // Cross-sectional Area
  CrossSectionalArea:
    Qudt.quantityKindFromLocalnameRequired("CrossSectionalArea"),
  // Mechanical Energy
  MechanicalEnergy: Qudt.quantityKindFromLocalnameRequired("MechanicalEnergy"),
  // Fermi Temperature
  FermiTemperature: Qudt.quantityKindFromLocalnameRequired("FermiTemperature"),
  // areic mass
  AreicMass: Qudt.quantityKindFromLocalnameRequired("AreicMass"),
  // Phase speed of sound
  PhaseSpeedOfSound:
    Qudt.quantityKindFromLocalnameRequired("PhaseSpeedOfSound"),
  // Specific Enthalpy
  SpecificEnthalpy: Qudt.quantityKindFromLocalnameRequired("SpecificEnthalpy"),
  // Thermodynamic Entropy
  ThermodynamicEntropy: Qudt.quantityKindFromLocalnameRequired(
    "ThermodynamicEntropy"
  ),
  // Burgers Vector
  BurgersVector: Qudt.quantityKindFromLocalnameRequired("BurgersVector"),
  // Initial Vehicle Mass
  InitialVehicleMass:
    Qudt.quantityKindFromLocalnameRequired("InitialVehicleMass"),
  // Energy Expenditure
  EnergyExpenditure:
    Qudt.quantityKindFromLocalnameRequired("EnergyExpenditure"),
  // energia libera di Gibbs
  GibbsEnergy: Qudt.quantityKindFromLocalnameRequired("GibbsEnergy"),
  // Decay Constant
  DecayConstant: Qudt.quantityKindFromLocalnameRequired("DecayConstant"),
  // Linear Velocity
  LinearVelocity: Qudt.quantityKindFromLocalnameRequired("LinearVelocity"),
  // Volumetric Heat Capacity
  VolumetricHeatCapacity: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricHeatCapacity"
  ),
  // water vapour permeability
  WaterVapourPermeability: Qudt.quantityKindFromLocalnameRequired(
    "WaterVapourPermeability"
  ),
  // Length Force
  LengthByForce: Qudt.quantityKindFromLocalnameRequired("LengthByForce"),
  // Einstein coefficients
  EinsteinCoefficients: Qudt.quantityKindFromLocalnameRequired(
    "EinsteinCoefficients"
  ),
  // lineic mass
  LineicMass: Qudt.quantityKindFromLocalnameRequired("LineicMass"),
  // temperature-based kinematic viscosity
  TemperatureBasedKinematicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedKinematicViscosity"
  ),
  // Linear Density
  LinearDensity: Qudt.quantityKindFromLocalnameRequired("LinearDensity"),
  // Transmittance
  Transmittance: Qudt.quantityKindFromLocalnameRequired("Transmittance"),
  // Center of Gravity in the X axis
  CENTER__OF__GRAVITY_X: Qudt.quantityKindFromLocalnameRequired(
    "CENTER-OF-GRAVITY_X"
  ),
  // massic power
  MassicPower: Qudt.quantityKindFromLocalnameRequired("MassicPower"),
  // piece
  Piece: Qudt.quantityKindFromLocalnameRequired("Piece"),
  // reciprocal energy
  ReciprocalEnergy: Qudt.quantityKindFromLocalnameRequired("ReciprocalEnergy"),
  // Total Angular Momentum Quantum Number
  TotalAngularMomentumQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "TotalAngularMomentumQuantumNumber"
  ),
  // Electric Field
  ElectricField: Qudt.quantityKindFromLocalnameRequired("ElectricField"),
  // Thickness
  Thickness: Qudt.quantityKindFromLocalnameRequired("Thickness"),
  // współczynnik rozszerzalności objętościowej
  CubicExpansionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "CubicExpansionCoefficient"
  ),
  // Mass Concentration of Water
  MassConcentrationOfWater: Qudt.quantityKindFromLocalnameRequired(
    "MassConcentrationOfWater"
  ),
  // Neutron Diffusion Length
  NeutronDiffusionLength: Qudt.quantityKindFromLocalnameRequired(
    "NeutronDiffusionLength"
  ),
  // ratio
  Ratio: Qudt.quantityKindFromLocalnameRequired("Ratio"),
  // Henry's Law Volatility Constant
  HenrysLawVolatilityConstant: Qudt.quantityKindFromLocalnameRequired(
    "HenrysLawVolatilityConstant"
  ),
  // Molar Optical Rotatory Power
  MolarOpticalRotatoryPower: Qudt.quantityKindFromLocalnameRequired(
    "MolarOpticalRotatoryPower"
  ),
  // Dry Mass
  DRY__MASS: Qudt.quantityKindFromLocalnameRequired("DRY-MASS"),
  // Volume Flow Ratio
  VolumeFlowRatio: Qudt.quantityKindFromLocalnameRequired("VolumeFlowRatio"),
  // Specific Electrical Current
  SpecificElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "SpecificElectricCurrent"
  ),
  // Total Pressure
  TotalPressure: Qudt.quantityKindFromLocalnameRequired("TotalPressure"),
  // Specific Helmholtz Energy
  SpecificHelmholtzEnergy: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHelmholtzEnergy"
  ),
  // Mortality Rate
  MortalityRate: Qudt.quantityKindFromLocalnameRequired("MortalityRate"),
  // Flächenlast
  PlanarForce: Qudt.quantityKindFromLocalnameRequired("PlanarForce"),
  // Molar Mass variation due to Pressure
  AmountOfSubstancePerMassPressure: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerMassPressure"
  ),
  // Maximum Beta-Particle Energy
  MaximumBeta__ParticleEnergy: Qudt.quantityKindFromLocalnameRequired(
    "MaximumBeta-ParticleEnergy"
  ),
  // Warping Moment
  WarpingMoment: Qudt.quantityKindFromLocalnameRequired("WarpingMoment"),
  // flusso magnetico
  MagneticFlux: Qudt.quantityKindFromLocalnameRequired("MagneticFlux"),
  // lineic power
  LineicPower: Qudt.quantityKindFromLocalnameRequired("LineicPower"),
  // Currency Per Flight
  CurrencyPerFlight:
    Qudt.quantityKindFromLocalnameRequired("CurrencyPerFlight"),
  // Orbital Radial Distance
  OrbitalRadialDistance: Qudt.quantityKindFromLocalnameRequired(
    "OrbitalRadialDistance"
  ),
  // Macroscopic Cross-section
  MacroscopicCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "MacroscopicCrossSection"
  ),
  // Photon Intensity
  PhotonIntensity: Qudt.quantityKindFromLocalnameRequired("PhotonIntensity"),
  // Relative Mass Excess
  RelativeMassExcess:
    Qudt.quantityKindFromLocalnameRequired("RelativeMassExcess"),
  // Stała Madelunga
  MadelungConstant: Qudt.quantityKindFromLocalnameRequired("MadelungConstant"),
  // Loss Factor
  LossFactor: Qudt.quantityKindFromLocalnameRequired("LossFactor"),
  // symbol transmission rate
  SymbolTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "SymbolTransmissionRate"
  ),
  // Power Per Area
  PowerPerArea: Qudt.quantityKindFromLocalnameRequired("PowerPerArea"),
  // thermal capacitance
  ThermalCapacitance:
    Qudt.quantityKindFromLocalnameRequired("ThermalCapacitance"),
  // Area per Time
  AreaPerTime: Qudt.quantityKindFromLocalnameRequired("AreaPerTime"),
  // Wasserdampfdiffusionsleitkoeffizient
  WaterVaporDiffusionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "WaterVaporDiffusionCoefficient"
  ),
  // Force per Length
  ForcePerLength: Qudt.quantityKindFromLocalnameRequired("ForcePerLength"),
  // exposure rate of ionizing radiation
  ExposureRateOfIonizingRadiation: Qudt.quantityKindFromLocalnameRequired(
    "ExposureRateOfIonizingRadiation"
  ),
  // Total Ionization
  TotalIonization: Qudt.quantityKindFromLocalnameRequired("TotalIonization"),
  // spectral concentration of radiant energy density
  SpectralConcentrationOfRadiantEnergyDensity:
    Qudt.quantityKindFromLocalnameRequired(
      "SpectralConcentrationOfRadiantEnergyDensity"
    ),
  // Half-Value Thickness
  Half__ValueThickness: Qudt.quantityKindFromLocalnameRequired(
    "Half-ValueThickness"
  ),
  // Mass Concentration of Water To Dry Matter
  MassRatioOfWaterToDryMatter: Qudt.quantityKindFromLocalnameRequired(
    "MassRatioOfWaterToDryMatter"
  ),
  // Photon Radiance
  PhotonRadiance: Qudt.quantityKindFromLocalnameRequired("PhotonRadiance"),
  // puissance
  Power: Qudt.quantityKindFromLocalnameRequired("Power"),
  // Auxillary Magnetic Field
  AuxillaryMagneticField: Qudt.quantityKindFromLocalnameRequired(
    "AuxillaryMagneticField"
  ),
  // Generalized Velocity
  GeneralizedVelocity: Qudt.quantityKindFromLocalnameRequired(
    "GeneralizedVelocity"
  ),
  // Electric Charge Volume Density
  ElectricChargeVolumeDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeVolumeDensity"
  ),
  // areic torque
  AreicTorque: Qudt.quantityKindFromLocalnameRequired("AreicTorque"),
  // Non-active Power
  NonActivePower: Qudt.quantityKindFromLocalnameRequired("NonActivePower"),
  // Vapor Permeability
  VaporPermeability:
    Qudt.quantityKindFromLocalnameRequired("VaporPermeability"),
  // Action Time
  ActionTime: Qudt.quantityKindFromLocalnameRequired("ActionTime"),
  // Anschaffungskosten pro Watt
  CostPerUnitPower: Qudt.quantityKindFromLocalnameRequired("CostPerUnitPower"),
  // Radiant Fluence
  RadiantFluence: Qudt.quantityKindFromLocalnameRequired("RadiantFluence"),
  // Pressure Burning Rate Constant
  PressureBurningRateConstant: Qudt.quantityKindFromLocalnameRequired(
    "PressureBurningRateConstant"
  ),
  // Azimuth
  Azimuth: Qudt.quantityKindFromLocalnameRequired("Azimuth"),
  // Center of Gravity in the Y axis
  CENTER__OF__GRAVITY_Y: Qudt.quantityKindFromLocalnameRequired(
    "CENTER-OF-GRAVITY_Y"
  ),
  // Torque per Angle
  TorquePerAngle: Qudt.quantityKindFromLocalnameRequired("TorquePerAngle"),
  // Luminous Energy
  LuminousEnergy: Qudt.quantityKindFromLocalnameRequired("LuminousEnergy"),
  // surface-related volume flow
  SurfaceRelatedVolumeFlow: Qudt.quantityKindFromLocalnameRequired(
    "SurfaceRelatedVolumeFlow"
  ),
  // Mean Mass Range
  MeanMassRange: Qudt.quantityKindFromLocalnameRequired("MeanMassRange"),
  // Bevel Gear Pitch Angle
  BevelGearPitchAngle: Qudt.quantityKindFromLocalnameRequired(
    "BevelGearPitchAngle"
  ),
  // Long-Range Order Parameter
  Long__RangeOrderParameter: Qudt.quantityKindFromLocalnameRequired(
    "Long-RangeOrderParameter"
  ),
  // عزم محورى
  Torque: Qudt.quantityKindFromLocalnameRequired("Torque"),
  // Recombination Coefficient
  RecombinationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "RecombinationCoefficient"
  ),
  // Radiant Intensity
  RadiantIntensity: Qudt.quantityKindFromLocalnameRequired("RadiantIntensity"),
  // Evaporative Heat Transfer
  EvaporativeHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "EvaporativeHeatTransfer"
  ),
  // energy content
  EnergyContent: Qudt.quantityKindFromLocalnameRequired("EnergyContent"),
  // Exhaust Gases Specific Heat
  ExhaustGasesSpecificHeat: Qudt.quantityKindFromLocalnameRequired(
    "ExhaustGasesSpecificHeat"
  ),
  // Mass Ratio
  MassRatio: Qudt.quantityKindFromLocalnameRequired("MassRatio"),
  // lineic mass
  LinearMass: Qudt.quantityKindFromLocalnameRequired("LinearMass"),
  // state density
  StateDensity: Qudt.quantityKindFromLocalnameRequired("StateDensity"),
  // Orbital Angular Momentum per Unit Mass
  OrbitalAngularMomentumPerUnitMass: Qudt.quantityKindFromLocalnameRequired(
    "OrbitalAngularMomentumPerUnitMass"
  ),
  // Permittivity Ratio
  PermittivityRatio:
    Qudt.quantityKindFromLocalnameRequired("PermittivityRatio"),
  // pressure in relation to volume flow rate
  PressureInRelationToVolumeFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "PressureInRelationToVolumeFlowRate"
  ),
  // Effective Mass
  EffectiveMass: Qudt.quantityKindFromLocalnameRequired("EffectiveMass"),
  // Specific Heat Volume
  SpecificHeatVolume:
    Qudt.quantityKindFromLocalnameRequired("SpecificHeatVolume"),
  // Inert Mass
  INERT__MASS: Qudt.quantityKindFromLocalnameRequired("INERT-MASS"),
  // Inverse Square Energy
  InverseEnergy_Squared: Qudt.quantityKindFromLocalnameRequired(
    "InverseEnergy_Squared"
  ),
  // Mass Of Solid Booster
  MassOfSolidBooster:
    Qudt.quantityKindFromLocalnameRequired("MassOfSolidBooster"),
  // areic bit density
  AreaBitDensity: Qudt.quantityKindFromLocalnameRequired("AreaBitDensity"),
  // Hole Density
  HoleDensity: Qudt.quantityKindFromLocalnameRequired("HoleDensity"),
  // Quartic Electric Dipole Moment per Cubic Energy
  QuarticElectricDipoleMomentPerCubicEnergy:
    Qudt.quantityKindFromLocalnameRequired(
      "QuarticElectricDipoleMomentPerCubicEnergy"
    ),
  // Burn Rate
  BurnRate: Qudt.quantityKindFromLocalnameRequired("BurnRate"),
  // 截面二次轴矩
  SecondMomentOfArea:
    Qudt.quantityKindFromLocalnameRequired("SecondMomentOfArea"),
  // Catalytic Activity
  CatalyticActivity:
    Qudt.quantityKindFromLocalnameRequired("CatalyticActivity"),
  // نقطه کوری
  CurieTemperature: Qudt.quantityKindFromLocalnameRequired("CurieTemperature"),
  // Specific Optical Rotatory Power
  SpecificOpticalRotatoryPower: Qudt.quantityKindFromLocalnameRequired(
    "SpecificOpticalRotatoryPower"
  ),
  // Absorbed Dose
  AbsorbedDose: Qudt.quantityKindFromLocalnameRequired("AbsorbedDose"),
  // Spectral Radiant Energy Density
  SpectralRadiantEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "SpectralRadiantEnergyDensity"
  ),
  // fluidity
  Fluidity: Qudt.quantityKindFromLocalnameRequired("Fluidity"),
  // real part of complex frequency
  ComplexFrequency_Real: Qudt.quantityKindFromLocalnameRequired(
    "ComplexFrequency_Real"
  ),
  // Resonance Escape Probability For Fission
  ResonanceEscapeProbabilityForFission: Qudt.quantityKindFromLocalnameRequired(
    "ResonanceEscapeProbabilityForFission"
  ),
  // Time Squared
  Time_Squared: Qudt.quantityKindFromLocalnameRequired("Time_Squared"),
  // Bragg Angle
  BraggAngle: Qudt.quantityKindFromLocalnameRequired("BraggAngle"),
  // pressure-based dynamic viscosity
  PressureBasedDynamicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedDynamicViscosity"
  ),
  // Strain
  Strain: Qudt.quantityKindFromLocalnameRequired("Strain"),
  // Catalytic Activity Concentration
  CatalyticActivityConcentration: Qudt.quantityKindFromLocalnameRequired(
    "CatalyticActivityConcentration"
  ),
  // Dew Point Temperature
  DewPointTemperature: Qudt.quantityKindFromLocalnameRequired(
    "DewPointTemperature"
  ),
  // Displacement Vector of Ion
  DisplacementVectorOfIon: Qudt.quantityKindFromLocalnameRequired(
    "DisplacementVectorOfIon"
  ),
  // Incidence
  Incidence: Qudt.quantityKindFromLocalnameRequired("Incidence"),
  // Length Percentage
  LengthPercentage: Qudt.quantityKindFromLocalnameRequired("LengthPercentage"),
  // Action
  Action: Qudt.quantityKindFromLocalnameRequired("Action"),
  // Grand Canonical Partition Function
  GrandCanonicalPartitionFunction: Qudt.quantityKindFromLocalnameRequired(
    "GrandCanonicalPartitionFunction"
  ),
  // Specific Electric Charge
  SpecificElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "SpecificElectricCharge"
  ),
  // Unknown
  Unknown: Qudt.quantityKindFromLocalnameRequired("Unknown"),
  // Superconductor Energy Gap
  SuperconductorEnergyGap: Qudt.quantityKindFromLocalnameRequired(
    "SuperconductorEnergyGap"
  ),
  // Absolute Humidity
  AbsoluteHumidity: Qudt.quantityKindFromLocalnameRequired("AbsoluteHumidity"),
  // Statistical Weight
  StatisticalWeight:
    Qudt.quantityKindFromLocalnameRequired("StatisticalWeight"),
  // Linear Strain
  LinearStrain: Qudt.quantityKindFromLocalnameRequired("LinearStrain"),
  // Угловое ускорение
  AngularAcceleration: Qudt.quantityKindFromLocalnameRequired(
    "AngularAcceleration"
  ),
  // Warping Constant
  WarpingConstant: Qudt.quantityKindFromLocalnameRequired("WarpingConstant"),
  // Activity
  Activity: Qudt.quantityKindFromLocalnameRequired("Activity"),
  // инвариантная масса
  RestMass: Qudt.quantityKindFromLocalnameRequired("RestMass"),
  // Diffusion Area
  DiffusionArea: Qudt.quantityKindFromLocalnameRequired("DiffusionArea"),
  // logarithm ratio to base 10
  LogarithmRatioToBase10: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmRatioToBase10"
  ),
  // Web Time
  WebTime: Qudt.quantityKindFromLocalnameRequired("WebTime"),
  // Energy Density of States
  EnergyDensityOfStates: Qudt.quantityKindFromLocalnameRequired(
    "EnergyDensityOfStates"
  ),
  // current of the amount of substance
  CurrentOfTheAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "CurrentOfTheAmountOfSubstance"
  ),
  // Momentum per Angle
  MomentumPerAngle: Qudt.quantityKindFromLocalnameRequired("MomentumPerAngle"),
  // temperature difference
  TemperatureDifference: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureDifference"
  ),
  // Oberflächenspannung
  SurfaceTension: Qudt.quantityKindFromLocalnameRequired("SurfaceTension"),
  // Thermal Utilization Factor For Fission
  ThermalUtilizationFactorForFission: Qudt.quantityKindFromLocalnameRequired(
    "ThermalUtilizationFactorForFission"
  ),
  // Population
  Population: Qudt.quantityKindFromLocalnameRequired("Population"),
  // Elliptical Orbit Apogee Velocity
  EllipticalOrbitApogeeVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EllipticalOrbitApogeeVelocity"
  ),
  // Flux
  Flux: Qudt.quantityKindFromLocalnameRequired("Flux"),
  // čas
  Time: Qudt.quantityKindFromLocalnameRequired("Time"),
  // Bending Moment of Force
  BendingMomentOfForce: Qudt.quantityKindFromLocalnameRequired(
    "BendingMomentOfForce"
  ),
  // Dimensionless
  Dimensionless: Qudt.quantityKindFromLocalnameRequired("Dimensionless"),
  // electron mobility
  ElectronMobility: Qudt.quantityKindFromLocalnameRequired("ElectronMobility"),
  // Aeric Heat Flow Rate
  AreicHeatFlowRate:
    Qudt.quantityKindFromLocalnameRequired("AreicHeatFlowRate"),
  // Hamilton Function
  HamiltonFunction: Qudt.quantityKindFromLocalnameRequired("HamiltonFunction"),
  // Relative Molecular Mass
  RelativeMolecularMass: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMolecularMass"
  ),
  // Debye-Waller Factor
  Debye__WallerFactor:
    Qudt.quantityKindFromLocalnameRequired("Debye-WallerFactor"),
  // Length Energy
  LengthEnergy: Qudt.quantityKindFromLocalnameRequired("LengthEnergy"),
  // Acceptor Density
  AcceptorDensity: Qudt.quantityKindFromLocalnameRequired("AcceptorDensity"),
  // Vapor Permeability
  VaporPermeance: Qudt.quantityKindFromLocalnameRequired("VaporPermeance"),
  // Volume Fraction
  VolumeFraction: Qudt.quantityKindFromLocalnameRequired("VolumeFraction"),
  // Density In Combustion Chamber
  DensityInCombustionChamber: Qudt.quantityKindFromLocalnameRequired(
    "DensityInCombustionChamber"
  ),
  // Mechanical Impedance
  MechanicalImpedance: Qudt.quantityKindFromLocalnameRequired(
    "MechanicalImpedance"
  ),
  // Resistance Percentage
  ResistancePercentage: Qudt.quantityKindFromLocalnameRequired(
    "ResistancePercentage"
  ),
  // time constant (inductance based)
  TimeConstant_Inductance: Qudt.quantityKindFromLocalnameRequired(
    "TimeConstant_Inductance"
  ),
  // Rocket Atmospheric Transverse Force
  RocketAtmosphericTransverseForce: Qudt.quantityKindFromLocalnameRequired(
    "RocketAtmosphericTransverseForce"
  ),
  // Linked Flux
  LinkedFlux: Qudt.quantityKindFromLocalnameRequired("LinkedFlux"),
  // Reaction Energy
  ReactionEnergy: Qudt.quantityKindFromLocalnameRequired("ReactionEnergy"),
  // Carrier LifetIme
  CarrierLifetime: Qudt.quantityKindFromLocalnameRequired("CarrierLifetime"),
  // Delta-V
  DELTA__V: Qudt.quantityKindFromLocalnameRequired("DELTA-V"),
  // Radiance Factor
  RadianceFactor: Qudt.quantityKindFromLocalnameRequired("RadianceFactor"),
  // Chemical Consumption per Mass
  ChemicalConsumptionPerMass: Qudt.quantityKindFromLocalnameRequired(
    "ChemicalConsumptionPerMass"
  ),
  // mechanical tension
  MechanicalTension:
    Qudt.quantityKindFromLocalnameRequired("MechanicalTension"),
  // Second Axial Moment of Area
  SecondAxialMomentOfArea: Qudt.quantityKindFromLocalnameRequired(
    "SecondAxialMomentOfArea"
  ),
  // Thermal Energy Length
  ThermalEnergyLength: Qudt.quantityKindFromLocalnameRequired(
    "ThermalEnergyLength"
  ),
  // Vision Thresholds
  VisionThresholds: Qudt.quantityKindFromLocalnameRequired("VisionThresholds"),
  // Force Magnitude
  ForceMagnitude: Qudt.quantityKindFromLocalnameRequired("ForceMagnitude"),
  // Initial Velocity
  InitialVelocity: Qudt.quantityKindFromLocalnameRequired("InitialVelocity"),
  // श्यानता
  KinematicViscosity:
    Qudt.quantityKindFromLocalnameRequired("KinematicViscosity"),
  // Scalar Magnetic Potential
  ScalarMagneticPotential: Qudt.quantityKindFromLocalnameRequired(
    "ScalarMagneticPotential"
  ),
  // Stage Propellant Mass
  StagePropellantMass: Qudt.quantityKindFromLocalnameRequired(
    "StagePropellantMass"
  ),
  // Amount of Substance of Concentration
  AmountOfSubstanceConcentration: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceConcentration"
  ),
  // Torque per Length
  TorquePerLength: Qudt.quantityKindFromLocalnameRequired("TorquePerLength"),
  // Energy Imparted
  EnergyImparted: Qudt.quantityKindFromLocalnameRequired("EnergyImparted"),
  // Angular Cross-section
  AngularCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "AngularCrossSection"
  ),
  // quantity of light
  QuantityOfLight: Qudt.quantityKindFromLocalnameRequired("QuantityOfLight"),
  // molar thermodynamic energy
  MolarThermodynamicEnergy: Qudt.quantityKindFromLocalnameRequired(
    "MolarThermodynamicEnergy"
  ),
  // byte rate
  ByteRate: Qudt.quantityKindFromLocalnameRequired("ByteRate"),
  // pressure-based mass
  PressureBasedMass:
    Qudt.quantityKindFromLocalnameRequired("PressureBasedMass"),
  // Specific Activity
  SpecificActivity: Qudt.quantityKindFromLocalnameRequired("SpecificActivity"),
  // Resistance
  Resistance: Qudt.quantityKindFromLocalnameRequired("Resistance"),
  // Acceleration Of Gravity
  AccelerationOfGravity: Qudt.quantityKindFromLocalnameRequired(
    "AccelerationOfGravity"
  ),
  // Hydraulic Permeability
  HydraulicPermeability: Qudt.quantityKindFromLocalnameRequired(
    "HydraulicPermeability"
  ),
  // Temperature
  Temperature: Qudt.quantityKindFromLocalnameRequired("Temperature"),
  // Çiftlenim sabiti
  CouplingFactor: Qudt.quantityKindFromLocalnameRequired("CouplingFactor"),
  // Voltage
  Voltage: Qudt.quantityKindFromLocalnameRequired("Voltage"),
  // Volume per Time
  VolumePerTime: Qudt.quantityKindFromLocalnameRequired("VolumePerTime"),
  // energia livre de Helmholtz
  HelmholtzEnergy: Qudt.quantityKindFromLocalnameRequired("HelmholtzEnergy"),
  // impulse
  Impulse: Qudt.quantityKindFromLocalnameRequired("Impulse"),
  // Modulus Of Admittance
  ModulusOfAdmittance: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfAdmittance"
  ),
  // Density Of The Exhaust Gases
  DensityOfTheExhaustGases: Qudt.quantityKindFromLocalnameRequired(
    "DensityOfTheExhaustGases"
  ),
  // Pressure Ratio
  PressureRatio: Qudt.quantityKindFromLocalnameRequired("PressureRatio"),
  // masa
  Mass: Qudt.quantityKindFromLocalnameRequired("Mass"),
  // Strain Energy Density
  StrainEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "StrainEnergyDensity"
  ),
  // Radiosity
  Radiosity: Qudt.quantityKindFromLocalnameRequired("Radiosity"),
  // luminous exitance
  LuminousExitance: Qudt.quantityKindFromLocalnameRequired("LuminousExitance"),
  // Federkonstante Drehfeder
  TorsionalSpringConstant: Qudt.quantityKindFromLocalnameRequired(
    "TorsionalSpringConstant"
  ),
  // Square Energy
  SquareEnergy: Qudt.quantityKindFromLocalnameRequired("SquareEnergy"),
  // Admittance
  Admittance: Qudt.quantityKindFromLocalnameRequired("Admittance"),
  // areic data volume
  AreicDataVolume: Qudt.quantityKindFromLocalnameRequired("AreicDataVolume"),
  // ऊष्मा धारिता
  HeatCapacity: Qudt.quantityKindFromLocalnameRequired("HeatCapacity"),
  // Linear Force
  LinearForce: Qudt.quantityKindFromLocalnameRequired("LinearForce"),
  // volumic output power
  VolumetricOutputPower: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricOutputPower"
  ),
  // massic electric current
  MassicElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "MassicElectricCurrent"
  ),
  // areic charge density or electric flux density or electric polarization
  AreicChargeDensityOrElectricFluxDensityOrElectricPolarization:
    Qudt.quantityKindFromLocalnameRequired(
      "AreicChargeDensityOrElectricFluxDensityOrElectricPolarization"
    ),
  // floating point calculation capability
  FloatingPointCalculationCapability: Qudt.quantityKindFromLocalnameRequired(
    "FloatingPointCalculationCapability"
  ),
  // Kosten pro Masse
  CostPerMass: Qudt.quantityKindFromLocalnameRequired("CostPerMass"),
  // Magnetic Tension
  MagneticTension: Qudt.quantityKindFromLocalnameRequired("MagneticTension"),
  // Positive Dimensionless Ratio
  PositiveDimensionlessRatio: Qudt.quantityKindFromLocalnameRequired(
    "PositiveDimensionlessRatio"
  ),
  // Kinetic Energy
  KineticEnergy: Qudt.quantityKindFromLocalnameRequired("KineticEnergy"),
  // bit transmission rate
  BitTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "BitTransmissionRate"
  ),
  // Phase coefficient
  PhaseCoefficient: Qudt.quantityKindFromLocalnameRequired("PhaseCoefficient"),
  // Soil Adsorption Coefficient
  SoilAdsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "SoilAdsorptionCoefficient"
  ),
  // mass stopping power
  MassStoppingPower:
    Qudt.quantityKindFromLocalnameRequired("MassStoppingPower"),
  // Beta Disintegration Energy
  BetaDisintegrationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "BetaDisintegrationEnergy"
  ),
  // Volume per Unit Area
  VolumePerArea: Qudt.quantityKindFromLocalnameRequired("VolumePerArea"),
  // Average Head End Pressure
  AverageHeadEndPressure: Qudt.quantityKindFromLocalnameRequired(
    "AverageHeadEndPressure"
  ),
  // Electric Displacement Field
  ElectricDisplacementField: Qudt.quantityKindFromLocalnameRequired(
    "ElectricDisplacementField"
  ),
  // equilibrium constant based on concentration
  EquilibriumConstantBasedOnConcentration:
    Qudt.quantityKindFromLocalnameRequired(
      "EquilibriumConstantBasedOnConcentration"
    ),
  // Olfactory Threshold
  OlfactoryThreshold:
    Qudt.quantityKindFromLocalnameRequired("OlfactoryThreshold"),
  // magnetic flux density or magnetic polarization
  MagneticFluxDensityOrMagneticPolarization:
    Qudt.quantityKindFromLocalnameRequired(
      "MagneticFluxDensityOrMagneticPolarization"
    ),
  // Polarization Field
  PolarizationField:
    Qudt.quantityKindFromLocalnameRequired("PolarizationField"),
  // Poisson Ratio
  PoissonRatio: Qudt.quantityKindFromLocalnameRequired("PoissonRatio"),
  // lineic charge
  LineicCharge: Qudt.quantityKindFromLocalnameRequired("LineicCharge"),
  // Amount of Substance per Unit Volume
  AmountOfSubstancePerUnitVolume: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerUnitVolume"
  ),
  // Energy Density
  EnergyDensity: Qudt.quantityKindFromLocalnameRequired("EnergyDensity"),
  // momento de dipolo magnético
  MagneticMoment: Qudt.quantityKindFromLocalnameRequired("MagneticMoment"),
  // induktivitás
  Inductance: Qudt.quantityKindFromLocalnameRequired("Inductance"),
  // pressure-based amount-of-substance concentration
  PressureBasedAmountOfSubstanceConcentration:
    Qudt.quantityKindFromLocalnameRequired(
      "PressureBasedAmountOfSubstanceConcentration"
    ),
  // Ignition interval time
  IgnitionIntervalTime: Qudt.quantityKindFromLocalnameRequired(
    "IgnitionIntervalTime"
  ),
  // Entalpi
  Enthalpy: Qudt.quantityKindFromLocalnameRequired("Enthalpy"),
  // Massic Activity
  MassicActivity: Qudt.quantityKindFromLocalnameRequired("MassicActivity"),
  // mobilità
  Mobility: Qudt.quantityKindFromLocalnameRequired("Mobility"),
  // Reflectance
  Reflectance: Qudt.quantityKindFromLocalnameRequired("Reflectance"),
  // Larmor Angular Frequency
  CyclotronAngularFrequency: Qudt.quantityKindFromLocalnameRequired(
    "CyclotronAngularFrequency"
  ),
  // Mass Fraction
  MassFraction: Qudt.quantityKindFromLocalnameRequired("MassFraction"),
  // thermal coefficient of linear expansion
  ThermalCoefficientOfLinearExpansion: Qudt.quantityKindFromLocalnameRequired(
    "ThermalCoefficientOfLinearExpansion"
  ),
  // molar density
  MolarDensity: Qudt.quantityKindFromLocalnameRequired("MolarDensity"),
  // Specific Energy
  SpecificEnergy: Qudt.quantityKindFromLocalnameRequired("SpecificEnergy"),
  // Vertical Velocity
  VerticalVelocity: Qudt.quantityKindFromLocalnameRequired("VerticalVelocity"),
  // Surface Density
  SurfaceDensity: Qudt.quantityKindFromLocalnameRequired("SurfaceDensity"),
  // angolo solido
  SolidAngle: Qudt.quantityKindFromLocalnameRequired("SolidAngle"),
  // data transmission rate
  DataTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "DataTransmissionRate"
  ),
  // Kerma Rate
  KermaRate: Qudt.quantityKindFromLocalnameRequired("KermaRate"),
  // Product of Inertia in the Z axis
  PRODUCT__OF__INERTIA_Z: Qudt.quantityKindFromLocalnameRequired(
    "PRODUCT-OF-INERTIA_Z"
  ),
  // temperature-based length
  TemperatureBasedLength: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedLength"
  ),
  // Diffusionskoeffizient
  NeutronDiffusionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "NeutronDiffusionCoefficient"
  ),
  // Equilibrium Constant
  EquilibriumConstant: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumConstant"
  ),
  // Max Sea Level Thrust
  MaxSeaLevelThrust:
    Qudt.quantityKindFromLocalnameRequired("MaxSeaLevelThrust"),
  // Atmospheric Hydroxylation Rate
  AtmosphericHydroxylationRate: Qudt.quantityKindFromLocalnameRequired(
    "AtmosphericHydroxylationRate"
  ),
  // Relative Mass Ratio of Vapour
  RelativeMassRatioOfVapour: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMassRatioOfVapour"
  ),
  // Compound Plane Angle
  CompoundPlaneAngle:
    Qudt.quantityKindFromLocalnameRequired("CompoundPlaneAngle"),
  // Fast Fission Factor
  FastFissionFactor:
    Qudt.quantityKindFromLocalnameRequired("FastFissionFactor"),
  // Force Per Area
  ForcePerArea: Qudt.quantityKindFromLocalnameRequired("ForcePerArea"),
  // Power Per Electric Charge
  PowerPerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "PowerPerElectricCharge"
  ),
  // Information flow rate
  InformationFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "InformationFlowRate"
  ),
  // Electromagnetic Permeability Ratio
  ElectromagneticPermeabilityRatio: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticPermeabilityRatio"
  ),
  // Section Modulus
  SectionModulus: Qudt.quantityKindFromLocalnameRequired("SectionModulus"),
  // Conductivity
  Conductivity: Qudt.quantityKindFromLocalnameRequired("Conductivity"),
  // Packing Fraction
  PackingFraction: Qudt.quantityKindFromLocalnameRequired("PackingFraction"),
  // Angle of Optical Rotation
  AngleOfOpticalRotation: Qudt.quantityKindFromLocalnameRequired(
    "AngleOfOpticalRotation"
  ),
  // Reverberation Time
  ReverberationTime:
    Qudt.quantityKindFromLocalnameRequired("ReverberationTime"),
  // Compressibility Factor
  CompressibilityFactor: Qudt.quantityKindFromLocalnameRequired(
    "CompressibilityFactor"
  ),
  // volumic amount of substance
  VolumicAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "VolumicAmountOfSubstance"
  ),
  // Angular Distance
  AngularDistance: Qudt.quantityKindFromLocalnameRequired("AngularDistance"),
  // logarithmic ratio to base 10
  Log10Ratio: Qudt.quantityKindFromLocalnameRequired("Log10Ratio"),
  // Spectral Luminous Efficiency
  SpectralLuminousEfficiency: Qudt.quantityKindFromLocalnameRequired(
    "SpectralLuminousEfficiency"
  ),
  // área
  Area: Qudt.quantityKindFromLocalnameRequired("Area"),
  // Thermal Transmittance
  ThermalTransmittance: Qudt.quantityKindFromLocalnameRequired(
    "ThermalTransmittance"
  ),
  // Number Density
  NumberDensity: Qudt.quantityKindFromLocalnameRequired("NumberDensity"),
  // massic heat capacity
  MassicHeatCapacity:
    Qudt.quantityKindFromLocalnameRequired("MassicHeatCapacity"),
  // Shear Modulus
  ShearModulus: Qudt.quantityKindFromLocalnameRequired("ShearModulus"),
  // Area Time
  AreaTime: Qudt.quantityKindFromLocalnameRequired("AreaTime"),
  // lineic resolution
  LineicResolution: Qudt.quantityKindFromLocalnameRequired("LineicResolution"),
  // Radius of Curvature
  RadiusOfCurvature:
    Qudt.quantityKindFromLocalnameRequired("RadiusOfCurvature"),
  // Diffusion Coefficient for Fluence Rate
  DiffusionCoefficientForFluenceRate: Qudt.quantityKindFromLocalnameRequired(
    "DiffusionCoefficientForFluenceRate"
  ),
  // Electric Displacement
  ElectricDisplacement: Qudt.quantityKindFromLocalnameRequired(
    "ElectricDisplacement"
  ),
  // Equilibrium Constant on Concentration Basis
  EquilibriumConstantOnConcentrationBasis:
    Qudt.quantityKindFromLocalnameRequired(
      "EquilibriumConstantOnConcentrationBasis"
    ),
  // Debye Angular Wavenumber
  DebyeAngularWavenumber: Qudt.quantityKindFromLocalnameRequired(
    "DebyeAngularWavenumber"
  ),
  // Donor Ionization Energy
  DonorIonizationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "DonorIonizationEnergy"
  ),
  // Molecular Viscosity
  MolecularViscosity:
    Qudt.quantityKindFromLocalnameRequired("MolecularViscosity"),
  // Magnetomotive Force
  MagnetomotiveForce:
    Qudt.quantityKindFromLocalnameRequired("MagnetomotiveForce"),
  // Specific Impulse
  SpecificImpulse: Qudt.quantityKindFromLocalnameRequired("SpecificImpulse"),
  // Voltage Percentage
  VoltagePercentage:
    Qudt.quantityKindFromLocalnameRequired("VoltagePercentage"),
  // Luminous Flux per Area
  LuminousFluxPerArea: Qudt.quantityKindFromLocalnameRequired(
    "LuminousFluxPerArea"
  ),
  // Water Horsepower
  WaterHorsepower: Qudt.quantityKindFromLocalnameRequired("WaterHorsepower"),
  // Coherence Length
  CoherenceLength: Qudt.quantityKindFromLocalnameRequired("CoherenceLength"),
  // Volume Thermal Expansion
  VolumeThermalExpansion: Qudt.quantityKindFromLocalnameRequired(
    "VolumeThermalExpansion"
  ),
  // Cubic Electric Dipole Moment per Square Energy
  ElectricDipoleMoment_CubicPerEnergy_Squared:
    Qudt.quantityKindFromLocalnameRequired(
      "ElectricDipoleMoment_CubicPerEnergy_Squared"
    ),
  // temperatura thermodynamica absoluta
  ThermodynamicTemperature: Qudt.quantityKindFromLocalnameRequired(
    "ThermodynamicTemperature"
  ),
  // Correlated Color Temperature
  CorrelatedColorTemperature: Qudt.quantityKindFromLocalnameRequired(
    "CorrelatedColorTemperature"
  ),
  // Buckling Factor
  BucklingFactor: Qudt.quantityKindFromLocalnameRequired("BucklingFactor"),
  // Equivalent Concentration
  EquivalentConcentration: Qudt.quantityKindFromLocalnameRequired(
    "EquivalentConcentration"
  ),
  // Single Stage Launcher Mass Ratio
  SingleStageLauncherMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "SingleStageLauncherMassRatio"
  ),
  // Molar Mass variation due to Pressure
  AmountOfSubstancePerUnitMassPressure: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerUnitMassPressure"
  ),
  // Position Vector
  PositionVector: Qudt.quantityKindFromLocalnameRequired("PositionVector"),
  // Bioconcentration Factor
  BioconcentrationFactor: Qudt.quantityKindFromLocalnameRequired(
    "BioconcentrationFactor"
  ),
  // podatność elektryczna
  ElectricSusceptibility: Qudt.quantityKindFromLocalnameRequired(
    "ElectricSusceptibility"
  ),
  // kinetic or thermal energy
  KineticOrThermalEnergy: Qudt.quantityKindFromLocalnameRequired(
    "KineticOrThermalEnergy"
  ),
  // equilibrium constant based on pressure
  EquilibriumConstantBasedOnPressure: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumConstantBasedOnPressure"
  ),
  // Maximum Operating Pressure
  MaximumOperatingPressure: Qudt.quantityKindFromLocalnameRequired(
    "MaximumOperatingPressure"
  ),
  // temperature-based dynamic viscosity
  TemperatureBasedDynamicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedDynamicViscosity"
  ),
  // Currency
  Currency: Qudt.quantityKindFromLocalnameRequired("Currency"),
  // spin
  Spin: Qudt.quantityKindFromLocalnameRequired("Spin"),
  // Electromagnetic Wave Phase Speed
  ElectromagneticWavePhaseSpeed: Qudt.quantityKindFromLocalnameRequired(
    "ElectromagneticWavePhaseSpeed"
  ),
  // Shear Strain
  ShearStrain: Qudt.quantityKindFromLocalnameRequired("ShearStrain"),
  // areic mass
  AreaMass: Qudt.quantityKindFromLocalnameRequired("AreaMass"),
  // temperature-related volume
  TemperatureRelatedVolume: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureRelatedVolume"
  ),
  // Length Temperature Time
  LengthTemperatureTime: Qudt.quantityKindFromLocalnameRequired(
    "LengthTemperatureTime"
  ),
  // Thermal Diffusion Coefficient
  ThermalDiffusionRatioCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "ThermalDiffusionRatioCoefficient"
  ),
  // g-Factor of Nucleus
  GFactorOfNucleus: Qudt.quantityKindFromLocalnameRequired("GFactorOfNucleus"),
  // Static Friction Coefficient
  StaticFrictionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "StaticFrictionCoefficient"
  ),
  // Depth
  Depth: Qudt.quantityKindFromLocalnameRequired("Depth"),
  // API Gravity
  Gravity_API: Qudt.quantityKindFromLocalnameRequired("Gravity_API"),
  // Biodegredation Half Life
  BiodegredationHalfLife: Qudt.quantityKindFromLocalnameRequired(
    "BiodegredationHalfLife"
  ),
  // Thermal Conductivity
  ThermalConductivity: Qudt.quantityKindFromLocalnameRequired(
    "ThermalConductivity"
  ),
  // Ion Concentration
  LuminousIntensityDistribution: Qudt.quantityKindFromLocalnameRequired(
    "LuminousIntensityDistribution"
  ),
  // Micro Canonical Partition Function
  MicroCanonicalPartitionFunction: Qudt.quantityKindFromLocalnameRequired(
    "MicroCanonicalPartitionFunction"
  ),
  // Energy and work per mass amount of substance
  EnergyPerMassAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerMassAmountOfSubstance"
  ),
  // Contract End Item (CEI) Specification Mass.
  CONTRACT__END__ITEM__SPECIFICATION__MASS:
    Qudt.quantityKindFromLocalnameRequired(
      "CONTRACT-END-ITEM-SPECIFICATION-MASS"
    ),
  // Partial Pressure
  PartialPressure: Qudt.quantityKindFromLocalnameRequired("PartialPressure"),
  // Fermi Energy
  FermiEnergy: Qudt.quantityKindFromLocalnameRequired("FermiEnergy"),
  // Coercivity
  Coercivity: Qudt.quantityKindFromLocalnameRequired("Coercivity"),
  // Thermal Insulance
  ThermalInsulance: Qudt.quantityKindFromLocalnameRequired("ThermalInsulance"),
  // second radiation constant
  SecondRadiationConstant: Qudt.quantityKindFromLocalnameRequired(
    "SecondRadiationConstant"
  ),
  // electrical resistance
  ElectricalResistance: Qudt.quantityKindFromLocalnameRequired(
    "ElectricalResistance"
  ),
  // resistance-based inductance
  ResistanceBasedInductance: Qudt.quantityKindFromLocalnameRequired(
    "ResistanceBasedInductance"
  ),
  // Nozzle Throat Diameter
  NozzleThroatDiameter: Qudt.quantityKindFromLocalnameRequired(
    "NozzleThroatDiameter"
  ),
  // Area Thermal Expansion
  AreaThermalExpansion: Qudt.quantityKindFromLocalnameRequired(
    "AreaThermalExpansion"
  ),
  // Force per Angle
  ForcePerAngle: Qudt.quantityKindFromLocalnameRequired("ForcePerAngle"),
  // Nozzle Throat Cross-sectional Area
  NozzleThroatCrossSectionalArea: Qudt.quantityKindFromLocalnameRequired(
    "NozzleThroatCrossSectionalArea"
  ),
  // Effective Multiplication Factor
  EffectiveMultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "EffectiveMultiplicationFactor"
  ),
  // Blood Glucose Level
  BloodGlucoseLevel:
    Qudt.quantityKindFromLocalnameRequired("BloodGlucoseLevel"),
  // Surface Coefficient of Heat Transfer
  SurfaceCoefficientOfHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "SurfaceCoefficientOfHeatTransfer"
  ),
  // عدد الموجة
  Wavenumber: Qudt.quantityKindFromLocalnameRequired("Wavenumber"),
  // Time averaged sound intensity
  TimeAveragedSoundIntensity: Qudt.quantityKindFromLocalnameRequired(
    "TimeAveragedSoundIntensity"
  ),
  // Sound power level
  SoundPowerLevel: Qudt.quantityKindFromLocalnameRequired("SoundPowerLevel"),
  // Thermal Expansion Coefficient
  ThermalExpansionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "ThermalExpansionCoefficient"
  ),
  // picture element
  PictureElement: Qudt.quantityKindFromLocalnameRequired("PictureElement"),
  // Einstein Transition Probability
  EinsteinTransitionProbability: Qudt.quantityKindFromLocalnameRequired(
    "EinsteinTransitionProbability"
  ),
  // Length per Electric Current
  LengthPerElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "LengthPerElectricCurrent"
  ),
  // Thermal Diffusion Factor
  ThermalDiffusionFactor: Qudt.quantityKindFromLocalnameRequired(
    "ThermalDiffusionFactor"
  ),
  // Volume
  Volume: Qudt.quantityKindFromLocalnameRequired("Volume"),
  // Isentropic Compressibility
  IsentropicCompressibility: Qudt.quantityKindFromLocalnameRequired(
    "IsentropicCompressibility"
  ),
  // Standard Absolute Activity
  StandardAbsoluteActivity: Qudt.quantityKindFromLocalnameRequired(
    "StandardAbsoluteActivity"
  ),
  // Gauge Pressure
  GaugePressure: Qudt.quantityKindFromLocalnameRequired("GaugePressure"),
  // Square Energy
  Energy_Squared: Qudt.quantityKindFromLocalnameRequired("Energy_Squared"),
  // pressure-based molality
  PressureBasedMolality: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedMolality"
  ),
  // Reluctance
  Reluctance: Qudt.quantityKindFromLocalnameRequired("Reluctance"),
  // Serum or Plasma Level
  SerumOrPlasmaLevel:
    Qudt.quantityKindFromLocalnameRequired("SerumOrPlasmaLevel"),
  // Superconduction Transition Temperature
  SuperconductionTransitionTemperature: Qudt.quantityKindFromLocalnameRequired(
    "SuperconductionTransitionTemperature"
  ),
  // Atmospheric Pressure
  AtmosphericPressure: Qudt.quantityKindFromLocalnameRequired(
    "AtmosphericPressure"
  ),
  // nuclear energy
  NuclearEnergy: Qudt.quantityKindFromLocalnameRequired("NuclearEnergy"),
  // Path Length
  PathLength: Qudt.quantityKindFromLocalnameRequired("PathLength"),
  // Dose Equivalent Quality Factor
  DoseEquivalentQualityFactor: Qudt.quantityKindFromLocalnameRequired(
    "DoseEquivalentQualityFactor"
  ),
  // قدرة إشعاعية
  RadiantFlux: Qudt.quantityKindFromLocalnameRequired("RadiantFlux"),
  // Resonance Escape Probability
  ResonanceEscapeProbability: Qudt.quantityKindFromLocalnameRequired(
    "ResonanceEscapeProbability"
  ),
  // Mass Attenuation Coefficient
  MassAttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MassAttenuationCoefficient"
  ),
  // Reactance
  Reactance: Qudt.quantityKindFromLocalnameRequired("Reactance"),
  // Richardson Constant
  RichardsonConstant:
    Qudt.quantityKindFromLocalnameRequired("RichardsonConstant"),
  // Second Polar Moment of Area
  SecondPolarMomentOfArea: Qudt.quantityKindFromLocalnameRequired(
    "SecondPolarMomentOfArea"
  ),
  // areic charge density
  AreaChargeDensity:
    Qudt.quantityKindFromLocalnameRequired("AreaChargeDensity"),
  // Inverse Square Energy
  InverseSquareEnergy: Qudt.quantityKindFromLocalnameRequired(
    "InverseSquareEnergy"
  ),
  // torsional rigidity
  TorsionalRigidity:
    Qudt.quantityKindFromLocalnameRequired("TorsionalRigidity"),
  // Electron Radius
  ElectronRadius: Qudt.quantityKindFromLocalnameRequired("ElectronRadius"),
  // Diffusionskoeffizient
  DiffusionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "DiffusionCoefficient"
  ),
  // eficiência
  Efficiency: Qudt.quantityKindFromLocalnameRequired("Efficiency"),
  // Mean Lifetime
  MeanLifetime: Qudt.quantityKindFromLocalnameRequired("MeanLifetime"),
  // Ketumpatan arus elektrik
  ElectricCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentDensity"
  ),
  // logarithm ratio to base e
  LogarithmRatioToBaseE: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmRatioToBaseE"
  ),
  // Particle Source Density
  ParticleSourceDensity: Qudt.quantityKindFromLocalnameRequired(
    "ParticleSourceDensity"
  ),
  // Thrust To Mass Ratio
  ThrustToMassRatio:
    Qudt.quantityKindFromLocalnameRequired("ThrustToMassRatio"),
  // elektryczny moment kwadrupolowy
  ElectricQuadrupoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "ElectricQuadrupoleMoment"
  ),
  // Electric Charge Density
  ElectricChargeDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargeDensity"
  ),
  // Viscosity
  Viscosity: Qudt.quantityKindFromLocalnameRequired("Viscosity"),
  // Luminous Emmitance
  LuminousEmittance:
    Qudt.quantityKindFromLocalnameRequired("LuminousEmittance"),
  // Planck Function
  PlanckFunction: Qudt.quantityKindFromLocalnameRequired("PlanckFunction"),
  // Electrolytic Conductivity
  ElectrolyticConductivity: Qudt.quantityKindFromLocalnameRequired(
    "ElectrolyticConductivity"
  ),
  // Principal Quantum Number
  PrincipalQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "PrincipalQuantumNumber"
  ),
  // Magnetic flux per length
  MagneticFluxPerLength: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFluxPerLength"
  ),
  // Mass per Area Time
  MassPerAreaTime: Qudt.quantityKindFromLocalnameRequired("MassPerAreaTime"),
  // Sound intensity
  SoundIntensity: Qudt.quantityKindFromLocalnameRequired("SoundIntensity"),
  // information content expressed as a logarithm to base 10
  InformationContentExpressedAsALogarithmToBase10:
    Qudt.quantityKindFromLocalnameRequired(
      "InformationContentExpressedAsALogarithmToBase10"
    ),
  // amount of biologically active substance
  AmountOfBiologicallyActiveSubstance: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfBiologicallyActiveSubstance"
  ),
  // neutral ratio
  NeutralRatio: Qudt.quantityKindFromLocalnameRequired("NeutralRatio"),
  // gas leak rate
  GasLeakRate: Qudt.quantityKindFromLocalnameRequired("GasLeakRate"),
  // Normal Stress
  NormalStress: Qudt.quantityKindFromLocalnameRequired("NormalStress"),
  // Tilt
  Tilt: Qudt.quantityKindFromLocalnameRequired("Tilt"),
  // Displacement
  Displacement: Qudt.quantityKindFromLocalnameRequired("Displacement"),
  // Isothermal Moisture Capacity
  IsothermalMoistureCapacity: Qudt.quantityKindFromLocalnameRequired(
    "IsothermalMoistureCapacity"
  ),
  // Kreisfrequenz
  AngularFrequency: Qudt.quantityKindFromLocalnameRequired("AngularFrequency"),
  // median information flow (from a source of information), expressed as a natural logarithm
  LogarithmicMedianInformationFlow_SourceToBaseE:
    Qudt.quantityKindFromLocalnameRequired(
      "LogarithmicMedianInformationFlow_SourceToBaseE"
    ),
  // Charge Number
  ChargeNumber: Qudt.quantityKindFromLocalnameRequired("ChargeNumber"),
  // Rotational Stiffness
  RotationalStiffness: Qudt.quantityKindFromLocalnameRequired(
    "RotationalStiffness"
  ),
  // Target Bogie Mass
  TARGET__BOGIE__MASS:
    Qudt.quantityKindFromLocalnameRequired("TARGET-BOGIE-MASS"),
  // Bulk Modulus
  BulkModulus: Qudt.quantityKindFromLocalnameRequired("BulkModulus"),
  // energia interna
  EnergyInternal: Qudt.quantityKindFromLocalnameRequired("EnergyInternal"),
  // failure rate
  FailureRate: Qudt.quantityKindFromLocalnameRequired("FailureRate"),
  // pressure-based quantity
  PressureBasedQuantity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedQuantity"
  ),
  // volumic electric charge
  VolumetricElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricElectricCharge"
  ),
  // Înălțime
  Height: Qudt.quantityKindFromLocalnameRequired("Height"),
  // Lande g-Factor
  LandeGFactor: Qudt.quantityKindFromLocalnameRequired("LandeGFactor"),
  // Sound volume velocity
  SoundVolumeVelocity: Qudt.quantityKindFromLocalnameRequired(
    "SoundVolumeVelocity"
  ),
  // Coefficient of heat transfer
  CoefficientOfHeatTransfer: Qudt.quantityKindFromLocalnameRequired(
    "CoefficientOfHeatTransfer"
  ),
  // polarizzabilità elettrica
  ElectricPolarizability: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPolarizability"
  ),
  // energia radiante
  RadiantEnergy: Qudt.quantityKindFromLocalnameRequired("RadiantEnergy"),
  // lineic torque
  LineicTorque: Qudt.quantityKindFromLocalnameRequired("LineicTorque"),
  // particle current density
  ParticleCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "ParticleCurrentDensity"
  ),
  // Amount of Substance per Unit Mass
  AmountOfSubstancePerUnitMass: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerUnitMass"
  ),
  // Static Friction
  StaticFriction: Qudt.quantityKindFromLocalnameRequired("StaticFriction"),
  // Power per Area Angle
  PowerPerAreaAngle:
    Qudt.quantityKindFromLocalnameRequired("PowerPerAreaAngle"),
  // Nozzle Walls Thrust Reaction
  NozzleWallsThrustReaction: Qudt.quantityKindFromLocalnameRequired(
    "NozzleWallsThrustReaction"
  ),
  // תדירות
  Frequency: Qudt.quantityKindFromLocalnameRequired("Frequency"),
  // Thruster Power To Thrust Efficiency
  ThrusterPowerToThrustEfficiency: Qudt.quantityKindFromLocalnameRequired(
    "ThrusterPowerToThrustEfficiency"
  ),
  // Nozzle Throat Pressure
  NozzleThroatPressure: Qudt.quantityKindFromLocalnameRequired(
    "NozzleThroatPressure"
  ),
  // Magnetic Polarization
  MagneticPolarization: Qudt.quantityKindFromLocalnameRequired(
    "MagneticPolarization"
  ),
  // Ionic Strength
  IonicStrength: Qudt.quantityKindFromLocalnameRequired("IonicStrength"),
  // Particle Current
  ParticleCurrent: Qudt.quantityKindFromLocalnameRequired("ParticleCurrent"),
  // چگالی شار الکتریکی
  ElectricFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricFluxDensity"
  ),
  // Thermal Diffusion Ratio
  ThermalDiffusionRatio: Qudt.quantityKindFromLocalnameRequired(
    "ThermalDiffusionRatio"
  ),
  // Angular Momentum per Angle
  AngularMomentumPerAngle: Qudt.quantityKindFromLocalnameRequired(
    "AngularMomentumPerAngle"
  ),
  // Product of Inertia in the Y axis
  PRODUCT__OF__INERTIA_Y: Qudt.quantityKindFromLocalnameRequired(
    "PRODUCT-OF-INERTIA_Y"
  ),
  // InternalConversionFactor
  InternalConversionFactor: Qudt.quantityKindFromLocalnameRequired(
    "InternalConversionFactor"
  ),
  // characteristic number
  CharacteristicNumber: Qudt.quantityKindFromLocalnameRequired(
    "CharacteristicNumber"
  ),
  // pressure-based density
  PressureBasedDensity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedDensity"
  ),
  // Multiplication Factor
  MultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "MultiplicationFactor"
  ),
  // CoefficientOfPerformance
  CoefficientOfPerformance: Qudt.quantityKindFromLocalnameRequired(
    "CoefficientOfPerformance"
  ),
  // Magnetic flux per unit length
  MagneticFluxPerUnitLength: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFluxPerUnitLength"
  ),
  // dataset of bytes
  DatasetOfBytes: Qudt.quantityKindFromLocalnameRequired("DatasetOfBytes"),
  // pressure-based velocity
  PressureBasedVelocity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedVelocity"
  ),
  // Specific Heats Ratio
  SpecificHeatsRatio:
    Qudt.quantityKindFromLocalnameRequired("SpecificHeatsRatio"),
  // Signal Strength
  SignalStrength: Qudt.quantityKindFromLocalnameRequired("SignalStrength"),
  // Linear Ionization
  LinearIonization: Qudt.quantityKindFromLocalnameRequired("LinearIonization"),
  // Atomic Number
  AtomicNumber: Qudt.quantityKindFromLocalnameRequired("AtomicNumber"),
  // Mass Of Electrical Power Supply
  MassOfElectricalPowerSupply: Qudt.quantityKindFromLocalnameRequired(
    "MassOfElectricalPowerSupply"
  ),
  // Stress-Optic Coefficient
  StressOpticCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "StressOpticCoefficient"
  ),
  // Specific Heat Capacity
  SpecificHeatCapacity: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatCapacity"
  ),
  // lineic resistance
  LinearResistance: Qudt.quantityKindFromLocalnameRequired("LinearResistance"),
  // pressure-based electric current
  PressureBasedElectricCurrent: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedElectricCurrent"
  ),
  // Fläche pro Heizlast
  AreaPerPower: Qudt.quantityKindFromLocalnameRequired("AreaPerPower"),
  // Linear Absorption Coefficient
  LinearAbsorptionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearAbsorptionCoefficient"
  ),
  // Infinite Multiplication Factor
  InfiniteMultiplicationFactor: Qudt.quantityKindFromLocalnameRequired(
    "InfiniteMultiplicationFactor"
  ),
  // Linear Force
  LinearStiffness: Qudt.quantityKindFromLocalnameRequired("LinearStiffness"),
  // Equivalent absorption area
  EquivalentAbsorptionArea: Qudt.quantityKindFromLocalnameRequired(
    "EquivalentAbsorptionArea"
  ),
  // Specific Energy Imparted
  SpecificEnergyImparted: Qudt.quantityKindFromLocalnameRequired(
    "SpecificEnergyImparted"
  ),
  // volumic bit density
  VolumetricBitDensity: Qudt.quantityKindFromLocalnameRequired(
    "VolumetricBitDensity"
  ),
  // Temperature Rate of Change
  TemperatureRateOfChange: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureRateOfChange"
  ),
  // Electric Current per Energy
  ElectricCurrentPerEnergy: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerEnergy"
  ),
  // rise of off-state voltage
  RiseOfOffStateVoltage: Qudt.quantityKindFromLocalnameRequired(
    "RiseOfOffStateVoltage"
  ),
  // Magnetic Reluctivity
  MagneticReluctivity: Qudt.quantityKindFromLocalnameRequired(
    "MagneticReluctivity"
  ),
  // jakost magnetnega polja
  MagneticFieldStrength_H: Qudt.quantityKindFromLocalnameRequired(
    "MagneticFieldStrength_H"
  ),
  // Orbital Angular Momentum per Mass
  OrbitalAngularMomentumPerMass: Qudt.quantityKindFromLocalnameRequired(
    "OrbitalAngularMomentumPerMass"
  ),
  // Mass per Time
  MassPerTime: Qudt.quantityKindFromLocalnameRequired("MassPerTime"),
  // Predicted Mass
  PREDICTED__MASS: Qudt.quantityKindFromLocalnameRequired("PREDICTED-MASS"),
  // Mass Energy Transfer Coefficient
  MassEnergyTransferCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "MassEnergyTransferCoefficient"
  ),
  // Strain Energy Release Rate
  StrainEnergyReleaseRate: Qudt.quantityKindFromLocalnameRequired(
    "StrainEnergyReleaseRate"
  ),
  // Electric Current per Angle
  ElectricCurrentPerAngle: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerAngle"
  ),
  // Sound particle acceleration
  SoundParticleAcceleration: Qudt.quantityKindFromLocalnameRequired(
    "SoundParticleAcceleration"
  ),
  // temperature-based mass flow rate
  TemperatureBasedMassFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedMassFlowRate"
  ),
  // Signal Detection Threshold
  SignalDetectionThreshold: Qudt.quantityKindFromLocalnameRequired(
    "SignalDetectionThreshold"
  ),
  // Equilibrium Position Vector of Ion
  EquilibriumPositionVectorOfIon: Qudt.quantityKindFromLocalnameRequired(
    "EquilibriumPositionVectorOfIon"
  ),
  // Volumic Electromagnetic Energy
  VolumicElectromagneticEnergy: Qudt.quantityKindFromLocalnameRequired(
    "VolumicElectromagneticEnergy"
  ),
  // Dynamic Pressure
  DynamicPressure: Qudt.quantityKindFromLocalnameRequired("DynamicPressure"),
  // Ventilation Rate per Floor Area
  VentilationRatePerFloorArea: Qudt.quantityKindFromLocalnameRequired(
    "VentilationRatePerFloorArea"
  ),
  // Relative Humidity
  RelativeHumidity: Qudt.quantityKindFromLocalnameRequired("RelativeHumidity"),
  // Pressure Loss per Length
  PressureLossPerLength: Qudt.quantityKindFromLocalnameRequired(
    "PressureLossPerLength"
  ),
  // polarização eléctrica
  ElectricPolarization: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPolarization"
  ),
  // Sound Particle Displacement
  SoundParticleDisplacement: Qudt.quantityKindFromLocalnameRequired(
    "SoundParticleDisplacement"
  ),
  // Polar moment of inertia
  PolarMomentOfInertia: Qudt.quantityKindFromLocalnameRequired(
    "PolarMomentOfInertia"
  ),
  // Amount of Substance per Mass
  AmountOfSubstancePerMass: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerMass"
  ),
  // Relaxation TIme
  RelaxationTIme: Qudt.quantityKindFromLocalnameRequired("RelaxationTIme"),
  // Heat Flow Rate per Unit Area
  HeatFlowRatePerUnitArea: Qudt.quantityKindFromLocalnameRequired(
    "HeatFlowRatePerUnitArea"
  ),
  // Molar Entropy
  MolarEntropy: Qudt.quantityKindFromLocalnameRequired("MolarEntropy"),
  // Reactivity
  Reactivity: Qudt.quantityKindFromLocalnameRequired("Reactivity"),
  // fluctús lucis
  LuminousFlux: Qudt.quantityKindFromLocalnameRequired("LuminousFlux"),
  // intervalo logarítmico de frequência
  LogarithmicFrequencyInterval: Qudt.quantityKindFromLocalnameRequired(
    "LogarithmicFrequencyInterval"
  ),
  // Dry Volume
  DryVolume: Qudt.quantityKindFromLocalnameRequired("DryVolume"),
  // Spectral Angular Cross-section
  SpectralAngularCrossSection: Qudt.quantityKindFromLocalnameRequired(
    "SpectralAngularCrossSection"
  ),
  // Asset
  Asset: Qudt.quantityKindFromLocalnameRequired("Asset"),
  // CO2Equivalent
  CO2Equivalent: Qudt.quantityKindFromLocalnameRequired("CO2Equivalent"),
  // bit data volume
  BitDataVolume: Qudt.quantityKindFromLocalnameRequired("BitDataVolume"),
  // Stoichiometric Number
  StoichiometricNumber: Qudt.quantityKindFromLocalnameRequired(
    "StoichiometricNumber"
  ),
  // areic energy flow
  AreicEnergyFlow: Qudt.quantityKindFromLocalnameRequired("AreicEnergyFlow"),
  // Moisture Diffusivity
  MoistureDiffusivity: Qudt.quantityKindFromLocalnameRequired(
    "MoistureDiffusivity"
  ),
  // Modulus of Subgrade Reaction
  ModulusOfSubgradeReaction: Qudt.quantityKindFromLocalnameRequired(
    "ModulusOfSubgradeReaction"
  ),
  // Ion Transport Number
  IonTransportNumber:
    Qudt.quantityKindFromLocalnameRequired("IonTransportNumber"),
  // número de onda angular
  AngularWavenumber:
    Qudt.quantityKindFromLocalnameRequired("AngularWavenumber"),
  // lineic data volume
  LineicDataVolume: Qudt.quantityKindFromLocalnameRequired("LineicDataVolume"),
  // lineic power
  LinearPower: Qudt.quantityKindFromLocalnameRequired("LinearPower"),
  // entropie
  Entropy: Qudt.quantityKindFromLocalnameRequired("Entropy"),
  // Incidence Proportion
  IncidenceProportion: Qudt.quantityKindFromLocalnameRequired(
    "IncidenceProportion"
  ),
  // Quality Factor
  QualityFactor: Qudt.quantityKindFromLocalnameRequired("QualityFactor"),
  // Specific Gibbs Energy
  SpecificGibbsEnergy: Qudt.quantityKindFromLocalnameRequired(
    "SpecificGibbsEnergy"
  ),
  // logarithmic ratio to base e
  LogERatio: Qudt.quantityKindFromLocalnameRequired("LogERatio"),
  // 皮相電力
  ApparentPower: Qudt.quantityKindFromLocalnameRequired("ApparentPower"),
  // battery capacity
  BatteryCapacity: Qudt.quantityKindFromLocalnameRequired("BatteryCapacity"),
  // specific optical rotational ability
  SpecificOpticalRotationalAbility: Qudt.quantityKindFromLocalnameRequired(
    "SpecificOpticalRotationalAbility"
  ),
  // masa molar
  MolarMass: Qudt.quantityKindFromLocalnameRequired("MolarMass"),
  // Relative Mass Concentration of Vapour
  RelativeMassConcentrationOfVapour: Qudt.quantityKindFromLocalnameRequired(
    "RelativeMassConcentrationOfVapour"
  ),
  // Second Stage Mass Ratio
  SecondStageMassRatio: Qudt.quantityKindFromLocalnameRequired(
    "SecondStageMassRatio"
  ),
  // Upper Critical Magnetic Flux Density
  UpperCriticalMagneticFluxDensity: Qudt.quantityKindFromLocalnameRequired(
    "UpperCriticalMagneticFluxDensity"
  ),
  // Diffusion Length (Solid State Physics)
  SolidStateDiffusionLength: Qudt.quantityKindFromLocalnameRequired(
    "SolidStateDiffusionLength"
  ),
  // Absorptance
  Absorptance: Qudt.quantityKindFromLocalnameRequired("Absorptance"),
  // Linear Acceleration
  LinearAcceleration:
    Qudt.quantityKindFromLocalnameRequired("LinearAcceleration"),
  // Heat Flow Rate per Unit Area
  HeatFlowRatePerArea: Qudt.quantityKindFromLocalnameRequired(
    "HeatFlowRatePerArea"
  ),
  // Generalized Coordinate
  GeneralizedCoordinate: Qudt.quantityKindFromLocalnameRequired(
    "GeneralizedCoordinate"
  ),
  // Speed
  Speed: Qudt.quantityKindFromLocalnameRequired("Speed"),
  // osvetljenost
  Illuminance: Qudt.quantityKindFromLocalnameRequired("Illuminance"),
  // Mass Ratio of Water Vapour to Dry Gas
  MassRatioOfWaterVapourToDryGas: Qudt.quantityKindFromLocalnameRequired(
    "MassRatioOfWaterVapourToDryGas"
  ),
  // Ускоре́ние
  Acceleration: Qudt.quantityKindFromLocalnameRequired("Acceleration"),
  // Area Time Temperature
  AreaTimeTemperature: Qudt.quantityKindFromLocalnameRequired(
    "AreaTimeTemperature"
  ),
  // Radiant Emmitance
  RadiantEmmitance: Qudt.quantityKindFromLocalnameRequired("RadiantEmmitance"),
  // मैक संख्या
  MachNumber: Qudt.quantityKindFromLocalnameRequired("MachNumber"),
  // Nuclear Quadrupole Moment
  NuclearQuadrupoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "NuclearQuadrupoleMoment"
  ),
  // Expansion Ratio
  ExpansionRatio: Qudt.quantityKindFromLocalnameRequired("ExpansionRatio"),
  // Emissivity
  Emissivity: Qudt.quantityKindFromLocalnameRequired("Emissivity"),
  // area per length
  AreaPerLength: Qudt.quantityKindFromLocalnameRequired("AreaPerLength"),
  // אורך
  Length: Qudt.quantityKindFromLocalnameRequired("Length"),
  // Sound reduction index
  SoundReductionIndex: Qudt.quantityKindFromLocalnameRequired(
    "SoundReductionIndex"
  ),
  // Temperature Ratio
  TemperatureRatio: Qudt.quantityKindFromLocalnameRequired("TemperatureRatio"),
  // विद्युत्-क्षेत्र
  ElectricFieldStrength: Qudt.quantityKindFromLocalnameRequired(
    "ElectricFieldStrength"
  ),
  // Propagation coefficient
  PropagationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "PropagationCoefficient"
  ),
  // Donor Density
  DonorDensity: Qudt.quantityKindFromLocalnameRequired("DonorDensity"),
  // Energy Per Square Magnetic Flux Density
  EnergyPerMagneticFluxDensity_Squared: Qudt.quantityKindFromLocalnameRequired(
    "EnergyPerMagneticFluxDensity_Squared"
  ),
  // Stress
  Stress: Qudt.quantityKindFromLocalnameRequired("Stress"),
  // Inverse Energy
  InverseEnergy: Qudt.quantityKindFromLocalnameRequired("InverseEnergy"),
  // Thermal Conductance
  ThermalConductance:
    Qudt.quantityKindFromLocalnameRequired("ThermalConductance"),
  // Electric Charge Per Mass
  ElectricChargePerMass: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargePerMass"
  ),
  // lineic quantity
  LineicQuantity: Qudt.quantityKindFromLocalnameRequired("LineicQuantity"),
  // Gravitational Attraction
  GravitationalAttraction: Qudt.quantityKindFromLocalnameRequired(
    "GravitationalAttraction"
  ),
  // Effective Exhaustvelocity
  EffectiveExhaustVelocity: Qudt.quantityKindFromLocalnameRequired(
    "EffectiveExhaustVelocity"
  ),
  // bandwidth length product
  BandwidthLengthProduct: Qudt.quantityKindFromLocalnameRequired(
    "BandwidthLengthProduct"
  ),
  // power constant
  PowerConstant: Qudt.quantityKindFromLocalnameRequired("PowerConstant"),
  // Exit Plane Pressure
  ExitPlanePressure:
    Qudt.quantityKindFromLocalnameRequired("ExitPlanePressure"),
  // Inverse Square Mass
  InverseMass_Squared: Qudt.quantityKindFromLocalnameRequired(
    "InverseMass_Squared"
  ),
  // Maximum Expected Operating Pressure
  MaximumExpectedOperatingPressure: Qudt.quantityKindFromLocalnameRequired(
    "MaximumExpectedOperatingPressure"
  ),
  // spectral radiant energy density in terms of wavelength
  SpectralRadiantEnergyDensityInTermsOfWavelength:
    Qudt.quantityKindFromLocalnameRequired(
      "SpectralRadiantEnergyDensityInTermsOfWavelength"
    ),
  // Mean Linear Range
  MeanLinearRange: Qudt.quantityKindFromLocalnameRequired("MeanLinearRange"),
  // Magnetic Field
  MagneticField: Qudt.quantityKindFromLocalnameRequired("MagneticField"),
  // Volume per Unit Time
  VolumePerUnitTime:
    Qudt.quantityKindFromLocalnameRequired("VolumePerUnitTime"),
  // Non-Leakage Probability
  Non__LeakageProbability: Qudt.quantityKindFromLocalnameRequired(
    "Non-LeakageProbability"
  ),
  // Electron Density
  ElectronDensity: Qudt.quantityKindFromLocalnameRequired("ElectronDensity"),
  // pressure-based mass flow
  PressureBasedMassFlow: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedMassFlow"
  ),
  // kerja
  Work: Qudt.quantityKindFromLocalnameRequired("Work"),
  // Combustion Chamber Temperature
  CombustionChamberTemperature: Qudt.quantityKindFromLocalnameRequired(
    "CombustionChamberTemperature"
  ),
  // Lethargy
  Lethargy: Qudt.quantityKindFromLocalnameRequired("Lethargy"),
  // Inverse Length Temperature
  InverseLengthTemperature: Qudt.quantityKindFromLocalnameRequired(
    "InverseLengthTemperature"
  ),
  // Product of Inertia in the X axis
  PRODUCT__OF__INERTIA_X: Qudt.quantityKindFromLocalnameRequired(
    "PRODUCT-OF-INERTIA_X"
  ),
  // श्यानता
  DynamicViscosity: Qudt.quantityKindFromLocalnameRequired("DynamicViscosity"),
  // Radiant Energy Density
  RadiantEnergyDensity: Qudt.quantityKindFromLocalnameRequired(
    "RadiantEnergyDensity"
  ),
  // Inverse Time
  InverseTime: Qudt.quantityKindFromLocalnameRequired("InverseTime"),
  // Peltier Coefficient
  PeltierCoefficient:
    Qudt.quantityKindFromLocalnameRequired("PeltierCoefficient"),
  // Chemical Affinity
  ChemicalAffinity: Qudt.quantityKindFromLocalnameRequired("ChemicalAffinity"),
  // Specific Impulse by Mass
  SpecificImpulseByMass: Qudt.quantityKindFromLocalnameRequired(
    "SpecificImpulseByMass"
  ),
  // Web Time Average Pressure
  WebTimeAveragePressure: Qudt.quantityKindFromLocalnameRequired(
    "WebTimeAveragePressure"
  ),
  // Heart Rate
  HeartRate: Qudt.quantityKindFromLocalnameRequired("HeartRate"),
  // Attenuation Coefficient
  AttenuationCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "AttenuationCoefficient"
  ),
  // Fundamental Reciprocal Lattice Vector
  FundamentalReciprocalLatticeVector: Qudt.quantityKindFromLocalnameRequired(
    "FundamentalReciprocalLatticeVector"
  ),
  // Video Frame Rate
  VideoFrameRate: Qudt.quantityKindFromLocalnameRequired("VideoFrameRate"),
  // Auditory Thresholds
  AuditoryThresholds:
    Qudt.quantityKindFromLocalnameRequired("AuditoryThresholds"),
  // Rovinný úhel
  PlaneAngle: Qudt.quantityKindFromLocalnameRequired("PlaneAngle"),
  // Standard Gravitational Parameter
  StandardGravitationalParameter: Qudt.quantityKindFromLocalnameRequired(
    "StandardGravitationalParameter"
  ),
  // Mass Temperature
  MassTemperature: Qudt.quantityKindFromLocalnameRequired("MassTemperature"),
  // Sound pressure
  SoundPressure: Qudt.quantityKindFromLocalnameRequired("SoundPressure"),
  // Specific Surface Area
  SpecificSurfaceArea: Qudt.quantityKindFromLocalnameRequired(
    "SpecificSurfaceArea"
  ),
  // force constant
  ForceConstant: Qudt.quantityKindFromLocalnameRequired("ForceConstant"),
  // Phonon Mean Free Path
  PhononMeanFreePath:
    Qudt.quantityKindFromLocalnameRequired("PhononMeanFreePath"),
  // exposure of ionizing radiation
  ExposureOfIonizingRadiation: Qudt.quantityKindFromLocalnameRequired(
    "ExposureOfIonizingRadiation"
  ),
  // Gap Energy
  GapEnergy: Qudt.quantityKindFromLocalnameRequired("GapEnergy"),
  // Resistance Ratio
  ResistanceRatio: Qudt.quantityKindFromLocalnameRequired("ResistanceRatio"),
  // Inverse Temperature
  InverseTemperature:
    Qudt.quantityKindFromLocalnameRequired("InverseTemperature"),
  // Ratio of Specific Heat Capacities
  RatioOfSpecificHeatCapacities: Qudt.quantityKindFromLocalnameRequired(
    "RatioOfSpecificHeatCapacities"
  ),
  // Specific Heat Pressure
  SpecificHeatPressure: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatPressure"
  ),
  // molar optical rotational ability
  MolarOpticalRotationalAbility: Qudt.quantityKindFromLocalnameRequired(
    "MolarOpticalRotationalAbility"
  ),
  // Tenaga kinetik
  EnergyKinetic: Qudt.quantityKindFromLocalnameRequired("EnergyKinetic"),
  // Logarithm of Octanol Water Partition Coefficient
  LogOctanolWaterPartitionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LogOctanolWaterPartitionCoefficient"
  ),
  // Temperature Gradient
  TemperatureGradient: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureGradient"
  ),
  // Gustatory Threshold
  GustatoryThreshold:
    Qudt.quantityKindFromLocalnameRequired("GustatoryThreshold"),
  // Migration Area
  MigrationArea: Qudt.quantityKindFromLocalnameRequired("MigrationArea"),
  // Exhaust Gas Mean Molecular Weight
  ExhaustGasMeanMolecularWeight: Qudt.quantityKindFromLocalnameRequired(
    "ExhaustGasMeanMolecularWeight"
  ),
  // photon luminance
  PhotonLuminance: Qudt.quantityKindFromLocalnameRequired("PhotonLuminance"),
  // vitesse  acoustique d‘une particule
  SoundParticleVelocity: Qudt.quantityKindFromLocalnameRequired(
    "SoundParticleVelocity"
  ),
  // Thermal Resistivity
  ThermalResistivity:
    Qudt.quantityKindFromLocalnameRequired("ThermalResistivity"),
  // مختصات دکارتی
  CartesianCoordinates: Qudt.quantityKindFromLocalnameRequired(
    "CartesianCoordinates"
  ),
  // Radiant Exposure
  RadiantExposure: Qudt.quantityKindFromLocalnameRequired("RadiantExposure"),
  // potencial químico
  ChemicalPotential:
    Qudt.quantityKindFromLocalnameRequired("ChemicalPotential"),
  // Gyromagnetic Ratio
  GyromagneticRatio:
    Qudt.quantityKindFromLocalnameRequired("GyromagneticRatio"),
  // Mass Fraction of Water
  MassFractionOfWater: Qudt.quantityKindFromLocalnameRequired(
    "MassFractionOfWater"
  ),
  // lineic bit density
  LinearBitDensity: Qudt.quantityKindFromLocalnameRequired("LinearBitDensity"),
  // Payload Mass
  PayloadMass: Qudt.quantityKindFromLocalnameRequired("PayloadMass"),
  // True Exhaust Velocity
  TrueExhaustVelocity: Qudt.quantityKindFromLocalnameRequired(
    "TrueExhaustVelocity"
  ),
  // Kerma
  Kerma: Qudt.quantityKindFromLocalnameRequired("Kerma"),
  // Constringence
  Constringence: Qudt.quantityKindFromLocalnameRequired("Constringence"),
  // Impedance
  Impedance: Qudt.quantityKindFromLocalnameRequired("Impedance"),
  // I²t-value
  CutoffCurrentRating: Qudt.quantityKindFromLocalnameRequired(
    "CutoffCurrentRating"
  ),
  // Linear Compressibility
  LinearCompressibility: Qudt.quantityKindFromLocalnameRequired(
    "LinearCompressibility"
  ),
  // Opening Ratio
  OpeningRatio: Qudt.quantityKindFromLocalnameRequired("OpeningRatio"),
  // Propellant Temperature
  PropellantTemperature: Qudt.quantityKindFromLocalnameRequired(
    "PropellantTemperature"
  ),
  // Speed Ratio
  SpeedRatio: Qudt.quantityKindFromLocalnameRequired("SpeedRatio"),
  // volume
  CartesianVolume: Qudt.quantityKindFromLocalnameRequired("CartesianVolume"),
  // Density
  Density: Qudt.quantityKindFromLocalnameRequired("Density"),
  // Exposure Rate
  ExposureRate: Qudt.quantityKindFromLocalnameRequired("ExposureRate"),
  // Nuclear Radius
  NuclearRadius: Qudt.quantityKindFromLocalnameRequired("NuclearRadius"),
  // Thrust
  Thrust: Qudt.quantityKindFromLocalnameRequired("Thrust"),
  // Ionic Charge
  IonicCharge: Qudt.quantityKindFromLocalnameRequired("IonicCharge"),
  // Magnetic Quantum Number
  MagneticQuantumNumber: Qudt.quantityKindFromLocalnameRequired(
    "MagneticQuantumNumber"
  ),
  // Particle Fluence Rate
  ParticleFluenceRate: Qudt.quantityKindFromLocalnameRequired(
    "ParticleFluenceRate"
  ),
  // Area Ratio
  AreaRatio: Qudt.quantityKindFromLocalnameRequired("AreaRatio"),
  // Friction Coefficient
  FrictionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "FrictionCoefficient"
  ),
  // byte transmission rate
  ByteTransmissionRate: Qudt.quantityKindFromLocalnameRequired(
    "ByteTransmissionRate"
  ),
  // Dimensionless Ratio
  DimensionlessRatio:
    Qudt.quantityKindFromLocalnameRequired("DimensionlessRatio"),
  // Radial Distance
  RadialDistance: Qudt.quantityKindFromLocalnameRequired("RadialDistance"),
  // Mass Excess
  MassExcess: Qudt.quantityKindFromLocalnameRequired("MassExcess"),
  // potencial magnético
  MagneticVectorPotential: Qudt.quantityKindFromLocalnameRequired(
    "MagneticVectorPotential"
  ),
  // 电导率
  ElectricConductivity: Qudt.quantityKindFromLocalnameRequired(
    "ElectricConductivity"
  ),
  // Heat Flux Density
  HeatFluxDensity: Qudt.quantityKindFromLocalnameRequired("HeatFluxDensity"),
  // Mass Concentration
  MassConcentration:
    Qudt.quantityKindFromLocalnameRequired("MassConcentration"),
  // information content expressed as a logarithm to base e
  InformationContentExpressedAsALogarithmToBaseE:
    Qudt.quantityKindFromLocalnameRequired(
      "InformationContentExpressedAsALogarithmToBaseE"
    ),
  // Microbial Formation
  MicrobialFormation:
    Qudt.quantityKindFromLocalnameRequired("MicrobialFormation"),
  // Time Percentage
  TimePercentage: Qudt.quantityKindFromLocalnameRequired("TimePercentage"),
  // Mass Concentration of Water Vapour
  MassConcentrationOfWaterVapour: Qudt.quantityKindFromLocalnameRequired(
    "MassConcentrationOfWaterVapour"
  ),
  // Massieu Function
  MassieuFunction: Qudt.quantityKindFromLocalnameRequired("MassieuFunction"),
  // Spatial Summation Function
  SpatialSummationFunction: Qudt.quantityKindFromLocalnameRequired(
    "SpatialSummationFunction"
  ),
  // Concentration
  Concentration: Qudt.quantityKindFromLocalnameRequired("Concentration"),
  // repetency
  Repetency: Qudt.quantityKindFromLocalnameRequired("Repetency"),
  // Over-range distance
  OverRangeDistance:
    Qudt.quantityKindFromLocalnameRequired("OverRangeDistance"),
  // temperature-based velocity
  TemperatureBasedVelocity: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedVelocity"
  ),
  // 速度
  Velocity: Qudt.quantityKindFromLocalnameRequired("Velocity"),
  // Fission Fuel Utilization Factor
  FissionFuelUtilizationFactor: Qudt.quantityKindFromLocalnameRequired(
    "FissionFuelUtilizationFactor"
  ),
  // Stochastic Process
  StochasticProcess:
    Qudt.quantityKindFromLocalnameRequired("StochasticProcess"),
  // Acoustic Impediance
  AcousticImpedance:
    Qudt.quantityKindFromLocalnameRequired("AcousticImpedance"),
  // Resonance Energy
  ResonanceEnergy: Qudt.quantityKindFromLocalnameRequired("ResonanceEnergy"),
  // 直径
  Diameter: Qudt.quantityKindFromLocalnameRequired("Diameter"),
  // Molar Conductivity
  MolarConductivity:
    Qudt.quantityKindFromLocalnameRequired("MolarConductivity"),
  // Jarak
  Distance: Qudt.quantityKindFromLocalnameRequired("Distance"),
  // Relative Mass Defect
  RelativeMassDefect:
    Qudt.quantityKindFromLocalnameRequired("RelativeMassDefect"),
  // Mechanical surface impedance
  MechanicalSurfaceImpedance: Qudt.quantityKindFromLocalnameRequired(
    "MechanicalSurfaceImpedance"
  ),
  // Amount of Substance per Volume
  AmountOfSubstancePerVolume: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstancePerVolume"
  ),
  // Warm Receptor Threshold
  WarmReceptorThreshold: Qudt.quantityKindFromLocalnameRequired(
    "WarmReceptorThreshold"
  ),
  // radioactivity
  Radioactivity: Qudt.quantityKindFromLocalnameRequired("Radioactivity"),
  // Total Current Density
  TotalCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "TotalCurrentDensity"
  ),
  // unbalance
  Unbalance: Qudt.quantityKindFromLocalnameRequired("Unbalance"),
  // pressure-based kinematic viscosity
  PressureBasedKinematicViscosity: Qudt.quantityKindFromLocalnameRequired(
    "PressureBasedKinematicViscosity"
  ),
  // Inverse Volume
  InverseVolume: Qudt.quantityKindFromLocalnameRequired("InverseVolume"),
  // Pressure Coefficient
  PressureCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "PressureCoefficient"
  ),
  // Specific Modulus
  SpecificModulus: Qudt.quantityKindFromLocalnameRequired("SpecificModulus"),
  // Ion Concentration
  AmountOfSubstanceIonConcentration: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceIonConcentration"
  ),
  // spectral density of vibrational modes
  SpectralDensityOfVibrationalModes: Qudt.quantityKindFromLocalnameRequired(
    "SpectralDensityOfVibrationalModes"
  ),
  // معدل التمدد الحراري الخطي
  LinearExpansionCoefficient: Qudt.quantityKindFromLocalnameRequired(
    "LinearExpansionCoefficient"
  ),
  // Thermal Admittance
  ThermalAdmittance:
    Qudt.quantityKindFromLocalnameRequired("ThermalAdmittance"),
  // Propellant Burn Rate
  PropellantBurnRate:
    Qudt.quantityKindFromLocalnameRequired("PropellantBurnRate"),
  // Lattice Vector
  LatticeVector: Qudt.quantityKindFromLocalnameRequired("LatticeVector"),
  // Distance Traveled During a Burn
  DistanceTraveledDuringBurn: Qudt.quantityKindFromLocalnameRequired(
    "DistanceTraveledDuringBurn"
  ),
  // traffic intensity
  TrafficIntensity: Qudt.quantityKindFromLocalnameRequired("TrafficIntensity"),
  // dots per inch
  DotsPerInch: Qudt.quantityKindFromLocalnameRequired("DotsPerInch"),
  // Molar Heat Capacity
  MolarHeatCapacity:
    Qudt.quantityKindFromLocalnameRequired("MolarHeatCapacity"),
  // Fundamental Lattice vector
  FundamentalLatticeVector: Qudt.quantityKindFromLocalnameRequired(
    "FundamentalLatticeVector"
  ),
  // Linear Electric Current Density
  LinearElectricCurrentDensity: Qudt.quantityKindFromLocalnameRequired(
    "LinearElectricCurrentDensity"
  ),
  // Показатель адиабаты
  IsentropicExponent:
    Qudt.quantityKindFromLocalnameRequired("IsentropicExponent"),
  // temperature-related molar mass
  TemperatureRelatedMolarMass: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureRelatedMolarMass"
  ),
  // Chromaticity
  Chromaticity: Qudt.quantityKindFromLocalnameRequired("Chromaticity"),
  // gradient
  Gradient: Qudt.quantityKindFromLocalnameRequired("Gradient"),
  // Diffusion Length
  DiffusionLength: Qudt.quantityKindFromLocalnameRequired("DiffusionLength"),
  // Luminance
  Luminance: Qudt.quantityKindFromLocalnameRequired("Luminance"),
  // Fractional Amount of Substance
  AmountOfSubstanceFraction: Qudt.quantityKindFromLocalnameRequired(
    "AmountOfSubstanceFraction"
  ),
  // Tekanan osmotik
  OsmoticPressure: Qudt.quantityKindFromLocalnameRequired("OsmoticPressure"),
  // Electric Flux
  ElectricFlux: Qudt.quantityKindFromLocalnameRequired("ElectricFlux"),
  // volumic data quantity
  VolumicDataQuantity: Qudt.quantityKindFromLocalnameRequired(
    "VolumicDataQuantity"
  ),
  // Vorticity
  Vorticity: Qudt.quantityKindFromLocalnameRequired("Vorticity"),
  // Wirkleistung
  ElectricPower: Qudt.quantityKindFromLocalnameRequired("ElectricPower"),
  // Kelajuan cahaya
  SpeedOfLight: Qudt.quantityKindFromLocalnameRequired("SpeedOfLight"),
  // Thermal Diffusivity
  ThermalDiffusivity:
    Qudt.quantityKindFromLocalnameRequired("ThermalDiffusivity"),
  // Circulation
  Circulation: Qudt.quantityKindFromLocalnameRequired("Circulation"),
  // Stage Structure Mass
  StageStructuralMass: Qudt.quantityKindFromLocalnameRequired(
    "StageStructuralMass"
  ),
  // Vehicle Velocity
  VehicleVelocity: Qudt.quantityKindFromLocalnameRequired("VehicleVelocity"),
  // momento di dipolo elettrico
  ElectricDipoleMoment: Qudt.quantityKindFromLocalnameRequired(
    "ElectricDipoleMoment"
  ),
  // Molecular Concentration
  MolecularConcentration: Qudt.quantityKindFromLocalnameRequired(
    "MolecularConcentration"
  ),
  // Electric Propulsion Propellant Mass
  ElectricPropulsionPropellantMass: Qudt.quantityKindFromLocalnameRequired(
    "ElectricPropulsionPropellantMass"
  ),
  // 无功功率
  ReactivePower: Qudt.quantityKindFromLocalnameRequired("ReactivePower"),
  // surface‑related volume flow rate
  VolumeFlowRate_SurfaceRelated: Qudt.quantityKindFromLocalnameRequired(
    "VolumeFlowRate_SurfaceRelated"
  ),
  // Flight Path Angle
  FlightPathAngle: Qudt.quantityKindFromLocalnameRequired("FlightPathAngle"),
  // Absorbed Dose Rate
  AbsorbedDoseRate: Qudt.quantityKindFromLocalnameRequired("AbsorbedDoseRate"),
  // Hall Coefficient
  HallCoefficient: Qudt.quantityKindFromLocalnameRequired("HallCoefficient"),
  // liczba neutronowa
  NeutronNumber: Qudt.quantityKindFromLocalnameRequired("NeutronNumber"),
  // Combined Non Evaporative Heat Transfer Coefficient
  CombinedNonEvaporativeHeatTransferCoefficient:
    Qudt.quantityKindFromLocalnameRequired(
      "CombinedNonEvaporativeHeatTransferCoefficient"
    ),
  // Sound exposure
  SoundExposure: Qudt.quantityKindFromLocalnameRequired("SoundExposure"),
  // Absolute Activity
  AbsoluteActivity: Qudt.quantityKindFromLocalnameRequired("AbsoluteActivity"),
  // Energiekosten
  CostPerUnitEnergy:
    Qudt.quantityKindFromLocalnameRequired("CostPerUnitEnergy"),
  // Acceptor Ionization Energy
  AcceptorIonizationEnergy: Qudt.quantityKindFromLocalnameRequired(
    "AcceptorIonizationEnergy"
  ),
  // Source Voltage Between Substances
  SourceVoltageBetweenSubstances: Qudt.quantityKindFromLocalnameRequired(
    "SourceVoltageBetweenSubstances"
  ),
  // Mechanical Mobility
  MechanicalMobility:
    Qudt.quantityKindFromLocalnameRequired("MechanicalMobility"),
  // Length Ratio
  LengthRatio: Qudt.quantityKindFromLocalnameRequired("LengthRatio"),
  // Drag Force
  DragForce: Qudt.quantityKindFromLocalnameRequired("DragForce"),
  // Exhaust Stream Power
  ExhaustStreamPower:
    Qudt.quantityKindFromLocalnameRequired("ExhaustStreamPower"),
  // Inverse amount of substance
  InverseAmountOfSubstance: Qudt.quantityKindFromLocalnameRequired(
    "InverseAmountOfSubstance"
  ),
  // 动量
  Momentum: Qudt.quantityKindFromLocalnameRequired("Momentum"),
  // information content expressed as a logarithm to base 2
  InformationContentExpressedAsALogarithmToBase2:
    Qudt.quantityKindFromLocalnameRequired(
      "InformationContentExpressedAsALogarithmToBase2"
    ),
  // Mass per Electric Charge
  MassPerElectricCharge: Qudt.quantityKindFromLocalnameRequired(
    "MassPerElectricCharge"
  ),
  // Electric Current per Temperature
  ElectricCurrentPerTemperature: Qudt.quantityKindFromLocalnameRequired(
    "ElectricCurrentPerTemperature"
  ),
  // Mass Growth Allowance
  MASS__GROWTH__ALLOWANCE: Qudt.quantityKindFromLocalnameRequired(
    "MASS-GROWTH-ALLOWANCE"
  ),
  // Mass Flow Rate
  MassFlowRate: Qudt.quantityKindFromLocalnameRequired("MassFlowRate"),
  // temperature-based mass
  TemperatureBasedMass: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedMass"
  ),
  // Thrust Coefficient
  ThrustCoefficient:
    Qudt.quantityKindFromLocalnameRequired("ThrustCoefficient"),
  // Total Angular Momentum
  TotalAngularMomentum: Qudt.quantityKindFromLocalnameRequired(
    "TotalAngularMomentum"
  ),
  // Fahrenheit temperature
  FahrenheitTemperature: Qudt.quantityKindFromLocalnameRequired(
    "FahrenheitTemperature"
  ),
  // Liquid Volume
  LiquidVolume: Qudt.quantityKindFromLocalnameRequired("LiquidVolume"),
  // Transmittance Density
  TransmittanceDensity: Qudt.quantityKindFromLocalnameRequired(
    "TransmittanceDensity"
  ),
  // Exit Plane Temperature
  ExitPlaneTemperature: Qudt.quantityKindFromLocalnameRequired(
    "ExitPlaneTemperature"
  ),
  // Initial Nozzle Throat Diameter
  InitialNozzleThroatDiameter: Qudt.quantityKindFromLocalnameRequired(
    "InitialNozzleThroatDiameter"
  ),
  // Basicity
  Basicity: Qudt.quantityKindFromLocalnameRequired("Basicity"),
  // Shear Stress
  ShearStress: Qudt.quantityKindFromLocalnameRequired("ShearStress"),
  // Residual Resistivity
  ResidualResistivity: Qudt.quantityKindFromLocalnameRequired(
    "ResidualResistivity"
  ),
  // Voltage Phasor
  VoltagePhasor: Qudt.quantityKindFromLocalnameRequired("VoltagePhasor"),
  // Electron Affinity
  ElectronAffinity: Qudt.quantityKindFromLocalnameRequired("ElectronAffinity"),
  // Lorenz Coefficient
  LorenzCoefficient:
    Qudt.quantityKindFromLocalnameRequired("LorenzCoefficient"),
  // Molar Equivalent
  Equivalent_Molar: Qudt.quantityKindFromLocalnameRequired("Equivalent_Molar"),
  // Einstein transition probability for spontaneous or induced emission and absorption
  EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption:
    Qudt.quantityKindFromLocalnameRequired(
      "EinsteinTransitionProbabilityForSpontaneousOrInducedEmissionAndAbsorption"
    ),
  // Elevation relative to NAP
  ElevationRelativeToNAP: Qudt.quantityKindFromLocalnameRequired(
    "ElevationRelativeToNAP"
  ),
  // Curvature
  Curvature: Qudt.quantityKindFromLocalnameRequired("Curvature"),
  // اختلاف طور
  PhaseDifference: Qudt.quantityKindFromLocalnameRequired("PhaseDifference"),
  // Positive Dimensionless Ratio
  NormalizedDimensionlessRatio: Qudt.quantityKindFromLocalnameRequired(
    "NormalizedDimensionlessRatio"
  ),
  // Relative Luminous Flux
  RelativeLuminousFlux: Qudt.quantityKindFromLocalnameRequired(
    "RelativeLuminousFlux"
  ),
  // Mass Margin
  MASS__MARGIN: Qudt.quantityKindFromLocalnameRequired("MASS-MARGIN"),
  // Mass Number
  MassNumber: Qudt.quantityKindFromLocalnameRequired("MassNumber"),
  // Work Function
  WorkFunction: Qudt.quantityKindFromLocalnameRequired("WorkFunction"),
  // Diastolic Blood Pressure
  DiastolicBloodPressure: Qudt.quantityKindFromLocalnameRequired(
    "DiastolicBloodPressure"
  ),
  // Specific Heat Capacity at Saturation
  SpecificHeatCapacityAtSaturation: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatCapacityAtSaturation"
  ),
  // Mass Defect
  MassDefect: Qudt.quantityKindFromLocalnameRequired("MassDefect"),
  // pressure gradient
  PressureGradient: Qudt.quantityKindFromLocalnameRequired("PressureGradient"),
  // temperature-based volume flow rate
  TemperatureBasedVolumeFlowRate: Qudt.quantityKindFromLocalnameRequired(
    "TemperatureBasedVolumeFlowRate"
  ),
  // magnetic dipole moment of a molecule
  MagneticDipoleMomentOfAMolecule: Qudt.quantityKindFromLocalnameRequired(
    "MagneticDipoleMomentOfAMolecule"
  ),
  // pressure in relation to volume flow
  PressureInRelationToVolumeFlow: Qudt.quantityKindFromLocalnameRequired(
    "PressureInRelationToVolumeFlow"
  ),
  // Berat
  Weight: Qudt.quantityKindFromLocalnameRequired("Weight"),
  // Electric charge per area
  ElectricChargePerArea: Qudt.quantityKindFromLocalnameRequired(
    "ElectricChargePerArea"
  ),
  // mass-related electrical current
  MassRelatedElectricalCurrent: Qudt.quantityKindFromLocalnameRequired(
    "MassRelatedElectricalCurrent"
  ),
  // Specific heat capacity at constant volume
  SpecificHeatCapacityAtConstantVolume: Qudt.quantityKindFromLocalnameRequired(
    "SpecificHeatCapacityAtConstantVolume"
  ),
  // CountRate
  CountRate: Qudt.quantityKindFromLocalnameRequired("CountRate"),
  // current of the amount of subtance
  CurrentOfTheAmountOfSubtance: Qudt.quantityKindFromLocalnameRequired(
    "CurrentOfTheAmountOfSubtance"
  ),
  // Neel Temperature
  NeelTemperature: Qudt.quantityKindFromLocalnameRequired("NeelTemperature"),
  // Characteristic Acoustic Impedance
  CharacteristicAcousticImpedance: Qudt.quantityKindFromLocalnameRequired(
    "CharacteristicAcousticImpedance"
  ),
  // Fuel Bias
  FUEL__BIAS: Qudt.quantityKindFromLocalnameRequired("FUEL-BIAS"),
  // Specific Acoustic Impedance
  SpecificAcousticImpedance: Qudt.quantityKindFromLocalnameRequired(
    "SpecificAcousticImpedance"
  ),
  // Volume Flow Rate
  VolumeFlowRate: Qudt.quantityKindFromLocalnameRequired("VolumeFlowRate"),
};

// Prefixes
{
  let prefix: Prefix;
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Atto",
    new Decimal("1.0E-18"),
    "a",
    "a",
    undefined
  );
  prefix.addLabel(new LangString("Atto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Atto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Centi",
    new Decimal("0.010"),
    "c",
    "c",
    undefined
  );
  prefix.addLabel(new LangString("Centi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Centi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Deca",
    new Decimal("10"),
    "da",
    "da",
    undefined
  );
  prefix.addLabel(new LangString("Deca", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Deca", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Deci",
    new Decimal("0.10"),
    "d",
    "d",
    undefined
  );
  prefix.addLabel(new LangString("Deci", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Deci", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Deka",
    new Decimal("10"),
    "da",
    "da",
    undefined
  );
  prefix.addLabel(new LangString("Deka", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Deka", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Exa",
    new Decimal("1.0E+18"),
    "E",
    "E",
    undefined
  );
  prefix.addLabel(new LangString("Exa", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Exa", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Exbi",
    new Decimal("152921504606846976"),
    "Ei",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Exbi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Exbi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Femto",
    new Decimal("1.0E-15"),
    "f",
    "f",
    undefined
  );
  prefix.addLabel(new LangString("Femto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Femto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Gibi",
    new Decimal("1073741824"),
    "Gi",
    "Gi",
    undefined
  );
  prefix.addLabel(new LangString("Gibi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Gibi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Giga",
    new Decimal("1.0E+9"),
    "G",
    "G",
    undefined
  );
  prefix.addLabel(new LangString("Giga", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Giga", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Hecto",
    new Decimal("1.0E+2"),
    "h",
    "h",
    undefined
  );
  prefix.addLabel(new LangString("Hecto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Hecto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Kibi",
    new Decimal("1024"),
    "Ki",
    "Ki",
    undefined
  );
  prefix.addLabel(new LangString("Kibi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Kibi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Kilo",
    new Decimal("1.0E+3"),
    "k",
    "k",
    undefined
  );
  prefix.addLabel(new LangString("Kilo", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Kilo", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Mebi",
    new Decimal("1048576"),
    "Mi",
    "Mi",
    undefined
  );
  prefix.addLabel(new LangString("Mebi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Mebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Mega",
    new Decimal("1.0E+6"),
    "M",
    "M",
    undefined
  );
  prefix.addLabel(new LangString("Mega", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Mega", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Micro",
    new Decimal("0.0000010"),
    "μ",
    "u",
    undefined
  );
  prefix.addLabel(new LangString("Micro", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Micro", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Milli",
    new Decimal("0.0010"),
    "m",
    "m",
    undefined
  );
  prefix.addLabel(new LangString("Milli", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Milli", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Nano",
    new Decimal("1.0E-9"),
    "n",
    "n",
    undefined
  );
  prefix.addLabel(new LangString("Nano", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Nano", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Pebi",
    new Decimal("125899906842624"),
    "Pi",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Pebi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Pebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Peta",
    new Decimal("1.0E+15"),
    "P",
    "P",
    undefined
  );
  prefix.addLabel(new LangString("Peta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Peta", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Pico",
    new Decimal("1.0E-12"),
    "p",
    "p",
    undefined
  );
  prefix.addLabel(new LangString("Pico", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Pico", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Quecto",
    new Decimal("1.0E-30"),
    "q",
    "q",
    undefined
  );
  prefix.addLabel(new LangString("Quecto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Quecto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Quetta",
    new Decimal("1.0E+30"),
    "Q",
    "Q",
    undefined
  );
  prefix.addLabel(new LangString("Quetta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Quetta", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Ronna",
    new Decimal("1.0E+27"),
    "R",
    "R",
    undefined
  );
  prefix.addLabel(new LangString("Ronna", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Ronna", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Ronto",
    new Decimal("1.0E-27"),
    "r",
    "r",
    undefined
  );
  prefix.addLabel(new LangString("Ronto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Ronto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Tebi",
    new Decimal("1099511627776"),
    "Ti",
    "Ti",
    undefined
  );
  prefix.addLabel(new LangString("Tebi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Tebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Tera",
    new Decimal("1.0E+12"),
    "T",
    "T",
    undefined
  );
  prefix.addLabel(new LangString("Tera", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Tera", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Yobi",
    new Decimal("1208925819614629174706176"),
    "Yi",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Yobi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Yobi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Yocto",
    new Decimal("1.0E-24"),
    "y",
    "y",
    undefined
  );
  prefix.addLabel(new LangString("Yocto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Yocto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Yotta",
    new Decimal("1.0E+24"),
    "Y",
    "Y",
    undefined
  );
  prefix.addLabel(new LangString("Yotta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Yotta", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Zebi",
    new Decimal("1180591620717411303424"),
    "Zi",
    undefined,
    undefined
  );
  prefix.addLabel(new LangString("Zebi", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Zebi", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Zepto",
    new Decimal("1.0E-21"),
    "z",
    "z",
    undefined
  );
  prefix.addLabel(new LangString("Zepto", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Zepto", prefix);
  prefix = new Prefix(
    "http://qudt.org/vocab/prefix/Zetta",
    new Decimal("1.0E+21"),
    "Z",
    "Z",
    undefined
  );
  prefix.addLabel(new LangString("Zetta", "en"));
  config.prefixes.set("http://qudt.org/vocab/prefix/Zetta", prefix);
}

export const Prefixes = {
  // Kibi
  Kibi: Qudt.prefixFromLocalnameRequired("Kibi"),
  // Milli
  Milli: Qudt.prefixFromLocalnameRequired("Milli"),
  // Yocto
  Yocto: Qudt.prefixFromLocalnameRequired("Yocto"),
  // Exa
  Exa: Qudt.prefixFromLocalnameRequired("Exa"),
  // Zetta
  Zetta: Qudt.prefixFromLocalnameRequired("Zetta"),
  // Gibi
  Gibi: Qudt.prefixFromLocalnameRequired("Gibi"),
  // Mega
  Mega: Qudt.prefixFromLocalnameRequired("Mega"),
  // Pebi
  Pebi: Qudt.prefixFromLocalnameRequired("Pebi"),
  // Deka
  Deka: Qudt.prefixFromLocalnameRequired("Deka"),
  // Kilo
  Kilo: Qudt.prefixFromLocalnameRequired("Kilo"),
  // Atto
  Atto: Qudt.prefixFromLocalnameRequired("Atto"),
  // Centi
  Centi: Qudt.prefixFromLocalnameRequired("Centi"),
  // Hecto
  Hecto: Qudt.prefixFromLocalnameRequired("Hecto"),
  // Quetta
  Quetta: Qudt.prefixFromLocalnameRequired("Quetta"),
  // Zebi
  Zebi: Qudt.prefixFromLocalnameRequired("Zebi"),
  // Tebi
  Tebi: Qudt.prefixFromLocalnameRequired("Tebi"),
  // Tera
  Tera: Qudt.prefixFromLocalnameRequired("Tera"),
  // Yobi
  Yobi: Qudt.prefixFromLocalnameRequired("Yobi"),
  // Quecto
  Quecto: Qudt.prefixFromLocalnameRequired("Quecto"),
  // Micro
  Micro: Qudt.prefixFromLocalnameRequired("Micro"),
  // Pico
  Pico: Qudt.prefixFromLocalnameRequired("Pico"),
  // Ronna
  Ronna: Qudt.prefixFromLocalnameRequired("Ronna"),
  // Yotta
  Yotta: Qudt.prefixFromLocalnameRequired("Yotta"),
  // Deca
  Deca: Qudt.prefixFromLocalnameRequired("Deca"),
  // Deci
  Deci: Qudt.prefixFromLocalnameRequired("Deci"),
  // Mebi
  Mebi: Qudt.prefixFromLocalnameRequired("Mebi"),
  // Giga
  Giga: Qudt.prefixFromLocalnameRequired("Giga"),
  // Exbi
  Exbi: Qudt.prefixFromLocalnameRequired("Exbi"),
  // Femto
  Femto: Qudt.prefixFromLocalnameRequired("Femto"),
  // Nano
  Nano: Qudt.prefixFromLocalnameRequired("Nano"),
  // Ronto
  Ronto: Qudt.prefixFromLocalnameRequired("Ronto"),
  // Peta
  Peta: Qudt.prefixFromLocalnameRequired("Peta"),
  // Zepto
  Zepto: Qudt.prefixFromLocalnameRequired("Zepto"),
};

// systemsOfUnit
{
  let systemOfUnits: SystemOfUnits;
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/ASU",
    [new LangString("Astronomic System Of Units", "en")],
    undefined,
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/ASU", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS",
    [new LangString("CGS System of Units", "en")],
    "CGS",
    [
      "http://qudt.org/vocab/unit/CentiM",
      "http://qudt.org/vocab/unit/GM",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/CGS", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS-EMU",
    [new LangString("CGS System of Units - EMU", "en")],
    "CGS-EMU",
    [
      "http://qudt.org/vocab/unit/CentiM",
      "http://qudt.org/vocab/unit/BIOT",
      "http://qudt.org/vocab/unit/GM",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/CGS-EMU", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS-ESU",
    [new LangString("CGS System of Units ESU", "en")],
    "CGS-ESU",
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/CGS-ESU", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/CGS-GAUSS",
    [new LangString("CGS System of Units - Gaussian", "en")],
    "CGS-GAUSS",
    [
      "http://qudt.org/vocab/unit/CentiM",
      "http://qudt.org/vocab/unit/GM",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/CGS-GAUSS",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/IMPERIAL",
    [new LangString("Imperial System of Units", "en")],
    "Imperial",
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/IMPERIAL",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/PLANCK",
    [new LangString("Planck System of Units", "en")],
    "PLANCK",
    [
      "http://qudt.org/vocab/unit/PlanckLength",
      "http://qudt.org/vocab/unit/PlanckTemperature",
      "http://qudt.org/vocab/unit/PlanckTime",
      "http://qudt.org/vocab/unit/PlanckCharge",
      "http://qudt.org/vocab/unit/PlanckMass",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/PLANCK", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SI",
    [new LangString("International System of Units", "en")],
    "SI",
    [
      "http://qudt.org/vocab/unit/A",
      "http://qudt.org/vocab/unit/CD",
      "http://qudt.org/vocab/unit/KiloGM",
      "http://qudt.org/vocab/unit/M",
      "http://qudt.org/vocab/unit/MOL",
      "http://qudt.org/vocab/unit/K",
      "http://qudt.org/vocab/unit/SEC",
      "http://qudt.org/vocab/unit/UNITLESS",
    ]
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/SI", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_ASU",
    [
      new LangString(
        "Astronomical System of Units (deprecated URI)",
        undefined
      ),
    ],
    undefined,
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/SOU_ASU", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_CGS",
    [new LangString("CGS System of Units (deprecated URI)", undefined)],
    undefined,
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/SOU_CGS", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_CGS-EMU",
    [new LangString("CGS-EMU System of Units (deprecated URI)", undefined)],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/SOU_CGS-EMU",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_CGS-ESU",
    [new LangString("CGS-ESU System of Units (deprecated URI)", undefined)],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/SOU_CGS-ESU",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_CGS-GAUSS",
    [new LangString("CGS-Gauss System of Units (deprecated URI)", undefined)],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/SOU_CGS-GAUSS",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_IMPERIAL",
    [new LangString("Imperial System of Units (deprecated URI)", undefined)],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/SOU_IMPERIAL",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_PLANCK",
    [new LangString("Planck System of Units (deprecated URI)", undefined)],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/SOU_PLANCK",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_SI",
    [new LangString("SI System of Units (deprecated URI)", undefined)],
    undefined,
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/SOU_SI", systemOfUnits);
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/SOU_USCS",
    [
      new LangString(
        "US Customary System of Units (deprecated URI)",
        undefined
      ),
    ],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/SOU_USCS",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/UNSTATED",
    [new LangString("Unstated System Of Units", "en")],
    undefined,
    []
  );
  config.systemsOfUnits.set(
    "http://qudt.org/vocab/sou/UNSTATED",
    systemOfUnits
  );
  systemOfUnits = new SystemOfUnits(
    "http://qudt.org/vocab/sou/USCS",
    [new LangString("US Customary Unit System", "en")],
    "US Customary",
    []
  );
  config.systemsOfUnits.set("http://qudt.org/vocab/sou/USCS", systemOfUnits);
}

export const SystemsOfUnits = {
  // CGS System of Units
  CGS: Qudt.systemOfUnitsFromLocalnameRequired("CGS"),
  // CGS System of Units ESU
  CGS__ESU: Qudt.systemOfUnitsFromLocalnameRequired("CGS-ESU"),
  // Imperial System of Units (deprecated URI)
  SOU_IMPERIAL: Qudt.systemOfUnitsFromLocalnameRequired("SOU_IMPERIAL"),
  // CGS System of Units - EMU
  CGS__EMU: Qudt.systemOfUnitsFromLocalnameRequired("CGS-EMU"),
  // CGS-ESU System of Units (deprecated URI)
  SOU_CGS__ESU: Qudt.systemOfUnitsFromLocalnameRequired("SOU_CGS-ESU"),
  // Planck System of Units (deprecated URI)
  SOU_PLANCK: Qudt.systemOfUnitsFromLocalnameRequired("SOU_PLANCK"),
  // CGS System of Units - Gaussian
  CGS__GAUSS: Qudt.systemOfUnitsFromLocalnameRequired("CGS-GAUSS"),
  // Unstated System Of Units
  UNSTATED: Qudt.systemOfUnitsFromLocalnameRequired("UNSTATED"),
  // CGS-Gauss System of Units (deprecated URI)
  SOU_CGS__GAUSS: Qudt.systemOfUnitsFromLocalnameRequired("SOU_CGS-GAUSS"),
  // US Customary System of Units (deprecated URI)
  SOU_USCS: Qudt.systemOfUnitsFromLocalnameRequired("SOU_USCS"),
  // Astronomic System Of Units
  ASU: Qudt.systemOfUnitsFromLocalnameRequired("ASU"),
  // Planck System of Units
  PLANCK: Qudt.systemOfUnitsFromLocalnameRequired("PLANCK"),
  // Imperial System of Units
  IMPERIAL: Qudt.systemOfUnitsFromLocalnameRequired("IMPERIAL"),
  // International System of Units
  SI: Qudt.systemOfUnitsFromLocalnameRequired("SI"),
  // CGS System of Units (deprecated URI)
  SOU_CGS: Qudt.systemOfUnitsFromLocalnameRequired("SOU_CGS"),
  // US Customary Unit System
  USCS: Qudt.systemOfUnitsFromLocalnameRequired("USCS"),
  // CGS-EMU System of Units (deprecated URI)
  SOU_CGS__EMU: Qudt.systemOfUnitsFromLocalnameRequired("SOU_CGS-EMU"),
  // Astronomical System of Units (deprecated URI)
  SOU_ASU: Qudt.systemOfUnitsFromLocalnameRequired("SOU_ASU"),
  // SI System of Units (deprecated URI)
  SOU_SI: Qudt.systemOfUnitsFromLocalnameRequired("SOU_SI"),
};

function getPrefix(iri: string): Prefix {
  const prefix: Prefix | undefined = config.prefixes.get(iri);
  if (!prefix) {
    throw `prefix ${iri} referenced but not loaded`;
  }
  return prefix;
}

function getUnit(iri: string): Unit {
  const unit: Unit | undefined = config.units.get(iri);
  if (!unit) {
    throw `unit ${iri} referenced but not loaded`;
  }
  return unit;
}

function getQuantityKind(iri: string): QuantityKind {
  const quantityKind: QuantityKind | undefined = config.quantityKinds.get(iri);
  if (!quantityKind) {
    throw `quantityKind ${iri} referenced but not loaded`;
  }
  return quantityKind;
}

// Connect objects
for (const unit of config.units.values()) {
  !!unit.prefixIri && unit.setPrefix(getPrefix(unit.prefixIri));
  !!unit.scalingOfIri && unit.setScalingOf(getUnit(unit.scalingOfIri));
  for (const qkIri of unit.quantityKindIris) {
    unit.addQuantityKind(getQuantityKind(qkIri));
  }
}

// Set factor units

{
  let unit: Unit;
  unit = getUnit("http://qudt.org/vocab/currency/AED");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/AED"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/AFN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/AFN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ALL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ALL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/AMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/AMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ANG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ANG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/AOA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/AOA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ARS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ARS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/AUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/AUD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/AWG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/AWG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/AZN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/AZN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BAM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BAM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BBD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BBD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BDT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BDT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BGN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BGN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BHD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BHD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BIF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BIF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BND"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BOB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BOB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BOV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BOV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BRL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BRL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BSD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BSD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BTN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BTN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BWP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BWP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BYN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BYN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/BZD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/BZD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CDF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CDF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CHE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CHE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CHF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CHF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CHW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CHW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CLF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CLF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CLP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CLP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CNY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CNY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/COP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/COP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/COU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/COU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CRC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CRC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CUP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CUP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CVE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CVE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CYP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CYP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/CZK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/CZK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/DJF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/DJF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/DKK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/DKK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/DOP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/DOP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/DZD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/DZD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/EEK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/EEK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/EGP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/EGP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ERN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ERN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ETB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ETB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/EUR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/EUR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/FJD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/FJD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/FKP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/FKP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GBP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GBP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GEL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GEL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GHS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GHS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GIP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GIP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GNF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GNF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GTQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GTQ"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/GYD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/GYD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/HKD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/HKD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/HNL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/HNL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/HRK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/HRK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/HTG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/HTG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/HUF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/HUF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/IDR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/IDR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ILS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ILS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/INR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/INR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/IQD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/IQD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/IRR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/IRR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ISK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ISK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/JMD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/JMD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/JOD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/JOD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/JPY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/JPY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KES");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KES"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KGS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KGS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KHR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KHR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KMF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KMF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KPW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KPW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KRW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KRW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KWD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KWD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KYD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KYD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/KZT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/KZT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LAK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LAK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LBP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LBP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LKR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LKR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LRD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LRD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LSL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LSL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LTL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LTL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LVL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LVL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/LYD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/LYD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MDL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MDL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MGA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MGA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MKD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MKD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MMK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MMK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MNT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MNT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MOP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MOP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MRU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MRU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MTL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MTL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MUR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MUR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MVR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MVR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MWK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MWK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MXN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MXN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MXV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MXV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MYR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MYR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MZN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MZN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/MegaUSD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/MegaUSD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/NAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/NAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/NGN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/NGN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/NIO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/NIO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/NOK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/NOK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/NPR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/NPR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/NZD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/NZD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/OMR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/OMR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/PAB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/PAB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/PEN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/PEN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/PGK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/PGK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/PHP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/PHP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/PKR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/PKR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/PLN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/PLN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/PYG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/PYG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/QAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/QAR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/RON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/RON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/RSD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/RSD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/RUB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/RUB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/RWF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/RWF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SAR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SBD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SBD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SCR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SCR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SDG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SDG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SEK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SEK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SGD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SGD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SHP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SHP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SKK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SKK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SOS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SOS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SRD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SRD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/STN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/STN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SYP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SYP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/SZL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/SZL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/THB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/THB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TJS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TJS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TMT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TMT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TND"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TOP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TOP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TRY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TTD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TTD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TWD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TWD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/TZS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/TZS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/UAH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/UAH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/UGX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/UGX"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/USD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/USD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/USN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/USN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/USS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/USS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/UYU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/UYU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/UZS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/UZS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/VES");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/VES"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/VND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/VND"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/VUV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/VUV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/WST");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/WST"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XAF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XAF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XAG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XAG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XAU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XAU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XBA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XBA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XBB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XBB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XBC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XBC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XBD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XBD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XCD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XCD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XDR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XDR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XFO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XFO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XFU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XFU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XOF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XOF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XPD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XPD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XPF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XPF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/XPT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/XPT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/YER");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/YER"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ZAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ZAR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ZMW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ZMW"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/currency/ZWL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/currency/ZWL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/1000000I");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/1000000I"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/1000I");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/1000I"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/100KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/100KiloCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/10KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/10KiloCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/2PiRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/2PiRAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-HR-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-M2-PER-J-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-M2-K2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("4046.8564224")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AC-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AC-FT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT_US"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AMU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1.66053878283E-27")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ANGSTROM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ANGSTROM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ANGSTROM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ARCMIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARCMIN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ARCSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARCSEC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ARE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("100.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AT-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("101325.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM-M3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM_T");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("98066.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ATM_T-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM_T"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("149597870691.6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AWG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/AWG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Ab-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Ab-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("3.335641E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/A_Stat-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1.0E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoJ-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/AttoJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/AttoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1.0E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/B");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/B"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/B-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/B"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("100000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("1E-28")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN-PER-EV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BARN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BARN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARN-PER-SR-EV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BARN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BARYE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BAUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAUD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1591132")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_UK_PET-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_UK_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1589873")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.1156281989625")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_PET");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US_PET"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_PET-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BBL_US_PET-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BBL_US_PET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BEAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BEAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BEAT-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BEAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BFT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BFT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIOT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BQ-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BREATH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BREATH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BREATH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BREATH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BREWSTER");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BREWSTER"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_39DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_39DEG_F"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_59DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_59DEG_F"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_60DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_60DEG_F"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055.05585262")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-FT-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-IN-PER-SEC-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-HR-FT2-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-IN2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-LB_F-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-MOL-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-MOL_LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_IT-PER-SEC-FT2-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_MEAN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055.05585262")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1054.3502645")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-FT-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-FT-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-IN-PER-FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-HR-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-LB-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BTU_TH-PER-SEC-FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.03636872")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3)],
      new Decimal("2150.42")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BU_US_DRY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/BYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-M2-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-KiloGM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C-PER-MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C2-M2-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C3-M-PER-J2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C4-M4-PER-J3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 4),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 4),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_15_DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.1855")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_20DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_20DEG_C"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.1868")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_IT-PER-SEC-CentiM2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_MEAN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.184")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM-SEC-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-G");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/G"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CAL_TH-PER-SEC-CentiM2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CARAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0002")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CASES");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CASES"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CASES-PER-1000I-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CASES"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/1000I"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CASES-PER-KiloINDIV-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CASES"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloINDIV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-KiloLM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-LM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CD_IN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD_IN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CFU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CFU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("20.1168")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CHAIN_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CHAIN_US"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CHF-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/currency/CHF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CI-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CLO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2-K-PER-W"), 1)],
      new Decimal("0.155")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CM_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("98.0665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CORD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("3.62")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CUP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00023658825")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CUP_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00023658825")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CWT_LONG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("50.80235")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CWT_SHORT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("45.359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CYC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CYC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CYC-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CYC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("10.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Ab-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("3.3356409519815204957557671447492E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Stat-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/C_Stat-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-KiloYR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloYR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM-SEC-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-ERG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-SR-ERG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-PER-V-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-MOL-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM3-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM6");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 6)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_H20_4DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/CentiM_H20_4DEG_C"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("98.0665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/CentiM_H2O_4DEG_C"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1333.224")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiM_HG_0DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/CentiM_HG_0DEG_C"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiPOISE-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiPOISE-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/CentiST");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1)],
      new Decimal("0.010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Ci");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("37000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DARCY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("9.869233E-13")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("86400.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DAY_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("86164.099")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS-PER-1000000I-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/1000000I"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS-PER-1000I-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/1000I"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS-PER-KiloINDIV-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloINDIV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEATHS-PER-MegaINDIV-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEATHS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaINDIV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DECADE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DECADE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.0174532925")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_API");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_API"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BALLING");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_BALLING"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_HEAVY"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEGREE_BAUME_US_LIGHT"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_BRIX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_BRIX"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_OECHSLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_OECHSLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_PLATO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE_PLATO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEGREE_TWADDELL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEGREE_TWADDELL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-KiloGM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/DEG_C_GROWING_CEREAL"),
          1
        ),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("0.5555555555555556")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_IT-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-FT2-PER-BTU_TH-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-HR-PER-BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_F-SEC-PER-BTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("0.5555555555555556")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DEG_R-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DIOPTER");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PER-M"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DPI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DRAM_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0017718451953125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DRAM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0038879346")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DWT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00155517384")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DYN-SEC-PER-CentiM5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DYN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Da");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1.66053878283E-27")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Debye");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C-M"), 1)],
      new Decimal("3.33564E-30")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaARE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARE"), 1)],
      new Decimal("10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaKiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaKiloCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DecaPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1)],
      new Decimal("10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/B"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-MilliW");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-MilliW-PER-MegaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciBAR-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_A"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_C"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_ISO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_ISO"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_M"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciB_Z");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciB_Z"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciM3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciTONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/DeciTON_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1)],
      new Decimal("0.10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Denier");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM"), 1)],
      new Decimal("1.1E-7")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/E");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("1.602176634E-19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ENZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ENZ"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ENZ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ENZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-CentiM2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-G");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/G"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-GM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERG-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ERLANG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ERLANG"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EU-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EU"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EUR-PER-KiloW");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/currency/EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EUR-PER-KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/currency/EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EUR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/currency/EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EUR-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/currency/EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EUR-PER-W-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/currency/EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EUR-PER-W-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/currency/EUR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.602176634E-19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-ANGSTROM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ANGSTROM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EV-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/E_h");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4.35974394E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/EarthMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("5972190000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ElementaryCharge");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.602176634E-19")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaBIT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1.0E+18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E+18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E+18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExbiBIT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExbiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExbiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ExbiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ExbiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("152921504606846976")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("96485.3399")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FA"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD_Ab-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FARAD_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1.112650056053618432174089964848E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FATH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.8288")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FBM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00236")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD-PER-M2"), 1)],
      new Decimal("10.764")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FLIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLIGHT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("3.3356409519815204957557671447492E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FRACTION");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FRACTION"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FRAME");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FRAME"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FRAME-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FRAME"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1)],
      new Decimal("12.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-HR-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-HR-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-HR-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LA"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-FT2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PDL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-SEC-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT-SEC-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-HR-DEG_F-PER-BTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-PER-BTU_IT-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT2-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-MIN-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("2989.067")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/FT_H2O_39dot2DEG_F"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("40636.66")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.3048006")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FUR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("201.168")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FUR_Long");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FUR_Long"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/FemtoV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1.0E-15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Flight");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/Flight"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/G");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("9.80665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GALILEO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_IMP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00454609")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("4.54609")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3)],
      new Decimal("231")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAL_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BU_US"), 1)],
      new Decimal("0.125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAUGE_FR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0003333333")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GAUSS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GA_Charriere");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GA_Charriere"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("0.795774715")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0001420653")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.000118294125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GI_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-CentiM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-HR-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MIN-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM2-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-L-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-M3-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliL-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliL-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM-SEC-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Carbon");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Carbon"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Carbon-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Carbon"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_DRY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00980665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_F-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Nitrogen");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Nitrogen"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GM_Nitrogen-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_Nitrogen"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00006479891")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN-PER-GAL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAIN-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Gamma");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1073741824")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GibiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1073741824")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaBYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaBasePair");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaBasePair"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaEV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaFLOPS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaHZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaPA-CentiM3-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E+9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/GigaW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Gs");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H-PER-KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("10000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HART");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HART"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HART-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HART"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("745.6999")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Boiler");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("9809.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Brake");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("9809.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Electric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("746.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("746.043")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HP_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("735.4988")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("3600.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HR_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("3590.17")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HZ-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("898760000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/H_Stat-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/H_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HeartBeat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HeartBeat"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("1.0E+2")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+2")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1.0E+2")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoKiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoKiloCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1.0E+2")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.0E+2")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1.0E+2")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/HectoPA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Hundredweight_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("50.80235")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Hundredweight_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("45.359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0254")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PDL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-2PiRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/2PiRAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("249.080024")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/IN_H2O_39dot2DEG_F"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_H2O_60DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN_H2O_60DEG_F"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("3386.389")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_HG_32DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN_HG_32DEG_F"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IN_HG_60DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN_HG_60DEG_F"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/IU-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IU"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-M-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-CentiM2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-K-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-KiloGM-K-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-M4");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -4),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-MOL-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-PER-T2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/J-SEC-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-M2-PER-KiloGM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PA-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/K2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KAT-PER-MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KIP_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KIP_F-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KIP_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_N"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KN-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1024")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KibiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KibiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1024")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Kilo-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("28.316846592")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloA-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBAUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAUD"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_IT"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_IT-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_IT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BTU_TH"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBTU_TH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBTU_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloBYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloBYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4184.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM-SEC-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-GM-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-MOL-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_IT"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_IT-PER-GM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_IT-PER-HR-M-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_Mean");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4190.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CAL_TH"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCAL_TH-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_TH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCi");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/Ci"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCount"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloCubicFT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCubicFT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloEV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloEV-PER-MicroM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGAUSS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAUSS"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-CentiM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-M2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-CentiM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-DeciM3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-GigaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaJ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-KiloMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-L-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-L-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MegaBTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBTU_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-PA-SEC-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-SEC3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_F"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-M-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGM_F-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloHZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloINDIV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloINDIV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-KiloV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-FT-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLB_F-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloLB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloLM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloM3-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMIL_Circ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIL_Circ"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloMOL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-DEG-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloN-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/P"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-M2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPA_A");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloPOND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POND"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/R"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloTONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloTONNE-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloTONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloTON_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A_Reactive-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-HR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-PER-M-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-PER-M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloW-PER-M2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloWB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloWB-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloWB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/KiloYR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), 1)],
      new Decimal("1.0E+3")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM3"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MOL-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-MicroMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/L-PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("0.31830988618")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LANGLEY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LANGLEY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LA_FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("0.31830988618")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.45359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-DEG_R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_R"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2-PER-GAL_UK-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2-PER-GAL_US-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-FT2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-FT6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_UK2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-GAL_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-HR-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-FT3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-GAL_UK-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-GAL_US-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-IN2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-FT6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_UK2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-GAL_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MIN-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-MOL-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT3-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-FT3-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-GAL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-HR-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN3-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-IN3-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-MIN-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-MIN-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-SEC-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-SEC-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-YD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-YD2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-FT6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_UK2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-GAL_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB-SEC-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-FT-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-IN-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN2-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-IN2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-PER-YD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-SEC-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_F-SEC-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.45359237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LB_T");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.3732417216")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LUX");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LUX-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LUX"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LUX-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LUX"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("9460730472580800.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/LunarMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("73460000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-K-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PA-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-DEG_C-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-FARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-V-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M0dot");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0dot"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M0pt");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0pt"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HR-DEG_C-PER-KiloCAL_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCAL_IT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-HZ4");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 4),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-K-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-GM_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM_DRY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HZ");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HZ-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-HZ2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-KiloW");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloW"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-N");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-SR-J");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-V-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-PER-W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-SEC-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-KiloGM-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-MOL-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M3-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M4-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 4),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M5");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 5)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M6");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 6)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MACH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MACH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MDOLLAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MDOLLAR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MDOLLAR-PER-FLIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MDOLLAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLIGHT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MESH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MESH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MHO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MHO_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S-PER-M"), 1)],
      new Decimal("1.1126500561E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1609.344")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MILLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MILLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIL_Circ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("5.067075E-10")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("60.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN_Angle");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN_Angle"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MIN_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("59.83617")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_N");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1852.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_N-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_N-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_UK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_UK3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_UK"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1609.347")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_US-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MI_US2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI_US"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("2551442.976")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOHM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-DeciM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-GM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-KiloGM-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-L-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-L-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-M-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M2-SEC-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL-PER-TONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("453.59237")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOL_LB-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL_LB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOMME_Pearl");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOMME_Pearl"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MOMME_Textile");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOMME_Textile"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO_MeanGREGORIAN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/MO_MeanGREGORIAN"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO_MeanJulian");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO_MeanJulian"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MO_Synodic");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO_Synodic"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("1E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/M_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M_H2O"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1048576")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MebiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1048576")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaA-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBAUD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAUD"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBTU_IT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBTU_IT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBTU_IT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBTU_IT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaBYTE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaBYTE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US-PER-FLIGHT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaDOLLAR_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FLIGHT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV-FemtoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FemtoM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaEV-PER-SpeedOfLight");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaEV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SpeedOfLight"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaFLOPS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaHZ-PER-T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaHZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaINDIV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaINDIV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaLB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-M0dot5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0dot"), 5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-M0pt5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0pt"), 5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaPSI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaTOE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TOE"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaTON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaTONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-A_Reactive-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MegaYR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), 1)],
      new Decimal("1.0E+6")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Megahertz");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/Megahertz"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Megahertz-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/Megahertz"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroATM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ATM"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroBQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroCi");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/Ci"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroFARAD-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroFARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/G"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroG-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGAL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGAL-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-CentiM2-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroGRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH-PER-KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroH-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroKAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-L-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-N");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroM3-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMHO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MHO"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-GM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-GM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-MicroMOL-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroMOL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroOHM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroS-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroSV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroTORR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TORR"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("0.0000010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MicroW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilLength");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0000254")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-HR-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-IN2-PER-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-L-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-LB_F-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliARCSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARCSEC"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBAR-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBAR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliBQ-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliCD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliCi");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/Ci"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliDARCY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DARCY"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliDEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/G"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GALILEO"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGAL-PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGAL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-HR-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-MIN-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-L-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-L2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M3-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGM-SEC-PER-M6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GRAY"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliGRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliH-PER-KiloOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloOHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliH-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliK-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliK-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliKAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-CentiM2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliL-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-DEG_C-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM2-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM3-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM4");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), 4)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-M3-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliMOL-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM_H2O");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("9.80665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM_HG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("133.322387415")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliM_HGA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliN-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliOHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-SEC-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliPA-SEC-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/R"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliRAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliRAD_R");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD_R"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliRAD_R-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliRAD_R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliR_man");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/R_man"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliS-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliSV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliTORR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TORR"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliV-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-CentiM2-MicroM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-M2-NanoM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliW-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MilliWB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("0.0010")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MillionUSD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MillionUSD"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/MillionUSD-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MillionUSD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-ARCMIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ARCMIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-DEG-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-M-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-MIN_Angle");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN_Angle"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-PER-W0dot5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W0dot"), -5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M-SEC-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M2-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-M2-PER-KiloGM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-MilliM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/N-SEC-PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NAT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NP"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NP-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NP"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NTU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NTU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-CentiM-KiloYR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloYR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-HectoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-KiloM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-NanoL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-PicoL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NUM-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NUM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoBQ-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoBQ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoFARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-CentiM2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-DeciL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DeciL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-M2-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-MicroL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGRAY"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoGRAY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoGRAY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoH-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoKAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM-PER-CentiM-MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM-PER-CentiM-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM-PER-MilliM-MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-CentiM3-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-GM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-L-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-MicroGM-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoMOL-PER-MicroMOL-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoN-M-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoOHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoOHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoS-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoSV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoSV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoSV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/NanoW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OCT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OCT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OCTET");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OCTET"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OCTET-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OCTET"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OERSTED");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-PER-M"), 1)],
      new Decimal("79.5774715")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OERSTED-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OERSTED"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-M2-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM-PER-MI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1E-9")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_CIRC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM_CIRC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_CIRC-MIL-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM_CIRC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OHM_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("898760000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ONE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ONE-PER-ONE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ONE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1)],
      new Decimal("0.0625")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT-HR-PER-IN3-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT-SEC-PER-IN3-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-FT2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-HR-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-IN2-PER-IN3-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-MIN-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-GAL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-YD2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN3-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ-SEC-PER-IN6");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -6),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.278013875")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_F-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_F-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_F"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.028349523125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_TROY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.0311034768")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0000284130625")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0000295735296")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/OZ_VOL_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ_VOL_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/P");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00980665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M0dot5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0dot"), 5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M0pt5");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M0pt"), 5),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA2-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PA2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PARSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("30856780000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PCA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0042333")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.138254954376")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-SEC-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PDL-SEC-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PDL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-ANGSTROM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ANGSTROM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-EV-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-EV2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/EV"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-GigaEV2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GigaEV"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-H");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-J");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-J-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-J2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloGM-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloGM2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-KiloV-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloV"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-NanoM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M2-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MILLE-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MILLE"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MILLE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MILLE-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MILLE"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MegaK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaK"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MegaPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MegaPA"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MicroM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MicroMOL-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliGM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliM3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-MilliSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliSEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-OZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OZ"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PERCENT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PicoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoM"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-PlanckMass2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PlanckMass"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC-SR-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-T-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-T-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-TON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-TONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-V-A-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-WB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-FT-HR-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-FT-SEC-PER-LB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-FT2-PER-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-HR-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-IN2-PER-LB_F-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-MIN-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-100KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/100KiloCount"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-10KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/10KiloCount"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-CentiPOISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiPOISE"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DEG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DEGREE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEGREE"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DecaCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaCount"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DecaK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-DecaKiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DecaKiloCount"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HectoBAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoBAR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-HectoKiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/HectoKiloCount"),
          -1
        ),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-KiloCount");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloCount"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-MilliPA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliPA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-OHM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-PA-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-PERCENT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-WK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WK"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-CentiM3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-GAL_US");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-IN3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT-SEC-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERCENT_RH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERCENT_RH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERMEABILITY_EM_REL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERMEABILITY_EM_REL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERMEABILITY_REL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERMEABILITY_REL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERMITTIVITY_REL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERMITTIVITY_REL"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_0DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERM_0DEG_C"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_23DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PERM_23DEG_C"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC-PER-M"), 1)],
      new Decimal("8.68127E-11")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_Metric_0DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERM_Metric_0DEG_C"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_Metric_23DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/PERM_Metric_23DEG_C"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PERM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC-PER-M"), 1)],
      new Decimal("5.72135E-11")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PFERDESTAERKE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PFERDESTAERKE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PFUND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PFUND"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PHON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PHON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PHOT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD-PER-M2"), 1)],
      new Decimal("10000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00056826125")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1)],
      new Decimal("0.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1)],
      new Decimal("0.5")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PINT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PINT_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.000550610471")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PIXEL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PIXEL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.009092181")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00880976754")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PK_US_DRY-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PK_US_DRY"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC"),
          1
        ),
      ],
      new Decimal("0.1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POISE-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/POISE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/POND");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("0.00980665")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPB"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPQ"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTH"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTH-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTH"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTM-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTR"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PPTR_VOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PPTR_VOL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-IN3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-L-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-M3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSI-YD3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PSU");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSU"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0000254")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PT_BIG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("0.0003527778")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PebiBIT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PebiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("125899906842624")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Pennyweight");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.00155517384")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaFLOPS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PetaV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PetaW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E+15")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoA-PER-HectoPA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HectoPA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoA-PER-MicroMOL-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroMOL"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoFARAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FARAD"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoFARAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoFARAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoGM-PER-MilliL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoGM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/H"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoKAT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoKAT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoKAT-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoKAT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-L-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-L-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M-W-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M2-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoMOL-PER-M3-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoMOL"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoPA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoPA-PER-KiloM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoPA"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoS-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoS"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoW-PER-CentiM2-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PicoW-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PicoW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckArea");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2"), 1)],
      new Decimal("2.61223E-71")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckCharge");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-SEC"), 1)],
      new Decimal("1.87554587E-18")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckCurrent");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("34789000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckCurrentDensity");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A-PER-M2"), 1)],
      new Decimal(
        "133177400000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
      )
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckDensity");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM-PER-DeciM3"), 1)],
      new Decimal(
        "5155000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
      )
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckEnergy");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1956100000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckForce");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("121027000000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckFrequency");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("18548700000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckFrequency_Ang");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("18548000000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckImpedance");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("29.9792458")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckLength");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("1.616252E-35")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("2.17644E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckMomentum");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-M-PER-SEC"),
          1
        ),
      ],
      new Decimal("6.52485")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckPower");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("36283100000000000000000000000000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckPressure");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M-SEC2"),
          1
        ),
      ],
      new Decimal(
        "463309000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000.0"
      )
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckTemperature");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), 1)],
      new Decimal("141678400000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckTime");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("5.39124E-49")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckVolt");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1042950000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/PlanckVolume");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("4.22419E-105")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_UK"), 1)],
      new Decimal("0.25")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_UK-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GAL_US"), 1)],
      new Decimal("0.25")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/QT_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QT_US_DRY");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.001101220942715")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/QUAD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1055000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Quarter_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("12.70058636")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/R");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("0.000258")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/R-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/R"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-M2-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-M2-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAD_R");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RAYL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/KiloGM-PER-M2-SEC"),
          1
        ),
      ],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M2-PER-SEC2"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REM-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/REV-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/REV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RHE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RHE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ROD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1)],
      new Decimal("5.02921")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RPK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/RPK"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("2.8316846592")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/R_man");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1)],
      new Decimal("0.01")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/RichterMagnitude");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/RichterMagnitude"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S-M2-PER-MOL");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MOL"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/S"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SAMPLE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SAMPLE"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SAMPLE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SAMPLE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCF-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCF-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCF"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCM"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SCM-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SCM"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-M3-RAD");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC-PER-RAD-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/RAD"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SH");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("1E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SHANNON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SHANNON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SHANNON-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SHANNON"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB"), 1)],
      new Decimal("32.17405")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-FT3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SLUG-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SLUG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SON"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SPF");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SPF"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/SPIN_QUANTUM_NUMBER"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ST-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/ST"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/STILB");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/CD-PER-M2"), 1)],
      new Decimal("10000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/STR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("1.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_ELEC"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/SUSCEPTIBILITY_MAG"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SV-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S-PER-M"), 1)],
      new Decimal("1000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/S_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/S-PER-M"), 1)],
      new Decimal("1.1126500561E-12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SolarMass");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1988435000000000000000000000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/SpeedOfLight");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SpeedOfLight"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Standard");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("4.672")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Stone_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("6.35029318")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TBSP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.0000147867656")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TEX");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM-PER-MilliM"), 1)],
      new Decimal("0.000001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THERM_EC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/THERM_EC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THERM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/THERM_US"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THM_EEC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/THM_EEC"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THM_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("105480400.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/THM_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/THM_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TOE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("41868000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("907.18474")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HA-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-M3-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-MO");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MO"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TONNE-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TONNE"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Assay");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("0.02916667")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_FG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J-PER-SEC"), 1)],
      new Decimal("3516.853")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_FG-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_FG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_F_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/N"), 1)],
      new Decimal("8896.443230521")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_LONG");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1016.0469088")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_LONG-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_LONG"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-DAY-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HR-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-HR-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-M3-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-MIN-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Metric-PER-SEC-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Metric"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_Register");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_Register"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHIPPING_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/TON_SHIPPING_UK"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHIPPING_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("1.1326")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("907.18474")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-HR-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_SHORT-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_SHORT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_UK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1016.0469088")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_UK-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_UK-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_UK"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("907.18474")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TON_US-PER-YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TON_US"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TORR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), 1)],
      new Decimal("133.322")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TORR-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TORR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TSP");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/M3"), 1)],
      new Decimal("0.00000492892187")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/T_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/T"), 1)],
      new Decimal("0.0001")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TebiBIT"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBIT-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TebiBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TebiBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1099511627776")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraA");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBIT");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BIT"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBIT-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraBIT"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBQ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BQ"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraBYTE");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/BYTE"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraFLOPS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraFLOPS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraHZ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/HZ"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraJ");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraJ-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraJ"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraOHM");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/OHM"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraV");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraV-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraV-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraV"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraW");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1)],
      new Decimal("1.0E+12")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraW-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TeraW-HR-PER-YR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/TeraW"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/TonEnergy");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1)],
      new Decimal("4184000000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/U");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), 1)],
      new Decimal("1.66053878283E-27")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/UNITLESS");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/UNITLESS"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/UNKNOWN");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/UNKNOWN"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/UnitPole");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1)],
      new Decimal("1.256637E-7")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A_Reactive");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A_Reactive-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-A_Reactive-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A_Reactive"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-IN2-PER-LB_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/LB_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-BAR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/BAR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-IN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-L-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-MicroSEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MicroSEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-PER-V");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V-SEC-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V2-PER-K2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Ab");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("1E-8")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Ab-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Ab-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Ab"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Stat");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/V"), 1)],
      new Decimal("299.792458")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Stat-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/V_Stat-PER-CentiM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/V_Stat"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-L");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/L"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-HR-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-M-PER-M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-M2-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-CentiM2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/CentiM"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-FT2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-GM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/GM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-IN2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/IN"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-KiloGM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/KiloGM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M-DEG_C");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_C"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-K");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-K4");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/K"), -4),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-M-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-NanoM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-NanoM-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/NanoM"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-PA");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PA"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M2-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-M3");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -3),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-SR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-PER-SR-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SR"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W-SEC-PER-M2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/W"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/W0dot");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/W0dot"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/A"), -1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/J"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), 1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB-PER-M");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/M"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WB-PER-MilliM");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/WB"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MilliM"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/WK");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("604800.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/FT"), 1)],
      new Decimal("3.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD-PER-SEC2");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 1),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -2),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD2");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 2)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-DAY");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DAY"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-DEG_F");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/DEG_F"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-HR");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/HR"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-MIN");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/MIN"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-PSI");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/PSI"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YD3-PER-SEC");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/YD"), 3),
        new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), -1),
      ],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31557600.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_Common");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31536000.0")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_Metrology");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/YR_Metrology"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_Sidereal");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31558149.7632")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YR_TROPICAL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/SEC"), 1)],
      new Decimal("31556925.216")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YoctoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E-24")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/YottaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+24")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/Z");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/Z"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ZOLL");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/ZOLL"), 1)],
      new Decimal("1")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ZeptoC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E-21")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/ZettaC");
  unit.setFactorUnits(
    new FactorUnits(
      [new FactorUnit(getUnit("http://qudt.org/vocab/unit/C"), 1)],
      new Decimal("1.0E+21")
    )
  );
  unit = getUnit("http://qudt.org/vocab/unit/failures-in-time");
  unit.setFactorUnits(
    new FactorUnits(
      [
        new FactorUnit(
          getUnit("http://qudt.org/vocab/unit/failures-in-time"),
          1
        ),
      ],
      new Decimal("1")
    )
  );
}

// freeze everything
{
  for (const x of config.prefixes.values()) {
    Object.freeze(x);
  }
  for (const x of config.units.values()) {
    Object.freeze(x);
  }
  for (const x of config.quantityKinds.values()) {
    Object.freeze(x);
  }
  for (const x of config.systemsOfUnits.values()) {
    Object.freeze(x);
  }
  config.indexUnitsByDimensionVector();
  for (const x of config.unitsByDimensionVector.values()) {
    Object.freeze(x);
  }
  Object.freeze(Units);
  Object.freeze(QuantityKinds);
  Object.freeze(Prefixes);
  Object.freeze(SystemsOfUnits);
}
